import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Router from "next/router";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import { CSSTransition } from "react-transition-group";
import Modal from "react-modal";

var commonjsGlobal =
  typeof globalThis !== "undefined"
    ? globalThis
    : typeof window !== "undefined"
    ? window
    : typeof global !== "undefined"
    ? global
    : typeof self !== "undefined"
    ? self
    : {};

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default")
    ? x["default"]
    : x;
}

function commonjsRequire(path) {
  throw new Error(
    'Could not dynamically require "' +
      path +
      '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.'
  );
}

var axios$2 = { exports: {} };

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === "[object Array]";
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === "undefined";
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return (
    val !== null &&
    !isUndefined(val) &&
    val.constructor !== null &&
    !isUndefined(val.constructor) &&
    typeof val.constructor.isBuffer === "function" &&
    val.constructor.isBuffer(val)
  );
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== "undefined" && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === "string";
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === "number";
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === "object";
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === "[object Date]";
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === "[object File]";
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return (
    typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams
  );
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (
    typeof navigator !== "undefined" &&
    (navigator.product === "ReactNative" ||
      navigator.product === "NativeScript" ||
      navigator.product === "NS")
  ) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === "undefined") {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== "object") {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === "function") {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xfeff) {
    content = content.slice(1);
  }
  return content;
}

var utils$d = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$c = utils$d;

function encode(val) {
  return encodeURIComponent(val)
    .replace(/%3A/gi, ":")
    .replace(/%24/g, "$")
    .replace(/%2C/gi, ",")
    .replace(/%20/g, "+")
    .replace(/%5B/gi, "[")
    .replace(/%5D/gi, "]");
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$c.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$c.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }

      if (utils$c.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }

      utils$c.forEach(val, function parseValue(v) {
        if (utils$c.isDate(v)) {
          v = v.toISOString();
        } else if (utils$c.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + "=" + encode(v));
      });
    });

    serializedParams = parts.join("&");
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }

  return url;
};

var utils$b = utils$d;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(
  fulfilled,
  rejected,
  options
) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$b.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$a = utils$d;

var normalizeHeaderName$1 = function normalizeHeaderName(
  headers,
  normalizedName
) {
  utils$a.forEach(headers, function processHeader(value, name) {
    if (
      name !== normalizedName &&
      name.toUpperCase() === normalizedName.toUpperCase()
    ) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$2 = function enhanceError(
  error,
  config,
  code,
  request,
  response
) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status:
        this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};

var enhanceError$1 = enhanceError$2;

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError$2 = function createError(
  message,
  config,
  code,
  request,
  response
) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request, response);
};

var createError$1 = createError$2;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(
      createError$1(
        "Request failed with status code " + response.status,
        response.config,
        null,
        response.request,
        response
      )
    );
  }
};

var utils$9 = utils$d;

var cookies$1 = utils$9.isStandardBrowserEnv()
  ? // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + "=" + encodeURIComponent(value));

          if (utils$9.isNumber(expires)) {
            cookie.push("expires=" + new Date(expires).toGMTString());
          }

          if (utils$9.isString(path)) {
            cookie.push("path=" + path);
          }

          if (utils$9.isString(domain)) {
            cookie.push("domain=" + domain);
          }

          if (secure === true) {
            cookie.push("secure");
          }

          document.cookie = cookie.join("; ");
        },

        read: function read(name) {
          var match = document.cookie.match(
            new RegExp("(^|;\\s*)(" + name + ")=([^;]*)")
          );
          return match ? decodeURIComponent(match[3]) : null;
        },

        remove: function remove(name) {
          this.write(name, "", Date.now() - 86400000);
        }
      };
    })()
  : // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() {
          return null;
        },
        remove: function remove() {}
      };
    })();

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "")
    : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var utils$8 = utils$d;

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils$8.forEach(headers.split("\n"), function parser(line) {
    i = line.indexOf(":");
    key = utils$8.trim(line.substr(0, i)).toLowerCase();
    val = utils$8.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });

  return parsed;
};

var utils$7 = utils$d;

var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv()
  ? // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement("a");
      var originURL;

      /**
       * Parse a URL to discover it's components
       *
       * @param {String} url The URL to be parsed
       * @returns {Object}
       */
      function resolveURL(url) {
        var href = url;

        if (msie) {
          // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute("href", href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute("href", href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol
            ? urlParsingNode.protocol.replace(/:$/, "")
            : "",
          host: urlParsingNode.host,
          search: urlParsingNode.search
            ? urlParsingNode.search.replace(/^\?/, "")
            : "",
          hash: urlParsingNode.hash
            ? urlParsingNode.hash.replace(/^#/, "")
            : "",
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname:
            urlParsingNode.pathname.charAt(0) === "/"
              ? urlParsingNode.pathname
              : "/" + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
       * Determine if a URL shares the same origin as the current location
       *
       * @param {String} requestURL The URL to test
       * @returns {boolean} True if URL shares the same origin, otherwise false
       */
      return function isURLSameOrigin(requestURL) {
        var parsed = utils$7.isString(requestURL)
          ? resolveURL(requestURL)
          : requestURL;
        return (
          parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host
        );
      };
    })()
  : // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })();

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel$3(message) {
  this.message = message;
}

Cancel$3.prototype.toString = function toString() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};

Cancel$3.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel$3;

var utils$6 = utils$d;
var settle = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath = buildFullPath$1;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError = createError$2;
var defaults$4 = defaults_1;
var Cancel$2 = Cancel_1;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }

    if (utils$6.isFormData(requestData)) {
      delete requestHeaders["Content-Type"]; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password
        ? unescape(encodeURIComponent(config.auth.password))
        : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(
      config.method.toUpperCase(),
      buildURL$1(fullPath, config.params, config.paramsSerializer),
      true
    );

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders =
        "getAllResponseHeaders" in request
          ? parseHeaders(request.getAllResponseHeaders())
          : null;
      var responseData =
        !responseType || responseType === "text" || responseType === "json"
          ? request.responseText
          : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(
        function _resolve(value) {
          resolve(value);
          done();
        },
        function _reject(err) {
          reject(err);
          done();
        },
        response
      );

      // Clean up request
      request = null;
    }

    if ("onloadend" in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (
          request.status === 0 &&
          !(request.responseURL && request.responseURL.indexOf("file:") === 0)
        ) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError("Request aborted", config, "ECONNABORTED", request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError("Network Error", config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout
        ? "timeout of " + config.timeout + "ms exceeded"
        : "timeout exceeded";
      var transitional = config.transitional || defaults$4.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(
        createError(
          timeoutErrorMessage,
          config,
          transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
          request
        )
      );

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$6.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue =
        (config.withCredentials || isURLSameOrigin(fullPath)) &&
        config.xsrfCookieName
          ? cookies.read(config.xsrfCookieName)
          : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ("setRequestHeader" in request) {
      utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (
          typeof requestData === "undefined" &&
          key.toLowerCase() === "content-type"
        ) {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$6.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== "json") {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === "function") {
      request.addEventListener("progress", config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === "function" && request.upload) {
      request.upload.addEventListener("progress", config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(
          !cancel || (cancel && cancel.type) ? new Cancel$2("canceled") : cancel
        );
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted
          ? onCanceled()
          : config.signal.addEventListener("abort", onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var utils$5 = utils$d;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$2;

var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};

function setContentTypeIfUnset(headers, value) {
  if (
    !utils$5.isUndefined(headers) &&
    utils$5.isUndefined(headers["Content-Type"])
  ) {
    headers["Content-Type"] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (
    typeof process !== "undefined" &&
    Object.prototype.toString.call(process) === "[object process]"
  ) {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$5.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$5.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [
    function transformRequest(data, headers) {
      normalizeHeaderName(headers, "Accept");
      normalizeHeaderName(headers, "Content-Type");

      if (
        utils$5.isFormData(data) ||
        utils$5.isArrayBuffer(data) ||
        utils$5.isBuffer(data) ||
        utils$5.isStream(data) ||
        utils$5.isFile(data) ||
        utils$5.isBlob(data)
      ) {
        return data;
      }
      if (utils$5.isArrayBufferView(data)) {
        return data.buffer;
      }
      if (utils$5.isURLSearchParams(data)) {
        setContentTypeIfUnset(
          headers,
          "application/x-www-form-urlencoded;charset=utf-8"
        );
        return data.toString();
      }
      if (
        utils$5.isObject(data) ||
        (headers && headers["Content-Type"] === "application/json")
      ) {
        setContentTypeIfUnset(headers, "application/json");
        return stringifySafely(data);
      }
      return data;
    }
  ],

  transformResponse: [
    function transformResponse(data) {
      var transitional = this.transitional || defaults$3.transitional;
      var silentJSONParsing = transitional && transitional.silentJSONParsing;
      var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
      var strictJSONParsing =
        !silentJSONParsing && this.responseType === "json";

      if (
        strictJSONParsing ||
        (forcedJSONParsing && utils$5.isString(data) && data.length)
      ) {
        try {
          return JSON.parse(data);
        } catch (e) {
          if (strictJSONParsing) {
            if (e.name === "SyntaxError") {
              throw enhanceError(e, this, "E_JSON_PARSE");
            }
            throw e;
          }
        }
      }

      return data;
    }
  ],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};

utils$5.forEach(["delete", "get", "head"], function forEachMethodNoData(
  method
) {
  defaults$3.headers[method] = {};
});

utils$5.forEach(["post", "put", "patch"], function forEachMethodWithData(
  method
) {
  defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$4 = utils$d;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$4.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$3 = utils$d;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$3.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$3.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(
    function onAdapterResolution(response) {
      throwIfCancellationRequested(config);

      // Transform response data
      response.data = transformData.call(
        config,
        response.data,
        response.headers,
        config.transformResponse
      );

      return response;
    },
    function onAdapterRejection(reason) {
      if (!isCancel(reason)) {
        throwIfCancellationRequested(config);

        // Transform response data
        if (reason && reason.response) {
          reason.response.data = transformData.call(
            config,
            reason.response.data,
            reason.response.headers,
            config.transformResponse
          );
        }
      }

      return Promise.reject(reason);
    }
  );
};

var utils$2 = utils$d;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys
  };

  utils$2.forEach(
    Object.keys(config1).concat(Object.keys(config2)),
    function computeConfigValue(prop) {
      var merge = mergeMap[prop] || mergeDeepProperties;
      var configValue = merge(prop);
      (utils$2.isUndefined(configValue) && merge !== mergeDirectKeys) ||
        (config[prop] = configValue);
    }
  );

  return config;
};

var data = {
  version: "0.24.0"
};

var VERSION = data.version;

var validators$1 = {};

// eslint-disable-next-line func-names
["object", "boolean", "number", "function", "string", "symbol"].forEach(
  function(type, i) {
    validators$1[type] = function validator(thing) {
      return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
  }
);

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return (
      "[Axios v" +
      VERSION +
      "] Transitional option '" +
      opt +
      "'" +
      desc +
      (message ? ". " + message : "")
    );
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(
        formatMessage(
          opt,
          " has been removed" + (version ? " in " + version : "")
        )
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" +
            version +
            " and will be removed in the near future"
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$1 = utils$d;
var buildURL = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === "string") {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(
      transitional,
      {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      },
      false
    );
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(
    interceptor
  ) {
    if (
      typeof interceptor.runWhen === "function" &&
      interceptor.runWhen(config) === false
    ) {
      return;
    }

    synchronousRequestInterceptors =
      synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(
      interceptor.fulfilled,
      interceptor.rejected
    );
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(
    interceptor
  ) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }

  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(
      responseInterceptorChain.shift(),
      responseInterceptorChain.shift()
    );
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(
    /^\?/,
    ""
  );
};

// Provide aliases for supported request methods
utils$1.forEach(
  ["delete", "get", "head", "options"],
  function forEachMethodNoData(method) {
    /*eslint func-names:0*/
    Axios$1.prototype[method] = function(url, config) {
      return this.request(
        mergeConfig$1(config || {}, {
          method: method,
          url: url,
          data: (config || {}).data
        })
      );
    };
  }
);

utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(
  method
) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(
      mergeConfig$1(config || {}, {
        method: method,
        url: url,
        data: data
      })
    );
  };
});

var Axios_1 = Axios$1;

var Cancel = Cancel_1;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return typeof payload === "object" && payload.isAxiosError === true;
};

var utils = utils$d;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;

var axios = axios$2.exports;

var lodash = { exports: {} };

/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function(module, exports) {
  (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */
    var undefined$1;

    /** Used as the semantic version number. */
    var VERSION = "4.17.21";

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;

    /** Error message constants. */
    var CORE_ERROR_TEXT =
        "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",
      FUNC_ERROR_TEXT = "Expected a function",
      INVALID_TEMPL_VAR_ERROR_TEXT =
        "Invalid `variable` option passed into `_.template`";

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = "__lodash_hash_undefined__";

    /** Used as the maximum memoize cache size. */
    var MAX_MEMOIZE_SIZE = 500;

    /** Used as the internal argument placeholder. */
    var PLACEHOLDER = "__lodash_placeholder__";

    /** Used to compose bitmasks for cloning. */
    var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

    /** Used to compose bitmasks for function metadata. */
    var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

    /** Used as default options for `_.truncate`. */
    var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = "...";

    /** Used to detect hot functions by number of calls within a span of milliseconds. */
    var HOT_COUNT = 800,
      HOT_SPAN = 16;

    /** Used to indicate the type of lazy iteratees. */
    var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e308,
      NAN = 0 / 0;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /** Used to associate wrap methods with their bit flags. */
    var wrapFlags = [
      ["ary", WRAP_ARY_FLAG],
      ["bind", WRAP_BIND_FLAG],
      ["bindKey", WRAP_BIND_KEY_FLAG],
      ["curry", WRAP_CURRY_FLAG],
      ["curryRight", WRAP_CURRY_RIGHT_FLAG],
      ["flip", WRAP_FLIP_FLAG],
      ["partial", WRAP_PARTIAL_FLAG],
      ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
      ["rearg", WRAP_REARG_FLAG]
    ];

    /** `Object#toString` result references. */
    var argsTag = "[object Arguments]",
      arrayTag = "[object Array]",
      asyncTag = "[object AsyncFunction]",
      boolTag = "[object Boolean]",
      dateTag = "[object Date]",
      domExcTag = "[object DOMException]",
      errorTag = "[object Error]",
      funcTag = "[object Function]",
      genTag = "[object GeneratorFunction]",
      mapTag = "[object Map]",
      numberTag = "[object Number]",
      nullTag = "[object Null]",
      objectTag = "[object Object]",
      promiseTag = "[object Promise]",
      proxyTag = "[object Proxy]",
      regexpTag = "[object RegExp]",
      setTag = "[object Set]",
      stringTag = "[object String]",
      symbolTag = "[object Symbol]",
      undefinedTag = "[object Undefined]",
      weakMapTag = "[object WeakMap]",
      weakSetTag = "[object WeakSet]";

    var arrayBufferTag = "[object ArrayBuffer]",
      dataViewTag = "[object DataView]",
      float32Tag = "[object Float32Array]",
      float64Tag = "[object Float64Array]",
      int8Tag = "[object Int8Array]",
      int16Tag = "[object Int16Array]",
      int32Tag = "[object Int32Array]",
      uint8Tag = "[object Uint8Array]",
      uint8ClampedTag = "[object Uint8ClampedArray]",
      uint16Tag = "[object Uint16Array]",
      uint32Tag = "[object Uint32Array]";

    /** Used to match empty string literals in compiled template source. */
    var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

    /** Used to match HTML entities and HTML characters. */
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

    /** Used to match template delimiters. */
    var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

    /** Used to match property names within property paths. */
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

    /** Used to match leading whitespace. */
    var reTrimStart = /^\s+/;

    /** Used to match a single whitespace character. */
    var reWhitespace = /\s/;

    /** Used to match wrap detail comments. */
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

    /** Used to match words composed of alphanumeric characters. */
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

    /**
     * Used to validate the `validate` option in `_.template` variable.
     *
     * Forbids characters which could potentially change the meaning of the function argument definition:
     * - "()," (modification of function parameters)
     * - "=" (default value)
     * - "[]{}" (destructuring of function parameters)
     * - "/" (beginning of a comment)
     * - whitespace
     */
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

    /** Used to match backslashes in property paths. */
    var reEscapeChar = /\\(\\)?/g;

    /**
     * Used to match
     * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
     */
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

    /** Used to match `RegExp` flags from their coerced string values. */
    var reFlags = /\w*$/;

    /** Used to detect bad signed hexadecimal string values. */
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

    /** Used to detect binary string values. */
    var reIsBinary = /^0b[01]+$/i;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Used to detect octal string values. */
    var reIsOctal = /^0o[0-7]+$/i;

    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    /** Used to match Latin Unicode letters (excluding mathematical operators). */
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

    /** Used to ensure capturing order of template delimiters. */
    var reNoMatch = /($^)/;

    /** Used to match unescaped characters in compiled string literals. */
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

    /** Used to compose unicode character classes. */
    var rsAstralRange = "\\ud800-\\udfff",
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange =
        rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = "\\u2700-\\u27bf",
      rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff",
      rsMathOpRange = "\\xac\\xb1\\xd7\\xf7",
      rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",
      rsPunctuationRange = "\\u2000-\\u206f",
      rsSpaceRange =
        " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
      rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde",
      rsVarRange = "\\ufe0e\\ufe0f",
      rsBreakRange =
        rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

    /** Used to compose unicode capture groups. */
    var rsApos = "['\u2019]",
      rsAstral = "[" + rsAstralRange + "]",
      rsBreak = "[" + rsBreakRange + "]",
      rsCombo = "[" + rsComboRange + "]",
      rsDigits = "\\d+",
      rsDingbat = "[" + rsDingbatRange + "]",
      rsLower = "[" + rsLowerRange + "]",
      rsMisc =
        "[^" +
        rsAstralRange +
        rsBreakRange +
        rsDigits +
        rsDingbatRange +
        rsLowerRange +
        rsUpperRange +
        "]",
      rsFitz = "\\ud83c[\\udffb-\\udfff]",
      rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")",
      rsNonAstral = "[^" + rsAstralRange + "]",
      rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      rsUpper = "[" + rsUpperRange + "]",
      rsZWJ = "\\u200d";

    /** Used to compose unicode regexes. */
    var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")",
      rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")",
      rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?",
      rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?",
      reOptMod = rsModifier + "?",
      rsOptVar = "[" + rsVarRange + "]?",
      rsOptJoin =
        "(?:" +
        rsZWJ +
        "(?:" +
        [rsNonAstral, rsRegional, rsSurrPair].join("|") +
        ")" +
        rsOptVar +
        reOptMod +
        ")*",
      rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
      rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji =
        "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq,
      rsSymbol =
        "(?:" +
        [
          rsNonAstral + rsCombo + "?",
          rsCombo,
          rsRegional,
          rsSurrPair,
          rsAstral
        ].join("|") +
        ")";

    /** Used to match apostrophes. */
    var reApos = RegExp(rsApos, "g");

    /**
     * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
     * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
     */
    var reComboMark = RegExp(rsCombo, "g");

    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
    var reUnicode = RegExp(
      rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq,
      "g"
    );

    /** Used to match complex or compound words. */
    var reUnicodeWord = RegExp(
      [
        rsUpper +
          "?" +
          rsLower +
          "+" +
          rsOptContrLower +
          "(?=" +
          [rsBreak, rsUpper, "$"].join("|") +
          ")",
        rsMiscUpper +
          "+" +
          rsOptContrUpper +
          "(?=" +
          [rsBreak, rsUpper + rsMiscLower, "$"].join("|") +
          ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"),
      "g"
    );

    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
    var reHasUnicode = RegExp(
      "[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]"
    );

    /** Used to detect strings that need a more robust regexp to match words. */
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

    /** Used to assign default `context` object properties. */
    var contextProps = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ];

    /** Used to make template sourceURLs easier to identify. */
    var templateCounter = -1;

    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[
      int8Tag
    ] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[
      uint8Tag
    ] = typedArrayTags[uint8ClampedTag] = typedArrayTags[
      uint16Tag
    ] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[
      arrayBufferTag
    ] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[
      dateTag
    ] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[
      mapTag
    ] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[
      regexpTag
    ] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[
      weakMapTag
    ] = false;

    /** Used to identify `toStringTag` values supported by `_.clone`. */
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[
      arrayBufferTag
    ] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[
      dateTag
    ] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[
      int8Tag
    ] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[
      mapTag
    ] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[
      regexpTag
    ] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[
      symbolTag
    ] = cloneableTags[uint8Tag] = cloneableTags[
      uint8ClampedTag
    ] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[
      weakMapTag
    ] = false;

    /** Used to map Latin Unicode letters to basic Latin letters. */
    var deburredLetters = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    };

    /** Used to map characters to HTML entities. */
    var htmlEscapes = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    };

    /** Used to map HTML entities to characters. */
    var htmlUnescapes = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    };

    /** Used to escape characters for inclusion in compiled string literals. */
    var stringEscapes = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    };

    /** Built-in method references without a dependency on `root`. */
    var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

    /** Detect free variable `global` from Node.js. */
    var freeGlobal =
      typeof commonjsGlobal == "object" &&
      commonjsGlobal &&
      commonjsGlobal.Object === Object &&
      commonjsGlobal;

    /** Detect free variable `self`. */
    var freeSelf =
      typeof self == "object" && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function("return this")();

    /** Detect free variable `exports`. */
    var freeExports = exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule =
      freeExports &&
      "object" == "object" &&
      module &&
      !module.nodeType &&
      module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil = (function() {
      try {
        // Use `util.types` for Node.js 10+.
        var types =
          freeModule && freeModule.require && freeModule.require("util").types;

        if (types) {
          return types;
        }

        // Legacy `process.binding('util')` for Node.js < 10.
        return (
          freeProcess && freeProcess.binding && freeProcess.binding("util")
        );
      } catch (e) {}
    })();

    /* Node.js helper references. */
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

    /*--------------------------------------------------------------------------*/

    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }

    /**
     * A specialized version of `baseAggregator` for arrays.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index = -1,
        length = array == null ? 0 : array.length;

      while (++index < length) {
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.includes` for arrays without support for
     * specifying an index to search from.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }

    /**
     * This function is like `arrayIncludes` except that it accepts a comparator.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */
    function arrayIncludesWith(array, value, comparator) {
      var index = -1,
        length = array == null ? 0 : array.length;

      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the first element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1,
        length = array == null ? 0 : array.length;

      if (initAccum && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the last element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * Gets the size of an ASCII `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */
    var asciiSize = baseProperty("length");

    /**
     * Converts an ASCII `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function asciiToArray(string) {
      return string.split("");
    }

    /**
     * Splits an ASCII `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }

    /**
     * The base implementation of methods like `_.findKey` and `_.findLastKey`,
     * without support for iteratee shorthands, which iterates over `collection`
     * using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = key;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOf(array, value, fromIndex) {
      return value === value
        ? strictIndexOf(array, value, fromIndex)
        : baseFindIndex(array, baseIsNaN, fromIndex);
    }

    /**
     * This function is like `baseIndexOf` except that it accepts a comparator.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index = fromIndex - 1,
        length = array.length;

      while (++index < length) {
        if (comparator(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */
    function baseIsNaN(value) {
      return value !== value;
    }

    /**
     * The base implementation of `_.mean` and `_.meanBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the mean.
     */
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }

    /**
     * The base implementation of `_.propertyOf` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight`, without support
     * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initAccum Specify using the first or last element of
     *  `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(
      collection,
      iteratee,
      accumulator,
      initAccum,
      eachFunc
    ) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum
          ? ((initAccum = false), value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define the
     * sort order of `array` and replaces criteria objects with their corresponding
     * values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sum` and `_.sumBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(array, iteratee) {
      var result,
        index = -1,
        length = array.length;

      while (++index < length) {
        var current = iteratee(array[index]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);

      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }

    /**
     * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
     * of key-value pairs for `object` corresponding to the property names of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the key-value pairs.
     */
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }

    /**
     * The base implementation of `_.trim`.
     *
     * @private
     * @param {string} string The string to trim.
     * @returns {string} Returns the trimmed string.
     */
    function baseTrim(string) {
      return string
        ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "")
        : string;
    }

    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }

    /**
     * Checks if a `cache` value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function cacheHas(cache, key) {
      return cache.has(key);
    }

    /**
     * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the first unmatched string symbol.
     */
    function charsStartIndex(strSymbols, chrSymbols) {
      var index = -1,
        length = strSymbols.length;

      while (
        ++index < length &&
        baseIndexOf(chrSymbols, strSymbols[index], 0) > -1
      ) {}
      return index;
    }

    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the last unmatched string symbol.
     */
    function charsEndIndex(strSymbols, chrSymbols) {
      var index = strSymbols.length;

      while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
      return index;
    }

    /**
     * Gets the number of `placeholder` occurrences in `array`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} placeholder The placeholder to search for.
     * @returns {number} Returns the placeholder count.
     */
    function countHolders(array, placeholder) {
      var length = array.length,
        result = 0;

      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }

    /**
     * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
     * letters to basic Latin letters.
     *
     * @private
     * @param {string} letter The matched letter to deburr.
     * @returns {string} Returns the deburred letter.
     */
    var deburrLetter = basePropertyOf(deburredLetters);

    /**
     * Used by `_.escape` to convert characters to HTML entities.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */
    var escapeHtmlChar = basePropertyOf(htmlEscapes);

    /**
     * Used by `_.template` to escape characters for inclusion in compiled string literals.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */
    function escapeStringChar(chr) {
      return "\\" + stringEscapes[chr];
    }

    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }

    /**
     * Checks if `string` contains Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a symbol is found, else `false`.
     */
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }

    /**
     * Checks if `string` contains a word composed of Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a word is found, else `false`.
     */
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }

    /**
     * Converts `iterator` to an array.
     *
     * @private
     * @param {Object} iterator The iterator to convert.
     * @returns {Array} Returns the converted array.
     */
    function iteratorToArray(iterator) {
      var data,
        result = [];

      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }

    /**
     * Converts `map` to its key-value pairs.
     *
     * @private
     * @param {Object} map The map to convert.
     * @returns {Array} Returns the key-value pairs.
     */
    function mapToArray(map) {
      var index = -1,
        result = Array(map.size);

      map.forEach(function(value, key) {
        result[++index] = [key, value];
      });
      return result;
    }

    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }

    /**
     * Replaces all `placeholder` elements in `array` with an internal placeholder
     * and returns an array of their indexes.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {*} placeholder The placeholder to replace.
     * @returns {Array} Returns the new array of placeholder indexes.
     */
    function replaceHolders(array, placeholder) {
      var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }
      return result;
    }

    /**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */
    function setToArray(set) {
      var index = -1,
        result = Array(set.size);

      set.forEach(function(value) {
        result[++index] = value;
      });
      return result;
    }

    /**
     * Converts `set` to its value-value pairs.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the value-value pairs.
     */
    function setToPairs(set) {
      var index = -1,
        result = Array(set.size);

      set.forEach(function(value) {
        result[++index] = [value, value];
      });
      return result;
    }

    /**
     * A specialized version of `_.indexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1,
        length = array.length;

      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * A specialized version of `_.lastIndexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function strictLastIndexOf(array, value, fromIndex) {
      var index = fromIndex + 1;
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return index;
    }

    /**
     * Gets the number of symbols in `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the string size.
     */
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }

    /**
     * Converts `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }

    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
     * character of `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the index of the last non-whitespace character.
     */
    function trimmedEndIndex(string) {
      var index = string.length;

      while (index-- && reWhitespace.test(string.charAt(index))) {}
      return index;
    }

    /**
     * Used by `_.unescape` to convert HTML entities to characters.
     *
     * @private
     * @param {string} chr The matched character to unescape.
     * @returns {string} Returns the unescaped character.
     */
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

    /**
     * Gets the size of a Unicode `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */
    function unicodeSize(string) {
      var result = (reUnicode.lastIndex = 0);
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }

    /**
     * Converts a Unicode `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }

    /**
     * Splits a Unicode `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }

    /*--------------------------------------------------------------------------*/

    /**
     * Create a new pristine `lodash` function using the `context` object.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Util
     * @param {Object} [context=root] The context object.
     * @returns {Function} Returns a new `lodash` function.
     * @example
     *
     * _.mixin({ 'foo': _.constant('foo') });
     *
     * var lodash = _.runInContext();
     * lodash.mixin({ 'bar': lodash.constant('bar') });
     *
     * _.isFunction(_.foo);
     * // => true
     * _.isFunction(_.bar);
     * // => false
     *
     * lodash.isFunction(lodash.foo);
     * // => false
     * lodash.isFunction(lodash.bar);
     * // => true
     *
     * // Create a suped-up `defer` in Node.js.
     * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
     */
    var runInContext = function runInContext(context) {
      context =
        context == null
          ? root
          : _.defaults(root.Object(), context, _.pick(root, contextProps));

      /** Built-in constructor references. */
      var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

      /** Used for built-in method references. */
      var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

      /** Used to detect overreaching core-js shims. */
      var coreJsData = context["__core-js_shared__"];

      /** Used to resolve the decompiled source of functions. */
      var funcToString = funcProto.toString;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /** Used to generate unique IDs. */
      var idCounter = 0;

      /** Used to detect methods masquerading as native. */
      var maskSrcKey = (function() {
        var uid = /[^.]+$/.exec(
          (coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO) || ""
        );
        return uid ? "Symbol(src)_1." + uid : "";
      })();

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var nativeObjectToString = objectProto.toString;

      /** Used to infer the `Object` constructor. */
      var objectCtorString = funcToString.call(Object);

      /** Used to restore the original `_` reference in `_.noConflict`. */
      var oldDash = root._;

      /** Used to detect if a method is native. */
      var reIsNative = RegExp(
        "^" +
          funcToString
            .call(hasOwnProperty)
            .replace(reRegExpChar, "\\$&")
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              "$1.*?"
            ) +
          "$"
      );

      /** Built-in value references. */
      var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

      var defineProperty = (function() {
        try {
          var func = getNative(Object, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e) {}
      })();

      /** Mocked built-ins. */
      var ctxClearTimeout =
          context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout =
          context.setTimeout !== root.setTimeout && context.setTimeout;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

      /* Built-in method references that are verified to be native. */
      var DataView = getNative(context, "DataView"),
        Map = getNative(context, "Map"),
        Promise = getNative(context, "Promise"),
        Set = getNative(context, "Set"),
        WeakMap = getNative(context, "WeakMap"),
        nativeCreate = getNative(Object, "create");

      /** Used to store function metadata. */
      var metaMap = WeakMap && new WeakMap();

      /** Used to lookup unminified function names. */
      var realNames = {};

      /** Used to detect maps, sets, and weakmaps. */
      var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

      /** Used to convert symbols to primitives and strings. */
      var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a `lodash` object which wraps `value` to enable implicit method
       * chain sequences. Methods that operate on and return arrays, collections,
       * and functions can be chained together. Methods that retrieve a single value
       * or may return a primitive value will automatically end the chain sequence
       * and return the unwrapped value. Otherwise, the value must be unwrapped
       * with `_#value`.
       *
       * Explicit chain sequences, which must be unwrapped with `_#value`, may be
       * enabled using `_.chain`.
       *
       * The execution of chained methods is lazy, that is, it's deferred until
       * `_#value` is implicitly or explicitly called.
       *
       * Lazy evaluation allows several methods to support shortcut fusion.
       * Shortcut fusion is an optimization to merge iteratee calls; this avoids
       * the creation of intermediate arrays and can greatly reduce the number of
       * iteratee executions. Sections of a chain sequence qualify for shortcut
       * fusion if the section is applied to an array and iteratees accept only
       * one argument. The heuristic for whether a section qualifies for shortcut
       * fusion is subject to change.
       *
       * Chaining is supported in custom builds as long as the `_#value` method is
       * directly or indirectly included in the build.
       *
       * In addition to lodash methods, wrappers have `Array` and `String` methods.
       *
       * The wrapper `Array` methods are:
       * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
       *
       * The wrapper `String` methods are:
       * `replace` and `split`
       *
       * The wrapper methods that support shortcut fusion are:
       * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
       * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
       * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
       *
       * The chainable wrapper methods are:
       * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
       * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
       * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
       * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
       * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
       * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
       * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
       * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
       * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
       * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
       * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
       * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
       * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
       * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
       * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
       * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
       * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
       * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
       * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
       * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
       * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
       * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
       * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
       * `zipObject`, `zipObjectDeep`, and `zipWith`
       *
       * The wrapper methods that are **not** chainable by default are:
       * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
       * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
       * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
       * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
       * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
       * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
       * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
       * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
       * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
       * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
       * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
       * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
       * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
       * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
       * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
       * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
       * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
       * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
       * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
       * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
       * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
       * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
       * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
       * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
       * `upperFirst`, `value`, and `words`
       *
       * @name _
       * @constructor
       * @category Seq
       * @param {*} value The value to wrap in a `lodash` instance.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var wrapped = _([1, 2, 3]);
       *
       * // Returns an unwrapped value.
       * wrapped.reduce(_.add);
       * // => 6
       *
       * // Returns a wrapped value.
       * var squares = wrapped.map(square);
       *
       * _.isArray(squares);
       * // => false
       *
       * _.isArray(squares.value());
       * // => true
       */
      function lodash(value) {
        if (
          isObjectLike(value) &&
          !isArray(value) &&
          !(value instanceof LazyWrapper)
        ) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }

      /**
       * The base implementation of `_.create` without support for assigning
       * properties to the created object.
       *
       * @private
       * @param {Object} proto The object to inherit from.
       * @returns {Object} Returns the new object.
       */
      var baseCreate = (function() {
        function object() {}
        return function(proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result = new object();
          object.prototype = undefined$1;
          return result;
        };
      })();

      /**
       * The function whose prototype chain sequence wrappers inherit from.
       *
       * @private
       */
      function baseLodash() {
        // No operation performed.
      }

      /**
       * The base constructor for creating `lodash` wrapper objects.
       *
       * @private
       * @param {*} value The value to wrap.
       * @param {boolean} [chainAll] Enable explicit method chain sequences.
       */
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }

      /**
       * By default, the template delimiters used by lodash are like those in
       * embedded Ruby (ERB) as well as ES2015 template strings. Change the
       * following template settings to use alternative delimiters.
       *
       * @static
       * @memberOf _
       * @type {Object}
       */
      lodash.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: reEscape,

        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: reEvaluate,

        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: reInterpolate,

        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",

        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: lodash
        }
      };

      // Ensure wrappers are instances of `baseLodash`.
      lodash.prototype = baseLodash.prototype;
      lodash.prototype.constructor = lodash;

      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
       *
       * @private
       * @constructor
       * @param {*} value The value to wrap.
       */
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }

      /**
       * Creates a clone of the lazy wrapper object.
       *
       * @private
       * @name clone
       * @memberOf LazyWrapper
       * @returns {Object} Returns the cloned `LazyWrapper` object.
       */
      function lazyClone() {
        var result = new LazyWrapper(this.__wrapped__);
        result.__actions__ = copyArray(this.__actions__);
        result.__dir__ = this.__dir__;
        result.__filtered__ = this.__filtered__;
        result.__iteratees__ = copyArray(this.__iteratees__);
        result.__takeCount__ = this.__takeCount__;
        result.__views__ = copyArray(this.__views__);
        return result;
      }

      /**
       * Reverses the direction of lazy iteration.
       *
       * @private
       * @name reverse
       * @memberOf LazyWrapper
       * @returns {Object} Returns the new reversed `LazyWrapper` object.
       */
      function lazyReverse() {
        if (this.__filtered__) {
          var result = new LazyWrapper(this);
          result.__dir__ = -1;
          result.__filtered__ = true;
        } else {
          result = this.clone();
          result.__dir__ *= -1;
        }
        return result;
      }

      /**
       * Extracts the unwrapped value from its lazy wrapper.
       *
       * @private
       * @name value
       * @memberOf LazyWrapper
       * @returns {*} Returns the unwrapped value.
       */
      function lazyValue() {
        var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : start - 1,
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

        if (
          !isArr ||
          (!isRight && arrLength == length && takeCount == length)
        ) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result = [];

        outer: while (length-- && resIndex < takeCount) {
          index += dir;

          var iterIndex = -1,
            value = array[index];

          while (++iterIndex < iterLength) {
            var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

            if (type == LAZY_MAP_FLAG) {
              value = computed;
            } else if (!computed) {
              if (type == LAZY_FILTER_FLAG) {
                continue outer;
              } else {
                break outer;
              }
            }
          }
          result[resIndex++] = value;
        }
        return result;
      }

      // Ensure `LazyWrapper` is an instance of `baseLodash`.
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a hash object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Hash(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;

        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      /**
       * Removes all key-value entries from the hash.
       *
       * @private
       * @name clear
       * @memberOf Hash
       */
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }

      /**
       * Removes `key` and its value from the hash.
       *
       * @private
       * @name delete
       * @memberOf Hash
       * @param {Object} hash The hash to modify.
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }

      /**
       * Gets the hash value for `key`.
       *
       * @private
       * @name get
       * @memberOf Hash
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? undefined$1 : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
      }

      /**
       * Checks if a hash value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Hash
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate
          ? data[key] !== undefined$1
          : hasOwnProperty.call(data, key);
      }

      /**
       * Sets the hash `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Hash
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the hash instance.
       */
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] =
          nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }

      // Add methods to `Hash`.
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;

      /*------------------------------------------------------------------------*/

      /**
       * Creates an list cache object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function ListCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;

        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      /**
       * Removes all key-value entries from the list cache.
       *
       * @private
       * @name clear
       * @memberOf ListCache
       */
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }

      /**
       * Removes `key` and its value from the list cache.
       *
       * @private
       * @name delete
       * @memberOf ListCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function listCacheDelete(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);

        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }

      /**
       * Gets the list cache value for `key`.
       *
       * @private
       * @name get
       * @memberOf ListCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function listCacheGet(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);

        return index < 0 ? undefined$1 : data[index][1];
      }

      /**
       * Checks if a list cache value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf ListCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }

      /**
       * Sets the list cache `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf ListCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the list cache instance.
       */
      function listCacheSet(key, value) {
        var data = this.__data__,
          index = assocIndexOf(data, key);

        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }

      // Add methods to `ListCache`.
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a map cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function MapCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;

        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      /**
       * Removes all key-value entries from the map.
       *
       * @private
       * @name clear
       * @memberOf MapCache
       */
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          hash: new Hash(),
          map: new (Map || ListCache)(),
          string: new Hash()
        };
      }

      /**
       * Removes `key` and its value from the map.
       *
       * @private
       * @name delete
       * @memberOf MapCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function mapCacheDelete(key) {
        var result = getMapData(this, key)["delete"](key);
        this.size -= result ? 1 : 0;
        return result;
      }

      /**
       * Gets the map value for `key`.
       *
       * @private
       * @name get
       * @memberOf MapCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }

      /**
       * Checks if a map value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf MapCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }

      /**
       * Sets the map `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf MapCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the map cache instance.
       */
      function mapCacheSet(key, value) {
        var data = getMapData(this, key),
          size = data.size;

        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }

      // Add methods to `MapCache`.
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;

      /*------------------------------------------------------------------------*/

      /**
       *
       * Creates an array cache object to store unique values.
       *
       * @private
       * @constructor
       * @param {Array} [values] The values to cache.
       */
      function SetCache(values) {
        var index = -1,
          length = values == null ? 0 : values.length;

        this.__data__ = new MapCache();
        while (++index < length) {
          this.add(values[index]);
        }
      }

      /**
       * Adds `value` to the array cache.
       *
       * @private
       * @name add
       * @memberOf SetCache
       * @alias push
       * @param {*} value The value to cache.
       * @returns {Object} Returns the cache instance.
       */
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }

      /**
       * Checks if `value` is in the array cache.
       *
       * @private
       * @name has
       * @memberOf SetCache
       * @param {*} value The value to search for.
       * @returns {number} Returns `true` if `value` is found, else `false`.
       */
      function setCacheHas(value) {
        return this.__data__.has(value);
      }

      // Add methods to `SetCache`.
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a stack cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Stack(entries) {
        var data = (this.__data__ = new ListCache(entries));
        this.size = data.size;
      }

      /**
       * Removes all key-value entries from the stack.
       *
       * @private
       * @name clear
       * @memberOf Stack
       */
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }

      /**
       * Removes `key` and its value from the stack.
       *
       * @private
       * @name delete
       * @memberOf Stack
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function stackDelete(key) {
        var data = this.__data__,
          result = data["delete"](key);

        this.size = data.size;
        return result;
      }

      /**
       * Gets the stack value for `key`.
       *
       * @private
       * @name get
       * @memberOf Stack
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function stackGet(key) {
        return this.__data__.get(key);
      }

      /**
       * Checks if a stack value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Stack
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function stackHas(key) {
        return this.__data__.has(key);
      }

      /**
       * Sets the stack `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Stack
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the stack cache instance.
       */
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }

      // Add methods to `Stack`.
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;

      /*------------------------------------------------------------------------*/

      /**
       * Creates an array of the enumerable property names of the array-like `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @param {boolean} inherited Specify returning inherited property names.
       * @returns {Array} Returns the array of property names.
       */
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

        for (var key in value) {
          if (
            (inherited || hasOwnProperty.call(value, key)) &&
            !(
              skipIndexes &&
              // Safari 9 has enumerable `arguments.length` in strict mode.
              (key == "length" ||
                // Node.js 0.10 has enumerable non-index properties on buffers.
                (isBuff && (key == "offset" || key == "parent")) ||
                // PhantomJS 2 has enumerable non-index properties on typed arrays.
                (isType &&
                  (key == "buffer" ||
                    key == "byteLength" ||
                    key == "byteOffset")) ||
                // Skip index properties.
                isIndex(key, length))
            )
          ) {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * A specialized version of `_.sample` for arrays.
       *
       * @private
       * @param {Array} array The array to sample.
       * @returns {*} Returns the random element.
       */
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }

      /**
       * A specialized version of `_.sampleSize` for arrays.
       *
       * @private
       * @param {Array} array The array to sample.
       * @param {number} n The number of elements to sample.
       * @returns {Array} Returns the random elements.
       */
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }

      /**
       * A specialized version of `_.shuffle` for arrays.
       *
       * @private
       * @param {Array} array The array to shuffle.
       * @returns {Array} Returns the new shuffled array.
       */
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }

      /**
       * This function is like `assignValue` except that it doesn't assign
       * `undefined` values.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignMergeValue(object, key, value) {
        if (
          (value !== undefined$1 && !eq(object[key], value)) ||
          (value === undefined$1 && !(key in object))
        ) {
          baseAssignValue(object, key, value);
        }
      }

      /**
       * Assigns `value` to `key` of `object` if the existing value is not equivalent
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (
          !(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined$1 && !(key in object))
        ) {
          baseAssignValue(object, key, value);
        }
      }

      /**
       * Gets the index at which the `key` is found in `array` of key-value pairs.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} key The key to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }

      /**
       * Aggregates elements of `collection` on `accumulator` with keys transformed
       * by `iteratee` and values set by `setter`.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform keys.
       * @param {Object} accumulator The initial aggregated object.
       * @returns {Function} Returns `accumulator`.
       */
      function baseAggregator(collection, setter, iteratee, accumulator) {
        baseEach(collection, function(value, key, collection) {
          setter(accumulator, value, iteratee(value), collection);
        });
        return accumulator;
      }

      /**
       * The base implementation of `_.assign` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }

      /**
       * The base implementation of `_.assignIn` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }

      /**
       * The base implementation of `assignValue` and `assignMergeValue` without
       * value checks.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            configurable: true,
            enumerable: true,
            value: value,
            writable: true
          });
        } else {
          object[key] = value;
        }
      }

      /**
       * The base implementation of `_.at` without support for individual paths.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {string[]} paths The property paths to pick.
       * @returns {Array} Returns the picked elements.
       */
      function baseAt(object, paths) {
        var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

        while (++index < length) {
          result[index] = skip ? undefined$1 : get(object, paths[index]);
        }
        return result;
      }

      /**
       * The base implementation of `_.clamp` which doesn't coerce arguments.
       *
       * @private
       * @param {number} number The number to clamp.
       * @param {number} [lower] The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the clamped number.
       */
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }

      /**
       * The base implementation of `_.clone` and `_.cloneDeep` which tracks
       * traversed objects.
       *
       * @private
       * @param {*} value The value to clone.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Deep clone
       *  2 - Flatten inherited properties
       *  4 - Clone symbols
       * @param {Function} [customizer] The function to customize cloning.
       * @param {string} [key] The key of `value`.
       * @param {Object} [object] The parent object of `value`.
       * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
       * @returns {*} Returns the cloned value.
       */
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

        if (customizer) {
          result = object
            ? customizer(value, key, object, stack)
            : customizer(value);
        }
        if (result !== undefined$1) {
          return result;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray(value);
        if (isArr) {
          result = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat
                ? copySymbolsIn(value, baseAssignIn(result, value))
                : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
          }
        }
        // Check for circular references and return its corresponding clone.
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result);

        if (isSet(value)) {
          value.forEach(function(subValue) {
            result.add(
              baseClone(subValue, bitmask, customizer, subValue, value, stack)
            );
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key) {
            result.set(
              key,
              baseClone(subValue, bitmask, customizer, key, value, stack)
            );
          });
        }

        var keysFunc = isFull
          ? isFlat
            ? getAllKeysIn
            : getAllKeys
          : isFlat
          ? keysIn
          : keys;

        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key) {
          if (props) {
            key = subValue;
            subValue = value[key];
          }
          // Recursively populate clone (susceptible to call stack limits).
          assignValue(
            result,
            key,
            baseClone(subValue, bitmask, customizer, key, value, stack)
          );
        });
        return result;
      }

      /**
       * The base implementation of `_.conforms` which doesn't clone `source`.
       *
       * @private
       * @param {Object} source The object of property predicates to conform to.
       * @returns {Function} Returns the new spec function.
       */
      function baseConforms(source) {
        var props = keys(source);
        return function(object) {
          return baseConformsTo(object, source, props);
        };
      }

      /**
       * The base implementation of `_.conformsTo` which accepts `props` to check.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property predicates to conform to.
       * @returns {boolean} Returns `true` if `object` conforms, else `false`.
       */
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (length--) {
          var key = props[length],
            predicate = source[key],
            value = object[key];

          if (
            (value === undefined$1 && !(key in object)) ||
            !predicate(value)
          ) {
            return false;
          }
        }
        return true;
      }

      /**
       * The base implementation of `_.delay` and `_.defer` which accepts `args`
       * to provide to `func`.
       *
       * @private
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {Array} args The arguments to provide to `func`.
       * @returns {number|Object} Returns the timer id or timeout object.
       */
      function baseDelay(func, wait, args) {
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return setTimeout(function() {
          func.apply(undefined$1, args);
        }, wait);
      }

      /**
       * The base implementation of methods like `_.difference` without support
       * for excluding multiple arrays or iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Array} values The values to exclude.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       */
      function baseDifference(array, values, iteratee, comparator) {
        var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

        if (!length) {
          return result;
        }
        if (iteratee) {
          values = arrayMap(values, baseUnary(iteratee));
        }
        if (comparator) {
          includes = arrayIncludesWith;
          isCommon = false;
        } else if (values.length >= LARGE_ARRAY_SIZE) {
          includes = cacheHas;
          isCommon = false;
          values = new SetCache(values);
        }
        outer: while (++index < length) {
          var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

          value = comparator || value !== 0 ? value : 0;
          if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while (valuesIndex--) {
              if (values[valuesIndex] === computed) {
                continue outer;
              }
            }
            result.push(value);
          } else if (!includes(values, computed, comparator)) {
            result.push(value);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.forEach` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       */
      var baseEach = createBaseEach(baseForOwn);

      /**
       * The base implementation of `_.forEachRight` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       */
      var baseEachRight = createBaseEach(baseForOwnRight, true);

      /**
       * The base implementation of `_.every` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if all elements pass the predicate check,
       *  else `false`
       */
      function baseEvery(collection, predicate) {
        var result = true;
        baseEach(collection, function(value, index, collection) {
          result = !!predicate(value, index, collection);
          return result;
        });
        return result;
      }

      /**
       * The base implementation of methods like `_.max` and `_.min` which accepts a
       * `comparator` to determine the extremum value.
       *
       * @private
       * @param {Array} array The array to iterate over.
       * @param {Function} iteratee The iteratee invoked per iteration.
       * @param {Function} comparator The comparator used to compare values.
       * @returns {*} Returns the extremum value.
       */
      function baseExtremum(array, iteratee, comparator) {
        var index = -1,
          length = array.length;

        while (++index < length) {
          var value = array[index],
            current = iteratee(value);

          if (
            current != null &&
            (computed === undefined$1
              ? current === current && !isSymbol(current)
              : comparator(current, computed))
          ) {
            var computed = current,
              result = value;
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.fill` without an iteratee call guard.
       *
       * @private
       * @param {Array} array The array to fill.
       * @param {*} value The value to fill `array` with.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns `array`.
       */
      function baseFill(array, value, start, end) {
        var length = array.length;

        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }

      /**
       * The base implementation of `_.filter` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       */
      function baseFilter(collection, predicate) {
        var result = [];
        baseEach(collection, function(value, index, collection) {
          if (predicate(value, index, collection)) {
            result.push(value);
          }
        });
        return result;
      }

      /**
       * The base implementation of `_.flatten` with support for restricting flattening.
       *
       * @private
       * @param {Array} array The array to flatten.
       * @param {number} depth The maximum recursion depth.
       * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
       * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
       * @param {Array} [result=[]] The initial result value.
       * @returns {Array} Returns the new flattened array.
       */
      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1,
          length = array.length;

        predicate || (predicate = isFlattenable);
        result || (result = []);

        while (++index < length) {
          var value = array[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              // Recursively flatten arrays (susceptible to call stack limits).
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }
        return result;
      }

      /**
       * The base implementation of `baseForOwn` which iterates over `object`
       * properties returned by `keysFunc` and invokes `iteratee` for each property.
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @returns {Object} Returns `object`.
       */
      var baseFor = createBaseFor();

      /**
       * This function is like `baseFor` except that it iterates over properties
       * in the opposite order.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @returns {Object} Returns `object`.
       */
      var baseForRight = createBaseFor(true);

      /**
       * The base implementation of `_.forOwn` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Object} Returns `object`.
       */
      function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
      }

      /**
       * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Object} Returns `object`.
       */
      function baseForOwnRight(object, iteratee) {
        return object && baseForRight(object, iteratee, keys);
      }

      /**
       * The base implementation of `_.functions` which creates an array of
       * `object` function property names filtered from `props`.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Array} props The property names to filter.
       * @returns {Array} Returns the function names.
       */
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction(object[key]);
        });
      }

      /**
       * The base implementation of `_.get` without support for default values.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @returns {*} Returns the resolved value.
       */
      function baseGet(object, path) {
        path = castPath(path, object);

        var index = 0,
          length = path.length;

        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }
        return index && index == length ? object : undefined$1;
      }

      /**
       * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
       * `keysFunc` and `symbolsFunc` to get the enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @param {Function} symbolsFunc The function to get the symbols of `object`.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object)
          ? result
          : arrayPush(result, symbolsFunc(object));
      }

      /**
       * The base implementation of `getTag` without fallbacks for buggy environments.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value)
          ? getRawTag(value)
          : objectToString(value);
      }

      /**
       * The base implementation of `_.gt` which doesn't coerce arguments.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is greater than `other`,
       *  else `false`.
       */
      function baseGt(value, other) {
        return value > other;
      }

      /**
       * The base implementation of `_.has` without support for deep paths.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {Array|string} key The key to check.
       * @returns {boolean} Returns `true` if `key` exists, else `false`.
       */
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }

      /**
       * The base implementation of `_.hasIn` without support for deep paths.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {Array|string} key The key to check.
       * @returns {boolean} Returns `true` if `key` exists, else `false`.
       */
      function baseHasIn(object, key) {
        return object != null && key in Object(object);
      }

      /**
       * The base implementation of `_.inRange` which doesn't coerce arguments.
       *
       * @private
       * @param {number} number The number to check.
       * @param {number} start The start of the range.
       * @param {number} end The end of the range.
       * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
       */
      function baseInRange(number, start, end) {
        return (
          number >= nativeMin(start, end) && number < nativeMax(start, end)
        );
      }

      /**
       * The base implementation of methods like `_.intersection`, without support
       * for iteratee shorthands, that accepts an array of arrays to inspect.
       *
       * @private
       * @param {Array} arrays The arrays to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of shared values.
       */
      function baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee) {
            array = arrayMap(array, baseUnary(iteratee));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] =
            !comparator && (iteratee || (length >= 120 && array.length >= 120))
              ? new SetCache(othIndex && array)
              : undefined$1;
        }
        array = arrays[0];

        var index = -1,
          seen = caches[0];

        outer: while (++index < length && result.length < maxLength) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;

          value = comparator || value !== 0 ? value : 0;
          if (
            !(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator))
          ) {
            othIndex = othLength;
            while (--othIndex) {
              var cache = caches[othIndex];
              if (
                !(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
              ) {
                continue outer;
              }
            }
            if (seen) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.invert` and `_.invertBy` which inverts
       * `object` with values transformed by `iteratee` and set by `setter`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform values.
       * @param {Object} accumulator The initial inverted object.
       * @returns {Function} Returns `accumulator`.
       */
      function baseInverter(object, setter, iteratee, accumulator) {
        baseForOwn(object, function(value, key, object) {
          setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
      }

      /**
       * The base implementation of `_.invoke` without support for individual
       * method arguments.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the method to invoke.
       * @param {Array} args The arguments to invoke the method with.
       * @returns {*} Returns the result of the invoked method.
       */
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }

      /**
       * The base implementation of `_.isArguments`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       */
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }

      /**
       * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
       */
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }

      /**
       * The base implementation of `_.isDate` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
       */
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }

      /**
       * The base implementation of `_.isEqual` which supports partial comparisons
       * and tracks traversed objects.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Unordered comparison
       *  2 - Partial comparison
       * @param {Function} [customizer] The function to customize comparisons.
       * @param {Object} [stack] Tracks traversed `value` and `other` objects.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       */
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (
          value == null ||
          other == null ||
          (!isObjectLike(value) && !isObjectLike(other))
        ) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(
          value,
          other,
          bitmask,
          customizer,
          baseIsEqual,
          stack
        );
      }

      /**
       * A specialized version of `baseIsEqual` for arrays and objects which performs
       * deep comparisons and tracks traversed objects enabling objects with circular
       * references to be compared.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} [stack] Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */
      function baseIsEqualDeep(
        object,
        other,
        bitmask,
        customizer,
        equalFunc,
        stack
      ) {
        var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;

        var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object)
            ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
            : equalByTag(
                object,
                other,
                objTag,
                bitmask,
                customizer,
                equalFunc,
                stack
              );
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped =
              objIsObj && hasOwnProperty.call(object, "__wrapped__"),
            othIsWrapped =
              othIsObj && hasOwnProperty.call(other, "__wrapped__");

          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

            stack || (stack = new Stack());
            return equalFunc(
              objUnwrapped,
              othUnwrapped,
              bitmask,
              customizer,
              stack
            );
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(
          object,
          other,
          bitmask,
          customizer,
          equalFunc,
          stack
        );
      }

      /**
       * The base implementation of `_.isMap` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       */
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }

      /**
       * The base implementation of `_.isMatch` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @param {Array} matchData The property names, values, and compare flags to match.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       */
      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (index--) {
          var data = matchData[index];
          if (
            noCustomizer && data[2]
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
          ) {
            return false;
          }
        }
        while (++index < length) {
          data = matchData[index];
          var key = data[0],
            objValue = object[key],
            srcValue = data[1];

          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result = customizer(
                objValue,
                srcValue,
                key,
                object,
                source,
                stack
              );
            }
            if (
              !(result === undefined$1
                ? baseIsEqual(
                    srcValue,
                    objValue,
                    COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG,
                    customizer,
                    stack
                  )
                : result)
            ) {
              return false;
            }
          }
        }
        return true;
      }

      /**
       * The base implementation of `_.isNative` without bad shim checks.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function,
       *  else `false`.
       */
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }

      /**
       * The base implementation of `_.isRegExp` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
       */
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }

      /**
       * The base implementation of `_.isSet` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       */
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }

      /**
       * The base implementation of `_.isTypedArray` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       */
      function baseIsTypedArray(value) {
        return (
          isObjectLike(value) &&
          isLength(value.length) &&
          !!typedArrayTags[baseGetTag(value)]
        );
      }

      /**
       * The base implementation of `_.iteratee`.
       *
       * @private
       * @param {*} [value=_.identity] The value to convert to an iteratee.
       * @returns {Function} Returns the iteratee.
       */
      function baseIteratee(value) {
        // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
        // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == "object") {
          return isArray(value)
            ? baseMatchesProperty(value[0], value[1])
            : baseMatches(value);
        }
        return property(value);
      }

      /**
       * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != "constructor") {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object),
          result = [];

        for (var key in object) {
          if (
            !(
              key == "constructor" &&
              (isProto || !hasOwnProperty.call(object, key))
            )
          ) {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.lt` which doesn't coerce arguments.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is less than `other`,
       *  else `false`.
       */
      function baseLt(value, other) {
        return value < other;
      }

      /**
       * The base implementation of `_.map` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       */
      function baseMap(collection, iteratee) {
        var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

        baseEach(collection, function(value, key, collection) {
          result[++index] = iteratee(value, key, collection);
        });
        return result;
      }

      /**
       * The base implementation of `_.matches` which doesn't clone `source`.
       *
       * @private
       * @param {Object} source The object of property values to match.
       * @returns {Function} Returns the new spec function.
       */
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }

      /**
       * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
       *
       * @private
       * @param {string} path The path of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       */
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue
            ? hasIn(object, path)
            : baseIsEqual(
                srcValue,
                objValue,
                COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG
              );
        };
      }

      /**
       * The base implementation of `_.merge` without support for multiple sources.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} [customizer] The function to customize merged values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(
          source,
          function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(
                object,
                source,
                key,
                srcIndex,
                baseMerge,
                customizer,
                stack
              );
            } else {
              var newValue = customizer
                ? customizer(
                    safeGet(object, key),
                    srcValue,
                    key + "",
                    object,
                    source,
                    stack
                  )
                : undefined$1;

              if (newValue === undefined$1) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          },
          keysIn
        );
      }

      /**
       * A specialized version of `baseMerge` for arrays and objects which performs
       * deep merges and tracks traversed objects enabling objects with circular
       * references to be merged.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {string} key The key of the value to merge.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} mergeFunc The function to merge values.
       * @param {Function} [customizer] The function to customize assigned values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMergeDeep(
        object,
        source,
        key,
        srcIndex,
        mergeFunc,
        customizer,
        stack
      ) {
        var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer
          ? customizer(objValue, srcValue, key + "", object, source, stack)
          : undefined$1;

        var isCommon = newValue === undefined$1;

        if (isCommon) {
          var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          // Recursively merge objects and arrays (susceptible to call stack limits).
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }

      /**
       * The base implementation of `_.nth` which doesn't coerce arguments.
       *
       * @private
       * @param {Array} array The array to query.
       * @param {number} n The index of the element to return.
       * @returns {*} Returns the nth element of `array`.
       */
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }

      /**
       * The base implementation of `_.orderBy` without param guards.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
       * @param {string[]} orders The sort orders of `iteratees`.
       * @returns {Array} Returns the new sorted array.
       */
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee) {
            if (isArray(iteratee)) {
              return function(value) {
                return baseGet(
                  value,
                  iteratee.length === 1 ? iteratee[0] : iteratee
                );
              };
            }
            return iteratee;
          });
        } else {
          iteratees = [identity];
        }

        var index = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

        var result = baseMap(collection, function(value, key, collection) {
          var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
          });
          return { criteria: criteria, index: ++index, value: value };
        });

        return baseSortBy(result, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }

      /**
       * The base implementation of `_.pick` without support for individual
       * property identifiers.
       *
       * @private
       * @param {Object} object The source object.
       * @param {string[]} paths The property paths to pick.
       * @returns {Object} Returns the new object.
       */
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value, path) {
          return hasIn(object, path);
        });
      }

      /**
       * The base implementation of  `_.pickBy` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The source object.
       * @param {string[]} paths The property paths to pick.
       * @param {Function} predicate The function invoked per property.
       * @returns {Object} Returns the new object.
       */
      function basePickBy(object, paths, predicate) {
        var index = -1,
          length = paths.length,
          result = {};

        while (++index < length) {
          var path = paths[index],
            value = baseGet(object, path);

          if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
          }
        }
        return result;
      }

      /**
       * A specialized version of `baseProperty` which supports deep paths.
       *
       * @private
       * @param {Array|string} path The path of the property to get.
       * @returns {Function} Returns the new accessor function.
       */
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }

      /**
       * The base implementation of `_.pullAllBy` without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns `array`.
       */
      function basePullAll(array, values, iteratee, comparator) {
        var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

        if (array === values) {
          values = copyArray(values);
        }
        if (iteratee) {
          seen = arrayMap(array, baseUnary(iteratee));
        }
        while (++index < length) {
          var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

          while (
            (fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1
          ) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }

      /**
       * The base implementation of `_.pullAt` without support for individual
       * indexes or capturing the removed elements.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {number[]} indexes The indexes of elements to remove.
       * @returns {Array} Returns `array`.
       */
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0,
          lastIndex = length - 1;

        while (length--) {
          var index = indexes[length];
          if (length == lastIndex || index !== previous) {
            var previous = index;
            if (isIndex(index)) {
              splice.call(array, index, 1);
            } else {
              baseUnset(array, index);
            }
          }
        }
        return array;
      }

      /**
       * The base implementation of `_.random` without support for returning
       * floating-point numbers.
       *
       * @private
       * @param {number} lower The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the random number.
       */
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }

      /**
       * The base implementation of `_.range` and `_.rangeRight` which doesn't
       * coerce arguments.
       *
       * @private
       * @param {number} start The start of the range.
       * @param {number} end The end of the range.
       * @param {number} step The value to increment or decrement by.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Array} Returns the range of numbers.
       */
      function baseRange(start, end, step, fromRight) {
        var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

        while (length--) {
          result[fromRight ? length : ++index] = start;
          start += step;
        }
        return result;
      }

      /**
       * The base implementation of `_.repeat` which doesn't coerce arguments.
       *
       * @private
       * @param {string} string The string to repeat.
       * @param {number} n The number of times to repeat the string.
       * @returns {string} Returns the repeated string.
       */
      function baseRepeat(string, n) {
        var result = "";
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result;
        }
        // Leverage the exponentiation by squaring algorithm for a faster repeat.
        // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
        do {
          if (n % 2) {
            result += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);

        return result;
      }

      /**
       * The base implementation of `_.rest` which doesn't validate or coerce arguments.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       */
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + "");
      }

      /**
       * The base implementation of `_.sample`.
       *
       * @private
       * @param {Array|Object} collection The collection to sample.
       * @returns {*} Returns the random element.
       */
      function baseSample(collection) {
        return arraySample(values(collection));
      }

      /**
       * The base implementation of `_.sampleSize` without param guards.
       *
       * @private
       * @param {Array|Object} collection The collection to sample.
       * @param {number} n The number of elements to sample.
       * @returns {Array} Returns the random elements.
       */
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }

      /**
       * The base implementation of `_.set`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @param {Function} [customizer] The function to customize path creation.
       * @returns {Object} Returns `object`.
       */
      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }
        path = castPath(path, object);

        var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

        while (nested != null && ++index < length) {
          var key = toKey(path[index]),
            newValue = value;

          if (
            key === "__proto__" ||
            key === "constructor" ||
            key === "prototype"
          ) {
            return object;
          }

          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer
              ? customizer(objValue, key, nested)
              : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject(objValue)
                ? objValue
                : isIndex(path[index + 1])
                ? []
                : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }

      /**
       * The base implementation of `setData` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to associate metadata with.
       * @param {*} data The metadata.
       * @returns {Function} Returns `func`.
       */
      var baseSetData = !metaMap
        ? identity
        : function(func, data) {
            metaMap.set(func, data);
            return func;
          };

      /**
       * The base implementation of `setToString` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var baseSetToString = !defineProperty
        ? identity
        : function(func, string) {
            return defineProperty(func, "toString", {
              configurable: true,
              enumerable: false,
              value: constant(string),
              writable: true
            });
          };

      /**
       * The base implementation of `_.shuffle`.
       *
       * @private
       * @param {Array|Object} collection The collection to shuffle.
       * @returns {Array} Returns the new shuffled array.
       */
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }

      /**
       * The base implementation of `_.slice` without an iteratee call guard.
       *
       * @private
       * @param {Array} array The array to slice.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the slice of `array`.
       */
      function baseSlice(array, start, end) {
        var index = -1,
          length = array.length;

        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : (end - start) >>> 0;
        start >>>= 0;

        var result = Array(length);
        while (++index < length) {
          result[index] = array[index + start];
        }
        return result;
      }

      /**
       * The base implementation of `_.some` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if any element passes the predicate check,
       *  else `false`.
       */
      function baseSome(collection, predicate) {
        var result;

        baseEach(collection, function(value, index, collection) {
          result = predicate(value, index, collection);
          return !result;
        });
        return !!result;
      }

      /**
       * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
       * performs a binary search of `array` to determine the index at which `value`
       * should be inserted into `array` in order to maintain its sort order.
       *
       * @private
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {boolean} [retHighest] Specify returning the highest qualified index.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       */
      function baseSortedIndex(array, value, retHighest) {
        var low = 0,
          high = array == null ? low : array.length;

        if (
          typeof value == "number" &&
          value === value &&
          high <= HALF_MAX_ARRAY_LENGTH
        ) {
          while (low < high) {
            var mid = (low + high) >>> 1,
              computed = array[mid];

            if (
              computed !== null &&
              !isSymbol(computed) &&
              (retHighest ? computed <= value : computed < value)
            ) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }

      /**
       * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
       * which invokes `iteratee` for `value` and each element of `array` to compute
       * their sort ranking. The iteratee is invoked with one argument; (value).
       *
       * @private
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {Function} iteratee The iteratee invoked per element.
       * @param {boolean} [retHighest] Specify returning the highest qualified index.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       */
      function baseSortedIndexBy(array, value, iteratee, retHighest) {
        var low = 0,
          high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }

        value = iteratee(value);
        var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;

        while (low < high) {
          var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow =
              othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow =
              othIsReflexive &&
              othIsDefined &&
              !othIsNull &&
              (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }

      /**
       * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
       * support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       */
      function baseSortedUniq(array, iteratee) {
        var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

        while (++index < length) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;

          if (!index || !eq(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.toNumber` which doesn't ensure correct
       * conversions of binary, hexadecimal, or octal string values.
       *
       * @private
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       */
      function baseToNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }

      /**
       * The base implementation of `_.toString` which doesn't convert nullish
       * values to empty strings.
       *
       * @private
       * @param {*} value The value to process.
       * @returns {string} Returns the string.
       */
      function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == "string") {
          return value;
        }
        if (isArray(value)) {
          // Recursively convert values (susceptible to call stack limits).
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
      }

      /**
       * The base implementation of `_.uniqBy` without support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       */
      function baseUniq(array, iteratee, comparator) {
        var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

        if (comparator) {
          isCommon = false;
          includes = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set = iteratee ? null : createSet(array);
          if (set) {
            return setToArray(set);
          }
          isCommon = false;
          includes = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee ? [] : result;
        }
        outer: while (++index < length) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;

          value = comparator || value !== 0 ? value : 0;
          if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while (seenIndex--) {
              if (seen[seenIndex] === computed) {
                continue outer;
              }
            }
            if (iteratee) {
              seen.push(computed);
            }
            result.push(value);
          } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.unset`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The property path to unset.
       * @returns {boolean} Returns `true` if the property is deleted, else `false`.
       */
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }

      /**
       * The base implementation of `_.update`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to update.
       * @param {Function} updater The function to produce the updated value.
       * @param {Function} [customizer] The function to customize path creation.
       * @returns {Object} Returns `object`.
       */
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(
          object,
          path,
          updater(baseGet(object, path)),
          customizer
        );
      }

      /**
       * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
       * without support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to query.
       * @param {Function} predicate The function invoked per iteration.
       * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Array} Returns the slice of `array`.
       */
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length,
          index = fromRight ? length : -1;

        while (
          (fromRight ? index-- : ++index < length) &&
          predicate(array[index], index, array)
        ) {}

        return isDrop
          ? baseSlice(
              array,
              fromRight ? 0 : index,
              fromRight ? index + 1 : length
            )
          : baseSlice(
              array,
              fromRight ? index + 1 : 0,
              fromRight ? length : index
            );
      }

      /**
       * The base implementation of `wrapperValue` which returns the result of
       * performing a sequence of actions on the unwrapped `value`, where each
       * successive action is supplied the return value of the previous.
       *
       * @private
       * @param {*} value The unwrapped value.
       * @param {Array} actions Actions to perform to resolve the unwrapped value.
       * @returns {*} Returns the resolved value.
       */
      function baseWrapperValue(value, actions) {
        var result = value;
        if (result instanceof LazyWrapper) {
          result = result.value();
        }
        return arrayReduce(
          actions,
          function(result, action) {
            return action.func.apply(
              action.thisArg,
              arrayPush([result], action.args)
            );
          },
          result
        );
      }

      /**
       * The base implementation of methods like `_.xor`, without support for
       * iteratee shorthands, that accepts an array of arrays to inspect.
       *
       * @private
       * @param {Array} arrays The arrays to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of values.
       */
      function baseXor(arrays, iteratee, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index = -1,
          result = Array(length);

        while (++index < length) {
          var array = arrays[index],
            othIndex = -1;

          while (++othIndex < length) {
            if (othIndex != index) {
              result[index] = baseDifference(
                result[index] || array,
                arrays[othIndex],
                iteratee,
                comparator
              );
            }
          }
        }
        return baseUniq(baseFlatten(result, 1), iteratee, comparator);
      }

      /**
       * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
       *
       * @private
       * @param {Array} props The property identifiers.
       * @param {Array} values The property values.
       * @param {Function} assignFunc The function to assign values.
       * @returns {Object} Returns the new object.
       */
      function baseZipObject(props, values, assignFunc) {
        var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

        while (++index < length) {
          var value = index < valsLength ? values[index] : undefined$1;
          assignFunc(result, props[index], value);
        }
        return result;
      }

      /**
       * Casts `value` to an empty array if it's not an array like object.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {Array|Object} Returns the cast array-like object.
       */
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }

      /**
       * Casts `value` to `identity` if it's not a function.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {Function} Returns cast function.
       */
      function castFunction(value) {
        return typeof value == "function" ? value : identity;
      }

      /**
       * Casts `value` to a path array if it's not one.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {Object} [object] The object to query keys on.
       * @returns {Array} Returns the cast property path array.
       */
      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }

      /**
       * A `baseRest` alias which can be replaced with `identity` by module
       * replacement plugins.
       *
       * @private
       * @type {Function}
       * @param {Function} func The function to apply a rest parameter to.
       * @returns {Function} Returns the new function.
       */
      var castRest = baseRest;

      /**
       * Casts `array` to a slice if it's needed.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {number} start The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the cast slice.
       */
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }

      /**
       * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
       *
       * @private
       * @param {number|Object} id The timer id or timeout object of the timer to clear.
       */
      var clearTimeout =
        ctxClearTimeout ||
        function(id) {
          return root.clearTimeout(id);
        };

      /**
       * Creates a clone of  `buffer`.
       *
       * @private
       * @param {Buffer} buffer The buffer to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Buffer} Returns the cloned buffer.
       */
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length,
          result = allocUnsafe
            ? allocUnsafe(length)
            : new buffer.constructor(length);

        buffer.copy(result);
        return result;
      }

      /**
       * Creates a clone of `arrayBuffer`.
       *
       * @private
       * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
       * @returns {ArrayBuffer} Returns the cloned array buffer.
       */
      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result).set(new Uint8Array(arrayBuffer));
        return result;
      }

      /**
       * Creates a clone of `dataView`.
       *
       * @private
       * @param {Object} dataView The data view to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned data view.
       */
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep
          ? cloneArrayBuffer(dataView.buffer)
          : dataView.buffer;
        return new dataView.constructor(
          buffer,
          dataView.byteOffset,
          dataView.byteLength
        );
      }

      /**
       * Creates a clone of `regexp`.
       *
       * @private
       * @param {Object} regexp The regexp to clone.
       * @returns {Object} Returns the cloned regexp.
       */
      function cloneRegExp(regexp) {
        var result = new regexp.constructor(
          regexp.source,
          reFlags.exec(regexp)
        );
        result.lastIndex = regexp.lastIndex;
        return result;
      }

      /**
       * Creates a clone of the `symbol` object.
       *
       * @private
       * @param {Object} symbol The symbol object to clone.
       * @returns {Object} Returns the cloned symbol object.
       */
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }

      /**
       * Creates a clone of `typedArray`.
       *
       * @private
       * @param {Object} typedArray The typed array to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned typed array.
       */
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep
          ? cloneArrayBuffer(typedArray.buffer)
          : typedArray.buffer;
        return new typedArray.constructor(
          buffer,
          typedArray.byteOffset,
          typedArray.length
        );
      }

      /**
       * Compares values to sort them in ascending order.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {number} Returns the sort order indicator for `value`.
       */
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

          var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

          if (
            (!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol &&
              othIsDefined &&
              othIsReflexive &&
              !othIsNull &&
              !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive
          ) {
            return 1;
          }
          if (
            (!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol &&
              valIsDefined &&
              valIsReflexive &&
              !valIsNull &&
              !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive
          ) {
            return -1;
          }
        }
        return 0;
      }

      /**
       * Used by `_.orderBy` to compare multiple properties of a value to another
       * and stable sort them.
       *
       * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
       * specify an order of "desc" for descending or "asc" for ascending sort order
       * of corresponding values.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {boolean[]|string[]} orders The order to sort by for each property.
       * @returns {number} Returns the sort order indicator for `object`.
       */
      function compareMultiple(object, other, orders) {
        var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

        while (++index < length) {
          var result = compareAscending(objCriteria[index], othCriteria[index]);
          if (result) {
            if (index >= ordersLength) {
              return result;
            }
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
          }
        }
        // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
        // that causes it, under certain circumstances, to provide the same value for
        // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
        // for more details.
        //
        // This also ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
      }

      /**
       * Creates an array that is the composition of partially applied arguments,
       * placeholders, and provided arguments into a single array of arguments.
       *
       * @private
       * @param {Array} args The provided arguments.
       * @param {Array} partials The arguments to prepend to those provided.
       * @param {Array} holders The `partials` placeholder indexes.
       * @params {boolean} [isCurried] Specify composing for a curried function.
       * @returns {Array} Returns the new array of composed arguments.
       */
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

        while (++leftIndex < leftLength) {
          result[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result[leftIndex++] = args[argsIndex++];
        }
        return result;
      }

      /**
       * This function is like `composeArgs` except that the arguments composition
       * is tailored for `_.partialRight`.
       *
       * @private
       * @param {Array} args The provided arguments.
       * @param {Array} partials The arguments to append to those provided.
       * @param {Array} holders The `partials` placeholder indexes.
       * @params {boolean} [isCurried] Specify composing for a curried function.
       * @returns {Array} Returns the new array of composed arguments.
       */
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

        while (++argsIndex < rangeLength) {
          result[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result;
      }

      /**
       * Copies the values of `source` to `array`.
       *
       * @private
       * @param {Array} source The array to copy values from.
       * @param {Array} [array=[]] The array to copy values to.
       * @returns {Array} Returns `array`.
       */
      function copyArray(source, array) {
        var index = -1,
          length = source.length;

        array || (array = Array(length));
        while (++index < length) {
          array[index] = source[index];
        }
        return array;
      }

      /**
       * Copies properties of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy properties from.
       * @param {Array} props The property identifiers to copy.
       * @param {Object} [object={}] The object to copy properties to.
       * @param {Function} [customizer] The function to customize copied values.
       * @returns {Object} Returns `object`.
       */
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});

        var index = -1,
          length = props.length;

        while (++index < length) {
          var key = props[index];

          var newValue = customizer
            ? customizer(object[key], source[key], key, object, source)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }

      /**
       * Copies own symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }

      /**
       * Copies own and inherited symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }

      /**
       * Creates a function like `_.groupBy`.
       *
       * @private
       * @param {Function} setter The function to set accumulator values.
       * @param {Function} [initializer] The accumulator object initializer.
       * @returns {Function} Returns the new aggregator function.
       */
      function createAggregator(setter, initializer) {
        return function(collection, iteratee) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

          return func(
            collection,
            setter,
            getIteratee(iteratee, 2),
            accumulator
          );
        };
      }

      /**
       * Creates a function like `_.assign`.
       *
       * @private
       * @param {Function} assigner The function to assign values.
       * @returns {Function} Returns the new assigner function.
       */
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;

          customizer =
            assigner.length > 3 && typeof customizer == "function"
              ? (length--, customizer)
              : undefined$1;

          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object(object);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }

      /**
       * Creates a `baseEach` or `baseEachRight` function.
       *
       * @private
       * @param {Function} eachFunc The function to iterate over a collection.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new base function.
       */
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
          }
          var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

          while (fromRight ? index-- : ++index < length) {
            if (iteratee(iterable[index], index, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }

      /**
       * Creates a base function for methods like `_.forIn` and `_.forOwn`.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new base function.
       */
      function createBaseFor(fromRight) {
        return function(object, iteratee, keysFunc) {
          var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }

      /**
       * Creates a function that wraps `func` to invoke it with the optional `this`
       * binding of `thisArg`.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {*} [thisArg] The `this` binding of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

        function wrapper() {
          var fn =
            this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }

      /**
       * Creates a function like `_.lowerFirst`.
       *
       * @private
       * @param {string} methodName The name of the `String` case method to use.
       * @returns {Function} Returns the new case function.
       */
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString(string);

          var strSymbols = hasUnicode(string)
            ? stringToArray(string)
            : undefined$1;

          var chr = strSymbols ? strSymbols[0] : string.charAt(0);

          var trailing = strSymbols
            ? castSlice(strSymbols, 1).join("")
            : string.slice(1);

          return chr[methodName]() + trailing;
        };
      }

      /**
       * Creates a function like `_.camelCase`.
       *
       * @private
       * @param {Function} callback The function to combine each word.
       * @returns {Function} Returns the new compounder function.
       */
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(
            words(deburr(string).replace(reApos, "")),
            callback,
            ""
          );
        };
      }

      /**
       * Creates a function that produces an instance of `Ctor` regardless of
       * whether it was invoked as part of a `new` expression or by `call` or `apply`.
       *
       * @private
       * @param {Function} Ctor The constructor to wrap.
       * @returns {Function} Returns the new wrapped function.
       */
      function createCtor(Ctor) {
        return function() {
          // Use a `switch` statement to work with class constructors. See
          // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
          // for more details.
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(
                args[0],
                args[1],
                args[2],
                args[3],
                args[4],
                args[5]
              );
            case 7:
              return new Ctor(
                args[0],
                args[1],
                args[2],
                args[3],
                args[4],
                args[5],
                args[6]
              );
          }
          var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

          // Mimic the constructor's `return` behavior.
          // See https://es5.github.io/#x13.2.2 for more details.
          return isObject(result) ? result : thisBinding;
        };
      }

      /**
       * Creates a function that wraps `func` to enable currying.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {number} arity The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);

        function wrapper() {
          var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

          while (index--) {
            args[index] = arguments[index];
          }
          var holders =
            length < 3 &&
            args[0] !== placeholder &&
            args[length - 1] !== placeholder
              ? []
              : replaceHolders(args, placeholder);

          length -= holders.length;
          if (length < arity) {
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              undefined$1,
              args,
              holders,
              undefined$1,
              undefined$1,
              arity - length
            );
          }
          var fn =
            this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }

      /**
       * Creates a `_.find` or `_.findLast` function.
       *
       * @private
       * @param {Function} findIndexFunc The function to find the collection index.
       * @returns {Function} Returns the new find function.
       */
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object(collection);
          if (!isArrayLike(collection)) {
            var iteratee = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee(iterable[key], key, iterable);
            };
          }
          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1
            ? iterable[iteratee ? collection[index] : index]
            : undefined$1;
        };
      }

      /**
       * Creates a `_.flow` or `_.flowRight` function.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new flow function.
       */
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

          if (fromRight) {
            funcs.reverse();
          }
          while (index--) {
            var func = funcs[index];
            if (typeof func != "function") {
              throw new TypeError(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index = wrapper ? index : length;
          while (++index < length) {
            func = funcs[index];

            var funcName = getFuncName(func),
              data = funcName == "wrapper" ? getData(func) : undefined$1;

            if (
              data &&
              isLaziable(data[0]) &&
              data[1] ==
                (WRAP_ARY_FLAG |
                  WRAP_CURRY_FLAG |
                  WRAP_PARTIAL_FLAG |
                  WRAP_REARG_FLAG) &&
              !data[4].length &&
              data[9] == 1
            ) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper =
                func.length == 1 && isLaziable(func)
                  ? wrapper[funcName]()
                  : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments,
              value = args[0];

            if (wrapper && args.length == 1 && isArray(value)) {
              return wrapper.plant(value).value();
            }
            var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

            while (++index < length) {
              result = funcs[index].call(this, result);
            }
            return result;
          };
        });
      }

      /**
       * Creates a function that wraps `func` to invoke it with optional `this`
       * binding of `thisArg`, partial application, and currying.
       *
       * @private
       * @param {Function|string} func The function or method name to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {*} [thisArg] The `this` binding of `func`.
       * @param {Array} [partials] The arguments to prepend to those provided to
       *  the new function.
       * @param {Array} [holders] The `partials` placeholder indexes.
       * @param {Array} [partialsRight] The arguments to append to those provided
       *  to the new function.
       * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
       * @param {Array} [argPos] The argument positions of the new function.
       * @param {number} [ary] The arity cap of `func`.
       * @param {number} [arity] The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createHybrid(
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
      ) {
        var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);

        function wrapper() {
          var length = arguments.length,
            args = Array(length),
            index = length;

          while (index--) {
            args[index] = arguments[index];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(
              args,
              partialsRight,
              holdersRight,
              isCurried
            );
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func,
              bitmask,
              createHybrid,
              wrapper.placeholder,
              thisArg,
              args,
              newHolders,
              argPos,
              ary,
              arity - length
            );
          }
          var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary < length) {
            args.length = ary;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }

      /**
       * Creates a function like `_.invertBy`.
       *
       * @private
       * @param {Function} setter The function to set accumulator values.
       * @param {Function} toIteratee The function to resolve iteratees.
       * @returns {Function} Returns the new inverter function.
       */
      function createInverter(setter, toIteratee) {
        return function(object, iteratee) {
          return baseInverter(object, setter, toIteratee(iteratee), {});
        };
      }

      /**
       * Creates a function that performs a mathematical operation on two values.
       *
       * @private
       * @param {Function} operator The function to perform the operation.
       * @param {number} [defaultValue] The value used for `undefined` arguments.
       * @returns {Function} Returns the new mathematical operation function.
       */
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result = value;
          }
          if (other !== undefined$1) {
            if (result === undefined$1) {
              return other;
            }
            if (typeof value == "string" || typeof other == "string") {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result = operator(value, other);
          }
          return result;
        };
      }

      /**
       * Creates a function like `_.over`.
       *
       * @private
       * @param {Function} arrayFunc The function to iterate over iteratees.
       * @returns {Function} Returns the new over function.
       */
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee) {
              return apply(iteratee, thisArg, args);
            });
          });
        });
      }

      /**
       * Creates the padding for `string` based on `length`. The `chars` string
       * is truncated if the number of characters exceeds `length`.
       *
       * @private
       * @param {number} length The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padding for `string`.
       */
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? " " : baseToString(chars);

        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars)
          ? castSlice(stringToArray(result), 0, length).join("")
          : result.slice(0, length);
      }

      /**
       * Creates a function that wraps `func` to invoke it with the `this` binding
       * of `thisArg` and `partials` prepended to the arguments it receives.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {Array} partials The arguments to prepend to those provided to
       *  the new function.
       * @returns {Function} Returns the new wrapped function.
       */
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

        function wrapper() {
          var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = this && this !== root && this instanceof wrapper ? Ctor : func;

          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }

      /**
       * Creates a `_.range` or `_.rangeRight` function.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new range function.
       */
      function createRange(fromRight) {
        return function(start, end, step) {
          if (
            step &&
            typeof step != "number" &&
            isIterateeCall(start, end, step)
          ) {
            end = step = undefined$1;
          }
          // Ensure the sign of `-0` is preserved.
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }

      /**
       * Creates a function that performs a relational operation on two values.
       *
       * @private
       * @param {Function} operator The function to perform the operation.
       * @returns {Function} Returns the new relational operation function.
       */
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == "string" && typeof other == "string")) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }

      /**
       * Creates a function that wraps `func` to continue currying.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {Function} wrapFunc The function to create the `func` wrapper.
       * @param {*} placeholder The placeholder value.
       * @param {*} [thisArg] The `this` binding of `func`.
       * @param {Array} [partials] The arguments to prepend to those provided to
       *  the new function.
       * @param {Array} [holders] The `partials` placeholder indexes.
       * @param {Array} [argPos] The argument positions of the new function.
       * @param {number} [ary] The arity cap of `func`.
       * @param {number} [arity] The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createRecurry(
        func,
        bitmask,
        wrapFunc,
        placeholder,
        thisArg,
        partials,
        holders,
        argPos,
        ary,
        arity
      ) {
        var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;

        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func,
          bitmask,
          thisArg,
          newPartials,
          newHolders,
          newPartialsRight,
          newHoldersRight,
          argPos,
          ary,
          arity
        ];

        var result = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result, newData);
        }
        result.placeholder = placeholder;
        return setWrapToString(result, func, bitmask);
      }

      /**
       * Creates a function like `_.round`.
       *
       * @private
       * @param {string} methodName The name of the `Math` method to use when rounding.
       * @returns {Function} Returns the new round function.
       */
      function createRound(methodName) {
        var func = Math[methodName];
        return function(number, precision) {
          number = toNumber(number);
          precision =
            precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = (toString(number) + "e").split("e"),
              value = func(pair[0] + "e" + (+pair[1] + precision));

            pair = (toString(value) + "e").split("e");
            return +(pair[0] + "e" + (+pair[1] - precision));
          }
          return func(number);
        };
      }

      /**
       * Creates a set object of `values`.
       *
       * @private
       * @param {Array} values The values to add to the set.
       * @returns {Object} Returns the new set.
       */
      var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY)
        ? noop
        : function(values) {
            return new Set(values);
          };

      /**
       * Creates a `_.toPairs` or `_.toPairsIn` function.
       *
       * @private
       * @param {Function} keysFunc The function to get the keys of a given object.
       * @returns {Function} Returns the new pairs function.
       */
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }

      /**
       * Creates a function that either curries or invokes `func` with optional
       * `this` binding and partially applied arguments.
       *
       * @private
       * @param {Function|string} func The function or method name to wrap.
       * @param {number} bitmask The bitmask flags.
       *    1 - `_.bind`
       *    2 - `_.bindKey`
       *    4 - `_.curry` or `_.curryRight` of a bound function
       *    8 - `_.curry`
       *   16 - `_.curryRight`
       *   32 - `_.partial`
       *   64 - `_.partialRight`
       *  128 - `_.rearg`
       *  256 - `_.ary`
       *  512 - `_.flip`
       * @param {*} [thisArg] The `this` binding of `func`.
       * @param {Array} [partials] The arguments to be partially applied.
       * @param {Array} [holders] The `partials` placeholder indexes.
       * @param {Array} [argPos] The argument positions of the new function.
       * @param {number} [ary] The arity cap of `func`.
       * @param {number} [arity] The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createWrap(
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        argPos,
        ary,
        arity
      ) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;

        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials,
            holdersRight = holders;

          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);

        var newData = [
          func,
          bitmask,
          thisArg,
          partials,
          holders,
          partialsRight,
          holdersRight,
          argPos,
          ary,
          arity
        ];

        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] =
          newData[9] === undefined$1
            ? isBindKey
              ? 0
              : func.length
            : nativeMax(newData[9] - length, 0);

        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result = createBind(func, bitmask, thisArg);
        } else if (
          bitmask == WRAP_CURRY_FLAG ||
          bitmask == WRAP_CURRY_RIGHT_FLAG
        ) {
          result = createCurry(func, bitmask, arity);
        } else if (
          (bitmask == WRAP_PARTIAL_FLAG ||
            bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) &&
          !holders.length
        ) {
          result = createPartial(func, bitmask, thisArg, partials);
        } else {
          result = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result, newData), func, bitmask);
      }

      /**
       * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
       * of source objects to the destination object for all destination properties
       * that resolve to `undefined`.
       *
       * @private
       * @param {*} objValue The destination value.
       * @param {*} srcValue The source value.
       * @param {string} key The key of the property to assign.
       * @param {Object} object The parent object of `objValue`.
       * @returns {*} Returns the value to assign.
       */
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (
          objValue === undefined$1 ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))
        ) {
          return srcValue;
        }
        return objValue;
      }

      /**
       * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
       * objects into destination objects that are passed thru.
       *
       * @private
       * @param {*} objValue The destination value.
       * @param {*} srcValue The source value.
       * @param {string} key The key of the property to merge.
       * @param {Object} object The parent object of `objValue`.
       * @param {Object} source The parent object of `srcValue`.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       * @returns {*} Returns the value to assign.
       */
      function customDefaultsMerge(
        objValue,
        srcValue,
        key,
        object,
        source,
        stack
      ) {
        if (isObject(objValue) && isObject(srcValue)) {
          // Recursively merge objects and arrays (susceptible to call stack limits).
          stack.set(srcValue, objValue);
          baseMerge(
            objValue,
            srcValue,
            undefined$1,
            customDefaultsMerge,
            stack
          );
          stack["delete"](srcValue);
        }
        return objValue;
      }

      /**
       * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
       * objects.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {string} key The key of the property to inspect.
       * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
       */
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$1 : value;
      }

      /**
       * A specialized version of `baseIsEqualDeep` for arrays with support for
       * partial deep comparisons.
       *
       * @private
       * @param {Array} array The array to compare.
       * @param {Array} other The other array to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `array` and `other` objects.
       * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
       */
      function equalArrays(
        array,
        other,
        bitmask,
        customizer,
        equalFunc,
        stack
      ) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        // Check that cyclic values are equal.
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index = -1,
          result = true,
          seen =
            bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;

        stack.set(array, other);
        stack.set(other, array);

        // Ignore non-index properties.
        while (++index < arrLength) {
          var arrValue = array[index],
            othValue = other[index];

          if (customizer) {
            var compared = isPartial
              ? customizer(othValue, arrValue, index, other, array, stack)
              : customizer(arrValue, othValue, index, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result = false;
            break;
          }
          // Recursively compare arrays (susceptible to call stack limits).
          if (seen) {
            if (
              !arraySome(other, function(othValue, othIndex) {
                if (
                  !cacheHas(seen, othIndex) &&
                  (arrValue === othValue ||
                    equalFunc(arrValue, othValue, bitmask, customizer, stack))
                ) {
                  return seen.push(othIndex);
                }
              })
            ) {
              result = false;
              break;
            }
          } else if (
            !(
              arrValue === othValue ||
              equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )
          ) {
            result = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result;
      }

      /**
       * A specialized version of `baseIsEqualDeep` for comparing objects of
       * the same `toStringTag`.
       *
       * **Note:** This function only supports comparing values with tags of
       * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {string} tag The `toStringTag` of the objects to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */
      function equalByTag(
        object,
        other,
        tag,
        bitmask,
        customizer,
        equalFunc,
        stack
      ) {
        switch (tag) {
          case dataViewTag:
            if (
              object.byteLength != other.byteLength ||
              object.byteOffset != other.byteOffset
            ) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;

          case arrayBufferTag:
            if (
              object.byteLength != other.byteLength ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))
            ) {
              return false;
            }
            return true;

          case boolTag:
          case dateTag:
          case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);

          case errorTag:
            return object.name == other.name && object.message == other.message;

          case regexpTag:
          case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";

          case mapTag:
            var convert = mapToArray;

          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);

            if (object.size != other.size && !isPartial) {
              return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;

            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(
              convert(object),
              convert(other),
              bitmask,
              customizer,
              equalFunc,
              stack
            );
            stack["delete"](object);
            return result;

          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }

      /**
       * A specialized version of `baseIsEqualDeep` for objects with support for
       * partial deep comparisons.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */
      function equalObjects(
        object,
        other,
        bitmask,
        customizer,
        equalFunc,
        stack
      ) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index = objLength;
        while (index--) {
          var key = objProps[index];
          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }
        // Check that cyclic values are equal.
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result = true;
        stack.set(object, other);
        stack.set(other, object);

        var skipCtor = isPartial;
        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key],
            othValue = other[key];

          if (customizer) {
            var compared = isPartial
              ? customizer(othValue, objValue, key, other, object, stack)
              : customizer(objValue, othValue, key, object, other, stack);
          }
          // Recursively compare objects (susceptible to call stack limits).
          if (
            !(compared === undefined$1
              ? objValue === othValue ||
                equalFunc(objValue, othValue, bitmask, customizer, stack)
              : compared)
          ) {
            result = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result && !skipCtor) {
          var objCtor = object.constructor,
            othCtor = other.constructor;

          // Non `Object` object instances with different constructors are not equal.
          if (
            objCtor != othCtor &&
            "constructor" in object && "constructor" in other &&
            !(
              typeof objCtor == "function" &&
              objCtor instanceof objCtor &&
              typeof othCtor == "function" &&
              othCtor instanceof othCtor
            )
          ) {
            result = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result;
      }

      /**
       * A specialized version of `baseRest` which flattens the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @returns {Function} Returns the new function.
       */
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + "");
      }

      /**
       * Creates an array of own enumerable property names and symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }

      /**
       * Creates an array of own and inherited enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }

      /**
       * Gets metadata for `func`.
       *
       * @private
       * @param {Function} func The function to query.
       * @returns {*} Returns the metadata for `func`.
       */
      var getData = !metaMap
        ? noop
        : function(func) {
            return metaMap.get(func);
          };

      /**
       * Gets the name of `func`.
       *
       * @private
       * @param {Function} func The function to query.
       * @returns {string} Returns the function name.
       */
      function getFuncName(func) {
        var result = func.name + "",
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

        while (length--) {
          var data = array[length],
            otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result;
      }

      /**
       * Gets the argument placeholder value for `func`.
       *
       * @private
       * @param {Function} func The function to inspect.
       * @returns {*} Returns the placeholder value.
       */
      function getHolder(func) {
        var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
        return object.placeholder;
      }

      /**
       * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
       * this function returns the custom method, otherwise it returns `baseIteratee`.
       * If arguments are provided, the chosen function is invoked with them and
       * its result is returned.
       *
       * @private
       * @param {*} [value] The value to convert to an iteratee.
       * @param {number} [arity] The arity of the created iteratee.
       * @returns {Function} Returns the chosen function or its result.
       */
      function getIteratee() {
        var result = lodash.iteratee || iteratee;
        result = result === iteratee ? baseIteratee : result;
        return arguments.length ? result(arguments[0], arguments[1]) : result;
      }

      /**
       * Gets the data for `map`.
       *
       * @private
       * @param {Object} map The map to query.
       * @param {string} key The reference key.
       * @returns {*} Returns the map data.
       */
      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key)
          ? data[typeof key == "string" ? "string" : "hash"]
          : data.map;
      }

      /**
       * Gets the property names, values, and compare flags of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the match data of `object`.
       */
      function getMatchData(object) {
        var result = keys(object),
          length = result.length;

        while (length--) {
          var key = result[length],
            value = object[key];

          result[length] = [key, value, isStrictComparable(value)];
        }
        return result;
      }

      /**
       * Gets the native function at `key` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the method to get.
       * @returns {*} Returns the function if it's native, else `undefined`.
       */
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }

      /**
       * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the raw `toStringTag`.
       */
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {}

        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }

      /**
       * Creates an array of the own enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbols = !nativeGetSymbols
        ? stubArray
        : function(object) {
            if (object == null) {
              return [];
            }
            object = Object(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
              return propertyIsEnumerable.call(object, symbol);
            });
          };

      /**
       * Creates an array of the own and inherited enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbolsIn = !nativeGetSymbols
        ? stubArray
        : function(object) {
            var result = [];
            while (object) {
              arrayPush(result, getSymbols(object));
              object = getPrototype(object);
            }
            return result;
          };

      /**
       * Gets the `toStringTag` of `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      var getTag = baseGetTag;

      // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
      if (
        (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map()) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set()) != setTag) ||
        (WeakMap && getTag(new WeakMap()) != weakMapTag)
      ) {
        getTag = function(value) {
          var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : "";

          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result;
        };
      }

      /**
       * Gets the view, applying any `transforms` to the `start` and `end` positions.
       *
       * @private
       * @param {number} start The start of the view.
       * @param {number} end The end of the view.
       * @param {Array} transforms The transformations to apply to the view.
       * @returns {Object} Returns an object containing the `start` and `end`
       *  positions of the view.
       */
      function getView(start, end, transforms) {
        var index = -1,
          length = transforms.length;

        while (++index < length) {
          var data = transforms[index],
            size = data.size;

          switch (data.type) {
            case "drop":
              start += size;
              break;
            case "dropRight":
              end -= size;
              break;
            case "take":
              end = nativeMin(end, start + size);
              break;
            case "takeRight":
              start = nativeMax(start, end - size);
              break;
          }
        }
        return { start: start, end: end };
      }

      /**
       * Extracts wrapper details from the `source` body comment.
       *
       * @private
       * @param {string} source The source to inspect.
       * @returns {Array} Returns the wrapper details.
       */
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }

      /**
       * Checks if `path` exists on `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @param {Function} hasFunc The function to check properties.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       */
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);

        var index = -1,
          length = path.length,
          result = false;

        while (++index < length) {
          var key = toKey(path[index]);
          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result || ++index != length) {
          return result;
        }
        length = object == null ? 0 : object.length;
        return (
          !!length &&
          isLength(length) &&
          isIndex(key, length) &&
          (isArray(object) || isArguments(object))
        );
      }

      /**
       * Initializes an array clone.
       *
       * @private
       * @param {Array} array The array to clone.
       * @returns {Array} Returns the initialized clone.
       */
      function initCloneArray(array) {
        var length = array.length,
          result = new array.constructor(length);

        // Add properties assigned by `RegExp#exec`.
        if (
          length &&
          typeof array[0] == "string" &&
          hasOwnProperty.call(array, "index")
        ) {
          result.index = array.index;
          result.input = array.input;
        }
        return result;
      }

      /**
       * Initializes an object clone.
       *
       * @private
       * @param {Object} object The object to clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object)
          ? baseCreate(getPrototype(object))
          : {};
      }

      /**
       * Initializes an object clone based on its `toStringTag`.
       *
       * **Note:** This function only supports cloning values with tags of
       * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
       *
       * @private
       * @param {Object} object The object to clone.
       * @param {string} tag The `toStringTag` of the object to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);

          case boolTag:
          case dateTag:
            return new Ctor(+object);

          case dataViewTag:
            return cloneDataView(object, isDeep);

          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);

          case mapTag:
            return new Ctor();

          case numberTag:
          case stringTag:
            return new Ctor(object);

          case regexpTag:
            return cloneRegExp(object);

          case setTag:
            return new Ctor();

          case symbolTag:
            return cloneSymbol(object);
        }
      }

      /**
       * Inserts wrapper `details` in a comment at the top of the `source` body.
       *
       * @private
       * @param {string} source The source to modify.
       * @returns {Array} details The details to insert.
       * @returns {string} Returns the modified source.
       */
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
        details = details.join(length > 2 ? ", " : " ");
        return source.replace(
          reWrapComment,
          "{\n/* [wrapped with " + details + "] */\n"
        );
      }

      /**
       * Checks if `value` is a flattenable `arguments` object or array.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
       */
      function isFlattenable(value) {
        return (
          isArray(value) ||
          isArguments(value) ||
          !!(spreadableSymbol && value && value[spreadableSymbol])
        );
      }

      /**
       * Checks if `value` is a valid array-like index.
       *
       * @private
       * @param {*} value The value to check.
       * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
       * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
       */
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;

        return (
          !!length &&
          (type == "number" || (type != "symbol" && reIsUint.test(value))) &&
          value > -1 && value % 1 == 0 && value < length
        );
      }

      /**
       * Checks if the given arguments are from an iteratee call.
       *
       * @private
       * @param {*} value The potential iteratee value argument.
       * @param {*} index The potential iteratee index or key argument.
       * @param {*} object The potential iteratee object argument.
       * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
       *  else `false`.
       */
      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index;
        if (
          type == "number"
            ? isArrayLike(object) && isIndex(index, object.length)
            : type == "string" && index in object
        ) {
          return eq(object[index], value);
        }
        return false;
      }

      /**
       * Checks if `value` is a property name and not a property path.
       *
       * @private
       * @param {*} value The value to check.
       * @param {Object} [object] The object to query keys on.
       * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
       */
      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }
        var type = typeof value;
        if (
          type == "number" ||
          type == "symbol" ||
          type == "boolean" ||
          value == null ||
          isSymbol(value)
        ) {
          return true;
        }
        return (
          reIsPlainProp.test(value) ||
          !reIsDeepProp.test(value) ||
          (object != null && value in Object(object))
        );
      }

      /**
       * Checks if `value` is suitable for use as unique object key.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
       */
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" ||
          type == "number" ||
          type == "symbol" ||
          type == "boolean"
          ? value !== "__proto__"
          : value === null;
      }

      /**
       * Checks if `func` has a lazy counterpart.
       *
       * @private
       * @param {Function} func The function to check.
       * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
       *  else `false`.
       */
      function isLaziable(func) {
        var funcName = getFuncName(func),
          other = lodash[funcName];

        if (
          typeof other != "function" ||
          !(funcName in LazyWrapper.prototype)
        ) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }

      /**
       * Checks if `func` has its source masked.
       *
       * @private
       * @param {Function} func The function to check.
       * @returns {boolean} Returns `true` if `func` is masked, else `false`.
       */
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }

      /**
       * Checks if `func` is capable of being masked.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
       */
      var isMaskable = coreJsData ? isFunction : stubFalse;

      /**
       * Checks if `value` is likely a prototype object.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
       */
      function isPrototype(value) {
        var Ctor = value && value.constructor,
          proto = (typeof Ctor == "function" && Ctor.prototype) || objectProto;

        return value === proto;
      }

      /**
       * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` if suitable for strict
       *  equality comparisons, else `false`.
       */
      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }

      /**
       * A specialized version of `matchesProperty` for source values suitable
       * for strict equality comparisons, i.e. `===`.
       *
       * @private
       * @param {string} key The key of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       */
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return (
            object[key] === srcValue &&
            (srcValue !== undefined$1 || key in Object(object))
          );
        };
      }

      /**
       * A specialized version of `_.memoize` which clears the memoized function's
       * cache when it exceeds `MAX_MEMOIZE_SIZE`.
       *
       * @private
       * @param {Function} func The function to have its output memoized.
       * @returns {Function} Returns the new memoized function.
       */
      function memoizeCapped(func) {
        var result = memoize(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });

        var cache = result.cache;
        return result;
      }

      /**
       * Merges the function metadata of `source` into `data`.
       *
       * Merging metadata reduces the number of wrappers used to invoke a function.
       * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
       * may be applied regardless of execution order. Methods like `_.ary` and
       * `_.rearg` modify function arguments, making the order in which they are
       * executed important, preventing the merging of metadata. However, we make
       * an exception for a safe combined case where curried functions have `_.ary`
       * and or `_.rearg` applied.
       *
       * @private
       * @param {Array} data The destination metadata.
       * @param {Array} source The source metadata.
       * @returns {Array} Returns `data`.
       */
      function mergeData(data, source) {
        var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon =
            newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

        var isCombo =
          (srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG) ||
          (srcBitmask == WRAP_ARY_FLAG &&
            bitmask == WRAP_REARG_FLAG &&
            data[7].length <= source[8]) ||
          (srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) &&
            source[7].length <= source[8] &&
            bitmask == WRAP_CURRY_FLAG);

        // Exit early if metadata can't be merged.
        if (!(isCommon || isCombo)) {
          return data;
        }
        // Use source `thisArg` if available.
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          // Set when currying a bound function.
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        // Compose partial arguments.
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        // Compose partial right arguments.
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials
            ? composeArgsRight(partials, value, source[6])
            : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        // Use source `argPos` if available.
        value = source[7];
        if (value) {
          data[7] = value;
        }
        // Use source `ary` if it's smaller.
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        // Use source `arity` if one is not provided.
        if (data[9] == null) {
          data[9] = source[9];
        }
        // Use source `func` and merge bitmasks.
        data[0] = source[0];
        data[1] = newBitmask;

        return data;
      }

      /**
       * This function is like
       * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * except that it includes inherited enumerable properties.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * Converts `value` to a string using `Object.prototype.toString`.
       *
       * @private
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       */
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }

      /**
       * A specialized version of `baseRest` which transforms the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @param {Function} transform The rest array transform.
       * @returns {Function} Returns the new function.
       */
      function overRest(func, start, transform) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

          while (++index < length) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }

      /**
       * Gets the parent value at `path` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} path The path to get the parent value of.
       * @returns {*} Returns the parent value.
       */
      function parent(object, path) {
        return path.length < 2
          ? object
          : baseGet(object, baseSlice(path, 0, -1));
      }

      /**
       * Reorder `array` according to the specified indexes where the element at
       * the first index is assigned as the first element, the element at
       * the second index is assigned as the second element, and so on.
       *
       * @private
       * @param {Array} array The array to reorder.
       * @param {Array} indexes The arranged array indexes.
       * @returns {Array} Returns `array`.
       */
      function reorder(array, indexes) {
        var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

        while (length--) {
          var index = indexes[length];
          array[length] = isIndex(index, arrLength)
            ? oldArray[index]
            : undefined$1;
        }
        return array;
      }

      /**
       * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the property to get.
       * @returns {*} Returns the property value.
       */
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }

        if (key == "__proto__") {
          return;
        }

        return object[key];
      }

      /**
       * Sets metadata for `func`.
       *
       * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
       * period of time, it will trip its breaker and transition to an identity
       * function to avoid garbage collection pauses in V8. See
       * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
       * for more details.
       *
       * @private
       * @param {Function} func The function to associate metadata with.
       * @param {*} data The metadata.
       * @returns {Function} Returns `func`.
       */
      var setData = shortOut(baseSetData);

      /**
       * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
       *
       * @private
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @returns {number|Object} Returns the timer id or timeout object.
       */
      var setTimeout =
        ctxSetTimeout ||
        function(func, wait) {
          return root.setTimeout(func, wait);
        };

      /**
       * Sets the `toString` method of `func` to return `string`.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var setToString = shortOut(baseSetToString);

      /**
       * Sets the `toString` method of `wrapper` to mimic the source of `reference`
       * with wrapper details in a comment at the top of the source body.
       *
       * @private
       * @param {Function} wrapper The function to modify.
       * @param {Function} reference The reference function.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @returns {Function} Returns `wrapper`.
       */
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + "";
        return setToString(
          wrapper,
          insertWrapDetails(
            source,
            updateWrapDetails(getWrapDetails(source), bitmask)
          )
        );
      }

      /**
       * Creates a function that'll short out and invoke `identity` instead
       * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
       * milliseconds.
       *
       * @private
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new shortable function.
       */
      function shortOut(func) {
        var count = 0,
          lastCalled = 0;

        return function() {
          var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }

      /**
       * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
       *
       * @private
       * @param {Array} array The array to shuffle.
       * @param {number} [size=array.length] The size of `array`.
       * @returns {Array} Returns `array`.
       */
      function shuffleSelf(array, size) {
        var index = -1,
          length = array.length,
          lastIndex = length - 1;

        size = size === undefined$1 ? length : size;
        while (++index < size) {
          var rand = baseRandom(index, lastIndex),
            value = array[rand];

          array[rand] = array[index];
          array[index] = value;
        }
        array.length = size;
        return array;
      }

      /**
       * Converts `string` to a property path array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the property path array.
       */
      var stringToPath = memoizeCapped(function(string) {
        var result = [];
        if (string.charCodeAt(0) === 46 /* . */) {
          result.push("");
        }
        string.replace(rePropName, function(match, number, quote, subString) {
          result.push(
            quote ? subString.replace(reEscapeChar, "$1") : number || match
          );
        });
        return result;
      });

      /**
       * Converts `value` to a string key if it's not a string or symbol.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {string|symbol} Returns the key.
       */
      function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) {
          return value;
        }
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
      }

      /**
       * Converts `func` to its source code.
       *
       * @private
       * @param {Function} func The function to convert.
       * @returns {string} Returns the source code.
       */
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {}
          try {
            return func + "";
          } catch (e) {}
        }
        return "";
      }

      /**
       * Updates wrapper `details` based on `bitmask` flags.
       *
       * @private
       * @returns {Array} details The details to modify.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @returns {Array} Returns `details`.
       */
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = "_." + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }

      /**
       * Creates a clone of `wrapper`.
       *
       * @private
       * @param {Object} wrapper The wrapper to clone.
       * @returns {Object} Returns the cloned wrapper.
       */
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result.__actions__ = copyArray(wrapper.__actions__);
        result.__index__ = wrapper.__index__;
        result.__values__ = wrapper.__values__;
        return result;
      }

      /*------------------------------------------------------------------------*/

      /**
       * Creates an array of elements split into groups the length of `size`.
       * If `array` can't be split evenly, the final chunk will be the remaining
       * elements.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to process.
       * @param {number} [size=1] The length of each chunk
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the new array of chunks.
       * @example
       *
       * _.chunk(['a', 'b', 'c', 'd'], 2);
       * // => [['a', 'b'], ['c', 'd']]
       *
       * _.chunk(['a', 'b', 'c', 'd'], 3);
       * // => [['a', 'b', 'c'], ['d']]
       */
      function chunk(array, size, guard) {
        if (guard ? isIterateeCall(array, size, guard) : size === undefined$1) {
          size = 1;
        } else {
          size = nativeMax(toInteger(size), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size < 1) {
          return [];
        }
        var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

        while (index < length) {
          result[resIndex++] = baseSlice(array, index, (index += size));
        }
        return result;
      }

      /**
       * Creates an array with all falsey values removed. The values `false`, `null`,
       * `0`, `""`, `undefined`, and `NaN` are falsey.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to compact.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.compact([0, 1, false, 2, '', 3]);
       * // => [1, 2, 3]
       */
      function compact(array) {
        var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }

      /**
       * Creates a new array concatenating `array` with any additional arrays
       * and/or values.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to concatenate.
       * @param {...*} [values] The values to concatenate.
       * @returns {Array} Returns the new concatenated array.
       * @example
       *
       * var array = [1];
       * var other = _.concat(array, 2, [3], [[4]]);
       *
       * console.log(other);
       * // => [1, 2, 3, [4]]
       *
       * console.log(array);
       * // => [1]
       */
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array(length - 1),
          array = arguments[0],
          index = length;

        while (index--) {
          args[index - 1] = arguments[index];
        }
        return arrayPush(
          isArray(array) ? copyArray(array) : [array],
          baseFlatten(args, 1)
        );
      }

      /**
       * Creates an array of `array` values not included in the other given arrays
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. The order and references of result values are
       * determined by the first array.
       *
       * **Note:** Unlike `_.pullAll`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.without, _.xor
       * @example
       *
       * _.difference([2, 1], [2, 3]);
       * // => [1]
       */
      var difference = baseRest(function(array, values) {
        return isArrayLikeObject(array)
          ? baseDifference(
              array,
              baseFlatten(values, 1, isArrayLikeObject, true)
            )
          : [];
      });

      /**
       * This method is like `_.difference` except that it accepts `iteratee` which
       * is invoked for each element of `array` and `values` to generate the criterion
       * by which they're compared. The order and references of result values are
       * determined by the first array. The iteratee is invoked with one argument:
       * (value).
       *
       * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
       * // => [{ 'x': 2 }]
       */
      var differenceBy = baseRest(function(array, values) {
        var iteratee = last(values);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return isArrayLikeObject(array)
          ? baseDifference(
              array,
              baseFlatten(values, 1, isArrayLikeObject, true),
              getIteratee(iteratee, 2)
            )
          : [];
      });

      /**
       * This method is like `_.difference` except that it accepts `comparator`
       * which is invoked to compare elements of `array` to `values`. The order and
       * references of result values are determined by the first array. The comparator
       * is invoked with two arguments: (arrVal, othVal).
       *
       * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       *
       * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
       * // => [{ 'x': 2, 'y': 1 }]
       */
      var differenceWith = baseRest(function(array, values) {
        var comparator = last(values);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array)
          ? baseDifference(
              array,
              baseFlatten(values, 1, isArrayLikeObject, true),
              undefined$1,
              comparator
            )
          : [];
      });

      /**
       * Creates a slice of `array` with `n` elements dropped from the beginning.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to drop.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.drop([1, 2, 3]);
       * // => [2, 3]
       *
       * _.drop([1, 2, 3], 2);
       * // => [3]
       *
       * _.drop([1, 2, 3], 5);
       * // => []
       *
       * _.drop([1, 2, 3], 0);
       * // => [1, 2, 3]
       */
      function drop(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }

      /**
       * Creates a slice of `array` with `n` elements dropped from the end.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to drop.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.dropRight([1, 2, 3]);
       * // => [1, 2]
       *
       * _.dropRight([1, 2, 3], 2);
       * // => [1]
       *
       * _.dropRight([1, 2, 3], 5);
       * // => []
       *
       * _.dropRight([1, 2, 3], 0);
       * // => [1, 2, 3]
       */
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }

      /**
       * Creates a slice of `array` excluding elements dropped from the end.
       * Elements are dropped until `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': true },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': false }
       * ];
       *
       * _.dropRightWhile(users, function(o) { return !o.active; });
       * // => objects for ['barney']
       *
       * // The `_.matches` iteratee shorthand.
       * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
       * // => objects for ['barney', 'fred']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.dropRightWhile(users, ['active', false]);
       * // => objects for ['barney']
       *
       * // The `_.property` iteratee shorthand.
       * _.dropRightWhile(users, 'active');
       * // => objects for ['barney', 'fred', 'pebbles']
       */
      function dropRightWhile(array, predicate) {
        return array && array.length
          ? baseWhile(array, getIteratee(predicate, 3), true, true)
          : [];
      }

      /**
       * Creates a slice of `array` excluding elements dropped from the beginning.
       * Elements are dropped until `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': false },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': true }
       * ];
       *
       * _.dropWhile(users, function(o) { return !o.active; });
       * // => objects for ['pebbles']
       *
       * // The `_.matches` iteratee shorthand.
       * _.dropWhile(users, { 'user': 'barney', 'active': false });
       * // => objects for ['fred', 'pebbles']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.dropWhile(users, ['active', false]);
       * // => objects for ['pebbles']
       *
       * // The `_.property` iteratee shorthand.
       * _.dropWhile(users, 'active');
       * // => objects for ['barney', 'fred', 'pebbles']
       */
      function dropWhile(array, predicate) {
        return array && array.length
          ? baseWhile(array, getIteratee(predicate, 3), true)
          : [];
      }

      /**
       * Fills elements of `array` with `value` from `start` up to, but not
       * including, `end`.
       *
       * **Note:** This method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 3.2.0
       * @category Array
       * @param {Array} array The array to fill.
       * @param {*} value The value to fill `array` with.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [1, 2, 3];
       *
       * _.fill(array, 'a');
       * console.log(array);
       * // => ['a', 'a', 'a']
       *
       * _.fill(Array(3), 2);
       * // => [2, 2, 2]
       *
       * _.fill([4, 6, 8, 10], '*', 1, 3);
       * // => [4, '*', '*', 10]
       */
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (
          start &&
          typeof start != "number" &&
          isIterateeCall(array, value, start)
        ) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }

      /**
       * This method is like `_.find` except that it returns the index of the first
       * element `predicate` returns truthy for instead of the element itself.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=0] The index to search from.
       * @returns {number} Returns the index of the found element, else `-1`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': false },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': true }
       * ];
       *
       * _.findIndex(users, function(o) { return o.user == 'barney'; });
       * // => 0
       *
       * // The `_.matches` iteratee shorthand.
       * _.findIndex(users, { 'user': 'fred', 'active': false });
       * // => 1
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findIndex(users, ['active', false]);
       * // => 0
       *
       * // The `_.property` iteratee shorthand.
       * _.findIndex(users, 'active');
       * // => 2
       */
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index);
      }

      /**
       * This method is like `_.findIndex` except that it iterates over elements
       * of `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=array.length-1] The index to search from.
       * @returns {number} Returns the index of the found element, else `-1`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': true },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': false }
       * ];
       *
       * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
       * // => 2
       *
       * // The `_.matches` iteratee shorthand.
       * _.findLastIndex(users, { 'user': 'barney', 'active': true });
       * // => 0
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findLastIndex(users, ['active', false]);
       * // => 2
       *
       * // The `_.property` iteratee shorthand.
       * _.findLastIndex(users, 'active');
       * // => 0
       */
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length - 1;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index =
            fromIndex < 0
              ? nativeMax(length + index, 0)
              : nativeMin(index, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index, true);
      }

      /**
       * Flattens `array` a single level deep.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * _.flatten([1, [2, [3, [4]], 5]]);
       * // => [1, 2, [3, [4]], 5]
       */
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }

      /**
       * Recursively flattens `array`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * _.flattenDeep([1, [2, [3, [4]], 5]]);
       * // => [1, 2, 3, 4, 5]
       */
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }

      /**
       * Recursively flatten `array` up to `depth` times.
       *
       * @static
       * @memberOf _
       * @since 4.4.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @param {number} [depth=1] The maximum recursion depth.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * var array = [1, [2, [3, [4]], 5]];
       *
       * _.flattenDepth(array, 1);
       * // => [1, 2, [3, [4]], 5]
       *
       * _.flattenDepth(array, 2);
       * // => [1, 2, 3, [4], 5]
       */
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }

      /**
       * The inverse of `_.toPairs`; this method returns an object composed
       * from key-value `pairs`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} pairs The key-value pairs.
       * @returns {Object} Returns the new object.
       * @example
       *
       * _.fromPairs([['a', 1], ['b', 2]]);
       * // => { 'a': 1, 'b': 2 }
       */
      function fromPairs(pairs) {
        var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

        while (++index < length) {
          var pair = pairs[index];
          result[pair[0]] = pair[1];
        }
        return result;
      }

      /**
       * Gets the first element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @alias first
       * @category Array
       * @param {Array} array The array to query.
       * @returns {*} Returns the first element of `array`.
       * @example
       *
       * _.head([1, 2, 3]);
       * // => 1
       *
       * _.head([]);
       * // => undefined
       */
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }

      /**
       * Gets the index at which the first occurrence of `value` is found in `array`
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. If `fromIndex` is negative, it's used as the
       * offset from the end of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=0] The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.indexOf([1, 2, 1, 2], 2);
       * // => 1
       *
       * // Search from the `fromIndex`.
       * _.indexOf([1, 2, 1, 2], 2, 2);
       * // => 3
       */
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseIndexOf(array, value, index);
      }

      /**
       * Gets all but the last element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.initial([1, 2, 3]);
       * // => [1, 2]
       */
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }

      /**
       * Creates an array of unique values that are included in all given arrays
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. The order and references of result values are
       * determined by the first array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * _.intersection([2, 1], [2, 3]);
       * // => [2]
       */
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0]
          ? baseIntersection(mapped)
          : [];
      });

      /**
       * This method is like `_.intersection` except that it accepts `iteratee`
       * which is invoked for each element of each `arrays` to generate the criterion
       * by which they're compared. The order and references of result values are
       * determined by the first array. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [2.1]
       *
       * // The `_.property` iteratee shorthand.
       * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }]
       */
      var intersectionBy = baseRest(function(arrays) {
        var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

        if (iteratee === last(mapped)) {
          iteratee = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0]
          ? baseIntersection(mapped, getIteratee(iteratee, 2))
          : [];
      });

      /**
       * This method is like `_.intersection` except that it accepts `comparator`
       * which is invoked to compare elements of `arrays`. The order and references
       * of result values are determined by the first array. The comparator is
       * invoked with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.intersectionWith(objects, others, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }]
       */
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

        comparator = typeof comparator == "function" ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0]
          ? baseIntersection(mapped, undefined$1, comparator)
          : [];
      });

      /**
       * Converts all elements in `array` into a string separated by `separator`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to convert.
       * @param {string} [separator=','] The element separator.
       * @returns {string} Returns the joined string.
       * @example
       *
       * _.join(['a', 'b', 'c'], '~');
       * // => 'a~b~c'
       */
      function join(array, separator) {
        return array == null ? "" : nativeJoin.call(array, separator);
      }

      /**
       * Gets the last element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {*} Returns the last element of `array`.
       * @example
       *
       * _.last([1, 2, 3]);
       * // => 3
       */
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }

      /**
       * This method is like `_.indexOf` except that it iterates over elements of
       * `array` from right to left.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=array.length-1] The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.lastIndexOf([1, 2, 1, 2], 2);
       * // => 3
       *
       * // Search from the `fromIndex`.
       * _.lastIndexOf([1, 2, 1, 2], 2, 2);
       * // => 1
       */
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index =
            index < 0
              ? nativeMax(length + index, 0)
              : nativeMin(index, length - 1);
        }
        return value === value
          ? strictLastIndexOf(array, value, index)
          : baseFindIndex(array, baseIsNaN, index, true);
      }

      /**
       * Gets the element at index `n` of `array`. If `n` is negative, the nth
       * element from the end is returned.
       *
       * @static
       * @memberOf _
       * @since 4.11.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=0] The index of the element to return.
       * @returns {*} Returns the nth element of `array`.
       * @example
       *
       * var array = ['a', 'b', 'c', 'd'];
       *
       * _.nth(array, 1);
       * // => 'b'
       *
       * _.nth(array, -2);
       * // => 'c';
       */
      function nth(array, n) {
        return array && array.length
          ? baseNth(array, toInteger(n))
          : undefined$1;
      }

      /**
       * Removes all given values from `array` using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
       * to remove elements from an array by predicate.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {...*} [values] The values to remove.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
       *
       * _.pull(array, 'a', 'c');
       * console.log(array);
       * // => ['b', 'b']
       */
      var pull = baseRest(pullAll);

      /**
       * This method is like `_.pull` except that it accepts an array of values to remove.
       *
       * **Note:** Unlike `_.difference`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
       *
       * _.pullAll(array, ['a', 'c']);
       * console.log(array);
       * // => ['b', 'b']
       */
      function pullAll(array, values) {
        return array && array.length && values && values.length
          ? basePullAll(array, values)
          : array;
      }

      /**
       * This method is like `_.pullAll` except that it accepts `iteratee` which is
       * invoked for each element of `array` and `values` to generate the criterion
       * by which they're compared. The iteratee is invoked with one argument: (value).
       *
       * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
       *
       * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
       * console.log(array);
       * // => [{ 'x': 2 }]
       */
      function pullAllBy(array, values, iteratee) {
        return array && array.length && values && values.length
          ? basePullAll(array, values, getIteratee(iteratee, 2))
          : array;
      }

      /**
       * This method is like `_.pullAll` except that it accepts `comparator` which
       * is invoked to compare elements of `array` to `values`. The comparator is
       * invoked with two arguments: (arrVal, othVal).
       *
       * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 4.6.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
       *
       * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
       * console.log(array);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
       */
      function pullAllWith(array, values, comparator) {
        return array && array.length && values && values.length
          ? basePullAll(array, values, undefined$1, comparator)
          : array;
      }

      /**
       * Removes elements from `array` corresponding to `indexes` and returns an
       * array of removed elements.
       *
       * **Note:** Unlike `_.at`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {...(number|number[])} [indexes] The indexes of elements to remove.
       * @returns {Array} Returns the new array of removed elements.
       * @example
       *
       * var array = ['a', 'b', 'c', 'd'];
       * var pulled = _.pullAt(array, [1, 3]);
       *
       * console.log(array);
       * // => ['a', 'c']
       *
       * console.log(pulled);
       * // => ['b', 'd']
       */
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

        basePullAt(
          array,
          arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending)
        );

        return result;
      });

      /**
       * Removes all elements from `array` that `predicate` returns truthy for
       * and returns an array of the removed elements. The predicate is invoked
       * with three arguments: (value, index, array).
       *
       * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
       * to pull elements from an array by value.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new array of removed elements.
       * @example
       *
       * var array = [1, 2, 3, 4];
       * var evens = _.remove(array, function(n) {
       *   return n % 2 == 0;
       * });
       *
       * console.log(array);
       * // => [1, 3]
       *
       * console.log(evens);
       * // => [2, 4]
       */
      function remove(array, predicate) {
        var result = [];
        if (!(array && array.length)) {
          return result;
        }
        var index = -1,
          indexes = [],
          length = array.length;

        predicate = getIteratee(predicate, 3);
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
          }
        }
        basePullAt(array, indexes);
        return result;
      }

      /**
       * Reverses `array` so that the first element becomes the last, the second
       * element becomes the second to last, and so on.
       *
       * **Note:** This method mutates `array` and is based on
       * [`Array#reverse`](https://mdn.io/Array/reverse).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [1, 2, 3];
       *
       * _.reverse(array);
       * // => [3, 2, 1]
       *
       * console.log(array);
       * // => [3, 2, 1]
       */
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }

      /**
       * Creates a slice of `array` from `start` up to, but not including, `end`.
       *
       * **Note:** This method is used instead of
       * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
       * returned.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to slice.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the slice of `array`.
       */
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (
          end &&
          typeof end != "number" &&
          isIterateeCall(array, start, end)
        ) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }

      /**
       * Uses a binary search to determine the lowest index at which `value`
       * should be inserted into `array` in order to maintain its sort order.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * _.sortedIndex([30, 50], 40);
       * // => 1
       */
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }

      /**
       * This method is like `_.sortedIndex` except that it accepts `iteratee`
       * which is invoked for `value` and each element of `array` to compute their
       * sort ranking. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * var objects = [{ 'x': 4 }, { 'x': 5 }];
       *
       * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
       * // => 0
       *
       * // The `_.property` iteratee shorthand.
       * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
       * // => 0
       */
      function sortedIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
      }

      /**
       * This method is like `_.indexOf` except that it performs a binary
       * search on a sorted `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
       * // => 1
       */
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value);
          if (index < length && eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }

      /**
       * This method is like `_.sortedIndex` except that it returns the highest
       * index at which `value` should be inserted into `array` in order to
       * maintain its sort order.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
       * // => 4
       */
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }

      /**
       * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
       * which is invoked for `value` and each element of `array` to compute their
       * sort ranking. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * var objects = [{ 'x': 4 }, { 'x': 5 }];
       *
       * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
       * // => 1
       *
       * // The `_.property` iteratee shorthand.
       * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
       * // => 1
       */
      function sortedLastIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
      }

      /**
       * This method is like `_.lastIndexOf` except that it performs a binary
       * search on a sorted `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
       * // => 3
       */
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }

      /**
       * This method is like `_.uniq` except that it's designed and optimized
       * for sorted arrays.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.sortedUniq([1, 1, 2]);
       * // => [1, 2]
       */
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }

      /**
       * This method is like `_.uniqBy` except that it's designed and optimized
       * for sorted arrays.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
       * // => [1.1, 2.3]
       */
      function sortedUniqBy(array, iteratee) {
        return array && array.length
          ? baseSortedUniq(array, getIteratee(iteratee, 2))
          : [];
      }

      /**
       * Gets all but the first element of `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.tail([1, 2, 3]);
       * // => [2, 3]
       */
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }

      /**
       * Creates a slice of `array` with `n` elements taken from the beginning.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to take.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.take([1, 2, 3]);
       * // => [1]
       *
       * _.take([1, 2, 3], 2);
       * // => [1, 2]
       *
       * _.take([1, 2, 3], 5);
       * // => [1, 2, 3]
       *
       * _.take([1, 2, 3], 0);
       * // => []
       */
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }

      /**
       * Creates a slice of `array` with `n` elements taken from the end.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to take.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.takeRight([1, 2, 3]);
       * // => [3]
       *
       * _.takeRight([1, 2, 3], 2);
       * // => [2, 3]
       *
       * _.takeRight([1, 2, 3], 5);
       * // => [1, 2, 3]
       *
       * _.takeRight([1, 2, 3], 0);
       * // => []
       */
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }

      /**
       * Creates a slice of `array` with elements taken from the end. Elements are
       * taken until `predicate` returns falsey. The predicate is invoked with
       * three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': true },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': false }
       * ];
       *
       * _.takeRightWhile(users, function(o) { return !o.active; });
       * // => objects for ['fred', 'pebbles']
       *
       * // The `_.matches` iteratee shorthand.
       * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
       * // => objects for ['pebbles']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.takeRightWhile(users, ['active', false]);
       * // => objects for ['fred', 'pebbles']
       *
       * // The `_.property` iteratee shorthand.
       * _.takeRightWhile(users, 'active');
       * // => []
       */
      function takeRightWhile(array, predicate) {
        return array && array.length
          ? baseWhile(array, getIteratee(predicate, 3), false, true)
          : [];
      }

      /**
       * Creates a slice of `array` with elements taken from the beginning. Elements
       * are taken until `predicate` returns falsey. The predicate is invoked with
       * three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': false },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': true }
       * ];
       *
       * _.takeWhile(users, function(o) { return !o.active; });
       * // => objects for ['barney', 'fred']
       *
       * // The `_.matches` iteratee shorthand.
       * _.takeWhile(users, { 'user': 'barney', 'active': false });
       * // => objects for ['barney']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.takeWhile(users, ['active', false]);
       * // => objects for ['barney', 'fred']
       *
       * // The `_.property` iteratee shorthand.
       * _.takeWhile(users, 'active');
       * // => []
       */
      function takeWhile(array, predicate) {
        return array && array.length
          ? baseWhile(array, getIteratee(predicate, 3))
          : [];
      }

      /**
       * Creates an array of unique values, in order, from all given arrays using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * _.union([2], [1, 2]);
       * // => [2, 1]
       */
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });

      /**
       * This method is like `_.union` except that it accepts `iteratee` which is
       * invoked for each element of each `arrays` to generate the criterion by
       * which uniqueness is computed. Result values are chosen from the first
       * array in which the value occurs. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * _.unionBy([2.1], [1.2, 2.3], Math.floor);
       * // => [2.1, 1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }, { 'x': 2 }]
       */
      var unionBy = baseRest(function(arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseUniq(
          baseFlatten(arrays, 1, isArrayLikeObject, true),
          getIteratee(iteratee, 2)
        );
      });

      /**
       * This method is like `_.union` except that it accepts `comparator` which
       * is invoked to compare elements of `arrays`. Result values are chosen from
       * the first array in which the value occurs. The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.unionWith(objects, others, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
       */
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseUniq(
          baseFlatten(arrays, 1, isArrayLikeObject, true),
          undefined$1,
          comparator
        );
      });

      /**
       * Creates a duplicate-free version of an array, using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons, in which only the first occurrence of each element
       * is kept. The order of result values is determined by the order they occur
       * in the array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.uniq([2, 1, 2]);
       * // => [2, 1]
       */
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }

      /**
       * This method is like `_.uniq` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * uniqueness is computed. The order of result values is determined by the
       * order they occur in the array. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
       * // => [2.1, 1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }, { 'x': 2 }]
       */
      function uniqBy(array, iteratee) {
        return array && array.length
          ? baseUniq(array, getIteratee(iteratee, 2))
          : [];
      }

      /**
       * This method is like `_.uniq` except that it accepts `comparator` which
       * is invoked to compare elements of `array`. The order of result values is
       * determined by the order they occur in the array.The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.uniqWith(objects, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
       */
      function uniqWith(array, comparator) {
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return array && array.length
          ? baseUniq(array, undefined$1, comparator)
          : [];
      }

      /**
       * This method is like `_.zip` except that it accepts an array of grouped
       * elements and creates an array regrouping the elements to their pre-zip
       * configuration.
       *
       * @static
       * @memberOf _
       * @since 1.2.0
       * @category Array
       * @param {Array} array The array of grouped elements to process.
       * @returns {Array} Returns the new array of regrouped elements.
       * @example
       *
       * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
       * // => [['a', 1, true], ['b', 2, false]]
       *
       * _.unzip(zipped);
       * // => [['a', 'b'], [1, 2], [true, false]]
       */
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index) {
          return arrayMap(array, baseProperty(index));
        });
      }

      /**
       * This method is like `_.unzip` except that it accepts `iteratee` to specify
       * how regrouped values should be combined. The iteratee is invoked with the
       * elements of each group: (...group).
       *
       * @static
       * @memberOf _
       * @since 3.8.0
       * @category Array
       * @param {Array} array The array of grouped elements to process.
       * @param {Function} [iteratee=_.identity] The function to combine
       *  regrouped values.
       * @returns {Array} Returns the new array of regrouped elements.
       * @example
       *
       * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
       * // => [[1, 10, 100], [2, 20, 200]]
       *
       * _.unzipWith(zipped, _.add);
       * // => [3, 30, 300]
       */
      function unzipWith(array, iteratee) {
        if (!(array && array.length)) {
          return [];
        }
        var result = unzip(array);
        if (iteratee == null) {
          return result;
        }
        return arrayMap(result, function(group) {
          return apply(iteratee, undefined$1, group);
        });
      }

      /**
       * Creates an array excluding all given values using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * **Note:** Unlike `_.pull`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...*} [values] The values to exclude.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.difference, _.xor
       * @example
       *
       * _.without([2, 1, 2, 3], 1, 2);
       * // => [3]
       */
      var without = baseRest(function(array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, values) : [];
      });

      /**
       * Creates an array of unique values that is the
       * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
       * of the given arrays. The order of result values is determined by the order
       * they occur in the arrays.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.difference, _.without
       * @example
       *
       * _.xor([2, 1], [2, 3]);
       * // => [1, 3]
       */
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });

      /**
       * This method is like `_.xor` except that it accepts `iteratee` which is
       * invoked for each element of each `arrays` to generate the criterion by
       * which by which they're compared. The order of result values is determined
       * by the order they occur in the arrays. The iteratee is invoked with one
       * argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [1.2, 3.4]
       *
       * // The `_.property` iteratee shorthand.
       * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 2 }]
       */
      var xorBy = baseRest(function(arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseXor(
          arrayFilter(arrays, isArrayLikeObject),
          getIteratee(iteratee, 2)
        );
      });

      /**
       * This method is like `_.xor` except that it accepts `comparator` which is
       * invoked to compare elements of `arrays`. The order of result values is
       * determined by the order they occur in the arrays. The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.xorWith(objects, others, _.isEqual);
       * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
       */
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == "function" ? comparator : undefined$1;
        return baseXor(
          arrayFilter(arrays, isArrayLikeObject),
          undefined$1,
          comparator
        );
      });

      /**
       * Creates an array of grouped elements, the first of which contains the
       * first elements of the given arrays, the second of which contains the
       * second elements of the given arrays, and so on.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to process.
       * @returns {Array} Returns the new array of grouped elements.
       * @example
       *
       * _.zip(['a', 'b'], [1, 2], [true, false]);
       * // => [['a', 1, true], ['b', 2, false]]
       */
      var zip = baseRest(unzip);

      /**
       * This method is like `_.fromPairs` except that it accepts two arrays,
       * one of property identifiers and one of corresponding values.
       *
       * @static
       * @memberOf _
       * @since 0.4.0
       * @category Array
       * @param {Array} [props=[]] The property identifiers.
       * @param {Array} [values=[]] The property values.
       * @returns {Object} Returns the new object.
       * @example
       *
       * _.zipObject(['a', 'b'], [1, 2]);
       * // => { 'a': 1, 'b': 2 }
       */
      function zipObject(props, values) {
        return baseZipObject(props || [], values || [], assignValue);
      }

      /**
       * This method is like `_.zipObject` except that it supports property paths.
       *
       * @static
       * @memberOf _
       * @since 4.1.0
       * @category Array
       * @param {Array} [props=[]] The property identifiers.
       * @param {Array} [values=[]] The property values.
       * @returns {Object} Returns the new object.
       * @example
       *
       * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
       * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
       */
      function zipObjectDeep(props, values) {
        return baseZipObject(props || [], values || [], baseSet);
      }

      /**
       * This method is like `_.zip` except that it accepts `iteratee` to specify
       * how grouped values should be combined. The iteratee is invoked with the
       * elements of each group: (...group).
       *
       * @static
       * @memberOf _
       * @since 3.8.0
       * @category Array
       * @param {...Array} [arrays] The arrays to process.
       * @param {Function} [iteratee=_.identity] The function to combine
       *  grouped values.
       * @returns {Array} Returns the new array of grouped elements.
       * @example
       *
       * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
       *   return a + b + c;
       * });
       * // => [111, 222]
       */
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;

        iteratee =
          typeof iteratee == "function"
            ? (arrays.pop(), iteratee)
            : undefined$1;
        return unzipWith(arrays, iteratee);
      });

      /*------------------------------------------------------------------------*/

      /**
       * Creates a `lodash` wrapper instance that wraps `value` with explicit method
       * chain sequences enabled. The result of such sequences must be unwrapped
       * with `_#value`.
       *
       * @static
       * @memberOf _
       * @since 1.3.0
       * @category Seq
       * @param {*} value The value to wrap.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36 },
       *   { 'user': 'fred',    'age': 40 },
       *   { 'user': 'pebbles', 'age': 1 }
       * ];
       *
       * var youngest = _
       *   .chain(users)
       *   .sortBy('age')
       *   .map(function(o) {
       *     return o.user + ' is ' + o.age;
       *   })
       *   .head()
       *   .value();
       * // => 'pebbles is 1'
       */
      function chain(value) {
        var result = lodash(value);
        result.__chain__ = true;
        return result;
      }

      /**
       * This method invokes `interceptor` and returns `value`. The interceptor
       * is invoked with one argument; (value). The purpose of this method is to
       * "tap into" a method chain sequence in order to modify intermediate results.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @param {*} value The value to provide to `interceptor`.
       * @param {Function} interceptor The function to invoke.
       * @returns {*} Returns `value`.
       * @example
       *
       * _([1, 2, 3])
       *  .tap(function(array) {
       *    // Mutate input array.
       *    array.pop();
       *  })
       *  .reverse()
       *  .value();
       * // => [2, 1]
       */
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }

      /**
       * This method is like `_.tap` except that it returns the result of `interceptor`.
       * The purpose of this method is to "pass thru" values replacing intermediate
       * results in a method chain sequence.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Seq
       * @param {*} value The value to provide to `interceptor`.
       * @param {Function} interceptor The function to invoke.
       * @returns {*} Returns the result of `interceptor`.
       * @example
       *
       * _('  abc  ')
       *  .chain()
       *  .trim()
       *  .thru(function(value) {
       *    return [value];
       *  })
       *  .value();
       * // => ['abc']
       */
      function thru(value, interceptor) {
        return interceptor(value);
      }

      /**
       * This method is the wrapper version of `_.at`.
       *
       * @name at
       * @memberOf _
       * @since 1.0.0
       * @category Seq
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
       *
       * _(object).at(['a[0].b.c', 'a[1]']).value();
       * // => [3, 4]
       */
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) {
            return baseAt(object, paths);
          };

        if (
          length > 1 ||
          this.__actions__.length ||
          !(value instanceof LazyWrapper) ||
          !isIndex(start)
        ) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          func: thru,
          args: [interceptor],
          thisArg: undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });

      /**
       * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
       *
       * @name chain
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36 },
       *   { 'user': 'fred',   'age': 40 }
       * ];
       *
       * // A sequence without explicit chaining.
       * _(users).head();
       * // => { 'user': 'barney', 'age': 36 }
       *
       * // A sequence with explicit chaining.
       * _(users)
       *   .chain()
       *   .head()
       *   .pick('user')
       *   .value();
       * // => { 'user': 'barney' }
       */
      function wrapperChain() {
        return chain(this);
      }

      /**
       * Executes the chain sequence and returns the wrapped result.
       *
       * @name commit
       * @memberOf _
       * @since 3.2.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var array = [1, 2];
       * var wrapped = _(array).push(3);
       *
       * console.log(array);
       * // => [1, 2]
       *
       * wrapped = wrapped.commit();
       * console.log(array);
       * // => [1, 2, 3]
       *
       * wrapped.last();
       * // => 3
       *
       * console.log(array);
       * // => [1, 2, 3]
       */
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }

      /**
       * Gets the next value on a wrapped object following the
       * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
       *
       * @name next
       * @memberOf _
       * @since 4.0.0
       * @category Seq
       * @returns {Object} Returns the next iterator value.
       * @example
       *
       * var wrapped = _([1, 2]);
       *
       * wrapped.next();
       * // => { 'done': false, 'value': 1 }
       *
       * wrapped.next();
       * // => { 'done': false, 'value': 2 }
       *
       * wrapped.next();
       * // => { 'done': true, 'value': undefined }
       */
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }
        var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];

        return { done: done, value: value };
      }

      /**
       * Enables the wrapper to be iterable.
       *
       * @name Symbol.iterator
       * @memberOf _
       * @since 4.0.0
       * @category Seq
       * @returns {Object} Returns the wrapper object.
       * @example
       *
       * var wrapped = _([1, 2]);
       *
       * wrapped[Symbol.iterator]() === wrapped;
       * // => true
       *
       * Array.from(wrapped);
       * // => [1, 2]
       */
      function wrapperToIterator() {
        return this;
      }

      /**
       * Creates a clone of the chain sequence planting `value` as the wrapped value.
       *
       * @name plant
       * @memberOf _
       * @since 3.2.0
       * @category Seq
       * @param {*} value The value to plant.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var wrapped = _([1, 2]).map(square);
       * var other = wrapped.plant([3, 4]);
       *
       * other.value();
       * // => [9, 16]
       *
       * wrapped.value();
       * // => [1, 4]
       */
      function wrapperPlant(value) {
        var result,
          parent = this;

        while (parent instanceof baseLodash) {
          var clone = wrapperClone(parent);
          clone.__index__ = 0;
          clone.__values__ = undefined$1;
          if (result) {
            previous.__wrapped__ = clone;
          } else {
            result = clone;
          }
          var previous = clone;
          parent = parent.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result;
      }

      /**
       * This method is the wrapper version of `_.reverse`.
       *
       * **Note:** This method mutates the wrapped array.
       *
       * @name reverse
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var array = [1, 2, 3];
       *
       * _(array).reverse().value()
       * // => [3, 2, 1]
       *
       * console.log(array);
       * // => [3, 2, 1]
       */
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            func: thru,
            args: [reverse],
            thisArg: undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }

      /**
       * Executes the chain sequence to resolve the unwrapped value.
       *
       * @name value
       * @memberOf _
       * @since 0.1.0
       * @alias toJSON, valueOf
       * @category Seq
       * @returns {*} Returns the resolved unwrapped value.
       * @example
       *
       * _([1, 2, 3]).value();
       * // => [1, 2, 3]
       */
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The corresponding value of
       * each key is the number of times the key was returned by `iteratee`. The
       * iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * _.countBy([6.1, 4.2, 6.3], Math.floor);
       * // => { '4': 1, '6': 2 }
       *
       * // The `_.property` iteratee shorthand.
       * _.countBy(['one', 'two', 'three'], 'length');
       * // => { '3': 2, '5': 1 }
       */
      var countBy = createAggregator(function(result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          ++result[key];
        } else {
          baseAssignValue(result, key, 1);
        }
      });

      /**
       * Checks if `predicate` returns truthy for **all** elements of `collection`.
       * Iteration is stopped once `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index|key, collection).
       *
       * **Note:** This method returns `true` for
       * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
       * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
       * elements of empty collections.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {boolean} Returns `true` if all elements pass the predicate check,
       *  else `false`.
       * @example
       *
       * _.every([true, 1, null, 'yes'], Boolean);
       * // => false
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': false },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.every(users, { 'user': 'barney', 'active': false });
       * // => false
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.every(users, ['active', false]);
       * // => true
       *
       * // The `_.property` iteratee shorthand.
       * _.every(users, 'active');
       * // => false
       */
      function every(collection, predicate, guard) {
        var func = isArray(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }

      /**
       * Iterates over elements of `collection`, returning an array of all elements
       * `predicate` returns truthy for. The predicate is invoked with three
       * arguments: (value, index|key, collection).
       *
       * **Note:** Unlike `_.remove`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       * @see _.reject
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': true },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * _.filter(users, function(o) { return !o.active; });
       * // => objects for ['fred']
       *
       * // The `_.matches` iteratee shorthand.
       * _.filter(users, { 'age': 36, 'active': true });
       * // => objects for ['barney']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.filter(users, ['active', false]);
       * // => objects for ['fred']
       *
       * // The `_.property` iteratee shorthand.
       * _.filter(users, 'active');
       * // => objects for ['barney']
       *
       * // Combining several predicates using `_.overEvery` or `_.overSome`.
       * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
       * // => objects for ['fred', 'barney']
       */
      function filter(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }

      /**
       * Iterates over elements of `collection`, returning the first element
       * `predicate` returns truthy for. The predicate is invoked with three
       * arguments: (value, index|key, collection).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=0] The index to search from.
       * @returns {*} Returns the matched element, else `undefined`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36, 'active': true },
       *   { 'user': 'fred',    'age': 40, 'active': false },
       *   { 'user': 'pebbles', 'age': 1,  'active': true }
       * ];
       *
       * _.find(users, function(o) { return o.age < 40; });
       * // => object for 'barney'
       *
       * // The `_.matches` iteratee shorthand.
       * _.find(users, { 'age': 1, 'active': true });
       * // => object for 'pebbles'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.find(users, ['active', false]);
       * // => object for 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.find(users, 'active');
       * // => object for 'barney'
       */
      var find = createFind(findIndex);

      /**
       * This method is like `_.find` except that it iterates over elements of
       * `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=collection.length-1] The index to search from.
       * @returns {*} Returns the matched element, else `undefined`.
       * @example
       *
       * _.findLast([1, 2, 3, 4], function(n) {
       *   return n % 2 == 1;
       * });
       * // => 3
       */
      var findLast = createFind(findLastIndex);

      /**
       * Creates a flattened array of values by running each element in `collection`
       * thru `iteratee` and flattening the mapped results. The iteratee is invoked
       * with three arguments: (value, index|key, collection).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * function duplicate(n) {
       *   return [n, n];
       * }
       *
       * _.flatMap([1, 2], duplicate);
       * // => [1, 1, 2, 2]
       */
      function flatMap(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), 1);
      }

      /**
       * This method is like `_.flatMap` except that it recursively flattens the
       * mapped results.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * function duplicate(n) {
       *   return [[[n, n]]];
       * }
       *
       * _.flatMapDeep([1, 2], duplicate);
       * // => [1, 1, 2, 2]
       */
      function flatMapDeep(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), INFINITY);
      }

      /**
       * This method is like `_.flatMap` except that it recursively flattens the
       * mapped results up to `depth` times.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {number} [depth=1] The maximum recursion depth.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * function duplicate(n) {
       *   return [[[n, n]]];
       * }
       *
       * _.flatMapDepth([1, 2], duplicate, 2);
       * // => [[1, 1], [2, 2]]
       */
      function flatMapDepth(collection, iteratee, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee), depth);
      }

      /**
       * Iterates over elements of `collection` and invokes `iteratee` for each element.
       * The iteratee is invoked with three arguments: (value, index|key, collection).
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * **Note:** As with other "Collections" methods, objects with a "length"
       * property are iterated like arrays. To avoid this behavior use `_.forIn`
       * or `_.forOwn` for object iteration.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @alias each
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       * @see _.forEachRight
       * @example
       *
       * _.forEach([1, 2], function(value) {
       *   console.log(value);
       * });
       * // => Logs `1` then `2`.
       *
       * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'a' then 'b' (iteration order is not guaranteed).
       */
      function forEach(collection, iteratee) {
        var func = isArray(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee, 3));
      }

      /**
       * This method is like `_.forEach` except that it iterates over elements of
       * `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @alias eachRight
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       * @see _.forEach
       * @example
       *
       * _.forEachRight([1, 2], function(value) {
       *   console.log(value);
       * });
       * // => Logs `2` then `1`.
       */
      function forEachRight(collection, iteratee) {
        var func = isArray(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee, 3));
      }

      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The order of grouped values
       * is determined by the order they occur in `collection`. The corresponding
       * value of each key is an array of elements responsible for generating the
       * key. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * _.groupBy([6.1, 4.2, 6.3], Math.floor);
       * // => { '4': [4.2], '6': [6.1, 6.3] }
       *
       * // The `_.property` iteratee shorthand.
       * _.groupBy(['one', 'two', 'three'], 'length');
       * // => { '3': ['one', 'two'], '5': ['three'] }
       */
      var groupBy = createAggregator(function(result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          result[key].push(value);
        } else {
          baseAssignValue(result, key, [value]);
        }
      });

      /**
       * Checks if `value` is in `collection`. If `collection` is a string, it's
       * checked for a substring of `value`, otherwise
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * is used for equality comparisons. If `fromIndex` is negative, it's used as
       * the offset from the end of `collection`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object|string} collection The collection to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=0] The index to search from.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
       * @returns {boolean} Returns `true` if `value` is found, else `false`.
       * @example
       *
       * _.includes([1, 2, 3], 1);
       * // => true
       *
       * _.includes([1, 2, 3], 1, 2);
       * // => false
       *
       * _.includes({ 'a': 1, 'b': 2 }, 1);
       * // => true
       *
       * _.includes('abcd', 'bc');
       * // => true
       */
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;

        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection)
          ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1
          : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }

      /**
       * Invokes the method at `path` of each element in `collection`, returning
       * an array of the results of each invoked method. Any additional arguments
       * are provided to each invoked method. If `path` is a function, it's invoked
       * for, and `this` bound to, each element in `collection`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Array|Function|string} path The path of the method to invoke or
       *  the function invoked per iteration.
       * @param {...*} [args] The arguments to invoke each method with.
       * @returns {Array} Returns the array of results.
       * @example
       *
       * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
       * // => [[1, 5, 7], [1, 2, 3]]
       *
       * _.invokeMap([123, 456], String.prototype.split, '');
       * // => [['1', '2', '3'], ['4', '5', '6']]
       */
      var invokeMap = baseRest(function(collection, path, args) {
        var index = -1,
          isFunc = typeof path == "function",
          result = isArrayLike(collection) ? Array(collection.length) : [];

        baseEach(collection, function(value) {
          result[++index] = isFunc
            ? apply(path, value, args)
            : baseInvoke(value, path, args);
        });
        return result;
      });

      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The corresponding value of
       * each key is the last element responsible for generating the key. The
       * iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * var array = [
       *   { 'dir': 'left', 'code': 97 },
       *   { 'dir': 'right', 'code': 100 }
       * ];
       *
       * _.keyBy(array, function(o) {
       *   return String.fromCharCode(o.code);
       * });
       * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
       *
       * _.keyBy(array, 'dir');
       * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
       */
      var keyBy = createAggregator(function(result, value, key) {
        baseAssignValue(result, key, value);
      });

      /**
       * Creates an array of values by running each element in `collection` thru
       * `iteratee`. The iteratee is invoked with three arguments:
       * (value, index|key, collection).
       *
       * Many lodash methods are guarded to work as iteratees for methods like
       * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
       *
       * The guarded methods are:
       * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
       * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
       * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
       * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * _.map([4, 8], square);
       * // => [16, 64]
       *
       * _.map({ 'a': 4, 'b': 8 }, square);
       * // => [16, 64] (iteration order is not guaranteed)
       *
       * var users = [
       *   { 'user': 'barney' },
       *   { 'user': 'fred' }
       * ];
       *
       * // The `_.property` iteratee shorthand.
       * _.map(users, 'user');
       * // => ['barney', 'fred']
       */
      function map(collection, iteratee) {
        var func = isArray(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee, 3));
      }

      /**
       * This method is like `_.sortBy` except that it allows specifying the sort
       * orders of the iteratees to sort by. If `orders` is unspecified, all values
       * are sorted in ascending order. Otherwise, specify an order of "desc" for
       * descending or "asc" for ascending sort order of corresponding values.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
       *  The iteratees to sort by.
       * @param {string[]} [orders] The sort orders of `iteratees`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
       * @returns {Array} Returns the new sorted array.
       * @example
       *
       * var users = [
       *   { 'user': 'fred',   'age': 48 },
       *   { 'user': 'barney', 'age': 34 },
       *   { 'user': 'fred',   'age': 40 },
       *   { 'user': 'barney', 'age': 36 }
       * ];
       *
       * // Sort by `user` in ascending order and by `age` in descending order.
       * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
       * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
       */
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }

      /**
       * Creates an array of elements split into two groups, the first of which
       * contains elements `predicate` returns truthy for, the second of which
       * contains elements `predicate` returns falsey for. The predicate is
       * invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the array of grouped elements.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36, 'active': false },
       *   { 'user': 'fred',    'age': 40, 'active': true },
       *   { 'user': 'pebbles', 'age': 1,  'active': false }
       * ];
       *
       * _.partition(users, function(o) { return o.active; });
       * // => objects for [['fred'], ['barney', 'pebbles']]
       *
       * // The `_.matches` iteratee shorthand.
       * _.partition(users, { 'age': 1, 'active': false });
       * // => objects for [['pebbles'], ['barney', 'fred']]
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.partition(users, ['active', false]);
       * // => objects for [['barney', 'pebbles'], ['fred']]
       *
       * // The `_.property` iteratee shorthand.
       * _.partition(users, 'active');
       * // => objects for [['fred'], ['barney', 'pebbles']]
       */
      var partition = createAggregator(
        function(result, value, key) {
          result[key ? 0 : 1].push(value);
        },
        function() {
          return [[], []];
        }
      );

      /**
       * Reduces `collection` to a value which is the accumulated result of running
       * each element in `collection` thru `iteratee`, where each successive
       * invocation is supplied the return value of the previous. If `accumulator`
       * is not given, the first element of `collection` is used as the initial
       * value. The iteratee is invoked with four arguments:
       * (accumulator, value, index|key, collection).
       *
       * Many lodash methods are guarded to work as iteratees for methods like
       * `_.reduce`, `_.reduceRight`, and `_.transform`.
       *
       * The guarded methods are:
       * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
       * and `sortBy`
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @returns {*} Returns the accumulated value.
       * @see _.reduceRight
       * @example
       *
       * _.reduce([1, 2], function(sum, n) {
       *   return sum + n;
       * }, 0);
       * // => 3
       *
       * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
       *   (result[value] || (result[value] = [])).push(key);
       *   return result;
       * }, {});
       * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
       */
      function reduce(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

        return func(
          collection,
          getIteratee(iteratee, 4),
          accumulator,
          initAccum,
          baseEach
        );
      }

      /**
       * This method is like `_.reduce` except that it iterates over elements of
       * `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @returns {*} Returns the accumulated value.
       * @see _.reduce
       * @example
       *
       * var array = [[0, 1], [2, 3], [4, 5]];
       *
       * _.reduceRight(array, function(flattened, other) {
       *   return flattened.concat(other);
       * }, []);
       * // => [4, 5, 2, 3, 0, 1]
       */
      function reduceRight(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

        return func(
          collection,
          getIteratee(iteratee, 4),
          accumulator,
          initAccum,
          baseEachRight
        );
      }

      /**
       * The opposite of `_.filter`; this method returns the elements of `collection`
       * that `predicate` does **not** return truthy for.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       * @see _.filter
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': false },
       *   { 'user': 'fred',   'age': 40, 'active': true }
       * ];
       *
       * _.reject(users, function(o) { return !o.active; });
       * // => objects for ['fred']
       *
       * // The `_.matches` iteratee shorthand.
       * _.reject(users, { 'age': 40, 'active': true });
       * // => objects for ['barney']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.reject(users, ['active', false]);
       * // => objects for ['fred']
       *
       * // The `_.property` iteratee shorthand.
       * _.reject(users, 'active');
       * // => objects for ['barney']
       */
      function reject(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }

      /**
       * Gets a random element from `collection`.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to sample.
       * @returns {*} Returns the random element.
       * @example
       *
       * _.sample([1, 2, 3, 4]);
       * // => 2
       */
      function sample(collection) {
        var func = isArray(collection) ? arraySample : baseSample;
        return func(collection);
      }

      /**
       * Gets `n` random elements at unique keys from `collection` up to the
       * size of `collection`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to sample.
       * @param {number} [n=1] The number of elements to sample.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the random elements.
       * @example
       *
       * _.sampleSize([1, 2, 3], 2);
       * // => [3, 1]
       *
       * _.sampleSize([1, 2, 3], 4);
       * // => [2, 3, 1]
       */
      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }

      /**
       * Creates an array of shuffled values, using a version of the
       * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to shuffle.
       * @returns {Array} Returns the new shuffled array.
       * @example
       *
       * _.shuffle([1, 2, 3, 4]);
       * // => [4, 1, 3, 2]
       */
      function shuffle(collection) {
        var func = isArray(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }

      /**
       * Gets the size of `collection` by returning its length for array-like
       * values or the number of own enumerable string keyed properties for objects.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object|string} collection The collection to inspect.
       * @returns {number} Returns the collection size.
       * @example
       *
       * _.size([1, 2, 3]);
       * // => 3
       *
       * _.size({ 'a': 1, 'b': 2 });
       * // => 2
       *
       * _.size('pebbles');
       * // => 7
       */
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString(collection)
            ? stringSize(collection)
            : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }

      /**
       * Checks if `predicate` returns truthy for **any** element of `collection`.
       * Iteration is stopped once `predicate` returns truthy. The predicate is
       * invoked with three arguments: (value, index|key, collection).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {boolean} Returns `true` if any element passes the predicate check,
       *  else `false`.
       * @example
       *
       * _.some([null, 0, 'yes', false], Boolean);
       * // => true
       *
       * var users = [
       *   { 'user': 'barney', 'active': true },
       *   { 'user': 'fred',   'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.some(users, { 'user': 'barney', 'active': false });
       * // => false
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.some(users, ['active', false]);
       * // => true
       *
       * // The `_.property` iteratee shorthand.
       * _.some(users, 'active');
       * // => true
       */
      function some(collection, predicate, guard) {
        var func = isArray(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }

      /**
       * Creates an array of elements, sorted in ascending order by the results of
       * running each element in a collection thru each iteratee. This method
       * performs a stable sort, that is, it preserves the original sort order of
       * equal elements. The iteratees are invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {...(Function|Function[])} [iteratees=[_.identity]]
       *  The iteratees to sort by.
       * @returns {Array} Returns the new sorted array.
       * @example
       *
       * var users = [
       *   { 'user': 'fred',   'age': 48 },
       *   { 'user': 'barney', 'age': 36 },
       *   { 'user': 'fred',   'age': 30 },
       *   { 'user': 'barney', 'age': 34 }
       * ];
       *
       * _.sortBy(users, [function(o) { return o.user; }]);
       * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
       *
       * _.sortBy(users, ['user', 'age']);
       * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
       */
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (
          length > 1 &&
          isIterateeCall(collection, iteratees[0], iteratees[1])
        ) {
          iteratees = [];
        } else if (
          length > 2 &&
          isIterateeCall(iteratees[0], iteratees[1], iteratees[2])
        ) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });

      /*------------------------------------------------------------------------*/

      /**
       * Gets the timestamp of the number of milliseconds that have elapsed since
       * the Unix epoch (1 January 1970 00:00:00 UTC).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Date
       * @returns {number} Returns the timestamp.
       * @example
       *
       * _.defer(function(stamp) {
       *   console.log(_.now() - stamp);
       * }, _.now());
       * // => Logs the number of milliseconds it took for the deferred invocation.
       */
      var now =
        ctxNow ||
        function() {
          return root.Date.now();
        };

      /*------------------------------------------------------------------------*/

      /**
       * The opposite of `_.before`; this method creates a function that invokes
       * `func` once it's called `n` or more times.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {number} n The number of calls before `func` is invoked.
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * var saves = ['profile', 'settings'];
       *
       * var done = _.after(saves.length, function() {
       *   console.log('done saving!');
       * });
       *
       * _.forEach(saves, function(type) {
       *   asyncSave({ 'type': type, 'complete': done });
       * });
       * // => Logs 'done saving!' after the two async saves have completed.
       */
      function after(n, func) {
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }

      /**
       * Creates a function that invokes `func`, with up to `n` arguments,
       * ignoring any additional arguments.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to cap arguments for.
       * @param {number} [n=func.length] The arity cap.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new capped function.
       * @example
       *
       * _.map(['6', '8', '10'], _.ary(parseInt, 1));
       * // => [6, 8, 10]
       */
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(
          func,
          WRAP_ARY_FLAG,
          undefined$1,
          undefined$1,
          undefined$1,
          undefined$1,
          n
        );
      }

      /**
       * Creates a function that invokes `func`, with the `this` binding and arguments
       * of the created function, while it's called less than `n` times. Subsequent
       * calls to the created function return the result of the last `func` invocation.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {number} n The number of calls at which `func` is no longer invoked.
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * jQuery(element).on('click', _.before(5, addContactToList));
       * // => Allows adding up to 4 contacts to the list.
       */
      function before(n, func) {
        var result;
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n > 0) {
            result = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result;
        };
      }

      /**
       * Creates a function that invokes `func` with the `this` binding of `thisArg`
       * and `partials` prepended to the arguments it receives.
       *
       * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
       * may be used as a placeholder for partially applied arguments.
       *
       * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
       * property of bound functions.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to bind.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new bound function.
       * @example
       *
       * function greet(greeting, punctuation) {
       *   return greeting + ' ' + this.user + punctuation;
       * }
       *
       * var object = { 'user': 'fred' };
       *
       * var bound = _.bind(greet, object, 'hi');
       * bound('!');
       * // => 'hi fred!'
       *
       * // Bound with placeholders.
       * var bound = _.bind(greet, object, _, '!');
       * bound('hi');
       * // => 'hi fred!'
       */
      var bind = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });

      /**
       * Creates a function that invokes the method at `object[key]` with `partials`
       * prepended to the arguments it receives.
       *
       * This method differs from `_.bind` by allowing bound functions to reference
       * methods that may be redefined or don't yet exist. See
       * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
       * for more details.
       *
       * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Function
       * @param {Object} object The object to invoke the method on.
       * @param {string} key The key of the method.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new bound function.
       * @example
       *
       * var object = {
       *   'user': 'fred',
       *   'greet': function(greeting, punctuation) {
       *     return greeting + ' ' + this.user + punctuation;
       *   }
       * };
       *
       * var bound = _.bindKey(object, 'greet', 'hi');
       * bound('!');
       * // => 'hi fred!'
       *
       * object.greet = function(greeting, punctuation) {
       *   return greeting + 'ya ' + this.user + punctuation;
       * };
       *
       * bound('!');
       * // => 'hiya fred!'
       *
       * // Bound with placeholders.
       * var bound = _.bindKey(object, 'greet', _, '!');
       * bound('hi');
       * // => 'hiya fred!'
       */
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });

      /**
       * Creates a function that accepts arguments of `func` and either invokes
       * `func` returning its result, if at least `arity` number of arguments have
       * been provided, or returns a function that accepts the remaining `func`
       * arguments, and so on. The arity of `func` may be specified if `func.length`
       * is not sufficient.
       *
       * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
       * may be used as a placeholder for provided arguments.
       *
       * **Note:** This method doesn't set the "length" property of curried functions.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Function
       * @param {Function} func The function to curry.
       * @param {number} [arity=func.length] The arity of `func`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new curried function.
       * @example
       *
       * var abc = function(a, b, c) {
       *   return [a, b, c];
       * };
       *
       * var curried = _.curry(abc);
       *
       * curried(1)(2)(3);
       * // => [1, 2, 3]
       *
       * curried(1, 2)(3);
       * // => [1, 2, 3]
       *
       * curried(1, 2, 3);
       * // => [1, 2, 3]
       *
       * // Curried with placeholders.
       * curried(1)(_, 3)(2);
       * // => [1, 2, 3]
       */
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(
          func,
          WRAP_CURRY_FLAG,
          undefined$1,
          undefined$1,
          undefined$1,
          undefined$1,
          undefined$1,
          arity
        );
        result.placeholder = curry.placeholder;
        return result;
      }

      /**
       * This method is like `_.curry` except that arguments are applied to `func`
       * in the manner of `_.partialRight` instead of `_.partial`.
       *
       * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for provided arguments.
       *
       * **Note:** This method doesn't set the "length" property of curried functions.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to curry.
       * @param {number} [arity=func.length] The arity of `func`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new curried function.
       * @example
       *
       * var abc = function(a, b, c) {
       *   return [a, b, c];
       * };
       *
       * var curried = _.curryRight(abc);
       *
       * curried(3)(2)(1);
       * // => [1, 2, 3]
       *
       * curried(2, 3)(1);
       * // => [1, 2, 3]
       *
       * curried(1, 2, 3);
       * // => [1, 2, 3]
       *
       * // Curried with placeholders.
       * curried(3)(1, _)(2);
       * // => [1, 2, 3]
       */
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(
          func,
          WRAP_CURRY_RIGHT_FLAG,
          undefined$1,
          undefined$1,
          undefined$1,
          undefined$1,
          undefined$1,
          arity
        );
        result.placeholder = curryRight.placeholder;
        return result;
      }

      /**
       * Creates a debounced function that delays invoking `func` until after `wait`
       * milliseconds have elapsed since the last time the debounced function was
       * invoked. The debounced function comes with a `cancel` method to cancel
       * delayed `func` invocations and a `flush` method to immediately invoke them.
       * Provide `options` to indicate whether `func` should be invoked on the
       * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
       * with the last arguments provided to the debounced function. Subsequent
       * calls to the debounced function return the result of the last `func`
       * invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the debounced function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.debounce` and `_.throttle`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to debounce.
       * @param {number} [wait=0] The number of milliseconds to delay.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=false]
       *  Specify invoking on the leading edge of the timeout.
       * @param {number} [options.maxWait]
       *  The maximum time `func` is allowed to be delayed before it's invoked.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new debounced function.
       * @example
       *
       * // Avoid costly calculations while the window size is in flux.
       * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
       *
       * // Invoke `sendMail` when clicked, debouncing subsequent calls.
       * jQuery(element).on('click', _.debounce(sendMail, 300, {
       *   'leading': true,
       *   'trailing': false
       * }));
       *
       * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
       * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
       * var source = new EventSource('/stream');
       * jQuery(source).on('message', debounced);
       *
       * // Cancel the trailing debounced invocation.
       * jQuery(window).on('popstate', debounced.cancel);
       */
      function debounce(func, wait, options) {
        var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing
            ? nativeMax(toNumber(options.maxWait) || 0, wait)
            : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }

        function invokeFunc(time) {
          var args = lastArgs,
            thisArg = lastThis;

          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }

        function leadingEdge(time) {
          // Reset any `maxWait` timer.
          lastInvokeTime = time;
          // Start the timer for the trailing edge.
          timerId = setTimeout(timerExpired, wait);
          // Invoke the leading edge.
          return leading ? invokeFunc(time) : result;
        }

        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

          return maxing
            ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
            : timeWaiting;
        }

        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

          // Either this is the first call, activity has stopped and we're at the
          // trailing edge, the system time has gone backwards and we're treating
          // it as the trailing edge, or we've hit the `maxWait` limit.
          return (
            lastCallTime === undefined$1 ||
            timeSinceLastCall >= wait ||
            timeSinceLastCall < 0 ||
            (maxing && timeSinceLastInvoke >= maxWait)
          );
        }

        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          // Restart the timer.
          timerId = setTimeout(timerExpired, remainingWait(time));
        }

        function trailingEdge(time) {
          timerId = undefined$1;

          // Only invoke if we have `lastArgs` which means `func` has been
          // debounced at least once.
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result;
        }

        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }

        function flush() {
          return timerId === undefined$1 ? result : trailingEdge(now());
        }

        function debounced() {
          var time = now(),
            isInvoking = shouldInvoke(time);

          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;

          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              // Handle invocations in a tight loop.
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }

      /**
       * Defers invoking the `func` until the current call stack has cleared. Any
       * additional arguments are provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to defer.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * _.defer(function(text) {
       *   console.log(text);
       * }, 'deferred');
       * // => Logs 'deferred' after one millisecond.
       */
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });

      /**
       * Invokes `func` after `wait` milliseconds. Any additional arguments are
       * provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * _.delay(function(text) {
       *   console.log(text);
       * }, 1000, 'later');
       * // => Logs 'later' after one second.
       */
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });

      /**
       * Creates a function that invokes `func` with arguments reversed.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to flip arguments for.
       * @returns {Function} Returns the new flipped function.
       * @example
       *
       * var flipped = _.flip(function() {
       *   return _.toArray(arguments);
       * });
       *
       * flipped('a', 'b', 'c', 'd');
       * // => ['d', 'c', 'b', 'a']
       */
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }

      /**
       * Creates a function that memoizes the result of `func`. If `resolver` is
       * provided, it determines the cache key for storing the result based on the
       * arguments provided to the memoized function. By default, the first argument
       * provided to the memoized function is used as the map cache key. The `func`
       * is invoked with the `this` binding of the memoized function.
       *
       * **Note:** The cache is exposed as the `cache` property on the memoized
       * function. Its creation may be customized by replacing the `_.memoize.Cache`
       * constructor with one whose instances implement the
       * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
       * method interface of `clear`, `delete`, `get`, `has`, and `set`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to have its output memoized.
       * @param {Function} [resolver] The function to resolve the cache key.
       * @returns {Function} Returns the new memoized function.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       * var other = { 'c': 3, 'd': 4 };
       *
       * var values = _.memoize(_.values);
       * values(object);
       * // => [1, 2]
       *
       * values(other);
       * // => [3, 4]
       *
       * object.a = 2;
       * values(object);
       * // => [1, 2]
       *
       * // Modify the result cache.
       * values.cache.set(object, ['a', 'b']);
       * values(object);
       * // => ['a', 'b']
       *
       * // Replace `_.memoize.Cache`.
       * _.memoize.Cache = WeakMap;
       */
      function memoize(func, resolver) {
        if (
          typeof func != "function" ||
          (resolver != null && typeof resolver != "function")
        ) {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

          if (cache.has(key)) {
            return cache.get(key);
          }
          var result = func.apply(this, args);
          memoized.cache = cache.set(key, result) || cache;
          return result;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }

      // Expose `MapCache`.
      memoize.Cache = MapCache;

      /**
       * Creates a function that negates the result of the predicate `func`. The
       * `func` predicate is invoked with the `this` binding and arguments of the
       * created function.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} predicate The predicate to negate.
       * @returns {Function} Returns the new negated function.
       * @example
       *
       * function isEven(n) {
       *   return n % 2 == 0;
       * }
       *
       * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
       * // => [1, 3, 5]
       */
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }

      /**
       * Creates a function that is restricted to invoking `func` once. Repeat calls
       * to the function return the value of the first invocation. The `func` is
       * invoked with the `this` binding and arguments of the created function.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * var initialize = _.once(createApplication);
       * initialize();
       * initialize();
       * // => `createApplication` is invoked once
       */
      function once(func) {
        return before(2, func);
      }

      /**
       * Creates a function that invokes `func` with its arguments transformed.
       *
       * @static
       * @since 4.0.0
       * @memberOf _
       * @category Function
       * @param {Function} func The function to wrap.
       * @param {...(Function|Function[])} [transforms=[_.identity]]
       *  The argument transforms.
       * @returns {Function} Returns the new function.
       * @example
       *
       * function doubled(n) {
       *   return n * 2;
       * }
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var func = _.overArgs(function(x, y) {
       *   return [x, y];
       * }, [square, doubled]);
       *
       * func(9, 3);
       * // => [81, 6]
       *
       * func(10, 5);
       * // => [100, 10]
       */
      var overArgs = castRest(function(func, transforms) {
        transforms =
          transforms.length == 1 && isArray(transforms[0])
            ? arrayMap(transforms[0], baseUnary(getIteratee()))
            : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index = -1,
            length = nativeMin(args.length, funcsLength);

          while (++index < length) {
            args[index] = transforms[index].call(this, args[index]);
          }
          return apply(func, this, args);
        });
      });

      /**
       * Creates a function that invokes `func` with `partials` prepended to the
       * arguments it receives. This method is like `_.bind` except it does **not**
       * alter the `this` binding.
       *
       * The `_.partial.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * **Note:** This method doesn't set the "length" property of partially
       * applied functions.
       *
       * @static
       * @memberOf _
       * @since 0.2.0
       * @category Function
       * @param {Function} func The function to partially apply arguments to.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new partially applied function.
       * @example
       *
       * function greet(greeting, name) {
       *   return greeting + ' ' + name;
       * }
       *
       * var sayHelloTo = _.partial(greet, 'hello');
       * sayHelloTo('fred');
       * // => 'hello fred'
       *
       * // Partially applied with placeholders.
       * var greetFred = _.partial(greet, _, 'fred');
       * greetFred('hi');
       * // => 'hi fred'
       */
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(
          func,
          WRAP_PARTIAL_FLAG,
          undefined$1,
          partials,
          holders
        );
      });

      /**
       * This method is like `_.partial` except that partially applied arguments
       * are appended to the arguments it receives.
       *
       * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * **Note:** This method doesn't set the "length" property of partially
       * applied functions.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Function
       * @param {Function} func The function to partially apply arguments to.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new partially applied function.
       * @example
       *
       * function greet(greeting, name) {
       *   return greeting + ' ' + name;
       * }
       *
       * var greetFred = _.partialRight(greet, 'fred');
       * greetFred('hi');
       * // => 'hi fred'
       *
       * // Partially applied with placeholders.
       * var sayHelloTo = _.partialRight(greet, 'hello', _);
       * sayHelloTo('fred');
       * // => 'hello fred'
       */
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(
          func,
          WRAP_PARTIAL_RIGHT_FLAG,
          undefined$1,
          partials,
          holders
        );
      });

      /**
       * Creates a function that invokes `func` with arguments arranged according
       * to the specified `indexes` where the argument value at the first index is
       * provided as the first argument, the argument value at the second index is
       * provided as the second argument, and so on.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to rearrange arguments for.
       * @param {...(number|number[])} indexes The arranged argument indexes.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var rearged = _.rearg(function(a, b, c) {
       *   return [a, b, c];
       * }, [2, 0, 1]);
       *
       * rearged('b', 'c', 'a')
       * // => ['a', 'b', 'c']
       */
      var rearg = flatRest(function(func, indexes) {
        return createWrap(
          func,
          WRAP_REARG_FLAG,
          undefined$1,
          undefined$1,
          undefined$1,
          indexes
        );
      });

      /**
       * Creates a function that invokes `func` with the `this` binding of the
       * created function and arguments from `start` and beyond provided as
       * an array.
       *
       * **Note:** This method is based on the
       * [rest parameter](https://mdn.io/rest_parameters).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var say = _.rest(function(what, names) {
       *   return what + ' ' + _.initial(names).join(', ') +
       *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
       * });
       *
       * say('hello', 'fred', 'barney', 'pebbles');
       * // => 'hello fred, barney, & pebbles'
       */
      function rest(func, start) {
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }

      /**
       * Creates a function that invokes `func` with the `this` binding of the
       * create function and an array of arguments much like
       * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
       *
       * **Note:** This method is based on the
       * [spread operator](https://mdn.io/spread_operator).
       *
       * @static
       * @memberOf _
       * @since 3.2.0
       * @category Function
       * @param {Function} func The function to spread arguments over.
       * @param {number} [start=0] The start position of the spread.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var say = _.spread(function(who, what) {
       *   return who + ' says ' + what;
       * });
       *
       * say(['fred', 'hello']);
       * // => 'fred says hello'
       *
       * var numbers = Promise.all([
       *   Promise.resolve(40),
       *   Promise.resolve(36)
       * ]);
       *
       * numbers.then(_.spread(function(x, y) {
       *   return x + y;
       * }));
       * // => a Promise of 76
       */
      function spread(func, start) {
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function(args) {
          var array = args[start],
            otherArgs = castSlice(args, 0, start);

          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }

      /**
       * Creates a throttled function that only invokes `func` at most once per
       * every `wait` milliseconds. The throttled function comes with a `cancel`
       * method to cancel delayed `func` invocations and a `flush` method to
       * immediately invoke them. Provide `options` to indicate whether `func`
       * should be invoked on the leading and/or trailing edge of the `wait`
       * timeout. The `func` is invoked with the last arguments provided to the
       * throttled function. Subsequent calls to the throttled function return the
       * result of the last `func` invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the throttled function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.throttle` and `_.debounce`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to throttle.
       * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=true]
       *  Specify invoking on the leading edge of the timeout.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new throttled function.
       * @example
       *
       * // Avoid excessively updating the position while scrolling.
       * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
       *
       * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
       * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
       * jQuery(element).on('click', throttled);
       *
       * // Cancel the trailing throttled invocation.
       * jQuery(window).on('popstate', throttled.cancel);
       */
      function throttle(func, wait, options) {
        var leading = true,
          trailing = true;

        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        if (isObject(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          leading: leading,
          maxWait: wait,
          trailing: trailing
        });
      }

      /**
       * Creates a function that accepts up to one argument, ignoring any
       * additional arguments.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to cap arguments for.
       * @returns {Function} Returns the new capped function.
       * @example
       *
       * _.map(['6', '8', '10'], _.unary(parseInt));
       * // => [6, 8, 10]
       */
      function unary(func) {
        return ary(func, 1);
      }

      /**
       * Creates a function that provides `value` to `wrapper` as its first
       * argument. Any additional arguments provided to the function are appended
       * to those provided to the `wrapper`. The wrapper is invoked with the `this`
       * binding of the created function.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {*} value The value to wrap.
       * @param {Function} [wrapper=identity] The wrapper function.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var p = _.wrap(_.escape, function(func, text) {
       *   return '<p>' + func(text) + '</p>';
       * });
       *
       * p('fred, barney, & pebbles');
       * // => '<p>fred, barney, &amp; pebbles</p>'
       */
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Casts `value` as an array if it's not one.
       *
       * @static
       * @memberOf _
       * @since 4.4.0
       * @category Lang
       * @param {*} value The value to inspect.
       * @returns {Array} Returns the cast array.
       * @example
       *
       * _.castArray(1);
       * // => [1]
       *
       * _.castArray({ 'a': 1 });
       * // => [{ 'a': 1 }]
       *
       * _.castArray('abc');
       * // => ['abc']
       *
       * _.castArray(null);
       * // => [null]
       *
       * _.castArray(undefined);
       * // => [undefined]
       *
       * _.castArray();
       * // => []
       *
       * var array = [1, 2, 3];
       * console.log(_.castArray(array) === array);
       * // => true
       */
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray(value) ? value : [value];
      }

      /**
       * Creates a shallow clone of `value`.
       *
       * **Note:** This method is loosely based on the
       * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
       * and supports cloning arrays, array buffers, booleans, date objects, maps,
       * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
       * arrays. The own enumerable properties of `arguments` objects are cloned
       * as plain objects. An empty object is returned for uncloneable values such
       * as error objects, functions, DOM nodes, and WeakMaps.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to clone.
       * @returns {*} Returns the cloned value.
       * @see _.cloneDeep
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var shallow = _.clone(objects);
       * console.log(shallow[0] === objects[0]);
       * // => true
       */
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }

      /**
       * This method is like `_.clone` except that it accepts `customizer` which
       * is invoked to produce the cloned value. If `customizer` returns `undefined`,
       * cloning is handled by the method instead. The `customizer` is invoked with
       * up to four arguments; (value [, index|key, object, stack]).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to clone.
       * @param {Function} [customizer] The function to customize cloning.
       * @returns {*} Returns the cloned value.
       * @see _.cloneDeepWith
       * @example
       *
       * function customizer(value) {
       *   if (_.isElement(value)) {
       *     return value.cloneNode(false);
       *   }
       * }
       *
       * var el = _.cloneWith(document.body, customizer);
       *
       * console.log(el === document.body);
       * // => false
       * console.log(el.nodeName);
       * // => 'BODY'
       * console.log(el.childNodes.length);
       * // => 0
       */
      function cloneWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }

      /**
       * This method is like `_.clone` except that it recursively clones `value`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Lang
       * @param {*} value The value to recursively clone.
       * @returns {*} Returns the deep cloned value.
       * @see _.clone
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var deep = _.cloneDeep(objects);
       * console.log(deep[0] === objects[0]);
       * // => false
       */
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }

      /**
       * This method is like `_.cloneWith` except that it recursively clones `value`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to recursively clone.
       * @param {Function} [customizer] The function to customize cloning.
       * @returns {*} Returns the deep cloned value.
       * @see _.cloneWith
       * @example
       *
       * function customizer(value) {
       *   if (_.isElement(value)) {
       *     return value.cloneNode(true);
       *   }
       * }
       *
       * var el = _.cloneDeepWith(document.body, customizer);
       *
       * console.log(el === document.body);
       * // => false
       * console.log(el.nodeName);
       * // => 'BODY'
       * console.log(el.childNodes.length);
       * // => 20
       */
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseClone(
          value,
          CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG,
          customizer
        );
      }

      /**
       * Checks if `object` conforms to `source` by invoking the predicate
       * properties of `source` with the corresponding property values of `object`.
       *
       * **Note:** This method is equivalent to `_.conforms` when `source` is
       * partially applied.
       *
       * @static
       * @memberOf _
       * @since 4.14.0
       * @category Lang
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property predicates to conform to.
       * @returns {boolean} Returns `true` if `object` conforms, else `false`.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       *
       * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
       * // => true
       *
       * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
       * // => false
       */
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }

      /**
       * Performs a
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * comparison between two values to determine if they are equivalent.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.eq(object, object);
       * // => true
       *
       * _.eq(object, other);
       * // => false
       *
       * _.eq('a', 'a');
       * // => true
       *
       * _.eq('a', Object('a'));
       * // => false
       *
       * _.eq(NaN, NaN);
       * // => true
       */
      function eq(value, other) {
        return value === other || (value !== value && other !== other);
      }

      /**
       * Checks if `value` is greater than `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is greater than `other`,
       *  else `false`.
       * @see _.lt
       * @example
       *
       * _.gt(3, 1);
       * // => true
       *
       * _.gt(3, 3);
       * // => false
       *
       * _.gt(1, 3);
       * // => false
       */
      var gt = createRelationalOperation(baseGt);

      /**
       * Checks if `value` is greater than or equal to `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is greater than or equal to
       *  `other`, else `false`.
       * @see _.lte
       * @example
       *
       * _.gte(3, 1);
       * // => true
       *
       * _.gte(3, 3);
       * // => true
       *
       * _.gte(1, 3);
       * // => false
       */
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });

      /**
       * Checks if `value` is likely an `arguments` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       *  else `false`.
       * @example
       *
       * _.isArguments(function() { return arguments; }());
       * // => true
       *
       * _.isArguments([1, 2, 3]);
       * // => false
       */
      var isArguments = baseIsArguments(
        (function() {
          return arguments;
        })()
      )
        ? baseIsArguments
        : function(value) {
            return (
              isObjectLike(value) &&
              hasOwnProperty.call(value, "callee") &&
              !propertyIsEnumerable.call(value, "callee")
            );
          };

      /**
       * Checks if `value` is classified as an `Array` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array, else `false`.
       * @example
       *
       * _.isArray([1, 2, 3]);
       * // => true
       *
       * _.isArray(document.body.children);
       * // => false
       *
       * _.isArray('abc');
       * // => false
       *
       * _.isArray(_.noop);
       * // => false
       */
      var isArray = Array.isArray;

      /**
       * Checks if `value` is classified as an `ArrayBuffer` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
       * @example
       *
       * _.isArrayBuffer(new ArrayBuffer(2));
       * // => true
       *
       * _.isArrayBuffer(new Array(2));
       * // => false
       */
      var isArrayBuffer = nodeIsArrayBuffer
        ? baseUnary(nodeIsArrayBuffer)
        : baseIsArrayBuffer;

      /**
       * Checks if `value` is array-like. A value is considered array-like if it's
       * not a function and has a `value.length` that's an integer greater than or
       * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       * @example
       *
       * _.isArrayLike([1, 2, 3]);
       * // => true
       *
       * _.isArrayLike(document.body.children);
       * // => true
       *
       * _.isArrayLike('abc');
       * // => true
       *
       * _.isArrayLike(_.noop);
       * // => false
       */
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }

      /**
       * This method is like `_.isArrayLike` except that it also checks if `value`
       * is an object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array-like object,
       *  else `false`.
       * @example
       *
       * _.isArrayLikeObject([1, 2, 3]);
       * // => true
       *
       * _.isArrayLikeObject(document.body.children);
       * // => true
       *
       * _.isArrayLikeObject('abc');
       * // => false
       *
       * _.isArrayLikeObject(_.noop);
       * // => false
       */
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }

      /**
       * Checks if `value` is classified as a boolean primitive or object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
       * @example
       *
       * _.isBoolean(false);
       * // => true
       *
       * _.isBoolean(null);
       * // => false
       */
      function isBoolean(value) {
        return (
          value === true ||
          value === false ||
          (isObjectLike(value) && baseGetTag(value) == boolTag)
        );
      }

      /**
       * Checks if `value` is a buffer.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
       * @example
       *
       * _.isBuffer(new Buffer(2));
       * // => true
       *
       * _.isBuffer(new Uint8Array(2));
       * // => false
       */
      var isBuffer = nativeIsBuffer || stubFalse;

      /**
       * Checks if `value` is classified as a `Date` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
       * @example
       *
       * _.isDate(new Date);
       * // => true
       *
       * _.isDate('Mon April 23 2012');
       * // => false
       */
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

      /**
       * Checks if `value` is likely a DOM element.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
       * @example
       *
       * _.isElement(document.body);
       * // => true
       *
       * _.isElement('<body>');
       * // => false
       */
      function isElement(value) {
        return (
          isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value)
        );
      }

      /**
       * Checks if `value` is an empty object, collection, map, or set.
       *
       * Objects are considered empty if they have no own enumerable string keyed
       * properties.
       *
       * Array-like values such as `arguments` objects, arrays, buffers, strings, or
       * jQuery-like collections are considered empty if they have a `length` of `0`.
       * Similarly, maps and sets are considered empty if they have a `size` of `0`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is empty, else `false`.
       * @example
       *
       * _.isEmpty(null);
       * // => true
       *
       * _.isEmpty(true);
       * // => true
       *
       * _.isEmpty(1);
       * // => true
       *
       * _.isEmpty([1, 2, 3]);
       * // => false
       *
       * _.isEmpty({ 'a': 1 });
       * // => false
       */
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (
          isArrayLike(value) &&
          (isArray(value) ||
            typeof value == "string" ||
            typeof value.splice == "function" ||
            isBuffer(value) ||
            isTypedArray(value) ||
            isArguments(value))
        ) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }
        return true;
      }

      /**
       * Performs a deep comparison between two values to determine if they are
       * equivalent.
       *
       * **Note:** This method supports comparing arrays, array buffers, booleans,
       * date objects, error objects, maps, numbers, `Object` objects, regexes,
       * sets, strings, symbols, and typed arrays. `Object` objects are compared
       * by their own, not inherited, enumerable properties. Functions and DOM
       * nodes are compared by strict equality, i.e. `===`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.isEqual(object, other);
       * // => true
       *
       * object === other;
       * // => false
       */
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }

      /**
       * This method is like `_.isEqual` except that it accepts `customizer` which
       * is invoked to compare values. If `customizer` returns `undefined`, comparisons
       * are handled by the method instead. The `customizer` is invoked with up to
       * six arguments: (objValue, othValue [, index|key, object, other, stack]).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * function isGreeting(value) {
       *   return /^h(?:i|ello)$/.test(value);
       * }
       *
       * function customizer(objValue, othValue) {
       *   if (isGreeting(objValue) && isGreeting(othValue)) {
       *     return true;
       *   }
       * }
       *
       * var array = ['hello', 'goodbye'];
       * var other = ['hi', 'goodbye'];
       *
       * _.isEqualWith(array, other, customizer);
       * // => true
       */
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        var result = customizer ? customizer(value, other) : undefined$1;
        return result === undefined$1
          ? baseIsEqual(value, other, undefined$1, customizer)
          : !!result;
      }

      /**
       * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
       * `SyntaxError`, `TypeError`, or `URIError` object.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
       * @example
       *
       * _.isError(new Error);
       * // => true
       *
       * _.isError(Error);
       * // => false
       */
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return (
          tag == errorTag ||
          tag == domExcTag ||
          (typeof value.message == "string" &&
            typeof value.name == "string" &&
            !isPlainObject(value))
        );
      }

      /**
       * Checks if `value` is a finite primitive number.
       *
       * **Note:** This method is based on
       * [`Number.isFinite`](https://mdn.io/Number/isFinite).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
       * @example
       *
       * _.isFinite(3);
       * // => true
       *
       * _.isFinite(Number.MIN_VALUE);
       * // => true
       *
       * _.isFinite(Infinity);
       * // => false
       *
       * _.isFinite('3');
       * // => false
       */
      function isFinite(value) {
        return typeof value == "number" && nativeIsFinite(value);
      }

      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a function, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.
        var tag = baseGetTag(value);
        return (
          tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag
        );
      }

      /**
       * Checks if `value` is an integer.
       *
       * **Note:** This method is based on
       * [`Number.isInteger`](https://mdn.io/Number/isInteger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
       * @example
       *
       * _.isInteger(3);
       * // => true
       *
       * _.isInteger(Number.MIN_VALUE);
       * // => false
       *
       * _.isInteger(Infinity);
       * // => false
       *
       * _.isInteger('3');
       * // => false
       */
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }

      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This method is loosely based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       * @example
       *
       * _.isLength(3);
       * // => true
       *
       * _.isLength(Number.MIN_VALUE);
       * // => false
       *
       * _.isLength(Infinity);
       * // => false
       *
       * _.isLength('3');
       * // => false
       */
      function isLength(value) {
        return (
          typeof value == "number" &&
          value > -1 &&
          value % 1 == 0 &&
          value <= MAX_SAFE_INTEGER
        );
      }

      /**
       * Checks if `value` is the
       * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
       * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(_.noop);
       * // => true
       *
       * _.isObject(null);
       * // => false
       */
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }

      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }

      /**
       * Checks if `value` is classified as a `Map` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       * @example
       *
       * _.isMap(new Map);
       * // => true
       *
       * _.isMap(new WeakMap);
       * // => false
       */
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

      /**
       * Performs a partial deep comparison between `object` and `source` to
       * determine if `object` contains equivalent property values.
       *
       * **Note:** This method is equivalent to `_.matches` when `source` is
       * partially applied.
       *
       * Partial comparisons will match empty array and empty object `source`
       * values against any array or object value, respectively. See `_.isEqual`
       * for a list of supported value comparisons.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       *
       * _.isMatch(object, { 'b': 2 });
       * // => true
       *
       * _.isMatch(object, { 'b': 1 });
       * // => false
       */
      function isMatch(object, source) {
        return (
          object === source || baseIsMatch(object, source, getMatchData(source))
        );
      }

      /**
       * This method is like `_.isMatch` except that it accepts `customizer` which
       * is invoked to compare values. If `customizer` returns `undefined`, comparisons
       * are handled by the method instead. The `customizer` is invoked with five
       * arguments: (objValue, srcValue, index|key, object, source).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       * @example
       *
       * function isGreeting(value) {
       *   return /^h(?:i|ello)$/.test(value);
       * }
       *
       * function customizer(objValue, srcValue) {
       *   if (isGreeting(objValue) && isGreeting(srcValue)) {
       *     return true;
       *   }
       * }
       *
       * var object = { 'greeting': 'hello' };
       * var source = { 'greeting': 'hi' };
       *
       * _.isMatchWith(object, source, customizer);
       * // => true
       */
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }

      /**
       * Checks if `value` is `NaN`.
       *
       * **Note:** This method is based on
       * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
       * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
       * `undefined` and other non-number values.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
       * @example
       *
       * _.isNaN(NaN);
       * // => true
       *
       * _.isNaN(new Number(NaN));
       * // => true
       *
       * isNaN(undefined);
       * // => true
       *
       * _.isNaN(undefined);
       * // => false
       */
      function isNaN(value) {
        // An `NaN` primitive is the only value that is not equal to itself.
        // Perform the `toStringTag` check first to avoid errors with some
        // ActiveX objects in IE.
        return isNumber(value) && value != +value;
      }

      /**
       * Checks if `value` is a pristine native function.
       *
       * **Note:** This method can't reliably detect native functions in the presence
       * of the core-js package because core-js circumvents this kind of detection.
       * Despite multiple requests, the core-js maintainer has made it clear: any
       * attempt to fix the detection will be obstructed. As a result, we're left
       * with little choice but to throw an error. Unfortunately, this also affects
       * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
       * which rely on core-js.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function,
       *  else `false`.
       * @example
       *
       * _.isNative(Array.prototype.push);
       * // => true
       *
       * _.isNative(_);
       * // => false
       */
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }

      /**
       * Checks if `value` is `null`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
       * @example
       *
       * _.isNull(null);
       * // => true
       *
       * _.isNull(void 0);
       * // => false
       */
      function isNull(value) {
        return value === null;
      }

      /**
       * Checks if `value` is `null` or `undefined`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
       * @example
       *
       * _.isNil(null);
       * // => true
       *
       * _.isNil(void 0);
       * // => true
       *
       * _.isNil(NaN);
       * // => false
       */
      function isNil(value) {
        return value == null;
      }

      /**
       * Checks if `value` is classified as a `Number` primitive or object.
       *
       * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
       * classified as numbers, use the `_.isFinite` method.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a number, else `false`.
       * @example
       *
       * _.isNumber(3);
       * // => true
       *
       * _.isNumber(Number.MIN_VALUE);
       * // => true
       *
       * _.isNumber(Infinity);
       * // => true
       *
       * _.isNumber('3');
       * // => false
       */
      function isNumber(value) {
        return (
          typeof value == "number" ||
          (isObjectLike(value) && baseGetTag(value) == numberTag)
        );
      }

      /**
       * Checks if `value` is a plain object, that is, an object created by the
       * `Object` constructor or one with a `[[Prototype]]` of `null`.
       *
       * @static
       * @memberOf _
       * @since 0.8.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * _.isPlainObject(new Foo);
       * // => false
       *
       * _.isPlainObject([1, 2, 3]);
       * // => false
       *
       * _.isPlainObject({ 'x': 0, 'y': 0 });
       * // => true
       *
       * _.isPlainObject(Object.create(null));
       * // => true
       */
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor =
          hasOwnProperty.call(proto, "constructor") && proto.constructor;
        return (
          typeof Ctor == "function" &&
          Ctor instanceof Ctor &&
          funcToString.call(Ctor) == objectCtorString
        );
      }

      /**
       * Checks if `value` is classified as a `RegExp` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
       * @example
       *
       * _.isRegExp(/abc/);
       * // => true
       *
       * _.isRegExp('/abc/');
       * // => false
       */
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

      /**
       * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
       * double precision number which isn't the result of a rounded unsafe integer.
       *
       * **Note:** This method is based on
       * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
       * @example
       *
       * _.isSafeInteger(3);
       * // => true
       *
       * _.isSafeInteger(Number.MIN_VALUE);
       * // => false
       *
       * _.isSafeInteger(Infinity);
       * // => false
       *
       * _.isSafeInteger('3');
       * // => false
       */
      function isSafeInteger(value) {
        return (
          isInteger(value) &&
          value >= -MAX_SAFE_INTEGER &&
          value <= MAX_SAFE_INTEGER
        );
      }

      /**
       * Checks if `value` is classified as a `Set` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       * @example
       *
       * _.isSet(new Set);
       * // => true
       *
       * _.isSet(new WeakSet);
       * // => false
       */
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

      /**
       * Checks if `value` is classified as a `String` primitive or object.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a string, else `false`.
       * @example
       *
       * _.isString('abc');
       * // => true
       *
       * _.isString(1);
       * // => false
       */
      function isString(value) {
        return (
          typeof value == "string" ||
          (!isArray(value) &&
            isObjectLike(value) &&
            baseGetTag(value) == stringTag)
        );
      }

      /**
       * Checks if `value` is classified as a `Symbol` primitive or object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
       * @example
       *
       * _.isSymbol(Symbol.iterator);
       * // => true
       *
       * _.isSymbol('abc');
       * // => false
       */
      function isSymbol(value) {
        return (
          typeof value == "symbol" ||
          (isObjectLike(value) && baseGetTag(value) == symbolTag)
        );
      }

      /**
       * Checks if `value` is classified as a typed array.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       * @example
       *
       * _.isTypedArray(new Uint8Array);
       * // => true
       *
       * _.isTypedArray([]);
       * // => false
       */
      var isTypedArray = nodeIsTypedArray
        ? baseUnary(nodeIsTypedArray)
        : baseIsTypedArray;

      /**
       * Checks if `value` is `undefined`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
       * @example
       *
       * _.isUndefined(void 0);
       * // => true
       *
       * _.isUndefined(null);
       * // => false
       */
      function isUndefined(value) {
        return value === undefined$1;
      }

      /**
       * Checks if `value` is classified as a `WeakMap` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
       * @example
       *
       * _.isWeakMap(new WeakMap);
       * // => true
       *
       * _.isWeakMap(new Map);
       * // => false
       */
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }

      /**
       * Checks if `value` is classified as a `WeakSet` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
       * @example
       *
       * _.isWeakSet(new WeakSet);
       * // => true
       *
       * _.isWeakSet(new Set);
       * // => false
       */
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }

      /**
       * Checks if `value` is less than `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is less than `other`,
       *  else `false`.
       * @see _.gt
       * @example
       *
       * _.lt(1, 3);
       * // => true
       *
       * _.lt(3, 3);
       * // => false
       *
       * _.lt(3, 1);
       * // => false
       */
      var lt = createRelationalOperation(baseLt);

      /**
       * Checks if `value` is less than or equal to `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is less than or equal to
       *  `other`, else `false`.
       * @see _.gte
       * @example
       *
       * _.lte(1, 3);
       * // => true
       *
       * _.lte(3, 3);
       * // => true
       *
       * _.lte(3, 1);
       * // => false
       */
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });

      /**
       * Converts `value` to an array.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Array} Returns the converted array.
       * @example
       *
       * _.toArray({ 'a': 1, 'b': 2 });
       * // => [1, 2]
       *
       * _.toArray('abc');
       * // => ['a', 'b', 'c']
       *
       * _.toArray(1);
       * // => []
       *
       * _.toArray(null);
       * // => []
       */
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value),
          func =
            tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;

        return func(value);
      }

      /**
       * Converts `value` to a finite number.
       *
       * @static
       * @memberOf _
       * @since 4.12.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted number.
       * @example
       *
       * _.toFinite(3.2);
       * // => 3.2
       *
       * _.toFinite(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toFinite(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toFinite('3.2');
       * // => 3.2
       */
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }

      /**
       * Converts `value` to an integer.
       *
       * **Note:** This method is loosely based on
       * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toInteger(3.2);
       * // => 3
       *
       * _.toInteger(Number.MIN_VALUE);
       * // => 0
       *
       * _.toInteger(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toInteger('3.2');
       * // => 3
       */
      function toInteger(value) {
        var result = toFinite(value),
          remainder = result % 1;

        return result === result
          ? remainder
            ? result - remainder
            : result
          : 0;
      }

      /**
       * Converts `value` to an integer suitable for use as the length of an
       * array-like object.
       *
       * **Note:** This method is based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toLength(3.2);
       * // => 3
       *
       * _.toLength(Number.MIN_VALUE);
       * // => 0
       *
       * _.toLength(Infinity);
       * // => 4294967295
       *
       * _.toLength('3.2');
       * // => 3
       */
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }

      /**
       * Converts `value` to a number.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       * @example
       *
       * _.toNumber(3.2);
       * // => 3.2
       *
       * _.toNumber(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toNumber(Infinity);
       * // => Infinity
       *
       * _.toNumber('3.2');
       * // => 3.2
       */
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other =
            typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value)
          ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
          : reIsBadHex.test(value)
          ? NAN
          : +value;
      }

      /**
       * Converts `value` to a plain object flattening inherited enumerable string
       * keyed properties of `value` to own properties of the plain object.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Object} Returns the converted plain object.
       * @example
       *
       * function Foo() {
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.assign({ 'a': 1 }, new Foo);
       * // => { 'a': 1, 'b': 2 }
       *
       * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
       * // => { 'a': 1, 'b': 2, 'c': 3 }
       */
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }

      /**
       * Converts `value` to a safe integer. A safe integer can be compared and
       * represented correctly.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toSafeInteger(3.2);
       * // => 3
       *
       * _.toSafeInteger(Number.MIN_VALUE);
       * // => 0
       *
       * _.toSafeInteger(Infinity);
       * // => 9007199254740991
       *
       * _.toSafeInteger('3.2');
       * // => 3
       */
      function toSafeInteger(value) {
        return value
          ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
          : value === 0
          ? value
          : 0;
      }

      /**
       * Converts `value` to a string. An empty string is returned for `null`
       * and `undefined` values. The sign of `-0` is preserved.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.toString(null);
       * // => ''
       *
       * _.toString(-0);
       * // => '-0'
       *
       * _.toString([1, 2, 3]);
       * // => '1,2,3'
       */
      function toString(value) {
        return value == null ? "" : baseToString(value);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Assigns own enumerable string keyed properties of source objects to the
       * destination object. Source objects are applied from left to right.
       * Subsequent sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object` and is loosely based on
       * [`Object.assign`](https://mdn.io/Object/assign).
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assignIn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assign({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'c': 3 }
       */
      var assign = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });

      /**
       * This method is like `_.assign` except that it iterates over own and
       * inherited source properties.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias extend
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assign
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assignIn({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
       */
      var assignIn = createAssigner(function(object, source) {
        copyObject(source, keysIn(source), object);
      });

      /**
       * This method is like `_.assignIn` except that it accepts `customizer`
       * which is invoked to produce the assigned values. If `customizer` returns
       * `undefined`, assignment is handled by the method instead. The `customizer`
       * is invoked with five arguments: (objValue, srcValue, key, object, source).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias extendWith
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @see _.assignWith
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   return _.isUndefined(objValue) ? srcValue : objValue;
       * }
       *
       * var defaults = _.partialRight(_.assignInWith, customizer);
       *
       * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */
      var assignInWith = createAssigner(function(
        object,
        source,
        srcIndex,
        customizer
      ) {
        copyObject(source, keysIn(source), object, customizer);
      });

      /**
       * This method is like `_.assign` except that it accepts `customizer`
       * which is invoked to produce the assigned values. If `customizer` returns
       * `undefined`, assignment is handled by the method instead. The `customizer`
       * is invoked with five arguments: (objValue, srcValue, key, object, source).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @see _.assignInWith
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   return _.isUndefined(objValue) ? srcValue : objValue;
       * }
       *
       * var defaults = _.partialRight(_.assignWith, customizer);
       *
       * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */
      var assignWith = createAssigner(function(
        object,
        source,
        srcIndex,
        customizer
      ) {
        copyObject(source, keys(source), object, customizer);
      });

      /**
       * Creates an array of values corresponding to `paths` of `object`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Array} Returns the picked values.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
       *
       * _.at(object, ['a[0].b.c', 'a[1]']);
       * // => [3, 4]
       */
      var at = flatRest(baseAt);

      /**
       * Creates an object that inherits from the `prototype` object. If a
       * `properties` object is given, its own enumerable string keyed properties
       * are assigned to the created object.
       *
       * @static
       * @memberOf _
       * @since 2.3.0
       * @category Object
       * @param {Object} prototype The object to inherit from.
       * @param {Object} [properties] The properties to assign to the object.
       * @returns {Object} Returns the new object.
       * @example
       *
       * function Shape() {
       *   this.x = 0;
       *   this.y = 0;
       * }
       *
       * function Circle() {
       *   Shape.call(this);
       * }
       *
       * Circle.prototype = _.create(Shape.prototype, {
       *   'constructor': Circle
       * });
       *
       * var circle = new Circle;
       * circle instanceof Circle;
       * // => true
       *
       * circle instanceof Shape;
       * // => true
       */
      function create(prototype, properties) {
        var result = baseCreate(prototype);
        return properties == null ? result : baseAssign(result, properties);
      }

      /**
       * Assigns own and inherited enumerable string keyed properties of source
       * objects to the destination object for all destination properties that
       * resolve to `undefined`. Source objects are applied from left to right.
       * Once a property is set, additional values of the same property are ignored.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.defaultsDeep
       * @example
       *
       * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */
      var defaults = baseRest(function(object, sources) {
        object = Object(object);

        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }

        while (++index < length) {
          var source = sources[index];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;

          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];

            if (
              value === undefined$1 ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))
            ) {
              object[key] = source[key];
            }
          }
        }

        return object;
      });

      /**
       * This method is like `_.defaults` except that it recursively assigns
       * default properties.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.defaults
       * @example
       *
       * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
       * // => { 'a': { 'b': 2, 'c': 3 } }
       */
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });

      /**
       * This method is like `_.find` except that it returns the key of the first
       * element `predicate` returns truthy for instead of the element itself.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {string|undefined} Returns the key of the matched element,
       *  else `undefined`.
       * @example
       *
       * var users = {
       *   'barney':  { 'age': 36, 'active': true },
       *   'fred':    { 'age': 40, 'active': false },
       *   'pebbles': { 'age': 1,  'active': true }
       * };
       *
       * _.findKey(users, function(o) { return o.age < 40; });
       * // => 'barney' (iteration order is not guaranteed)
       *
       * // The `_.matches` iteratee shorthand.
       * _.findKey(users, { 'age': 1, 'active': true });
       * // => 'pebbles'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findKey(users, ['active', false]);
       * // => 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.findKey(users, 'active');
       * // => 'barney'
       */
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }

      /**
       * This method is like `_.findKey` except that it iterates over elements of
       * a collection in the opposite order.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {string|undefined} Returns the key of the matched element,
       *  else `undefined`.
       * @example
       *
       * var users = {
       *   'barney':  { 'age': 36, 'active': true },
       *   'fred':    { 'age': 40, 'active': false },
       *   'pebbles': { 'age': 1,  'active': true }
       * };
       *
       * _.findLastKey(users, function(o) { return o.age < 40; });
       * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
       *
       * // The `_.matches` iteratee shorthand.
       * _.findLastKey(users, { 'age': 36, 'active': true });
       * // => 'barney'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findLastKey(users, ['active', false]);
       * // => 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.findLastKey(users, 'active');
       * // => 'pebbles'
       */
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }

      /**
       * Iterates over own and inherited enumerable string keyed properties of an
       * object and invokes `iteratee` for each property. The iteratee is invoked
       * with three arguments: (value, key, object). Iteratee functions may exit
       * iteration early by explicitly returning `false`.
       *
       * @static
       * @memberOf _
       * @since 0.3.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forInRight
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forIn(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
       */
      function forIn(object, iteratee) {
        return object == null
          ? object
          : baseFor(object, getIteratee(iteratee, 3), keysIn);
      }

      /**
       * This method is like `_.forIn` except that it iterates over properties of
       * `object` in the opposite order.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forIn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forInRight(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
       */
      function forInRight(object, iteratee) {
        return object == null
          ? object
          : baseForRight(object, getIteratee(iteratee, 3), keysIn);
      }

      /**
       * Iterates over own enumerable string keyed properties of an object and
       * invokes `iteratee` for each property. The iteratee is invoked with three
       * arguments: (value, key, object). Iteratee functions may exit iteration
       * early by explicitly returning `false`.
       *
       * @static
       * @memberOf _
       * @since 0.3.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forOwnRight
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forOwn(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'a' then 'b' (iteration order is not guaranteed).
       */
      function forOwn(object, iteratee) {
        return object && baseForOwn(object, getIteratee(iteratee, 3));
      }

      /**
       * This method is like `_.forOwn` except that it iterates over properties of
       * `object` in the opposite order.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forOwn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forOwnRight(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
       */
      function forOwnRight(object, iteratee) {
        return object && baseForOwnRight(object, getIteratee(iteratee, 3));
      }

      /**
       * Creates an array of function property names from own enumerable properties
       * of `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to inspect.
       * @returns {Array} Returns the function names.
       * @see _.functionsIn
       * @example
       *
       * function Foo() {
       *   this.a = _.constant('a');
       *   this.b = _.constant('b');
       * }
       *
       * Foo.prototype.c = _.constant('c');
       *
       * _.functions(new Foo);
       * // => ['a', 'b']
       */
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }

      /**
       * Creates an array of function property names from own and inherited
       * enumerable properties of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @returns {Array} Returns the function names.
       * @see _.functions
       * @example
       *
       * function Foo() {
       *   this.a = _.constant('a');
       *   this.b = _.constant('b');
       * }
       *
       * Foo.prototype.c = _.constant('c');
       *
       * _.functionsIn(new Foo);
       * // => ['a', 'b', 'c']
       */
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }

      /**
       * Gets the value at `path` of `object`. If the resolved value is
       * `undefined`, the `defaultValue` is returned in its place.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @param {*} [defaultValue] The value returned for `undefined` resolved values.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.get(object, 'a[0].b.c');
       * // => 3
       *
       * _.get(object, ['a', '0', 'b', 'c']);
       * // => 3
       *
       * _.get(object, 'a.b.c', 'default');
       * // => 'default'
       */
      function get(object, path, defaultValue) {
        var result = object == null ? undefined$1 : baseGet(object, path);
        return result === undefined$1 ? defaultValue : result;
      }

      /**
       * Checks if `path` is a direct property of `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       * @example
       *
       * var object = { 'a': { 'b': 2 } };
       * var other = _.create({ 'a': _.create({ 'b': 2 }) });
       *
       * _.has(object, 'a');
       * // => true
       *
       * _.has(object, 'a.b');
       * // => true
       *
       * _.has(object, ['a', 'b']);
       * // => true
       *
       * _.has(other, 'a');
       * // => false
       */
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }

      /**
       * Checks if `path` is a direct or inherited property of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       * @example
       *
       * var object = _.create({ 'a': _.create({ 'b': 2 }) });
       *
       * _.hasIn(object, 'a');
       * // => true
       *
       * _.hasIn(object, 'a.b');
       * // => true
       *
       * _.hasIn(object, ['a', 'b']);
       * // => true
       *
       * _.hasIn(object, 'b');
       * // => false
       */
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }

      /**
       * Creates an object composed of the inverted keys and values of `object`.
       * If `object` contains duplicate values, subsequent values overwrite
       * property assignments of previous values.
       *
       * @static
       * @memberOf _
       * @since 0.7.0
       * @category Object
       * @param {Object} object The object to invert.
       * @returns {Object} Returns the new inverted object.
       * @example
       *
       * var object = { 'a': 1, 'b': 2, 'c': 1 };
       *
       * _.invert(object);
       * // => { '1': 'c', '2': 'b' }
       */
      var invert = createInverter(function(result, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }

        result[value] = key;
      }, constant(identity));

      /**
       * This method is like `_.invert` except that the inverted object is generated
       * from the results of running each element of `object` thru `iteratee`. The
       * corresponding inverted value of each inverted key is an array of keys
       * responsible for generating the inverted value. The iteratee is invoked
       * with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.1.0
       * @category Object
       * @param {Object} object The object to invert.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Object} Returns the new inverted object.
       * @example
       *
       * var object = { 'a': 1, 'b': 2, 'c': 1 };
       *
       * _.invertBy(object);
       * // => { '1': ['a', 'c'], '2': ['b'] }
       *
       * _.invertBy(object, function(value) {
       *   return 'group' + value;
       * });
       * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
       */
      var invertBy = createInverter(function(result, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }

        if (hasOwnProperty.call(result, value)) {
          result[value].push(key);
        } else {
          result[value] = [key];
        }
      }, getIteratee);

      /**
       * Invokes the method at `path` of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the method to invoke.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {*} Returns the result of the invoked method.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
       *
       * _.invoke(object, 'a[0].b.c.slice', 1, 3);
       * // => [2, 3]
       */
      var invoke = baseRest(baseInvoke);

      /**
       * Creates an array of the own enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects. See the
       * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * for more details.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keys(new Foo);
       * // => ['a', 'b'] (iteration order is not guaranteed)
       *
       * _.keys('hi');
       * // => ['0', '1']
       */
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }

      /**
       * Creates an array of the own and inherited enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keysIn(new Foo);
       * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
       */
      function keysIn(object) {
        return isArrayLike(object)
          ? arrayLikeKeys(object, true)
          : baseKeysIn(object);
      }

      /**
       * The opposite of `_.mapValues`; this method creates an object with the
       * same values as `object` and keys generated by running each own enumerable
       * string keyed property of `object` thru `iteratee`. The iteratee is invoked
       * with three arguments: (value, key, object).
       *
       * @static
       * @memberOf _
       * @since 3.8.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns the new mapped object.
       * @see _.mapValues
       * @example
       *
       * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
       *   return key + value;
       * });
       * // => { 'a1': 1, 'b2': 2 }
       */
      function mapKeys(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);

        baseForOwn(object, function(value, key, object) {
          baseAssignValue(result, iteratee(value, key, object), value);
        });
        return result;
      }

      /**
       * Creates an object with the same keys as `object` and values generated
       * by running each own enumerable string keyed property of `object` thru
       * `iteratee`. The iteratee is invoked with three arguments:
       * (value, key, object).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns the new mapped object.
       * @see _.mapKeys
       * @example
       *
       * var users = {
       *   'fred':    { 'user': 'fred',    'age': 40 },
       *   'pebbles': { 'user': 'pebbles', 'age': 1 }
       * };
       *
       * _.mapValues(users, function(o) { return o.age; });
       * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
       *
       * // The `_.property` iteratee shorthand.
       * _.mapValues(users, 'age');
       * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
       */
      function mapValues(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);

        baseForOwn(object, function(value, key, object) {
          baseAssignValue(result, key, iteratee(value, key, object));
        });
        return result;
      }

      /**
       * This method is like `_.assign` except that it recursively merges own and
       * inherited enumerable string keyed properties of source objects into the
       * destination object. Source properties that resolve to `undefined` are
       * skipped if a destination value exists. Array and plain object properties
       * are merged recursively. Other objects and value types are overridden by
       * assignment. Source objects are applied from left to right. Subsequent
       * sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {
       *   'a': [{ 'b': 2 }, { 'd': 4 }]
       * };
       *
       * var other = {
       *   'a': [{ 'c': 3 }, { 'e': 5 }]
       * };
       *
       * _.merge(object, other);
       * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
       */
      var merge = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });

      /**
       * This method is like `_.merge` except that it accepts `customizer` which
       * is invoked to produce the merged values of the destination and source
       * properties. If `customizer` returns `undefined`, merging is handled by the
       * method instead. The `customizer` is invoked with six arguments:
       * (objValue, srcValue, key, object, source, stack).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} customizer The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   if (_.isArray(objValue)) {
       *     return objValue.concat(srcValue);
       *   }
       * }
       *
       * var object = { 'a': [1], 'b': [2] };
       * var other = { 'a': [3], 'b': [4] };
       *
       * _.mergeWith(object, other, customizer);
       * // => { 'a': [1, 3], 'b': [2, 4] }
       */
      var mergeWith = createAssigner(function(
        object,
        source,
        srcIndex,
        customizer
      ) {
        baseMerge(object, source, srcIndex, customizer);
      });

      /**
       * The opposite of `_.pick`; this method creates an object composed of the
       * own and inherited enumerable property paths of `object` that are not omitted.
       *
       * **Note:** This method is considerably slower than `_.pick`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to omit.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omit(object, ['a', 'c']);
       * // => { 'b': '2' }
       */
      var omit = flatRest(function(object, paths) {
        var result = {};
        if (object == null) {
          return result;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result);
        if (isDeep) {
          result = baseClone(
            result,
            CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG,
            customOmitClone
          );
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result, paths[length]);
        }
        return result;
      });

      /**
       * The opposite of `_.pickBy`; this method creates an object composed of
       * the own and inherited enumerable string keyed properties of `object` that
       * `predicate` doesn't return truthy for. The predicate is invoked with two
       * arguments: (value, key).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The source object.
       * @param {Function} [predicate=_.identity] The function invoked per property.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omitBy(object, _.isNumber);
       * // => { 'b': '2' }
       */
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }

      /**
       * Creates an object composed of the picked `object` properties.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.pick(object, ['a', 'c']);
       * // => { 'a': 1, 'c': 3 }
       */
      var pick = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });

      /**
       * Creates an object composed of the `object` properties `predicate` returns
       * truthy for. The predicate is invoked with two arguments: (value, key).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The source object.
       * @param {Function} [predicate=_.identity] The function invoked per property.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.pickBy(object, _.isNumber);
       * // => { 'a': 1, 'c': 3 }
       */
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }

      /**
       * This method is like `_.get` except that if the resolved value is a
       * function it's invoked with the `this` binding of its parent object and
       * its result is returned.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to resolve.
       * @param {*} [defaultValue] The value returned for `undefined` resolved values.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
       *
       * _.result(object, 'a[0].b.c1');
       * // => 3
       *
       * _.result(object, 'a[0].b.c2');
       * // => 4
       *
       * _.result(object, 'a[0].b.c3', 'default');
       * // => 'default'
       *
       * _.result(object, 'a[0].b.c3', _.constant('default'));
       * // => 'default'
       */
      function result(object, path, defaultValue) {
        path = castPath(path, object);

        var index = -1,
          length = path.length;

        // Ensure the loop is entered when path is empty.
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index])];
          if (value === undefined$1) {
            index = length;
            value = defaultValue;
          }
          object = isFunction(value) ? value.call(object) : value;
        }
        return object;
      }

      /**
       * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
       * it's created. Arrays are created for missing index properties while objects
       * are created for all other missing properties. Use `_.setWith` to customize
       * `path` creation.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.set(object, 'a[0].b.c', 4);
       * console.log(object.a[0].b.c);
       * // => 4
       *
       * _.set(object, ['x', '0', 'y', 'z'], 5);
       * console.log(object.x[0].y.z);
       * // => 5
       */
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }

      /**
       * This method is like `_.set` except that it accepts `customizer` which is
       * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
       * path creation is handled by the method instead. The `customizer` is invoked
       * with three arguments: (nsValue, key, nsObject).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {};
       *
       * _.setWith(object, '[0][1]', 'a', Object);
       * // => { '0': { '1': 'a' } }
       */
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null
          ? object
          : baseSet(object, path, value, customizer);
      }

      /**
       * Creates an array of own enumerable string keyed-value pairs for `object`
       * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
       * entries are returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias entries
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the key-value pairs.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.toPairs(new Foo);
       * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
       */
      var toPairs = createToPairs(keys);

      /**
       * Creates an array of own and inherited enumerable string keyed-value pairs
       * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
       * or set, its entries are returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias entriesIn
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the key-value pairs.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.toPairsIn(new Foo);
       * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
       */
      var toPairsIn = createToPairs(keysIn);

      /**
       * An alternative to `_.reduce`; this method transforms `object` to a new
       * `accumulator` object which is the result of running each of its own
       * enumerable string keyed properties thru `iteratee`, with each invocation
       * potentially mutating the `accumulator` object. If `accumulator` is not
       * provided, a new object with the same `[[Prototype]]` will be used. The
       * iteratee is invoked with four arguments: (accumulator, value, key, object).
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * @static
       * @memberOf _
       * @since 1.3.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The custom accumulator value.
       * @returns {*} Returns the accumulated value.
       * @example
       *
       * _.transform([2, 3, 4], function(result, n) {
       *   result.push(n *= n);
       *   return n % 2 == 0;
       * }, []);
       * // => [4, 9]
       *
       * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
       *   (result[value] || (result[value] = [])).push(key);
       * }, {});
       * // => { '1': ['a', 'c'], '2': ['b'] }
       */
      function transform(object, iteratee, accumulator) {
        var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

        iteratee = getIteratee(iteratee, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject(object)) {
            accumulator = isFunction(Ctor)
              ? baseCreate(getPrototype(object))
              : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(
          value,
          index,
          object
        ) {
          return iteratee(accumulator, value, index, object);
        });
        return accumulator;
      }

      /**
       * Removes the property at `path` of `object`.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to unset.
       * @returns {boolean} Returns `true` if the property is deleted, else `false`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 7 } }] };
       * _.unset(object, 'a[0].b.c');
       * // => true
       *
       * console.log(object);
       * // => { 'a': [{ 'b': {} }] };
       *
       * _.unset(object, ['a', '0', 'b', 'c']);
       * // => true
       *
       * console.log(object);
       * // => { 'a': [{ 'b': {} }] };
       */
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }

      /**
       * This method is like `_.set` except that accepts `updater` to produce the
       * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
       * is invoked with one argument: (value).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.6.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {Function} updater The function to produce the updated value.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.update(object, 'a[0].b.c', function(n) { return n * n; });
       * console.log(object.a[0].b.c);
       * // => 9
       *
       * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
       * console.log(object.x[0].y.z);
       * // => 0
       */
      function update(object, path, updater) {
        return object == null
          ? object
          : baseUpdate(object, path, castFunction(updater));
      }

      /**
       * This method is like `_.update` except that it accepts `customizer` which is
       * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
       * path creation is handled by the method instead. The `customizer` is invoked
       * with three arguments: (nsValue, key, nsObject).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.6.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {Function} updater The function to produce the updated value.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {};
       *
       * _.updateWith(object, '[0][1]', _.constant('a'), Object);
       * // => { '0': { '1': 'a' } }
       */
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == "function" ? customizer : undefined$1;
        return object == null
          ? object
          : baseUpdate(object, path, castFunction(updater), customizer);
      }

      /**
       * Creates an array of the own enumerable string keyed property values of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property values.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.values(new Foo);
       * // => [1, 2] (iteration order is not guaranteed)
       *
       * _.values('hi');
       * // => ['h', 'i']
       */
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }

      /**
       * Creates an array of the own and inherited enumerable string keyed property
       * values of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property values.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.valuesIn(new Foo);
       * // => [1, 2, 3] (iteration order is not guaranteed)
       */
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }

      /*------------------------------------------------------------------------*/

      /**
       * Clamps `number` within the inclusive `lower` and `upper` bounds.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Number
       * @param {number} number The number to clamp.
       * @param {number} [lower] The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the clamped number.
       * @example
       *
       * _.clamp(-10, -5, 5);
       * // => -5
       *
       * _.clamp(10, -5, 5);
       * // => 5
       */
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }

      /**
       * Checks if `n` is between `start` and up to, but not including, `end`. If
       * `end` is not specified, it's set to `start` with `start` then set to `0`.
       * If `start` is greater than `end` the params are swapped to support
       * negative ranges.
       *
       * @static
       * @memberOf _
       * @since 3.3.0
       * @category Number
       * @param {number} number The number to check.
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
       * @see _.range, _.rangeRight
       * @example
       *
       * _.inRange(3, 2, 4);
       * // => true
       *
       * _.inRange(4, 8);
       * // => true
       *
       * _.inRange(4, 2);
       * // => false
       *
       * _.inRange(2, 2);
       * // => false
       *
       * _.inRange(1.2, 2);
       * // => true
       *
       * _.inRange(5.2, 4);
       * // => false
       *
       * _.inRange(-3, -2, -6);
       * // => true
       */
      function inRange(number, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number = toNumber(number);
        return baseInRange(number, start, end);
      }

      /**
       * Produces a random number between the inclusive `lower` and `upper` bounds.
       * If only one argument is provided a number between `0` and the given number
       * is returned. If `floating` is `true`, or either `lower` or `upper` are
       * floats, a floating-point number is returned instead of an integer.
       *
       * **Note:** JavaScript follows the IEEE-754 standard for resolving
       * floating-point values which can produce unexpected results.
       *
       * @static
       * @memberOf _
       * @since 0.7.0
       * @category Number
       * @param {number} [lower=0] The lower bound.
       * @param {number} [upper=1] The upper bound.
       * @param {boolean} [floating] Specify returning a floating-point number.
       * @returns {number} Returns the random number.
       * @example
       *
       * _.random(0, 5);
       * // => an integer between 0 and 5
       *
       * _.random(5);
       * // => also an integer between 0 and 5
       *
       * _.random(5, true);
       * // => a floating-point number between 0 and 5
       *
       * _.random(1.2, 5.2);
       * // => a floating-point number between 1.2 and 5.2
       */
      function random(lower, upper, floating) {
        if (
          floating &&
          typeof floating != "boolean" &&
          isIterateeCall(lower, upper, floating)
        ) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == "boolean") {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == "boolean") {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(
            lower +
              rand *
                (upper -
                  lower +
                  freeParseFloat("1e-" + ((rand + "").length - 1))),
            upper
          );
        }
        return baseRandom(lower, upper);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the camel cased string.
       * @example
       *
       * _.camelCase('Foo Bar');
       * // => 'fooBar'
       *
       * _.camelCase('--foo-bar--');
       * // => 'fooBar'
       *
       * _.camelCase('__FOO_BAR__');
       * // => 'fooBar'
       */
      var camelCase = createCompounder(function(result, word, index) {
        word = word.toLowerCase();
        return result + (index ? capitalize(word) : word);
      });

      /**
       * Converts the first character of `string` to upper case and the remaining
       * to lower case.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to capitalize.
       * @returns {string} Returns the capitalized string.
       * @example
       *
       * _.capitalize('FRED');
       * // => 'Fred'
       */
      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }

      /**
       * Deburrs `string` by converting
       * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
       * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
       * letters to basic Latin letters and removing
       * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to deburr.
       * @returns {string} Returns the deburred string.
       * @example
       *
       * _.deburr('déjà vu');
       * // => 'deja vu'
       */
      function deburr(string) {
        string = toString(string);
        return (
          string &&
          string.replace(reLatin, deburrLetter).replace(reComboMark, "")
        );
      }

      /**
       * Checks if `string` ends with the given target string.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {string} [target] The string to search for.
       * @param {number} [position=string.length] The position to search up to.
       * @returns {boolean} Returns `true` if `string` ends with `target`,
       *  else `false`.
       * @example
       *
       * _.endsWith('abc', 'c');
       * // => true
       *
       * _.endsWith('abc', 'b');
       * // => false
       *
       * _.endsWith('abc', 'b', 2);
       * // => true
       */
      function endsWith(string, target, position) {
        string = toString(string);
        target = baseToString(target);

        var length = string.length;
        position =
          position === undefined$1
            ? length
            : baseClamp(toInteger(position), 0, length);

        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }

      /**
       * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
       * corresponding HTML entities.
       *
       * **Note:** No other characters are escaped. To escape additional
       * characters use a third-party library like [_he_](https://mths.be/he).
       *
       * Though the ">" character is escaped for symmetry, characters like
       * ">" and "/" don't need escaping in HTML and have no special meaning
       * unless they're part of a tag or unquoted attribute value. See
       * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
       * (under "semi-related fun fact") for more details.
       *
       * When working with HTML you should always
       * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
       * XSS vectors.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category String
       * @param {string} [string=''] The string to escape.
       * @returns {string} Returns the escaped string.
       * @example
       *
       * _.escape('fred, barney, & pebbles');
       * // => 'fred, barney, &amp; pebbles'
       */
      function escape(string) {
        string = toString(string);
        return string && reHasUnescapedHtml.test(string)
          ? string.replace(reUnescapedHtml, escapeHtmlChar)
          : string;
      }

      /**
       * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
       * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to escape.
       * @returns {string} Returns the escaped string.
       * @example
       *
       * _.escapeRegExp('[lodash](https://lodash.com/)');
       * // => '\[lodash\]\(https://lodash\.com/\)'
       */
      function escapeRegExp(string) {
        string = toString(string);
        return string && reHasRegExpChar.test(string)
          ? string.replace(reRegExpChar, "\\$&")
          : string;
      }

      /**
       * Converts `string` to
       * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the kebab cased string.
       * @example
       *
       * _.kebabCase('Foo Bar');
       * // => 'foo-bar'
       *
       * _.kebabCase('fooBar');
       * // => 'foo-bar'
       *
       * _.kebabCase('__FOO_BAR__');
       * // => 'foo-bar'
       */
      var kebabCase = createCompounder(function(result, word, index) {
        return result + (index ? "-" : "") + word.toLowerCase();
      });

      /**
       * Converts `string`, as space separated words, to lower case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the lower cased string.
       * @example
       *
       * _.lowerCase('--Foo-Bar--');
       * // => 'foo bar'
       *
       * _.lowerCase('fooBar');
       * // => 'foo bar'
       *
       * _.lowerCase('__FOO_BAR__');
       * // => 'foo bar'
       */
      var lowerCase = createCompounder(function(result, word, index) {
        return result + (index ? " " : "") + word.toLowerCase();
      });

      /**
       * Converts the first character of `string` to lower case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.lowerFirst('Fred');
       * // => 'fred'
       *
       * _.lowerFirst('FRED');
       * // => 'fRED'
       */
      var lowerFirst = createCaseFirst("toLowerCase");

      /**
       * Pads `string` on the left and right sides if it's shorter than `length`.
       * Padding characters are truncated if they can't be evenly divided by `length`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to pad.
       * @param {number} [length=0] The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padded string.
       * @example
       *
       * _.pad('abc', 8);
       * // => '  abc   '
       *
       * _.pad('abc', 8, '_-');
       * // => '_-abc_-_'
       *
       * _.pad('abc', 3);
       * // => 'abc'
       */
      function pad(string, length, chars) {
        string = toString(string);
        length = toInteger(length);

        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return (
          createPadding(nativeFloor(mid), chars) +
          string +
          createPadding(nativeCeil(mid), chars)
        );
      }

      /**
       * Pads `string` on the right side if it's shorter than `length`. Padding
       * characters are truncated if they exceed `length`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to pad.
       * @param {number} [length=0] The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padded string.
       * @example
       *
       * _.padEnd('abc', 6);
       * // => 'abc   '
       *
       * _.padEnd('abc', 6, '_-');
       * // => 'abc_-_'
       *
       * _.padEnd('abc', 3);
       * // => 'abc'
       */
      function padEnd(string, length, chars) {
        string = toString(string);
        length = toInteger(length);

        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length
          ? string + createPadding(length - strLength, chars)
          : string;
      }

      /**
       * Pads `string` on the left side if it's shorter than `length`. Padding
       * characters are truncated if they exceed `length`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to pad.
       * @param {number} [length=0] The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padded string.
       * @example
       *
       * _.padStart('abc', 6);
       * // => '   abc'
       *
       * _.padStart('abc', 6, '_-');
       * // => '_-_abc'
       *
       * _.padStart('abc', 3);
       * // => 'abc'
       */
      function padStart(string, length, chars) {
        string = toString(string);
        length = toInteger(length);

        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length
          ? createPadding(length - strLength, chars) + string
          : string;
      }

      /**
       * Converts `string` to an integer of the specified radix. If `radix` is
       * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
       * hexadecimal, in which case a `radix` of `16` is used.
       *
       * **Note:** This method aligns with the
       * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category String
       * @param {string} string The string to convert.
       * @param {number} [radix=10] The radix to interpret `value` by.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.parseInt('08');
       * // => 8
       *
       * _.map(['6', '08', '10'], _.parseInt);
       * // => [6, 8, 10]
       */
      function parseInt(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(
          toString(string).replace(reTrimStart, ""),
          radix || 0
        );
      }

      /**
       * Repeats the given string `n` times.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to repeat.
       * @param {number} [n=1] The number of times to repeat the string.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the repeated string.
       * @example
       *
       * _.repeat('*', 3);
       * // => '***'
       *
       * _.repeat('abc', 2);
       * // => 'abcabc'
       *
       * _.repeat('abc', 0);
       * // => ''
       */
      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString(string), n);
      }

      /**
       * Replaces matches for `pattern` in `string` with `replacement`.
       *
       * **Note:** This method is based on
       * [`String#replace`](https://mdn.io/String/replace).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to modify.
       * @param {RegExp|string} pattern The pattern to replace.
       * @param {Function|string} replacement The match replacement.
       * @returns {string} Returns the modified string.
       * @example
       *
       * _.replace('Hi Fred', 'Fred', 'Barney');
       * // => 'Hi Barney'
       */
      function replace() {
        var args = arguments,
          string = toString(args[0]);

        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }

      /**
       * Converts `string` to
       * [snake case](https://en.wikipedia.org/wiki/Snake_case).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the snake cased string.
       * @example
       *
       * _.snakeCase('Foo Bar');
       * // => 'foo_bar'
       *
       * _.snakeCase('fooBar');
       * // => 'foo_bar'
       *
       * _.snakeCase('--FOO-BAR--');
       * // => 'foo_bar'
       */
      var snakeCase = createCompounder(function(result, word, index) {
        return result + (index ? "_" : "") + word.toLowerCase();
      });

      /**
       * Splits `string` by `separator`.
       *
       * **Note:** This method is based on
       * [`String#split`](https://mdn.io/String/split).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to split.
       * @param {RegExp|string} separator The separator pattern to split by.
       * @param {number} [limit] The length to truncate results to.
       * @returns {Array} Returns the string segments.
       * @example
       *
       * _.split('a-b-c', '-', 2);
       * // => ['a', 'b']
       */
      function split(string, separator, limit) {
        if (
          limit &&
          typeof limit != "number" &&
          isIterateeCall(string, separator, limit)
        ) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString(string);
        if (
          string &&
          (typeof separator == "string" ||
            (separator != null && !isRegExp(separator)))
        ) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }

      /**
       * Converts `string` to
       * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
       *
       * @static
       * @memberOf _
       * @since 3.1.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the start cased string.
       * @example
       *
       * _.startCase('--foo-bar--');
       * // => 'Foo Bar'
       *
       * _.startCase('fooBar');
       * // => 'Foo Bar'
       *
       * _.startCase('__FOO_BAR__');
       * // => 'FOO BAR'
       */
      var startCase = createCompounder(function(result, word, index) {
        return result + (index ? " " : "") + upperFirst(word);
      });

      /**
       * Checks if `string` starts with the given target string.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {string} [target] The string to search for.
       * @param {number} [position=0] The position to search from.
       * @returns {boolean} Returns `true` if `string` starts with `target`,
       *  else `false`.
       * @example
       *
       * _.startsWith('abc', 'a');
       * // => true
       *
       * _.startsWith('abc', 'b');
       * // => false
       *
       * _.startsWith('abc', 'b', 1);
       * // => true
       */
      function startsWith(string, target, position) {
        string = toString(string);
        position =
          position == null
            ? 0
            : baseClamp(toInteger(position), 0, string.length);

        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }

      /**
       * Creates a compiled template function that can interpolate data properties
       * in "interpolate" delimiters, HTML-escape interpolated data properties in
       * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
       * properties may be accessed as free variables in the template. If a setting
       * object is given, it takes precedence over `_.templateSettings` values.
       *
       * **Note:** In the development build `_.template` utilizes
       * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
       * for easier debugging.
       *
       * For more information on precompiling templates see
       * [lodash's custom builds documentation](https://lodash.com/custom-builds).
       *
       * For more information on Chrome extension sandboxes see
       * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category String
       * @param {string} [string=''] The template string.
       * @param {Object} [options={}] The options object.
       * @param {RegExp} [options.escape=_.templateSettings.escape]
       *  The HTML "escape" delimiter.
       * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
       *  The "evaluate" delimiter.
       * @param {Object} [options.imports=_.templateSettings.imports]
       *  An object to import into the template as free variables.
       * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
       *  The "interpolate" delimiter.
       * @param {string} [options.sourceURL='lodash.templateSources[n]']
       *  The sourceURL of the compiled template.
       * @param {string} [options.variable='obj']
       *  The data object variable name.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the compiled template function.
       * @example
       *
       * // Use the "interpolate" delimiter to create a compiled template.
       * var compiled = _.template('hello <%= user %>!');
       * compiled({ 'user': 'fred' });
       * // => 'hello fred!'
       *
       * // Use the HTML "escape" delimiter to escape data property values.
       * var compiled = _.template('<b><%- value %></b>');
       * compiled({ 'value': '<script>' });
       * // => '<b>&lt;script&gt;</b>'
       *
       * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
       * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
       * compiled({ 'users': ['fred', 'barney'] });
       * // => '<li>fred</li><li>barney</li>'
       *
       * // Use the internal `print` function in "evaluate" delimiters.
       * var compiled = _.template('<% print("hello " + user); %>!');
       * compiled({ 'user': 'barney' });
       * // => 'hello barney!'
       *
       * // Use the ES template literal delimiter as an "interpolate" delimiter.
       * // Disable support by replacing the "interpolate" delimiter.
       * var compiled = _.template('hello ${ user }!');
       * compiled({ 'user': 'pebbles' });
       * // => 'hello pebbles!'
       *
       * // Use backslashes to treat delimiters as plain text.
       * var compiled = _.template('<%= "\\<%- value %\\>" %>');
       * compiled({ 'value': 'ignored' });
       * // => '<%- value %>'
       *
       * // Use the `imports` option to import `jQuery` as `jq`.
       * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
       * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
       * compiled({ 'users': ['fred', 'barney'] });
       * // => '<li>fred</li><li>barney</li>'
       *
       * // Use the `sourceURL` option to specify a custom sourceURL for the template.
       * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
       * compiled(data);
       * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
       *
       * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
       * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
       * compiled.source;
       * // => function(data) {
       * //   var __t, __p = '';
       * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
       * //   return __p;
       * // }
       *
       * // Use custom template delimiters.
       * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
       * var compiled = _.template('hello {{ user }}!');
       * compiled({ 'user': 'mustache' });
       * // => 'hello mustache!'
       *
       * // Use the `source` property to inline compiled templates for meaningful
       * // line numbers in error messages and stack traces.
       * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
       *   var JST = {\
       *     "main": ' + _.template(mainText).source + '\
       *   };\
       * ');
       */
      function template(string, options, guard) {
        // Based on John Resig's `tmpl` implementation
        // (http://ejohn.org/blog/javascript-micro-templating/)
        // and Laura Doktorova's doT.js (https://github.com/olado/doT).
        var settings = lodash.templateSettings;

        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);

        var imports = assignInWith(
            {},
            options.imports,
            settings.imports,
            customDefaultsAssignIn
          ),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

        var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

        // Compile the regexp to match each delimiter.
        var reDelimiters = RegExp(
          (options.escape || reNoMatch).source +
            "|" +
            interpolate.source +
            "|" +
            (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source +
            "|" +
            (options.evaluate || reNoMatch).source +
            "|$",
          "g"
        );

        // Use a sourceURL for easier debugging.
        // The sourceURL gets injected into the source that's eval-ed, so be careful
        // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
        // and escape the comment, thus injecting code that gets evaled.
        var sourceURL =
          "//# sourceURL=" +
          (hasOwnProperty.call(options, "sourceURL")
            ? (options.sourceURL + "").replace(/\s/g, " ")
            : "lodash.templateSources[" + ++templateCounter + "]") +
          "\n";

        string.replace(reDelimiters, function(
          match,
          escapeValue,
          interpolateValue,
          esTemplateValue,
          evaluateValue,
          offset
        ) {
          interpolateValue || (interpolateValue = esTemplateValue);

          // Escape characters that can't be included in string literals.
          source += string
            .slice(index, offset)
            .replace(reUnescapedString, escapeStringChar);

          // Replace delimiters with snippets.
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source +=
              "' +\n((__t = (" +
              interpolateValue +
              ")) == null ? '' : __t) +\n'";
          }
          index = offset + match.length;

          // The JS engine embedded in Adobe products needs `match` returned in
          // order to produce the correct `offset` value.
          return match;
        });

        source += "';\n";

        // If `variable` is not specified wrap a with-statement around the generated
        // code to add the data object to the top of the scope chain.
        var variable =
          hasOwnProperty.call(options, "variable") && options.variable;
        if (!variable) {
          source = "with (obj) {\n" + source + "\n}\n";
        }
        // Throw an error if a forbidden character was found in `variable`, to prevent
        // potential command injection attacks.
        else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
        }

        // Cleanup code by stripping empty strings.
        source = (isEvaluating
          ? source.replace(reEmptyStringLeading, "")
          : source
        )
          .replace(reEmptyStringMiddle, "$1")
          .replace(reEmptyStringTrailing, "$1;");

        // Frame code as the function body.
        source =
          "function(" +
          (variable || "obj") +
          ") {\n" +
          (variable ? "" : "obj || (obj = {});\n") +
          "var __t, __p = ''" +
          (isEscaping ? ", __e = _.escape" : "") +
          (isEvaluating
            ? ", __j = Array.prototype.join;\n" +
              "function print() { __p += __j.call(arguments, '') }\n"
            : ";\n") +
          source +
          "return __p\n}";

        var result = attempt(function() {
          return Function(importsKeys, sourceURL + "return " + source).apply(
            undefined$1,
            importsValues
          );
        });

        // Provide the compiled function's source by its `toString` method or
        // the `source` property as a convenience for inlining compiled templates.
        result.source = source;
        if (isError(result)) {
          throw result;
        }
        return result;
      }

      /**
       * Converts `string`, as a whole, to lower case just like
       * [String#toLowerCase](https://mdn.io/toLowerCase).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the lower cased string.
       * @example
       *
       * _.toLower('--Foo-Bar--');
       * // => '--foo-bar--'
       *
       * _.toLower('fooBar');
       * // => 'foobar'
       *
       * _.toLower('__FOO_BAR__');
       * // => '__foo_bar__'
       */
      function toLower(value) {
        return toString(value).toLowerCase();
      }

      /**
       * Converts `string`, as a whole, to upper case just like
       * [String#toUpperCase](https://mdn.io/toUpperCase).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the upper cased string.
       * @example
       *
       * _.toUpper('--foo-bar--');
       * // => '--FOO-BAR--'
       *
       * _.toUpper('fooBar');
       * // => 'FOOBAR'
       *
       * _.toUpper('__foo_bar__');
       * // => '__FOO_BAR__'
       */
      function toUpper(value) {
        return toString(value).toUpperCase();
      }

      /**
       * Removes leading and trailing whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trim('  abc  ');
       * // => 'abc'
       *
       * _.trim('-_-abc-_-', '_-');
       * // => 'abc'
       *
       * _.map(['  foo  ', '  bar  '], _.trim);
       * // => ['foo', 'bar']
       */
      function trim(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

        return castSlice(strSymbols, start, end).join("");
      }

      /**
       * Removes trailing whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trimEnd('  abc  ');
       * // => '  abc'
       *
       * _.trimEnd('-_-abc-_-', '_-');
       * // => '-_-abc'
       */
      function trimEnd(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

        return castSlice(strSymbols, 0, end).join("");
      }

      /**
       * Removes leading whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trimStart('  abc  ');
       * // => 'abc  '
       *
       * _.trimStart('-_-abc-_-', '_-');
       * // => 'abc-_-'
       */
      function trimStart(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, "");
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

        return castSlice(strSymbols, start).join("");
      }

      /**
       * Truncates `string` if it's longer than the given maximum string length.
       * The last characters of the truncated string are replaced with the omission
       * string which defaults to "...".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to truncate.
       * @param {Object} [options={}] The options object.
       * @param {number} [options.length=30] The maximum string length.
       * @param {string} [options.omission='...'] The string to indicate text is omitted.
       * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
       * @returns {string} Returns the truncated string.
       * @example
       *
       * _.truncate('hi-diddly-ho there, neighborino');
       * // => 'hi-diddly-ho there, neighbo...'
       *
       * _.truncate('hi-diddly-ho there, neighborino', {
       *   'length': 24,
       *   'separator': ' '
       * });
       * // => 'hi-diddly-ho there,...'
       *
       * _.truncate('hi-diddly-ho there, neighborino', {
       *   'length': 24,
       *   'separator': /,? +/
       * });
       * // => 'hi-diddly-ho there...'
       *
       * _.truncate('hi-diddly-ho there, neighborino', {
       *   'omission': ' [...]'
       * });
       * // => 'hi-diddly-ho there, neig [...]'
       */
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

        if (isObject(options)) {
          var separator =
            "separator" in options ? options.separator : separator;
          length = "length" in options ? toInteger(options.length) : length;
          omission =
            "omission" in options ? baseToString(options.omission) : omission;
        }
        string = toString(string);

        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result = strSymbols
          ? castSlice(strSymbols, 0, end).join("")
          : string.slice(0, end);

        if (separator === undefined$1) {
          return result + omission;
        }
        if (strSymbols) {
          end += result.length - end;
        }
        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match,
              substring = result;

            if (!separator.global) {
              separator = RegExp(
                separator.source,
                toString(reFlags.exec(separator)) + "g"
              );
            }
            separator.lastIndex = 0;
            while ((match = separator.exec(substring))) {
              var newEnd = match.index;
            }
            result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index = result.lastIndexOf(separator);
          if (index > -1) {
            result = result.slice(0, index);
          }
        }
        return result + omission;
      }

      /**
       * The inverse of `_.escape`; this method converts the HTML entities
       * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
       * their corresponding characters.
       *
       * **Note:** No other HTML entities are unescaped. To unescape additional
       * HTML entities use a third-party library like [_he_](https://mths.be/he).
       *
       * @static
       * @memberOf _
       * @since 0.6.0
       * @category String
       * @param {string} [string=''] The string to unescape.
       * @returns {string} Returns the unescaped string.
       * @example
       *
       * _.unescape('fred, barney, &amp; pebbles');
       * // => 'fred, barney, & pebbles'
       */
      function unescape(string) {
        string = toString(string);
        return string && reHasEscapedHtml.test(string)
          ? string.replace(reEscapedHtml, unescapeHtmlChar)
          : string;
      }

      /**
       * Converts `string`, as space separated words, to upper case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the upper cased string.
       * @example
       *
       * _.upperCase('--foo-bar');
       * // => 'FOO BAR'
       *
       * _.upperCase('fooBar');
       * // => 'FOO BAR'
       *
       * _.upperCase('__foo_bar__');
       * // => 'FOO BAR'
       */
      var upperCase = createCompounder(function(result, word, index) {
        return result + (index ? " " : "") + word.toUpperCase();
      });

      /**
       * Converts the first character of `string` to upper case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.upperFirst('fred');
       * // => 'Fred'
       *
       * _.upperFirst('FRED');
       * // => 'FRED'
       */
      var upperFirst = createCaseFirst("toUpperCase");

      /**
       * Splits `string` into an array of its words.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {RegExp|string} [pattern] The pattern to match words.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the words of `string`.
       * @example
       *
       * _.words('fred, barney, & pebbles');
       * // => ['fred', 'barney', 'pebbles']
       *
       * _.words('fred, barney, & pebbles', /[^, ]+/g);
       * // => ['fred', 'barney', '&', 'pebbles']
       */
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$1 : pattern;

        if (pattern === undefined$1) {
          return hasUnicodeWord(string)
            ? unicodeWords(string)
            : asciiWords(string);
        }
        return string.match(pattern) || [];
      }

      /*------------------------------------------------------------------------*/

      /**
       * Attempts to invoke `func`, returning either the result or the caught error
       * object. Any additional arguments are provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {Function} func The function to attempt.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {*} Returns the `func` result or error object.
       * @example
       *
       * // Avoid throwing errors for invalid selectors.
       * var elements = _.attempt(function(selector) {
       *   return document.querySelectorAll(selector);
       * }, '>_>');
       *
       * if (_.isError(elements)) {
       *   elements = [];
       * }
       */
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error(e);
        }
      });

      /**
       * Binds methods of an object to the object itself, overwriting the existing
       * method.
       *
       * **Note:** This method doesn't set the "length" property of bound functions.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {Object} object The object to bind and assign the bound methods to.
       * @param {...(string|string[])} methodNames The object method names to bind.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var view = {
       *   'label': 'docs',
       *   'click': function() {
       *     console.log('clicked ' + this.label);
       *   }
       * };
       *
       * _.bindAll(view, ['click']);
       * jQuery(element).on('click', view.click);
       * // => Logs 'clicked docs' when clicked.
       */
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });

      /**
       * Creates a function that iterates over `pairs` and invokes the corresponding
       * function of the first predicate to return truthy. The predicate-function
       * pairs are invoked with the `this` binding and arguments of the created
       * function.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {Array} pairs The predicate-function pairs.
       * @returns {Function} Returns the new composite function.
       * @example
       *
       * var func = _.cond([
       *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
       *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
       *   [_.stubTrue,                      _.constant('no match')]
       * ]);
       *
       * func({ 'a': 1, 'b': 2 });
       * // => 'matches A'
       *
       * func({ 'a': 0, 'b': 1 });
       * // => 'matches B'
       *
       * func({ 'a': '1', 'b': '2' });
       * // => 'no match'
       */
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

        pairs = !length
          ? []
          : arrayMap(pairs, function(pair) {
              if (typeof pair[1] != "function") {
                throw new TypeError(FUNC_ERROR_TEXT);
              }
              return [toIteratee(pair[0]), pair[1]];
            });

        return baseRest(function(args) {
          var index = -1;
          while (++index < length) {
            var pair = pairs[index];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }

      /**
       * Creates a function that invokes the predicate properties of `source` with
       * the corresponding property values of a given object, returning `true` if
       * all predicates return truthy, else `false`.
       *
       * **Note:** The created function is equivalent to `_.conformsTo` with
       * `source` partially applied.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {Object} source The object of property predicates to conform to.
       * @returns {Function} Returns the new spec function.
       * @example
       *
       * var objects = [
       *   { 'a': 2, 'b': 1 },
       *   { 'a': 1, 'b': 2 }
       * ];
       *
       * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
       * // => [{ 'a': 1, 'b': 2 }]
       */
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that returns `value`.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Util
       * @param {*} value The value to return from the new function.
       * @returns {Function} Returns the new constant function.
       * @example
       *
       * var objects = _.times(2, _.constant({ 'a': 1 }));
       *
       * console.log(objects);
       * // => [{ 'a': 1 }, { 'a': 1 }]
       *
       * console.log(objects[0] === objects[1]);
       * // => true
       */
      function constant(value) {
        return function() {
          return value;
        };
      }

      /**
       * Checks `value` to determine whether a default value should be returned in
       * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
       * or `undefined`.
       *
       * @static
       * @memberOf _
       * @since 4.14.0
       * @category Util
       * @param {*} value The value to check.
       * @param {*} defaultValue The default value.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * _.defaultTo(1, 10);
       * // => 1
       *
       * _.defaultTo(undefined, 10);
       * // => 10
       */
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }

      /**
       * Creates a function that returns the result of invoking the given functions
       * with the `this` binding of the created function, where each successive
       * invocation is supplied the return value of the previous.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {...(Function|Function[])} [funcs] The functions to invoke.
       * @returns {Function} Returns the new composite function.
       * @see _.flowRight
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var addSquare = _.flow([_.add, square]);
       * addSquare(1, 2);
       * // => 9
       */
      var flow = createFlow();

      /**
       * This method is like `_.flow` except that it creates a function that
       * invokes the given functions from right to left.
       *
       * @static
       * @since 3.0.0
       * @memberOf _
       * @category Util
       * @param {...(Function|Function[])} [funcs] The functions to invoke.
       * @returns {Function} Returns the new composite function.
       * @see _.flow
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var addSquare = _.flowRight([square, _.add]);
       * addSquare(1, 2);
       * // => 9
       */
      var flowRight = createFlow(true);

      /**
       * This method returns the first argument it receives.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {*} value Any value.
       * @returns {*} Returns `value`.
       * @example
       *
       * var object = { 'a': 1 };
       *
       * console.log(_.identity(object) === object);
       * // => true
       */
      function identity(value) {
        return value;
      }

      /**
       * Creates a function that invokes `func` with the arguments of the created
       * function. If `func` is a property name, the created function returns the
       * property value for a given element. If `func` is an array or object, the
       * created function returns `true` for elements that contain the equivalent
       * source properties, otherwise it returns `false`.
       *
       * @static
       * @since 4.0.0
       * @memberOf _
       * @category Util
       * @param {*} [func=_.identity] The value to convert to a callback.
       * @returns {Function} Returns the callback.
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': true },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
       * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.filter(users, _.iteratee(['user', 'fred']));
       * // => [{ 'user': 'fred', 'age': 40 }]
       *
       * // The `_.property` iteratee shorthand.
       * _.map(users, _.iteratee('user'));
       * // => ['barney', 'fred']
       *
       * // Create custom iteratee shorthands.
       * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
       *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
       *     return func.test(string);
       *   };
       * });
       *
       * _.filter(['abc', 'def'], /ef/);
       * // => ['def']
       */
      function iteratee(func) {
        return baseIteratee(
          typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG)
        );
      }

      /**
       * Creates a function that performs a partial deep comparison between a given
       * object and `source`, returning `true` if the given object has equivalent
       * property values, else `false`.
       *
       * **Note:** The created function is equivalent to `_.isMatch` with `source`
       * partially applied.
       *
       * Partial comparisons will match empty array and empty object `source`
       * values against any array or object value, respectively. See `_.isEqual`
       * for a list of supported value comparisons.
       *
       * **Note:** Multiple values can be checked by combining several matchers
       * using `_.overSome`
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {Object} source The object of property values to match.
       * @returns {Function} Returns the new spec function.
       * @example
       *
       * var objects = [
       *   { 'a': 1, 'b': 2, 'c': 3 },
       *   { 'a': 4, 'b': 5, 'c': 6 }
       * ];
       *
       * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
       * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
       *
       * // Checking for several possible values
       * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
       * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
       */
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that performs a partial deep comparison between the
       * value at `path` of a given object to `srcValue`, returning `true` if the
       * object value is equivalent, else `false`.
       *
       * **Note:** Partial comparisons will match empty array and empty object
       * `srcValue` values against any array or object value, respectively. See
       * `_.isEqual` for a list of supported value comparisons.
       *
       * **Note:** Multiple values can be checked by combining several matchers
       * using `_.overSome`
       *
       * @static
       * @memberOf _
       * @since 3.2.0
       * @category Util
       * @param {Array|string} path The path of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       * @example
       *
       * var objects = [
       *   { 'a': 1, 'b': 2, 'c': 3 },
       *   { 'a': 4, 'b': 5, 'c': 6 }
       * ];
       *
       * _.find(objects, _.matchesProperty('a', 4));
       * // => { 'a': 4, 'b': 5, 'c': 6 }
       *
       * // Checking for several possible values
       * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
       * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
       */
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that invokes the method at `path` of a given object.
       * Any additional arguments are provided to the invoked method.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Util
       * @param {Array|string} path The path of the method to invoke.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {Function} Returns the new invoker function.
       * @example
       *
       * var objects = [
       *   { 'a': { 'b': _.constant(2) } },
       *   { 'a': { 'b': _.constant(1) } }
       * ];
       *
       * _.map(objects, _.method('a.b'));
       * // => [2, 1]
       *
       * _.map(objects, _.method(['a', 'b']));
       * // => [2, 1]
       */
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });

      /**
       * The opposite of `_.method`; this method creates a function that invokes
       * the method at a given path of `object`. Any additional arguments are
       * provided to the invoked method.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Util
       * @param {Object} object The object to query.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {Function} Returns the new invoker function.
       * @example
       *
       * var array = _.times(3, _.constant),
       *     object = { 'a': array, 'b': array, 'c': array };
       *
       * _.map(['a[2]', 'c[0]'], _.methodOf(object));
       * // => [2, 0]
       *
       * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
       * // => [2, 0]
       */
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });

      /**
       * Adds all own enumerable string keyed function properties of a source
       * object to the destination object. If `object` is a function, then methods
       * are added to its prototype as well.
       *
       * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
       * avoid conflicts caused by modifying the original.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {Function|Object} [object=lodash] The destination object.
       * @param {Object} source The object of functions to add.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
       * @returns {Function|Object} Returns `object`.
       * @example
       *
       * function vowels(string) {
       *   return _.filter(string, function(v) {
       *     return /[aeiou]/i.test(v);
       *   });
       * }
       *
       * _.mixin({ 'vowels': vowels });
       * _.vowels('fred');
       * // => ['e']
       *
       * _('fred').vowels().value();
       * // => ['e']
       *
       * _.mixin({ 'vowels': vowels }, { 'chain': false });
       * _('fred').vowels();
       * // => ['e']
       */
      function mixin(object, source, options) {
        var props = keys(source),
          methodNames = baseFunctions(source, props);

        if (
          options == null &&
          !(isObject(source) && (methodNames.length || !props.length))
        ) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain =
            !(isObject(options) && "chain" in options) || !!options.chain,
          isFunc = isFunction(object);

        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                  actions = (result.__actions__ = copyArray(this.__actions__));

                actions.push({ func: func, args: arguments, thisArg: object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });

        return object;
      }

      /**
       * Reverts the `_` variable to its previous value and returns a reference to
       * the `lodash` function.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @returns {Function} Returns the `lodash` function.
       * @example
       *
       * var lodash = _.noConflict();
       */
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }

      /**
       * This method returns `undefined`.
       *
       * @static
       * @memberOf _
       * @since 2.3.0
       * @category Util
       * @example
       *
       * _.times(2, _.noop);
       * // => [undefined, undefined]
       */
      function noop() {
        // No operation performed.
      }

      /**
       * Creates a function that gets the argument at index `n`. If `n` is negative,
       * the nth argument from the end is returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {number} [n=0] The index of the argument to return.
       * @returns {Function} Returns the new pass-thru function.
       * @example
       *
       * var func = _.nthArg(1);
       * func('a', 'b', 'c', 'd');
       * // => 'b'
       *
       * var func = _.nthArg(-2);
       * func('a', 'b', 'c', 'd');
       * // => 'c'
       */
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function(args) {
          return baseNth(args, n);
        });
      }

      /**
       * Creates a function that invokes `iteratees` with the arguments it receives
       * and returns their results.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {...(Function|Function[])} [iteratees=[_.identity]]
       *  The iteratees to invoke.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var func = _.over([Math.max, Math.min]);
       *
       * func(1, 2, 3, 4);
       * // => [4, 1]
       */
      var over = createOver(arrayMap);

      /**
       * Creates a function that checks if **all** of the `predicates` return
       * truthy when invoked with the arguments it receives.
       *
       * Following shorthands are possible for providing predicates.
       * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
       * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {...(Function|Function[])} [predicates=[_.identity]]
       *  The predicates to check.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var func = _.overEvery([Boolean, isFinite]);
       *
       * func('1');
       * // => true
       *
       * func(null);
       * // => false
       *
       * func(NaN);
       * // => false
       */
      var overEvery = createOver(arrayEvery);

      /**
       * Creates a function that checks if **any** of the `predicates` return
       * truthy when invoked with the arguments it receives.
       *
       * Following shorthands are possible for providing predicates.
       * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
       * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {...(Function|Function[])} [predicates=[_.identity]]
       *  The predicates to check.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var func = _.overSome([Boolean, isFinite]);
       *
       * func('1');
       * // => true
       *
       * func(null);
       * // => true
       *
       * func(NaN);
       * // => false
       *
       * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
       * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
       */
      var overSome = createOver(arraySome);

      /**
       * Creates a function that returns the value at `path` of a given object.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Util
       * @param {Array|string} path The path of the property to get.
       * @returns {Function} Returns the new accessor function.
       * @example
       *
       * var objects = [
       *   { 'a': { 'b': 2 } },
       *   { 'a': { 'b': 1 } }
       * ];
       *
       * _.map(objects, _.property('a.b'));
       * // => [2, 1]
       *
       * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
       * // => [1, 2]
       */
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }

      /**
       * The opposite of `_.property`; this method creates a function that returns
       * the value at a given path of `object`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {Object} object The object to query.
       * @returns {Function} Returns the new accessor function.
       * @example
       *
       * var array = [0, 1, 2],
       *     object = { 'a': array, 'b': array, 'c': array };
       *
       * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
       * // => [2, 0]
       *
       * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
       * // => [2, 0]
       */
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }

      /**
       * Creates an array of numbers (positive and/or negative) progressing from
       * `start` up to, but not including, `end`. A step of `-1` is used if a negative
       * `start` is specified without an `end` or `step`. If `end` is not specified,
       * it's set to `start` with `start` then set to `0`.
       *
       * **Note:** JavaScript follows the IEEE-754 standard for resolving
       * floating-point values which can produce unexpected results.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @param {number} [step=1] The value to increment or decrement by.
       * @returns {Array} Returns the range of numbers.
       * @see _.inRange, _.rangeRight
       * @example
       *
       * _.range(4);
       * // => [0, 1, 2, 3]
       *
       * _.range(-4);
       * // => [0, -1, -2, -3]
       *
       * _.range(1, 5);
       * // => [1, 2, 3, 4]
       *
       * _.range(0, 20, 5);
       * // => [0, 5, 10, 15]
       *
       * _.range(0, -4, -1);
       * // => [0, -1, -2, -3]
       *
       * _.range(1, 4, 0);
       * // => [1, 1, 1]
       *
       * _.range(0);
       * // => []
       */
      var range = createRange();

      /**
       * This method is like `_.range` except that it populates values in
       * descending order.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @param {number} [step=1] The value to increment or decrement by.
       * @returns {Array} Returns the range of numbers.
       * @see _.inRange, _.range
       * @example
       *
       * _.rangeRight(4);
       * // => [3, 2, 1, 0]
       *
       * _.rangeRight(-4);
       * // => [-3, -2, -1, 0]
       *
       * _.rangeRight(1, 5);
       * // => [4, 3, 2, 1]
       *
       * _.rangeRight(0, 20, 5);
       * // => [15, 10, 5, 0]
       *
       * _.rangeRight(0, -4, -1);
       * // => [-3, -2, -1, 0]
       *
       * _.rangeRight(1, 4, 0);
       * // => [1, 1, 1]
       *
       * _.rangeRight(0);
       * // => []
       */
      var rangeRight = createRange(true);

      /**
       * This method returns a new empty array.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {Array} Returns the new empty array.
       * @example
       *
       * var arrays = _.times(2, _.stubArray);
       *
       * console.log(arrays);
       * // => [[], []]
       *
       * console.log(arrays[0] === arrays[1]);
       * // => false
       */
      function stubArray() {
        return [];
      }

      /**
       * This method returns `false`.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {boolean} Returns `false`.
       * @example
       *
       * _.times(2, _.stubFalse);
       * // => [false, false]
       */
      function stubFalse() {
        return false;
      }

      /**
       * This method returns a new empty object.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {Object} Returns the new empty object.
       * @example
       *
       * var objects = _.times(2, _.stubObject);
       *
       * console.log(objects);
       * // => [{}, {}]
       *
       * console.log(objects[0] === objects[1]);
       * // => false
       */
      function stubObject() {
        return {};
      }

      /**
       * This method returns an empty string.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {string} Returns the empty string.
       * @example
       *
       * _.times(2, _.stubString);
       * // => ['', '']
       */
      function stubString() {
        return "";
      }

      /**
       * This method returns `true`.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {boolean} Returns `true`.
       * @example
       *
       * _.times(2, _.stubTrue);
       * // => [true, true]
       */
      function stubTrue() {
        return true;
      }

      /**
       * Invokes the iteratee `n` times, returning an array of the results of
       * each invocation. The iteratee is invoked with one argument; (index).
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {number} n The number of times to invoke `iteratee`.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the array of results.
       * @example
       *
       * _.times(3, String);
       * // => ['0', '1', '2']
       *
       *  _.times(4, _.constant(0));
       * // => [0, 0, 0, 0]
       */
      function times(n, iteratee) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

        iteratee = getIteratee(iteratee);
        n -= MAX_ARRAY_LENGTH;

        var result = baseTimes(length, iteratee);
        while (++index < n) {
          iteratee(index);
        }
        return result;
      }

      /**
       * Converts `value` to a property path array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {*} value The value to convert.
       * @returns {Array} Returns the new property path array.
       * @example
       *
       * _.toPath('a.b.c');
       * // => ['a', 'b', 'c']
       *
       * _.toPath('a[0].b.c');
       * // => ['a', '0', 'b', 'c']
       */
      function toPath(value) {
        if (isArray(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value)
          ? [value]
          : copyArray(stringToPath(toString(value)));
      }

      /**
       * Generates a unique ID. If `prefix` is given, the ID is appended to it.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {string} [prefix=''] The value to prefix the ID with.
       * @returns {string} Returns the unique ID.
       * @example
       *
       * _.uniqueId('contact_');
       * // => 'contact_104'
       *
       * _.uniqueId();
       * // => '105'
       */
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString(prefix) + id;
      }

      /*------------------------------------------------------------------------*/

      /**
       * Adds two numbers.
       *
       * @static
       * @memberOf _
       * @since 3.4.0
       * @category Math
       * @param {number} augend The first number in an addition.
       * @param {number} addend The second number in an addition.
       * @returns {number} Returns the total.
       * @example
       *
       * _.add(6, 4);
       * // => 10
       */
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);

      /**
       * Computes `number` rounded up to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round up.
       * @param {number} [precision=0] The precision to round up to.
       * @returns {number} Returns the rounded up number.
       * @example
       *
       * _.ceil(4.006);
       * // => 5
       *
       * _.ceil(6.004, 2);
       * // => 6.01
       *
       * _.ceil(6040, -2);
       * // => 6100
       */
      var ceil = createRound("ceil");

      /**
       * Divide two numbers.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Math
       * @param {number} dividend The first number in a division.
       * @param {number} divisor The second number in a division.
       * @returns {number} Returns the quotient.
       * @example
       *
       * _.divide(6, 4);
       * // => 1.5
       */
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);

      /**
       * Computes `number` rounded down to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round down.
       * @param {number} [precision=0] The precision to round down to.
       * @returns {number} Returns the rounded down number.
       * @example
       *
       * _.floor(4.006);
       * // => 4
       *
       * _.floor(0.046, 2);
       * // => 0.04
       *
       * _.floor(4060, -2);
       * // => 4000
       */
      var floor = createRound("floor");

      /**
       * Computes the maximum value of `array`. If `array` is empty or falsey,
       * `undefined` is returned.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {*} Returns the maximum value.
       * @example
       *
       * _.max([4, 2, 8, 6]);
       * // => 8
       *
       * _.max([]);
       * // => undefined
       */
      function max(array) {
        return array && array.length
          ? baseExtremum(array, identity, baseGt)
          : undefined$1;
      }

      /**
       * This method is like `_.max` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * the value is ranked. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {*} Returns the maximum value.
       * @example
       *
       * var objects = [{ 'n': 1 }, { 'n': 2 }];
       *
       * _.maxBy(objects, function(o) { return o.n; });
       * // => { 'n': 2 }
       *
       * // The `_.property` iteratee shorthand.
       * _.maxBy(objects, 'n');
       * // => { 'n': 2 }
       */
      function maxBy(array, iteratee) {
        return array && array.length
          ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
          : undefined$1;
      }

      /**
       * Computes the mean of the values in `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {number} Returns the mean.
       * @example
       *
       * _.mean([4, 2, 8, 6]);
       * // => 5
       */
      function mean(array) {
        return baseMean(array, identity);
      }

      /**
       * This method is like `_.mean` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the value to be averaged.
       * The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the mean.
       * @example
       *
       * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
       *
       * _.meanBy(objects, function(o) { return o.n; });
       * // => 5
       *
       * // The `_.property` iteratee shorthand.
       * _.meanBy(objects, 'n');
       * // => 5
       */
      function meanBy(array, iteratee) {
        return baseMean(array, getIteratee(iteratee, 2));
      }

      /**
       * Computes the minimum value of `array`. If `array` is empty or falsey,
       * `undefined` is returned.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {*} Returns the minimum value.
       * @example
       *
       * _.min([4, 2, 8, 6]);
       * // => 2
       *
       * _.min([]);
       * // => undefined
       */
      function min(array) {
        return array && array.length
          ? baseExtremum(array, identity, baseLt)
          : undefined$1;
      }

      /**
       * This method is like `_.min` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * the value is ranked. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {*} Returns the minimum value.
       * @example
       *
       * var objects = [{ 'n': 1 }, { 'n': 2 }];
       *
       * _.minBy(objects, function(o) { return o.n; });
       * // => { 'n': 1 }
       *
       * // The `_.property` iteratee shorthand.
       * _.minBy(objects, 'n');
       * // => { 'n': 1 }
       */
      function minBy(array, iteratee) {
        return array && array.length
          ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
          : undefined$1;
      }

      /**
       * Multiply two numbers.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Math
       * @param {number} multiplier The first number in a multiplication.
       * @param {number} multiplicand The second number in a multiplication.
       * @returns {number} Returns the product.
       * @example
       *
       * _.multiply(6, 4);
       * // => 24
       */
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);

      /**
       * Computes `number` rounded to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round.
       * @param {number} [precision=0] The precision to round to.
       * @returns {number} Returns the rounded number.
       * @example
       *
       * _.round(4.006);
       * // => 4
       *
       * _.round(4.006, 2);
       * // => 4.01
       *
       * _.round(4060, -2);
       * // => 4100
       */
      var round = createRound("round");

      /**
       * Subtract two numbers.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {number} minuend The first number in a subtraction.
       * @param {number} subtrahend The second number in a subtraction.
       * @returns {number} Returns the difference.
       * @example
       *
       * _.subtract(6, 4);
       * // => 2
       */
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);

      /**
       * Computes the sum of the values in `array`.
       *
       * @static
       * @memberOf _
       * @since 3.4.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {number} Returns the sum.
       * @example
       *
       * _.sum([4, 2, 8, 6]);
       * // => 20
       */
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }

      /**
       * This method is like `_.sum` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the value to be summed.
       * The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the sum.
       * @example
       *
       * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
       *
       * _.sumBy(objects, function(o) { return o.n; });
       * // => 20
       *
       * // The `_.property` iteratee shorthand.
       * _.sumBy(objects, 'n');
       * // => 20
       */
      function sumBy(array, iteratee) {
        return array && array.length
          ? baseSum(array, getIteratee(iteratee, 2))
          : 0;
      }

      /*------------------------------------------------------------------------*/

      // Add methods that return wrapped values in chain sequences.
      lodash.after = after;
      lodash.ary = ary;
      lodash.assign = assign;
      lodash.assignIn = assignIn;
      lodash.assignInWith = assignInWith;
      lodash.assignWith = assignWith;
      lodash.at = at;
      lodash.before = before;
      lodash.bind = bind;
      lodash.bindAll = bindAll;
      lodash.bindKey = bindKey;
      lodash.castArray = castArray;
      lodash.chain = chain;
      lodash.chunk = chunk;
      lodash.compact = compact;
      lodash.concat = concat;
      lodash.cond = cond;
      lodash.conforms = conforms;
      lodash.constant = constant;
      lodash.countBy = countBy;
      lodash.create = create;
      lodash.curry = curry;
      lodash.curryRight = curryRight;
      lodash.debounce = debounce;
      lodash.defaults = defaults;
      lodash.defaultsDeep = defaultsDeep;
      lodash.defer = defer;
      lodash.delay = delay;
      lodash.difference = difference;
      lodash.differenceBy = differenceBy;
      lodash.differenceWith = differenceWith;
      lodash.drop = drop;
      lodash.dropRight = dropRight;
      lodash.dropRightWhile = dropRightWhile;
      lodash.dropWhile = dropWhile;
      lodash.fill = fill;
      lodash.filter = filter;
      lodash.flatMap = flatMap;
      lodash.flatMapDeep = flatMapDeep;
      lodash.flatMapDepth = flatMapDepth;
      lodash.flatten = flatten;
      lodash.flattenDeep = flattenDeep;
      lodash.flattenDepth = flattenDepth;
      lodash.flip = flip;
      lodash.flow = flow;
      lodash.flowRight = flowRight;
      lodash.fromPairs = fromPairs;
      lodash.functions = functions;
      lodash.functionsIn = functionsIn;
      lodash.groupBy = groupBy;
      lodash.initial = initial;
      lodash.intersection = intersection;
      lodash.intersectionBy = intersectionBy;
      lodash.intersectionWith = intersectionWith;
      lodash.invert = invert;
      lodash.invertBy = invertBy;
      lodash.invokeMap = invokeMap;
      lodash.iteratee = iteratee;
      lodash.keyBy = keyBy;
      lodash.keys = keys;
      lodash.keysIn = keysIn;
      lodash.map = map;
      lodash.mapKeys = mapKeys;
      lodash.mapValues = mapValues;
      lodash.matches = matches;
      lodash.matchesProperty = matchesProperty;
      lodash.memoize = memoize;
      lodash.merge = merge;
      lodash.mergeWith = mergeWith;
      lodash.method = method;
      lodash.methodOf = methodOf;
      lodash.mixin = mixin;
      lodash.negate = negate;
      lodash.nthArg = nthArg;
      lodash.omit = omit;
      lodash.omitBy = omitBy;
      lodash.once = once;
      lodash.orderBy = orderBy;
      lodash.over = over;
      lodash.overArgs = overArgs;
      lodash.overEvery = overEvery;
      lodash.overSome = overSome;
      lodash.partial = partial;
      lodash.partialRight = partialRight;
      lodash.partition = partition;
      lodash.pick = pick;
      lodash.pickBy = pickBy;
      lodash.property = property;
      lodash.propertyOf = propertyOf;
      lodash.pull = pull;
      lodash.pullAll = pullAll;
      lodash.pullAllBy = pullAllBy;
      lodash.pullAllWith = pullAllWith;
      lodash.pullAt = pullAt;
      lodash.range = range;
      lodash.rangeRight = rangeRight;
      lodash.rearg = rearg;
      lodash.reject = reject;
      lodash.remove = remove;
      lodash.rest = rest;
      lodash.reverse = reverse;
      lodash.sampleSize = sampleSize;
      lodash.set = set;
      lodash.setWith = setWith;
      lodash.shuffle = shuffle;
      lodash.slice = slice;
      lodash.sortBy = sortBy;
      lodash.sortedUniq = sortedUniq;
      lodash.sortedUniqBy = sortedUniqBy;
      lodash.split = split;
      lodash.spread = spread;
      lodash.tail = tail;
      lodash.take = take;
      lodash.takeRight = takeRight;
      lodash.takeRightWhile = takeRightWhile;
      lodash.takeWhile = takeWhile;
      lodash.tap = tap;
      lodash.throttle = throttle;
      lodash.thru = thru;
      lodash.toArray = toArray;
      lodash.toPairs = toPairs;
      lodash.toPairsIn = toPairsIn;
      lodash.toPath = toPath;
      lodash.toPlainObject = toPlainObject;
      lodash.transform = transform;
      lodash.unary = unary;
      lodash.union = union;
      lodash.unionBy = unionBy;
      lodash.unionWith = unionWith;
      lodash.uniq = uniq;
      lodash.uniqBy = uniqBy;
      lodash.uniqWith = uniqWith;
      lodash.unset = unset;
      lodash.unzip = unzip;
      lodash.unzipWith = unzipWith;
      lodash.update = update;
      lodash.updateWith = updateWith;
      lodash.values = values;
      lodash.valuesIn = valuesIn;
      lodash.without = without;
      lodash.words = words;
      lodash.wrap = wrap;
      lodash.xor = xor;
      lodash.xorBy = xorBy;
      lodash.xorWith = xorWith;
      lodash.zip = zip;
      lodash.zipObject = zipObject;
      lodash.zipObjectDeep = zipObjectDeep;
      lodash.zipWith = zipWith;

      // Add aliases.
      lodash.entries = toPairs;
      lodash.entriesIn = toPairsIn;
      lodash.extend = assignIn;
      lodash.extendWith = assignInWith;

      // Add methods to `lodash.prototype`.
      mixin(lodash, lodash);

      /*------------------------------------------------------------------------*/

      // Add methods that return unwrapped values in chain sequences.
      lodash.add = add;
      lodash.attempt = attempt;
      lodash.camelCase = camelCase;
      lodash.capitalize = capitalize;
      lodash.ceil = ceil;
      lodash.clamp = clamp;
      lodash.clone = clone;
      lodash.cloneDeep = cloneDeep;
      lodash.cloneDeepWith = cloneDeepWith;
      lodash.cloneWith = cloneWith;
      lodash.conformsTo = conformsTo;
      lodash.deburr = deburr;
      lodash.defaultTo = defaultTo;
      lodash.divide = divide;
      lodash.endsWith = endsWith;
      lodash.eq = eq;
      lodash.escape = escape;
      lodash.escapeRegExp = escapeRegExp;
      lodash.every = every;
      lodash.find = find;
      lodash.findIndex = findIndex;
      lodash.findKey = findKey;
      lodash.findLast = findLast;
      lodash.findLastIndex = findLastIndex;
      lodash.findLastKey = findLastKey;
      lodash.floor = floor;
      lodash.forEach = forEach;
      lodash.forEachRight = forEachRight;
      lodash.forIn = forIn;
      lodash.forInRight = forInRight;
      lodash.forOwn = forOwn;
      lodash.forOwnRight = forOwnRight;
      lodash.get = get;
      lodash.gt = gt;
      lodash.gte = gte;
      lodash.has = has;
      lodash.hasIn = hasIn;
      lodash.head = head;
      lodash.identity = identity;
      lodash.includes = includes;
      lodash.indexOf = indexOf;
      lodash.inRange = inRange;
      lodash.invoke = invoke;
      lodash.isArguments = isArguments;
      lodash.isArray = isArray;
      lodash.isArrayBuffer = isArrayBuffer;
      lodash.isArrayLike = isArrayLike;
      lodash.isArrayLikeObject = isArrayLikeObject;
      lodash.isBoolean = isBoolean;
      lodash.isBuffer = isBuffer;
      lodash.isDate = isDate;
      lodash.isElement = isElement;
      lodash.isEmpty = isEmpty;
      lodash.isEqual = isEqual;
      lodash.isEqualWith = isEqualWith;
      lodash.isError = isError;
      lodash.isFinite = isFinite;
      lodash.isFunction = isFunction;
      lodash.isInteger = isInteger;
      lodash.isLength = isLength;
      lodash.isMap = isMap;
      lodash.isMatch = isMatch;
      lodash.isMatchWith = isMatchWith;
      lodash.isNaN = isNaN;
      lodash.isNative = isNative;
      lodash.isNil = isNil;
      lodash.isNull = isNull;
      lodash.isNumber = isNumber;
      lodash.isObject = isObject;
      lodash.isObjectLike = isObjectLike;
      lodash.isPlainObject = isPlainObject;
      lodash.isRegExp = isRegExp;
      lodash.isSafeInteger = isSafeInteger;
      lodash.isSet = isSet;
      lodash.isString = isString;
      lodash.isSymbol = isSymbol;
      lodash.isTypedArray = isTypedArray;
      lodash.isUndefined = isUndefined;
      lodash.isWeakMap = isWeakMap;
      lodash.isWeakSet = isWeakSet;
      lodash.join = join;
      lodash.kebabCase = kebabCase;
      lodash.last = last;
      lodash.lastIndexOf = lastIndexOf;
      lodash.lowerCase = lowerCase;
      lodash.lowerFirst = lowerFirst;
      lodash.lt = lt;
      lodash.lte = lte;
      lodash.max = max;
      lodash.maxBy = maxBy;
      lodash.mean = mean;
      lodash.meanBy = meanBy;
      lodash.min = min;
      lodash.minBy = minBy;
      lodash.stubArray = stubArray;
      lodash.stubFalse = stubFalse;
      lodash.stubObject = stubObject;
      lodash.stubString = stubString;
      lodash.stubTrue = stubTrue;
      lodash.multiply = multiply;
      lodash.nth = nth;
      lodash.noConflict = noConflict;
      lodash.noop = noop;
      lodash.now = now;
      lodash.pad = pad;
      lodash.padEnd = padEnd;
      lodash.padStart = padStart;
      lodash.parseInt = parseInt;
      lodash.random = random;
      lodash.reduce = reduce;
      lodash.reduceRight = reduceRight;
      lodash.repeat = repeat;
      lodash.replace = replace;
      lodash.result = result;
      lodash.round = round;
      lodash.runInContext = runInContext;
      lodash.sample = sample;
      lodash.size = size;
      lodash.snakeCase = snakeCase;
      lodash.some = some;
      lodash.sortedIndex = sortedIndex;
      lodash.sortedIndexBy = sortedIndexBy;
      lodash.sortedIndexOf = sortedIndexOf;
      lodash.sortedLastIndex = sortedLastIndex;
      lodash.sortedLastIndexBy = sortedLastIndexBy;
      lodash.sortedLastIndexOf = sortedLastIndexOf;
      lodash.startCase = startCase;
      lodash.startsWith = startsWith;
      lodash.subtract = subtract;
      lodash.sum = sum;
      lodash.sumBy = sumBy;
      lodash.template = template;
      lodash.times = times;
      lodash.toFinite = toFinite;
      lodash.toInteger = toInteger;
      lodash.toLength = toLength;
      lodash.toLower = toLower;
      lodash.toNumber = toNumber;
      lodash.toSafeInteger = toSafeInteger;
      lodash.toString = toString;
      lodash.toUpper = toUpper;
      lodash.trim = trim;
      lodash.trimEnd = trimEnd;
      lodash.trimStart = trimStart;
      lodash.truncate = truncate;
      lodash.unescape = unescape;
      lodash.uniqueId = uniqueId;
      lodash.upperCase = upperCase;
      lodash.upperFirst = upperFirst;

      // Add aliases.
      lodash.each = forEach;
      lodash.eachRight = forEachRight;
      lodash.first = head;

      mixin(
        lodash,
        (function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        })(),
        { chain: false }
      );

      /*------------------------------------------------------------------------*/

      /**
       * The semantic version number.
       *
       * @static
       * @memberOf _
       * @type {string}
       */
      lodash.VERSION = VERSION;

      // Assign default placeholders.
      arrayEach(
        ["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"],
        function(methodName) {
          lodash[methodName].placeholder = lodash;
        }
      );

      // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
      arrayEach(["drop", "take"], function(methodName, index) {
        LazyWrapper.prototype[methodName] = function(n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

          var result =
            this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();

          if (result.__filtered__) {
            result.__takeCount__ = nativeMin(n, result.__takeCount__);
          } else {
            result.__views__.push({
              size: nativeMin(n, MAX_ARRAY_LENGTH),
              type: methodName + (result.__dir__ < 0 ? "Right" : "")
            });
          }
          return result;
        };

        LazyWrapper.prototype[methodName + "Right"] = function(n) {
          return this.reverse()
            [methodName](n)
            .reverse();
        };
      });

      // Add `LazyWrapper` methods that accept an `iteratee` value.
      arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
        var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

        LazyWrapper.prototype[methodName] = function(iteratee) {
          var result = this.clone();
          result.__iteratees__.push({
            iteratee: getIteratee(iteratee, 3),
            type: type
          });
          result.__filtered__ = result.__filtered__ || isFilter;
          return result;
        };
      });

      // Add `LazyWrapper` methods for `_.head` and `_.last`.
      arrayEach(["head", "last"], function(methodName, index) {
        var takeName = "take" + (index ? "Right" : "");

        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });

      // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
      arrayEach(["initial", "tail"], function(methodName, index) {
        var dropName = "drop" + (index ? "" : "Right");

        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });

      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };

      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };

      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };

      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == "function") {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });

      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };

      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger(start);

        var result = this;
        if (result.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result);
        }
        if (start < 0) {
          result = result.takeRight(-start);
        } else if (start) {
          result = result.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result = end < 0 ? result.dropRight(-end) : result.take(end - start);
        }
        return result;
      };

      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse()
          .takeWhile(predicate)
          .reverse();
      };

      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };

      // Add `LazyWrapper` methods to `lodash.prototype`.
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(
            methodName
          ),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc =
            lodash[
              isTaker
                ? "take" + (methodName == "last" ? "Right" : "")
                : methodName
            ],
          retUnwrapped = isTaker || /^find/.test(methodName);

        if (!lodashFunc) {
          return;
        }
        lodash.prototype[methodName] = function() {
          var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

          var interceptor = function(value) {
            var result = lodashFunc.apply(lodash, arrayPush([value], args));
            return isTaker && chainAll ? result[0] : result;
          };

          if (
            useLazy &&
            checkIteratee &&
            typeof iteratee == "function" &&
            iteratee.length != 1
          ) {
            // Avoid lazy use if the iteratee has a "length" value other than `1`.
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result = func.apply(value, args);
            result.__actions__.push({
              func: thru,
              args: [interceptor],
              thisArg: undefined$1
            });
            return new LodashWrapper(result, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result = this.thru(interceptor);
          return isUnwrapped
            ? isTaker
              ? result.value()[0]
              : result.value()
            : result;
        };
      });

      // Add `Array` methods to `lodash.prototype`.
      arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(
        methodName
      ) {
        var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName)
            ? "tap"
            : "thru",
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

        lodash.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray(value) ? value : [], args);
          }
          return this[chainName](function(value) {
            return func.apply(isArray(value) ? value : [], args);
          });
        };
      });

      // Map minified method names to their real names.
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + "";
          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ name: methodName, func: lodashFunc });
        }
      });

      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [
        {
          name: "wrapper",
          func: undefined$1
        }
      ];

      // Add methods to `LazyWrapper`.
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;

      // Add chain sequence methods to the `lodash` wrapper.
      lodash.prototype.at = wrapperAt;
      lodash.prototype.chain = wrapperChain;
      lodash.prototype.commit = wrapperCommit;
      lodash.prototype.next = wrapperNext;
      lodash.prototype.plant = wrapperPlant;
      lodash.prototype.reverse = wrapperReverse;
      lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

      // Add lazy aliases.
      lodash.prototype.first = lodash.prototype.head;

      if (symIterator) {
        lodash.prototype[symIterator] = wrapperToIterator;
      }
      return lodash;
    };

    /*--------------------------------------------------------------------------*/

    // Export lodash.
    var _ = runInContext();

    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (freeModule) {
      // Export for Node.js.
      (freeModule.exports = _)._ = _;
      // Export for CommonJS support.
      freeExports._ = _;
    } else {
      // Export to the global object.
      root._ = _;
    }
  }.call(commonjsGlobal));
})(lodash, lodash.exports);

var RequestParam = /*#__PURE__*/ (function() {
  function RequestParam() {
    _classCallCheck(this, RequestParam);

    this.baseURL = "";
    this.r2d2Url = "";
    this.paymentUrl = "";
    this.merchantID = "";
    this.webBaseURL = "";
    this.setBaseUrl = this.setBaseUrl.bind(this);
    this.setR2D2Url = this.setR2D2Url.bind(this);
    this.setPaymentUrl = this.setPaymentUrl.bind(this);
    this.setMerchantID = this.setMerchantID.bind(this);
    this.setWebBaseURL = this.setWebBaseURL.bind(this);
  }

  _createClass(RequestParam, [
    {
      key: "setBaseUrl",
      value: function setBaseUrl(url) {
        this.baseURL = url;
      }
    },
    {
      key: "setR2D2Url",
      value: function setR2D2Url(url) {
        this.r2d2Url = url;
      }
    },
    {
      key: "setPaymentUrl",
      value: function setPaymentUrl(url) {
        this.paymentUrl = url;
      }
    },
    {
      key: "setMerchantID",
      value: function setMerchantID(id) {
        this.merchantID = id;
      }
    },
    {
      key: "setWebBaseURL",
      value: function setWebBaseURL(url) {
        this.webBaseURL = url;
      }
    }
  ]);

  return RequestParam;
})();

var requestParam$1 = new RequestParam(); // create singleton param for call api function

var setBaseUrl = requestParam$1.setBaseUrl;
var setR2D2Url = requestParam$1.setR2D2Url;
var setPaymentUrl = requestParam$1.setPaymentUrl;
var setMerchantID = requestParam$1.setMerchantID;
var setWebBaseURL = requestParam$1.setWebBaseURL;
function apiRequest(axiosOptions, useAuthorizedHeader) {
  if (!requestParam$1.baseURL) {
    console.error(
      'Please run setBaseUrl from import { apiRequest } from "stktwlib" '
    );
  }

  var headers = {
    "Content-Type": "application/json"
  };
  var userheader = localStorage.userheader
    ? JSON.parse(localStorage.userheader)
    : null;

  if (userheader && useAuthorizedHeader) {
    headers["uid"] = userheader["uid"];
    headers["access-token"] = userheader["token"];
    headers["client"] = userheader["client"];
  } // submit token to server even token is null

  var defaultOpt = {
    baseURL: requestParam$1.baseURL,
    headers: headers
  };
  var opt = lodash.exports.merge({}, defaultOpt, axiosOptions);
  return new Promise(function(resolve, reject) {
    axios(opt)
      .then(function(res) {
        if (res.status === 200) {
          resolve(res);
        } else {
          reject(res);
        }
      })
      ["catch"](function(err) {
        if (err.response && err.response.status === 401) {
          localStorage.clear();
          window.location.href = requestParam$1.webBaseURL + "/login";
        }

        reject(err);
      });
  });
}

function get(_x) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator(
    /*#__PURE__*/ _regeneratorRuntime.mark(function _callee(url) {
      var useAuthorizedHeader,
        allowFailedResponse,
        isReturnOriginalResponse,
        opt,
        response,
        _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch ((_context.prev = _context.next)) {
            case 0:
              useAuthorizedHeader =
                _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
              allowFailedResponse =
                _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
              isReturnOriginalResponse =
                _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
              opt = {
                method: "get",
                url: url
              };
              _context.next = 6;
              return apiRequest(opt, useAuthorizedHeader);

            case 6:
              response = _context.sent;
              return _context.abrupt(
                "return",
                new Promise(function(resolve, reject) {
                  if (allowFailedResponse) {
                    if (response.data) {
                      resolve(response.data);
                    } else {
                      reject(response.data);
                    }
                  } else {
                    if (
                      !response.data.response &&
                      response.data.status &&
                      response.data.status !== "ok"
                    ) {
                      reject(response.data.errors);
                    } else {
                      if (isReturnOriginalResponse) {
                        resolve(response.data);
                      } else {
                        resolve(response.data.response);
                      }
                    }
                  }
                })
              );

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })
  );
  return _get.apply(this, arguments);
}

function post(_x2, _x3, _x4, _x5) {
  return _post.apply(this, arguments);
}

function _post() {
  _post = _asyncToGenerator(
    /*#__PURE__*/ _regeneratorRuntime.mark(function _callee2(
      url,
      data,
      useAuthorizedHeader,
      isReturnOriginalResponse
    ) {
      var opt, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch ((_context2.prev = _context2.next)) {
            case 0:
              opt = {
                method: "post",
                url: url,
                data: data
              };
              _context2.next = 3;
              return apiRequest(opt, useAuthorizedHeader);

            case 3:
              response = _context2.sent;
              return _context2.abrupt(
                "return",
                new Promise(function(resolve, reject) {
                  if (
                    !response.data.response &&
                    response.data.status !== "ok"
                  ) {
                    // alert(response.data.errors?response.data.errors:response.data.error);
                    reject(response.data.errors);
                  } else {
                    var header = response.headers;

                    if (url === "auth/sign_in") {
                      var _data = {
                        token: header["access-token"],
                        uid: header.uid,
                        client: header.client
                      };
                      localStorage.setItem("userheader", JSON.stringify(_data));
                    }

                    if (isReturnOriginalResponse) {
                      resolve(response);
                    } else {
                      resolve(response.data.response);
                    }
                  }
                })
              );

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })
  );
  return _post.apply(this, arguments);
}

function put(_x6, _x7, _x8) {
  return _put.apply(this, arguments);
}

function _put() {
  _put = _asyncToGenerator(
    /*#__PURE__*/ _regeneratorRuntime.mark(function _callee3(
      url,
      data,
      useAuthorizedHeader
    ) {
      var opt, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch ((_context3.prev = _context3.next)) {
            case 0:
              opt = {
                method: "put",
                url: url,
                data: data
              };
              _context3.next = 3;
              return apiRequest(opt, useAuthorizedHeader);

            case 3:
              response = _context3.sent;
              return _context3.abrupt(
                "return",
                new Promise(function(resolve, reject) {
                  if (!response.data.response) {
                    reject(response.data.errors);
                  } else {
                    resolve(response.data.response);
                  }
                })
              );

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })
  );
  return _put.apply(this, arguments);
}

function del(_x9, _x10, _x11) {
  return _del.apply(this, arguments);
}

function _del() {
  _del = _asyncToGenerator(
    /*#__PURE__*/ _regeneratorRuntime.mark(function _callee4(
      url,
      data,
      useAuthorizedHeader
    ) {
      var opt, response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch ((_context4.prev = _context4.next)) {
            case 0:
              opt = {
                method: "delete",
                url: url,
                data: data
              };
              _context4.next = 3;
              return apiRequest(opt, useAuthorizedHeader);

            case 3:
              response = _context4.sent;
              return _context4.abrupt(
                "return",
                new Promise(function(resolve, reject) {
                  if (!response) {
                    reject(response);
                  } else {
                    resolve(response.data.response);
                  }
                })
              );

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })
  );
  return _del.apply(this, arguments);
}

var index = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  get: get,
  post: post,
  put: put,
  del: del,
  request: apiRequest,
  requestParam: requestParam$1,
  setBaseUrl: setBaseUrl,
  setR2D2Url: setR2D2Url,
  setPaymentUrl: setPaymentUrl,
  setMerchantID: setMerchantID,
  setWebBaseURL: setWebBaseURL
});

var reactResponsive = { exports: {} };

(function(module, exports) {
  !(function(root, factory) {
    module.exports = factory(React);
  })("undefined" != typeof self ? self : commonjsGlobal, function(
    __WEBPACK_EXTERNAL_MODULE_1__
  ) {
    return (function(modules) {
      function __webpack_require__(moduleId) {
        if (installedModules[moduleId])
          return installedModules[moduleId].exports;
        var module = (installedModules[moduleId] = {
          i: moduleId,
          l: !1,
          exports: {}
        });
        return (
          modules[moduleId].call(
            module.exports,
            module,
            module.exports,
            __webpack_require__
          ),
          (module.l = !0),
          module.exports
        );
      }
      var installedModules = {};
      return (
        (__webpack_require__.m = modules),
        (__webpack_require__.c = installedModules),
        (__webpack_require__.d = function(exports, name, getter) {
          __webpack_require__.o(exports, name) ||
            Object.defineProperty(exports, name, {
              configurable: !1,
              enumerable: !0,
              get: getter
            });
        }),
        (__webpack_require__.n = function(module) {
          var getter =
            module && module.__esModule
              ? function() {
                  return module.default;
                }
              : function() {
                  return module;
                };
          return __webpack_require__.d(getter, "a", getter), getter;
        }),
        (__webpack_require__.o = function(object, property) {
          return Object.prototype.hasOwnProperty.call(object, property);
        }),
        (__webpack_require__.p = ""),
        __webpack_require__((__webpack_require__.s = 7))
      );
    })([
      function(module, exports, __webpack_require__) {
        var __importDefault =
          (this && this.__importDefault) ||
          function(mod) {
            return mod && mod.__esModule
              ? mod
              : {
                  default: mod
                };
          };
        Object.defineProperty(exports, "__esModule", {
          value: !0
        });
        var react_1 = __importDefault(__webpack_require__(1)),
          matchmediaquery_1 = __importDefault(__webpack_require__(8)),
          hyphenate_style_name_1 = __importDefault(__webpack_require__(2)),
          shallow_equal_1 = __webpack_require__(10),
          toQuery_1 = __importDefault(__webpack_require__(3)),
          Context_1 = __importDefault(__webpack_require__(6)),
          makeQuery = function(settings) {
            return settings.query || (0, toQuery_1.default)(settings);
          },
          hyphenateKeys = function(obj) {
            if (!obj) return null;
            var keys = Object.keys(obj);
            return 0 === keys.length
              ? null
              : keys.reduce(function(result, key) {
                  return (
                    (result[(0, hyphenate_style_name_1.default)(key)] =
                      obj[key]),
                    result
                  );
                }, {});
          },
          useIsUpdate = function() {
            var ref = react_1.default.useRef(!1);
            return (
              react_1.default.useEffect(function() {
                ref.current = !0;
              }, []),
              ref.current
            );
          },
          useDevice = function(deviceFromProps) {
            var deviceFromContext = react_1.default.useContext(
                Context_1.default
              ),
              getDevice = function() {
                return (
                  hyphenateKeys(deviceFromProps) ||
                  hyphenateKeys(deviceFromContext) ||
                  {}
                );
              },
              _a = react_1.default.useState(getDevice),
              device = _a[0],
              setDevice = _a[1];
            return (
              react_1.default.useEffect(
                function() {
                  var newDevice = getDevice();
                  (0, shallow_equal_1.shallowEqualObjects)(device, newDevice) ||
                    setDevice(newDevice);
                },
                [deviceFromProps, deviceFromContext]
              ),
              device
            );
          },
          useQuery = function(settings) {
            var getQuery = function() {
                return makeQuery(settings);
              },
              _a = react_1.default.useState(getQuery),
              query = _a[0],
              setQuery = _a[1];
            return (
              react_1.default.useEffect(
                function() {
                  var newQuery = getQuery();
                  query !== newQuery && setQuery(newQuery);
                },
                [settings]
              ),
              query
            );
          },
          useMatchMedia = function(query, device) {
            var getMatchMedia = function() {
                return (0, matchmediaquery_1.default)(query, device);
              },
              _a = react_1.default.useState(getMatchMedia),
              mq = _a[0],
              setMq = _a[1],
              isUpdate = useIsUpdate();
            return (
              react_1.default.useEffect(
                function() {
                  if (isUpdate) {
                    var newMq_1 = getMatchMedia();
                    return (
                      setMq(newMq_1),
                      function() {
                        newMq_1 && newMq_1.dispose();
                      }
                    );
                  }
                },
                [query, device]
              ),
              mq
            );
          },
          useMatches = function(mediaQuery) {
            var _a = react_1.default.useState(mediaQuery.matches),
              matches = _a[0],
              setMatches = _a[1];
            return (
              react_1.default.useEffect(
                function() {
                  var updateMatches = function() {
                    setMatches(mediaQuery.matches);
                  };
                  return (
                    mediaQuery.addListener(updateMatches),
                    updateMatches(),
                    function() {
                      mediaQuery.removeListener(updateMatches);
                    }
                  );
                },
                [mediaQuery]
              ),
              matches
            );
          },
          useMediaQuery = function(settings, device, onChange) {
            var deviceSettings = useDevice(device),
              query = useQuery(settings);
            if (!query) throw new Error("Invalid or missing MediaQuery!");
            var mq = useMatchMedia(query, deviceSettings),
              matches = useMatches(mq),
              isUpdate = useIsUpdate();
            return (
              react_1.default.useEffect(
                function() {
                  isUpdate && onChange && onChange(matches);
                },
                [matches]
              ),
              react_1.default.useEffect(function() {
                return function() {
                  mq && mq.dispose();
                };
              }, []),
              matches
            );
          };
        exports.default = useMediaQuery;
      },
      function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
      },
      function(module, __webpack_exports__, __webpack_require__) {
        function toHyphenLower(match) {
          return "-" + match.toLowerCase();
        }
        function hyphenateStyleName(name) {
          if (cache.hasOwnProperty(name)) return cache[name];
          var hName = name.replace(uppercasePattern, toHyphenLower);
          return (cache[name] = msPattern.test(hName) ? "-" + hName : hName);
        }
        Object.defineProperty(__webpack_exports__, "__esModule", {
          value: !0
        });
        var uppercasePattern = /[A-Z]/g,
          msPattern = /^ms-/,
          cache = {};
        __webpack_exports__.default = hyphenateStyleName;
      },
      function(module, exports, __webpack_require__) {
        var __importDefault =
          (this && this.__importDefault) ||
          function(mod) {
            return mod && mod.__esModule
              ? mod
              : {
                  default: mod
                };
          };
        Object.defineProperty(exports, "__esModule", {
          value: !0
        });
        var hyphenate_style_name_1 = __importDefault(__webpack_require__(2)),
          mediaQuery_1 = __importDefault(__webpack_require__(11)),
          negate = function(cond) {
            return "not ".concat(cond);
          },
          keyVal = function(k, v) {
            var realKey = (0, hyphenate_style_name_1.default)(k);
            return (
              "number" == typeof v && (v = "".concat(v, "px")),
              !0 === v
                ? realKey
                : !1 === v
                ? negate(realKey)
                : "(".concat(realKey, ": ").concat(v, ")")
            );
          },
          join = function(conds) {
            return conds.join(" and ");
          },
          toQuery = function(obj) {
            var rules = [];
            return (
              Object.keys(mediaQuery_1.default.all).forEach(function(k) {
                var v = obj[k];
                null != v && rules.push(keyVal(k, v));
              }),
              join(rules)
            );
          };
        exports.default = toQuery;
      },
      function(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(13);
      },
      function(module, exports, __webpack_require__) {
        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      function(module, exports, __webpack_require__) {
        var __importDefault =
          (this && this.__importDefault) ||
          function(mod) {
            return mod && mod.__esModule
              ? mod
              : {
                  default: mod
                };
          };
        Object.defineProperty(exports, "__esModule", {
          value: !0
        });
        var react_1 = __importDefault(__webpack_require__(1)),
          Context = react_1.default.createContext({});
        exports.default = Context;
      },
      function(module, exports, __webpack_require__) {
        var __importDefault =
          (this && this.__importDefault) ||
          function(mod) {
            return mod && mod.__esModule
              ? mod
              : {
                  default: mod
                };
          };
        Object.defineProperty(exports, "__esModule", {
          value: !0
        }),
          (exports.Context = exports.toQuery = exports.useMediaQuery = exports.default = void 0);
        var useMediaQuery_1 = __importDefault(__webpack_require__(0));
        exports.useMediaQuery = useMediaQuery_1.default;
        var Component_1 = __importDefault(__webpack_require__(17));
        exports.default = Component_1.default;
        var toQuery_1 = __importDefault(__webpack_require__(3));
        exports.toQuery = toQuery_1.default;
        var Context_1 = __importDefault(__webpack_require__(6));
        exports.Context = Context_1.default;
      },
      function(module, exports, __webpack_require__) {
        function Mql(query, values, forceStatic) {
          function addListener(listener) {
            mql && mql.addListener(listener);
          }
          function removeListener(listener) {
            mql && mql.removeListener(listener);
          }
          function update(evt) {
            (self.matches = evt.matches), (self.media = evt.media);
          }
          function dispose() {
            mql && mql.removeListener(update);
          }
          var self = this;
          if (dynamicMatch && !forceStatic) {
            var mql = dynamicMatch.call(window, query);
            (this.matches = mql.matches),
              (this.media = mql.media),
              mql.addListener(update);
          } else
            (this.matches = staticMatch(query, values)), (this.media = query);
          (this.addListener = addListener),
            (this.removeListener = removeListener),
            (this.dispose = dispose);
        }
        function matchMedia(query, values, forceStatic) {
          return new Mql(query, values, forceStatic);
        }
        var staticMatch = __webpack_require__(9).match,
          dynamicMatch =
            "undefined" != typeof window ? window.matchMedia : null;
        module.exports = matchMedia;
      },
      function(module, exports, __webpack_require__) {
        function matchQuery(mediaQuery, values) {
          return parseQuery(mediaQuery).some(function(query) {
            var inverse = query.inverse,
              typeMatch = "all" === query.type || values.type === query.type;
            if ((typeMatch && inverse) || (!typeMatch && !inverse)) return !1;
            var expressionsMatch = query.expressions.every(function(
              expression
            ) {
              var feature = expression.feature,
                modifier = expression.modifier,
                expValue = expression.value,
                value = values[feature];
              if (!value) return !1;
              switch (feature) {
                case "orientation":
                case "scan":
                  return value.toLowerCase() === expValue.toLowerCase();

                case "width":
                case "height":
                case "device-width":
                case "device-height":
                  (expValue = toPx(expValue)), (value = toPx(value));
                  break;

                case "resolution":
                  (expValue = toDpi(expValue)), (value = toDpi(value));
                  break;

                case "aspect-ratio":
                case "device-aspect-ratio":
                case "device-pixel-ratio":
                  (expValue = toDecimal(expValue)), (value = toDecimal(value));
                  break;

                case "grid":
                case "color":
                case "color-index":
                case "monochrome":
                  (expValue = parseInt(expValue, 10) || 1),
                    (value = parseInt(value, 10) || 0);
              }
              switch (modifier) {
                case "min":
                  return value >= expValue;

                case "max":
                  return value <= expValue;

                default:
                  return value === expValue;
              }
            });
            return (
              (expressionsMatch && !inverse) || (!expressionsMatch && inverse)
            );
          });
        }
        function parseQuery(mediaQuery) {
          return mediaQuery.split(",").map(function(query) {
            query = query.trim();
            var captures = query.match(RE_MEDIA_QUERY),
              modifier = captures[1],
              type = captures[2],
              expressions = captures[3] || "",
              parsed = {};
            return (
              (parsed.inverse = !!modifier && "not" === modifier.toLowerCase()),
              (parsed.type = type ? type.toLowerCase() : "all"),
              (expressions = expressions.match(/\([^\)]+\)/g) || []),
              (parsed.expressions = expressions.map(function(expression) {
                var captures = expression.match(RE_MQ_EXPRESSION),
                  feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                return {
                  modifier: feature[1],
                  feature: feature[2],
                  value: captures[2]
                };
              })),
              parsed
            );
          });
        }
        function toDecimal(ratio) {
          var numbers,
            decimal = Number(ratio);
          return (
            decimal ||
              ((numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/)),
              (decimal = numbers[1] / numbers[2])),
            decimal
          );
        }
        function toDpi(resolution) {
          var value = parseFloat(resolution);
          switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
            case "dpcm":
              return value / 2.54;

            case "dppx":
              return 96 * value;

            default:
              return value;
          }
        }
        function toPx(length) {
          var value = parseFloat(length);
          switch (String(length).match(RE_LENGTH_UNIT)[1]) {
            case "em":
            case "rem":
              return 16 * value;

            case "cm":
              return (96 * value) / 2.54;

            case "mm":
              return (96 * value) / 2.54 / 10;

            case "in":
              return 96 * value;

            case "pt":
              return 72 * value;

            case "pc":
              return (72 * value) / 12;

            default:
              return value;
          }
        }
        (exports.match = matchQuery), (exports.parse = parseQuery);
        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i,
          RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/,
          RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/,
          RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/,
          RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
      },
      function(module, __webpack_exports__, __webpack_require__) {
        function shallowEqualObjects(objA, objB) {
          if (objA === objB) return !0;
          if (!objA || !objB) return !1;
          var aKeys = Object.keys(objA),
            bKeys = Object.keys(objB),
            len = aKeys.length;
          if (bKeys.length !== len) return !1;
          for (var i = 0; i < len; i++) {
            var key = aKeys[i];
            if (
              objA[key] !== objB[key] ||
              !Object.prototype.hasOwnProperty.call(objB, key)
            )
              return !1;
          }
          return !0;
        }
        function shallowEqualArrays(arrA, arrB) {
          if (arrA === arrB) return !0;
          if (!arrA || !arrB) return !1;
          var len = arrA.length;
          if (arrB.length !== len) return !1;
          for (var i = 0; i < len; i++) if (arrA[i] !== arrB[i]) return !1;
          return !0;
        }
        Object.defineProperty(__webpack_exports__, "__esModule", {
          value: !0
        }),
          __webpack_require__.d(
            __webpack_exports__,
            "shallowEqualArrays",
            function() {
              return shallowEqualArrays;
            }
          ),
          __webpack_require__.d(
            __webpack_exports__,
            "shallowEqualObjects",
            function() {
              return shallowEqualObjects;
            }
          );
      },
      function(module, exports, __webpack_require__) {
        var __assign =
            (this && this.__assign) ||
            function() {
              return (
                (__assign =
                  Object.assign ||
                  function(t) {
                    for (var s, i = 1, n = arguments.length; i < n; i++) {
                      s = arguments[i];
                      for (var p in s)
                        Object.prototype.hasOwnProperty.call(s, p) &&
                          (t[p] = s[p]);
                    }
                    return t;
                  }),
                __assign.apply(this, arguments)
              );
            },
          __rest =
            (this && this.__rest) ||
            function(s, e) {
              var t = {};
              for (var p in s)
                Object.prototype.hasOwnProperty.call(s, p) &&
                  e.indexOf(p) < 0 &&
                  (t[p] = s[p]);
              if (
                null != s &&
                "function" == typeof Object.getOwnPropertySymbols
              )
                for (
                  var i = 0, p = Object.getOwnPropertySymbols(s);
                  i < p.length;
                  i++
                )
                  e.indexOf(p[i]) < 0 &&
                    Object.prototype.propertyIsEnumerable.call(s, p[i]) &&
                    (t[p[i]] = s[p[i]]);
              return t;
            },
          __importDefault =
            (this && this.__importDefault) ||
            function(mod) {
              return mod && mod.__esModule
                ? mod
                : {
                    default: mod
                  };
            };
        Object.defineProperty(exports, "__esModule", {
          value: !0
        });
        var prop_types_1 = __importDefault(__webpack_require__(12)),
          stringOrNumber = prop_types_1.default.oneOfType([
            prop_types_1.default.string,
            prop_types_1.default.number
          ]),
          types = {
            all: prop_types_1.default.bool,
            grid: prop_types_1.default.bool,
            aural: prop_types_1.default.bool,
            braille: prop_types_1.default.bool,
            handheld: prop_types_1.default.bool,
            print: prop_types_1.default.bool,
            projection: prop_types_1.default.bool,
            screen: prop_types_1.default.bool,
            tty: prop_types_1.default.bool,
            tv: prop_types_1.default.bool,
            embossed: prop_types_1.default.bool
          },
          matchers = {
            orientation: prop_types_1.default.oneOf(["portrait", "landscape"]),
            scan: prop_types_1.default.oneOf(["progressive", "interlace"]),
            aspectRatio: prop_types_1.default.string,
            deviceAspectRatio: prop_types_1.default.string,
            height: stringOrNumber,
            deviceHeight: stringOrNumber,
            width: stringOrNumber,
            deviceWidth: stringOrNumber,
            color: prop_types_1.default.bool,
            colorIndex: prop_types_1.default.bool,
            monochrome: prop_types_1.default.bool,
            resolution: stringOrNumber,
            type: Object.keys(types)
          },
          featureMatchers = __rest(matchers, ["type"]),
          features = __assign(
            {
              minAspectRatio: prop_types_1.default.string,
              maxAspectRatio: prop_types_1.default.string,
              minDeviceAspectRatio: prop_types_1.default.string,
              maxDeviceAspectRatio: prop_types_1.default.string,
              minHeight: stringOrNumber,
              maxHeight: stringOrNumber,
              minDeviceHeight: stringOrNumber,
              maxDeviceHeight: stringOrNumber,
              minWidth: stringOrNumber,
              maxWidth: stringOrNumber,
              minDeviceWidth: stringOrNumber,
              maxDeviceWidth: stringOrNumber,
              minColor: prop_types_1.default.number,
              maxColor: prop_types_1.default.number,
              minColorIndex: prop_types_1.default.number,
              maxColorIndex: prop_types_1.default.number,
              minMonochrome: prop_types_1.default.number,
              maxMonochrome: prop_types_1.default.number,
              minResolution: stringOrNumber,
              maxResolution: stringOrNumber
            },
            featureMatchers
          ),
          all = __assign(__assign({}, types), features);
        exports.default = {
          all: all,
          types: types,
          matchers: matchers,
          features: features
        };
      },
      function(module, exports, __webpack_require__) {
        var ReactIs = __webpack_require__(4);
        module.exports = __webpack_require__(14)(ReactIs.isElement, !0);
      },
      function(module, exports, __webpack_require__) {
        !(function() {
          function isValidElementType(type) {
            return (
              "string" == typeof type ||
              "function" == typeof type ||
              type === REACT_FRAGMENT_TYPE ||
              type === REACT_CONCURRENT_MODE_TYPE ||
              type === REACT_PROFILER_TYPE ||
              type === REACT_STRICT_MODE_TYPE ||
              type === REACT_SUSPENSE_TYPE ||
              type === REACT_SUSPENSE_LIST_TYPE ||
              ("object" == typeof type &&
                null !== type &&
                (type.$$typeof === REACT_LAZY_TYPE ||
                  type.$$typeof === REACT_MEMO_TYPE ||
                  type.$$typeof === REACT_PROVIDER_TYPE ||
                  type.$$typeof === REACT_CONTEXT_TYPE ||
                  type.$$typeof === REACT_FORWARD_REF_TYPE ||
                  type.$$typeof === REACT_FUNDAMENTAL_TYPE ||
                  type.$$typeof === REACT_RESPONDER_TYPE ||
                  type.$$typeof === REACT_SCOPE_TYPE ||
                  type.$$typeof === REACT_BLOCK_TYPE))
            );
          }
          function typeOf(object) {
            if ("object" == typeof object && null !== object) {
              var $$typeof = object.$$typeof;
              switch ($$typeof) {
                case REACT_ELEMENT_TYPE:
                  var type = object.type;
                  switch (type) {
                    case REACT_ASYNC_MODE_TYPE:
                    case REACT_CONCURRENT_MODE_TYPE:
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                      return type;

                    default:
                      var $$typeofType = type && type.$$typeof;
                      switch ($$typeofType) {
                        case REACT_CONTEXT_TYPE:
                        case REACT_FORWARD_REF_TYPE:
                        case REACT_LAZY_TYPE:
                        case REACT_MEMO_TYPE:
                        case REACT_PROVIDER_TYPE:
                          return $$typeofType;

                        default:
                          return $$typeof;
                      }
                  }

                case REACT_PORTAL_TYPE:
                  return $$typeof;
              }
            }
          }
          function isAsyncMode(object) {
            return (
              hasWarnedAboutDeprecatedIsAsyncMode ||
                ((hasWarnedAboutDeprecatedIsAsyncMode = !0),
                console.warn(
                  "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API."
                )),
              isConcurrentMode(object) ||
                typeOf(object) === REACT_ASYNC_MODE_TYPE
            );
          }
          function isConcurrentMode(object) {
            return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
          }
          function isContextConsumer(object) {
            return typeOf(object) === REACT_CONTEXT_TYPE;
          }
          function isContextProvider(object) {
            return typeOf(object) === REACT_PROVIDER_TYPE;
          }
          function isElement(object) {
            return (
              "object" == typeof object &&
              null !== object &&
              object.$$typeof === REACT_ELEMENT_TYPE
            );
          }
          function isForwardRef(object) {
            return typeOf(object) === REACT_FORWARD_REF_TYPE;
          }
          function isFragment(object) {
            return typeOf(object) === REACT_FRAGMENT_TYPE;
          }
          function isLazy(object) {
            return typeOf(object) === REACT_LAZY_TYPE;
          }
          function isMemo(object) {
            return typeOf(object) === REACT_MEMO_TYPE;
          }
          function isPortal(object) {
            return typeOf(object) === REACT_PORTAL_TYPE;
          }
          function isProfiler(object) {
            return typeOf(object) === REACT_PROFILER_TYPE;
          }
          function isStrictMode(object) {
            return typeOf(object) === REACT_STRICT_MODE_TYPE;
          }
          function isSuspense(object) {
            return typeOf(object) === REACT_SUSPENSE_TYPE;
          }
          var hasSymbol = "function" == typeof Symbol && Symbol.for,
            REACT_ELEMENT_TYPE = hasSymbol
              ? Symbol.for("react.element")
              : 60103,
            REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106,
            REACT_FRAGMENT_TYPE = hasSymbol
              ? Symbol.for("react.fragment")
              : 60107,
            REACT_STRICT_MODE_TYPE = hasSymbol
              ? Symbol.for("react.strict_mode")
              : 60108,
            REACT_PROFILER_TYPE = hasSymbol
              ? Symbol.for("react.profiler")
              : 60114,
            REACT_PROVIDER_TYPE = hasSymbol
              ? Symbol.for("react.provider")
              : 60109,
            REACT_CONTEXT_TYPE = hasSymbol
              ? Symbol.for("react.context")
              : 60110,
            REACT_ASYNC_MODE_TYPE = hasSymbol
              ? Symbol.for("react.async_mode")
              : 60111,
            REACT_CONCURRENT_MODE_TYPE = hasSymbol
              ? Symbol.for("react.concurrent_mode")
              : 60111,
            REACT_FORWARD_REF_TYPE = hasSymbol
              ? Symbol.for("react.forward_ref")
              : 60112,
            REACT_SUSPENSE_TYPE = hasSymbol
              ? Symbol.for("react.suspense")
              : 60113,
            REACT_SUSPENSE_LIST_TYPE = hasSymbol
              ? Symbol.for("react.suspense_list")
              : 60120,
            REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115,
            REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116,
            REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121,
            REACT_FUNDAMENTAL_TYPE = hasSymbol
              ? Symbol.for("react.fundamental")
              : 60117,
            REACT_RESPONDER_TYPE = hasSymbol
              ? Symbol.for("react.responder")
              : 60118,
            REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119,
            AsyncMode = REACT_ASYNC_MODE_TYPE,
            ConcurrentMode = REACT_CONCURRENT_MODE_TYPE,
            ContextConsumer = REACT_CONTEXT_TYPE,
            ContextProvider = REACT_PROVIDER_TYPE,
            Element = REACT_ELEMENT_TYPE,
            ForwardRef = REACT_FORWARD_REF_TYPE,
            Fragment = REACT_FRAGMENT_TYPE,
            Lazy = REACT_LAZY_TYPE,
            Memo = REACT_MEMO_TYPE,
            Portal = REACT_PORTAL_TYPE,
            Profiler = REACT_PROFILER_TYPE,
            StrictMode = REACT_STRICT_MODE_TYPE,
            Suspense = REACT_SUSPENSE_TYPE,
            hasWarnedAboutDeprecatedIsAsyncMode = !1;
          (exports.AsyncMode = AsyncMode),
            (exports.ConcurrentMode = ConcurrentMode),
            (exports.ContextConsumer = ContextConsumer),
            (exports.ContextProvider = ContextProvider),
            (exports.Element = Element),
            (exports.ForwardRef = ForwardRef),
            (exports.Fragment = Fragment),
            (exports.Lazy = Lazy),
            (exports.Memo = Memo),
            (exports.Portal = Portal),
            (exports.Profiler = Profiler),
            (exports.StrictMode = StrictMode),
            (exports.Suspense = Suspense),
            (exports.isAsyncMode = isAsyncMode),
            (exports.isConcurrentMode = isConcurrentMode),
            (exports.isContextConsumer = isContextConsumer),
            (exports.isContextProvider = isContextProvider),
            (exports.isElement = isElement),
            (exports.isForwardRef = isForwardRef),
            (exports.isFragment = isFragment),
            (exports.isLazy = isLazy),
            (exports.isMemo = isMemo),
            (exports.isPortal = isPortal),
            (exports.isProfiler = isProfiler),
            (exports.isStrictMode = isStrictMode),
            (exports.isSuspense = isSuspense),
            (exports.isValidElementType = isValidElementType),
            (exports.typeOf = typeOf);
        })();
      },
      function(module, exports, __webpack_require__) {
        function emptyFunctionThatReturnsNull() {
          return null;
        }
        var ReactIs = __webpack_require__(4),
          assign = __webpack_require__(15),
          ReactPropTypesSecret = __webpack_require__(5),
          checkPropTypes = __webpack_require__(16),
          has = Function.call.bind(Object.prototype.hasOwnProperty),
          printWarning = function() {};
        (printWarning = function(text) {
          var message = "Warning: " + text;
          "undefined" != typeof console && console.error(message);
          try {
            throw new Error(message);
          } catch (x) {}
        }),
          (module.exports = function(isValidElement, throwOnDirectAccess) {
            function getIteratorFn(maybeIterable) {
              var iteratorFn =
                maybeIterable &&
                ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
                  maybeIterable[FAUX_ITERATOR_SYMBOL]);
              if ("function" == typeof iteratorFn) return iteratorFn;
            }
            function is(x, y) {
              return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
            }
            function PropTypeError(message) {
              (this.message = message), (this.stack = "");
            }
            function createChainableTypeChecker(validate) {
              function checkType(
                isRequired,
                props,
                propName,
                componentName,
                location,
                propFullName,
                secret
              ) {
                if (
                  ((componentName = componentName || ANONYMOUS),
                  (propFullName = propFullName || propName),
                  secret !== ReactPropTypesSecret)
                ) {
                  if (throwOnDirectAccess) {
                    var err = new Error(
                      "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                    );
                    throw ((err.name = "Invariant Violation"), err);
                  }
                  if ("undefined" != typeof console) {
                    var cacheKey = componentName + ":" + propName;
                    !manualPropTypeCallCache[cacheKey] &&
                      manualPropTypeWarningCount < 3 &&
                      (printWarning(
                        "You are manually calling a React.PropTypes validation function for the `" +
                          propFullName +
                          "` prop on `" +
                          componentName +
                          "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                      ),
                      (manualPropTypeCallCache[cacheKey] = !0),
                      manualPropTypeWarningCount++);
                  }
                }
                return null == props[propName]
                  ? isRequired
                    ? new PropTypeError(
                        null === props[propName]
                          ? "The " +
                            location +
                            " `" +
                            propFullName +
                            "` is marked as required in `" +
                            componentName +
                            "`, but its value is `null`."
                          : "The " +
                            location +
                            " `" +
                            propFullName +
                            "` is marked as required in `" +
                            componentName +
                            "`, but its value is `undefined`."
                      )
                    : null
                  : validate(
                      props,
                      propName,
                      componentName,
                      location,
                      propFullName
                    );
              }
              var manualPropTypeCallCache = {},
                manualPropTypeWarningCount = 0,
                chainedCheckType = checkType.bind(null, !1);
              return (
                (chainedCheckType.isRequired = checkType.bind(null, !0)),
                chainedCheckType
              );
            }
            function createPrimitiveTypeChecker(expectedType) {
              function validate(
                props,
                propName,
                componentName,
                location,
                propFullName,
                secret
              ) {
                var propValue = props[propName];
                if (getPropType(propValue) !== expectedType)
                  return new PropTypeError(
                    "Invalid " +
                      location +
                      " `" +
                      propFullName +
                      "` of type `" +
                      getPreciseType(propValue) +
                      "` supplied to `" +
                      componentName +
                      "`, expected `" +
                      expectedType +
                      "`."
                  );
                return null;
              }
              return createChainableTypeChecker(validate);
            }
            function createArrayOfTypeChecker(typeChecker) {
              function validate(
                props,
                propName,
                componentName,
                location,
                propFullName
              ) {
                if ("function" != typeof typeChecker)
                  return new PropTypeError(
                    "Property `" +
                      propFullName +
                      "` of component `" +
                      componentName +
                      "` has invalid PropType notation inside arrayOf."
                  );
                var propValue = props[propName];
                if (!Array.isArray(propValue)) {
                  return new PropTypeError(
                    "Invalid " +
                      location +
                      " `" +
                      propFullName +
                      "` of type `" +
                      getPropType(propValue) +
                      "` supplied to `" +
                      componentName +
                      "`, expected an array."
                  );
                }
                for (var i = 0; i < propValue.length; i++) {
                  var error = typeChecker(
                    propValue,
                    i,
                    componentName,
                    location,
                    propFullName + "[" + i + "]",
                    ReactPropTypesSecret
                  );
                  if (error instanceof Error) return error;
                }
                return null;
              }
              return createChainableTypeChecker(validate);
            }
            function createInstanceTypeChecker(expectedClass) {
              function validate(
                props,
                propName,
                componentName,
                location,
                propFullName
              ) {
                if (!(props[propName] instanceof expectedClass)) {
                  var expectedClassName = expectedClass.name || ANONYMOUS;
                  return new PropTypeError(
                    "Invalid " +
                      location +
                      " `" +
                      propFullName +
                      "` of type `" +
                      getClassName(props[propName]) +
                      "` supplied to `" +
                      componentName +
                      "`, expected instance of `" +
                      expectedClassName +
                      "`."
                  );
                }
                return null;
              }
              return createChainableTypeChecker(validate);
            }
            function createEnumTypeChecker(expectedValues) {
              function validate(
                props,
                propName,
                componentName,
                location,
                propFullName
              ) {
                for (
                  var propValue = props[propName], i = 0;
                  i < expectedValues.length;
                  i++
                )
                  if (is(propValue, expectedValues[i])) return null;
                var valuesString = JSON.stringify(expectedValues, function(
                  key,
                  value
                ) {
                  return "symbol" === getPreciseType(value)
                    ? String(value)
                    : value;
                });
                return new PropTypeError(
                  "Invalid " +
                    location +
                    " `" +
                    propFullName +
                    "` of value `" +
                    String(propValue) +
                    "` supplied to `" +
                    componentName +
                    "`, expected one of " +
                    valuesString +
                    "."
                );
              }
              return Array.isArray(expectedValues)
                ? createChainableTypeChecker(validate)
                : (printWarning(
                    arguments.length > 1
                      ? "Invalid arguments supplied to oneOf, expected an array, got " +
                          arguments.length +
                          " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                      : "Invalid argument supplied to oneOf, expected an array."
                  ),
                  emptyFunctionThatReturnsNull);
            }
            function createObjectOfTypeChecker(typeChecker) {
              function validate(
                props,
                propName,
                componentName,
                location,
                propFullName
              ) {
                if ("function" != typeof typeChecker)
                  return new PropTypeError(
                    "Property `" +
                      propFullName +
                      "` of component `" +
                      componentName +
                      "` has invalid PropType notation inside objectOf."
                  );
                var propValue = props[propName],
                  propType = getPropType(propValue);
                if ("object" !== propType)
                  return new PropTypeError(
                    "Invalid " +
                      location +
                      " `" +
                      propFullName +
                      "` of type `" +
                      propType +
                      "` supplied to `" +
                      componentName +
                      "`, expected an object."
                  );
                for (var key in propValue)
                  if (has(propValue, key)) {
                    var error = typeChecker(
                      propValue,
                      key,
                      componentName,
                      location,
                      propFullName + "." + key,
                      ReactPropTypesSecret
                    );
                    if (error instanceof Error) return error;
                  }
                return null;
              }
              return createChainableTypeChecker(validate);
            }
            function createUnionTypeChecker(arrayOfTypeCheckers) {
              function validate(
                props,
                propName,
                componentName,
                location,
                propFullName
              ) {
                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                  if (
                    null ==
                    (0, arrayOfTypeCheckers[i])(
                      props,
                      propName,
                      componentName,
                      location,
                      propFullName,
                      ReactPropTypesSecret
                    )
                  )
                    return null;
                }
                return new PropTypeError(
                  "Invalid " +
                    location +
                    " `" +
                    propFullName +
                    "` supplied to `" +
                    componentName +
                    "`."
                );
              }
              if (!Array.isArray(arrayOfTypeCheckers))
                return (
                  printWarning(
                    "Invalid argument supplied to oneOfType, expected an instance of array."
                  ),
                  emptyFunctionThatReturnsNull
                );
              for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                var checker = arrayOfTypeCheckers[i];
                if ("function" != typeof checker)
                  return (
                    printWarning(
                      "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " +
                        getPostfixForTypeWarning(checker) +
                        " at index " +
                        i +
                        "."
                    ),
                    emptyFunctionThatReturnsNull
                  );
              }
              return createChainableTypeChecker(validate);
            }
            function createShapeTypeChecker(shapeTypes) {
              function validate(
                props,
                propName,
                componentName,
                location,
                propFullName
              ) {
                var propValue = props[propName],
                  propType = getPropType(propValue);
                if ("object" !== propType)
                  return new PropTypeError(
                    "Invalid " +
                      location +
                      " `" +
                      propFullName +
                      "` of type `" +
                      propType +
                      "` supplied to `" +
                      componentName +
                      "`, expected `object`."
                  );
                for (var key in shapeTypes) {
                  var checker = shapeTypes[key];
                  if (checker) {
                    var error = checker(
                      propValue,
                      key,
                      componentName,
                      location,
                      propFullName + "." + key,
                      ReactPropTypesSecret
                    );
                    if (error) return error;
                  }
                }
                return null;
              }
              return createChainableTypeChecker(validate);
            }
            function createStrictShapeTypeChecker(shapeTypes) {
              function validate(
                props,
                propName,
                componentName,
                location,
                propFullName
              ) {
                var propValue = props[propName],
                  propType = getPropType(propValue);
                if ("object" !== propType)
                  return new PropTypeError(
                    "Invalid " +
                      location +
                      " `" +
                      propFullName +
                      "` of type `" +
                      propType +
                      "` supplied to `" +
                      componentName +
                      "`, expected `object`."
                  );
                var allKeys = assign({}, props[propName], shapeTypes);
                for (var key in allKeys) {
                  var checker = shapeTypes[key];
                  if (!checker)
                    return new PropTypeError(
                      "Invalid " +
                        location +
                        " `" +
                        propFullName +
                        "` key `" +
                        key +
                        "` supplied to `" +
                        componentName +
                        "`.\nBad object: " +
                        JSON.stringify(props[propName], null, "  ") +
                        "\nValid keys: " +
                        JSON.stringify(Object.keys(shapeTypes), null, "  ")
                    );
                  var error = checker(
                    propValue,
                    key,
                    componentName,
                    location,
                    propFullName + "." + key,
                    ReactPropTypesSecret
                  );
                  if (error) return error;
                }
                return null;
              }
              return createChainableTypeChecker(validate);
            }
            function isNode(propValue) {
              switch (typeof propValue) {
                case "number":
                case "string":
                case "undefined":
                  return !0;

                case "boolean":
                  return !propValue;

                case "object":
                  if (Array.isArray(propValue)) return propValue.every(isNode);
                  if (null === propValue || isValidElement(propValue))
                    return !0;
                  var iteratorFn = getIteratorFn(propValue);
                  if (!iteratorFn) return !1;
                  var step,
                    iterator = iteratorFn.call(propValue);
                  if (iteratorFn !== propValue.entries) {
                    for (; !(step = iterator.next()).done; )
                      if (!isNode(step.value)) return !1;
                  } else
                    for (; !(step = iterator.next()).done; ) {
                      var entry = step.value;
                      if (entry && !isNode(entry[1])) return !1;
                    }
                  return !0;

                default:
                  return !1;
              }
            }
            function isSymbol(propType, propValue) {
              return (
                "symbol" === propType ||
                (!!propValue &&
                  ("Symbol" === propValue["@@toStringTag"] ||
                    ("function" == typeof Symbol &&
                      propValue instanceof Symbol)))
              );
            }
            function getPropType(propValue) {
              var propType = typeof propValue;
              return Array.isArray(propValue)
                ? "array"
                : propValue instanceof RegExp
                ? "object"
                : isSymbol(propType, propValue)
                ? "symbol"
                : propType;
            }
            function getPreciseType(propValue) {
              if (void 0 === propValue || null === propValue)
                return "" + propValue;
              var propType = getPropType(propValue);
              if ("object" === propType) {
                if (propValue instanceof Date) return "date";
                if (propValue instanceof RegExp) return "regexp";
              }
              return propType;
            }
            function getPostfixForTypeWarning(value) {
              var type = getPreciseType(value);
              switch (type) {
                case "array":
                case "object":
                  return "an " + type;

                case "boolean":
                case "date":
                case "regexp":
                  return "a " + type;

                default:
                  return type;
              }
            }
            function getClassName(propValue) {
              return propValue.constructor && propValue.constructor.name
                ? propValue.constructor.name
                : ANONYMOUS;
            }
            var ITERATOR_SYMBOL =
                "function" == typeof Symbol && Symbol.iterator,
              FAUX_ITERATOR_SYMBOL = "@@iterator",
              ANONYMOUS = "<<anonymous>>",
              ReactPropTypes = {
                array: createPrimitiveTypeChecker("array"),
                bool: createPrimitiveTypeChecker("boolean"),
                func: createPrimitiveTypeChecker("function"),
                number: createPrimitiveTypeChecker("number"),
                object: createPrimitiveTypeChecker("object"),
                string: createPrimitiveTypeChecker("string"),
                symbol: createPrimitiveTypeChecker("symbol"),
                any: (function() {
                  return createChainableTypeChecker(
                    emptyFunctionThatReturnsNull
                  );
                })(),
                arrayOf: createArrayOfTypeChecker,
                element: (function() {
                  function validate(
                    props,
                    propName,
                    componentName,
                    location,
                    propFullName
                  ) {
                    var propValue = props[propName];
                    if (!isValidElement(propValue)) {
                      return new PropTypeError(
                        "Invalid " +
                          location +
                          " `" +
                          propFullName +
                          "` of type `" +
                          getPropType(propValue) +
                          "` supplied to `" +
                          componentName +
                          "`, expected a single ReactElement."
                      );
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                })(),
                elementType: (function() {
                  function validate(
                    props,
                    propName,
                    componentName,
                    location,
                    propFullName
                  ) {
                    var propValue = props[propName];
                    if (!ReactIs.isValidElementType(propValue)) {
                      return new PropTypeError(
                        "Invalid " +
                          location +
                          " `" +
                          propFullName +
                          "` of type `" +
                          getPropType(propValue) +
                          "` supplied to `" +
                          componentName +
                          "`, expected a single ReactElement type."
                      );
                    }
                    return null;
                  }
                  return createChainableTypeChecker(validate);
                })(),
                instanceOf: createInstanceTypeChecker,
                node: (function() {
                  function validate(
                    props,
                    propName,
                    componentName,
                    location,
                    propFullName
                  ) {
                    return isNode(props[propName])
                      ? null
                      : new PropTypeError(
                          "Invalid " +
                            location +
                            " `" +
                            propFullName +
                            "` supplied to `" +
                            componentName +
                            "`, expected a ReactNode."
                        );
                  }
                  return createChainableTypeChecker(validate);
                })(),
                objectOf: createObjectOfTypeChecker,
                oneOf: createEnumTypeChecker,
                oneOfType: createUnionTypeChecker,
                shape: createShapeTypeChecker,
                exact: createStrictShapeTypeChecker
              };
            return (
              (PropTypeError.prototype = Error.prototype),
              (ReactPropTypes.checkPropTypes = checkPropTypes),
              (ReactPropTypes.resetWarningCache =
                checkPropTypes.resetWarningCache),
              (ReactPropTypes.PropTypes = ReactPropTypes),
              ReactPropTypes
            );
          });
      },
      function(module, exports, __webpack_require__) {
        function toObject(val) {
          if (null === val || void 0 === val)
            throw new TypeError(
              "Object.assign cannot be called with null or undefined"
            );
          return Object(val);
        }
        /*
object-assign
(c) Sindre Sorhus
@license MIT
*/
        var getOwnPropertySymbols = Object.getOwnPropertySymbols,
          hasOwnProperty = Object.prototype.hasOwnProperty,
          propIsEnumerable = Object.prototype.propertyIsEnumerable;
        module.exports = (function() {
          try {
            if (!Object.assign) return !1;
            var test1 = new String("abc");
            if (
              ((test1[5] = "de"), "5" === Object.getOwnPropertyNames(test1)[0])
            )
              return !1;
            for (var test2 = {}, i = 0; i < 10; i++)
              test2["_" + String.fromCharCode(i)] = i;
            if (
              "0123456789" !==
              Object.getOwnPropertyNames(test2)
                .map(function(n) {
                  return test2[n];
                })
                .join("")
            )
              return !1;
            var test3 = {};
            return (
              "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                test3[letter] = letter;
              }),
              "abcdefghijklmnopqrst" ===
                Object.keys(Object.assign({}, test3)).join("")
            );
          } catch (err) {
            return !1;
          }
        })()
          ? Object.assign
          : function(target, source) {
              for (
                var from, symbols, to = toObject(target), s = 1;
                s < arguments.length;
                s++
              ) {
                from = Object(arguments[s]);
                for (var key in from)
                  hasOwnProperty.call(from, key) && (to[key] = from[key]);
                if (getOwnPropertySymbols) {
                  symbols = getOwnPropertySymbols(from);
                  for (var i = 0; i < symbols.length; i++)
                    propIsEnumerable.call(from, symbols[i]) &&
                      (to[symbols[i]] = from[symbols[i]]);
                }
              }
              return to;
            };
      },
      function(module, exports, __webpack_require__) {
        function checkPropTypes(
          typeSpecs,
          values,
          location,
          componentName,
          getStack
        ) {
          for (var typeSpecName in typeSpecs)
            if (has(typeSpecs, typeSpecName)) {
              var error;
              try {
                if ("function" != typeof typeSpecs[typeSpecName]) {
                  var err = Error(
                    (componentName || "React class") +
                      ": " +
                      location +
                      " type `" +
                      typeSpecName +
                      "` is invalid; it must be a function, usually from the `prop-types` package, but received `" +
                      typeof typeSpecs[typeSpecName] +
                      "`."
                  );
                  throw ((err.name = "Invariant Violation"), err);
                }
                error = typeSpecs[typeSpecName](
                  values,
                  typeSpecName,
                  componentName,
                  location,
                  null,
                  ReactPropTypesSecret
                );
              } catch (ex) {
                error = ex;
              }
              if (
                (!error ||
                  error instanceof Error ||
                  printWarning(
                    (componentName || "React class") +
                      ": type specification of " +
                      location +
                      " `" +
                      typeSpecName +
                      "` is invalid; the type checker function must return `null` or an `Error` but returned a " +
                      typeof error +
                      ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                  ),
                error instanceof Error &&
                  !(error.message in loggedTypeFailures))
              ) {
                loggedTypeFailures[error.message] = !0;
                var stack = getStack ? getStack() : "";
                printWarning(
                  "Failed " +
                    location +
                    " type: " +
                    error.message +
                    (null != stack ? stack : "")
                );
              }
            }
        }
        var printWarning = function() {},
          ReactPropTypesSecret = __webpack_require__(5),
          loggedTypeFailures = {},
          has = Function.call.bind(Object.prototype.hasOwnProperty);
        (printWarning = function(text) {
          var message = "Warning: " + text;
          "undefined" != typeof console && console.error(message);
          try {
            throw new Error(message);
          } catch (x) {}
        }),
          (checkPropTypes.resetWarningCache = function() {
            loggedTypeFailures = {};
          }),
          (module.exports = checkPropTypes);
      },
      function(module, exports, __webpack_require__) {
        var __rest =
            (this && this.__rest) ||
            function(s, e) {
              var t = {};
              for (var p in s)
                Object.prototype.hasOwnProperty.call(s, p) &&
                  e.indexOf(p) < 0 &&
                  (t[p] = s[p]);
              if (
                null != s &&
                "function" == typeof Object.getOwnPropertySymbols
              )
                for (
                  var i = 0, p = Object.getOwnPropertySymbols(s);
                  i < p.length;
                  i++
                )
                  e.indexOf(p[i]) < 0 &&
                    Object.prototype.propertyIsEnumerable.call(s, p[i]) &&
                    (t[p[i]] = s[p[i]]);
              return t;
            },
          __importDefault =
            (this && this.__importDefault) ||
            function(mod) {
              return mod && mod.__esModule
                ? mod
                : {
                    default: mod
                  };
            };
        Object.defineProperty(exports, "__esModule", {
          value: !0
        });
        var useMediaQuery_1 = __importDefault(__webpack_require__(0)),
          MediaQuery = function(_a) {
            var children = _a.children,
              device = _a.device,
              onChange = _a.onChange,
              settings = __rest(_a, ["children", "device", "onChange"]),
              matches = (0, useMediaQuery_1.default)(
                settings,
                device,
                onChange
              );
            return "function" == typeof children
              ? children(matches)
              : matches
              ? children
              : null;
          };
        exports.default = MediaQuery;
      }
    ]);
  });
})(reactResponsive);

var MediaQuery = /*@__PURE__*/ getDefaultExportFromCjs(reactResponsive.exports);

var useAppHeight = function useAppHeight() {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    oriFontSize = _useState2[0],
    setOriFontSize = _useState2[1];

  useEffect(function() {
    function appHeight() {
      var doc = document.documentElement;
      doc.style.setProperty("--vh", window.innerHeight * 0.01 + "px");
    }

    appHeight();
    window.addEventListener("resize", appHeight);
    setOriFontSize(document.documentElement.style.fontSize); // make sure rem is base on 14px

    document.documentElement.style.fontSize = "14px";
    return function() {
      window.removeEventListener("resize", appHeight);
      document.documentElement.style.fontSize = oriFontSize;
    };
  }, []);
};

var MobileDetector = function MobileDetector(_ref) {
  var desktopChildren = _ref.desktopChildren,
    mobileChildren = _ref.mobileChildren;
  useAppHeight();
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "stkLibPage"
    },
    /*#__PURE__*/ React.createElement(
      MediaQuery,
      {
        query: "(min-device-width: 1224px)"
      },
      desktopChildren
    ),
    /*#__PURE__*/ React.createElement(
      MediaQuery,
      {
        query: "(max-device-width: 1224px)"
      },
      mobileChildren
    )
  );
};
MobileDetector.prototype = {
  desktopChildren: PropTypes.any,
  mobileChildren: PropTypes.any
};

var STK_Workshop_LOGO =
  "data:image/png;base64,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";

var right2 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA1UlEQVQ4T63TMU5CQRDG8d/0amVpj8RGvYCcgUSksJfGKwAewxNIQqe1XkE74w2sjf2YJbyIL4E85G21m535z3y780VmBi5xjLJvut4xj8wcYLZlcimSGBbAGHflgI+G5TvLotMCmGCKs4h4WwVk5l5EfNehmXmK15K3FpCZJ0UjbiPiuQb+A7hAD/cR8VkFZuY5HrGP64h4Wrn7BWzSvOziBQcYVJC6hBuMNoCOcIgv9IucdgFtSNjtEdfNwTbf2Nog/XuUr/Cwi5kqO3cbGqkKW9j5B6synoNLTY58AAAAAElFTkSuQmCC";

var zhHK = {
  "common.mainleft3": "登出",
  "login.login1": "登入帳戶",
  "login.login2": "請輸入您訂單的電子郵箱跟密碼登入",
  "login.login3": "電郵地址",
  "login.login4": "密碼",
  "login.login5": "登 錄",
  "login.login6": "忘記密碼?",
  invalidlogincredentials: "你輸入的密碼和賬戶名不匹配",
  notyouraccount: "不是您嗎？ ",
  notyouraccount2: "登入其他帳戶。",
  "forgot.forgot1": "登錄時遇到問題？",
  "forgot.forgot2": "請在下面輸入您的電郵地址並重置密碼",
  "forgot.forgot3": "你的電郵地址",
  "forgot.forgot4": "重置密碼",
  "forgot.forgot5": "郵件發送",
  ordervalidinfo: "請輸入以上有效資料",
  "common.mainleft1": "個人資料",
  "common.mainleft2": "訂單記錄",
  "subscription.title": "訂閱",
  orderStatusCreated: "訂單待請款",
  orderStatusConfirmedOrder: "訂單已確認",
  orderStatusPartiallyShipped: "訂單部分的產品已出貨",
  orderStatusFulfilled: "訂單已發貨完成",
  orderStatusPaymentFailed: "訂單請款失敗",
  orderStatusCancelled: "訂單已取消",
  orderStatusRefunded: "訂單已退款",
  order1: "訂單記錄",
  order4: "狀態",
  order5: "數量",
  order6: "價格",
  order7: "如果你對訂單有任何疑問，請致電0809-080-838跟我們的客服聯絡, 謝謝。",
  "order.ref": "訂單編號: ",
  "order.date": "訂單日期: ",
  "order.status": "訂單狀態: ",
  "order.shipto": "送貨地址: ",
  "order.giftmsg": "禮品信息: ",
  "order.ordertotal": "訂單金額: ",
  "order.paytotal": "支付金額: ",
  "order.item": "物品",
  "order.confirmed_order": "訂單已確認",
  "shipmentstatus.status": "貨運狀態",
  shippedqty: "寄出數量: ",
  "subscription.sub": "訂閱訂單",
  cartpaybytermcheckbox: "分期付款",
  cartmonthlypayments: "個月付款",
  accessoriessection23: "展示牌上的姓名: ",
  accessoriessection24: "展示名稱: ",
  breadcrumbproduct: "產品",
  profiledesc1:
    "更改了的地址和電話號碼將會在下次訂購時顯示在購物車的訂單資料中。",
  profiledesc2: "如果您想更改已訂購商品的送貨地址，請與我們聯絡。",
  profiledesc3: "訂戶可以在其帳戶的“訂閱”頁面上查看他們下次發送的地址。",
  proile1: "個人資料",
  proile2: "你的電郵地址",
  proile3: "密碼",
  proile4: "更改密碼",
  proile5: "當前密碼",
  proile6: "新密碼",
  proile7: "設置新密碼",
  "proile.firstname": "名字",
  "proile.lastname": "姓氏",
  "proile.contactnum": "聯絡電話",
  "proile.address1": "地址一",
  "proile.city": "區",
  "proile.country": "國家",
  "proile.save": "保存",
  passwordlength: "您的密碼至少8個字符",
  "cart.cart66": "台灣",
  wrongOldPassword: "舊密碼不正確",
  "subscription.pack": "已運送期數: ",
  "subscription.nextshipment": "預計下個送貨日期: ",
  "subscription.shipaddress": "送貨地址: ",
  "subscription.unsub": "取消訂閱",
  "subscription.unsubtitle": "取消訂閱",
  "subscription.unsubdesc": "您確定要取消此訂閱嗎？",
  "subscription.nounsub": "我要完成我的訂閱",
  "subscription.plzunsub": "取消我的訂閱",
  "cart.receive_date_1": " 至 ",
  "cart.receive_date": "預計送貨日期：",
  "cart.cart1": "購物車",
  "cart.cart2": "送貨資料",
  "cart.cart3": "付款方法",
  "cart.cart4": "產品",
  "cart.cart5": "數量",
  "cart.cart6": "價錢",
  "cart.cart7": "刪除產品",
  "cart.cart8": "不想自己動手組裝?",
  "cart.cart9": "讓我們的模型大師來幫你!",
  "cart.cart10": "送貨費用",
  "cart.cart11": "免費",
  "cart.cart12": "總計",
  "cart.cart13": "預計交貨日期",
  "cart.cart14": "前往結帳",
  "cart.cart46": "所有組裝，並由專業大師級工匠為您組裝",
  "cart.cart47": "取消組裝服務",
  "cart.cart48": "自行組裝套裝",
  "cart.cart64tc": "期後每個月 ",
  "cart.cart64": " ",
  "cart.cart64b": " ",
  "cart.cart64c": "每個月",
  "cart.cart64d": "期後每個月",
  "cart.deposit": "訂金(將不獲退回)",
  "cart.paynow": "馬上支付: ",
  "cart.balancedue": "發貨後餘額付款",
  "cart.discountamt": "折扣",
  "cart.inputdiscount": "輸入優惠券代碼",
  "cart.invaliddiscountcode": "優惠代碼並不適用於購物車",
  "cart.nevermiss": "每期送到府上",
  "cart.freedelivery": "免運費",
  "cart.nocommitment": "無須預先付款",
  "cart.cancelanytime": "可隨時停止訂閱",
  "cart.starter01": "以最低價格開始製作您的拍攝電影用模型復刻品",
  "cart.starter02":
    "如果您決定組裝其餘部份，您可以今天於網站上顯示的價格繼續訂購。",
  "cart.starter03": "完成整套模型後，您可免費獲得訂戶禮物。",
  "cart.starter04":
    "不想繼續組裝嗎？無需煩惱，什麼都不用做。我們不會再收取任何額外費用。",
  "cart.pack1disclaimer1": "您的第1期組合包含",
  "cart.pack1disclaimer2": "駕駛艙和內部船艙所需的所有零件，如圖。",
  "cart.pack1disclaimer3": "要以特別折扣價訂購",
  "cart.pack1disclaimer4": "千年鷹號",
  "cart.pack1disclaimer5": " ",
  "cart.pack1disclaimer6": "完整組合，",
  "cart.pack1disclaimer7": "請點擊這裡訂購系列",
  "cart.depositdisclaimer0":
    "請注意: 全套收藏版終極模型為客製化商品，不適用於七天鑑賞期。",
  "cart.depositdisclaimer1":
    "終極模型訂單需要先付訂金才能訂閱。 我們現在只會先收取訂閱訂金。 當產品準備好發貨後，我們會再收取餘額付款。 請注意，訂閱訂金是不予退還的 - 如果您在發貨前取消訂單，則不會退還訂金。",
  "cart.depositdisclaimer2": "有關詳細信息，請參閱常見問題。",
  cartremoveitemheader: "刪除產品",
  cartremoveitem: "您確定要從購物車中刪除此商品嗎？",
  cartremoveconfirm: "刪除",
  cartremovecancel: "取消",
  "cart.empty1": "你的購物車內沒有貨品。",
  "cart.empty2": " ",
  "cart.empty3": "繼續購物",
  "cart.continueshopping": "繼續購物",
  snhBenefit1: "95折優惠",
  snhBenefit2: "宅配免運費",
  snhBenefit3: "可隨時取消訂閱",
  snhBenefit4: "提前收到*",
  snhBenefit5: "不錯過任何一期",
  snhBenefit6: "專屬贈品大型Snoopy玩偶*",
  amcBenefit1: "95折優惠",
  amcBenefit2: "宅配免運費",
  amcBenefit3: "可隨時取消訂閱",
  amcBenefit4: "提前收到*",
  amcBenefit5: "不錯過任何一期",
  amcBenefit6: "贈送SHELBY COBRA",
  amcBenefit7: "7月10日前開始訂閱送您第6期Ford Mustang Boss 429",
  kncBenefit1: "95折優惠",
  kncBenefit2: "宅配免運費",
  kncBenefit3: "可隨時取消訂閱",
  kncBenefit4: "提前收到*",
  kncBenefit5: "不錯過任何一期",
  kncBenefit6: "贈送Hello Kitty 胸章套組",
  cartBenefitDisclaimer1: "* 有關詳細資料，請參閱",
  cartBenefitDisclaimer2: "常見問題",
  cartBenefitDisclaimer3: "。",
  acceleratedDisclaimer1: "你現在購買的是千歲鷹號 10 期組件內的 1-5 期。",
  acceleratedDisclaimer2:
    "這訂單並沒有強制性要購買第 6-10 期的。 您不會自動為任何後續期數付費。",
  acceleratedDisclaimer3:
    "如要完成您的千歲鷹號整機組裝的話，請在成功訂購第 1-5 期後的六個月內再次與我們聯絡，您可以選擇",
  acceleratedDisclaimer4a: "(1) 以 NT$ ",
  acceleratedDisclaimer4b: " 一次過購入餘下5期或 (2) 每月 NT$ ",
  acceleratedDisclaimer4c: " (共5個月)。",
  acceleratedDisclaimer5: "請參閱常見問題解答以獲取更多信息。",
  r2d2StarterDisclaimer1: "你現在購買的是 R2-D2 12 期組件內的 1-5 期。",
  r2d2StarterDisclaimer2:
    "這訂單並沒有強制性要購買第 6-12 期的。 您不會自動為任何後續期數付費。",
  r2d2StarterDisclaimer3:
    "如要完成您的 R2-D2 完整組裝的話，請在成功訂購第 1-5 期後的六個月內再次與我們聯絡，您可以選擇",
  r2d2StarterDisclaimer4a: "(1) 以 NT$ ",
  r2d2StarterDisclaimer4b: " 一次過購入餘下7期或 (2) 每月 NT$ ",
  r2d2StarterDisclaimer4c: " (共7個月)。",
  r2d2StarterDisclaimer5: "請參閱常見問題解答以獲取更多信息。",
  "cart.cart15": "個人資料",
  "cart.cart16": "買家名字",
  "cart.cart17": "買家姓氏",
  "cart.cart18": "你的電郵地址",
  "cart.emaildisclaimer": "我們會把所有的訂單通知和追踪號碼發送到此電郵地址。",
  "cart.mobiledisclaimer": "如交付時遇到任何問題, 我們會聯絡此電話號碼",
  "cart.passworddisclaimer":
    "登記帳戶來查看您的訂單，接收免費禮品等資訊。 （可選的）",
  "cart.cart21": "收件地址",
  "cart.cart22": "收件人",
  "cart.cart23": "地址一",
  "cart.cart26": "國家",
  "cart.cart27": "這訂單是禮物",
  "cart.cart28": "您的信息將包含在產品包裝盒內",
  "cart.cart29": "繼續",
  "cart.cart30": "訂單摘要",
  "cart.cart32": "數量",
  "cart.cart33": "價格",
  "cart.cart45": "密碼 (最少八個字)",
  "cart.cart69": "買家聯絡電話",
  "cart.cart70": "收件人電話號碼",
  ordervalidemailconfirm: "您的確認電子郵件地址與您的電子郵件地址不符。",
  paymentdisclaimer: "如您繼續提交訂單, 將被視為您已閱讀、理解、並同意我們的",
  paymentdisclaimer2: "條款與條件",
  paymentdisclaimer3: "及",
  paymentdisclaimer4: "隱私政策。",
  paymentdepositdisclaimer:
    "我理解並同意此終極模型訂單的訂金是不可退還的。 我亦理解並同意",
  paymentdepositdisclaimer2: "條款和細則，包括取消政策。",
  mustagreedisclaimer: "付款前必須同意我們的條款和細則，包括取消政策。",
  "cart.cart34": "感謝您的選購！",
  "cart.cart35": "您的付款已成功處理。 我們已發送了訂單確認到您的電子郵箱。",
  "cart.cart36": "回到主頁",
  "cart.cart37": "請完成“建立您的帳戶”",
  "cart.cart38": "設置密碼建立帳戶，以便您可以隨時登錄並查看訂單歷史記錄。",
  "cart.cart39": "你的電郵地址",
  "cart.cart41": "創建帳戶",
  reginfovalid: "請輸入以上有效資料",
  "cart.cart61": "付款不成功",
  "cart.cart62":
    "您的交易無法處理。 沒有從您的帳戶中扣款。 請再試一次。 如果問題仍然存在，請聯繫客戶服務。",
  "cart.cart63": "請返回再次嘗試付款",
  twCity: "市/縣",
  twDistrict: "區",
  postal_code: "郵遞區號",
  "twCity.taipeiCity": "臺北市",
  "twCity.keelungCity": "基隆市",
  "twCity.newTaipeiCity": "新北市",
  "twCity.yilanCounty": "宜蘭縣",
  "twCity.hsinchuCity": "新竹市",
  "twCity.hsinchuCounty": "新竹縣",
  "twCity.taoyuanCity": "桃園市",
  "twCity.miaoliCounty": "苗栗縣",
  "twCity.taichungCity": "臺中市",
  "twCity.changhuaCounty": "彰化縣",
  "twCity.nantouCounty": "南投縣",
  "twCity.chiayiCity": "嘉義市",
  "twCity.chiayiCounty": "嘉義縣",
  "twCity.yunlinCounty": "雲林縣",
  "twCity.tainanCity": "臺南市",
  "twCity.kaohsiungCity": "高雄市",
  "twCity.southChinaSeaIslands": "南海諸島",
  "twCity.penghuCounty": "澎湖縣",
  "twCity.pingtungCounty": "屏東縣",
  "twCity.taitungCounty": "臺東縣",
  "twCity.hualienCounty": "花蓮縣",
  "twCity.kinmenIslands": "金門縣",
  "twCity.lienchiangCounty": "連江縣",
  "twDistrict.zhongzhengDistrict": "中正區",
  "twDistrict.datongDistrict": "大同區",
  "twDistrict.zhongshanDistrict": "中山區",
  "twDistrict.songshanDistrict": "松山區",
  "twDistrict.daAnDistrict": "大安區",
  "twDistrict.wanhuaDistrict": "萬華區",
  "twDistrict.xinyiDistrict": "信義區",
  "twDistrict.shilinDistrict": "士林區",
  "twDistrict.beitouDistrict": "北投區",
  "twDistrict.neihuDistrict": "內湖區",
  "twDistrict.nangangDistrict": "南港區",
  "twDistrict.wenshanDistrict": "文山區",
  "twDistrict.renAiDistrict": "仁愛區",
  "twDistrict.anleDistrict": "安樂區",
  "twDistrict.nuannuanDistrict": "暖暖區",
  "twDistrict.qiduDistrict": "七堵區",
  "twDistrict.wanliDistrict": "萬里區",
  "twDistrict.jinshanDistrict": "金山區",
  "twDistrict.banqiaoDistrict": "板橋區",
  "twDistrict.xizhiDistrict": "汐止區",
  "twDistrict.shenkengDistrict": "深坑區",
  "twDistrict.shidingDistrict": "石碇區",
  "twDistrict.ruifangDistrict": "瑞芳區",
  "twDistrict.pingxiDistrict": "平溪區",
  "twDistrict.shuangxiDistrict": "雙溪區",
  "twDistrict.gongliaoDistrict": "貢寮區",
  "twDistrict.xindianDistrict": "新店區",
  "twDistrict.pinglinDistrict": "坪林區",
  "twDistrict.wulaiDistrict": "烏來區",
  "twDistrict.yongheDistrict": "永和區",
  "twDistrict.zhongheDistrict": "中和區",
  "twDistrict.tuchengDistrict": "土城區",
  "twDistrict.sanxiaDistrict": "三峽區",
  "twDistrict.shulinDistrict": "樹林區",
  "twDistrict.yinggeDistrict": "鶯歌區",
  "twDistrict.sanchongDistrict": "三重區",
  "twDistrict.xinzhuangDistrict": "新莊區",
  "twDistrict.taishanDistrict": "泰山區",
  "twDistrict.linkouDistrict": "林口區",
  "twDistrict.luzhouDistrict": "蘆洲區",
  "twDistrict.wuguDistrict": "五股區",
  "twDistrict.baliDistrict": "八里區",
  "twDistrict.tamsuiDistrict": "淡水區",
  "twDistrict.sanzhiDistrict": "三芝區",
  "twDistrict.shimenDistrict": "石門區",
  "twDistrict.yilan": "宜蘭",
  "twDistrict.toucheng": "頭城",
  "twDistrict.jiaoxi": "礁溪",
  "twDistrict.zhuangwei": "壯圍",
  "twDistrict.yuanshan": "員山",
  "twDistrict.luodong": "羅東",
  "twDistrict.sanxing": "三星",
  "twDistrict.datong": "大同",
  "twDistrict.wujie": "五結",
  "twDistrict.dongshan": "冬山",
  "twDistrict.suAo": "蘇澳",
  "twDistrict.nanAo": "南澳",
  "twDistrict.diaoyutaiIslands": "釣魚臺列嶼",
  "twDistrict.eastDistrict": "東區",
  "twDistrict.northDistrict": "北區",
  "twDistrict.xiangshanDistrict": "香山區",
  "twDistrict.zhubei": "竹北",
  "twDistrict.hukou": "湖口",
  "twDistrict.xinfeng": "新豐",
  "twDistrict.xinpu": "新埔",
  "twDistrict.guanxi": "關西",
  "twDistrict.qionglin": "芎林",
  "twDistrict.baoshan": "寶山",
  "twDistrict.zhudong": "竹東",
  "twDistrict.wufeng": "五峰",
  "twDistrict.hengshan": "橫山",
  "twDistrict.jianshi": "尖石",
  "twDistrict.beipu": "北埔",
  "twDistrict.emei": "峨眉",
  "twDistrict.zhongliDistrict": "中壢區",
  "twDistrict.pingzhenDistrict": "平鎮區",
  "twDistrict.longtanDistrict": "龍潭區",
  "twDistrict.yangmeiDistrict": "楊梅區",
  "twDistrict.xinwuDistrict": "新屋區",
  "twDistrict.guanyinDistrict": "觀音區",
  "twDistrict.taoyuanDistrict": "桃園區",
  "twDistrict.guishanDistrict": "龜山區",
  "twDistrict.badeDistrict": "八德區",
  "twDistrict.daxiDistrict": "大溪區",
  "twDistrict.fuxingDistrict": "復興區",
  "twDistrict.dayuanDistrict": "大園區",
  "twDistrict.luzhuDistrict": "蘆竹區",
  "twDistrict.zhunan": "竹南",
  "twDistrict.toufen": "頭份",
  "twDistrict.sanwan": "三灣",
  "twDistrict.nanzhuang": "南庄",
  "twDistrict.shitan": "獅潭",
  "twDistrict.houlong": "後龍",
  "twDistrict.tongxiao": "通霄",
  "twDistrict.yuanli": "苑裡",
  "twDistrict.miaoli": "苗栗",
  "twDistrict.zaoqiao": "造橋",
  "twDistrict.touwu": "頭屋",
  "twDistrict.gongguan": "公館",
  "twDistrict.dahu": "大湖",
  "twDistrict.taiAn": "泰安",
  "twDistrict.tongluo": "銅鑼",
  "twDistrict.sanyi": "三義",
  "twDistrict.xihu": "西湖",
  "twDistrict.zhuolan": "卓蘭",
  "twDistrict.centralDistrict": "中區",
  "twDistrict.southDistrict": "南區",
  "twDistrict.westDistrict": "西區",
  "twDistrict.beitunDistrict": "北屯區",
  "twDistrict.xitunDistrict": "西屯區",
  "twDistrict.nantunDistrict": "南屯區",
  "twDistrict.taipingDistrict": "太平區",
  "twDistrict.daliDistrict": "大里區",
  "twDistrict.wufengDistrict": "霧峰區",
  "twDistrict.wuriDistrict": "烏日區",
  "twDistrict.fengyuanDistrict": "豐原區",
  "twDistrict.houliDistrict": "后里區",
  "twDistrict.shigangDistrict": "石岡區",
  "twDistrict.dongshiDistrict": "東勢區",
  "twDistrict.hepingDistrict": "和平區",
  "twDistrict.xinsheDistrict": "新社區",
  "twDistrict.tanziDistrict": "潭子區",
  "twDistrict.dayaDistrict": "大雅區",
  "twDistrict.shengangDistrict": "神岡區",
  "twDistrict.daduDistrict": "大肚區",
  "twDistrict.shaluDistrict": "沙鹿區",
  "twDistrict.longjingDistrict": "龍井區",
  "twDistrict.wuqiDistrict": "梧棲區",
  "twDistrict.qingshuiDistrict": "清水區",
  "twDistrict.dajiaDistrict": "大甲區",
  "twDistrict.waipuDistrict": "外埔區",
  "twDistrict.changhua": "彰化",
  "twDistrict.fenyuan": "芬園",
  "twDistrict.huatan": "花壇",
  "twDistrict.xiushui": "秀水",
  "twDistrict.lukang": "鹿港",
  "twDistrict.fuxing": "福興",
  "twDistrict.xianxi": "線西",
  "twDistrict.hemei": "和美",
  "twDistrict.shengang": "伸港",
  "twDistrict.yuanlin": "員林",
  "twDistrict.shetou": "社頭",
  "twDistrict.yongjing": "永靖",
  "twDistrict.puxin": "埔心",
  "twDistrict.dacun": "大村",
  "twDistrict.puyan": "埔鹽",
  "twDistrict.tianzhong": "田中",
  "twDistrict.beidou": "北斗",
  "twDistrict.tianwei": "田尾",
  "twDistrict.pitou": "埤頭",
  "twDistrict.xizhou": "溪州",
  "twDistrict.zhutang": "竹塘",
  "twDistrict.erlin": "二林",
  "twDistrict.dacheng": "大城",
  "twDistrict.fangyuan": "芳苑",
  "twDistrict.ershui": "二水",
  "twDistrict.nantou": "南投",
  "twDistrict.zhongliao": "中寮",
  "twDistrict.caotun": "草屯",
  "twDistrict.guoxing": "國姓",
  "twDistrict.puli": "埔里",
  "twDistrict.renAi": "仁愛",
  "twDistrict.mingjian": "名間",
  "twDistrict.jiji": "集集",
  "twDistrict.shuili": "水里",
  "twDistrict.yuchi": "魚池",
  "twDistrict.xinyi": "信義",
  "twDistrict.zhushan": "竹山",
  "twDistrict.lugu": "鹿谷",
  "twDistrict.fanlu": "番路",
  "twDistrict.meishan": "梅山",
  "twDistrict.zhuqi": "竹崎",
  "twDistrict.alishan": "阿里山",
  "twDistrict.zhongpu": "中埔",
  "twDistrict.dapu": "大埔",
  "twDistrict.shuishang": "水上",
  "twDistrict.lucao": "鹿草",
  "twDistrict.taibao": "太保",
  "twDistrict.puzi": "朴子",
  "twDistrict.dongshi": "東石",
  "twDistrict.liujiao": "六腳",
  "twDistrict.xingang": "新港",
  "twDistrict.minxiong": "民雄",
  "twDistrict.dalin": "大林",
  "twDistrict.xikou": "溪口",
  "twDistrict.yizhu": "義竹",
  "twDistrict.budai": "布袋",
  "twDistrict.dounan": "斗南",
  "twDistrict.dapi": "大埤",
  "twDistrict.huwei": "虎尾",
  "twDistrict.tuku": "土庫",
  "twDistrict.baozhong": "褒忠",
  "twDistrict.taixi": "臺西",
  "twDistrict.lunbei": "崙背",
  "twDistrict.mailiao": "麥寮",
  "twDistrict.douliu": "斗六",
  "twDistrict.linnei": "林內",
  "twDistrict.gukeng": "古坑",
  "twDistrict.citong": "莿桐",
  "twDistrict.xiluo": "西螺",
  "twDistrict.erlun": "二崙",
  "twDistrict.beigang": "北港",
  "twDistrict.shuilin": "水林",
  "twDistrict.kouhu": "口湖",
  "twDistrict.sihu": "四湖",
  "twDistrict.yuanchang": "元長",
  "twDistrict.westCentralDistrict": "中西區",
  "twDistrict.anpingDistrict": "安平區",
  "twDistrict.annanDistrict": "安南區",
  "twDistrict.yongkangDistrict": "永康區",
  "twDistrict.guirenDistrict": "歸仁區",
  "twDistrict.xinhuaDistrict": "新化區",
  "twDistrict.zuozhenDistrict": "左鎮區",
  "twDistrict.yujingDistrict": "玉井區",
  "twDistrict.nanxiDistrict": "楠西區",
  "twDistrict.nanhuaDistrict": "南化區",
  "twDistrict.rendeDistrict": "仁德區",
  "twDistrict.guanmiaoDistrict": "關廟區",
  "twDistrict.longciDistrict": "龍崎區",
  "twDistrict.guantianDistrict": "官田區",
  "twDistrict.madouDistrict": "麻豆區",
  "twDistrict.jialiDistrict": "佳里區",
  "twDistrict.xigangDistrict": "西港區",
  "twDistrict.qiguDistrict": "七股區",
  "twDistrict.jiangjunDistrict": "將軍區",
  "twDistrict.xuejiaDistrict": "學甲區",
  "twDistrict.beimenDistrict": "北門區",
  "twDistrict.xinyingDistrict": "新營區",
  "twDistrict.houbiDistrict": "後壁區",
  "twDistrict.baiheDistrict": "白河區",
  "twDistrict.dongshanDistrict": "東山區",
  "twDistrict.liujiaDistrict": "六甲區",
  "twDistrict.xiayingDistrict": "下營區",
  "twDistrict.liuyingDistrict": "柳營區",
  "twDistrict.yanshuiDistrict": "鹽水區",
  "twDistrict.shanhuaDistrict": "善化區",
  "twDistrict.daneiDistrict": "大內區",
  "twDistrict.shanshangDistrict": "山上區",
  "twDistrict.xinshiDistrict": "新市區",
  "twDistrict.andingDistrict": "安定區",
  "twDistrict.xinxingDistrict": "新興區",
  "twDistrict.qianjinDistrict": "前金區",
  "twDistrict.lingyaDistrict": "苓雅區",
  "twDistrict.yanchengDistrict": "鹽埕區",
  "twDistrict.gushanDistrict": "鼓山區",
  "twDistrict.qijinDistrict": "旗津區",
  "twDistrict.qianzhenDistrict": "前鎮區",
  "twDistrict.sanminDistrict": "三民區",
  "twDistrict.nanzihDistrict": "楠梓區",
  "twDistrict.xiaogangDistrict": "小港區",
  "twDistrict.zuoyingDistrict": "左營區",
  "twDistrict.renwuDistrict": "仁武區",
  "twDistrict.dasheDistrict": "大社區",
  "twDistrict.gangshanDistrict": "岡山區",
  "twDistrict.alianDistrict": "阿蓮區",
  "twDistrict.tianliaoDistrict": "田寮區",
  "twDistrict.yanchaoDistrict": "燕巢區",
  "twDistrict.qiaotouDistrict": "橋頭區",
  "twDistrict.ziguanDistrict": "梓官區",
  "twDistrict.mituoDistrict": "彌陀區",
  "twDistrict.yongAnDistrict": "永安區",
  "twDistrict.huneiDistrict": "湖內區",
  "twDistrict.fengshanDistrict": "鳳山區",
  "twDistrict.daliaoDistrict": "大寮區",
  "twDistrict.linyuanDistrict": "林園區",
  "twDistrict.niaosongDistrict": "鳥松區",
  "twDistrict.dashuDistrict": "大樹區",
  "twDistrict.qishanDistrict": "旗山區",
  "twDistrict.meinongDistrict": "美濃區",
  "twDistrict.liuguiDistrict": "六龜區",
  "twDistrict.neimenDistrict": "內門區",
  "twDistrict.shanlinDistrict": "杉林區",
  "twDistrict.jiaxianDistrict": "甲仙區",
  "twDistrict.namaxiaDistrict": "那瑪夏區",
  "twDistrict.maolinDistrict": "茂林區",
  "twDistrict.jiadingDistrict": "茄萣區",
  "twDistrict.pratasIsland": "東沙",
  "twDistrict.spratlyIslands": "南沙",
  "twDistrict.magong": "馬公",
  "twDistrict.xiyu": "西嶼",
  "twDistrict.wangAn": "望安",
  "twDistrict.qimei": "七美",
  "twDistrict.baisha": "白沙",
  "twDistrict.huxi": "湖西",
  "twDistrict.pingtung": "屏東",
  "twDistrict.sandimen": "三地門",
  "twDistrict.wutai": "霧臺",
  "twDistrict.majia": "瑪家",
  "twDistrict.jiuru": "九如",
  "twDistrict.ligang": "里港",
  "twDistrict.gaoshu": "高樹",
  "twDistrict.yanpu": "鹽埔",
  "twDistrict.changzhi": "長治",
  "twDistrict.linluo": "麟洛",
  "twDistrict.zhutian": "竹田",
  "twDistrict.neipu": "內埔",
  "twDistrict.wandan": "萬丹",
  "twDistrict.chaozhou": "潮州",
  "twDistrict.taiwu": "泰武",
  "twDistrict.laiyi": "來義",
  "twDistrict.wanluan": "萬巒",
  "twDistrict.kanding": "崁頂",
  "twDistrict.sinpi": "新埤",
  "twDistrict.nanzhou": "南州",
  "twDistrict.linbian": "林邊",
  "twDistrict.donggang": "東港",
  "twDistrict.liuqiu": "琉球",
  "twDistrict.jiadong": "佳冬",
  "twDistrict.xinyuan": "新園",
  "twDistrict.fangliao": "枋寮",
  "twDistrict.fangshan": "枋山",
  "twDistrict.chunri": "春日",
  "twDistrict.shizi": "獅子",
  "twDistrict.checheng": "車城",
  "twDistrict.mudan": "牡丹",
  "twDistrict.hengchun": "恆春",
  "twDistrict.manzhou": "滿州",
  "twDistrict.taitung": "臺東",
  "twDistrict.greenIsland": "綠島",
  "twDistrict.lanyu": "蘭嶼",
  "twDistrict.yanping": "延平",
  "twDistrict.beinan": "卑南",
  "twDistrict.luye": "鹿野",
  "twDistrict.guanshan": "關山",
  "twDistrict.haiduan": "海端",
  "twDistrict.chishang": "池上",
  "twDistrict.donghe": "東河",
  "twDistrict.chenggong": "成功",
  "twDistrict.changbin": "長濱",
  "twDistrict.taimali": "太麻里",
  "twDistrict.jinfeng": "金峰",
  "twDistrict.dawu": "大武",
  "twDistrict.daren": "達仁",
  "twDistrict.hualien": "花蓮",
  "twDistrict.xincheng": "新城",
  "twDistrict.xiulin": "秀林",
  "twDistrict.jiAn": "吉安",
  "twDistrict.shoufeng": "壽豐",
  "twDistrict.fenglin": "鳳林",
  "twDistrict.guangfu": "光復",
  "twDistrict.fengbin": "豐濱",
  "twDistrict.ruisui": "瑞穗",
  "twDistrict.wanrong": "萬榮",
  "twDistrict.yuli": "玉里",
  "twDistrict.zhuoxi": "卓溪",
  "twDistrict.fuli": "富里",
  "twDistrict.jinsha": "金沙",
  "twDistrict.jinhu": "金湖",
  "twDistrict.jinning": "金寧",
  "twDistrict.jincheng": "金城",
  "twDistrict.lieyu": "烈嶼",
  "twDistrict.wuqiu": "烏坵",
  "twDistrict.nangan": "南竿",
  "twDistrict.beigan": "北竿",
  "twDistrict.juguang": "莒光",
  "twDistrict.dongyin": "東引",
  "shipmentstatus.preparingshipment": "準備貨運",
  "shipmentstatus.shipped": "貨運完畢",
  "shipmentstatus.shipmentfailed": "貨運失敗",
  auto_pay_at: "自動轉帳日期: ",
  "footer.edm.title": "最新消息、特別優惠、活動、贈品和更多資訊",
  "footer.edm.p": "登記會員通訊",
  "footer.edm.submit": "馬上登記",
  "footer.edm.disclaimer": "我們不會與其它第三方透露您的電郵地址",
  "footer.contact.title": "如有任何問題",
  "footer.contact.phone": "請致電: 0809-080-838",
  "footer.contact.phonehours1": "週一到週五服務時間",
  "footer.contact.phonehours2": "09:00-18:00，國定假日除外",
  "footer.contact.email1": "或寄送電子郵件至",
  "footer.contact.email2": "helpdesk@stk-workshop.tw",
  "footer.contact.whatsapp": "或可透過LINE與我們聯絡, 官方帳號為 @stkworkshop",
  "footer.contact.online": "關注我們",
  "footer.emf.companyname": "STK Workshop Limited",
  "footer.emf.address1": "台灣分公司： ",
  "footer.emf.address2":
    "時特科工作室有限公司 - 新北市中和區板南路492號7樓 統一編號：85019016",
  "footer.emf.address3": "香港總公司： ",
  "footer.emf.address4": "樺津佳樺科技有限公司 - 香港九龍荔枝角長順街18號華盛工業大廈3樓A室",
  "footer.copyright": " STK Workshop Limited. All Rights Reserved.",
  "footer.about": "關於我們",
  "footer.terms": "條款和細則",
  "footer.privacy": "隱私政策",
  "footer.useofwebsite": "網站使用條款",
  faq: "常見問題",
  "modal.close": "關閉",
  alert1: "輸入框不能是空的",
  alert2: "找不到",
  alert3: "單項訂單必須與預訂訂單分開下單。",
  alert4: "請先確認您的訂購訂單，然後單獨訂購單件商品。",
  alert5: "預訂訂單必須與單項訂單分開下單。",
  alert6: "請先確認您的單件商品，然後單獨訂購訂購訂單。",
  orderconflictnote:
    "對於給您帶來的不便，我們深表歉意 - 這是第三方安全支付服務供應商要求確保正確處理費用的要求。",
  orderconflictnote2:
    "如果您在訂購多件商品時遇到任何問題，請與我們聯繫，我們將盡力提供協助。",
  alert7: "成功",
  alert8: "錯誤",
  subscriptionmorethanone1: "只可訂購一個預訂訂單.",
  subscriptionmorethanone2: "請先完成付款再訂購下一個預訂訂單.",
  subscriptionmorethanone3:
    "對於給您帶來的不便，我們深表歉意 - 這是第三方安全支付服務供應商要求確保正確處理費用的要求。"
};

var enUS = {
  "common.mainleft3": "Log Out",
  "login.login1": "Please log in.",
  "login.login2":
    "Use the email address for your order and the password you created.",
  "login.login3": "Your email",
  "login.login4": "Password",
  "login.login5": "Log In",
  "login.login6": "Forgot password?",
  invalidlogincredentials:
    "The password and login email you entered do not match.",
  notyouraccount: "Not you? ",
  notyouraccount2: "Click here to login to a different account.",
  "forgot.forgot1": "Having trouble logging in?",
  "forgot.forgot2": "Enter your email address below and reset password.",
  "forgot.forgot3": "Your email",
  "forgot.forgot4": "Reset password",
  "forgot.forgot5": "Email Sent",
  ordervalidinfo: "Please enter valid information above.",
  "common.mainleft1": "Profile",
  "common.mainleft2": "Order History",
  "subscription.title": "Subscriptions",
  orderStatusCreated: "Created",
  orderStatusConfirmedOrder: "Confirmed Order",
  orderStatusPartiallyShipped: "Partially Shipped",
  orderStatusFulfilled: "Fulfilled",
  orderStatusPaymentFailed: "Payment Failed",
  orderStatusCancelled: "Cancelled",
  orderStatusRefunded: "Refunded",
  order1: "Order History",
  order4: "Item Status",
  order5: "Qty",
  order6: "Price",
  order7:
    "If you have any questions about your orders, please contact our customer service at 0809-080-838. Thank you.",
  "order.ref": "Order reference no.: ",
  "order.date": "Order date: ",
  "order.status": "Order status: ",
  "order.shipto": "Ship to: ",
  "order.giftmsg": "Gift message: ",
  "order.ordertotal": "Order total: ",
  "order.paytotal": "Payment total: ",
  "order.item": "Item",
  "order.confirmed_order": "Confirmed",
  "shipmentstatus.status": "Shipment Status",
  shippedqty: "Shipped Qty: ",
  "subscription.sub": "Subscription",
  cartpaybytermcheckbox: "Pay by installment",
  cartmonthlypayments: "monthly payments",
  accessoriessection23: "Name on the plaque: ",
  accessoriessection24: "Credit line: ",
  breadcrumbproduct: "Product",
  profiledesc1:
    "Changes to your address and phone number will be registered and shown in your shopping cart the next time you place an order.",
  profiledesc2:
    "If you wish to change the delivery address for an item you have already ordered, please contact us.",
  profiledesc3:
    "Subscribers can check the address their next delivery will be sent to on the Subscriptions page in their account area.",
  proile1: "Personal Information",
  proile2: "Your email",
  proile3: "Password",
  proile4: "Change Password",
  proile5: "Current Password",
  proile6: "New Password",
  proile7: "Set New Password",
  "proile.firstname": "First Name",
  "proile.lastname": "Last Name",
  "proile.contactnum": "Contact Number",
  "proile.address1": "Address Line 1",
  "proile.city": "District",
  "proile.province": "Province",
  "proile.country": "Country",
  "proile.save": "Save",
  passwordlength: "Your password must be at least 8 characters long.",
  "cart.cart66": "Taiwan",
  wrongOldPassword: "Old Password is not correct.",
  "subscription.pack": "Packs Shipped: ",
  "subscription.nextshipment": "Next Shipment: ",
  "subscription.shipaddress": "Shipment Address: ",
  "subscription.unsub": "Cancel Subscription",
  "subscription.unsubtitle": "Cancel Subscription",
  "subscription.unsubdesc":
    "Are you sure you want to cancel this subscription?",
  "subscription.nounsub": "I want to complete the model!",
  "subscription.plzunsub": "Cancel my subscription",
  "cart.receive_date_1": " to ",
  "cart.receive_date": "Estimated delivery: ",
  "cart.cart1": "Shopping Cart",
  "cart.cart2": "Shipping Information",
  "cart.cart3": "Payment Method",
  "cart.cart4": "Item",
  "cart.cart5": "Qty",
  "cart.cart6": "Price",
  "cart.cart7": "Remove",
  "cart.cart8": "Don’t want to build?",
  "cart.cart9": "Let our master modellers do it for you!",
  "cart.cart10": "Shipping",
  "cart.cart11": "FREE",
  "cart.cart12": "Order total",
  "cart.cart13": "Expected delivery date",
  "cart.cart14": "PROCEED TO CHECKOUT",
  "cart.cart46": "Fully assembled by master craftsmen",
  "cart.cart47": "Cancel Build Service",
  "cart.cart48": "Build Yourself Kit",
  "cart.cart64tc": " ",
  "cart.cart64": " per month thereafter",
  "cart.cart64b": "per month",
  "cart.cart64c": " ",
  "cart.cart64d": "Per month thereafter",
  "cart.deposit": "Non-refundable deposit",
  "cart.paynow": "Payment due today",
  "cart.balancedue": "Balance due upon shipment",
  "cart.discountamt": "Discount amount",
  "cart.inputdiscount": "Enter promo code",
  "cart.invaliddiscountcode": "Invalid discount code",
  "cart.nevermiss": "Never miss a Pack",
  "cart.freedelivery": "Free delivery",
  "cart.nocommitment": "No commitment",
  "cart.cancelanytime": "Cancel at any time",
  "cart.starter01":
    "Start building your movie prop replica with our lowest price offer",
  "cart.starter02":
    "If you decide to continue building your model, you'll be able to purchase the rest of the parts with no penalty - you'll pay the same prices in total as shown on the website today",
  "cart.starter03":
    "Plus you'll receive the free subscriber gifts when you complete the model",
  "cart.starter04":
    "Don't want to continue? Just do nothing. You don't need to cancel anything and we won't bill any further amounts",
  "cart.pack1disclaimer1":
    "Your delivery of Pack One will include all the kit pieces required to build ",
  "cart.pack1disclaimer2": "the complete Cockpit and Hold, as pictured above. ",
  "cart.pack1disclaimer3": "To receive the kit pieces for the whole ",
  "cart.pack1disclaimer4": "Millennium Falcon ",
  "cart.pack1disclaimer5": "at special ",
  "cart.pack1disclaimer6": "discounted prices, ",
  "cart.pack1disclaimer7": "click here to order a subscription",
  "cart.depositdisclaimer0":
    "This is a built-to-order item. Returns or refunds are not possible, except in the case of defect.",
  "cart.depositdisclaimer1":
    "This order requires a deposit to reserve the item. Only the reservation deposit will be billed now. The balance payment is due once the item is ready to ship. Please note that reservation deposits are non-refundable - if you cancel your order before delivery your deposit will not be refunded. ",
  "cart.depositdisclaimer2": "Please see the FAQ for further information.",
  cartremoveitemheader: "Remove Item",
  cartremoveitem:
    "Are you sure you want to remove this item from the shopping cart?",
  cartremoveconfirm: "Remove",
  cartremovecancel: "Cancel",
  "cart.empty1": "You have no items in your shopping cart.",
  "cart.empty2": " ",
  "cart.empty3": "Click here to continue shopping.",
  "cart.continueshopping": "Continue Shopping",
  cartBenefit1: "5% off",
  cartBenefit2: "Free Delivery",
  cartBenefit3: "Cancel Anytime",
  cartBenefit4: "Receive Earlier*",
  cartBenefit5: "Will not miss any product",
  cartBenefit6: "Dedicated Giveaway Stuffed Snoopy Toy*",
  cartBenefitDisclaimer: "* For more information, please related to the FAQ",
  acceleratedDisclaimer1: "Your order is for packs 1-5 of the 10-pack series.",
  acceleratedDisclaimer2:
    "You have no obligation to purchase packs 6-10. You will not be automatically billed for any subsequent packs.",
  acceleratedDisclaimer3:
    "To complete your Falcon, please contact us again within six months of your initial order with your choice of",
  acceleratedDisclaimer4a: "(1) a single payment of NT$ ",
  acceleratedDisclaimer4b: " or (2) 5 monthly packs at NT$ ",
  acceleratedDisclaimer4c: " each. ",
  acceleratedDisclaimer5: "Please see the FAQ for further information.",
  r2d2StarterDisclaimer1: "Your order is for packs 1-5 of the 12-pack series.",
  r2d2StarterDisclaimer2:
    "You have no obligation to purchase packs 6-12. You will not be automatically billed for any subsequent packs.",
  r2d2StarterDisclaimer3:
    "To complete your R2-D2, please contact us again within six months of your initial order with your choice of",
  r2d2StarterDisclaimer4a: "(1) a single payment of NT$ ",
  r2d2StarterDisclaimer4b: " or (2) 7 monthly packs at NT$ ",
  r2d2StarterDisclaimer4c: " each. ",
  r2d2StarterDisclaimer5: "Please see the FAQ for further information.",
  "cart.cart15": "Personal Information",
  "cart.cart16": "Buyer First Name",
  "cart.cart17": "Buyer Last Name",
  "cart.cart18": "Your Email",
  "cart.emaildisclaimer":
    "We'll send your order confirmation and tracking number to this email address.",
  "cart.mobiledisclaimer":
    "So we can contact you in case of any problems when we deliver.",
  "cart.passworddisclaimer":
    "Create an account to view your orders, receive free gifts and more. (Optional)",
  "cart.cart21": "Shipping Address",
  "cart.cart22": "Receiver Name",
  "cart.cart23": "Address Line 1",
  "cart.cart26": "Country",
  "cart.cart27": "This purchase is a gift",
  "cart.cart28": "Your message to be included in the box",
  "cart.cart29": "Continue",
  "cart.cart30": "Order Summary",
  "cart.cart32": "Qty",
  "cart.cart33": "Price",
  "cart.cart45": "Password (minimum 8 characters)",
  "cart.cart69": "Buyer Contact Number",
  "cart.cart70": "Recipient Contact Number",
  ORDERVALIDEMAILCONFIRM:
    "Your confirmation email address does not match your email address.",
  paymentdisclaimer: "By clicking Continue, you agree and consent to our ",
  paymentdisclaimer2: "Terms & Conditions",
  paymentdisclaimer3: " and ",
  paymentdisclaimer4: "Privacy Policy.",
  paymentdepositdisclaimer:
    "I acknowledge and agree to pay the non-refundable deposit due for this order. I understand and agree to the ",
  paymentdepositdisclaimer2:
    "terms and conditions including the cancellation policy.",
  mustagreedisclaimer:
    "You must acknowledge and agree to the above in order to proceed.",
  "cart.cart34": "Thank you for your purchase!",
  "cart.cart35":
    "Your payment has been processed successfully. We have sent an order confirmation to your email address.",
  "cart.cart36": "Back to homepage",
  "cart.cart37": "Complete Create Account",
  "cart.cart38":
    "Set up a password to create an account, so you can log in any time to see your order history.",
  "cart.cart39": "Your email",
  "cart.cart41": "create account",
  reginfovalid: "Please enter valid information above.",
  "cart.cart61": "Payment Failed",
  "cart.cart62":
    "Your transaction could not be processed. No money has been taken from your account. Please try again. If the problem persists, please contact Customer Service.",
  "cart.cart63": "Go back to try the payment again",
  twCity: "city/county",
  twDistrict: "district",
  postal_code: "Postal Code",
  "twCity.taipeiCity": "Taipei City",
  "twCity.keelungCity": "Keelung City",
  "twCity.newTaipeiCity": "New Taipei City",
  "twCity.yilanCounty": "Yilan County",
  "twCity.hsinchuCity": "Hsinchu City",
  "twCity.hsinchuCounty": "Hsinchu County",
  "twCity.taoyuanCity": "Taoyuan City",
  "twCity.miaoliCounty": "Miaoli County",
  "twCity.taichungCity": "Taichung City",
  "twCity.changhuaCounty": "Changhua County",
  "twCity.nantouCounty": "Nantou County",
  "twCity.chiayiCity": "Chiayi City",
  "twCity.chiayiCounty": "Chiayi County",
  "twCity.yunlinCounty": "Yunlin County",
  "twCity.tainanCity": "Tainan City",
  "twCity.kaohsiungCity": "Kaohsiung City",
  "twCity.southChinaSeaIslands": "South China Sea Islands",
  "twCity.penghuCounty": "Penghu County",
  "twCity.pingtungCounty": "Pingtung County",
  "twCity.taitungCounty": "Taitung County",
  "twCity.hualienCounty": "Hualien County",
  "twCity.kinmenIslands": "Kinmen Islands",
  "twCity.lienchiangCounty": "Lienchiang County",
  "twDistrict.zhongzhengDistrict": "Zhongzheng District",
  "twDistrict.datongDistrict": "Datong District",
  "twDistrict.zhongshanDistrict": "Zhongshan District",
  "twDistrict.songshanDistrict": "Songshan District",
  "twDistrict.daAnDistrict": "Da'an District",
  "twDistrict.wanhuaDistrict": "Wanhua District",
  "twDistrict.xinyiDistrict": "Xinyi District",
  "twDistrict.shilinDistrict": "Shilin District",
  "twDistrict.beitouDistrict": "Beitou District",
  "twDistrict.neihuDistrict": "Neihu District",
  "twDistrict.nangangDistrict": "Nangang District",
  "twDistrict.wenshanDistrict": "Wenshan District",
  "twDistrict.renAiDistrict": "Ren’ai District",
  "twDistrict.anleDistrict": "Anle District",
  "twDistrict.nuannuanDistrict": "Nuannuan District",
  "twDistrict.qiduDistrict": "Qidu District",
  "twDistrict.wanliDistrict": "Wanli District",
  "twDistrict.jinshanDistrict": "Jinshan District",
  "twDistrict.banqiaoDistrict": "Banqiao District",
  "twDistrict.xizhiDistrict": "Xizhi District",
  "twDistrict.shenkengDistrict": "Shenkeng District",
  "twDistrict.shidingDistrict": "Shiding District",
  "twDistrict.ruifangDistrict": "Ruifang District",
  "twDistrict.pingxiDistrict": "Pingxi District",
  "twDistrict.shuangxiDistrict": "Shuangxi District",
  "twDistrict.gongliaoDistrict": "Gongliao District",
  "twDistrict.xindianDistrict": "Xindian District",
  "twDistrict.pinglinDistrict": "Pinglin District",
  "twDistrict.wulaiDistrict": "Wulai District",
  "twDistrict.yongheDistrict": "Yonghe District",
  "twDistrict.zhongheDistrict": "Zhonghe District",
  "twDistrict.tuchengDistrict": "Tucheng District",
  "twDistrict.sanxiaDistrict": "Sanxia District",
  "twDistrict.shulinDistrict": "Shulin District",
  "twDistrict.yinggeDistrict": "Yingge District",
  "twDistrict.sanchongDistrict": "Sanchong District",
  "twDistrict.xinzhuangDistrict": "Xinzhuang District",
  "twDistrict.taishanDistrict": "Taishan District",
  "twDistrict.linkouDistrict": "Linkou District",
  "twDistrict.luzhouDistrict": "Luzhou District",
  "twDistrict.wuguDistrict": "Wugu District",
  "twDistrict.baliDistrict": "Bali District",
  "twDistrict.tamsuiDistrict": "Tamsui District",
  "twDistrict.sanzhiDistrict": "Sanzhi District",
  "twDistrict.shimenDistrict": "Shimen District",
  "twDistrict.yilan": "Yilan",
  "twDistrict.toucheng": "Toucheng",
  "twDistrict.jiaoxi": "Jiaoxi",
  "twDistrict.zhuangwei": "Zhuangwei",
  "twDistrict.yuanshan": "Yuanshan",
  "twDistrict.luodong": "Luodong",
  "twDistrict.sanxing": "Sanxing",
  "twDistrict.datong": "Datong",
  "twDistrict.wujie": "Wujie",
  "twDistrict.dongshan": "Dongshan",
  "twDistrict.suAo": "Su'ao",
  "twDistrict.nanAo": "Nan'ao",
  "twDistrict.diaoyutaiIslands": "Diaoyutai Islands",
  "twDistrict.eastDistrict": "East District",
  "twDistrict.northDistrict": "North District",
  "twDistrict.xiangshanDistrict": "Xiangshan District",
  "twDistrict.zhubei": "Zhubei",
  "twDistrict.hukou": "Hukou",
  "twDistrict.xinfeng": "Xinfeng",
  "twDistrict.xinpu": "Xinpu",
  "twDistrict.guanxi": "Guanxi",
  "twDistrict.qionglin": "Qionglin",
  "twDistrict.baoshan": "Baoshan",
  "twDistrict.zhudong": "Zhudong",
  "twDistrict.wufeng": "Wufeng",
  "twDistrict.hengshan": "Hengshan",
  "twDistrict.jianshi": "Jianshi",
  "twDistrict.beipu": "Beipu",
  "twDistrict.emei": "Emei",
  "twDistrict.zhongliDistrict": "Zhongli District",
  "twDistrict.pingzhenDistrict": "Pingzhen District",
  "twDistrict.longtanDistrict": "Longtan District",
  "twDistrict.yangmeiDistrict": "Yangmei District",
  "twDistrict.xinwuDistrict": "Xinwu District",
  "twDistrict.guanyinDistrict": "Guanyin District",
  "twDistrict.taoyuanDistrict": "Taoyuan District",
  "twDistrict.guishanDistrict": "Guishan District",
  "twDistrict.badeDistrict": "Bade District",
  "twDistrict.daxiDistrict": "Daxi District",
  "twDistrict.fuxingDistrict": "Fuxing District",
  "twDistrict.dayuanDistrict": "Dayuan District",
  "twDistrict.luzhuDistrict": "Luzhu District",
  "twDistrict.zhunan": "Zhunan",
  "twDistrict.toufen": "Toufen",
  "twDistrict.sanwan": "Sanwan",
  "twDistrict.nanzhuang": "Nanzhuang",
  "twDistrict.shitan": "Shitan",
  "twDistrict.houlong": "Houlong",
  "twDistrict.tongxiao": "Tongxiao",
  "twDistrict.yuanli": "Yuanli",
  "twDistrict.miaoli": "Miaoli",
  "twDistrict.zaoqiao": "Zaoqiao",
  "twDistrict.touwu": "Touwu",
  "twDistrict.gongguan": "Gongguan",
  "twDistrict.dahu": "Dahu",
  "twDistrict.taiAn": "Tai'an",
  "twDistrict.tongluo": "Tongluo",
  "twDistrict.sanyi": "Sanyi",
  "twDistrict.xihu": "Xihu",
  "twDistrict.zhuolan": "Zhuolan",
  "twDistrict.centralDistrict": "Central District",
  "twDistrict.southDistrict": "South District",
  "twDistrict.westDistrict": "West District",
  "twDistrict.beitunDistrict": "Beitun District",
  "twDistrict.xitunDistrict": "Xitun District",
  "twDistrict.nantunDistrict": "Nantun District",
  "twDistrict.taipingDistrict": "Taiping District",
  "twDistrict.daliDistrict": "Dali District",
  "twDistrict.wufengDistrict": "Wufeng District",
  "twDistrict.wuriDistrict": "Wuri District",
  "twDistrict.fengyuanDistrict": "Fengyuan District",
  "twDistrict.houliDistrict": "Houli District",
  "twDistrict.shigangDistrict": "Shigang District",
  "twDistrict.dongshiDistrict": "Dongshi District",
  "twDistrict.hepingDistrict": "Heping District",
  "twDistrict.xinsheDistrict": "Xinshe District",
  "twDistrict.tanziDistrict": "Tanzi District",
  "twDistrict.dayaDistrict": "Daya District",
  "twDistrict.shengangDistrict": "Shengang District",
  "twDistrict.daduDistrict": "Dadu District",
  "twDistrict.shaluDistrict": "Shalu District",
  "twDistrict.longjingDistrict": "Longjing District",
  "twDistrict.wuqiDistrict": "Wuqi District",
  "twDistrict.qingshuiDistrict": "Qingshui District",
  "twDistrict.dajiaDistrict": "Dajia District",
  "twDistrict.waipuDistrict": "Waipu District",
  "twDistrict.changhua": "Changhua",
  "twDistrict.fenyuan": "Fenyuan",
  "twDistrict.huatan": "Huatan",
  "twDistrict.xiushui": "Xiushui",
  "twDistrict.lukang": "Lukang",
  "twDistrict.fuxing": "Fuxing",
  "twDistrict.xianxi": "Xianxi",
  "twDistrict.hemei": "Hemei",
  "twDistrict.shengang": "Shengang",
  "twDistrict.yuanlin": "Yuanlin",
  "twDistrict.shetou": "Shetou",
  "twDistrict.yongjing": "Yongjing",
  "twDistrict.puxin": "Puxin",
  "twDistrict.dacun": "Dacun",
  "twDistrict.puyan": "Puyan",
  "twDistrict.tianzhong": "Tianzhong",
  "twDistrict.beidou": "Beidou",
  "twDistrict.tianwei": "Tianwei",
  "twDistrict.pitou": "Pitou",
  "twDistrict.xizhou": "Xizhou",
  "twDistrict.zhutang": "Zhutang",
  "twDistrict.erlin": "Erlin",
  "twDistrict.dacheng": "Dacheng",
  "twDistrict.fangyuan": "Fangyuan",
  "twDistrict.ershui": "Ershui",
  "twDistrict.nantou": "Nantou",
  "twDistrict.zhongliao": "Zhongliao",
  "twDistrict.caotun": "Caotun",
  "twDistrict.guoxing": "Guoxing",
  "twDistrict.puli": "Puli",
  "twDistrict.renAi": "Ren’ai",
  "twDistrict.mingjian": "Mingjian",
  "twDistrict.jiji": "Jiji",
  "twDistrict.shuili": "Shuili",
  "twDistrict.yuchi": "Yuchi",
  "twDistrict.xinyi": "Xinyi",
  "twDistrict.zhushan": "Zhushan",
  "twDistrict.lugu": "Lugu",
  "twDistrict.fanlu": "Fanlu",
  "twDistrict.meishan": "Meishan",
  "twDistrict.zhuqi": "Zhuqi",
  "twDistrict.alishan": "Alishan",
  "twDistrict.zhongpu": "Zhongpu",
  "twDistrict.dapu": "Dapu",
  "twDistrict.shuishang": "Shuishang",
  "twDistrict.lucao": "Lucao",
  "twDistrict.taibao": "Taibao",
  "twDistrict.puzi": "Puzi",
  "twDistrict.dongshi": "Dongshi",
  "twDistrict.liujiao": "Liujiao",
  "twDistrict.xingang": "Xingang",
  "twDistrict.minxiong": "Minxiong",
  "twDistrict.dalin": "Dalin",
  "twDistrict.xikou": "Xikou",
  "twDistrict.yizhu": "Yizhu",
  "twDistrict.budai": "Budai",
  "twDistrict.dounan": "Dounan",
  "twDistrict.dapi": "Dapi",
  "twDistrict.huwei": "Huwei",
  "twDistrict.tuku": "Tuku",
  "twDistrict.baozhong": "Baozhong",
  "twDistrict.taixi": "Taixi",
  "twDistrict.lunbei": "Lunbei",
  "twDistrict.mailiao": "Mailiao",
  "twDistrict.douliu": "Douliu",
  "twDistrict.linnei": "Linnei",
  "twDistrict.gukeng": "Gukeng",
  "twDistrict.citong": "Citong",
  "twDistrict.xiluo": "Xiluo",
  "twDistrict.erlun": "Erlun",
  "twDistrict.beigang": "Beigang",
  "twDistrict.shuilin": "Shuilin",
  "twDistrict.kouhu": "Kouhu",
  "twDistrict.sihu": "Sihu",
  "twDistrict.yuanchang": "Yuanchang",
  "twDistrict.westCentralDistrict": "West Central District",
  "twDistrict.anpingDistrict": "Anping District",
  "twDistrict.annanDistrict": "Annan District",
  "twDistrict.yongkangDistrict": "Yongkang District",
  "twDistrict.guirenDistrict": "Guiren District",
  "twDistrict.xinhuaDistrict": "Xinhua District",
  "twDistrict.zuozhenDistrict": "Zuozhen District",
  "twDistrict.yujingDistrict": "Yujing District",
  "twDistrict.nanxiDistrict": "Nanxi District",
  "twDistrict.nanhuaDistrict": "Nanhua District",
  "twDistrict.rendeDistrict": "Rende District",
  "twDistrict.guanmiaoDistrict": "Guanmiao District",
  "twDistrict.longciDistrict": "Longci District",
  "twDistrict.guantianDistrict": "Guantian District",
  "twDistrict.madouDistrict": "Madou District",
  "twDistrict.jialiDistrict": "Jiali District",
  "twDistrict.xigangDistrict": "Xigang District",
  "twDistrict.qiguDistrict": "Qigu District",
  "twDistrict.jiangjunDistrict": "Jiangjun District",
  "twDistrict.xuejiaDistrict": "Xuejia District",
  "twDistrict.beimenDistrict": "Beimen District",
  "twDistrict.xinyingDistrict": "Xinying District",
  "twDistrict.houbiDistrict": "Houbi District",
  "twDistrict.baiheDistrict": "Baihe District",
  "twDistrict.dongshanDistrict": "Dongshan District",
  "twDistrict.liujiaDistrict": "Liujia District",
  "twDistrict.xiayingDistrict": "Xiaying District",
  "twDistrict.liuyingDistrict": "Liuying District",
  "twDistrict.yanshuiDistrict": "Yanshui District",
  "twDistrict.shanhuaDistrict": "Shanhua District",
  "twDistrict.daneiDistrict": "Danei District",
  "twDistrict.shanshangDistrict": "Shanshang District",
  "twDistrict.xinshiDistrict": "Xinshi District",
  "twDistrict.andingDistrict": "Anding District",
  "twDistrict.xinxingDistrict": "Xinxing District",
  "twDistrict.qianjinDistrict": "Qianjin District",
  "twDistrict.lingyaDistrict": "Lingya District",
  "twDistrict.yanchengDistrict": "Yancheng District",
  "twDistrict.gushanDistrict": "Gushan District",
  "twDistrict.qijinDistrict": "Qijin District",
  "twDistrict.qianzhenDistrict": "Qianzhen District",
  "twDistrict.sanminDistrict": "Sanmin District",
  "twDistrict.nanzihDistrict": "Nanzih District",
  "twDistrict.xiaogangDistrict": "Xiaogang District",
  "twDistrict.zuoyingDistrict": "Zuoying District",
  "twDistrict.renwuDistrict": "Renwu District",
  "twDistrict.dasheDistrict": "Dashe District",
  "twDistrict.gangshanDistrict": "Gangshan District",
  "twDistrict.alianDistrict": "Alian District",
  "twDistrict.tianliaoDistrict": "Tianliao District",
  "twDistrict.yanchaoDistrict": "Yanchao District",
  "twDistrict.qiaotouDistrict": "Qiaotou District",
  "twDistrict.ziguanDistrict": "Ziguan District",
  "twDistrict.mituoDistrict": "Mituo District",
  "twDistrict.yongAnDistrict": "Yong'an District",
  "twDistrict.huneiDistrict": "Hunei District",
  "twDistrict.fengshanDistrict": "Fengshan District",
  "twDistrict.daliaoDistrict": "Daliao District",
  "twDistrict.linyuanDistrict": "Linyuan District",
  "twDistrict.niaosongDistrict": "Niaosong District",
  "twDistrict.dashuDistrict": "Dashu District",
  "twDistrict.qishanDistrict": "Qishan District",
  "twDistrict.meinongDistrict": "Meinong District",
  "twDistrict.liuguiDistrict": "Liugui District",
  "twDistrict.neimenDistrict": "Neimen District",
  "twDistrict.shanlinDistrict": "Shanlin District",
  "twDistrict.jiaxianDistrict": "Jiaxian District",
  "twDistrict.namaxiaDistrict": "Namaxia District",
  "twDistrict.maolinDistrict": "Maolin District",
  "twDistrict.jiadingDistrict": "Jiading District",
  "twDistrict.pratasIsland": "Pratas Island",
  "twDistrict.spratlyIslands": "Spratly Islands",
  "twDistrict.magong": "Magong",
  "twDistrict.xiyu": "Xiyu",
  "twDistrict.wangAn": "Wang-an",
  "twDistrict.qimei": "Qimei",
  "twDistrict.baisha": "Baisha",
  "twDistrict.huxi": "Huxi",
  "twDistrict.pingtung": "Pingtung",
  "twDistrict.sandimen": "Sandimen",
  "twDistrict.wutai": "Wutai",
  "twDistrict.majia": "Majia",
  "twDistrict.jiuru": "Jiuru",
  "twDistrict.ligang": "Ligang",
  "twDistrict.gaoshu": "Gaoshu",
  "twDistrict.yanpu": "Yanpu",
  "twDistrict.changzhi": "Changzhi",
  "twDistrict.linluo": "Linluo",
  "twDistrict.zhutian": "Zhutian",
  "twDistrict.neipu": "Neipu",
  "twDistrict.wandan": "Wandan",
  "twDistrict.chaozhou": "Chaozhou",
  "twDistrict.taiwu": "Taiwu",
  "twDistrict.laiyi": "Laiyi",
  "twDistrict.wanluan": "Wanluan",
  "twDistrict.kanding": "Kanding",
  "twDistrict.sinpi": "Sinpi",
  "twDistrict.nanzhou": "Nanzhou",
  "twDistrict.linbian": "Linbian",
  "twDistrict.donggang": "Donggang",
  "twDistrict.liuqiu": "Liuqiu",
  "twDistrict.jiadong": "Jiadong",
  "twDistrict.xinyuan": "Xinyuan",
  "twDistrict.fangliao": "Fangliao",
  "twDistrict.fangshan": "Fangshan",
  "twDistrict.chunri": "Chunri",
  "twDistrict.shizi": "Shizi",
  "twDistrict.checheng": "Checheng",
  "twDistrict.mudan": "Mudan",
  "twDistrict.hengchun": "Hengchun",
  "twDistrict.manzhou": "Manzhou",
  "twDistrict.taitung": "Taitung",
  "twDistrict.greenIsland": "Green Island",
  "twDistrict.lanyu": "Lanyu",
  "twDistrict.yanping": "Yanping",
  "twDistrict.beinan": "Beinan",
  "twDistrict.luye": "Luye",
  "twDistrict.guanshan": "Guanshan",
  "twDistrict.haiduan": "Haiduan",
  "twDistrict.chishang": "Chishang",
  "twDistrict.donghe": "Donghe",
  "twDistrict.chenggong": "Chenggong",
  "twDistrict.changbin": "Changbin",
  "twDistrict.taimali": "Taimali",
  "twDistrict.jinfeng": "Jinfeng",
  "twDistrict.dawu": "Dawu",
  "twDistrict.daren": "Daren",
  "twDistrict.hualien": "Hualien",
  "twDistrict.xincheng": "Xincheng",
  "twDistrict.xiulin": "Xiulin",
  "twDistrict.jiAn": "Ji'an",
  "twDistrict.shoufeng": "Shoufeng",
  "twDistrict.fenglin": "Fenglin",
  "twDistrict.guangfu": "Guangfu",
  "twDistrict.fengbin": "Fengbin",
  "twDistrict.ruisui": "Ruisui",
  "twDistrict.wanrong": "Wanrong",
  "twDistrict.yuli": "Yuli",
  "twDistrict.zhuoxi": "Zhuoxi",
  "twDistrict.fuli": "Fuli",
  "twDistrict.jinsha": "Jinsha",
  "twDistrict.jinhu": "Jinhu",
  "twDistrict.jinning": "Jinning",
  "twDistrict.jincheng": "Jincheng",
  "twDistrict.lieyu": "Lieyu",
  "twDistrict.wuqiu": "Wuqiu",
  "twDistrict.nangan": "Nangan",
  "twDistrict.beigan": "Beigan",
  "twDistrict.juguang": "Juguang",
  "twDistrict.dongyin": "Dongyin",
  "shipmentstatus.preparingshipment": "Preparing Shipment",
  "shipmentstatus.shipped": "Shipped",
  "shipmentstatus.shipmentfailed": "Shipment Failed",
  auto_pay_at: "Auto Pay Date: "
};

var formatMessage = function(_ref) {
  var _avaLang$find$message, _avaLang$find;

  var id = _ref.id;
  var avaLang = [
    {
      lang: "tw",
      messages: zhHK
    },
    {
      lang: "en",
      messages: enUS
    }
  ];
  var messages =
    (_avaLang$find$message =
      (_avaLang$find = avaLang.find(function(lang) {
        return lang.lang === localStorage.lang;
      })) === null || _avaLang$find === void 0
        ? void 0
        : _avaLang$find.messages) !== null && _avaLang$find$message !== void 0
      ? _avaLang$find$message
      : zhHK;

  if (messages[id]) {
    return messages[id];
  } else {
    console.error("".concat(id, " does not exists"));
    return id;
  }
};

var Header = function Header(_ref) {
  var type = _ref.type,
    showRight = _ref.showRight;

  var logout = function logout() {
    del("auth/sign_out", {}, true)
      .then(function() {
        localStorage.clear();
        window.location.href = "/";
      })
      ["catch"](function(err) {
        if (err.response && [404].includes(err.response.status)) {
          window.location.href = "/";
        } else {
          alert("Network error, please refresh");
        }
      });
  };

  var mainleft3 = formatMessage({
    id: "common.mainleft3"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: type === 2 ? "header header2" : "header"
    },
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "mg"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "main"
        },
        /*#__PURE__*/ React.createElement(
          "a",
          {
            href: "/"
          },
          /*#__PURE__*/ React.createElement("img", {
            src: STK_Workshop_LOGO,
            alt: "STK Workshop"
          })
        )
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: showRight ? "right" : "hidden"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "logout",
            onClick: function onClick() {
              return logout();
            }
          },
          mainleft3,
          /*#__PURE__*/ React.createElement("img", {
            src: right2,
            alt: ""
          })
        )
      )
    )
  );
};

Header.prototype = {
  type: PropTypes.number,
  showRight: PropTypes.bool
};

var LoginMobile = function LoginMobile() {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];

  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    pwd = _useState4[0],
    setPwd = _useState4[1];

  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isRedirect = _useState6[0],
    setIsRedirect = _useState6[1];

  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    orderRef = _useState8[0],
    setOrderRef = _useState8[1];

  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showError = _useState10[0],
    setShowError = _useState10[1];

  var submit = function submit(email, pwd, setShowError) {
    if (email === "" || pwd === "") {
      setShowError(true);
      return;
    }

    setShowError(false);
    var data = {
      uid: email,
      password: pwd,
      provider: "email"
    };
    post("auth/sign_in", data, 1)
      .then(function(res) {
        localStorage.setItem("user", JSON.stringify(res));
        localStorage.removeItem("cartItem");
        localStorage.setItem("cartKey", res.shopping_cart_key);

        if (localStorage.redirectedfromcart) {
          localStorage.setItem("historyOrderRef", orderRef);
          window.location.href = requestParam$1.webBaseURL + "/cart1";
        } else {
          window.location.href = requestParam$1.webBaseURL + "/user";
        }
      })
      ["catch"](function(err) {
        setShowError(true);
      });
  };

  var logout = function logout() {
    localStorage.clear();
    window.location.reload();
  };

  useEffect(function() {
    if (localStorage.redirectedfromcartemail) {
      if (localStorage.historyOrderRef) {
        setOrderRef(localStorage.historyOrderRef);
        localStorage.setItem("historyOrderRef", "");
      }

      setEmail(localStorage.redirectedfromcartemail);
      setIsRedirect(true);
    }
  }, []);
  var login1 = formatMessage({
    id: "login.login1"
  });
  var login2 = formatMessage({
    id: "login.login2"
  });
  var login3 = formatMessage({
    id: "login.login3"
  });
  var login4 = formatMessage({
    id: "login.login4"
  });
  var login5 = formatMessage({
    id: "login.login5"
  });
  var login6 = formatMessage({
    id: "login.login6"
  });
  var notyouraccount = formatMessage({
    id: "notyouraccount"
  });
  var notyouraccount2 = formatMessage({
    id: "notyouraccount2"
  });
  var invalidlogincredentials = formatMessage({
    id: "invalidlogincredentials"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, {
      type: 2
    }),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers mobilelogin"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "main mpad_h"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "title"
          },
          login1
        ),
        /*#__PURE__*/ React.createElement("p", null, login2),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "form"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "group"
            },
            /*#__PURE__*/ React.createElement("p", null, login3),
            /*#__PURE__*/ React.createElement("input", {
              type: "text",
              placeholder: "customer@gmail.com",
              value: email,
              onInput: function onInput(e) {
                return setEmail(e.target.value);
              },
              maxLength: "120",
              readOnly: isRedirect
            })
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "group"
            },
            /*#__PURE__*/ React.createElement("p", null, login4),
            /*#__PURE__*/ React.createElement("input", {
              type: "password",
              placeholder: "********",
              onInput: function onInput(e) {
                return setPwd(e.target.value);
              },
              maxLength: "60"
            })
          ),
          /*#__PURE__*/ React.createElement("br", null),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              id: "form-error",
              className: "form-error",
              style: {
                display: showError ? "block" : "none"
              }
            },
            invalidlogincredentials
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "btn",
              onClick: function onClick() {
                return submit(email, pwd, setShowError);
              }
            },
            login5
          ),
          isRedirect
            ? /*#__PURE__*/ React.createElement(
                "div",
                null,
                /*#__PURE__*/ React.createElement(
                  "a",
                  {
                    onClick: function onClick() {
                      return logout();
                    }
                  },
                  notyouraccount,
                  notyouraccount2
                ),
                /*#__PURE__*/ React.createElement("br", null)
              )
            : null,
          /*#__PURE__*/ React.createElement(
            "a",
            {
              href: requestParam$1.webBaseURL + "/forgot"
            },
            login6
          )
        )
      )
    )
  );
};

var LoginWeb = function LoginWeb() {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];

  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    pwd = _useState4[0],
    setPwd = _useState4[1];

  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isRedirect = _useState6[0],
    setIsRedirect = _useState6[1];

  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    orderRef = _useState8[0],
    setOrderRef = _useState8[1];

  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showError = _useState10[0],
    setShowError = _useState10[1];

  var submit = function submit(email, pwd, setShowError) {
    if (email === "" || pwd === "") {
      setShowError(true);
      return;
    }

    setShowError(false);
    var data = {
      uid: email,
      password: pwd,
      provider: "email"
    };
    post("auth/sign_in", data, 1)
      .then(function(res) {
        localStorage.setItem("user", JSON.stringify(res));
        localStorage.removeItem("cartItem");
        localStorage.setItem("cartKey", res.shopping_cart_key);

        if (localStorage.redirectedfromcart) {
          localStorage.setItem("historyOrderRef", orderRef);
          window.location.href = requestParam$1.webBaseURL + "/cart1";
        } else {
          window.location.href = requestParam$1.webBaseURL + "/user";
        }
      })
      ["catch"](function(err) {
        setShowError(true);
      });
  };

  var logout = function logout() {
    localStorage.clear();
    window.location.reload();
  };

  useEffect(function() {
    if (localStorage.redirectedfromcartemail) {
      if (localStorage.historyOrderRef) {
        setOrderRef(localStorage.historyOrderRef);
        localStorage.setItem("historyOrderRef", "");
      }

      setEmail(localStorage.redirectedfromcartemail);
      setIsRedirect(true);
    }
  }, []);
  var login1 = formatMessage({
    id: "login.login1"
  });
  var login2 = formatMessage({
    id: "login.login2"
  });
  var login3 = formatMessage({
    id: "login.login3"
  });
  var login4 = formatMessage({
    id: "login.login4"
  });
  var login5 = formatMessage({
    id: "login.login5"
  });
  var login6 = formatMessage({
    id: "login.login6"
  });
  var notyouraccount = formatMessage({
    id: "notyouraccount"
  });
  var notyouraccount2 = formatMessage({
    id: "notyouraccount2"
  });
  var invalidlogincredentials = formatMessage({
    id: "invalidlogincredentials"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers login"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "main",
          style: {
            paddingLeft: 5,
            paddingRight: 5
          }
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "title"
          },
          login1
        ),
        /*#__PURE__*/ React.createElement("p", null, login2),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "form"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "group"
            },
            /*#__PURE__*/ React.createElement("p", null, login3),
            /*#__PURE__*/ React.createElement("input", {
              type: "text",
              placeholder: "customer@gmail.com",
              value: email,
              onInput: function onInput(e) {
                return setEmail(e.target.value);
              },
              maxLength: "120",
              readOnly: isRedirect
            })
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "group"
            },
            /*#__PURE__*/ React.createElement("p", null, login4),
            /*#__PURE__*/ React.createElement("input", {
              type: "password",
              placeholder: "********",
              onInput: function onInput(e) {
                return setPwd(e.target.value);
              },
              maxLength: "60"
            })
          ),
          /*#__PURE__*/ React.createElement("br", null),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              id: "form-error",
              className: "form-error",
              style: {
                display: showError ? "block" : "none"
              }
            },
            invalidlogincredentials
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "btn",
              onClick: function onClick() {
                return submit(email, pwd, setShowError);
              }
            },
            login5
          ),
          isRedirect
            ? /*#__PURE__*/ React.createElement(
                "div",
                null,
                /*#__PURE__*/ React.createElement(
                  "a",
                  {
                    onClick: function onClick() {
                      return logout();
                    }
                  },
                  notyouraccount,
                  notyouraccount2
                ),
                /*#__PURE__*/ React.createElement("br", null)
              )
            : null,
          /*#__PURE__*/ React.createElement(
            "a",
            {
              href: requestParam$1.webBaseURL + "/forgot"
            },
            login6
          )
        )
      )
    )
  );
};

var Login = function Login() {
  return /*#__PURE__*/ React.createElement(MobileDetector, {
    desktopChildren: /*#__PURE__*/ React.createElement(LoginWeb, null),
    mobileChildren: /*#__PURE__*/ React.createElement(LoginMobile, null)
  });
};

var PATH =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAABAUlEQVQ4T5WSzyrFYRCGnycbyQJ7O1dBlpQFpcPCBRBbS4oobgGlXICk2LFUkguwJ2sspLPh1aff0XH8O+dbfjPPzDvzjnT4kvQB0+qBnbBJuoEzYBRYbhtO0gUclq7AHTDSCbwDLAIPpbN60xacZA3YAF6AMfWyjPsBJ5kDTtXn1h0kmQf2gFegpp40ckyyAmwBR8CsmkYwyVT1X+ZdUPebixd4CLgG+oFVdbtSMwycAz3AurrZqqohe6LIroKTwC1wAQwAu+rST5Z+LqxJ/iNQZh8EjoEZ9e0/uBQqPtaqxNJ5XK3/dkhfrErSC1wVAyovn/66wG8+Vwusq/f/ne472WpZlSXttBoAAAAASUVORK5CYII=";

var ForgotMobile = function ForgotMobile() {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];

  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSendSuccess = _useState4[0],
    setIsSendSuccess = _useState4[1];

  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showError = _useState6[0],
    setShowError = _useState6[1];

  var submit = function submit() {
    if (email === "") {
      setShowError(true);
      return;
    }

    setShowError(false);
    var data = {
      email: email
    };
    post("api/v1/users/forgot_password", data)
      .then(function() {
        setIsSendSuccess(true);
      })
      ["catch"](function() {
        setShowError(true);
      });
  };

  var forgot1 = formatMessage({
    id: "forgot.forgot1"
  });
  var forgot2 = formatMessage({
    id: "forgot.forgot2"
  });
  var forgot3 = formatMessage({
    id: "forgot.forgot3"
  });
  var forgot4 = formatMessage({
    id: "forgot.forgot4"
  });
  var forgot5 = formatMessage({
    id: "forgot.forgot5"
  });
  var ordervalidinfo = formatMessage({
    id: "ordervalidinfo"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers mobileforgot"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "main mpad_h"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "title"
          },
          forgot1
        ),
        /*#__PURE__*/ React.createElement("p", null, forgot2),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "form"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "group"
            },
            /*#__PURE__*/ React.createElement("p", null, forgot3),
            /*#__PURE__*/ React.createElement("input", {
              type: "text",
              placeholder: "customer@gmail.com",
              onInput: function onInput(e) {
                return setEmail(e.target.value);
              },
              maxLength: "120"
            })
          ),
          /*#__PURE__*/ React.createElement("br", null),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              id: "form-error",
              className: "form-error",
              style: {
                display: showError ? "block" : "none"
              }
            },
            ordervalidinfo
          ),
          !isSendSuccess
            ? /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "btn",
                  onClick: submit
                },
                forgot4
              )
            : /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "btn2"
                },
                /*#__PURE__*/ React.createElement("img", {
                  src: PATH,
                  alt: "Check"
                }),
                forgot5
              )
        )
      )
    )
  );
};

var ForgotWeb = function ForgotWeb() {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];

  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSendSuccess = _useState4[0],
    setIsSendSuccess = _useState4[1];

  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showError = _useState6[0],
    setShowError = _useState6[1];

  var submit = function submit() {
    if (email === "") {
      setShowError(true);
      return;
    }

    setShowError(false);
    var data = {
      email: email
    };
    post("api/v1/users/forgot_password", data)
      .then(function() {
        setIsSendSuccess(true);
      })
      ["catch"](function() {
        setShowError(true);
      });
  };

  var forgot1 = formatMessage({
    id: "forgot.forgot1"
  });
  var forgot2 = formatMessage({
    id: "forgot.forgot2"
  });
  var forgot3 = formatMessage({
    id: "forgot.forgot3"
  });
  var forgot4 = formatMessage({
    id: "forgot.forgot4"
  });
  var forgot5 = formatMessage({
    id: "forgot.forgot5"
  });
  var ordervalidinfo = formatMessage({
    id: "ordervalidinfo"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers forgot"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "main"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "title"
          },
          forgot1
        ),
        /*#__PURE__*/ React.createElement("p", null, forgot2),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "form"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "group"
            },
            /*#__PURE__*/ React.createElement("p", null, forgot3),
            /*#__PURE__*/ React.createElement("input", {
              type: "text",
              placeholder: "customer@gmail.com",
              onInput: function onInput(e) {
                return setEmail(e.target.value);
              },
              maxLength: "120"
            })
          ),
          /*#__PURE__*/ React.createElement("br", null),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              id: "form-error",
              className: "form-error",
              style: {
                display: showError ? "block" : "none"
              }
            },
            ordervalidinfo
          ),
          !isSendSuccess
            ? /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "btn",
                  onClick: submit
                },
                forgot4
              )
            : /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "btn2"
                },
                /*#__PURE__*/ React.createElement("img", {
                  src: PATH,
                  alt: "Check"
                }),
                forgot5
              )
        )
      )
    )
  );
};

var Forgot = function Forgot() {
  var submit = function submit(email, setShowError, setIsSendSuccess) {
    if (email === "") {
      setShowError(true);
      return;
    }

    setShowError(false);
    var data = {
      email: email
    };
    post("api/v1/users/forgot_password", data)
      .then(function() {
        setIsSendSuccess(true);
      })
      ["catch"](function() {
        setShowError(true);
      });
  };

  return /*#__PURE__*/ React.createElement(MobileDetector, {
    desktopChildren: /*#__PURE__*/ React.createElement(ForgotWeb, {
      submit: submit
    }),
    mobileChildren: /*#__PURE__*/ React.createElement(ForgotMobile, {
      submit: submit
    })
  });
};

var districtTW = [
  {
    tKey: "twCity.taipeiCity",
    district: [
      {
        tKey: "twDistrict.zhongzhengDistrict",
        code: "100"
      },
      {
        tKey: "twDistrict.datongDistrict",
        code: "103"
      },
      {
        tKey: "twDistrict.zhongshanDistrict",
        code: "104"
      },
      {
        tKey: "twDistrict.songshanDistrict",
        code: "105"
      },
      {
        tKey: "twDistrict.daAnDistrict",
        code: "106"
      },
      {
        tKey: "twDistrict.wanhuaDistrict",
        code: "108"
      },
      {
        tKey: "twDistrict.xinyiDistrict",
        code: "110"
      },
      {
        tKey: "twDistrict.shilinDistrict",
        code: "111"
      },
      {
        tKey: "twDistrict.beitouDistrict",
        code: "112"
      },
      {
        tKey: "twDistrict.neihuDistrict",
        code: "114"
      },
      {
        tKey: "twDistrict.nangangDistrict",
        code: "115"
      },
      {
        tKey: "twDistrict.wenshanDistrict",
        code: "116"
      }
    ]
  },
  {
    tKey: "twCity.keelungCity",
    district: [
      {
        tKey: "twDistrict.renAiDistrict",
        code: "200"
      },
      {
        tKey: "twDistrict.xinyiDistrict",
        code: "201"
      },
      {
        tKey: "twDistrict.zhongzhengDistrict",
        code: "202"
      },
      {
        tKey: "twDistrict.zhongshanDistrict",
        code: "203"
      },
      {
        tKey: "twDistrict.anleDistrict",
        code: "204"
      },
      {
        tKey: "twDistrict.nuannuanDistrict",
        code: "205"
      },
      {
        tKey: "twDistrict.qiduDistrict",
        code: "206"
      }
    ]
  },
  {
    tKey: "twCity.newTaipeiCity",
    district: [
      {
        tKey: "twDistrict.wanliDistrict",
        code: "207"
      },
      {
        tKey: "twDistrict.jinshanDistrict",
        code: "208"
      },
      {
        tKey: "twDistrict.banqiaoDistrict",
        code: "220"
      },
      {
        tKey: "twDistrict.xizhiDistrict",
        code: "221"
      },
      {
        tKey: "twDistrict.shenkengDistrict",
        code: "222"
      },
      {
        tKey: "twDistrict.shidingDistrict",
        code: "223"
      },
      {
        tKey: "twDistrict.ruifangDistrict",
        code: "224"
      },
      {
        tKey: "twDistrict.pingxiDistrict",
        code: "226"
      },
      {
        tKey: "twDistrict.shuangxiDistrict",
        code: "227"
      },
      {
        tKey: "twDistrict.gongliaoDistrict",
        code: "228"
      },
      {
        tKey: "twDistrict.xindianDistrict",
        code: "231"
      },
      {
        tKey: "twDistrict.pinglinDistrict",
        code: "232"
      },
      {
        tKey: "twDistrict.wulaiDistrict",
        code: "233"
      },
      {
        tKey: "twDistrict.yongheDistrict",
        code: "234"
      },
      {
        tKey: "twDistrict.zhongheDistrict",
        code: "235"
      },
      {
        tKey: "twDistrict.tuchengDistrict",
        code: "236"
      },
      {
        tKey: "twDistrict.sanxiaDistrict",
        code: "237"
      },
      {
        tKey: "twDistrict.shulinDistrict",
        code: "238"
      },
      {
        tKey: "twDistrict.yinggeDistrict",
        code: "239"
      },
      {
        tKey: "twDistrict.sanchongDistrict",
        code: "241"
      },
      {
        tKey: "twDistrict.xinzhuangDistrict",
        code: "242"
      },
      {
        tKey: "twDistrict.taishanDistrict",
        code: "243"
      },
      {
        tKey: "twDistrict.linkouDistrict",
        code: "244"
      },
      {
        tKey: "twDistrict.luzhouDistrict",
        code: "247"
      },
      {
        tKey: "twDistrict.wuguDistrict",
        code: "248"
      },
      {
        tKey: "twDistrict.baliDistrict",
        code: "249"
      },
      {
        tKey: "twDistrict.tamsuiDistrict",
        code: "251"
      },
      {
        tKey: "twDistrict.sanzhiDistrict",
        code: "252"
      },
      {
        tKey: "twDistrict.shimenDistrict",
        code: "253"
      }
    ]
  },
  {
    tKey: "twCity.yilanCounty",
    district: [
      {
        tKey: "twDistrict.yilan",
        code: "260"
      },
      {
        tKey: "twDistrict.toucheng",
        code: "261"
      },
      {
        tKey: "twDistrict.jiaoxi",
        code: "262"
      },
      {
        tKey: "twDistrict.zhuangwei",
        code: "263"
      },
      {
        tKey: "twDistrict.yuanshan",
        code: "264"
      },
      {
        tKey: "twDistrict.luodong",
        code: "265"
      },
      {
        tKey: "twDistrict.sanxing",
        code: "266"
      },
      {
        tKey: "twDistrict.datong",
        code: "267"
      },
      {
        tKey: "twDistrict.wujie",
        code: "268"
      },
      {
        tKey: "twDistrict.dongshan",
        code: "269"
      },
      {
        tKey: "twDistrict.suAo",
        code: "270"
      },
      {
        tKey: "twDistrict.nanAo",
        code: "272"
      },
      {
        tKey: "twDistrict.diaoyutaiIslands",
        code: "290"
      }
    ]
  },
  {
    tKey: "twCity.hsinchuCity",
    district: [
      {
        tKey: "twDistrict.eastDistrict",
        code: "300"
      },
      {
        tKey: "twDistrict.northDistrict",
        code: "300"
      },
      {
        tKey: "twDistrict.xiangshanDistrict",
        code: "300"
      }
    ]
  },
  {
    tKey: "twCity.hsinchuCounty",
    district: [
      {
        tKey: "twDistrict.zhubei",
        code: "302"
      },
      {
        tKey: "twDistrict.hukou",
        code: "303"
      },
      {
        tKey: "twDistrict.xinfeng",
        code: "304"
      },
      {
        tKey: "twDistrict.xinpu",
        code: "305"
      },
      {
        tKey: "twDistrict.guanxi",
        code: "306"
      },
      {
        tKey: "twDistrict.qionglin",
        code: "307"
      },
      {
        tKey: "twDistrict.baoshan",
        code: "308"
      },
      {
        tKey: "twDistrict.zhudong",
        code: "310"
      },
      {
        tKey: "twDistrict.wufeng",
        code: "311"
      },
      {
        tKey: "twDistrict.hengshan",
        code: "312"
      },
      {
        tKey: "twDistrict.jianshi",
        code: "313"
      },
      {
        tKey: "twDistrict.beipu",
        code: "314"
      },
      {
        tKey: "twDistrict.emei",
        code: "315"
      }
    ]
  },
  {
    tKey: "twCity.taoyuanCity",
    district: [
      {
        tKey: "twDistrict.zhongliDistrict",
        code: "320"
      },
      {
        tKey: "twDistrict.pingzhenDistrict",
        code: "324"
      },
      {
        tKey: "twDistrict.longtanDistrict",
        code: "325"
      },
      {
        tKey: "twDistrict.yangmeiDistrict",
        code: "326"
      },
      {
        tKey: "twDistrict.xinwuDistrict",
        code: "327"
      },
      {
        tKey: "twDistrict.guanyinDistrict",
        code: "328"
      },
      {
        tKey: "twDistrict.taoyuanDistrict",
        code: "330"
      },
      {
        tKey: "twDistrict.guishanDistrict",
        code: "333"
      },
      {
        tKey: "twDistrict.badeDistrict",
        code: "334"
      },
      {
        tKey: "twDistrict.daxiDistrict",
        code: "335"
      },
      {
        tKey: "twDistrict.fuxingDistrict",
        code: "336"
      },
      {
        tKey: "twDistrict.dayuanDistrict",
        code: "337"
      },
      {
        tKey: "twDistrict.luzhuDistrict",
        code: "338"
      }
    ]
  },
  {
    tKey: "twCity.miaoliCounty",
    district: [
      {
        tKey: "twDistrict.zhunan",
        code: "350"
      },
      {
        tKey: "twDistrict.toufen",
        code: "351"
      },
      {
        tKey: "twDistrict.sanwan",
        code: "352"
      },
      {
        tKey: "twDistrict.nanzhuang",
        code: "353"
      },
      {
        tKey: "twDistrict.shitan",
        code: "354"
      },
      {
        tKey: "twDistrict.houlong",
        code: "356"
      },
      {
        tKey: "twDistrict.tongxiao",
        code: "357"
      },
      {
        tKey: "twDistrict.yuanli",
        code: "358"
      },
      {
        tKey: "twDistrict.miaoli",
        code: "360"
      },
      {
        tKey: "twDistrict.zaoqiao",
        code: "361"
      },
      {
        tKey: "twDistrict.touwu",
        code: "362"
      },
      {
        tKey: "twDistrict.gongguan",
        code: "363"
      },
      {
        tKey: "twDistrict.dahu",
        code: "364"
      },
      {
        tKey: "twDistrict.taiAn",
        code: "365"
      },
      {
        tKey: "twDistrict.tongluo",
        code: "366"
      },
      {
        tKey: "twDistrict.sanyi",
        code: "367"
      },
      {
        tKey: "twDistrict.xihu",
        code: "368"
      },
      {
        tKey: "twDistrict.zhuolan",
        code: "369"
      }
    ]
  },
  {
    tKey: "twCity.taichungCity",
    district: [
      {
        tKey: "twDistrict.centralDistrict",
        code: "400"
      },
      {
        tKey: "twDistrict.eastDistrict",
        code: "401"
      },
      {
        tKey: "twDistrict.southDistrict",
        code: "402"
      },
      {
        tKey: "twDistrict.westDistrict",
        code: "403"
      },
      {
        tKey: "twDistrict.northDistrict",
        code: "404"
      },
      {
        tKey: "twDistrict.beitunDistrict",
        code: "406"
      },
      {
        tKey: "twDistrict.xitunDistrict",
        code: "407"
      },
      {
        tKey: "twDistrict.nantunDistrict",
        code: "408"
      },
      {
        tKey: "twDistrict.taipingDistrict",
        code: "411"
      },
      {
        tKey: "twDistrict.daliDistrict",
        code: "412"
      },
      {
        tKey: "twDistrict.wufengDistrict",
        code: "413"
      },
      {
        tKey: "twDistrict.wuriDistrict",
        code: "414"
      },
      {
        tKey: "twDistrict.fengyuanDistrict",
        code: "420"
      },
      {
        tKey: "twDistrict.houliDistrict",
        code: "421"
      },
      {
        tKey: "twDistrict.shigangDistrict",
        code: "422"
      },
      {
        tKey: "twDistrict.dongshiDistrict",
        code: "423"
      },
      {
        tKey: "twDistrict.hepingDistrict",
        code: "424"
      },
      {
        tKey: "twDistrict.xinsheDistrict",
        code: "426"
      },
      {
        tKey: "twDistrict.tanziDistrict",
        code: "427"
      },
      {
        tKey: "twDistrict.dayaDistrict",
        code: "428"
      },
      {
        tKey: "twDistrict.shengangDistrict",
        code: "429"
      },
      {
        tKey: "twDistrict.daduDistrict",
        code: "432"
      },
      {
        tKey: "twDistrict.shaluDistrict",
        code: "433"
      },
      {
        tKey: "twDistrict.longjingDistrict",
        code: "434"
      },
      {
        tKey: "twDistrict.wuqiDistrict",
        code: "435"
      },
      {
        tKey: "twDistrict.qingshuiDistrict",
        code: "436"
      },
      {
        tKey: "twDistrict.dajiaDistrict",
        code: "437"
      },
      {
        tKey: "twDistrict.waipuDistrict",
        code: "438"
      },
      {
        tKey: "twDistrict.daAnDistrict",
        code: "439"
      }
    ]
  },
  {
    tKey: "twCity.changhuaCounty",
    district: [
      {
        tKey: "twDistrict.changhua",
        code: "500"
      },
      {
        tKey: "twDistrict.fenyuan",
        code: "502"
      },
      {
        tKey: "twDistrict.huatan",
        code: "503"
      },
      {
        tKey: "twDistrict.xiushui",
        code: "504"
      },
      {
        tKey: "twDistrict.lukang",
        code: "505"
      },
      {
        tKey: "twDistrict.fuxing",
        code: "506"
      },
      {
        tKey: "twDistrict.xianxi",
        code: "507"
      },
      {
        tKey: "twDistrict.hemei",
        code: "508"
      },
      {
        tKey: "twDistrict.shengang",
        code: "509"
      },
      {
        tKey: "twDistrict.yuanlin",
        code: "510"
      },
      {
        tKey: "twDistrict.shetou",
        code: "511"
      },
      {
        tKey: "twDistrict.yongjing",
        code: "512"
      },
      {
        tKey: "twDistrict.puxin",
        code: "513"
      },
      {
        tKey: "twDistrict.xihu",
        code: "514"
      },
      {
        tKey: "twDistrict.dacun",
        code: "515"
      },
      {
        tKey: "twDistrict.puyan",
        code: "516"
      },
      {
        tKey: "twDistrict.tianzhong",
        code: "520"
      },
      {
        tKey: "twDistrict.beidou",
        code: "521"
      },
      {
        tKey: "twDistrict.tianwei",
        code: "522"
      },
      {
        tKey: "twDistrict.pitou",
        code: "523"
      },
      {
        tKey: "twDistrict.xizhou",
        code: "524"
      },
      {
        tKey: "twDistrict.zhutang",
        code: "525"
      },
      {
        tKey: "twDistrict.erlin",
        code: "526"
      },
      {
        tKey: "twDistrict.dacheng",
        code: "527"
      },
      {
        tKey: "twDistrict.fangyuan",
        code: "528"
      },
      {
        tKey: "twDistrict.ershui",
        code: "530"
      }
    ]
  },
  {
    tKey: "twCity.nantouCounty",
    district: [
      {
        tKey: "twDistrict.nantou",
        code: "540"
      },
      {
        tKey: "twDistrict.zhongliao",
        code: "541"
      },
      {
        tKey: "twDistrict.caotun",
        code: "542"
      },
      {
        tKey: "twDistrict.guoxing",
        code: "544"
      },
      {
        tKey: "twDistrict.puli",
        code: "545"
      },
      {
        tKey: "twDistrict.renAi",
        code: "546"
      },
      {
        tKey: "twDistrict.mingjian",
        code: "551"
      },
      {
        tKey: "twDistrict.jiji",
        code: "552"
      },
      {
        tKey: "twDistrict.shuili",
        code: "553"
      },
      {
        tKey: "twDistrict.yuchi",
        code: "555"
      },
      {
        tKey: "twDistrict.xinyi",
        code: "556"
      },
      {
        tKey: "twDistrict.zhushan",
        code: "557"
      },
      {
        tKey: "twDistrict.lugu",
        code: "558"
      }
    ]
  },
  {
    tKey: "twCity.chiayiCity",
    district: [
      {
        tKey: "twDistrict.eastDistrict",
        code: "600"
      },
      {
        tKey: "twDistrict.westDistrict",
        code: "600"
      }
    ]
  },
  {
    tKey: "twCity.chiayiCounty",
    district: [
      {
        tKey: "twDistrict.fanlu",
        code: "602"
      },
      {
        tKey: "twDistrict.meishan",
        code: "603"
      },
      {
        tKey: "twDistrict.zhuqi",
        code: "604"
      },
      {
        tKey: "twDistrict.alishan",
        code: "605"
      },
      {
        tKey: "twDistrict.zhongpu",
        code: "606"
      },
      {
        tKey: "twDistrict.dapu",
        code: "607"
      },
      {
        tKey: "twDistrict.shuishang",
        code: "608"
      },
      {
        tKey: "twDistrict.lucao",
        code: "611"
      },
      {
        tKey: "twDistrict.taibao",
        code: "612"
      },
      {
        tKey: "twDistrict.puzi",
        code: "613"
      },
      {
        tKey: "twDistrict.dongshi",
        code: "614"
      },
      {
        tKey: "twDistrict.liujiao",
        code: "615"
      },
      {
        tKey: "twDistrict.xingang",
        code: "616"
      },
      {
        tKey: "twDistrict.minxiong",
        code: "621"
      },
      {
        tKey: "twDistrict.dalin",
        code: "622"
      },
      {
        tKey: "twDistrict.xikou",
        code: "623"
      },
      {
        tKey: "twDistrict.yizhu",
        code: "624"
      },
      {
        tKey: "twDistrict.budai",
        code: "625"
      }
    ]
  },
  {
    tKey: "twCity.yunlinCounty",
    district: [
      {
        tKey: "twDistrict.dounan",
        code: "630"
      },
      {
        tKey: "twDistrict.dapi",
        code: "631"
      },
      {
        tKey: "twDistrict.huwei",
        code: "632"
      },
      {
        tKey: "twDistrict.tuku",
        code: "633"
      },
      {
        tKey: "twDistrict.baozhong",
        code: "634"
      },
      {
        tKey: "twDistrict.dongshi",
        code: "635"
      },
      {
        tKey: "twDistrict.taixi",
        code: "636"
      },
      {
        tKey: "twDistrict.lunbei",
        code: "637"
      },
      {
        tKey: "twDistrict.mailiao",
        code: "638"
      },
      {
        tKey: "twDistrict.douliu",
        code: "640"
      },
      {
        tKey: "twDistrict.linnei",
        code: "643"
      },
      {
        tKey: "twDistrict.gukeng",
        code: "646"
      },
      {
        tKey: "twDistrict.citong",
        code: "647"
      },
      {
        tKey: "twDistrict.xiluo",
        code: "648"
      },
      {
        tKey: "twDistrict.erlun",
        code: "649"
      },
      {
        tKey: "twDistrict.beigang",
        code: "651"
      },
      {
        tKey: "twDistrict.shuilin",
        code: "652"
      },
      {
        tKey: "twDistrict.kouhu",
        code: "653"
      },
      {
        tKey: "twDistrict.sihu",
        code: "654"
      },
      {
        tKey: "twDistrict.yuanchang",
        code: "655"
      }
    ]
  },
  {
    tKey: "twCity.tainanCity",
    district: [
      {
        tKey: "twDistrict.westCentralDistrict",
        code: "700"
      },
      {
        tKey: "twDistrict.eastDistrict",
        code: "701"
      },
      {
        tKey: "twDistrict.southDistrict",
        code: "702"
      },
      {
        tKey: "twDistrict.northDistrict",
        code: "704"
      },
      {
        tKey: "twDistrict.anpingDistrict",
        code: "708"
      },
      {
        tKey: "twDistrict.annanDistrict",
        code: "709"
      },
      {
        tKey: "twDistrict.yongkangDistrict",
        code: "710"
      },
      {
        tKey: "twDistrict.guirenDistrict",
        code: "711"
      },
      {
        tKey: "twDistrict.xinhuaDistrict",
        code: "712"
      },
      {
        tKey: "twDistrict.zuozhenDistrict",
        code: "713"
      },
      {
        tKey: "twDistrict.yujingDistrict",
        code: "714"
      },
      {
        tKey: "twDistrict.nanxiDistrict",
        code: "715"
      },
      {
        tKey: "twDistrict.nanhuaDistrict",
        code: "716"
      },
      {
        tKey: "twDistrict.rendeDistrict",
        code: "717"
      },
      {
        tKey: "twDistrict.guanmiaoDistrict",
        code: "718"
      },
      {
        tKey: "twDistrict.longciDistrict",
        code: "719"
      },
      {
        tKey: "twDistrict.guantianDistrict",
        code: "720"
      },
      {
        tKey: "twDistrict.madouDistrict",
        code: "721"
      },
      {
        tKey: "twDistrict.jialiDistrict",
        code: "722"
      },
      {
        tKey: "twDistrict.xigangDistrict",
        code: "723"
      },
      {
        tKey: "twDistrict.qiguDistrict",
        code: "724"
      },
      {
        tKey: "twDistrict.jiangjunDistrict",
        code: "725"
      },
      {
        tKey: "twDistrict.xuejiaDistrict",
        code: "726"
      },
      {
        tKey: "twDistrict.beimenDistrict",
        code: "727"
      },
      {
        tKey: "twDistrict.xinyingDistrict",
        code: "730"
      },
      {
        tKey: "twDistrict.houbiDistrict",
        code: "731"
      },
      {
        tKey: "twDistrict.baiheDistrict",
        code: "732"
      },
      {
        tKey: "twDistrict.dongshanDistrict",
        code: "733"
      },
      {
        tKey: "twDistrict.liujiaDistrict",
        code: "734"
      },
      {
        tKey: "twDistrict.xiayingDistrict",
        code: "735"
      },
      {
        tKey: "twDistrict.liuyingDistrict",
        code: "736"
      },
      {
        tKey: "twDistrict.yanshuiDistrict",
        code: "737"
      },
      {
        tKey: "twDistrict.shanhuaDistrict",
        code: "741"
      },
      {
        tKey: "twDistrict.daneiDistrict",
        code: "742"
      },
      {
        tKey: "twDistrict.shanshangDistrict",
        code: "743"
      },
      {
        tKey: "twDistrict.xinshiDistrict",
        code: "744"
      },
      {
        tKey: "twDistrict.andingDistrict",
        code: "745"
      }
    ]
  },
  {
    tKey: "twCity.kaohsiungCity",
    district: [
      {
        tKey: "twDistrict.xinxingDistrict",
        code: "800"
      },
      {
        tKey: "twDistrict.qianjinDistrict",
        code: "801"
      },
      {
        tKey: "twDistrict.lingyaDistrict",
        code: "802"
      },
      {
        tKey: "twDistrict.yanchengDistrict",
        code: "803"
      },
      {
        tKey: "twDistrict.gushanDistrict",
        code: "804"
      },
      {
        tKey: "twDistrict.qijinDistrict",
        code: "805"
      },
      {
        tKey: "twDistrict.qianzhenDistrict",
        code: "806"
      },
      {
        tKey: "twDistrict.sanminDistrict",
        code: "807"
      },
      {
        tKey: "twDistrict.nanzihDistrict",
        code: "811"
      },
      {
        tKey: "twDistrict.xiaogangDistrict",
        code: "812"
      },
      {
        tKey: "twDistrict.zuoyingDistrict",
        code: "813"
      },
      {
        tKey: "twDistrict.renwuDistrict",
        code: "814"
      },
      {
        tKey: "twDistrict.dasheDistrict",
        code: "815"
      },
      {
        tKey: "twDistrict.gangshanDistrict",
        code: "820"
      },
      {
        tKey: "twDistrict.luzhuDistrict",
        code: "821"
      },
      {
        tKey: "twDistrict.alianDistrict",
        code: "822"
      },
      {
        tKey: "twDistrict.tianliaoDistrict",
        code: "823"
      },
      {
        tKey: "twDistrict.yanchaoDistrict",
        code: "824"
      },
      {
        tKey: "twDistrict.qiaotouDistrict",
        code: "825"
      },
      {
        tKey: "twDistrict.ziguanDistrict",
        code: "826"
      },
      {
        tKey: "twDistrict.mituoDistrict",
        code: "827"
      },
      {
        tKey: "twDistrict.yongAnDistrict",
        code: "828"
      },
      {
        tKey: "twDistrict.huneiDistrict",
        code: "829"
      },
      {
        tKey: "twDistrict.fengshanDistrict",
        code: "830"
      },
      {
        tKey: "twDistrict.daliaoDistrict",
        code: "831"
      },
      {
        tKey: "twDistrict.linyuanDistrict",
        code: "832"
      },
      {
        tKey: "twDistrict.niaosongDistrict",
        code: "833"
      },
      {
        tKey: "twDistrict.dashuDistrict",
        code: "840"
      },
      {
        tKey: "twDistrict.qishanDistrict",
        code: "842"
      },
      {
        tKey: "twDistrict.meinongDistrict",
        code: "843"
      },
      {
        tKey: "twDistrict.liuguiDistrict",
        code: "844"
      },
      {
        tKey: "twDistrict.neimenDistrict",
        code: "845"
      },
      {
        tKey: "twDistrict.shanlinDistrict",
        code: "846"
      },
      {
        tKey: "twDistrict.jiaxianDistrict",
        code: "847"
      },
      {
        tKey: "twDistrict.taoyuanDistrict",
        code: "848"
      },
      {
        tKey: "twDistrict.namaxiaDistrict",
        code: "849"
      },
      {
        tKey: "twDistrict.maolinDistrict",
        code: "851"
      },
      {
        tKey: "twDistrict.jiadingDistrict",
        code: "852"
      }
    ]
  },
  {
    tKey: "twCity.southChinaSeaIslands",
    district: [
      {
        tKey: "twDistrict.pratasIsland",
        code: "817"
      },
      {
        tKey: "twDistrict.spratlyIslands",
        code: "819"
      }
    ]
  },
  {
    tKey: "twCity.penghuCounty",
    district: [
      {
        tKey: "twDistrict.magong",
        code: "880"
      },
      {
        tKey: "twDistrict.xiyu",
        code: "881"
      },
      {
        tKey: "twDistrict.wangAn",
        code: "882"
      },
      {
        tKey: "twDistrict.qimei",
        code: "883"
      },
      {
        tKey: "twDistrict.baisha",
        code: "884"
      },
      {
        tKey: "twDistrict.huxi",
        code: "885"
      }
    ]
  },
  {
    tKey: "twCity.pingtungCounty",
    district: [
      {
        tKey: "twDistrict.pingtung",
        code: "900"
      },
      {
        tKey: "twDistrict.sandimen",
        code: "901"
      },
      {
        tKey: "twDistrict.wutai",
        code: "902"
      },
      {
        tKey: "twDistrict.majia",
        code: "903"
      },
      {
        tKey: "twDistrict.jiuru",
        code: "904"
      },
      {
        tKey: "twDistrict.ligang",
        code: "905"
      },
      {
        tKey: "twDistrict.gaoshu",
        code: "906"
      },
      {
        tKey: "twDistrict.yanpu",
        code: "907"
      },
      {
        tKey: "twDistrict.changzhi",
        code: "908"
      },
      {
        tKey: "twDistrict.linluo",
        code: "909"
      },
      {
        tKey: "twDistrict.zhutian",
        code: "911"
      },
      {
        tKey: "twDistrict.neipu",
        code: "912"
      },
      {
        tKey: "twDistrict.wandan",
        code: "913"
      },
      {
        tKey: "twDistrict.chaozhou",
        code: "920"
      },
      {
        tKey: "twDistrict.taiwu",
        code: "921"
      },
      {
        tKey: "twDistrict.laiyi",
        code: "922"
      },
      {
        tKey: "twDistrict.wanluan",
        code: "923"
      },
      {
        tKey: "twDistrict.kanding",
        code: "924"
      },
      {
        tKey: "twDistrict.sinpi",
        code: "925"
      },
      {
        tKey: "twDistrict.nanzhou",
        code: "926"
      },
      {
        tKey: "twDistrict.linbian",
        code: "927"
      },
      {
        tKey: "twDistrict.donggang",
        code: "928"
      },
      {
        tKey: "twDistrict.liuqiu",
        code: "929"
      },
      {
        tKey: "twDistrict.jiadong",
        code: "931"
      },
      {
        tKey: "twDistrict.xinyuan",
        code: "932"
      },
      {
        tKey: "twDistrict.fangliao",
        code: "940"
      },
      {
        tKey: "twDistrict.fangshan",
        code: "941"
      },
      {
        tKey: "twDistrict.chunri",
        code: "942"
      },
      {
        tKey: "twDistrict.shizi",
        code: "943"
      },
      {
        tKey: "twDistrict.checheng",
        code: "944"
      },
      {
        tKey: "twDistrict.mudan",
        code: "945"
      },
      {
        tKey: "twDistrict.hengchun",
        code: "946"
      },
      {
        tKey: "twDistrict.manzhou",
        code: "947"
      }
    ]
  },
  {
    tKey: "twCity.taitungCounty",
    district: [
      {
        tKey: "twDistrict.taitung",
        code: "950"
      },
      {
        tKey: "twDistrict.greenIsland",
        code: "951"
      },
      {
        tKey: "twDistrict.lanyu",
        code: "952"
      },
      {
        tKey: "twDistrict.yanping",
        code: "953"
      },
      {
        tKey: "twDistrict.beinan",
        code: "954"
      },
      {
        tKey: "twDistrict.luye",
        code: "955"
      },
      {
        tKey: "twDistrict.guanshan",
        code: "956"
      },
      {
        tKey: "twDistrict.haiduan",
        code: "957"
      },
      {
        tKey: "twDistrict.chishang",
        code: "958"
      },
      {
        tKey: "twDistrict.donghe",
        code: "959"
      },
      {
        tKey: "twDistrict.chenggong",
        code: "961"
      },
      {
        tKey: "twDistrict.changbin",
        code: "962"
      },
      {
        tKey: "twDistrict.taimali",
        code: "963"
      },
      {
        tKey: "twDistrict.jinfeng",
        code: "964"
      },
      {
        tKey: "twDistrict.dawu",
        code: "965"
      },
      {
        tKey: "twDistrict.daren",
        code: "966"
      }
    ]
  },
  {
    tKey: "twCity.hualienCounty",
    district: [
      {
        tKey: "twDistrict.hualien",
        code: "970"
      },
      {
        tKey: "twDistrict.xincheng",
        code: "971"
      },
      {
        tKey: "twDistrict.xiulin",
        code: "972"
      },
      {
        tKey: "twDistrict.jiAn",
        code: "973"
      },
      {
        tKey: "twDistrict.shoufeng",
        code: "974"
      },
      {
        tKey: "twDistrict.fenglin",
        code: "975"
      },
      {
        tKey: "twDistrict.guangfu",
        code: "976"
      },
      {
        tKey: "twDistrict.fengbin",
        code: "977"
      },
      {
        tKey: "twDistrict.ruisui",
        code: "978"
      },
      {
        tKey: "twDistrict.wanrong",
        code: "979"
      },
      {
        tKey: "twDistrict.yuli",
        code: "981"
      },
      {
        tKey: "twDistrict.zhuoxi",
        code: "982"
      },
      {
        tKey: "twDistrict.fuli",
        code: "983"
      }
    ]
  },
  {
    tKey: "twCity.kinmenIslands",
    district: [
      {
        tKey: "twDistrict.jinsha",
        code: "890"
      },
      {
        tKey: "twDistrict.jinhu",
        code: "891"
      },
      {
        tKey: "twDistrict.jinning",
        code: "892"
      },
      {
        tKey: "twDistrict.jincheng",
        code: "893"
      },
      {
        tKey: "twDistrict.lieyu",
        code: "894"
      },
      {
        tKey: "twDistrict.wuqiu",
        code: "896"
      }
    ]
  },
  {
    tKey: "twCity.lienchiangCounty",
    district: [
      {
        tKey: "twDistrict.nangan",
        code: "209"
      },
      {
        tKey: "twDistrict.beigan",
        code: "210"
      },
      {
        tKey: "twDistrict.juguang",
        code: "211"
      },
      {
        tKey: "twDistrict.dongyin",
        code: "212"
      }
    ]
  }
];

var RECTANGLE =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAYCAYAAACSuF9OAAABvUlEQVRIS8XWz2oUQRDH8c+CEP+jF+96y0v4BKJPEA+CEvwX498gJCroRU95BO855BAERUFBCQgqiKKiQVBCcvPgSUJIKOiB3SE70xl3sg3LMDtdVd+uX3V1d/SOvTiEXaX/23zdwD/8wVqnK9Io7uE4DqP7W5tA6/iFx5gtgo5gDifajFzj+y9OFUBH8RzHhggUoWcKoCN4iZBtWCNq6XwBFM/reDgsGnzByXLhzuIcdu8w2CouRR2XgfZgCtewb4egvuMKnkS8rbZ2gNxNErbN9BOn8boIVNVrop4uIrLWxliJIsZ8t/MqoKijG7jVgnxfMYFn5ZXWdeOQ73b6DSpLP5JMi1s5rAMqbO7j6gDkW8Y4FvqtLhco5JtMmdrfMFWfk0wvquxzgcJH3ARu4k4DoG9Jprd1ttsBKnzNpEIPwJzxG2fxNGdyE6C4GVzGNA7UBPmY5r7KgenXGHNsIzvRXR9UTI6zaQzvchzmNMYcP3HMRKbK8sWF6wwqC/h/tn0/uJAvum0cNQfTpPdJpjc5K9puY8zxGUfLBTzCp7SbPuQYtpGhbp8h0RKyC7htoKZJ6bFrsu0HErifk03kyD9urSX1jQAAAABJRU5ErkJggg==";

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function(key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }
  return target;
}

var ProfileMobile = function ProfileMobile() {
  var _districtTW$find;

  var _useState = useState(
      localStorage.user ? JSON.parse(localStorage.user) : null
    ),
    _useState2 = _slicedToArray(_useState, 1),
    user = _useState2[0];

  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    old_password = _useState4[0],
    setOld_password = _useState4[1];

  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    password = _useState6[0],
    setPassword = _useState6[1];

  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    changePasswordError = _useState8[0],
    setChangePasswordError = _useState8[1];

  var _useState9 = useState(user ? user.first_name : ""),
    _useState10 = _slicedToArray(_useState9, 2),
    first_name = _useState10[0],
    setFirst_name = _useState10[1];

  var _useState11 = useState(user ? user.last_name : ""),
    _useState12 = _slicedToArray(_useState11, 2),
    last_name = _useState12[0],
    setLast_name = _useState12[1];

  var _useState13 = useState(user ? user.contact_number : ""),
    _useState14 = _slicedToArray(_useState13, 2),
    contact_number = _useState14[0],
    setContact_number = _useState14[1];

  var _useState15 = useState(user ? user.address_line_1 : ""),
    _useState16 = _slicedToArray(_useState15, 2),
    address_line_1 = _useState16[0],
    setAddress_line_1 = _useState16[1];

  var _useState17 = useState(user ? user.city : ""),
    _useState18 = _slicedToArray(_useState17, 2),
    city = _useState18[0],
    setCity = _useState18[1];

  var _useState19 = useState(user ? user.district : ""),
    _useState20 = _slicedToArray(_useState19, 2),
    district = _useState20[0],
    setDistrict = _useState20[1];

  var _useState21 = useState(
      user !== null && user !== void 0 && user.postal_code
        ? user.postal_code
        : ""
    ),
    _useState22 = _slicedToArray(_useState21, 2),
    postal_code = _useState22[0],
    setPostal_code = _useState22[1];

  var _useState23 = useState(user ? user.country : ""),
    _useState24 = _slicedToArray(_useState23, 2),
    country = _useState24[0],
    setCountry = _useState24[1];

  var _useState25 = useState(
      ((_districtTW$find = districtTW.find(function(c) {
        return (
          formatMessage({
            id: c.tKey
          }) === user.city
        );
      })) === null || _districtTW$find === void 0
        ? void 0
        : _districtTW$find.district) || []
    ),
    _useState26 = _slicedToArray(_useState25, 2),
    districtList = _useState26[0],
    setDistrictList = _useState26[1];

  var _useState27 = useState({}),
    _useState28 = _slicedToArray(_useState27, 2),
    changeInfoError = _useState28[0],
    setChangeInfoError = _useState28[1];

  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    showCityList = _useState30[0],
    setShowCityList = _useState30[1];

  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    showDistrictList = _useState32[0],
    setShowDistrictList = _useState32[1];

  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showCountryList = _useState34[0],
    setShowCountryList = _useState34[1];

  var toggleCityList = function toggleCityList() {
    if (!showCityList) {
      setShowCityList(true);
      setShowDistrictList(false);
      setShowCountryList(false);
    } else {
      setShowCityList(false);
    }
  };

  var toggleDistrictList = function toggleDistrictList() {
    if (!showDistrictList) {
      setShowCityList(false);
      setShowDistrictList(true);
      setShowCountryList(false);
    } else {
      setShowDistrictList(false);
    }
  };

  var toggleCountryList = function toggleCountryList() {
    if (!showCountryList) {
      setShowCityList(false);
      setShowDistrictList(false);
      setShowCountryList(true);
    } else {
      setShowCountryList(false);
    }
  };

  var selectCity = function selectCity(val, list) {
    setCity(val);
    setDistrictList(list);
    setDistrict("");
    setPostal_code("");
    setShowCityList(false);
  };

  var selectDistrict = function selectDistrict(val, code) {
    setDistrict(val);
    setPostal_code(code);
    setShowDistrictList(false);
  };

  var selectCountry = function selectCountry(val) {
    setCountry(val);
    setShowCountryList(false);
  };

  var changePassword = function changePassword() {
    var newChangePasswordError = {};

    if (password === "") {
      newChangePasswordError.password = true;
    }

    if (old_password === "") {
      newChangePasswordError.old_password = true;
    }

    setChangePasswordError(newChangePasswordError);
    if (Object.keys(newChangePasswordError).length > 0) return;
    var data = {
      user: {
        old_password: old_password,
        password: password,
        password_confirmation: password
      }
    };
    post("api/v1/users/reset_password", data, 1)
      .then(function() {
        window.location.reload();
      })
      ["catch"](function() {
        setChangePasswordError({
          newChangePasswordError: newChangePasswordError,
          serverError: true
        });
      });
  };

  var saveInfo = function saveInfo() {
    var newChangeInfoError = {};

    if (first_name === "") {
      newChangeInfoError.first_name = true;
    }

    if (last_name === "") {
      newChangeInfoError.last_name = true;
    }

    if (contact_number === "" || contact_number.length < 8) {
      newChangeInfoError.contact_number = true;
    }

    if (address_line_1 === "") {
      newChangeInfoError.address_line_1 = true;
    }

    if (city === "") {
      newChangeInfoError.city = true;
    }

    if (district === "") {
      newChangeInfoError.district = true;
    }

    if (country === "") {
      newChangeInfoError.country = true;
    }

    setChangeInfoError(newChangeInfoError);
    if (Object.keys(newChangeInfoError).length > 0) return;
    var data = {
      user: {
        first_name: first_name,
        last_name: last_name,
        contact_number: contact_number,
        address_line_1: address_line_1,
        address_line_2: "",
        city: city,
        province: "",
        country: country
      }
    };
    post("api/v1/users/update", data, 1)
      .then(function(res) {
        localStorage.setItem("user", JSON.stringify(res));
        window.location.reload();
      })
      ["catch"](function() {
        setChangeInfoError(
          _objectSpread$2(
            _objectSpread$2({}, newChangeInfoError),
            {},
            {
              serverError: true
            }
          )
        );
      });
  };

  var profiledesc1 = formatMessage({
    id: "profiledesc1"
  });
  var profiledesc2 = formatMessage({
    id: "profiledesc2"
  });
  var profiledesc3 = formatMessage({
    id: "profiledesc3"
  });
  var proile1 = formatMessage({
    id: "proile1"
  });
  var proile2 = formatMessage({
    id: "proile2"
  });
  var proile4 = formatMessage({
    id: "proile4"
  });
  var proile5 = formatMessage({
    id: "proile5"
  });
  var proile6 = formatMessage({
    id: "proile6"
  });
  var proile7 = formatMessage({
    id: "proile7"
  });
  var proilefirstname = formatMessage({
    id: "proile.firstname"
  });
  var proilelastname = formatMessage({
    id: "proile.lastname"
  });
  var proilecontactnum = formatMessage({
    id: "proile.contactnum"
  });
  var proileaddress1 = formatMessage({
    id: "proile.address1"
  });
  var proilecountry = formatMessage({
    id: "proile.country"
  });
  var proilesave = formatMessage({
    id: "proile.save"
  });
  var ordervalidinfo = formatMessage({
    id: "ordervalidinfo"
  });
  var passwordlength = formatMessage({
    id: "passwordlength"
  });
  var cart66 = formatMessage({
    id: "cart.cart66"
  });
  var wrongOldPassword = formatMessage({
    id: "wrongOldPassword"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "mobileproile mpad_h"
    },
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "form"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "title"
        },
        proile1
      ),
      /*#__PURE__*/ React.createElement("br", null),
      /*#__PURE__*/ React.createElement("p", null, profiledesc1),
      /*#__PURE__*/ React.createElement("p", null, profiledesc2),
      /*#__PURE__*/ React.createElement("p", null, profiledesc3),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement("p", null, proile2),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          readOnly: true,
          value: user && user.email ? user.email : ""
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-first-name",
            className: "".concat(
              changeInfoError.first_name ? "form-error-text" : ""
            )
          },
          proilefirstname
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          onInput: function onInput(e) {
            return setFirst_name(e.target.value);
          },
          defaultValue: first_name,
          maxLength: "60"
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-last-name",
            className: "".concat(
              changeInfoError.last_name ? "form-error-text" : ""
            )
          },
          proilelastname
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          onInput: function onInput(e) {
            return setLast_name(e.target.value);
          },
          defaultValue: last_name,
          maxLength: "60"
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-contact-number",
            className: "".concat(
              changeInfoError.contact_number ? "form-error-text" : ""
            )
          },
          proilecontactnum
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          minLength: "10",
          maxLength: "10",
          onInput: function onInput(e) {
            return setContact_number(e.target.value);
          },
          defaultValue: contact_number,
          required: true
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-address-line-1",
            className: "".concat(
              changeInfoError.address_line_1 ? "form-error-text" : ""
            )
          },
          proileaddress1
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          onInput: function onInput(e) {
            return setAddress_line_1(e.target.value);
          },
          defaultValue: address_line_1,
          maxLength: "250"
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group country-dropdown-container",
          style: {
            position: "relative",
            zIndex: 3
          }
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-postal_code"
          },
          ""
            .concat(
              formatMessage({
                id: "postal_code"
              }),
              ": "
            )
            .concat(postal_code)
        )
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group country-dropdown-container",
          style: {
            position: "relative",
            zIndex: 3
          }
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-city",
            className: "".concat(
              changePasswordError.city ? "form-error-text" : ""
            )
          },
          formatMessage({
            id: "twCity"
          })
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          readOnly: true,
          value: city,
          style: {
            cursor: "pointer"
          },
          onClick: toggleCityList
        }),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            onClick: toggleCityList,
            style: {
              width: 12,
              height: 8,
              position: "absolute",
              top: 38,
              right: 0,
              cursor: "pointer"
            }
          },
          /*#__PURE__*/ React.createElement("img", {
            style: {
              width: "100%",
              height: "100%"
            },
            src: RECTANGLE,
            alt: "Dropdown Icon"
          })
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "chooseCountry",
            style: {
              display: showCityList ? "block" : "none",
              bottom: -150,
              height: 150,
              overflow: "auto",
              cursor: "pointer",
              position: "absolute",
              right: 0,
              width: 216,
              border: "1px solid #000"
            }
          },
          districtTW.map(function(districtCity) {
            return /*#__PURE__*/ React.createElement(
              "div",
              {
                key: districtCity.tKey,
                onClick: function onClick() {
                  return selectCity(
                    formatMessage({
                      id: districtCity.tKey
                    }),
                    districtCity.district
                  );
                },
                style: {
                  cursor: "pointer",
                  position: "relative",
                  zIndex: 11,
                  paddingLeft: 18,
                  height: 44,
                  lineHeight: "44px",
                  fontSize: 14,
                  color: "#000",
                  backgroundColor: "#FFF"
                }
              },
              formatMessage({
                id: districtCity.tKey
              })
            );
          })
        )
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group country-dropdown-container",
          style: {
            position: "relative",
            zIndex: 2
          }
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-district",
            className: "".concat(
              changePasswordError.district ? "form-error-text" : ""
            )
          },
          formatMessage({
            id: "twDistrict"
          })
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          readOnly: true,
          value: district,
          style: {
            cursor: "pointer"
          },
          onClick: toggleDistrictList
        }),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            onClick: toggleDistrictList,
            style: {
              width: 12,
              height: 8,
              position: "absolute",
              top: 38,
              right: 0,
              cursor: "pointer"
            }
          },
          /*#__PURE__*/ React.createElement("img", {
            style: {
              width: "100%",
              height: "100%"
            },
            src: RECTANGLE,
            alt: "Dropdown Icon"
          })
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "chooseCountry",
            style: {
              display: showDistrictList ? "block" : "none",
              bottom: -150,
              height: 150,
              overflow: "auto",
              cursor: "pointer",
              position: "absolute",
              right: 0,
              width: 216,
              border: "1px solid #000",
              background: "white"
            }
          },
          districtList.map(function(twDistrict) {
            return /*#__PURE__*/ React.createElement(
              "div",
              {
                key: twDistrict.tKey,
                onClick: function onClick() {
                  return selectDistrict(
                    formatMessage({
                      id: twDistrict.tKey
                    }),
                    twDistrict.code
                  );
                },
                style: {
                  cursor: "pointer",
                  position: "relative",
                  zIndex: 11,
                  paddingLeft: 18,
                  height: 44,
                  lineHeight: "44px",
                  fontSize: 14,
                  color: "#000",
                  backgroundColor: "#FFF"
                }
              },
              ""
                .concat(
                  formatMessage({
                    id: twDistrict.tKey
                  }),
                  " ("
                )
                .concat(twDistrict.code, ")")
            );
          })
        )
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group country-dropdown-container",
          style: {
            position: "relative",
            zIndex: 1
          }
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-country",
            className: "".concat(
              changeInfoError.country ? "form-error-text" : ""
            )
          },
          proilecountry
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          readOnly: true,
          value: country,
          onClick: toggleCountryList
        }),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            onClick: toggleCountryList,
            style: {
              width: 12,
              height: 8,
              position: "absolute",
              top: 38,
              right: 0
            }
          },
          /*#__PURE__*/ React.createElement("img", {
            style: {
              width: "100%",
              height: "100%"
            },
            src: RECTANGLE,
            alt: "Dropdown Icon"
          })
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "chooseCountry",
            style: {
              display: showCountryList ? "block" : "none",
              bottom: -49,
              cursor: "pointer",
              position: "absolute",
              right: 0,
              width: 216,
              border: "1px solid #000"
            }
          },
          [cart66].map(function(place) {
            return /*#__PURE__*/ React.createElement(
              "div",
              {
                key: place,
                onClick: function onClick() {
                  return selectCountry(place);
                },
                style: {
                  cursor: "pointer",
                  position: "relative",
                  zIndex: 11,
                  paddingLeft: 18,
                  height: 44,
                  lineHeight: "44px",
                  fontSize: 14,
                  color: "#000",
                  backgroundColor: "#FFF"
                }
              },
              place
            );
          })
        )
      ),
      /*#__PURE__*/ React.createElement("br", null),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          id: "form-error",
          className: "form-error",
          style: {
            display: Object.keys(changeInfoError).length > 0 ? "block" : "none"
          }
        },
        ordervalidinfo
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "btn",
          onClick: saveInfo
        },
        proilesave
      )
    ),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "form"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "title"
        },
        proile4
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-current-pw",
            className: "".concat(
              changePasswordError.old_password ? "form-error-text" : ""
            )
          },
          proile5
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          onInput: function onInput(e) {
            return setOld_password(e.target.value);
          },
          maxLength: "60"
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-new-pw",
            className: "".concat(
              changePasswordError.password ? "form-error-text" : ""
            )
          },
          proile6
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "password",
          onInput: function onInput(e) {
            return setPassword(e.target.value);
          },
          maxLength: "60"
        })
      )
    ),
    /*#__PURE__*/ React.createElement("br", null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        id: "form-error-pw",
        className: "form-error",
        style: {
          display:
            Object.keys(changePasswordError).length > 0 ? "block" : "none"
        }
      },
      changePasswordError.serverError ? wrongOldPassword : passwordlength
    ),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "btn",
        onClick: changePassword
      },
      proile7
    )
  );
};

var moment$1 = { exports: {} };

(function(module, exports) {
  (function(global, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    var hookCallback;

    function hooks() {
      return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
      hookCallback = callback;
    }

    function isArray(input) {
      return (
        input instanceof Array ||
        Object.prototype.toString.call(input) === "[object Array]"
      );
    }

    function isObject(input) {
      // IE8 will treat undefined and null as object if it wasn't for
      // input != null
      return (
        input != null &&
        Object.prototype.toString.call(input) === "[object Object]"
      );
    }

    function isObjectEmpty(obj) {
      if (Object.getOwnPropertyNames) {
        return Object.getOwnPropertyNames(obj).length === 0;
      } else {
        var k;
        for (k in obj) {
          if (obj.hasOwnProperty(k)) {
            return false;
          }
        }
        return true;
      }
    }

    function isUndefined(input) {
      return input === void 0;
    }

    function isNumber(input) {
      return (
        typeof input === "number" ||
        Object.prototype.toString.call(input) === "[object Number]"
      );
    }

    function isDate(input) {
      return (
        input instanceof Date ||
        Object.prototype.toString.call(input) === "[object Date]"
      );
    }

    function map(arr, fn) {
      var res = [],
        i;
      for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
      }
      return res;
    }

    function hasOwnProp(a, b) {
      return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
      for (var i in b) {
        if (hasOwnProp(b, i)) {
          a[i] = b[i];
        }
      }

      if (hasOwnProp(b, "toString")) {
        a.toString = b.toString;
      }

      if (hasOwnProp(b, "valueOf")) {
        a.valueOf = b.valueOf;
      }

      return a;
    }

    function createUTC(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
      // We need to deep clone this object.
      return {
        empty: false,
        unusedTokens: [],
        unusedInput: [],
        overflow: -2,
        charsLeftOver: 0,
        nullInput: false,
        invalidMonth: null,
        invalidFormat: false,
        userInvalidated: false,
        iso: false,
        parsedDateParts: [],
        meridiem: null,
        rfc2822: false,
        weekdayMismatch: false
      };
    }

    function getParsingFlags(m) {
      if (m._pf == null) {
        m._pf = defaultParsingFlags();
      }
      return m._pf;
    }

    var some;
    if (Array.prototype.some) {
      some = Array.prototype.some;
    } else {
      some = function(fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
          if (i in t && fun.call(this, t[i], i, t)) {
            return true;
          }
        }

        return false;
      };
    }

    function isValid(m) {
      if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function(i) {
          return i != null;
        });
        var isNowValid =
          !isNaN(m._d.getTime()) &&
          flags.overflow < 0 &&
          !flags.empty &&
          !flags.invalidMonth &&
          !flags.invalidWeekday &&
          !flags.weekdayMismatch &&
          !flags.nullInput &&
          !flags.invalidFormat &&
          !flags.userInvalidated &&
          (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
          isNowValid =
            isNowValid &&
            flags.charsLeftOver === 0 &&
            flags.unusedTokens.length === 0 &&
            flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
          m._isValid = isNowValid;
        } else {
          return isNowValid;
        }
      }
      return m._isValid;
    }

    function createInvalid(flags) {
      var m = createUTC(NaN);
      if (flags != null) {
        extend(getParsingFlags(m), flags);
      } else {
        getParsingFlags(m).userInvalidated = true;
      }

      return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []);

    function copyConfig(to, from) {
      var i, prop, val;

      if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
      }
      if (!isUndefined(from._i)) {
        to._i = from._i;
      }
      if (!isUndefined(from._f)) {
        to._f = from._f;
      }
      if (!isUndefined(from._l)) {
        to._l = from._l;
      }
      if (!isUndefined(from._strict)) {
        to._strict = from._strict;
      }
      if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
      }
      if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
      }
      if (!isUndefined(from._offset)) {
        to._offset = from._offset;
      }
      if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
      }
      if (!isUndefined(from._locale)) {
        to._locale = from._locale;
      }

      if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
          prop = momentProperties[i];
          val = from[prop];
          if (!isUndefined(val)) {
            to[prop] = val;
          }
        }
      }

      return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
      copyConfig(this, config);
      this._d = new Date(config._d != null ? config._d.getTime() : NaN);
      if (!this.isValid()) {
        this._d = new Date(NaN);
      }
      // Prevent infinite loop in case updateOffset creates new moment
      // objects.
      if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
      }
    }

    function isMoment(obj) {
      return (
        obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
      );
    }

    function absFloor(number) {
      if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
      } else {
        return Math.floor(number);
      }
    }

    function toInt(argumentForCoercion) {
      var coercedNumber = +argumentForCoercion,
        value = 0;

      if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
      }

      return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
      var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
      for (i = 0; i < len; i++) {
        if (
          (dontConvert && array1[i] !== array2[i]) ||
          (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
        ) {
          diffs++;
        }
      }
      return diffs + lengthDiff;
    }

    function warn(msg) {
      if (
        hooks.suppressDeprecationWarnings === false &&
        typeof console !== "undefined" &&
        console.warn
      ) {
        console.warn("Deprecation warning: " + msg);
      }
    }

    function deprecate(msg, fn) {
      var firstTime = true;

      return extend(function() {
        if (hooks.deprecationHandler != null) {
          hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
          var args = [];
          var arg;
          for (var i = 0; i < arguments.length; i++) {
            arg = "";
            if (typeof arguments[i] === "object") {
              arg += "\n[" + i + "] ";
              for (var key in arguments[0]) {
                arg += key + ": " + arguments[0][key] + ", ";
              }
              arg = arg.slice(0, -2); // Remove trailing comma and space
            } else {
              arg = arguments[i];
            }
            args.push(arg);
          }
          warn(
            msg +
              "\nArguments: " +
              Array.prototype.slice.call(args).join("") +
              "\n" +
              new Error().stack
          );
          firstTime = false;
        }
        return fn.apply(this, arguments);
      }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
      }
      if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
      }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
      return (
        input instanceof Function ||
        Object.prototype.toString.call(input) === "[object Function]"
      );
    }

    function set(config) {
      var prop, i;
      for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
          this[i] = prop;
        } else {
          this["_" + i] = prop;
        }
      }
      this._config = config;
      // Lenient ordinal parsing accepts just a number in addition to
      // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
      // TODO: Remove "ordinalParse" fallback in next major release.
      this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
          "|" +
          /\d{1,2}/.source
      );
    }

    function mergeConfigs(parentConfig, childConfig) {
      var res = extend({}, parentConfig),
        prop;
      for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
          if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
            res[prop] = {};
            extend(res[prop], parentConfig[prop]);
            extend(res[prop], childConfig[prop]);
          } else if (childConfig[prop] != null) {
            res[prop] = childConfig[prop];
          } else {
            delete res[prop];
          }
        }
      }
      for (prop in parentConfig) {
        if (
          hasOwnProp(parentConfig, prop) &&
          !hasOwnProp(childConfig, prop) &&
          isObject(parentConfig[prop])
        ) {
          // make sure changes to properties don't modify parent config
          res[prop] = extend({}, res[prop]);
        }
      }
      return res;
    }

    function Locale(config) {
      if (config != null) {
        this.set(config);
      }
    }

    var keys;

    if (Object.keys) {
      keys = Object.keys;
    } else {
      keys = function(obj) {
        var i,
          res = [];
        for (i in obj) {
          if (hasOwnProp(obj, i)) {
            res.push(i);
          }
        }
        return res;
      };
    }

    var defaultCalendar = {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    };

    function calendar(key, mom, now) {
      var output = this._calendar[key] || this._calendar["sameElse"];
      return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
      LTS: "h:mm:ss A",
      LT: "h:mm A",
      L: "MM/DD/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    };

    function longDateFormat(key) {
      var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

      if (format || !formatUpper) {
        return format;
      }

      this._longDateFormat[key] = formatUpper.replace(
        /MMMM|MM|DD|dddd/g,
        function(val) {
          return val.slice(1);
        }
      );

      return this._longDateFormat[key];
    }

    var defaultInvalidDate = "Invalid date";

    function invalidDate() {
      return this._invalidDate;
    }

    var defaultOrdinal = "%d";
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
      return this._ordinal.replace("%d", number);
    }

    var defaultRelativeTime = {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
      var output = this._relativeTime[string];
      return isFunction(output)
        ? output(number, withoutSuffix, string, isFuture)
        : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
      var format = this._relativeTime[diff > 0 ? "future" : "past"];
      return isFunction(format)
        ? format(output)
        : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
      var lowerCase = unit.toLowerCase();
      aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
      return typeof units === "string"
        ? aliases[units] || aliases[units.toLowerCase()]
        : undefined;
    }

    function normalizeObjectUnits(inputObject) {
      var normalizedInput = {},
        normalizedProp,
        prop;

      for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
          normalizedProp = normalizeUnits(prop);
          if (normalizedProp) {
            normalizedInput[normalizedProp] = inputObject[prop];
          }
        }
      }

      return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
      priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
      var units = [];
      for (var u in unitsObj) {
        units.push({ unit: u, priority: priorities[u] });
      }
      units.sort(function(a, b) {
        return a.priority - b.priority;
      });
      return units;
    }

    function zeroFill(number, targetLength, forceSign) {
      var absNumber = "" + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
      return (
        (sign ? (forceSign ? "+" : "") : "-") +
        Math.pow(10, Math.max(0, zerosToFill))
          .toString()
          .substr(1) +
        absNumber
      );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
      var func = callback;
      if (typeof callback === "string") {
        func = function() {
          return this[callback]();
        };
      }
      if (token) {
        formatTokenFunctions[token] = func;
      }
      if (padded) {
        formatTokenFunctions[padded[0]] = function() {
          return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
      }
      if (ordinal) {
        formatTokenFunctions[ordinal] = function() {
          return this.localeData().ordinal(func.apply(this, arguments), token);
        };
      }
    }

    function removeFormattingTokens(input) {
      if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, "");
      }
      return input.replace(/\\/g, "");
    }

    function makeFormatFunction(format) {
      var array = format.match(formattingTokens),
        i,
        length;

      for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
          array[i] = formatTokenFunctions[array[i]];
        } else {
          array[i] = removeFormattingTokens(array[i]);
        }
      }

      return function(mom) {
        var output = "",
          i;
        for (i = 0; i < length; i++) {
          output += isFunction(array[i])
            ? array[i].call(mom, format)
            : array[i];
        }
        return output;
      };
    }

    // format date using native date object
    function formatMoment(m, format) {
      if (!m.isValid()) {
        return m.localeData().invalidDate();
      }

      format = expandFormat(format, m.localeData());
      formatFunctions[format] =
        formatFunctions[format] || makeFormatFunction(format);

      return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
      var i = 5;

      function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
      }

      localFormattingTokens.lastIndex = 0;
      while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(
          localFormattingTokens,
          replaceLongDateFormatTokens
        );
        localFormattingTokens.lastIndex = 0;
        i -= 1;
      }

      return format;
    }

    var match1 = /\d/; //       0 - 9
    var match2 = /\d\d/; //      00 - 99
    var match3 = /\d{3}/; //     000 - 999
    var match4 = /\d{4}/; //    0000 - 9999
    var match6 = /[+-]?\d{6}/; // -999999 - 999999
    var match1to2 = /\d\d?/; //       0 - 99
    var match3to4 = /\d\d\d\d?/; //     999 - 9999
    var match5to6 = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3 = /\d{1,3}/; //       0 - 999
    var match1to4 = /\d{1,4}/; //       0 - 9999
    var match1to6 = /[+-]?\d{1,6}/; // -999999 - 999999

    var matchUnsigned = /\d+/; //       0 - inf
    var matchSigned = /[+-]?\d+/; //    -inf - inf

    var matchOffset = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken(token, regex, strictRegex) {
      regexes[token] = isFunction(regex)
        ? regex
        : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
          };
    }

    function getParseRegexForToken(token, config) {
      if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
      }

      return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
      return regexEscape(
        s
          .replace("\\", "")
          .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(
            matched,
            p1,
            p2,
            p3,
            p4
          ) {
            return p1 || p2 || p3 || p4;
          })
      );
    }

    function regexEscape(s) {
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }

    var tokens = {};

    function addParseToken(token, callback) {
      var i,
        func = callback;
      if (typeof token === "string") {
        token = [token];
      }
      if (isNumber(callback)) {
        func = function(input, array) {
          array[callback] = toInt(input);
        };
      }
      for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
      }
    }

    function addWeekParseToken(token, callback) {
      addParseToken(token, function(input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
      });
    }

    function addTimeToArrayFromToken(token, input, config) {
      if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
      }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken("Y", 0, 0, function() {
      var y = this.year();
      return y <= 9999 ? "" + y : "+" + y;
    });

    addFormatToken(0, ["YY", 2], 0, function() {
      return this.year() % 100;
    });

    addFormatToken(0, ["YYYY", 4], 0, "year");
    addFormatToken(0, ["YYYYY", 5], 0, "year");
    addFormatToken(0, ["YYYYYY", 6, true], 0, "year");

    // ALIASES

    addUnitAlias("year", "y");

    // PRIORITIES

    addUnitPriority("year", 1);

    // PARSING

    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);

    addParseToken(["YYYYY", "YYYYYY"], YEAR);
    addParseToken("YYYY", function(input, array) {
      array[YEAR] =
        input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
      array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
      array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
      return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
      return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function(input) {
      return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet("FullYear", true);

    function getIsLeapYear() {
      return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
      return function(value) {
        if (value != null) {
          set$1(this, unit, value);
          hooks.updateOffset(this, keepTime);
          return this;
        } else {
          return get(this, unit);
        }
      };
    }

    function get(mom, unit) {
      return mom.isValid()
        ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]()
        : NaN;
    }

    function set$1(mom, unit, value) {
      if (mom.isValid() && !isNaN(value)) {
        if (
          unit === "FullYear" &&
          isLeapYear(mom.year()) &&
          mom.month() === 1 &&
          mom.date() === 29
        ) {
          mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](
            value,
            mom.month(),
            daysInMonth(value, mom.month())
          );
        } else {
          mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
      }
    }

    // MOMENTS

    function stringGet(units) {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units]();
      }
      return this;
    }

    function stringSet(units, value) {
      if (typeof units === "object") {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
          this[prioritized[i].unit](units[prioritized[i].unit]);
        }
      } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
          return this[units](value);
        }
      }
      return this;
    }

    function mod(n, x) {
      return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
      indexOf = Array.prototype.indexOf;
    } else {
      indexOf = function(o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
          if (this[i] === o) {
            return i;
          }
        }
        return -1;
      };
    }

    function daysInMonth(year, month) {
      if (isNaN(year) || isNaN(month)) {
        return NaN;
      }
      var modMonth = mod(month, 12);
      year += (month - modMonth) / 12;
      return modMonth === 1
        ? isLeapYear(year)
          ? 29
          : 28
        : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken("M", ["MM", 2], "Mo", function() {
      return this.month() + 1;
    });

    addFormatToken("MMM", 0, 0, function(format) {
      return this.localeData().monthsShort(this, format);
    });

    addFormatToken("MMMM", 0, 0, function(format) {
      return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias("month", "M");

    // PRIORITY

    addUnitPriority("month", 8);

    // PARSING

    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
      return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
      return locale.monthsRegex(isStrict);
    });

    addParseToken(["M", "MM"], function(input, array) {
      array[MONTH] = toInt(input) - 1;
    });

    addParseToken(["MMM", "MMMM"], function(input, array, config, token) {
      var month = config._locale.monthsParse(input, token, config._strict);
      // if we didn't find a month name, mark the date as invalid.
      if (month != null) {
        array[MONTH] = month;
      } else {
        getParsingFlags(config).invalidMonth = input;
      }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    );
    function localeMonths(m, format) {
      if (!m) {
        return isArray(this._months)
          ? this._months
          : this._months["standalone"];
      }
      return isArray(this._months)
        ? this._months[m.month()]
        : this._months[
            (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
              ? "format"
              : "standalone"
          ][m.month()];
    }

    var defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split(
      "_"
    );
    function localeMonthsShort(m, format) {
      if (!m) {
        return isArray(this._monthsShort)
          ? this._monthsShort
          : this._monthsShort["standalone"];
      }
      return isArray(this._monthsShort)
        ? this._monthsShort[m.month()]
        : this._monthsShort[
            MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"
          ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
      var i,
        ii,
        mom,
        llc = monthName.toLocaleLowerCase();
      if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
          mom = createUTC([2000, i]);
          this._shortMonthsParse[i] = this.monthsShort(
            mom,
            ""
          ).toLocaleLowerCase();
          this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === "MMM") {
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === "MMM") {
          ii = indexOf.call(this._shortMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._longMonthsParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._longMonthsParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortMonthsParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeMonthsParse(monthName, format, strict) {
      var i, mom, regex;

      if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
      }

      if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
      }

      // TODO: add sorting
      // Sorting makes sure if one month (or abbr) is a prefix of another
      // see sorting in computeMonthsParse
      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
          this._longMonthsParse[i] = new RegExp(
            "^" + this.months(mom, "").replace(".", "") + "$",
            "i"
          );
          this._shortMonthsParse[i] = new RegExp(
            "^" + this.monthsShort(mom, "").replace(".", "") + "$",
            "i"
          );
        }
        if (!strict && !this._monthsParse[i]) {
          regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
          this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
        }
        // test the regex
        if (
          strict &&
          format === "MMMM" &&
          this._longMonthsParse[i].test(monthName)
        ) {
          return i;
        } else if (
          strict &&
          format === "MMM" &&
          this._shortMonthsParse[i].test(monthName)
        ) {
          return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
          return i;
        }
      }
    }

    // MOMENTS

    function setMonth(mom, value) {
      var dayOfMonth;

      if (!mom.isValid()) {
        // No op
        return mom;
      }

      if (typeof value === "string") {
        if (/^\d+$/.test(value)) {
          value = toInt(value);
        } else {
          value = mom.localeData().monthsParse(value);
          // TODO: Another silent failure?
          if (!isNumber(value)) {
            return mom;
          }
        }
      }

      dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
      mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
      return mom;
    }

    function getSetMonth(value) {
      if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
      } else {
        return get(this, "Month");
      }
    }

    function getDaysInMonth() {
      return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsShortStrictRegex;
        } else {
          return this._monthsShortRegex;
        }
      } else {
        if (!hasOwnProp(this, "_monthsShortRegex")) {
          this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict
          ? this._monthsShortStrictRegex
          : this._monthsShortRegex;
      }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex(isStrict) {
      if (this._monthsParseExact) {
        if (!hasOwnProp(this, "_monthsRegex")) {
          computeMonthsParse.call(this);
        }
        if (isStrict) {
          return this._monthsStrictRegex;
        } else {
          return this._monthsRegex;
        }
      } else {
        if (!hasOwnProp(this, "_monthsRegex")) {
          this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict
          ? this._monthsStrictRegex
          : this._monthsRegex;
      }
    }

    function computeMonthsParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom;
      for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ""));
        longPieces.push(this.months(mom, ""));
        mixedPieces.push(this.months(mom, ""));
        mixedPieces.push(this.monthsShort(mom, ""));
      }
      // Sorting makes sure if one month (or abbr) is a prefix of another it
      // will match the longer piece.
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
      }
      for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }

      this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._monthsShortRegex = this._monthsRegex;
      this._monthsStrictRegex = new RegExp(
        "^(" + longPieces.join("|") + ")",
        "i"
      );
      this._monthsShortStrictRegex = new RegExp(
        "^(" + shortPieces.join("|") + ")",
        "i"
      );
    }

    function createDate(y, m, d, h, M, s, ms) {
      // can't just apply() to create a date:
      // https://stackoverflow.com/q/181348
      var date = new Date(y, m, d, h, M, s, ms);

      // the date constructor remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
      }
      return date;
    }

    function createUTCDate(y) {
      var date = new Date(Date.UTC.apply(null, arguments));

      // the Date.UTC function remaps years 0-99 to 1900-1999
      if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
      }
      return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
      var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

      return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
      var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear,
        resDayOfYear;

      if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
      } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
      } else {
        resYear = year;
        resDayOfYear = dayOfYear;
      }

      return {
        year: resYear,
        dayOfYear: resDayOfYear
      };
    }

    function weekOfYear(mom, dow, doy) {
      var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek,
        resYear;

      if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
      } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
      } else {
        resYear = mom.year();
        resWeek = week;
      }

      return {
        week: resWeek,
        year: resYear
      };
    }

    function weeksInYear(year, dow, doy) {
      var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
      return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken("w", ["ww", 2], "wo", "week");
    addFormatToken("W", ["WW", 2], "Wo", "isoWeek");

    // ALIASES

    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");

    // PRIORITIES

    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);

    // PARSING

    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);

    addWeekParseToken(["w", "ww", "W", "WW"], function(
      input,
      week,
      config,
      token
    ) {
      week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
      return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
      dow: 0, // Sunday is the first day of the week.
      doy: 6 // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek() {
      return this._week.dow;
    }

    function localeFirstDayOfYear() {
      return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
      var week = this.localeData().week(this);
      return input == null ? week : this.add((input - week) * 7, "d");
    }

    function getSetISOWeek(input) {
      var week = weekOfYear(this, 1, 4).week;
      return input == null ? week : this.add((input - week) * 7, "d");
    }

    // FORMATTING

    addFormatToken("d", 0, "do", "day");

    addFormatToken("dd", 0, 0, function(format) {
      return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken("ddd", 0, 0, function(format) {
      return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken("dddd", 0, 0, function(format) {
      return this.localeData().weekdays(this, format);
    });

    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");

    // ALIASES

    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");

    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);

    // PARSING

    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
      return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
      return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
      return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(["dd", "ddd", "dddd"], function(
      input,
      week,
      config,
      token
    ) {
      var weekday = config._locale.weekdaysParse(input, token, config._strict);
      // if we didn't get a weekday name, mark the date as invalid
      if (weekday != null) {
        week.d = weekday;
      } else {
        getParsingFlags(config).invalidWeekday = input;
      }
    });

    addWeekParseToken(["d", "e", "E"], function(input, week, config, token) {
      week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
      if (typeof input !== "string") {
        return input;
      }

      if (!isNaN(input)) {
        return parseInt(input, 10);
      }

      input = locale.weekdaysParse(input);
      if (typeof input === "number") {
        return input;
      }

      return null;
    }

    function parseIsoWeekday(input, locale) {
      if (typeof input === "string") {
        return locale.weekdaysParse(input) % 7 || 7;
      }
      return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_"
    );
    function localeWeekdays(m, format) {
      if (!m) {
        return isArray(this._weekdays)
          ? this._weekdays
          : this._weekdays["standalone"];
      }
      return isArray(this._weekdays)
        ? this._weekdays[m.day()]
        : this._weekdays[
            this._weekdays.isFormat.test(format) ? "format" : "standalone"
          ][m.day()];
    }

    var defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_");
    function localeWeekdaysShort(m) {
      return m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_");
    function localeWeekdaysMin(m) {
      return m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
      var i,
        ii,
        mom,
        llc = weekdayName.toLocaleLowerCase();
      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
          mom = createUTC([2000, 1]).day(i);
          this._minWeekdaysParse[i] = this.weekdaysMin(
            mom,
            ""
          ).toLocaleLowerCase();
          this._shortWeekdaysParse[i] = this.weekdaysShort(
            mom,
            ""
          ).toLocaleLowerCase();
          this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
        }
      }

      if (strict) {
        if (format === "dddd") {
          ii = indexOf.call(this._weekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === "ddd") {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      } else {
        if (format === "dddd") {
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else if (format === "ddd") {
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._minWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        } else {
          ii = indexOf.call(this._minWeekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._weekdaysParse, llc);
          if (ii !== -1) {
            return ii;
          }
          ii = indexOf.call(this._shortWeekdaysParse, llc);
          return ii !== -1 ? ii : null;
        }
      }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
      var i, mom, regex;

      if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
      }

      if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
      }

      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
          this._fullWeekdaysParse[i] = new RegExp(
            "^" + this.weekdays(mom, "").replace(".", ".?") + "$",
            "i"
          );
          this._shortWeekdaysParse[i] = new RegExp(
            "^" + this.weekdaysShort(mom, "").replace(".", ".?") + "$",
            "i"
          );
          this._minWeekdaysParse[i] = new RegExp(
            "^" + this.weekdaysMin(mom, "").replace(".", ".?") + "$",
            "i"
          );
        }
        if (!this._weekdaysParse[i]) {
          regex =
            "^" +
            this.weekdays(mom, "") +
            "|^" +
            this.weekdaysShort(mom, "") +
            "|^" +
            this.weekdaysMin(mom, "");
          this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
        }
        // test the regex
        if (
          strict &&
          format === "dddd" &&
          this._fullWeekdaysParse[i].test(weekdayName)
        ) {
          return i;
        } else if (
          strict &&
          format === "ddd" &&
          this._shortWeekdaysParse[i].test(weekdayName)
        ) {
          return i;
        } else if (
          strict &&
          format === "dd" &&
          this._minWeekdaysParse[i].test(weekdayName)
        ) {
          return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
          return i;
        }
      }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
      if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, "d");
      } else {
        return day;
      }
    }

    function getSetLocaleDayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
      return input == null ? weekday : this.add(input - weekday, "d");
    }

    function getSetISODayOfWeek(input) {
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }

      // behaves the same as moment#day except
      // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
      // as a setter, sunday should belong to the previous week.

      if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
      } else {
        return this.day() || 7;
      }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysStrictRegex;
        } else {
          return this._weekdaysRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict
          ? this._weekdaysStrictRegex
          : this._weekdaysRegex;
      }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysShortStrictRegex;
        } else {
          return this._weekdaysShortRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysShortRegex")) {
          this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict
          ? this._weekdaysShortStrictRegex
          : this._weekdaysShortRegex;
      }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex(isStrict) {
      if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, "_weekdaysRegex")) {
          computeWeekdaysParse.call(this);
        }
        if (isStrict) {
          return this._weekdaysMinStrictRegex;
        } else {
          return this._weekdaysMinRegex;
        }
      } else {
        if (!hasOwnProp(this, "_weekdaysMinRegex")) {
          this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict
          ? this._weekdaysMinStrictRegex
          : this._weekdaysMinRegex;
      }
    }

    function computeWeekdaysParse() {
      function cmpLenRev(a, b) {
        return b.length - a.length;
      }

      var minPieces = [],
        shortPieces = [],
        longPieces = [],
        mixedPieces = [],
        i,
        mom,
        minp,
        shortp,
        longp;
      for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, "");
        shortp = this.weekdaysShort(mom, "");
        longp = this.weekdays(mom, "");
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
      }
      // Sorting makes sure if one weekday (or abbr) is a prefix of another it
      // will match the longer piece.
      minPieces.sort(cmpLenRev);
      shortPieces.sort(cmpLenRev);
      longPieces.sort(cmpLenRev);
      mixedPieces.sort(cmpLenRev);
      for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
      }

      this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
      this._weekdaysShortRegex = this._weekdaysRegex;
      this._weekdaysMinRegex = this._weekdaysRegex;

      this._weekdaysStrictRegex = new RegExp(
        "^(" + longPieces.join("|") + ")",
        "i"
      );
      this._weekdaysShortStrictRegex = new RegExp(
        "^(" + shortPieces.join("|") + ")",
        "i"
      );
      this._weekdaysMinStrictRegex = new RegExp(
        "^(" + minPieces.join("|") + ")",
        "i"
      );
    }

    // FORMATTING

    function hFormat() {
      return this.hours() % 12 || 12;
    }

    function kFormat() {
      return this.hours() || 24;
    }

    addFormatToken("H", ["HH", 2], 0, "hour");
    addFormatToken("h", ["hh", 2], 0, hFormat);
    addFormatToken("k", ["kk", 2], 0, kFormat);

    addFormatToken("hmm", 0, 0, function() {
      return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken("hmmss", 0, 0, function() {
      return (
        "" +
        hFormat.apply(this) +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
      );
    });

    addFormatToken("Hmm", 0, 0, function() {
      return "" + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken("Hmmss", 0, 0, function() {
      return (
        "" +
        this.hours() +
        zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2)
      );
    });

    function meridiem(token, lowercase) {
      addFormatToken(token, 0, 0, function() {
        return this.localeData().meridiem(
          this.hours(),
          this.minutes(),
          lowercase
        );
      });
    }

    meridiem("a", true);
    meridiem("A", false);

    // ALIASES

    addUnitAlias("hour", "h");

    // PRIORITY
    addUnitPriority("hour", 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
      return locale._meridiemParse;
    }

    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);

    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);

    addParseToken(["H", "HH"], HOUR);
    addParseToken(["k", "kk"], function(input, array, config) {
      var kInput = toInt(input);
      array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(["a", "A"], function(input, array, config) {
      config._isPm = config._locale.isPM(input);
      config._meridiem = input;
    });
    addParseToken(["h", "hh"], function(input, array, config) {
      array[HOUR] = toInt(input);
      getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
      var pos1 = input.length - 4;
      var pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
      getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
      var pos = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos));
      array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
      var pos1 = input.length - 4;
      var pos2 = input.length - 2;
      array[HOUR] = toInt(input.substr(0, pos1));
      array[MINUTE] = toInt(input.substr(pos1, 2));
      array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
      // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
      // Using charAt should be more compatible.
      return (input + "").toLowerCase().charAt(0) === "p";
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? "pm" : "PM";
      } else {
        return isLower ? "am" : "AM";
      }
    }

    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet("Hours", true);

    var baseConfig = {
      calendar: defaultCalendar,
      longDateFormat: defaultLongDateFormat,
      invalidDate: defaultInvalidDate,
      ordinal: defaultOrdinal,
      dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
      relativeTime: defaultRelativeTime,

      months: defaultLocaleMonths,
      monthsShort: defaultLocaleMonthsShort,

      week: defaultLocaleWeek,

      weekdays: defaultLocaleWeekdays,
      weekdaysMin: defaultLocaleWeekdaysMin,
      weekdaysShort: defaultLocaleWeekdaysShort,

      meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
      return key ? key.toLowerCase().replace("_", "-") : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
      var i = 0,
        j,
        next,
        locale,
        split;

      while (i < names.length) {
        split = normalizeLocale(names[i]).split("-");
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split("-") : null;
        while (j > 0) {
          locale = loadLocale(split.slice(0, j).join("-"));
          if (locale) {
            return locale;
          }
          if (
            next &&
            next.length >= j &&
            compareArrays(split, next, true) >= j - 1
          ) {
            //the next array item is better than a shallower substring of this one
            break;
          }
          j--;
        }
        i++;
      }
      return globalLocale;
    }

    function loadLocale(name) {
      var oldLocale = null;
      // TODO: Find a better way to register and load all the locales in Node
      if (
        !locales[name] &&
        "object" !== "undefined" &&
        module &&
        module.exports
      ) {
        try {
          oldLocale = globalLocale._abbr;
          var aliasedRequire = commonjsRequire;
          aliasedRequire("./locale/" + name);
          getSetGlobalLocale(oldLocale);
        } catch (e) {}
      }
      return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
      var data;
      if (key) {
        if (isUndefined(values)) {
          data = getLocale(key);
        } else {
          data = defineLocale(key, values);
        }

        if (data) {
          // moment.duration._locale = moment._locale = data;
          globalLocale = data;
        } else {
          if (typeof console !== "undefined" && console.warn) {
            //warn user if arguments are passed but the locale could not be set
            console.warn(
              "Locale " + key + " not found. Did you forget to load it?"
            );
          }
        }
      }

      return globalLocale._abbr;
    }

    function defineLocale(name, config) {
      if (config !== null) {
        var locale,
          parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
          deprecateSimple(
            "defineLocaleOverride",
            "use moment.updateLocale(localeName, config) to change " +
              "an existing locale. moment.defineLocale(localeName, " +
              "config) should only be used for creating a new locale " +
              "See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
          );
          parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
          if (locales[config.parentLocale] != null) {
            parentConfig = locales[config.parentLocale]._config;
          } else {
            locale = loadLocale(config.parentLocale);
            if (locale != null) {
              parentConfig = locale._config;
            } else {
              if (!localeFamilies[config.parentLocale]) {
                localeFamilies[config.parentLocale] = [];
              }
              localeFamilies[config.parentLocale].push({
                name: name,
                config: config
              });
              return null;
            }
          }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
          localeFamilies[name].forEach(function(x) {
            defineLocale(x.name, x.config);
          });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);

        return locales[name];
      } else {
        // useful for testing
        delete locales[name];
        return null;
      }
    }

    function updateLocale(name, config) {
      if (config != null) {
        var locale,
          tmpLocale,
          parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
          parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
      } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
          if (locales[name].parentLocale != null) {
            locales[name] = locales[name].parentLocale;
          } else if (locales[name] != null) {
            delete locales[name];
          }
        }
      }
      return locales[name];
    }

    // returns locale data
    function getLocale(key) {
      var locale;

      if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
      }

      if (!key) {
        return globalLocale;
      }

      if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
          return locale;
        }
        key = [key];
      }

      return chooseLocale(key);
    }

    function listLocales() {
      return keys(locales);
    }

    function checkOverflow(m) {
      var overflow;
      var a = m._a;

      if (a && getParsingFlags(m).overflow === -2) {
        overflow =
          a[MONTH] < 0 || a[MONTH] > 11
            ? MONTH
            : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
            ? DATE
            : a[HOUR] < 0 ||
              a[HOUR] > 24 ||
              (a[HOUR] === 24 &&
                (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0))
            ? HOUR
            : a[MINUTE] < 0 || a[MINUTE] > 59
            ? MINUTE
            : a[SECOND] < 0 || a[SECOND] > 59
            ? SECOND
            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
            ? MILLISECOND
            : -1;

        if (
          getParsingFlags(m)._overflowDayOfYear &&
          (overflow < YEAR || overflow > DATE)
        ) {
          overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
          overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
          overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
      }

      return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
      if (a != null) {
        return a;
      }
      if (b != null) {
        return b;
      }
      return c;
    }

    function currentDateArray(config) {
      // hooks is actually the exported moment object
      var nowValue = new Date(hooks.now());
      if (config._useUTC) {
        return [
          nowValue.getUTCFullYear(),
          nowValue.getUTCMonth(),
          nowValue.getUTCDate()
        ];
      }
      return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
      var i,
        date,
        input = [],
        currentDate,
        expectedWeekday,
        yearToUse;

      if (config._d) {
        return;
      }

      currentDate = currentDateArray(config);

      //compute day of the year from weeks and weekdays
      if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
      }

      //if the day of the year is set, figure out what it is
      if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (
          config._dayOfYear > daysInYear(yearToUse) ||
          config._dayOfYear === 0
        ) {
          getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
      }

      // Default to current date.
      // * if no year, month, day of month are given, default to today
      // * if day of month is given, default month and year
      // * if month is given, default only year
      // * if year is given, don't default anything
      for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
      }

      // Zero out whatever was not defaulted, including time
      for (; i < 7; i++) {
        config._a[i] = input[i] =
          config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
      }

      // Check for 24:00:00.000
      if (
        config._a[HOUR] === 24 &&
        config._a[MINUTE] === 0 &&
        config._a[SECOND] === 0 &&
        config._a[MILLISECOND] === 0
      ) {
        config._nextDay = true;
        config._a[HOUR] = 0;
      }

      config._d = (config._useUTC ? createUTCDate : createDate).apply(
        null,
        input
      );
      expectedWeekday = config._useUTC
        ? config._d.getUTCDay()
        : config._d.getDay();

      // Apply timezone offset from input. The actual utcOffset can be changed
      // with parseZone.
      if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      }

      if (config._nextDay) {
        config._a[HOUR] = 24;
      }

      // check for mismatching day of week
      if (
        config._w &&
        typeof config._w.d !== "undefined" &&
        config._w.d !== expectedWeekday
      ) {
        getParsingFlags(config).weekdayMismatch = true;
      }
    }

    function dayOfYearFromWeekInfo(config) {
      var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

      w = config._w;
      if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(
          w.GG,
          config._a[YEAR],
          weekOfYear(createLocal(), 1, 4).year
        );
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
          weekdayOverflow = true;
        }
      } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
          // weekday -- low day numbers are considered next week
          weekday = w.d;
          if (weekday < 0 || weekday > 6) {
            weekdayOverflow = true;
          }
        } else if (w.e != null) {
          // local weekday -- counting starts from begining of week
          weekday = w.e + dow;
          if (w.e < 0 || w.e > 6) {
            weekdayOverflow = true;
          }
        } else {
          // default to begining of week
          weekday = dow;
        }
      }
      if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
      } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
      } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
      }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
      ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
      ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
      ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
      ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
      ["YYYY-DDD", /\d{4}-\d{3}/],
      ["YYYY-MM", /\d{4}-\d\d/, false],
      ["YYYYYYMMDD", /[+-]\d{10}/],
      ["YYYYMMDD", /\d{8}/],
      // YYYYMM is NOT allowed by the standard
      ["GGGG[W]WWE", /\d{4}W\d{3}/],
      ["GGGG[W]WW", /\d{4}W\d{2}/, false],
      ["YYYYDDD", /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
      ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
      ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
      ["HH:mm:ss", /\d\d:\d\d:\d\d/],
      ["HH:mm", /\d\d:\d\d/],
      ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
      ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
      ["HHmmss", /\d\d\d\d\d\d/],
      ["HHmm", /\d\d\d\d/],
      ["HH", /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
      var i,
        l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime,
        dateFormat,
        timeFormat,
        tzFormat;

      if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
          if (isoDates[i][1].exec(match[1])) {
            dateFormat = isoDates[i][0];
            allowTime = isoDates[i][2] !== false;
            break;
          }
        }
        if (dateFormat == null) {
          config._isValid = false;
          return;
        }
        if (match[3]) {
          for (i = 0, l = isoTimes.length; i < l; i++) {
            if (isoTimes[i][1].exec(match[3])) {
              // match[2] should be 'T' or space
              timeFormat = (match[2] || " ") + isoTimes[i][0];
              break;
            }
          }
          if (timeFormat == null) {
            config._isValid = false;
            return;
          }
        }
        if (!allowTime && timeFormat != null) {
          config._isValid = false;
          return;
        }
        if (match[4]) {
          if (tzRegex.exec(match[4])) {
            tzFormat = "Z";
          } else {
            config._isValid = false;
            return;
          }
        }
        config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
        configFromStringAndFormat(config);
      } else {
        config._isValid = false;
      }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(
      yearStr,
      monthStr,
      dayStr,
      hourStr,
      minuteStr,
      secondStr
    ) {
      var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
      ];

      if (secondStr) {
        result.push(parseInt(secondStr, 10));
      }

      return result;
    }

    function untruncateYear(yearStr) {
      var year = parseInt(yearStr, 10);
      if (year <= 49) {
        return 2000 + year;
      } else if (year <= 999) {
        return 1900 + year;
      }
      return year;
    }

    function preprocessRFC2822(s) {
      // Remove comments and folding whitespace and replace multiple-spaces with a single space
      return s
        .replace(/\([^)]*\)|[\n\t]/g, " ")
        .replace(/(\s\s+)/g, " ")
        .trim();
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
      if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
          weekdayActual = new Date(
            parsedInput[0],
            parsedInput[1],
            parsedInput[2]
          ).getDay();
        if (weekdayProvided !== weekdayActual) {
          getParsingFlags(config).weekdayMismatch = true;
          config._isValid = false;
          return false;
        }
      }
      return true;
    }

    var obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
      if (obsOffset) {
        return obsOffsets[obsOffset];
      } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
      } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100,
          h = (hm - m) / 100;
        return h * 60 + m;
      }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
      var match = rfc2822.exec(preprocessRFC2822(config._i));
      if (match) {
        var parsedArray = extractFromRFC2822Strings(
          match[4],
          match[3],
          match[2],
          match[5],
          match[6],
          match[7]
        );
        if (!checkWeekday(match[1], parsedArray, config)) {
          return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
      } else {
        config._isValid = false;
      }
    }

    // date from iso format or fallback
    function configFromString(config) {
      var matched = aspNetJsonRegex.exec(config._i);

      if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
      }

      configFromISO(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }

      configFromRFC2822(config);
      if (config._isValid === false) {
        delete config._isValid;
      } else {
        return;
      }

      // Final attempt, use Input Fallback
      hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
      "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), " +
        "which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are " +
        "discouraged and will be removed in an upcoming major release. Please refer to " +
        "http://momentjs.com/guides/#/warnings/js-date/ for more info.",
      function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
      }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};

    // date from string and format string
    function configFromStringAndFormat(config) {
      // TODO: Move this to another part of the creation flow to prevent circular deps
      if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
      }
      if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
      }
      config._a = [];
      getParsingFlags(config).empty = true;

      // This array is used to make a Date, either with `new Date` or `Date.UTC`
      var string = "" + config._i,
        i,
        parsedInput,
        tokens,
        token,
        skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

      tokens =
        expandFormat(config._f, config._locale).match(formattingTokens) || [];

      for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) ||
          [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
          skipped = string.substr(0, string.indexOf(parsedInput));
          if (skipped.length > 0) {
            getParsingFlags(config).unusedInput.push(skipped);
          }
          string = string.slice(
            string.indexOf(parsedInput) + parsedInput.length
          );
          totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
          if (parsedInput) {
            getParsingFlags(config).empty = false;
          } else {
            getParsingFlags(config).unusedTokens.push(token);
          }
          addTimeToArrayFromToken(token, parsedInput, config);
        } else if (config._strict && !parsedInput) {
          getParsingFlags(config).unusedTokens.push(token);
        }
      }

      // add remaining unparsed input length to the string
      getParsingFlags(config).charsLeftOver =
        stringLength - totalParsedInputLength;
      if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
      }

      // clear _12h flag if hour is <= 12
      if (
        config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0
      ) {
        getParsingFlags(config).bigHour = undefined;
      }

      getParsingFlags(config).parsedDateParts = config._a.slice(0);
      getParsingFlags(config).meridiem = config._meridiem;
      // handle meridiem
      config._a[HOUR] = meridiemFixWrap(
        config._locale,
        config._a[HOUR],
        config._meridiem
      );

      configFromArray(config);
      checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
      var isPm;

      if (meridiem == null) {
        // nothing to do
        return hour;
      }
      if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
      } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
          hour += 12;
        }
        if (!isPm && hour === 12) {
          hour = 0;
        }
        return hour;
      } else {
        // this is not supposed to happen
        return hour;
      }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
      var tempConfig, bestMoment, scoreToBeat, i, currentScore;

      if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
      }

      for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
          tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
          continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
        }
      }

      extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
      if (config._d) {
        return;
      }

      var i = normalizeObjectUnits(config._i);
      config._a = map(
        [
          i.year,
          i.month,
          i.day || i.date,
          i.hour,
          i.minute,
          i.second,
          i.millisecond
        ],
        function(obj) {
          return obj && parseInt(obj, 10);
        }
      );

      configFromArray(config);
    }

    function createFromConfig(config) {
      var res = new Moment(checkOverflow(prepareConfig(config)));
      if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, "d");
        res._nextDay = undefined;
      }

      return res;
    }

    function prepareConfig(config) {
      var input = config._i,
        format = config._f;

      config._locale = config._locale || getLocale(config._l);

      if (input === null || (format === undefined && input === "")) {
        return createInvalid({ nullInput: true });
      }

      if (typeof input === "string") {
        config._i = input = config._locale.preparse(input);
      }

      if (isMoment(input)) {
        return new Moment(checkOverflow(input));
      } else if (isDate(input)) {
        config._d = input;
      } else if (isArray(format)) {
        configFromStringAndArray(config);
      } else if (format) {
        configFromStringAndFormat(config);
      } else {
        configFromInput(config);
      }

      if (!isValid(config)) {
        config._d = null;
      }

      return config;
    }

    function configFromInput(config) {
      var input = config._i;
      if (isUndefined(input)) {
        config._d = new Date(hooks.now());
      } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
      } else if (typeof input === "string") {
        configFromString(config);
      } else if (isArray(input)) {
        config._a = map(input.slice(0), function(obj) {
          return parseInt(obj, 10);
        });
        configFromArray(config);
      } else if (isObject(input)) {
        configFromObject(config);
      } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
      } else {
        hooks.createFromInputFallback(config);
      }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
      var c = {};

      if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
      }

      if (
        (isObject(input) && isObjectEmpty(input)) ||
        (isArray(input) && input.length === 0)
      ) {
        input = undefined;
      }
      // object construction must be done this way.
      // https://github.com/moment/moment/issues/1423
      c._isAMomentObject = true;
      c._useUTC = c._isUTC = isUTC;
      c._l = locale;
      c._i = input;
      c._f = format;
      c._strict = strict;

      return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
      return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
      "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other < this ? this : other;
        } else {
          return createInvalid();
        }
      }
    );

    var prototypeMax = deprecate(
      "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
      function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
          return other > this ? this : other;
        } else {
          return createInvalid();
        }
      }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
      var res, i;
      if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
      }
      if (!moments.length) {
        return createLocal();
      }
      res = moments[0];
      for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
          res = moments[i];
        }
      }
      return res;
    }

    // TODO: Use [].sort instead?
    function min() {
      var args = [].slice.call(arguments, 0);

      return pickBy("isBefore", args);
    }

    function max() {
      var args = [].slice.call(arguments, 0);

      return pickBy("isAfter", args);
    }

    var now = function() {
      return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
      "year",
      "quarter",
      "month",
      "week",
      "day",
      "hour",
      "minute",
      "second",
      "millisecond"
    ];

    function isDurationValid(m) {
      for (var key in m) {
        if (
          !(
            indexOf.call(ordering, key) !== -1 &&
            (m[key] == null || !isNaN(m[key]))
          )
        ) {
          return false;
        }
      }

      var unitHasDecimal = false;
      for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
          if (unitHasDecimal) {
            return false; // only allow non-integers for smallest unit
          }
          if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
            unitHasDecimal = true;
          }
        }
      }

      return true;
    }

    function isValid$1() {
      return this._isValid;
    }

    function createInvalid$1() {
      return createDuration(NaN);
    }

    function Duration(duration) {
      var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

      this._isValid = isDurationValid(normalizedInput);

      // representation for dateAddRemove
      this._milliseconds =
        +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
      // Because of dateAddRemove treats 24 hours as different from a
      // day when working around DST, we need to store them separately
      this._days = +days + weeks * 7;
      // It is impossible to translate months into days without knowing
      // which months you are are talking about, so we have to store
      // it separately.
      this._months = +months + quarters * 3 + years * 12;

      this._data = {};

      this._locale = getLocale();

      this._bubble();
    }

    function isDuration(obj) {
      return obj instanceof Duration;
    }

    function absRound(number) {
      if (number < 0) {
        return Math.round(-1 * number) * -1;
      } else {
        return Math.round(number);
      }
    }

    // FORMATTING

    function offset(token, separator) {
      addFormatToken(token, 0, 0, function() {
        var offset = this.utcOffset();
        var sign = "+";
        if (offset < 0) {
          offset = -offset;
          sign = "-";
        }
        return (
          sign +
          zeroFill(~~(offset / 60), 2) +
          separator +
          zeroFill(~~offset % 60, 2)
        );
      });
    }

    offset("Z", ":");
    offset("ZZ", "");

    // PARSING

    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken(["Z", "ZZ"], function(input, array, config) {
      config._useUTC = true;
      config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
      var matches = (string || "").match(matcher);

      if (matches === null) {
        return null;
      }

      var chunk = matches[matches.length - 1] || [];
      var parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
      var minutes = +(parts[1] * 60) + toInt(parts[2]);

      return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
      var res, diff;
      if (model._isUTC) {
        res = model.clone();
        diff =
          (isMoment(input) || isDate(input)
            ? input.valueOf()
            : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
      } else {
        return createLocal(input).local();
      }
    }

    function getDateOffset(m) {
      // On Firefox.24 Date#getTimezoneOffset returns a floating point.
      // https://github.com/moment/moment/pull/1871
      return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
      var offset = this._offset || 0,
        localAdjust;
      if (!this.isValid()) {
        return input != null ? this : NaN;
      }
      if (input != null) {
        if (typeof input === "string") {
          input = offsetFromString(matchShortOffset, input);
          if (input === null) {
            return this;
          }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
          input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
          localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
          this.add(localAdjust, "m");
        }
        if (offset !== input) {
          if (!keepLocalTime || this._changeInProgress) {
            addSubtract(this, createDuration(input - offset, "m"), 1, false);
          } else if (!this._changeInProgress) {
            this._changeInProgress = true;
            hooks.updateOffset(this, true);
            this._changeInProgress = null;
          }
        }
        return this;
      } else {
        return this._isUTC ? offset : getDateOffset(this);
      }
    }

    function getSetZone(input, keepLocalTime) {
      if (input != null) {
        if (typeof input !== "string") {
          input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
      } else {
        return -this.utcOffset();
      }
    }

    function setOffsetToUTC(keepLocalTime) {
      return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
      if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
          this.subtract(getDateOffset(this), "m");
        }
      }
      return this;
    }

    function setOffsetToParsedOffset() {
      if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
      } else if (typeof this._i === "string") {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
          this.utcOffset(tZone);
        } else {
          this.utcOffset(0, true);
        }
      }
      return this;
    }

    function hasAlignedHourOffset(input) {
      if (!this.isValid()) {
        return false;
      }
      input = input ? createLocal(input).utcOffset() : 0;

      return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
      return (
        this.utcOffset() >
          this.clone()
            .month(0)
            .utcOffset() ||
        this.utcOffset() >
          this.clone()
            .month(5)
            .utcOffset()
      );
    }

    function isDaylightSavingTimeShifted() {
      if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
      }

      var c = {};

      copyConfig(c, this);
      c = prepareConfig(c);

      if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted =
          this.isValid() && compareArrays(c._a, other.toArray()) > 0;
      } else {
        this._isDSTShifted = false;
      }

      return this._isDSTShifted;
    }

    function isLocal() {
      return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
      return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
      return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
      var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

      if (isDuration(input)) {
        duration = {
          ms: input._milliseconds,
          d: input._days,
          M: input._months
        };
      } else if (isNumber(input)) {
        duration = {};
        if (key) {
          duration[key] = input;
        } else {
          duration.milliseconds = input;
        }
      } else if (!!(match = aspNetRegex.exec(input))) {
        sign = match[1] === "-" ? -1 : 1;
        duration = {
          y: 0,
          d: toInt(match[DATE]) * sign,
          h: toInt(match[HOUR]) * sign,
          m: toInt(match[MINUTE]) * sign,
          s: toInt(match[SECOND]) * sign,
          ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
      } else if (!!(match = isoRegex.exec(input))) {
        sign = match[1] === "-" ? -1 : match[1] === "+" ? 1 : 1;
        duration = {
          y: parseIso(match[2], sign),
          M: parseIso(match[3], sign),
          w: parseIso(match[4], sign),
          d: parseIso(match[5], sign),
          h: parseIso(match[6], sign),
          m: parseIso(match[7], sign),
          s: parseIso(match[8], sign)
        };
      } else if (duration == null) {
        // checks for null or undefined
        duration = {};
      } else if (
        typeof duration === "object" &&
        ("from" in duration || "to" in duration)
      ) {
        diffRes = momentsDifference(
          createLocal(duration.from),
          createLocal(duration.to)
        );

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
      }

      ret = new Duration(duration);

      if (isDuration(input) && hasOwnProp(input, "_locale")) {
        ret._locale = input._locale;
      }

      return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
      // We'd normally use ~~inp for this, but unfortunately it also
      // converts floats to ints.
      // inp may be undefined, so careful calling replace on it.
      var res = inp && parseFloat(inp.replace(",", "."));
      // apply sign while we're at it
      return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
      var res = { milliseconds: 0, months: 0 };

      res.months =
        other.month() - base.month() + (other.year() - base.year()) * 12;
      if (
        base
          .clone()
          .add(res.months, "M")
          .isAfter(other)
      ) {
        --res.months;
      }

      res.milliseconds = +other - +base.clone().add(res.months, "M");

      return res;
    }

    function momentsDifference(base, other) {
      var res;
      if (!(base.isValid() && other.isValid())) {
        return { milliseconds: 0, months: 0 };
      }

      other = cloneWithOffset(other, base);
      if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
      } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
      }

      return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
      return function(val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
          deprecateSimple(
            name,
            "moment()." +
              name +
              "(period, number) is deprecated. Please use moment()." +
              name +
              "(number, period). " +
              "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
          );
          tmp = val;
          val = period;
          period = tmp;
        }

        val = typeof val === "string" ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
      };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
      var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

      if (!mom.isValid()) {
        // No op
        return;
      }

      updateOffset = updateOffset == null ? true : updateOffset;

      if (months) {
        setMonth(mom, get(mom, "Month") + months * isAdding);
      }
      if (days) {
        set$1(mom, "Date", get(mom, "Date") + days * isAdding);
      }
      if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
      }
      if (updateOffset) {
        hooks.updateOffset(mom, days || months);
      }
    }

    var add = createAdder(1, "add");
    var subtract = createAdder(-1, "subtract");

    function getCalendarFormat(myMoment, now) {
      var diff = myMoment.diff(now, "days", true);
      return diff < -6
        ? "sameElse"
        : diff < -1
        ? "lastWeek"
        : diff < 0
        ? "lastDay"
        : diff < 1
        ? "sameDay"
        : diff < 2
        ? "nextDay"
        : diff < 7
        ? "nextWeek"
        : "sameElse";
    }

    function calendar$1(time, formats) {
      // We want to compare the start of today, vs this.
      // Getting start-of-today depends on whether we're local/utc/offset or not.
      var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf("day"),
        format = hooks.calendarFormat(this, sod) || "sameElse";

      var output =
        formats &&
        (isFunction(formats[format])
          ? formats[format].call(this, now)
          : formats[format]);

      return this.format(
        output || this.localeData().calendar(format, this, createLocal(now))
      );
    }

    function clone() {
      return new Moment(this);
    }

    function isAfter(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(!isUndefined(units) ? units : "millisecond");
      if (units === "millisecond") {
        return this.valueOf() > localInput.valueOf();
      } else {
        return (
          localInput.valueOf() <
          this.clone()
            .startOf(units)
            .valueOf()
        );
      }
    }

    function isBefore(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input);
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(!isUndefined(units) ? units : "millisecond");
      if (units === "millisecond") {
        return this.valueOf() < localInput.valueOf();
      } else {
        return (
          this.clone()
            .endOf(units)
            .valueOf() < localInput.valueOf()
        );
      }
    }

    function isBetween(from, to, units, inclusivity) {
      inclusivity = inclusivity || "()";
      return (
        (inclusivity[0] === "("
          ? this.isAfter(from, units)
          : !this.isBefore(from, units)) &&
        (inclusivity[1] === ")"
          ? this.isBefore(to, units)
          : !this.isAfter(to, units))
      );
    }

    function isSame(input, units) {
      var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
      if (!(this.isValid() && localInput.isValid())) {
        return false;
      }
      units = normalizeUnits(units || "millisecond");
      if (units === "millisecond") {
        return this.valueOf() === localInput.valueOf();
      } else {
        inputMs = localInput.valueOf();
        return (
          this.clone()
            .startOf(units)
            .valueOf() <= inputMs &&
          inputMs <=
            this.clone()
              .endOf(units)
              .valueOf()
        );
      }
    }

    function isSameOrAfter(input, units) {
      return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
      return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
      var that, zoneDelta, output;

      if (!this.isValid()) {
        return NaN;
      }

      that = cloneWithOffset(input, this);

      if (!that.isValid()) {
        return NaN;
      }

      zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

      units = normalizeUnits(units);

      switch (units) {
        case "year":
          output = monthDiff(this, that) / 12;
          break;
        case "month":
          output = monthDiff(this, that);
          break;
        case "quarter":
          output = monthDiff(this, that) / 3;
          break;
        case "second":
          output = (this - that) / 1e3;
          break; // 1000
        case "minute":
          output = (this - that) / 6e4;
          break; // 1000 * 60
        case "hour":
          output = (this - that) / 36e5;
          break; // 1000 * 60 * 60
        case "day":
          output = (this - that - zoneDelta) / 864e5;
          break; // 1000 * 60 * 60 * 24, negate dst
        case "week":
          output = (this - that - zoneDelta) / 6048e5;
          break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default:
          output = this - that;
      }

      return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
      // difference in months
      var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"),
        anchor2,
        adjust;

      if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
      } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
      }

      //check for negative zero, return zero if negative zero
      return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";

    function toString() {
      return this.clone()
        .locale("en")
        .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }

    function toISOString(keepOffset) {
      if (!this.isValid()) {
        return null;
      }
      var utc = keepOffset !== true;
      var m = utc ? this.clone().utc() : this;
      if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(
          m,
          utc
            ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
            : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
        );
      }
      if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
          return this.toDate().toISOString();
        } else {
          return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
            .toISOString()
            .replace("Z", formatMoment(m, "Z"));
        }
      }
      return formatMoment(
        m,
        utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
      );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
      if (!this.isValid()) {
        return "moment.invalid(/* " + this._i + " */)";
      }
      var func = "moment";
      var zone = "";
      if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
        zone = "Z";
      }
      var prefix = "[" + func + '("]';
      var year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
      var datetime = "-MM-DD[T]HH:mm:ss.SSS";
      var suffix = zone + '[")]';

      return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
      if (!inputString) {
        inputString = this.isUtc()
          ? hooks.defaultFormatUtc
          : hooks.defaultFormat;
      }
      var output = formatMoment(this, inputString);
      return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
      if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
      ) {
        return createDuration({ to: this, from: time })
          .locale(this.locale())
          .humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function fromNow(withoutSuffix) {
      return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
      if (
        this.isValid() &&
        ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
      ) {
        return createDuration({ from: this, to: time })
          .locale(this.locale())
          .humanize(!withoutSuffix);
      } else {
        return this.localeData().invalidDate();
      }
    }

    function toNow(withoutSuffix) {
      return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
      var newLocaleData;

      if (key === undefined) {
        return this._locale._abbr;
      } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
          this._locale = newLocaleData;
        }
        return this;
      }
    }

    var lang = deprecate(
      "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
      function(key) {
        if (key === undefined) {
          return this.localeData();
        } else {
          return this.locale(key);
        }
      }
    );

    function localeData() {
      return this._locale;
    }

    function startOf(units) {
      units = normalizeUnits(units);
      // the following switch intentionally omits break keywords
      // to utilize falling through the cases.
      switch (units) {
        case "year":
          this.month(0);
        /* falls through */
        case "quarter":
        case "month":
          this.date(1);
        /* falls through */
        case "week":
        case "isoWeek":
        case "day":
        case "date":
          this.hours(0);
        /* falls through */
        case "hour":
          this.minutes(0);
        /* falls through */
        case "minute":
          this.seconds(0);
        /* falls through */
        case "second":
          this.milliseconds(0);
      }

      // weeks are a special case
      if (units === "week") {
        this.weekday(0);
      }
      if (units === "isoWeek") {
        this.isoWeekday(1);
      }

      // quarters are also special
      if (units === "quarter") {
        this.month(Math.floor(this.month() / 3) * 3);
      }

      return this;
    }

    function endOf(units) {
      units = normalizeUnits(units);
      if (units === undefined || units === "millisecond") {
        return this;
      }

      // 'date' is an alias for 'day', so it should be considered as such.
      if (units === "date") {
        units = "day";
      }

      return this.startOf(units)
        .add(1, units === "isoWeek" ? "week" : units)
        .subtract(1, "ms");
    }

    function valueOf() {
      return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
      return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
      return new Date(this.valueOf());
    }

    function toArray() {
      var m = this;
      return [
        m.year(),
        m.month(),
        m.date(),
        m.hour(),
        m.minute(),
        m.second(),
        m.millisecond()
      ];
    }

    function toObject() {
      var m = this;
      return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
      };
    }

    function toJSON() {
      // new Date(NaN).toJSON() === null
      return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
      return isValid(this);
    }

    function parsingFlags() {
      return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
      return getParsingFlags(this).overflow;
    }

    function creationData() {
      return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
      };
    }

    // FORMATTING

    addFormatToken(0, ["gg", 2], 0, function() {
      return this.weekYear() % 100;
    });

    addFormatToken(0, ["GG", 2], 0, function() {
      return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
      addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");

    // ALIASES

    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");

    // PRIORITY

    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);

    // PARSING

    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);

    addWeekParseToken(["gggg", "ggggg", "GGGG", "GGGGG"], function(
      input,
      week,
      config,
      token
    ) {
      week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(["gg", "GG"], function(input, week, config, token) {
      week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.week(),
        this.weekday(),
        this.localeData()._week.dow,
        this.localeData()._week.doy
      );
    }

    function getSetISOWeekYear(input) {
      return getSetWeekYearHelper.call(
        this,
        input,
        this.isoWeek(),
        this.isoWeekday(),
        1,
        4
      );
    }

    function getISOWeeksInYear() {
      return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear() {
      var weekInfo = this.localeData()._week;
      return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
      var weeksTarget;
      if (input == null) {
        return weekOfYear(this, dow, doy).year;
      } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
          week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
      }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
      var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

      this.year(date.getUTCFullYear());
      this.month(date.getUTCMonth());
      this.date(date.getUTCDate());
      return this;
    }

    // FORMATTING

    addFormatToken("Q", 0, "Qo", "quarter");

    // ALIASES

    addUnitAlias("quarter", "Q");

    // PRIORITY

    addUnitPriority("quarter", 7);

    // PARSING

    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
      array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
      return input == null
        ? Math.ceil((this.month() + 1) / 3)
        : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken("D", ["DD", 2], "Do", "date");

    // ALIASES

    addUnitAlias("date", "D");

    // PRIOROITY
    addUnitPriority("date", 9);

    // PARSING

    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
      // TODO: Remove "ordinalParse" fallback in next major release.
      return isStrict
        ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
        : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(["D", "DD"], DATE);
    addParseToken("Do", function(input, array) {
      array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet("Date", true);

    // FORMATTING

    addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");

    // ALIASES

    addUnitAlias("dayOfYear", "DDD");

    // PRIORITY
    addUnitPriority("dayOfYear", 4);

    // PARSING

    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken(["DDD", "DDDD"], function(input, array, config) {
      config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
      var dayOfYear =
        Math.round(
          (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
        ) + 1;
      return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }

    // FORMATTING

    addFormatToken("m", ["mm", 2], 0, "minute");

    // ALIASES

    addUnitAlias("minute", "m");

    // PRIORITY

    addUnitPriority("minute", 14);

    // PARSING

    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken(["m", "mm"], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet("Minutes", false);

    // FORMATTING

    addFormatToken("s", ["ss", 2], 0, "second");

    // ALIASES

    addUnitAlias("second", "s");

    // PRIORITY

    addUnitPriority("second", 15);

    // PARSING

    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken(["s", "ss"], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet("Seconds", false);

    // FORMATTING

    addFormatToken("S", 0, 0, function() {
      return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ["SS", 2], 0, function() {
      return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ["SSS", 3], 0, "millisecond");
    addFormatToken(0, ["SSSS", 4], 0, function() {
      return this.millisecond() * 10;
    });
    addFormatToken(0, ["SSSSS", 5], 0, function() {
      return this.millisecond() * 100;
    });
    addFormatToken(0, ["SSSSSS", 6], 0, function() {
      return this.millisecond() * 1000;
    });
    addFormatToken(0, ["SSSSSSS", 7], 0, function() {
      return this.millisecond() * 10000;
    });
    addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
      return this.millisecond() * 100000;
    });
    addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
      return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias("millisecond", "ms");

    // PRIORITY

    addUnitPriority("millisecond", 16);

    // PARSING

    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);

    var token;
    for (token = "SSSS"; token.length <= 9; token += "S") {
      addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
      array[MILLISECOND] = toInt(("0." + input) * 1000);
    }

    for (token = "S"; token.length <= 9; token += "S") {
      addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet("Milliseconds", false);

    // FORMATTING

    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");

    // MOMENTS

    function getZoneAbbr() {
      return this._isUTC ? "UTC" : "";
    }

    function getZoneName() {
      return this._isUTC ? "Coordinated Universal Time" : "";
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
      "dates accessor is deprecated. Use date instead.",
      getSetDayOfMonth
    );
    proto.months = deprecate(
      "months accessor is deprecated. Use month instead",
      getSetMonth
    );
    proto.years = deprecate(
      "years accessor is deprecated. Use year instead",
      getSetYear
    );
    proto.zone = deprecate(
      "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
      getSetZone
    );
    proto.isDSTShifted = deprecate(
      "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
      isDaylightSavingTimeShifted
    );

    function createUnix(input) {
      return createLocal(input * 1000);
    }

    function createInZone() {
      return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
      return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
      var locale = getLocale();
      var utc = createUTC().set(setter, index);
      return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }

      format = format || "";

      if (index != null) {
        return get$1(format, index, field, "month");
      }

      var i;
      var out = [];
      for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, "month");
      }
      return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
      if (typeof localeSorted === "boolean") {
        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || "";
      } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
          index = format;
          format = undefined;
        }

        format = format || "";
      }

      var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

      if (index != null) {
        return get$1(format, (index + shift) % 7, field, "day");
      }

      var i;
      var out = [];
      for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, "day");
      }
      return out;
    }

    function listMonths(format, index) {
      return listMonthsImpl(format, index, "months");
    }

    function listMonthsShort(format, index) {
      return listMonthsImpl(format, index, "monthsShort");
    }

    function listWeekdays(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }

    function listWeekdaysShort(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }

    function listWeekdaysMin(localeSorted, format, index) {
      return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }

    getSetGlobalLocale("en", {
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function(number) {
        var b = number % 10,
          output =
            toInt((number % 100) / 10) === 1
              ? "th"
              : b === 1
              ? "st"
              : b === 2
              ? "nd"
              : b === 3
              ? "rd"
              : "th";
        return number + output;
      }
    });

    // Side effect imports

    hooks.lang = deprecate(
      "moment.lang is deprecated. Use moment.locale instead.",
      getSetGlobalLocale
    );
    hooks.langData = deprecate(
      "moment.langData is deprecated. Use moment.localeData instead.",
      getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
      var data = this._data;

      this._milliseconds = mathAbs(this._milliseconds);
      this._days = mathAbs(this._days);
      this._months = mathAbs(this._months);

      data.milliseconds = mathAbs(data.milliseconds);
      data.seconds = mathAbs(data.seconds);
      data.minutes = mathAbs(data.minutes);
      data.hours = mathAbs(data.hours);
      data.months = mathAbs(data.months);
      data.years = mathAbs(data.years);

      return this;
    }

    function addSubtract$1(duration, input, value, direction) {
      var other = createDuration(input, value);

      duration._milliseconds += direction * other._milliseconds;
      duration._days += direction * other._days;
      duration._months += direction * other._months;

      return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
      return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
      return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
      if (number < 0) {
        return Math.floor(number);
      } else {
        return Math.ceil(number);
      }
    }

    function bubble() {
      var milliseconds = this._milliseconds;
      var days = this._days;
      var months = this._months;
      var data = this._data;
      var seconds, minutes, hours, years, monthsFromDays;

      // if we have a mix of positive and negative values, bubble down first
      // check: https://github.com/moment/moment/issues/2166
      if (
        !(
          (milliseconds >= 0 && days >= 0 && months >= 0) ||
          (milliseconds <= 0 && days <= 0 && months <= 0)
        )
      ) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
      }

      // The following code bubbles up values, see the tests for
      // examples of what that means.
      data.milliseconds = milliseconds % 1000;

      seconds = absFloor(milliseconds / 1000);
      data.seconds = seconds % 60;

      minutes = absFloor(seconds / 60);
      data.minutes = minutes % 60;

      hours = absFloor(minutes / 60);
      data.hours = hours % 24;

      days += absFloor(hours / 24);

      // convert days to months
      monthsFromDays = absFloor(daysToMonths(days));
      months += monthsFromDays;
      days -= absCeil(monthsToDays(monthsFromDays));

      // 12 months -> 1 year
      years = absFloor(months / 12);
      months %= 12;

      data.days = days;
      data.months = months;
      data.years = years;

      return this;
    }

    function daysToMonths(days) {
      // 400 years have 146097 days (taking into account leap year rules)
      // 400 years have 12 months === 4800
      return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
      // the reverse of daysToMonths
      return (months * 146097) / 4800;
    }

    function as(units) {
      if (!this.isValid()) {
        return NaN;
      }
      var days;
      var months;
      var milliseconds = this._milliseconds;

      units = normalizeUnits(units);

      if (units === "month" || units === "year") {
        days = this._days + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === "month" ? months : months / 12;
      } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
          case "week":
            return days / 7 + milliseconds / 6048e5;
          case "day":
            return days + milliseconds / 864e5;
          case "hour":
            return days * 24 + milliseconds / 36e5;
          case "minute":
            return days * 1440 + milliseconds / 6e4;
          case "second":
            return days * 86400 + milliseconds / 1000;
          // Math.floor prevents floating point math errors here
          case "millisecond":
            return Math.floor(days * 864e5) + milliseconds;
          default:
            throw new Error("Unknown unit " + units);
        }
      }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
      if (!this.isValid()) {
        return NaN;
      }
      return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
      );
    }

    function makeAs(alias) {
      return function() {
        return this.as(alias);
      };
    }

    var asMilliseconds = makeAs("ms");
    var asSeconds = makeAs("s");
    var asMinutes = makeAs("m");
    var asHours = makeAs("h");
    var asDays = makeAs("d");
    var asWeeks = makeAs("w");
    var asMonths = makeAs("M");
    var asYears = makeAs("y");

    function clone$1() {
      return createDuration(this);
    }

    function get$2(units) {
      units = normalizeUnits(units);
      return this.isValid() ? this[units + "s"]() : NaN;
    }

    function makeGetter(name) {
      return function() {
        return this.isValid() ? this._data[name] : NaN;
      };
    }

    var milliseconds = makeGetter("milliseconds");
    var seconds = makeGetter("seconds");
    var minutes = makeGetter("minutes");
    var hours = makeGetter("hours");
    var days = makeGetter("days");
    var months = makeGetter("months");
    var years = makeGetter("years");

    function weeks() {
      return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
      ss: 44, // a few seconds to seconds
      s: 45, // seconds to minute
      m: 45, // minutes to hour
      h: 22, // hours to day
      d: 26, // days to month
      M: 11 // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(
      string,
      number,
      withoutSuffix,
      isFuture,
      locale
    ) {
      return locale.relativeTime(
        number || 1,
        !!withoutSuffix,
        string,
        isFuture
      );
    }

    function relativeTime$1(posNegDuration, withoutSuffix, locale) {
      var duration = createDuration(posNegDuration).abs();
      var seconds = round(duration.as("s"));
      var minutes = round(duration.as("m"));
      var hours = round(duration.as("h"));
      var days = round(duration.as("d"));
      var months = round(duration.as("M"));
      var years = round(duration.as("y"));

      var a = (seconds <= thresholds.ss && ["s", seconds]) ||
        (seconds < thresholds.s && ["ss", seconds]) ||
        (minutes <= 1 && ["m"]) ||
        (minutes < thresholds.m && ["mm", minutes]) ||
        (hours <= 1 && ["h"]) ||
        (hours < thresholds.h && ["hh", hours]) ||
        (days <= 1 && ["d"]) ||
        (days < thresholds.d && ["dd", days]) ||
        (months <= 1 && ["M"]) ||
        (months < thresholds.M && ["MM", months]) ||
        (years <= 1 && ["y"]) || ["yy", years];

      a[2] = withoutSuffix;
      a[3] = +posNegDuration > 0;
      a[4] = locale;
      return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
      if (roundingFunction === undefined) {
        return round;
      }
      if (typeof roundingFunction === "function") {
        round = roundingFunction;
        return true;
      }
      return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
      if (thresholds[threshold] === undefined) {
        return false;
      }
      if (limit === undefined) {
        return thresholds[threshold];
      }
      thresholds[threshold] = limit;
      if (threshold === "s") {
        thresholds.ss = limit - 1;
      }
      return true;
    }

    function humanize(withSuffix) {
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var locale = this.localeData();
      var output = relativeTime$1(this, !withSuffix, locale);

      if (withSuffix) {
        output = locale.pastFuture(+this, output);
      }

      return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
      return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
      // for ISO strings we do not use the normal bubbling rules:
      //  * milliseconds bubble up until they become hours
      //  * days do not bubble at all
      //  * months bubble up until they become years
      // This is because there is no context-free conversion between hours and days
      // (think of clock changes)
      // and also not between days and months (28-31 days per month)
      if (!this.isValid()) {
        return this.localeData().invalidDate();
      }

      var seconds = abs$1(this._milliseconds) / 1000;
      var days = abs$1(this._days);
      var months = abs$1(this._months);
      var minutes, hours, years;

      // 3600 seconds -> 60 minutes -> 1 hour
      minutes = absFloor(seconds / 60);
      hours = absFloor(minutes / 60);
      seconds %= 60;
      minutes %= 60;

      // 12 months -> 1 year
      years = absFloor(months / 12);
      months %= 12;

      // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
      var Y = years;
      var M = months;
      var D = days;
      var h = hours;
      var m = minutes;
      var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
      var total = this.asSeconds();

      if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
      }

      var totalSign = total < 0 ? "-" : "";
      var ymSign = sign(this._months) !== sign(total) ? "-" : "";
      var daysSign = sign(this._days) !== sign(total) ? "-" : "";
      var hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";

      return (
        totalSign +
        "P" +
        (Y ? ymSign + Y + "Y" : "") +
        (M ? ymSign + M + "M" : "") +
        (D ? daysSign + D + "D" : "") +
        (h || m || s ? "T" : "") +
        (h ? hmsSign + h + "H" : "") +
        (m ? hmsSign + m + "M" : "") +
        (s ? hmsSign + s + "S" : "")
      );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
      "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
      toISOString$1
    );
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");

    // PARSING

    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
      config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken("x", function(input, array, config) {
      config._d = new Date(toInt(input));
    });

    // Side effect imports

    hooks.version = "2.22.0";

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
      DATETIME_LOCAL: "YYYY-MM-DDTHH:mm", // <input type="datetime-local" />
      DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss", // <input type="datetime-local" step="1" />
      DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS", // <input type="datetime-local" step="0.001" />
      DATE: "YYYY-MM-DD", // <input type="date" />
      TIME: "HH:mm", // <input type="time" />
      TIME_SECONDS: "HH:mm:ss", // <input type="time" step="1" />
      TIME_MS: "HH:mm:ss.SSS", // <input type="time" step="0.001" />
      WEEK: "YYYY-[W]WW", // <input type="week" />
      MONTH: "YYYY-MM" // <input type="month" />
    };

    return hooks;
  });
})(moment$1);

var moment = moment$1.exports;

var Paging = function Paging(_ref) {
  var totalPage = _ref.totalPage,
    currentPage = _ref.currentPage,
    maxPageSelection = _ref.maxPageSelection,
    goToPageNo = _ref.goToPageNo,
    isMobile = _ref.isMobile;
  var pagingTotalPage = totalPage || 1; // at least one when 0

  var isFirstPage = currentPage === 1;
  var isLastPage = currentPage >= pagingTotalPage;
  var renderSelectablePage = pagingTotalPage > maxPageSelection;
  var selectablePage = renderSelectablePage
    ? maxPageSelection
    : pagingTotalPage;
  var prevCount = Math.ceil((maxPageSelection - 1) / 2);
  var nextCount = Math.floor((maxPageSelection - 1) / 2);
  var startSelectablePage = currentPage - prevCount;

  if (startSelectablePage < 1) {
    startSelectablePage = 1;
  } else if (pagingTotalPage - nextCount < currentPage) {
    startSelectablePage = pagingTotalPage - selectablePage + 1;
  }

  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "order-pagination ".concat(isMobile ? "morder-paging" : "")
    },
    /*#__PURE__*/ React.createElement(
      "ul",
      null,
      /*#__PURE__*/ React.createElement(
        "li",
        {
          className: "first ".concat(isFirstPage ? "disabled" : "")
        },
        /*#__PURE__*/ React.createElement(
          "a",
          {
            onClick: function onClick() {
              !isFirstPage && goToPageNo(1);
            }
          },
          "<<"
        )
      ),
      /*#__PURE__*/ React.createElement(
        "li",
        {
          className: "".concat(isFirstPage ? "disabled" : "")
        },
        /*#__PURE__*/ React.createElement(
          "a",
          {
            onClick: function onClick() {
              !isFirstPage && goToPageNo(currentPage - 1);
            }
          },
          "<"
        )
      ),
      Array(selectablePage)
        .fill(0)
        .map(function(_, index) {
          var pageNo = startSelectablePage + index;
          var isCurrentPage = pageNo === currentPage;
          return /*#__PURE__*/ React.createElement(
            "li",
            {
              className: "".concat(isCurrentPage ? "active" : ""),
              key: pageNo
            },
            /*#__PURE__*/ React.createElement(
              "a",
              {
                onClick: function onClick() {
                  !isCurrentPage && goToPageNo(pageNo);
                }
              },
              pageNo
            )
          );
        }),
      /*#__PURE__*/ React.createElement(
        "li",
        {
          className: "".concat(isLastPage ? "disabled" : "")
        },
        /*#__PURE__*/ React.createElement(
          "a",
          {
            onClick: function onClick() {
              !isLastPage && goToPageNo(currentPage + 1);
            }
          },
          ">"
        )
      ),
      /*#__PURE__*/ React.createElement(
        "li",
        {
          className: "last ".concat(isLastPage ? "disabled" : "")
        },
        /*#__PURE__*/ React.createElement(
          "a",
          {
            onClick: function onClick() {
              !isLastPage && goToPageNo(pagingTotalPage);
            }
          },
          ">>"
        )
      )
    )
  );
};

var LOADING =
  "data:image/gif;base64,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";

var PreLoader = function PreLoader(_ref) {
  var isLoading = _ref.isLoading,
    containerClassName = _ref.containerClassName,
    innerClassName = _ref.innerClassName;
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      id: "preloader-container",
      className: containerClassName || "preloader-container",
      style: {
        display: isLoading ? "block" : "none"
      }
    },
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: innerClassName || "preloader"
      },
      /*#__PURE__*/ React.createElement("img", {
        src: LOADING,
        alt: "Loading"
      })
    )
  );
};

var STK =
  "data:image/png;base64,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";

var formatDateStr = function formatDateStr(moment) {
  if (moment.isValid()) {
    return moment.format("YYYY-MM-DD");
  } else {
    return "";
  }
};

var OrderHistoryMobile = function OrderHistoryMobile() {
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];

  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    totalPage = _useState4[0],
    setTotalPage = _useState4[1];

  var _useState5 = useState(5),
    _useState6 = _slicedToArray(_useState5, 1),
    maxPageSelection = _useState6[0];

  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];

  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    data = _useState10[0],
    setData = _useState10[1];

  var tableRef = useRef();

  var getMyOrder = function getMyOrder(page) {
    setIsLoading(function(prevLoading) {
      return prevLoading + 1;
    });
    setCurrentPage(page);
    setData([]);
    get("api/v1/users/get_my_orders?page=".concat(page), 1, undefined, true)
      .then(function(res) {
        setTotalPage(res.pagination ? res.pagination.total_pages : 1);
        setData(res.response); // if page not exists and greater than last page, get last page from server

        if (res.pagination && page > res.pagination.total_pages && page !== 1) {
          getMyOrder(res.pagination.total_pages);
        }
      })
      ["catch"](function(err) {})
      ["finally"](function() {
        setIsLoading(function(prevLoading) {
          return prevLoading - 1;
        });
      });
  };

  var goToPageNo = function goToPageNo(pageNo) {
    getMyOrder(pageNo);
    tableRef.current.scrollTop = 0;
  };

  useEffect(function() {
    getMyOrder(1);
  }, []);
  var order1 = formatMessage({
    id: "order1"
  });
  var order4 = formatMessage({
    id: "order4"
  });
  var order5 = formatMessage({
    id: "order5"
  });
  var auto_pay_at = formatMessage({
    id: "auto_pay_at"
  });
  var order6 = formatMessage({
    id: "order6"
  });
  var order7 = formatMessage({
    id: "order7"
  });
  var orderref = formatMessage({
    id: "order.ref"
  });
  var orderdate = formatMessage({
    id: "order.date"
  });
  var orderstatus = formatMessage({
    id: "order.status"
  });
  var ordershipto = formatMessage({
    id: "order.shipto"
  });
  var ordergiftmsg = formatMessage({
    id: "order.giftmsg"
  });
  var ordertotal = formatMessage({
    id: "order.ordertotal"
  });
  var orderpaytotal = formatMessage({
    id: "order.paytotal"
  });
  var orderitem = formatMessage({
    id: "order.item"
  });
  var confirmed_order = formatMessage({
    id: "order.confirmed_order"
  });
  var shipment_shipped = formatMessage({
    id: "shipmentstatus.shipped"
  });
  var shippedqty = formatMessage({
    id: "shippedqty"
  });
  var subsub = formatMessage({
    id: "subscription.sub"
  });
  var cartpaybytermcheckbox = formatMessage({
    id: "cartpaybytermcheckbox"
  });
  var cartmonthlypayments = formatMessage({
    id: "cartmonthlypayments"
  });
  var accessoriessection23 = formatMessage({
    id: "accessoriessection23"
  });
  var accessoriessection24 = formatMessage({
    id: "accessoriessection24"
  });
  var breadcrumbproduct = formatMessage({
    id: "breadcrumbproduct"
  });
  var orderStatusCreated = formatMessage({
    id: "orderStatusCreated"
  });
  var orderStatusConfirmedOrder = formatMessage({
    id: "orderStatusConfirmedOrder"
  });
  var orderStatusPartiallyShipped = formatMessage({
    id: "orderStatusPartiallyShipped"
  });
  var orderStatusFulfilled = formatMessage({
    id: "orderStatusFulfilled"
  });
  var orderStatusPaymentFailed = formatMessage({
    id: "orderStatusPaymentFailed"
  });
  var orderStatusCancelled = formatMessage({
    id: "orderStatusCancelled"
  });
  var orderStatusRefunded = formatMessage({
    id: "orderStatusRefunded"
  });
  var displayStatusLookup = {
    created: orderStatusCreated,
    confirmed_order: orderStatusConfirmedOrder,
    partially_shipped: orderStatusPartiallyShipped,
    fulfilled: orderStatusFulfilled,
    payment_failed: orderStatusPaymentFailed,
    cancelled: orderStatusCancelled,
    refunded: orderStatusRefunded
  };
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "orderWrapper"
    },
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "mobileorderhistory",
        style: {
          position: "relative",
          flex: 1,
          height: "unset"
        }
      },
      isLoading
        ? /*#__PURE__*/ React.createElement(PreLoader, {
            isLoading: true
          })
        : /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "mTable",
              ref: tableRef
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "title"
              },
              order1
            ),
            data && data.length > 0
              ? data.map(function(item, index) {
                  var displayStatus =
                    displayStatusLookup[
                      item.status && item.status.toLowerCase()
                    ];
                  return /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      key: index,
                      className: "tabel"
                    },
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item order-detail-title"
                      },
                      orderref,
                      item.order_ref
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item"
                      },
                      orderdate,
                      formatDateStr(moment(item.created_at))
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item"
                      },
                      orderstatus,
                      displayStatus ? displayStatus : null
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item"
                      },
                      ordershipto,
                      item.receiver_name,
                      /*#__PURE__*/ React.createElement("br", null),
                      item.address_line_1
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item",
                        style: {
                          display: item.address_line_2 ? "block" : "none"
                        }
                      },
                      item.address_line_2
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        style: {
                          display: item.district ? "block" : "none"
                        }
                      },
                      ""
                        .concat(item.district, " ")
                        .concat(
                          item.postal_code
                            ? " (".concat(item.postal_code, ")")
                            : ""
                        )
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item",
                        style: {
                          display: item.city ? "block" : "none"
                        }
                      },
                      item.city
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item",
                        style: {
                          display: item.province ? "block" : "none"
                        }
                      },
                      item.province
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item",
                        style: {
                          display: item.country ? "block" : "none"
                        }
                      },
                      item.country
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item",
                        style: {
                          display: item.recipient_contact_number
                            ? "block"
                            : "none"
                        }
                      },
                      item.recipient_contact_number
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item",
                        style: {
                          display: item.is_gift ? "block" : "none"
                        }
                      },
                      ordergiftmsg,
                      item.gift_message
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item"
                      },
                      ordertotal,
                      "NT$",
                      item.total
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item",
                        style: {
                          display:
                            item.total > item.payment_total ? "block" : "none"
                        }
                      },
                      orderpaytotal,
                      "NT$",
                      item.payment_total
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item",
                        style: {
                          display: item.term > 0 ? "block" : "none"
                        }
                      },
                      cartpaybytermcheckbox,
                      "\xA0",
                      item.term,
                      " ",
                      cartmonthlypayments
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "item",
                        style: {
                          display:
                            item.order_items &&
                            item.order_items.some(function(o) {
                              return o.subscription_product_item;
                            }) &&
                            item.auto_pay_at
                              ? "block"
                              : "none"
                        }
                      },
                      auto_pay_at,
                      formatDateStr(moment(item.auto_pay_at))
                    ),
                    item.order_items.length > 0
                      ? item.order_items.map(function(i, inx) {
                          return /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              key: inx,
                              className: "maingroup"
                            },
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "group"
                              },
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "thead"
                                },
                                /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "item"
                                  },
                                  orderitem
                                )
                              ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "item"
                                },
                                /*#__PURE__*/ React.createElement("img", {
                                  className: "itemimg",
                                  src: i.product.image,
                                  alt: "Product"
                                }),
                                /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "text"
                                  },
                                  /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "name"
                                    },
                                    localStorage.lang === "tw"
                                      ? i.product.zhtw_product_series
                                      : localStorage.lang === "en"
                                      ? i.product.product_series
                                      : i.product.product_series
                                  ),
                                  /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "name"
                                    },
                                    localStorage.lang === "tw"
                                      ? i.product.zhtw_product_item_name
                                      : localStorage.lang === "en"
                                      ? i.product.name
                                      : i.product.name
                                  ),
                                  /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "name"
                                    },
                                    localStorage.lang === "tw"
                                      ? i.product.zhtw_product_variation
                                      : localStorage.lang === "en"
                                      ? i.product.product_variation
                                      : i.product.product_variation
                                  ),
                                  i.custom_plaque_name != null
                                    ? /*#__PURE__*/ React.createElement(
                                        "div",
                                        {
                                          className: "name"
                                        },
                                        accessoriessection23 +
                                          i.custom_plaque_name
                                      )
                                    : null,
                                  i.custom_plaque_creditline != null
                                    ? /*#__PURE__*/ React.createElement(
                                        "div",
                                        {
                                          className: "name"
                                        },
                                        accessoriessection24 +
                                          i.custom_plaque_creditline
                                      )
                                    : null,
                                  i.product.is_installment
                                    ? /*#__PURE__*/ React.createElement(
                                        "div",
                                        {
                                          className: "name"
                                        },
                                        subsub
                                      )
                                    : null
                                )
                              ),
                              i.product.product_variation === "Build Service"
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "bottext bottext1"
                                    },
                                    /*#__PURE__*/ React.createElement("img", {
                                      className: "img",
                                      src: STK,
                                      alt: "Build Service Logo"
                                    }),
                                    /*#__PURE__*/ React.createElement(
                                      "div",
                                      {
                                        className: "price"
                                      },
                                      order6,
                                      ": ",
                                      "NT$",
                                      i.price_subtotal
                                    ),
                                    /*#__PURE__*/ React.createElement(
                                      "div",
                                      {
                                        className: "qty"
                                      },
                                      order5,
                                      ": ",
                                      i.amount
                                    )
                                  )
                                : /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "bottext bottext2"
                                    },
                                    i.subscription_product_item &&
                                      /*#__PURE__*/ React.createElement(
                                        "div",
                                        {
                                          className: "price"
                                        },
                                        breadcrumbproduct,
                                        ":",
                                        " ",
                                        localStorage.lang === "tw"
                                          ? i.subscription_product_item
                                              .zhtw_item_name
                                          : localStorage.lang === "en"
                                          ? i.subscription_product_item
                                              .en_item_name
                                          : i.subscription_product_item
                                              .en_item_name
                                      ),
                                    /*#__PURE__*/ React.createElement(
                                      "div",
                                      {
                                        className: "price"
                                      },
                                      order6,
                                      ": ",
                                      "NT$",
                                      i.price_subtotal !== "0.0"
                                        ? i.price_subtotal
                                        : i.subscription_product_item
                                        ? i.subscription_product_item.price *
                                          i.amount
                                        : i.price_subtotal
                                    ),
                                    /*#__PURE__*/ React.createElement(
                                      "div",
                                      {
                                        className: "qty"
                                      },
                                      order5,
                                      ": ",
                                      i.amount
                                    )
                                  ),
                              item.status &&
                                (item.status.toLowerCase() === "created" ||
                                  item.status.toLowerCase() ===
                                    "payment_failed" ||
                                  item.status.toLowerCase() === "cancelled")
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "status"
                                    },
                                    order4,
                                    ": ",
                                    displayStatus
                                  )
                                : /*#__PURE__*/ React.createElement(
                                    React.Fragment,
                                    null,
                                    i.shipped_quantity === 0
                                      ? /*#__PURE__*/ React.createElement(
                                          "div",
                                          {
                                            className: "status"
                                          },
                                          order4,
                                          ": ",
                                          confirmed_order
                                        )
                                      : null,
                                    i.amount === 1 && i.shipped_quantity === 1
                                      ? /*#__PURE__*/ React.createElement(
                                          "div",
                                          {
                                            className: "status"
                                          },
                                          order4,
                                          ": ",
                                          shipment_shipped
                                        )
                                      : null
                                  ),
                              i.amount > i.shipped_quantity &&
                                i.shipped_quantity != 0
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "status"
                                    },
                                    shippedqty,
                                    i.shipped_quantity,
                                    " / ",
                                    i.amount
                                  )
                                : null,
                              i.amount > 1 && i.amount === i.shipped_quantity
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "status"
                                    },
                                    shippedqty,
                                    i.shipped_quantity,
                                    " / ",
                                    i.amount
                                  )
                                : null
                            )
                          );
                        })
                      : null
                  );
                })
              : null
          )
    ),
    /*#__PURE__*/ React.createElement(Paging, {
      totalPage: totalPage,
      currentPage: currentPage,
      maxPageSelection: maxPageSelection,
      goToPageNo: goToPageNo,
      isMobile: true
    }),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        style: {
          color: "white",
          background: "black",
          padding: "1rem 1.428571rem"
        }
      },
      order7
    )
  );
};

var CLOSE =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA3ElEQVQ4T7XUQQrCMBAF0JmW7EUIlO7d9RDiITyFx/ESegjxEO68QCEg7kM6JaFIrUmmSbC7lsxrpj8dbJpGVlV1Hobh1Pe9goxrbmDbthcAOBLRg4gOqajFEPGGiB0AXHH+IBX11aLtMAcN1TgwFY1t4AOuRbluvkAO5TBb/wOGULd4SjMWnhf0oRPYcSchCC5Re89hwZZ9yReDywCKWvalmR1K7GgkH5s1Bdya//x63Ft9IzI4HHKw2EBBKeVOCHEnolfhgN1qrffuG1q0rut36rSe79QYs1FKPUf2QX+WydGB/wAAAABJRU5ErkJggg==";

//#region product determination
var isSubOf = function isSubOf(cartItem, prefix) {
  return (
    cartItem &&
    cartItem.product &&
    cartItem.product.is_installment &&
    cartItem.product.product_key &&
    cartItem.product.product_key.startsWith(prefix)
  );
};
var isBtmfSub = function isBtmfSub(cartItem) {
  return isSubOf(cartItem, "btmf");
};
var isR2D2Sub = function isR2D2Sub(cartItem) {
  return isSubOf(cartItem, "r2d2");
};
var isSnoopySub = function isSnoopySub(cartItem) {
  return isSubOf(cartItem, "snh");
};
var isAmcSub = function isAmcSub(cartItem) {
  return isSubOf(cartItem, "amc");
};
var isKncSub = function isKncSub(cartItem) {
  return isSubOf(cartItem, "knc");
};
var haveBtmfSub = function haveBtmfSub(cartItem) {
  return isSubOf(cartItem, "btmf");
};
var haveR2D2Sub = function haveR2D2Sub(cartItem) {
  return isSubOf(cartItem, "r2d2");
};
//#region display control

var getSubBenefitTranslationKey = function getSubBenefitTranslationKey(
  cartItem
) {
  if (isSnoopySub(cartItem)) {
    return [
      "snhBenefit1",
      "snhBenefit2",
      "snhBenefit3",
      "snhBenefit4",
      "snhBenefit5",
      "snhBenefit6"
    ];
  }

  if (isAmcSub(cartItem)) {
    return [
      "amcBenefit1",
      "amcBenefit2",
      "amcBenefit3",
      "amcBenefit4",
      "amcBenefit5",
      "amcBenefit6"
    ];
  }

  if (isKncSub(cartItem)) {
    return [
      "kncBenefit1",
      "kncBenefit2",
      "kncBenefit3",
      "kncBenefit4",
      "kncBenefit5",
      "kncBenefit6"
    ];
  }

  return [
    "cart.nevermiss",
    "cart.freedelivery",
    "cart.nocommitment",
    "cart.cancelanytime"
  ];
};
var isShowNextMonthPaymentAmount = function isShowNextMonthPaymentAmount(_ref) {
  var cartItem = _ref.cartItem,
    cartItems = _ref.cartItems;

  if (cartItem) {
    return isBtmfSub(cartItem) || isR2D2Sub(cartItem);
  } else if (cartItems) {
    return haveBtmfSub(cartItems) || haveR2D2Sub(cartItems);
  }

  return true;
};
var isShowShipDate = function isShowShipDate(cartItem) {
  if (cartItem) {
    return isBtmfSub(cartItem) || isR2D2Sub(cartItem);
  }

  return true;
};
var isShowDiscountCode = function isShowDiscountCode(_ref2) {
  var cartItem = _ref2.cartItem,
    cartItems = _ref2.cartItems;

  if (cartItem) {
    return isBtmfSub(cartItem) || isR2D2Sub(cartItem);
  } else if (cartItems) {
    return haveBtmfSub(cartItems) || haveR2D2Sub(cartItems);
  }

  return true;
};
var isShowBenefitDisclaimer = function isShowBenefitDisclaimer(_ref3) {
  var cartItem = _ref3.cartItem,
    cartItems = _ref3.cartItems;

  if (cartItem) {
    return !(isBtmfSub(cartItem) || isR2D2Sub(cartItem));
  } else if (cartItems) {
    return !(haveBtmfSub(cartItems) || haveR2D2Sub(cartItems));
  }

  return false;
}; //#endregion

var outOfStockKey = {
  snh_special_scene_1_5: {
    redirectTo: "https://www.stk-workshop.tw/scene-5"
  },
  snh_special_scene_1_4: {
    redirectTo: "https://www.stk-workshop.tw/scene-5"
  }
};

var SubscriptionMobile = function SubscriptionMobile() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];

  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];

  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2);
  _useState6[0];
  _useState6[1];

  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2);
  _useState8[0];
  _useState8[1];

  var parseData = function parseData(res) {
    var newRes = [];
    var index = 0;
    var key_ref = []; // group subscription order item into one subscription for display
    // by subscription_ref

    for (var i = 0; i < res.length; i++) {
      if (key_ref.indexOf(res[i].order.subscription_ref) < 0) {
        key_ref[index] = res[i].order.subscription_ref;
        newRes[index] = res[i];
        newRes[index].pack_received = 0;
        index++;
      }

      var status = res[i].order.status;
      var index_i = key_ref.indexOf(res[i].order.subscription_ref); // use latest first_date_to_ship item as master

      if (status === "created") {
        if (
          moment(newRes[index_i].first_date_to_ship).diff(
            moment(res[i].first_date_to_ship),
            "days"
          ) > 0
        ) {
          newRes[index_i].first_date_to_ship = res[i].first_date_to_ship;
          newRes[index_i].last_date_to_ship = res[i].last_date_to_ship;
        }
      }

      if (
        status === "confirmed_order" ||
        status === "partially_shipped" ||
        status === "fulfilled"
      ) {
        newRes[index_i].pack_received++;
      }
    }

    setData(newRes);
  };

  var generateFirstDateToReceive = function generateFirstDateToReceive(
    firstPackFirstDate,
    firstPackLastDate,
    packsDelivered
  ) {
    if (moment().isAfter(firstPackLastDate)) {
      return moment(firstPackFirstDate).add(packsDelivered - 1, "M");
    }

    return firstPackFirstDate;
  };

  var generateLastDateToReceive = function generateLastDateToReceive(
    firstPackLastDate,
    packsDelivered
  ) {
    if (moment().isAfter(firstPackLastDate)) {
      return moment(firstPackLastDate).add(packsDelivered - 1, "M");
    }

    return firstPackLastDate;
  };

  useEffect(function() {
    setIsLoading(true);
    get("api/v1/users/get_my_subscription_order_items", 1)
      .then(function(res) {
        parseData(res);
      })
      ["catch"](function() {})
      ["finally"](function() {
        setIsLoading(false);
      });
  }, []);
  var subpack = formatMessage({
    id: "subscription.pack"
  });
  var subnextshipment = formatMessage({
    id: "subscription.nextshipment"
  });
  var subshipaddress = formatMessage({
    id: "subscription.shipaddress"
  });
  formatMessage({
    id: "subscription.unsub"
  });
  var subscriptiontitle = formatMessage({
    id: "subscription.title"
  });
  formatMessage({
    id: "subscription.unsubtitle"
  });
  formatMessage({
    id: "subscription.unsubdesc"
  });
  formatMessage({
    id: "subscription.nounsub"
  });
  formatMessage({
    id: "subscription.plzunsub"
  });
  var datetodate = formatMessage({
    id: "cart.receive_date_1"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "mobileorderhistory mobilesubscriptions mpad_h",
      style: {
        position: "relative",
        height: "100%"
      }
    },
    /*#__PURE__*/ React.createElement(PreLoader, {
      isLoading: isLoading
    }),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "title"
      },
      subscriptiontitle
    ),
    data && data.length > 0
      ? data.map(function(item, index) {
          return /*#__PURE__*/ React.createElement(
            "div",
            {
              key: index,
              className: "tabel"
            },
            /*#__PURE__*/ React.createElement("img", {
              className: "itemimg",
              src: item.product.image,
              alt: "Product"
            }),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "name"
                },
                localStorage.lang === "tw"
                  ? item.product.zhtw_product_series
                  : localStorage.lang === "en"
                  ? item.product.product_series
                  : item.product.product_series
              )
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "name"
                },
                localStorage.lang === "tw"
                  ? item.product.zhtw_product_item_name
                  : localStorage.lang === "en"
                  ? item.product.name
                  : item.product.name
              )
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "name"
                },
                localStorage.lang === "tw"
                  ? item.product.zhtw_product_variation
                  : localStorage.lang === "en"
                  ? item.product.product_variation
                  : item.product.product_variation
              )
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item"
              },
              subpack,
              item.pack_received
            ),
            item.product &&
              isShowShipDate(item) &&
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item"
                },
                subnextshipment,
                formatDateStr(
                  moment(
                    generateFirstDateToReceive(
                      item.first_date_to_ship,
                      item.last_date_to_ship,
                      item.pack_received
                    )
                  )
                ),
                datetodate,
                formatDateStr(
                  moment(
                    generateLastDateToReceive(
                      item.last_date_to_ship,
                      item.pack_received
                    )
                  )
                )
              ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item"
              },
              subshipaddress,
              item.order.receiver_name,
              /*#__PURE__*/ React.createElement("br", null),
              item.order.address_line_1
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item",
                style: {
                  display: item.order.address_line_2 ? "block" : "none"
                }
              },
              item.order.address_line_2
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item",
                style: {
                  display: item.order.city ? "block" : "none"
                }
              },
              item.order.city
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item",
                style: {
                  display: item.order.province ? "block" : "none"
                }
              },
              item.order.province
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item",
                style: {
                  display: item.order.country ? "block" : "none"
                }
              },
              item.order.country
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "item",
                style: {
                  display: item.order.recipient_contact_number
                    ? "block"
                    : "none"
                }
              },
              item.order.recipient_contact_number
            ),
            /*#__PURE__*/ React.createElement("div", {
              className: "thead"
            })
          );
        })
      : null
  );
};

var UserMobile = function UserMobile() {
  var mainleft1 = formatMessage({
    id: "common.mainleft1"
  });
  var mainleft2 = formatMessage({
    id: "common.mainleft2"
  });
  var subscriptiontitle = formatMessage({
    id: "subscription.title"
  });

  var _useState = useState({
      order: {
        title: mainleft2,
        component: /*#__PURE__*/ React.createElement(OrderHistoryMobile, null)
      },
      profile: {
        title: mainleft1,
        component: /*#__PURE__*/ React.createElement(ProfileMobile, null)
      },
      subscription: {
        title: subscriptiontitle,
        component: /*#__PURE__*/ React.createElement(SubscriptionMobile, null)
      }
    }),
    _useState2 = _slicedToArray(_useState, 1),
    pages = _useState2[0];

  var _useState3 = useState("order"),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];

  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page page2"
    },
    /*#__PURE__*/ React.createElement(Header, {
      type: 2,
      showRight: true
    }),
    /*#__PURE__*/ React.createElement(
      "ul",
      {
        className: "navbar"
      },
      Object.keys(pages).map(function(pageKey) {
        return /*#__PURE__*/ React.createElement(
          "li",
          {
            key: pageKey,
            className: currentPage === pageKey ? "active" : "",
            onClick: function onClick() {
              return setCurrentPage(pageKey);
            }
          },
          pages[pageKey].title
        );
      })
    ),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers user"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "main"
        },
        pages[currentPage] && pages[currentPage].component
      )
    )
  );
};

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function(key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }
  return target;
}

var ProfileWeb = function ProfileWeb() {
  var _districtTW$find;

  var _useState = useState(
      localStorage.user ? JSON.parse(localStorage.user) : null
    ),
    _useState2 = _slicedToArray(_useState, 1),
    user = _useState2[0];

  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    old_password = _useState4[0],
    setOld_password = _useState4[1];

  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    password = _useState6[0],
    setPassword = _useState6[1];

  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    changePasswordError = _useState8[0],
    setChangePasswordError = _useState8[1];

  var _useState9 = useState(user ? user.first_name : ""),
    _useState10 = _slicedToArray(_useState9, 2),
    first_name = _useState10[0],
    setFirst_name = _useState10[1];

  var _useState11 = useState(user ? user.last_name : ""),
    _useState12 = _slicedToArray(_useState11, 2),
    last_name = _useState12[0],
    setLast_name = _useState12[1];

  var _useState13 = useState(user ? user.contact_number : ""),
    _useState14 = _slicedToArray(_useState13, 2),
    contact_number = _useState14[0],
    setContact_number = _useState14[1];

  var _useState15 = useState(user ? user.address_line_1 : ""),
    _useState16 = _slicedToArray(_useState15, 2),
    address_line_1 = _useState16[0],
    setAddress_line_1 = _useState16[1];

  var _useState17 = useState(user ? user.city : ""),
    _useState18 = _slicedToArray(_useState17, 2),
    city = _useState18[0],
    setCity = _useState18[1];

  var _useState19 = useState(user ? user.district : ""),
    _useState20 = _slicedToArray(_useState19, 2),
    district = _useState20[0],
    setDistrict = _useState20[1];

  var _useState21 = useState(
      user !== null && user !== void 0 && user.postal_code
        ? user.postal_code
        : ""
    ),
    _useState22 = _slicedToArray(_useState21, 2),
    postal_code = _useState22[0],
    setPostal_code = _useState22[1];

  var _useState23 = useState(user ? user.country : ""),
    _useState24 = _slicedToArray(_useState23, 2),
    country = _useState24[0],
    setCountry = _useState24[1];

  var _useState25 = useState(
      ((_districtTW$find = districtTW.find(function(c) {
        return (
          formatMessage({
            id: c.tKey
          }) === user.city
        );
      })) === null || _districtTW$find === void 0
        ? void 0
        : _districtTW$find.district) || []
    ),
    _useState26 = _slicedToArray(_useState25, 2),
    districtList = _useState26[0],
    setDistrictList = _useState26[1];

  var _useState27 = useState({}),
    _useState28 = _slicedToArray(_useState27, 2),
    changeInfoError = _useState28[0],
    setChangeInfoError = _useState28[1];

  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    showCityList = _useState30[0],
    setShowCityList = _useState30[1];

  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    showDistrictList = _useState32[0],
    setShowDistrictList = _useState32[1];

  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    showCountryList = _useState34[0],
    setShowCountryList = _useState34[1];

  var toggleCityList = function toggleCityList() {
    if (!showCityList) {
      setShowCityList(true);
      setShowDistrictList(false);
      setShowCountryList(false);
    } else {
      setShowCityList(false);
    }
  };

  var toggleDistrictList = function toggleDistrictList() {
    if (!showDistrictList) {
      setShowCityList(false);
      setShowDistrictList(true);
      setShowCountryList(false);
    } else {
      setShowDistrictList(false);
    }
  };

  var toggleCountryList = function toggleCountryList() {
    if (!showCountryList) {
      setShowCityList(false);
      setShowDistrictList(false);
      setShowCountryList(true);
    } else {
      setShowCountryList(false);
    }
  };

  var selectCity = function selectCity(val, list) {
    setCity(val);
    setDistrictList(list);
    setDistrict("");
    setPostal_code("");
    setShowCityList(false);
  };

  var selectDistrict = function selectDistrict(val, code) {
    setDistrict(val);
    setPostal_code(code);
    setShowDistrictList(false);
  };

  var selectCountry = function selectCountry(val) {
    setCountry(val);
    setShowCountryList(false);
  };

  var changePassword = function changePassword() {
    var newChangePasswordError = {};

    if (password === "") {
      newChangePasswordError.password = true;
    }

    if (old_password === "") {
      newChangePasswordError.old_password = true;
    }

    setChangePasswordError(newChangePasswordError);
    if (Object.keys(newChangePasswordError).length > 0) return;
    var data = {
      user: {
        old_password: old_password,
        password: password,
        password_confirmation: password
      }
    };
    post("api/v1/users/reset_password", data, 1)
      .then(function() {
        window.location.reload();
      })
      ["catch"](function() {
        setChangePasswordError({
          newChangePasswordError: newChangePasswordError,
          serverError: true
        });
      });
  };

  var saveInfo = function saveInfo() {
    var newChangeInfoError = {};

    if (first_name === "") {
      newChangeInfoError.first_name = true;
    }

    if (last_name === "") {
      newChangeInfoError.last_name = true;
    }

    if (contact_number === "" || contact_number.length < 8) {
      newChangeInfoError.contact_number = true;
    }

    if (address_line_1 === "") {
      newChangeInfoError.address_line_1 = true;
    }

    if (city === "") {
      newChangeInfoError.city = true;
    }

    if (district === "") {
      newChangeInfoError.district = true;
    }

    if (country === "") {
      newChangeInfoError.country = true;
    }

    setChangeInfoError(newChangeInfoError);
    if (Object.keys(newChangeInfoError).length > 0) return;
    var data = {
      user: {
        first_name: first_name,
        last_name: last_name,
        contact_number: contact_number,
        address_line_1: address_line_1,
        address_line_2: "",
        city: city,
        province: "",
        country: country
      }
    };
    post("api/v1/users/update", data, 1)
      .then(function(res) {
        localStorage.setItem("user", JSON.stringify(res));
        window.location.reload();
      })
      ["catch"](function() {
        setChangeInfoError(
          _objectSpread$1(
            _objectSpread$1({}, newChangeInfoError),
            {},
            {
              serverError: true
            }
          )
        );
      });
  };

  var profiledesc1 = formatMessage({
    id: "profiledesc1"
  });
  var profiledesc2 = formatMessage({
    id: "profiledesc2"
  });
  var profiledesc3 = formatMessage({
    id: "profiledesc3"
  });
  var proile1 = formatMessage({
    id: "proile1"
  });
  var proile2 = formatMessage({
    id: "proile2"
  });
  var proile4 = formatMessage({
    id: "proile4"
  });
  var proile5 = formatMessage({
    id: "proile5"
  });
  var proile6 = formatMessage({
    id: "proile6"
  });
  var proile7 = formatMessage({
    id: "proile7"
  });
  var proilefirstname = formatMessage({
    id: "proile.firstname"
  });
  var proilelastname = formatMessage({
    id: "proile.lastname"
  });
  var proilecontactnum = formatMessage({
    id: "proile.contactnum"
  });
  var proileaddress1 = formatMessage({
    id: "proile.address1"
  });
  var proilecountry = formatMessage({
    id: "proile.country"
  });
  var proilesave = formatMessage({
    id: "proile.save"
  });
  var ordervalidinfo = formatMessage({
    id: "ordervalidinfo"
  });
  var passwordlength = formatMessage({
    id: "passwordlength"
  });
  var cart66 = formatMessage({
    id: "cart.cart66"
  });
  var wrongOldPassword = formatMessage({
    id: "wrongOldPassword"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "proile"
    },
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "form"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "title"
        },
        proile1
      ),
      /*#__PURE__*/ React.createElement("br", null),
      /*#__PURE__*/ React.createElement("p", null, profiledesc1),
      /*#__PURE__*/ React.createElement("p", null, profiledesc2),
      /*#__PURE__*/ React.createElement("p", null, profiledesc3),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement("p", null, proile2),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          readOnly: true,
          value: user && user.email ? user.email : ""
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-first-name",
            className: "".concat(
              changeInfoError.first_name ? "form-error-text" : ""
            )
          },
          proilefirstname
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          onInput: function onInput(e) {
            return setFirst_name(e.target.value);
          },
          defaultValue: first_name,
          maxLength: "60"
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-last-name",
            className: "".concat(
              changeInfoError.last_name ? "form-error-text" : ""
            )
          },
          proilelastname
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          onInput: function onInput(e) {
            return setLast_name(e.target.value);
          },
          defaultValue: last_name,
          maxLength: "60"
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-contact-number",
            className: "".concat(
              changeInfoError.contact_number ? "form-error-text" : ""
            )
          },
          proilecontactnum
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          minLength: "10",
          maxLength: "10",
          onInput: function onInput(e) {
            return setContact_number(e.target.value);
          },
          defaultValue: contact_number,
          required: true
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-address-line-1",
            className: "".concat(
              changeInfoError.address_line_1 ? "form-error-text" : ""
            )
          },
          proileaddress1
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          onInput: function onInput(e) {
            return setAddress_line_1(e.target.value);
          },
          defaultValue: address_line_1,
          maxLength: "250"
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group country-dropdown-container",
          style: {
            position: "relative",
            zIndex: 3
          }
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-postal_code"
          },
          ""
            .concat(
              formatMessage({
                id: "postal_code"
              }),
              ": "
            )
            .concat(postal_code)
        )
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group country-dropdown-container",
          style: {
            position: "relative",
            zIndex: 3
          }
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-city",
            className: "".concat(
              changePasswordError.city ? "form-error-text" : ""
            )
          },
          formatMessage({
            id: "twCity"
          })
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          readOnly: true,
          value: city,
          style: {
            cursor: "pointer"
          },
          onClick: toggleCityList
        }),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            onClick: toggleCityList,
            style: {
              width: 12,
              height: 8,
              position: "absolute",
              top: 38,
              right: 0,
              cursor: "pointer"
            }
          },
          /*#__PURE__*/ React.createElement("img", {
            style: {
              width: "100%",
              height: "100%"
            },
            src: RECTANGLE,
            alt: "Dropdown Icon"
          })
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "chooseCountry",
            style: {
              display: showCityList ? "block" : "none",
              bottom: -150,
              height: 150,
              overflow: "auto",
              cursor: "pointer",
              position: "absolute",
              right: 0,
              width: 216,
              border: "1px solid #000"
            }
          },
          districtTW.map(function(districtCity) {
            return /*#__PURE__*/ React.createElement(
              "div",
              {
                key: districtCity.tKey,
                onClick: function onClick() {
                  return selectCity(
                    formatMessage({
                      id: districtCity.tKey
                    }),
                    districtCity.district
                  );
                },
                style: {
                  cursor: "pointer",
                  position: "relative",
                  zIndex: 11,
                  paddingLeft: 18,
                  height: 44,
                  lineHeight: "44px",
                  fontSize: 14,
                  color: "#000",
                  backgroundColor: "#FFF"
                }
              },
              formatMessage({
                id: districtCity.tKey
              })
            );
          })
        )
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group country-dropdown-container",
          style: {
            position: "relative",
            zIndex: 2
          }
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-district",
            className: "".concat(
              changePasswordError.district ? "form-error-text" : ""
            )
          },
          formatMessage({
            id: "twDistrict"
          })
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          readOnly: true,
          value: district,
          style: {
            cursor: "pointer"
          },
          onClick: toggleDistrictList
        }),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            onClick: toggleDistrictList,
            style: {
              width: 12,
              height: 8,
              position: "absolute",
              top: 38,
              right: 0,
              cursor: "pointer"
            }
          },
          /*#__PURE__*/ React.createElement("img", {
            style: {
              width: "100%",
              height: "100%"
            },
            src: RECTANGLE,
            alt: "Dropdown Icon"
          })
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "chooseCountry",
            style: {
              display: showDistrictList ? "block" : "none",
              bottom: -150,
              height: 150,
              overflow: "auto",
              cursor: "pointer",
              position: "absolute",
              right: 0,
              width: 216,
              border: "1px solid #000",
              background: "white"
            }
          },
          districtList.map(function(twDistrict) {
            return /*#__PURE__*/ React.createElement(
              "div",
              {
                key: twDistrict.tKey,
                onClick: function onClick() {
                  return selectDistrict(
                    formatMessage({
                      id: twDistrict.tKey
                    }),
                    twDistrict.code
                  );
                },
                style: {
                  cursor: "pointer",
                  position: "relative",
                  zIndex: 11,
                  paddingLeft: 18,
                  height: 44,
                  lineHeight: "44px",
                  fontSize: 14,
                  color: "#000",
                  backgroundColor: "#FFF"
                }
              },
              ""
                .concat(
                  formatMessage({
                    id: twDistrict.tKey
                  }),
                  " ("
                )
                .concat(twDistrict.code, ")")
            );
          })
        )
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group country-dropdown-container",
          style: {
            position: "relative",
            zIndex: 1
          }
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-country",
            className: "".concat(
              changeInfoError.country ? "form-error-text" : ""
            )
          },
          proilecountry
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          readOnly: true,
          value: country,
          style: {
            cursor: "pointer"
          },
          onClick: toggleCountryList
        }),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            onClick: toggleCountryList,
            style: {
              width: 12,
              height: 8,
              position: "absolute",
              top: 38,
              right: 0,
              cursor: "pointer"
            }
          },
          /*#__PURE__*/ React.createElement("img", {
            style: {
              width: "100%",
              height: "100%"
            },
            src: RECTANGLE,
            alt: "Dropdown Icon"
          })
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "chooseCountry",
            style: {
              display: showCountryList ? "block" : "none",
              bottom: -49,
              cursor: "pointer",
              position: "absolute",
              right: 0,
              width: 216,
              border: "1px solid #000"
            }
          },
          [cart66].map(function(place) {
            return /*#__PURE__*/ React.createElement(
              "div",
              {
                key: place,
                onClick: function onClick() {
                  return selectCountry(place);
                },
                style: {
                  cursor: "pointer",
                  position: "relative",
                  zIndex: 11,
                  paddingLeft: 18,
                  height: 44,
                  lineHeight: "44px",
                  fontSize: 14,
                  color: "#000",
                  backgroundColor: "#FFF"
                }
              },
              place
            );
          })
        )
      ),
      /*#__PURE__*/ React.createElement("br", null),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          id: "form-error",
          className: "form-error",
          style: {
            display: Object.keys(changeInfoError).length > 0 ? "block" : "none"
          }
        },
        ordervalidinfo
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "btn",
          onClick: saveInfo
        },
        proilesave
      )
    ),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "form"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "title"
        },
        proile4
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-current-pw",
            className: "".concat(
              changePasswordError.old_password ? "form-error-text" : ""
            )
          },
          proile5
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "text",
          onInput: function onInput(e) {
            return setOld_password(e.target.value);
          },
          maxLength: "60"
        })
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "group"
        },
        /*#__PURE__*/ React.createElement(
          "p",
          {
            id: "form-new-pw",
            className: "".concat(
              changePasswordError.password ? "form-error-text" : ""
            )
          },
          proile6
        ),
        /*#__PURE__*/ React.createElement("input", {
          type: "password",
          onInput: function onInput(e) {
            return setPassword(e.target.value);
          },
          maxLength: "60"
        })
      )
    ),
    /*#__PURE__*/ React.createElement("br", null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        id: "form-error-pw",
        className: "form-error",
        style: {
          display:
            Object.keys(changePasswordError).length > 0 ? "block" : "none"
        }
      },
      changePasswordError.serverError ? wrongOldPassword : passwordlength
    ),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "btn",
        onClick: changePassword
      },
      proile7
    )
  );
};

var OrderHistoryWeb = function OrderHistoryWeb() {
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];

  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    totalPage = _useState4[0],
    setTotalPage = _useState4[1];

  var _useState5 = useState(5),
    _useState6 = _slicedToArray(_useState5, 1),
    maxPageSelection = _useState6[0];

  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];

  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    data = _useState10[0],
    setData = _useState10[1];

  var tableRef = useRef();

  var getMyOrder = function getMyOrder(page) {
    setIsLoading(function(prevLoading) {
      return prevLoading + 1;
    });
    setCurrentPage(page);
    setData([]);
    get("api/v1/users/get_my_orders?page=".concat(page), 1, undefined, true)
      .then(function(res) {
        setTotalPage(res.pagination ? res.pagination.total_pages : 1);
        setData(res.response); // if page not exists and greater than last page, get last page from server

        if (res.pagination && page > res.pagination.total_pages && page !== 1) {
          getMyOrder(res.pagination.total_pages);
        }
      })
      ["catch"](function(err) {})
      ["finally"](function() {
        setIsLoading(function(prevLoading) {
          return prevLoading - 1;
        });
      });
  };

  var goToPageNo = function goToPageNo(pageNo) {
    getMyOrder(pageNo);
    tableRef.current.scrollTop = 0;
  };

  useEffect(function() {
    getMyOrder(1);
  }, []);
  var order1 = formatMessage({
    id: "order1"
  });
  var order4 = formatMessage({
    id: "order4"
  });
  var order5 = formatMessage({
    id: "order5"
  });
  var auto_pay_at = formatMessage({
    id: "auto_pay_at"
  });
  var order6 = formatMessage({
    id: "order6"
  });
  var order7 = formatMessage({
    id: "order7"
  });
  var orderref = formatMessage({
    id: "order.ref"
  });
  var orderdate = formatMessage({
    id: "order.date"
  });
  var orderstatus = formatMessage({
    id: "order.status"
  });
  var ordershipto = formatMessage({
    id: "order.shipto"
  });
  var ordergiftmsg = formatMessage({
    id: "order.giftmsg"
  });
  var ordertotal = formatMessage({
    id: "order.ordertotal"
  });
  var orderpaytotal = formatMessage({
    id: "order.paytotal"
  });
  var orderitem = formatMessage({
    id: "order.item"
  });
  var confirmed_order = formatMessage({
    id: "order.confirmed_order"
  });
  var shipment_shipped = formatMessage({
    id: "shipmentstatus.shipped"
  });
  var shippedqty = formatMessage({
    id: "shippedqty"
  });
  var subsub = formatMessage({
    id: "subscription.sub"
  });
  var cartpaybytermcheckbox = formatMessage({
    id: "cartpaybytermcheckbox"
  });
  var cartmonthlypayments = formatMessage({
    id: "cartmonthlypayments"
  });
  var accessoriessection23 = formatMessage({
    id: "accessoriessection23"
  });
  var accessoriessection24 = formatMessage({
    id: "accessoriessection24"
  });
  var breadcrumbproduct = formatMessage({
    id: "breadcrumbproduct"
  });
  var orderStatusCreated = formatMessage({
    id: "orderStatusCreated"
  });
  var orderStatusConfirmedOrder = formatMessage({
    id: "orderStatusConfirmedOrder"
  });
  var orderStatusPartiallyShipped = formatMessage({
    id: "orderStatusPartiallyShipped"
  });
  var orderStatusFulfilled = formatMessage({
    id: "orderStatusFulfilled"
  });
  var orderStatusPaymentFailed = formatMessage({
    id: "orderStatusPaymentFailed"
  });
  var orderStatusCancelled = formatMessage({
    id: "orderStatusCancelled"
  });
  var orderStatusRefunded = formatMessage({
    id: "orderStatusRefunded"
  });
  var displayStatusLookup = {
    created: orderStatusCreated,
    confirmed_order: orderStatusConfirmedOrder,
    partially_shipped: orderStatusPartiallyShipped,
    fulfilled: orderStatusFulfilled,
    payment_failed: orderStatusPaymentFailed,
    cancelled: orderStatusCancelled,
    refunded: orderStatusRefunded
  };
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "orderhistory"
    },
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "title"
      },
      order1
    ),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "maintable",
        ref: tableRef,
        style: {
          position: "relative"
        }
      },
      /*#__PURE__*/ React.createElement(PreLoader, {
        isLoading: isLoading
      }),
      data && data.length > 0
        ? data.map(function(item, index) {
            var displayStatus =
              displayStatusLookup[item.status && item.status.toLowerCase()];
            return /*#__PURE__*/ React.createElement(
              "div",
              {
                key: index,
                className: "tabel"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "order-detail-title"
                },
                /*#__PURE__*/ React.createElement("span", null, orderref),
                /*#__PURE__*/ React.createElement("span", null, item.order_ref)
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "order-detail-line"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-left"
                  },
                  orderdate
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-right"
                  },
                  formatDateStr(moment(item.created_at))
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "order-detail-line"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-left"
                  },
                  orderstatus
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-right"
                  },
                  displayStatus
                    ? /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "status"
                        },
                        displayStatus
                      )
                    : null
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "order-detail-line"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-left"
                  },
                  ordershipto
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-right"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    null,
                    item.receiver_name
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    null,
                    item.address_line_1
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      style: {
                        display: item.address_line_2 ? "block" : "none"
                      }
                    },
                    item.address_line_2
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      style: {
                        display: item.district ? "block" : "none"
                      }
                    },
                    ""
                      .concat(item.district, " ")
                      .concat(
                        item.postal_code
                          ? " (".concat(item.postal_code, ")")
                          : ""
                      )
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      style: {
                        display: item.city ? "block" : "none"
                      }
                    },
                    item.city
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      style: {
                        display: item.province ? "block" : "none"
                      }
                    },
                    item.province
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      style: {
                        display: item.country ? "block" : "none"
                      }
                    },
                    item.country
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      style: {
                        display: item.recipient_contact_number
                          ? "block"
                          : "none"
                      }
                    },
                    item.recipient_contact_number
                  )
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "order-detail-line",
                  style: {
                    display: item.is_gift ? "flex" : "none"
                  }
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-left"
                  },
                  ordergiftmsg
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-right"
                  },
                  item.gift_message
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "order-detail-line"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-left"
                  },
                  ordertotal
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-right"
                  },
                  "NT$",
                  item.total
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "order-detail-line",
                  style: {
                    display: item.total > item.payment_total ? "flex" : "none"
                  }
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-left"
                  },
                  orderpaytotal
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-right"
                  },
                  "NT$",
                  item.payment_total
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "order-detail-line",
                  style: {
                    display: item.term > 0 ? "flex" : "none"
                  }
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-left"
                  },
                  cartpaybytermcheckbox
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-right"
                  },
                  item.term,
                  " ",
                  cartmonthlypayments
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "order-detail-line",
                  style: {
                    display:
                      item.order_items &&
                      item.order_items.some(function(o) {
                        return o.subscription_product_item;
                      }) &&
                      item.auto_pay_at
                        ? "flex"
                        : "none"
                  }
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-left"
                  },
                  auto_pay_at
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "order-detail-right"
                  },
                  formatDateStr(moment(item.auto_pay_at))
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "thead"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "item"
                  },
                  orderitem
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "status"
                  },
                  order4
                )
              ),
              item.order_items.length > 0
                ? item.order_items.map(function(i, inx) {
                    return /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        key: inx,
                        className: "tbody"
                      },
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "item"
                        },
                        /*#__PURE__*/ React.createElement("img", {
                          className: "itemimg",
                          src: i.product.image,
                          alt: "Product"
                        }),
                        i.product.product_variation === "Build Service"
                          ? /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "text text1"
                              },
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "name"
                                },
                                localStorage.lang === "tw"
                                  ? i.product.zhtw_product_series
                                  : localStorage.lang === "en"
                                  ? i.product.product_series
                                  : i.product.product_series
                              ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "name"
                                },
                                localStorage.lang === "tw"
                                  ? i.product.zhtw_product_item_name
                                  : localStorage.lang === "en"
                                  ? i.product.name
                                  : i.product.name
                              ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "name"
                                },
                                localStorage.lang === "tw"
                                  ? i.product.zhtw_product_variation
                                  : localStorage.lang === "en"
                                  ? i.product.product_variation
                                  : i.product.product_variation
                              ),
                              i.product.is_installment
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "name"
                                    },
                                    subsub
                                  )
                                : null,
                              /*#__PURE__*/ React.createElement("img", {
                                src: STK,
                                alt: "Build Service Logo"
                              }),
                              i.custom_plaque_name != null
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "name"
                                    },
                                    accessoriessection23 + i.custom_plaque_name
                                  )
                                : null,
                              i.custom_plaque_creditline != null
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "name"
                                    },
                                    accessoriessection24 +
                                      i.custom_plaque_creditline
                                  )
                                : null,
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "price"
                                },
                                order6,
                                ": ",
                                "NT$",
                                i.price_subtotal
                              ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "qty"
                                },
                                order5,
                                ": ",
                                i.amount
                              )
                            )
                          : /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "text text2"
                              },
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "name"
                                },
                                localStorage.lang === "tw"
                                  ? i.product.zhtw_product_series
                                  : localStorage.lang === "en"
                                  ? i.product.product_series
                                  : i.product.product_series
                              ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "name"
                                },
                                localStorage.lang === "tw"
                                  ? i.product.zhtw_product_item_name
                                  : localStorage.lang === "en"
                                  ? i.product.name
                                  : i.product.name
                              ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "name"
                                },
                                localStorage.lang === "tw"
                                  ? i.product.zhtw_product_variation
                                  : localStorage.lang === "en"
                                  ? i.product.product_variation
                                  : i.product.product_variation
                              ),
                              i.product.is_installment
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "name"
                                    },
                                    subsub
                                  )
                                : null,
                              i.custom_plaque_name != null
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "name"
                                    },
                                    accessoriessection23 + i.custom_plaque_name
                                  )
                                : null,
                              i.custom_plaque_creditline != null
                                ? /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "name"
                                    },
                                    accessoriessection24 +
                                      i.custom_plaque_creditline
                                  )
                                : null,
                              i.subscription_product_item &&
                                /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "price"
                                  },
                                  breadcrumbproduct,
                                  ":",
                                  " ",
                                  localStorage.lang === "tw"
                                    ? i.subscription_product_item.zhtw_item_name
                                    : localStorage.lang === "en"
                                    ? i.subscription_product_item.en_item_name
                                    : i.subscription_product_item.en_item_name
                                ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "price"
                                },
                                order6,
                                ": ",
                                "NT$",
                                i.price_subtotal !== "0.0"
                                  ? i.price_subtotal
                                  : i.subscription_product_item
                                  ? i.subscription_product_item.price * i.amount
                                  : i.price_subtotal
                              ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "qty"
                                },
                                order5,
                                ": ",
                                i.amount
                              )
                            )
                      ),
                      item.status &&
                        (item.status.toLowerCase() === "created" ||
                          item.status.toLowerCase() === "payment_failed" ||
                          item.status.toLowerCase() === "cancelled")
                        ? /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "status"
                            },
                            displayStatus
                          )
                        : /*#__PURE__*/ React.createElement(
                            React.Fragment,
                            null,
                            i.shipped_quantity === 0
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "status"
                                  },
                                  confirmed_order
                                )
                              : null,
                            i.amount === 1 && i.shipped_quantity === 1
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "status"
                                  },
                                  shipment_shipped
                                )
                              : null
                          ),
                      i.amount > i.shipped_quantity && i.shipped_quantity != 0
                        ? /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "status"
                            },
                            shippedqty,
                            i.shipped_quantity,
                            " / ",
                            i.amount
                          )
                        : null,
                      i.amount > 1 && i.amount === i.shipped_quantity
                        ? /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "status"
                            },
                            shippedqty,
                            i.shipped_quantity,
                            " / ",
                            i.amount
                          )
                        : null
                    );
                  })
                : null
            );
          })
        : null
    ),
    /*#__PURE__*/ React.createElement(Paging, {
      totalPage: totalPage,
      currentPage: currentPage,
      maxPageSelection: maxPageSelection,
      goToPageNo: goToPageNo
    }),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "bot"
      },
      order7
    )
  );
};

var SubscriptionWeb = function SubscriptionWeb() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];

  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];

  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2);
  _useState6[0];
  _useState6[1];

  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2);
  _useState8[0];
  _useState8[1];

  var parseData = function parseData(res) {
    var newRes = [];
    var index = 0;
    var key_ref = []; // group subscription order item into one subscription for display
    // by subscription_ref

    for (var i = 0; i < res.length; i++) {
      if (key_ref.indexOf(res[i].order.subscription_ref) < 0) {
        key_ref[index] = res[i].order.subscription_ref;
        newRes[index] = res[i];
        newRes[index].pack_received = 0;
        index++;
      }

      var status = res[i].order.status;
      var index_i = key_ref.indexOf(res[i].order.subscription_ref); // use latest first_date_to_ship item as master

      if (status === "created") {
        if (
          moment(newRes[index_i].first_date_to_ship).diff(
            moment(res[i].first_date_to_ship),
            "days"
          ) > 0
        ) {
          newRes[index_i].first_date_to_ship = res[i].first_date_to_ship;
          newRes[index_i].last_date_to_ship = res[i].last_date_to_ship;
        }
      }

      if (
        status === "confirmed_order" ||
        status === "partially_shipped" ||
        status === "fulfilled"
      ) {
        newRes[index_i].pack_received++;
      }
    }

    setData(newRes);
  };

  var generateFirstDateToReceive = function generateFirstDateToReceive(
    firstPackFirstDate,
    firstPackLastDate,
    packsDelivered
  ) {
    if (moment().isAfter(firstPackLastDate)) {
      return moment(firstPackFirstDate).add(packsDelivered - 1, "M");
    }

    return firstPackFirstDate;
  };

  var generateLastDateToReceive = function generateLastDateToReceive(
    firstPackLastDate,
    packsDelivered
  ) {
    if (moment().isAfter(firstPackLastDate)) {
      return moment(firstPackLastDate).add(packsDelivered - 1, "M");
    }

    return firstPackLastDate;
  };

  useEffect(function() {
    setIsLoading(true);
    get("api/v1/users/get_my_subscription_order_items", 1)
      .then(function(res) {
        parseData(res);
      })
      ["catch"](function() {})
      ["finally"](function() {
        setIsLoading(false);
      });
  }, []);
  var subpack = formatMessage({
    id: "subscription.pack"
  });
  var subnextshipment = formatMessage({
    id: "subscription.nextshipment"
  });
  var subshipaddress = formatMessage({
    id: "subscription.shipaddress"
  });
  formatMessage({
    id: "subscription.unsub"
  });
  var subscriptiontitle = formatMessage({
    id: "subscription.title"
  });
  formatMessage({
    id: "subscription.unsubtitle"
  });
  formatMessage({
    id: "subscription.unsubdesc"
  });
  formatMessage({
    id: "subscription.nounsub"
  });
  formatMessage({
    id: "subscription.plzunsub"
  });
  var datetodate = formatMessage({
    id: "cart.receive_date_1"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "orderhistory subscriptions"
    },
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "title"
      },
      subscriptiontitle
    ),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "maintable",
        style: {
          position: "relative"
        }
      },
      /*#__PURE__*/ React.createElement(PreLoader, {
        isLoading: isLoading
      }),
      data && data.length > 0
        ? data.map(function(item, index) {
            return /*#__PURE__*/ React.createElement(
              "div",
              {
                key: index,
                className: "tabel"
              },
              /*#__PURE__*/ React.createElement("img", {
                className: "itemimg",
                src: item.product.image,
                alt: "Product"
              }),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item subscriptions-title"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "name"
                  },
                  localStorage.lang === "tw"
                    ? item.product.zhtw_product_series
                    : localStorage.lang === "en"
                    ? item.product.product_series
                    : item.product.product_series
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item subscriptions-title"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "name"
                  },
                  localStorage.lang === "tw"
                    ? item.product.zhtw_product_item_name
                    : localStorage.lang === "en"
                    ? item.product.name
                    : item.product.name
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item subscriptions-title"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "name"
                  },
                  localStorage.lang === "tw"
                    ? item.product.zhtw_product_variation
                    : localStorage.lang === "en"
                    ? item.product.product_variation
                    : item.product.product_variation
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item"
                },
                subpack,
                item.pack_received
              ),
              item.product &&
                isShowShipDate(item) &&
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "item"
                  },
                  subnextshipment,
                  formatDateStr(
                    moment(
                      generateFirstDateToReceive(
                        item.first_date_to_ship,
                        item.last_date_to_ship,
                        item.pack_received
                      )
                    )
                  ),
                  datetodate,
                  formatDateStr(
                    moment(
                      generateLastDateToReceive(
                        item.last_date_to_ship,
                        item.pack_received
                      )
                    )
                  )
                ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item"
                },
                subshipaddress,
                item.order.receiver_name,
                /*#__PURE__*/ React.createElement("br", null),
                item.order.address_line_1
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item",
                  style: {
                    display: item.order.address_line_2 ? "block" : "none"
                  }
                },
                item.order.address_line_2
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item",
                  style: {
                    display: item.order.city ? "block" : "none"
                  }
                },
                item.order.city
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item",
                  style: {
                    display: item.order.province ? "block" : "none"
                  }
                },
                item.order.province
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item",
                  style: {
                    display: item.order.country ? "block" : "none"
                  }
                },
                item.order.country
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "item",
                  style: {
                    display: item.order.recipient_contact_number
                      ? "block"
                      : "none"
                  }
                },
                item.order.recipient_contact_number
              ),
              /*#__PURE__*/ React.createElement("div", {
                className: "thead"
              })
            );
          })
        : null
    )
  );
};

var RIGHT =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAx0lEQVQ4T63TMU4CQRTG8R89UFnSq7FRLyBnIEEs6LXxCroewxNIQge1XAE6wg2oib3kkd2EJboZ3Z1qJvPe/8335n0ttDDERb6XuNaYRvI9Jn9MjhrfeAjAC97igE1i9fO8aBaAV2S4weoE0MbXD9BrLCOvCnAVGvGMzxNICXCHPt6xPQq8xQwdjDE/uisBqmTHKxbo5s0uICXAI54qKD2cYYdBLqdZQG0JtZv42xwkf2Njg/TvUR7ho46ZCjtfJhqpCDvYeQ8b3z6z+sqbawAAAABJRU5ErkJggg==";

var UserWeb = function UserWeb() {
  var mainleft1 = formatMessage({
    id: "common.mainleft1"
  });
  var mainleft2 = formatMessage({
    id: "common.mainleft2"
  });
  var mainleft3 = formatMessage({
    id: "common.mainleft3"
  });
  var subscriptiontitle = formatMessage({
    id: "subscription.title"
  });

  var _useState = useState({
      order: {
        title: mainleft2,
        component: /*#__PURE__*/ React.createElement(OrderHistoryWeb, null)
      },
      profile: {
        title: mainleft1,
        component: /*#__PURE__*/ React.createElement(ProfileWeb, null)
      },
      subscription: {
        title: subscriptiontitle,
        component: /*#__PURE__*/ React.createElement(SubscriptionWeb, null)
      }
    }),
    _useState2 = _slicedToArray(_useState, 1),
    pages = _useState2[0];

  var _useState3 = useState("order"),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];

  var logout = function logout() {
    del("auth/sign_out", {}, true)
      .then(function() {
        localStorage.clear();
        window.location.href = "/";
      })
      ["catch"](function(err) {
        window.location.href = "/";
      });
  };

  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers user"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "main"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "mainleft"
          },
          /*#__PURE__*/ React.createElement(
            "ul",
            null,
            Object.keys(pages).map(function(pageKey) {
              return /*#__PURE__*/ React.createElement(
                "li",
                {
                  key: pageKey,
                  className: currentPage === pageKey ? "active" : "",
                  onClick: function onClick() {
                    return setCurrentPage(pageKey);
                  }
                },
                pages[pageKey].title
              );
            })
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "logout",
              onClick: logout
            },
            mainleft3,
            /*#__PURE__*/ React.createElement("img", {
              src: RIGHT,
              alt: "Logout Icon"
            })
          )
        ),
        pages[currentPage] && pages[currentPage].component
      )
    )
  );
};

var User = function User() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    render = _useState2[0],
    setRender = _useState2[1];

  useEffect(function() {
    if (!localStorage.getItem("userheader")) {
      window.location.href = requestParam$1.webBaseURL + "/login";
    } else {
      setRender(true);
    }
  }, []);
  return render
    ? /*#__PURE__*/ React.createElement(MobileDetector, {
        desktopChildren: /*#__PURE__*/ React.createElement(UserWeb, null),
        mobileChildren: /*#__PURE__*/ React.createElement(UserMobile, null)
      })
    : null;
};

// Note this is for BTMF/R2D2 but there are no accelerated starter plan in tw
var acceleratedStarterPlanSinglePay = "4,889";
var acceleratedStarterPlanEachMonth = 978;
var r2d2StarterPlanSinglePay = "5,943";
var r2d2StarterPlanEachMonth = 849; // price to allow installment

var priceToAllowInstallment = 2000; //

var availableTermDuration = [3, 6, 12];

var initCartKey = function initCartKey() {
  if (!localStorage.cartKey) {
    var key = Date.now();
    key = key + "" + Math.floor(Math.random() * 9999999999999999);
    localStorage.setItem("cartKey", key);
  }
};

var STK_LOGO_BUILD_SERVICE_BUTTON =
  "data:image/png;base64,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";

var CART_CHECK_MARK =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAh1BMVEX+/v4OvgH///8AugAAuQDh9eDm9+X5/fje9N3p+OjM7spp0GX7/vu25rTU8dNBxzx51HZy0m+Q242u5Kzz+/Nl0GHY8te+6bwyxCzG7MVJyURYzFWW3ZPu+e2K2Yc7xjV/1nwowyCb3plu0mui4J9dzVlPykqo4qa05rKL2Yh91nrC6sArwyRucVHlAAAQcklEQVR4nM2da2PqLAyALaD1Xp06r1PrNvfubP//971VZxsgXAvWfDpnm5anQAghCS0SXebt/mj2Mpkuzoc8uUh+OC+mk5fZqN+ex398K+aXd5an6YFeJZHl9ovD9LTsxGxELMLecp8lOBlCmmT7ZS9SS2IQdmbviRUbz5m8z2J0ZmjC4fqYM1e6kpLlx/UwcIuCEqajhXPfyX25GKUhGxWQcFkfr4RchmtWKMLXf4Hw7pD/XgO1LAjhcLZiAfFuwlazIFMyAGFvH7T7KqF0H2AJqU3YHZjxbkv+IdtsPxeLxed2kxXWjcIOED456DZMON5qh+d1MZ/sLuaZqB/TizG3mxjNArqtOSFrEb7q+CjNp1/9t/JBotx/8db/muY6Srat1Y81CHsLJR+l2a4/x8lQ0rf1LlNTskWN+ehNmB4VfJQl+3VqBcdjput9ojKH2NHbCvAl/MKbQtnh1HaD4zDbp4MCkn49lHC8QpvBfk8dX7wSsnP6RUcHXY0fRjicYE2gyeS1Hl4J+TpJsDfIJj4mgAfhD/6GZ2kAvDtkOsNHyc8DCIfvSAfSbT8Y3h2yv0UY2btzN7oSjrH+e+8G5rsx4uaS62x0JPyWO5C9dyLw3Rg7yIBh3xEJ55n0UtkiFt+Nsf0pMdLMyUPnQtiX+Gg2jsh3YxzLr5X24xDuxLdJk2VkvhvjSFo72C4G4UJ8DN0P4/NdGYd76dmD4IRvB2mAdh/Dd2XsikOVHmwnoyVhW5oKHw8YoACRfEizsR2ScC29wc4j+a6MnYPYCDt9Y0U4EnQMe3loB/4hkhexGVY+RxvCL1GJjh/Pd2UUDSpms6OyIDzxgHSbNgNYIKZnfqSyUwhCYWw0MkJLRKw1dQlf+LdGf5rjuzIuhfYYEU2EwhAtVHSjgAWisHAZB6qBUFAyxTLbMGCBOOeND5O60RPyywTdNjgFKyGE3xsbFg0t4ZoHnD4D30XIO4+oXfp1hG3ue+j+WQALxCPfNJ0BpyF8E5VW01xARBWvMcM1hIfnBZQQDz6Ei2cGFBE1+0Ul4Y77gqeZg2SY3v/FzUWq3PWrCPtQjT6RFk2z070tvEZVKlQF4Zwb5dunAXzLk6RsDNlyE0mhbRSEGT+Nm6QCQl6Tq3eh/D+nDDMXwm+uC5/AVLsKWd6mzrD8wVzQhtaEY24SNm5s/wn5YHelUv6IM0oY6vDHCIfwzbCGt0ulkP39vdNqC37v1j/Bjm0wwne+65vEKoVAzXms2sQvi1M7wh/4Wp5EjRIC/RcMePo4hcrWNoTcGE0a88lwQlJ+TwjeO0m538jjVCac8HO3Qa5ShE3Ata+qX3J6cWImhH//JJOQdBJRctAwbirK+lQiXIHveY6lnrzKR8FgxRAW/pWJEMbJ0Ie77jGRjhRubeuBcdqBjRbdNgJhCv/24ykAR3gEEVTy3LENHWoJj+A7sqcAnCniwOgIIkI7+qgj7EE188DzQaVI/logYCEjXahsehpCsK9/ik2vdNwEZQE7EZ4SD9SEr/D7huoHP0oEl5ognMUM7RTWVRICA4gum+9CMjGEScNxChXSVkUIF/snUDOC3xeRgULZsFcFIejCJzDX5OAPSdhIYbxtccIu+JNF04CEfNqkOLwBxM/qx7SLEg7Ay2namhFPX1RyBoRt0EMDjLAHvvK9ccCNXZIKPQFE0EW0hxDuwe8b7sIC0Irv0tRX3GmzlwmHz9OFgjPTINW6zXXiUCIE9l/D9pobIFCK0HajM4kQ7Aub9c2QlhPgZbtUfhSsdyuREBhstN8kIWlZz8E/YeVUhBGw5ap/J/wH6ZsEHLr14FVK6w2OxKNAyI3gBgHttSiQclWELgrKE8I4nFTbhsiEPoBgpwdci3TJEYKN4aTJLvQCBGY09IUuIGHKzdDmAO1MNVlK3Qjtb5oCQrC5+m0Q0MrYloRuwPEfyaufjwBhNUihofdoQIuMYkTYHkZqkV31m0VFCCy25nYVZOrXg7wzgnTADmNYEgKfa2NubvLPCzAXewQ4wOm6JKy8pI0NUiKlVFh14FZK+SAneM54J8zLn7GGjrTFKC47Yd9IijhwVeR3Qjh0GwL88Kk6wbm9q+8Cb6DzRwg2Ts24gcl/XmU18JUbzrnZH2F1bk/XTRDy5+q2snrD2wr15vsfYfUp2oRNimT9mYVuW6rOgPFcN0LggmrCD8ydqlgDTtQB2cBFcHFItbh9xe7xhKTnznfJP9R840tFuLwSVk62BqYhH7hlC/ifrp1wIu6vhKBTHx7BRoa5O6DBzQIDKzdXwuqj+eO70MNnkZhcgcCCSS6E4Jj/4YGyXvsl496ATMu/vfi2gaIBfrnHiI+1nSuWQfi1VeDCJU0LWKqPdiPyseR2crAIQwML7CWeBHap+fWEFB9bbWOTPk7euIkHA4oeC+huytCzXeIVUJ6FDUMasmiEnCMrQNvMMrgAEmjFPdKP6LHSU+uDaeBTpPNWuxmbjYsQtAO0P/MD7ijabgG9g24o4wifKmEF6LBYA+8oHbdGTSwW+lCguoDccjFqVRv8x6UduDst3PKSwIaMzlpgq/Eou1vITQ0OyNneuxY4ynjQBt99nXBQMjcBR1CTVmXSGBf8MF0sBNfHAIRL/rRVHVmY3N1pmGA+5w0THTg/F6xFg9a5/LfBpCFT/gzEU8zxeCLgp/tDwVs8tyqzdKPfOf9HC7uwdoIJUknHAOgTGQJOWrNWXv5b+1X3jXLNFYXPTbWRs88DgUGRt6rv0o6G+8iuV/nD3bGWeU0MBaHOsK0O97SOPOOTfx0BV37lxGBcgh0h3KwWutuXkc+AtxHPee9MyCWlJDTzfa6z18LXylIQquchdM9dpec1OZyNNa/HXB8F52HVeKUuRQaXRxi4s5apESJJqlU+t1gPsSXMQ6W67nnrbOa49dBo05AxWtPX1bfqasuwOjYiZ9OY7FKVQ4W5ZV+SmdskdH6D/NOgXVrtLfBTC6WhTF0cV1yqg4XUzF7l9haG/aEmjsfe99US0qfNgDXdftz+UL/HV9Vev33AujIWzPawAawZh83v8bV+Gj5PWm7Jxm5X7LqhqOua5v00Ol+b2W1rc1CCpirrJK+7R+N9bTp/qcUStrJojeMk9DdlynZz/lKNz9sieyxJfo22o6O9TeuH8EKfd0dzbmEZa5YbEJW5yriEqKXCn1soz57sj/e0iPy+xAwYIkWeP3tSnR/ixpo7otumlx4DAIrnh/gZMFKLQi2agep4QuHhV0OeKZwBo+f4jsd7SkRHz1OYCGXxHB+LxSCuW50Vjujq3w5zciLGYmDxNO6ZHfjSDzMCzRIqKxCGk3bwmCifQB7M7ScVAtdKsJpbYkwUVK03VWO10ksiuwik0kB6wFClVKCi2eCxiaTvAXgJBREfdTZ/qvp4sDgJOTZRji8lb/hNPYY2CmdE2p2XJPpTEydCKb4UiREmXhk6/HINB4uFhCsqJscIo3He8o0kNohc9SanMRowGUmO88Zj9cmPRy8C/5GTwc0CBifDhk+1+RbyrR02Tb37AIUKqHoJmouE5Vsocmawy4/Mjf3zhrt4ZtzP6bWE1ReXOTOqvCc/fXOdUUJNSr0EzZdD857UuWvYHV1GuWhFJ3s0aBwPnrumzj903KDfv4IrvmiQAF4LrsXVngHkH2pySD3sG7pw2T2zsOn/ihxSXR6wh0qlL/YhM/Rf2FAzmAc8sMzlJnPnUFAHCWes/bU2r14ezOXW5uOT1tlnr2EngSvAKvPx9TUV/FYNGwle3gB4nfiaCqa6GFUd5qASvsiIui6GqbaJrkKjP2Dw0HlNbRNjfZpLWFtoCZ/9AJ2zYn0aY40hvBRsLQmeoqOtMWSuE4VeI1tDWPjAeW2dKItaX17bKaVEqN5gqPUF67UpgnLdfGcGCeK/F9oHvbNEIrSpuUfmeTDCCIAwQv4bIbSpmyhWf/eWGLkdxrqJXO1LVQPI0LOSkwCoTcb2BDTWvuQy/5WzhL+kwBcwRpYc9JswvH6pXQ1a28qiOolR5ocLjPkkOCEsBa2xN/yONaDUDrbAWmVTR5irBa1J1au51agVdahsk1UtaD68TlPPuxZimKN6USzreVvXZPesy3WVKLW2bGuy29fVNxYTV0qUlHj7uvr2dyP4Isa5XIm7w0N7N4LD/RZ+iHEmIfQCm+63cLijxAsxziR0uaPE5Z4ZH3UTYyV0vGfG5a4g50UjykrY4u7B4xZ7nNDlvidH6yaKOcqba9TivienO7vcAm+ilGD2uLOLT08yJDi6mOFxatlz4QJ296453Z1H7OMRAh8y3RvAXUZpeXeecP+hXjvYl4iPcmWG5/2HTndYkqHl0VSMm3l877AkQoS3/hSapLkFX5RrXfzvIXW7S9Ym2jbOLXw17pJ1uw/YIncy9EHo7bm8lnO7D1i409kQ8GIuXxlly1TrTmfxXm7DlsBQtytK9SLhXu6TCkR9tzpndJrmEXfEKkmMaoV88Wifu9UJP42NiF+aI9QIC4Wg7g9qDA0hryKNiMpk+xh3EYjlvxVaxkAo1AIyzkXFjjjGQiHkqRRGiR+hkA5i1Kh4hbII23ohL1ypRs2EgtVnyool2MEUDb6tF49O2FLLoCcU9cdBn6aG2G/hA0rEGC020yMYCKUoE60Zjhg3we+OIl3+AexkIDARimmW+rst5aDE0DXgxIXXCGgmFC87ZS+6ySjO3MCuJyKG9JoBLQjFgUq3Ot8N55wNfUUdSc+uPWhFKJsrur0e50UNa8xIET0mJWNNKIWla0dqldkXNiZIGqGmZcKFUNo60IPab1a6ecKeUZDOQWyEdqF3JJTDoeiHshvva0bICu+En99X0Zlq7oRkLr3BTHm+eOvykJ4Z0pUef9AY216ESJww3auKqV1OsAKOUTKUEsI1+0F/QjmbjSYjxVAt9hnBxigho0QEtFklPAgRVwXNxjgjWQUao4SMkewrOx3jToilerHPNsroVw1Q5mt/Sr4DmtlOQXdCyYS7Mg5wxiB8A+R5uOM3FCEaKEwH3QiMhHTRE1jUdR+QkAyniMuJbvuBGYtZjx3csSl2+BKWkJA18mITuvpKg0ESkn79Inw0Qc4HIxCS4QTzHNJkchlAAfDIeCqtD9cOnDh3oCdh0QQ8X5/lu049yOLTnV2Oul7pSgpCiEhIlNUE2OHU9YUsPtc9rRSeZSlOJjZhYUmpmsKS4/q6YrnBkfnPMVE5ztnRZ4DWIySkhyxWd0qavdwozZjXv3pbv2RUefTBBj1dQ6IRFmNqqzmsoDSffvTfygehZBe4/sd7rqYr+LZd/PEPICTkVR9tQouWZ5PdqN+dp8In03m3P9pNsuvfaIR9+imYUmoSqgwPCbT4o1W22W4Xi8X2vMlW9x+aPjmo1X9BCIv5uLdoqo/Q5LvG/AtIWOjVmUrH1xC2svGkmSUIYSGvx6AdSemx5vQrJRRhIctFIEhKF1Z+QjsJSFjox9ECNSid8JLFSNS7tSQoYSHD9TFn3nH8LD+uvY0XhYQmvEhn9p44D9jiA9NZJ0JrYhBepLfcb0yLeclGk81+GWBhQCUW4VU6Px/TjFLF2n77RTb9+InRdaVEJbzJvD0ezXaT6eCc5XlBlufZeTCd7GajcdvJa+Yn/wMB7h03C7nNRgAAAABJRU5ErkJggg==";

var SHOPPING_CART_512 =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAMAAADDpiTIAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAA/cAAAP3AFfAHc3AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAwBQTFRF////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACyO34QAAAP90Uk5TAAECAwQFBgcICQoLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIjJCUmJygpKissLS4vMDEyMzQ1Njc4OTo7PD0+P0BBQkNERUZHSElKS0xNTk9QUVJTVFVWV1hZWltcXV5fYGFiY2RlZmdoaWprbG1ub3BxcnN0dXZ3eHl6e3x9fn+AgYKDhIWGh4iJiouMjY6PkJGSk5SVlpeYmZqbnJ2en6ChoqOkpaanqKmqq6ytrq+wsbKztLW2t7i5uru8vb6/wMHCw8TFxsfIycrLzM3Oz9DR0tPU1dbX2Nna29zd3t/g4eLj5OXm5+jp6uvs7e7v8PHy8/T19vf4+fr7/P3+6wjZNQAAGpJJREFUGBntwQmgTIX+B/Dv3MXFvXEpS2QLCUkLoZKUUEqprImyl5KQvGRLlpJQSZRXKZSdFMpTWhCeLWQpW7Lv+11mvv/e0vtXnPM7M3POzJwzv88HUEoppZRSSimllFJKKaWUUkop5XGFO72zaPuedYveaXYJVLzxtfjGz9/5l7RPg4onNZfzz06+XQ0qXvhe4AWs65IPKh7knsoLO/vhrVCelzCXxrY8WwjK216kqczpdyZAedddAUp29S8O5VEJG2mB/7P7k6G8qBUt2vdSWSjv2ULrvnwoJ5S3lGNQjoyqBOUlTzJYy9qlQXnGLAbv5LgboDxiDUOy9sl8UF6wmyE6+0EtKPc7y9Bt7lkQyuUOMRyZ0+onQLnZCoZpZ79iUO41hWHzf9ooCcqlutMOe4eWgXKlUrRHYFGLFCgXWkW7HB51FZTrPEobLW2bCuUuCWtopxPjqkK5yu202Zon0qFcZBDtdmbCLVCu4ZtB+21+piCUS6TOogMyp9ZLgHIF3/N+OmFH38ugXOGW7+mI7Ln3JUG5wb2r6Iy9PXNCuUHVcSfoiJ0tfVBukNZ2GR2xoiiUO1w16jAdsL0MlEuktFgUoO32VoJyjTJD9tJuBy6Gco+kRp/6aa93oVylWN8dtFUtKHdJqDctk/b5MQHKbQo+s5m2qQnlQrd8cIb2GAnlSulPrKEddkG5VdWxJxi+66FcK7XNUobrMSg3u2rkYYblLSh3S2m+KMDQLYVyvdJD9jJUp3xQ7pd039xshqYslCdc1ncHQ/EglEck1JuayaANhPKOAj02MUhzoDyl5oQzDMZOKI9J77yaQUiH8pwqY0/QqlpQHpTaZgmt6QLlTRVHHKIF46G8KqXZPwKUrITysNKTKTibCOVhN1FSAcrD8gQoaA7lZT9TMBTKy2ZQMA/Ky/pRsAfKy+6jpACUh5WipA6Uh/mOU9Adysu+oWAClJe9QcFaKC9rT0FmDigPu4GSylAelttPQSuELP3eIW9P+2Le1PdGv9yvx2OtHqhf87pyl+XLARVDNlEwHKFJav19Ni8o6+juzau+mT99wphXBvTs/Ejju2pdf2Wx/ClQ0fAxBQsRCl+HHQxS9vE9W9d89/nMD8e+OvDZJx5t0uDWqhVKXJILylHPUXAQIcg3h3bxn9z387qlC2dNHDfixb91advsntuqXVWqYKoPyhYNKCmCoJXfTqcFTu3f9sOyf8yZ/M6owb27tm9xb53qlS4vlJYAFZzLKLkTwSq6i1Fz5uCODcu/nPvx318f+vzTHR66744bK5e5NE8ilJHDFPRCkPL+wJhz7vCuH1d+9emUd994qW/3Tg/fX+/ma68omp4MhUUUTEaQxtE1Mo78sumfX8+b9v6bw/o/83jrB++seV25y/LlQDwZQcFGBKdqgG6XdezXLau/XTDjg7eGD+jZ+ZHGd9WqUr74xTnhSY9QkJ0LQVlGr8o+sfentd99PvPDsa8O7PVkm6Z3176hYskCueBu11JSBcG4hvEmcHLfz+uWLpw96e2Rg557ql3zhrdVu6pUwVQf3CEli4K2CMYwqn8LnD6wff33iz75aPxrg3t3bd/i3jo1ri5d+KIExJofKHgNwdhNZersoZ0bl3859+O/vz60T7eOLRvVvemaskXyJCFqPqRgMYJQgCok5w7v+nHl4s+mvjf65X49Hmt1f72br72iaHoinPcMBccQhBupbJS5ccagW+CsupSUgHWtqOy24cm8cFAhShrCuk5U9jvQEA7aR0EfWNecygljU+GYBRRMh3UNqByx6iI45WUKfoJ1lamcMT8JDnmIgkAaLPMdonLG3+GQqyi5EdZNo3JIIzgj6RwFj8G61lQO2ZQEZ6yi4C1Yl7yTyiEd4Yx3KViKIDxG5ZCdcEZXCk75YF3KD1QOKQ9H1KakLIJQ7gSVM56EI/JT8iCC0SRA5YjZcMYvFAxEUFpkUjlhPZwxl4I5CE7dk1QO+BnOGETBTgSp2DQq++2BM5pQko5g3fGFn8pmB+GMcpTUQvCK9PhkUwaVjZbAGQmnKeiC0CReWvaam+o2atmxW5+hb7w75dOvVmzceegsVWjegEO+p2A87JRwUeHSV9eoc2+L9l17Dx71zuQ5/1j2w7b9pwJU5trCIeMoWIkI8OUuULLiDbXvbtrmyV4vjhg3cdYXS9b+tPdENtV/VYRDOlNwNhHRk/Pi4uWr1Lqr8SOdew54ZcyE6fO/WbV599FMxp2tcMrNlFRAzElOL3rFtTfXu//hTj36vTz6vamfLV75467D5+hdL8EpeQIUNIdbJOa5tEzlG++476EOTz8/5LXxH32y6Pv12w+cpgdUg2O2UTAULudLLVjqqmq33dOs3VPPDRr59qTZC5eu+3nfST/dY7cPjplJwTx4VK5LSlSoemuDJo8+8ewLw9/6YMaCb1dv+fVYFmPQ63BOfwr2IL7kyHdZuetq3vlg68ef6T/szfenzfv6n5t+OZLBaKoN5zSipAAUkJS3SNlrbqrbqGXHbn2Gvv73j+d+uXzDjoNnGAkHE+GcyympA2UoIa3Q5ZVq1Lm3RfuuvQePemfynH8s+2Hb/lMB2mk8HOQ7QUF3qGD5chcoWfGG2nc3bfNkr4Gvjv1w5uffrdm653g2Q9IATvqWgglQdknJX6x8lVp3NX6kc88Br4yZMH3+N6uOU3I8BU4aTcFaKAdtoGQSHNWBgswcUI4pR9GDcFQ1SipDOeZvlJxNhaNy+yloBeWYFZTMgsM2UzAcyinFKWoFh02hYCGUU7pSkpUPDutNwUEop3xNyedw2t2UFIFyRkE/JZ3gtGKU3AnljA6U+AvDcYcp6AXljPmUfAvnfUnBZChHpGdS0g3OG0nBRihHtKSoJJz3KAXZuaCcMIOSVYiA6yipAuWA3Kcp6Y0ISMmioC2UA+6nqDwiYT0Fr0E54ENKfkRETKRgMZT9chyjZBAioicFx6DsV5+i6xER9SgpAWW7cZTsQGQUpqQhlN0S9lMyAhGyn4I+UHa7haKaiJDPKZgGZbeRlOxLQIQMo2ArlN12UjIWkdKSgkAalL2qUFQPkVKJkhpQ9hpMydFkREpSBgWPQdlrEyUfIHJWU/AWlK0qUnQfIuddCpZC2aoPJadzIXK6UnDKB2Wn1ZRMQwTVpqQslI1KUdQCEXQxJQ9C2ag7JRl5EUm/UDAQykbfUfIZImouBXOg7HNpgJJ2iKhBFOyEss9jlGQXQEQ1oSQdyjZfUPIVIqscJbWg7JI/i5IuiKyEMxR0gbJLa4qKIcK+p2A8lF1mU7IckTaOgpVQNkk7S0kvRFpnCs4mQtmjMUVXINJupqQClD0mU/IDIi4PJc2hbJFygpIBiLxtFAyFskUDiioj8mZSMA/KFuMp+RlR0J+CPVB2SDxEyTBEQSNKCkDZoDZFNRAFl1NSB8oGr1Pyqw9R4DtBQXeo8Pl2UzIaUfEtBROgwledotsRFaMpWAsVvpcpOZyEqOhAQWYOqLBtpeRdREc1SipDhetqiu5BdKT6KWgFFa7+lJxMQZRspmA4VLjWUfIRomUKBQuhwlSGoiaIlt4UHIQKU09KzqUhWu6mpAhUeJZRMgdRU4ySO6HCUjRAySOIniMU9IIKyxOUZOVH9HxJwWSosCyiZCGiaCQFG6HCcUk2JY8jih6lIDsXVBjaUBIogii6jpIqUGGYS8kSRFNKFgVtoUJ30TlKeiCq1lPwGlTomlF0OaJqIgWLoUI3hZI1iK6eFByDClnOU5T0RXTVo6QEVKgaUlQR0VWYkoZQoXqPks2Itv0U9IEKUdIRSoYg2j6nYBpUiO6gqCqibRgFW6FCNIaSXYi6lhQE0qBC4ttLyShEXSVKakCF5CaKaiHqkjMo6AQVkuGUHEhE9K2mYAxUSLZR8jZiwHsULIEKxbUU3YkY8DQFp3xQIRhIybEciAG3UVIWKgQbKJmIWHAxJQ9CBa8cRQ8gJuymYCBU8P5GyZnciAmfUjAHKngrKJmB2DCYgp1QQStOUUvEhqaUpEMF6ylKMtMRG66kpBZUsBZTMh8xIvEMBV2gglTQT0kHxIrlFIyHClJ7SvyFECvepmAlVJDmUfI1YsYTFJxNhApK3kxKuiJm1KSkAlRQHqKoBGJGXkqaQwVlOiUrEUO2UzAUKhi5T1PyHGLILArmQQWjEUVXIoYMoGAPVDA+pGQjYsn9lBSAsi75GCUDEUtKU1IHyrr6FF2LWOI7QUF3KOvGUbIdseU7CiZAWZawn5LhiC1vUrAWyrJbKLoJsaUjBZk5oKwaScneBMSW6pRUhrJqJyVjEGNS/RS0grKoCkV3INZsoWA4lEWDKTmShFgzlYKFUBZtouR9xJznKTgIZU0Fiu5FzLmHkiJQljxPyamciDnFKbkTypJVlExFDDpCQS8oK0pR1Awx6CsKJkNZ0Y2ScxchBo2iYCOUFd9SMhexqA0F2bmgZIX9lLRBLLqekipQsk6UZF+CWJQzi4K2ULLPKVmE2LSBgtegRPmyKHkCsWkSBYuhRK0oCRRFbHqWgmNQotmULEOMqk9JCShB6llKeiJGXUpJQyhBY4rKIFbtp6APlGAyJesQsz6nYBqUuZQTlPRHzBpGwVYocw0ouhoxqyUFgTQoU+Mp2YrYVYmSGlBmEg9S8hJiV3IGBZ2gzNSmqBpi2GoKxkCZeZ2S3T7EsPcoWAJlwrebktcRy56m4JQPylg1imojlt1GSRkoYy9RcjARsewSSh6AMraVkvGIbbspGAhlqBJFDRDbPqVgDpShfpScSEFsG0zBTihDaymZjBjXlJJ0KAOlKWqMGHclJbWgDDxDydlUxLjEMxR0gTKwlJJZiHnLKRgPdWFFA5S0Qsx7m4KVUBfWmZKsfIh5T1BwNhHqghZR8jliX01KKkBdyMXZlHRC7MtLSXOoC2lDib8wXGA7BUOhLmQuJd/CDWZRMA/qAi46R0k3uMEACvZAXUAzikrCDe6npADU+aZQsgquUJqSOlDnyXmSkufhCr6TFHSHOk9DiirAHb6jYALUed6jZBNc4k0K1kL9VdJhSgbBJTpSkJkD6i/qUHQ9XKI6JZWh/uJNSnbCLVL9FLSC+jPfHkpGwDW2UDAc6s9upKgmXGMqBQuh/uwVSvYnwDWep+Ag1J9to2Qs3OMeSopA/dE1FNWDexSn5E6oP3qBkqPJcJGjFPSC+qP1lHwAN/mKgslQf3AFRY3gJqMo2Aj1B70oOZ0LbtKGguycUP9vBSXT4SrXU1IF6n+KUfQQXCVnNgVtof7nKUoy8sJdNlDwGtT/LKbkM7jMJAoWQ/2uoJ+SdnCZZyk4CvW79pRkF4DL1KekBNR/zaPkK7jNpZQ0hPqPvBmUdIHrHKCgD9R/PERRMbjOFxRMg/qP6ZQsh/u8QsFWqH/LdZqSXnCfhykIpEH9SyOKroD7XE1JDah/+YCS9XCh5AwKOkH9JvkoJS/AjdZQMAbqN/UougZu9D4FS6B+M5aSn+FK3Sg46YNCwn5KhsGVbqekDBRqUlQDrnQJJQ9AYQQle3xwp18peAEKOykZDZf6jILZUNdTdDtcaggFO6AGUXI4CS7VjJIX+se9nZS8C7cqT2WDe+BWiWeownYyJ1xrBVXYPoZ7vUMVtqZwryepwnUuDe51C1W4PoGL5aUK1yNwsx1U4cm6GG42myo8C+FqL1CF53G42gNUYQkUgauVoQrLErib7yRVOHrA5ZZQheNyuNwYqjCsgdt1ogpDX7hdDaowXAW3SwtQhWwL3G8LVciGwv3GU4WsKtyvCVWodvngfvmzqEL0LLzgParQHEiFF5QPUIXkGXjDG1Sh2J8Kb0haQBWCx+AVedZTBa0/vKPEPqog9YeXVN1FFZT+8JZcfU9TWba5KTznsg8DVJbsaJMIL6r66noqwZnVkzvmgGddfHWdJs3+YzdNDGwWn+qX9CFOlKaJIzmgPK4vTYyF8rotNFETyuNuoIntPiiPe40mXoTyuKQDNHEllMc1oImVUF43mSa6QnncRWdoLLsQlMe1pon5UF73BU08BOVxRfw0dioVyuO608QHUF63mibqQXlcRZrYmwjlcUNoYgSUx/l20cT1UB53K01shPK6d2jiOSiPSzlGY4ESUB73IE18DeV1s2iiA5TH5c+gsXP5oDyuE01Mh/K6b2miEZTHlaKJIzmgPO55mhgL5XWbaKImlMdVoYntPiiPG0UTg6A8Lmk/TZSH8rg7aWIllNdNpImuUB6XdprGsgtBedzDNDEfyusW0ERLKI8rnE1jp1KhPO5pmvgAyuv+SRP1oDyuAk3sTYTyuME08fNb6jfDezQvDo/y7aCyYmW3XPCiW6gs+rUdPGgclWWTcsJrUo5SWbc0FR5zP1UwpvngLTOogvIMPCVfBlVQThaCl3SgCtKb8JJFVEE6ngPekeMsVbDqwjtqUAXtJXjH01RBmwTv6E0VtK/gHc9SBe07eEc3qqBNhXfcRRW0UfCOtCyqYDWFh3xHFaTMPPCQdlRBmg0vSdpMFZTsq+ApTamCMhYeM54qCGtS4TGJn1BZtq8EPCf3TCqL1pWEFz18lMqC7HfS4E2XDtxFJTg7pQK8K+GO3m99unTZ/9tEu6xaFjEHaJNTy/7sy49GNk5DPElYRLuMQqSUOkab+Osgzg2gfRohMnIsp232X4q4druf9jlaEhExkjb6KhFxrNA+2un7ZETAfbTVi4hfCQtprxFwXsmjtFWgLuJWX9rtXjgt+Xva7EARxKlb/bTbkeJw2HDa7usExCXfD7Tfh3BWuWzaryXiUhM6wF8OjvqQDticiDiUsIFOmAgnXemnEx5GHGpOq479uGTraVrkvxIOmkiL/PtWL/8lixZtSUTcSdhEC45Nblo6N/4lT/mO8zJowSQ450o/Ldg2onbRJPzGV/CGfqtpRSvEnZaUTaubjD/K0/R7ivzl4ZhJFJ1+uTL+pES3vRRtTUScSdxCyTfVcR5fk58omQynlPdTkP1OEZwnte9JSlojzjxMwYH7cEHJ3TNpzn8lHDKJgmUVcUEFJ1KwNQHxZR7NrSsJI7ccpLn+cEauMzQ3IQVGevhprhriSq6zNDUrDcZK/UBTK+CMBjTl7wkTDY7T1ADElQY0NdEHMxetpZlAIThiNE21hqnrTtPMCsSV0TSzPCfMFd9HM4/AETtoZggEDwRoIlAQ8WQ7TfxaBJIa52hiKpxQkWZm+iDpRzOtEUfK00TgRsg60cTxZDigJ038nAqRbx5NfIw40p0mJsOCxPU0URsOWEwTTWFBhWwaO5qI+LGQxjJKwYoGNPEK7JeeRWPLfbDibZq4GXEjKYPGRsCaL2lsFezXkCZqwZIip2msL+JGERoLFIU1DWjsAOz3OI2tgEXjaGwc4sZ1NLYcFuU8RUOBJNjuBRrrA4vuorE5iBt30VhvWDWTxorAduNorDIsSjlJQ8sRN9rSWEVY1YbGroftPqGhnbBsKg39grjRm4YOwrLLaawBbLeChibAss40lOlDvHidhtbAspQADbWF7X6hoUGw7D4auxjxYioNfQbrDtBQb9jNl0lDj8OyG2isIuLFtzQ0HtatpqHXYbdLaOxeWFaMxm5HvNhCQ4Nh3TwamgK7VaCxarAsB421QLzYQEOjYd0SGpoIu5WlsbqwrACNNUa8WEZDM2DdLhp6C3YrTGNtYNnVNFYf8eILGloGyxKyaGgY7JZKY31gWX0auwnxYiYN7YRlhWmsH+zm89PQW7DsURqrjHjxPg35C8Cqu2jsadjuOA0th2Wv0VgpxIt+NNYGVo2hsftguzU0FLgUVu2koawkxItmNDYbVu2msSthu49orD0supbGNiFuXEtjZ3LDmutoLCsZthtAY3Ng0QAam424kRqgsXaw5g0a2wz7Naexc5fBkhzbaOwlxI9tNPZrblhRJpPGZsB+V9PEu7DkKZpohfgxmiZ6w4qpNNEe9vPtpjF/JViQ9xCN+QshftxBE8cLQFadJvyF4IDRNDEPFgyhie8QR5KP0cSCREjy/0QTS+CEujTTBaLbsmiiJ+LJJJoZCUHylzTTE05IPkYT2fUhKH2YZq5APGlKU+1gbhxNlYMjJtPMsfIwlWcDzfyIuJIng2Yy28BE4iia+hHOaEpTv1wLEwWX0NQQxJf5NPdqIoykL6C5IXBGngyaOv0gDF2zk+aqI750omBeflxY+U0UVIdD5tNcoF8iLqzxKZrb40N8KeKn4EiPFJyvwGuZFOzxwSEdKdlwNy7gms8pGYN48x5FO1om48/y9D5OUVc4JfevFH11I/7i8gl+SrLKIt4UP0fZsUlN8+B3hTvOy6BsWw44ph0t2D6iViJ+V7nfKlrwJuLPMFqS8cOC94b0HDZx0eYALWkO5yRuoCVHVsx+q99zr09fsoeWnCqE+JPvKJ2w0gcH3UNHDEA86kkn3AZHfU0H7E9DPMr5C+33GZxVjQ54AvHpUdrOXwkOm0rb/ZSM+JSwnnZ7F04rm0m7NUW8uimD9tpdGI57njb7xIe41Ya2OlMFEfAxbbXhIsSxEbRTM0RC7n/SRocuRzxLXED7vIjIuGwvbZNVG/EtfTPtMtOHCKl+jnZ5DPHuiqO0x7o0REwr2uRNqLrZtMOBkoigYbTFoiQodMhm+I7dhEhK+Ig2WJMf6jf1jzJcm8shsnwDAgzXtFSofyu3meFZkI6Ia3yaYQn080H9V/o8hmNkIqLg2l0Mw6kHoP5f4nCGLKMtoqPQdwzZjspQf9L6HENz4GZES8q7DNHXBaD+ovp6hmJhCURR56MMQeYryVDnSWizm8FaWx/Rlf/VDAbr49JQF5Trb8cYjF2tExB1JScGGIzFN0AZumRkBq062jMnYsJ1C2nZhnugTF0+OUArzg3Pj5hRbw0t2dM+EUpSuvs3fpo7O7ddQcSShJtf2UrBgfENc0JZUrDtJ2dp5MiEB1IRgyr2Xh6gka2v3JwAFYTU+ycc4vm2j6qdhJhV9LEF53ge//LeFaFCULhWh+EzF634cfehXRuWfTFlcKtq6Yh1iaUbdBv76dert+47sG3tt/Pef+6BiilQSimllFJKKaWUUkoppZRSSimlbPd/98qv62HdWCAAAAAASUVORK5CYII=";

var queryString = {};

var strictUriEncode = (str) =>
  encodeURIComponent(str).replace(
    /[!'()*]/g,
    (x) =>
      `%${x
        .charCodeAt(0)
        .toString(16)
        .toUpperCase()}`
  );

var token = "%[a-f0-9]{2}";
var singleMatcher = new RegExp(token, "gi");
var multiMatcher = new RegExp("(" + token + ")+", "gi");

function decodeComponents(components, split) {
  try {
    // Try to decode the entire string first
    return decodeURIComponent(components.join(""));
  } catch (err) {
    // Do nothing
  }

  if (components.length === 1) {
    return components;
  }

  split = split || 1;

  // Split the array in 2 parts
  var left = components.slice(0, split);
  var right = components.slice(split);

  return Array.prototype.concat.call(
    [],
    decodeComponents(left),
    decodeComponents(right)
  );
}

function decode(input) {
  try {
    return decodeURIComponent(input);
  } catch (err) {
    var tokens = input.match(singleMatcher);

    for (var i = 1; i < tokens.length; i++) {
      input = decodeComponents(tokens, i).join("");

      tokens = input.match(singleMatcher);
    }

    return input;
  }
}

function customDecodeURIComponent(input) {
  // Keep track of all the replacements and prefill the map with the `BOM`
  var replaceMap = {
    "%FE%FF": "\uFFFD\uFFFD",
    "%FF%FE": "\uFFFD\uFFFD"
  };

  var match = multiMatcher.exec(input);
  while (match) {
    try {
      // Decode as big chunks as possible
      replaceMap[match[0]] = decodeURIComponent(match[0]);
    } catch (err) {
      var result = decode(match[0]);

      if (result !== match[0]) {
        replaceMap[match[0]] = result;
      }
    }

    match = multiMatcher.exec(input);
  }

  // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
  replaceMap["%C2"] = "\uFFFD";

  var entries = Object.keys(replaceMap);

  for (var i = 0; i < entries.length; i++) {
    // Replace all decoded components
    var key = entries[i];
    input = input.replace(new RegExp(key, "g"), replaceMap[key]);
  }

  return input;
}

var decodeUriComponent = function(encodedURI) {
  if (typeof encodedURI !== "string") {
    throw new TypeError(
      "Expected `encodedURI` to be of type `string`, got `" +
        typeof encodedURI +
        "`"
    );
  }

  try {
    encodedURI = encodedURI.replace(/\+/g, " ");

    // Try the built in decoder first
    return decodeURIComponent(encodedURI);
  } catch (err) {
    // Fallback to a more advanced decoder
    return customDecodeURIComponent(encodedURI);
  }
};

var splitOnFirst = (string, separator) => {
  if (!(typeof string === "string" && typeof separator === "string")) {
    throw new TypeError("Expected the arguments to be of type `string`");
  }

  if (separator === "") {
    return [string];
  }

  const separatorIndex = string.indexOf(separator);

  if (separatorIndex === -1) {
    return [string];
  }

  return [
    string.slice(0, separatorIndex),
    string.slice(separatorIndex + separator.length)
  ];
};

var filterObj = function(obj, predicate) {
  var ret = {};
  var keys = Object.keys(obj);
  var isArr = Array.isArray(predicate);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var val = obj[key];

    if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
      ret[key] = val;
    }
  }

  return ret;
};

(function(exports) {
  const strictUriEncode$1 = strictUriEncode;
  const decodeComponent = decodeUriComponent;
  const splitOnFirst$1 = splitOnFirst;
  const filterObject = filterObj;

  const isNullOrUndefined = (value) => value === null || value === undefined;

  const encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");

  function encoderForArrayFormat(options) {
    switch (options.arrayFormat) {
      case "index":
        return (key) => (result, value) => {
          const index = result.length;

          if (
            value === undefined ||
            (options.skipNull && value === null) ||
            (options.skipEmptyString && value === "")
          ) {
            return result;
          }

          if (value === null) {
            return [
              ...result,
              [encode(key, options), "[", index, "]"].join("")
            ];
          }

          return [
            ...result,
            [
              encode(key, options),
              "[",
              encode(index, options),
              "]=",
              encode(value, options)
            ].join("")
          ];
        };

      case "bracket":
        return (key) => (result, value) => {
          if (
            value === undefined ||
            (options.skipNull && value === null) ||
            (options.skipEmptyString && value === "")
          ) {
            return result;
          }

          if (value === null) {
            return [...result, [encode(key, options), "[]"].join("")];
          }

          return [
            ...result,
            [encode(key, options), "[]=", encode(value, options)].join("")
          ];
        };

      case "comma":
      case "separator":
      case "bracket-separator": {
        const keyValueSep =
          options.arrayFormat === "bracket-separator" ? "[]=" : "=";

        return (key) => (result, value) => {
          if (
            value === undefined ||
            (options.skipNull && value === null) ||
            (options.skipEmptyString && value === "")
          ) {
            return result;
          }

          // Translate null to an empty string so that it doesn't serialize as 'null'
          value = value === null ? "" : value;

          if (result.length === 0) {
            return [
              [encode(key, options), keyValueSep, encode(value, options)].join(
                ""
              )
            ];
          }

          return [
            [result, encode(value, options)].join(options.arrayFormatSeparator)
          ];
        };
      }

      default:
        return (key) => (result, value) => {
          if (
            value === undefined ||
            (options.skipNull && value === null) ||
            (options.skipEmptyString && value === "")
          ) {
            return result;
          }

          if (value === null) {
            return [...result, encode(key, options)];
          }

          return [
            ...result,
            [encode(key, options), "=", encode(value, options)].join("")
          ];
        };
    }
  }

  function parserForArrayFormat(options) {
    let result;

    switch (options.arrayFormat) {
      case "index":
        return (key, value, accumulator) => {
          result = /\[(\d*)\]$/.exec(key);

          key = key.replace(/\[\d*\]$/, "");

          if (!result) {
            accumulator[key] = value;
            return;
          }

          if (accumulator[key] === undefined) {
            accumulator[key] = {};
          }

          accumulator[key][result[1]] = value;
        };

      case "bracket":
        return (key, value, accumulator) => {
          result = /(\[\])$/.exec(key);
          key = key.replace(/\[\]$/, "");

          if (!result) {
            accumulator[key] = value;
            return;
          }

          if (accumulator[key] === undefined) {
            accumulator[key] = [value];
            return;
          }

          accumulator[key] = [].concat(accumulator[key], value);
        };

      case "comma":
      case "separator":
        return (key, value, accumulator) => {
          const isArray =
            typeof value === "string" &&
            value.includes(options.arrayFormatSeparator);
          const isEncodedArray =
            typeof value === "string" &&
            !isArray &&
            decode(value, options).includes(options.arrayFormatSeparator);
          value = isEncodedArray ? decode(value, options) : value;
          const newValue =
            isArray || isEncodedArray
              ? value
                  .split(options.arrayFormatSeparator)
                  .map((item) => decode(item, options))
              : value === null
              ? value
              : decode(value, options);
          accumulator[key] = newValue;
        };

      case "bracket-separator":
        return (key, value, accumulator) => {
          const isArray = /(\[\])$/.test(key);
          key = key.replace(/\[\]$/, "");

          if (!isArray) {
            accumulator[key] = value ? decode(value, options) : value;
            return;
          }

          const arrayValue =
            value === null
              ? []
              : value
                  .split(options.arrayFormatSeparator)
                  .map((item) => decode(item, options));

          if (accumulator[key] === undefined) {
            accumulator[key] = arrayValue;
            return;
          }

          accumulator[key] = [].concat(accumulator[key], arrayValue);
        };

      default:
        return (key, value, accumulator) => {
          if (accumulator[key] === undefined) {
            accumulator[key] = value;
            return;
          }

          accumulator[key] = [].concat(accumulator[key], value);
        };
    }
  }

  function validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) {
      throw new TypeError(
        "arrayFormatSeparator must be single character string"
      );
    }
  }

  function encode(value, options) {
    if (options.encode) {
      return options.strict
        ? strictUriEncode$1(value)
        : encodeURIComponent(value);
    }

    return value;
  }

  function decode(value, options) {
    if (options.decode) {
      return decodeComponent(value);
    }

    return value;
  }

  function keysSorter(input) {
    if (Array.isArray(input)) {
      return input.sort();
    }

    if (typeof input === "object") {
      return keysSorter(Object.keys(input))
        .sort((a, b) => Number(a) - Number(b))
        .map((key) => input[key]);
    }

    return input;
  }

  function removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) {
      input = input.slice(0, hashStart);
    }

    return input;
  }

  function getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) {
      hash = url.slice(hashStart);
    }

    return hash;
  }

  function extract(input) {
    input = removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) {
      return "";
    }

    return input.slice(queryStart + 1);
  }

  function parseValue(value, options) {
    if (
      options.parseNumbers &&
      !Number.isNaN(Number(value)) &&
      typeof value === "string" && value.trim() !== ""
    ) {
      value = Number(value);
    } else if (
      options.parseBooleans &&
      value !== null &&
      (value.toLowerCase() === "true" || value.toLowerCase() === "false")
    ) {
      value = value.toLowerCase() === "true";
    }

    return value;
  }

  function parse(query, options) {
    options = Object.assign(
      {
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
      },
      options
    );

    validateArrayFormatSeparator(options.arrayFormatSeparator);

    const formatter = parserForArrayFormat(options);

    // Create an object with no prototype
    const ret = Object.create(null);

    if (typeof query !== "string") {
      return ret;
    }

    query = query.trim().replace(/^[?#&]/, "");

    if (!query) {
      return ret;
    }

    for (const param of query.split("&")) {
      if (param === "") {
        continue;
      }

      let [key, value] = splitOnFirst$1(
        options.decode ? param.replace(/\+/g, " ") : param,
        "="
      );

      // Missing `=` should be `null`:
      // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
      value =
        value === undefined
          ? null
          : ["comma", "separator", "bracket-separator"].includes(
              options.arrayFormat
            )
          ? value
          : decode(value, options);
      formatter(decode(key, options), value, ret);
    }

    for (const key of Object.keys(ret)) {
      const value = ret[key];
      if (typeof value === "object" && value !== null) {
        for (const k of Object.keys(value)) {
          value[k] = parseValue(value[k], options);
        }
      } else {
        ret[key] = parseValue(value, options);
      }
    }

    if (options.sort === false) {
      return ret;
    }

    return (options.sort === true
      ? Object.keys(ret).sort()
      : Object.keys(ret).sort(options.sort)
    ).reduce((result, key) => {
      const value = ret[key];
      if (
        Boolean(value) &&
        typeof value === "object" &&
        !Array.isArray(value)
      ) {
        // Sort object keys, not values
        result[key] = keysSorter(value);
      } else {
        result[key] = value;
      }

      return result;
    }, Object.create(null));
  }

  exports.extract = extract;
  exports.parse = parse;

  exports.stringify = (object, options) => {
    if (!object) {
      return "";
    }

    options = Object.assign(
      {
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
      },
      options
    );

    validateArrayFormatSeparator(options.arrayFormatSeparator);

    const shouldFilter = (key) =>
      (options.skipNull && isNullOrUndefined(object[key])) ||
      (options.skipEmptyString && object[key] === "");

    const formatter = encoderForArrayFormat(options);

    const objectCopy = {};

    for (const key of Object.keys(object)) {
      if (!shouldFilter(key)) {
        objectCopy[key] = object[key];
      }
    }

    const keys = Object.keys(objectCopy);

    if (options.sort !== false) {
      keys.sort(options.sort);
    }

    return keys
      .map((key) => {
        const value = object[key];

        if (value === undefined) {
          return "";
        }

        if (value === null) {
          return encode(key, options);
        }

        if (Array.isArray(value)) {
          if (
            value.length === 0 &&
            options.arrayFormat === "bracket-separator"
          ) {
            return encode(key, options) + "[]";
          }

          return value.reduce(formatter(key), []).join("&");
        }

        return encode(key, options) + "=" + encode(value, options);
      })
      .filter((x) => x.length > 0)
      .join("&");
  };

  exports.parseUrl = (url, options) => {
    options = Object.assign(
      {
        decode: true
      },
      options
    );

    const [url_, hash] = splitOnFirst$1(url, "#");

    return Object.assign(
      {
        url: url_.split("?")[0] || "",
        query: parse(extract(url), options)
      },
      options && options.parseFragmentIdentifier && hash
        ? { fragmentIdentifier: decode(hash, options) }
        : {}
    );
  };

  exports.stringifyUrl = (object, options) => {
    options = Object.assign(
      {
        encode: true,
        strict: true,
        [encodeFragmentIdentifier]: true
      },
      options
    );

    const url = removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = exports.extract(object.url);
    const parsedQueryFromUrl = exports.parse(queryFromUrl, { sort: false });

    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = exports.stringify(query, options);
    if (queryString) {
      queryString = `?${queryString}`;
    }

    let hash = getHash(object.url);
    if (object.fragmentIdentifier) {
      hash = `#${
        options[encodeFragmentIdentifier]
          ? encode(object.fragmentIdentifier, options)
          : object.fragmentIdentifier
      }`;
    }

    return `${url}${queryString}${hash}`;
  };

  exports.pick = (input, filter, options) => {
    options = Object.assign(
      {
        parseFragmentIdentifier: true,
        [encodeFragmentIdentifier]: false
      },
      options
    );

    const { url, query, fragmentIdentifier } = exports.parseUrl(input, options);
    return exports.stringifyUrl(
      {
        url,
        query: filterObject(query, filter),
        fragmentIdentifier
      },
      options
    );
  };

  exports.exclude = (input, filter, options) => {
    const exclusionFilter = Array.isArray(filter)
      ? (key) => !filter.includes(key)
      : (key, value) => !filter(key, value);

    return exports.pick(input, exclusionFilter, options);
  };
})(queryString);

var addCartFailureHandler = function addCartFailureHandler(showpop) {
  return function(err) {
    var _err$response;

    console.log("err");
    console.log(err);
    var alert3 =
      formatMessage === null || formatMessage === void 0
        ? void 0
        : formatMessage({
            id: "alert3"
          });
    var alert4 =
      formatMessage === null || formatMessage === void 0
        ? void 0
        : formatMessage({
            id: "alert4"
          });
    var alert5 =
      formatMessage === null || formatMessage === void 0
        ? void 0
        : formatMessage({
            id: "alert5"
          });
    var alert6 =
      formatMessage === null || formatMessage === void 0
        ? void 0
        : formatMessage({
            id: "alert6"
          });
    var orderconflictnote =
      formatMessage === null || formatMessage === void 0
        ? void 0
        : formatMessage({
            id: "orderconflictnote"
          });
    var orderconflictnote2 =
      formatMessage === null || formatMessage === void 0
        ? void 0
        : formatMessage({
            id: "orderconflictnote2"
          });
    var subscriptionmorethanone1 =
      formatMessage === null || formatMessage === void 0
        ? void 0
        : formatMessage({
            id: "subscriptionmorethanone1"
          });
    var subscriptionmorethanone2 =
      formatMessage === null || formatMessage === void 0
        ? void 0
        : formatMessage({
            id: "subscriptionmorethanone2"
          });
    var subscriptionmorethanone3 =
      formatMessage === null || formatMessage === void 0
        ? void 0
        : formatMessage({
            id: "subscriptionmorethanone3"
          });

    if (err.response && err.response.status === 403) {
      if (err.response.data.has_installment_production_in_shopping_cart) {
        showpop === null || showpop === void 0
          ? void 0
          : showpop(alert3, alert4, orderconflictnote, orderconflictnote2);
      } else {
        showpop === null || showpop === void 0
          ? void 0
          : showpop(alert5, alert6, orderconflictnote, orderconflictnote2);
      }
    }

    if (err.response && err.response.status === 400) {
      if (err.response.data.has_installment_production_in_shopping_cart) {
        showpop === null || showpop === void 0
          ? void 0
          : showpop(
              subscriptionmorethanone1,
              subscriptionmorethanone2,
              subscriptionmorethanone3,
              orderconflictnote2
            );
      }
    }

    if (
      (err === null || err === void 0
        ? void 0
        : (_err$response = err.response) === null || _err$response === void 0
        ? void 0
        : _err$response.status) === 401
    ) {
      var _Router$push;

      localStorage.clear();
      (_Router$push = Router.push) === null || _Router$push === void 0
        ? void 0
        : _Router$push.call(Router, "/");
    }
  };
};
var requestAddCart = function requestAddCart(_ref) {
  var getCart = _ref.getCart,
    product_key = _ref.product_key,
    _ref$amount = _ref.amount,
    amount = _ref$amount === void 0 ? 1 : _ref$amount,
    showpop = _ref.showpop;
  initCartKey();
  var data = {
    shopping_cart_key: localStorage.cartKey,
    amount: amount,
    product_key: product_key
  };
  post("api/v1/shopping_carts/add_product_to_shopping_cart", data, 1, 22)
    .then(function() {})
    ["catch"](addCartFailureHandler(showpop))
    ["finally"](function() {
      getCart();
    });
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(
          target,
          key,
          Object.getOwnPropertyDescriptor(source, key)
        );
      });
    }
  }
  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(
      Reflect.construct(Boolean, [], function() {})
    );
    return true;
  } catch (e) {
    return false;
  }
}

var AppModal = /*#__PURE__*/ (function(_React$Component) {
  _inherits(AppModal, _React$Component);

  var _super = _createSuper(AppModal);

  function AppModal() {
    _classCallCheck(this, AppModal);

    return _super.apply(this, arguments);
  }

  _createClass(AppModal, [
    {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          isOpen = _this$props.isOpen,
          children = _this$props.children,
          style = _this$props.style;
        return /*#__PURE__*/ React.createElement(
          CSSTransition,
          {
            in: isOpen,
            timeout: 300,
            classNames: "dialog"
          },
          /*#__PURE__*/ React.createElement(
            Modal,
            {
              closeTimeoutMS: 500,
              isOpen: isOpen,
              style: {
                content: _objectSpread(
                  {
                    width: 500,
                    maxWidth: "100%",
                    padding: 28,
                    borderRadius: 18,
                    inset: "unset"
                  },
                  style ? style : {}
                ),
                overlay: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(0,0,0,0.3)"
                }
              }
            },
            children
          )
        );
      }
    }
  ]);

  return AppModal;
})(React.Component);

var ErrorModal = function ErrorModal(props) {
  var note1 = props.note1,
    note2 = props.note2,
    note3 = props.note3,
    note4 = props.note4,
    isOpen = props.isOpen,
    onCloseButtonClick = props.onCloseButtonClick;
  var modalClose = formatMessage({
    id: "modal.close"
  });
  return /*#__PURE__*/ React.createElement(
    AppModal,
    {
      isOpen: isOpen
    },
    /*#__PURE__*/ React.createElement(
      "div",
      null,
      /*#__PURE__*/ React.createElement("p", null, note1),
      /*#__PURE__*/ React.createElement("p", null, note2),
      /*#__PURE__*/ React.createElement(
        "p",
        {
          className: "note"
        },
        note3,
        note4
      )
    ),
    /*#__PURE__*/ React.createElement(
      "button",
      {
        onClick: function onClick() {
          onCloseButtonClick === null || onCloseButtonClick === void 0
            ? void 0
            : onCloseButtonClick();
        },
        className: "modal-close-btn"
      },
      modalClose
    )
  );
};

var Cart1Mobile = function Cart1Mobile(_ref) {
  var continuePath = _ref.continuePath;

  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    willRemoveItemID = _useState2[0],
    setWillRemoveItemID = _useState2[1];

  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPop = _useState4[0],
    setShowPop = _useState4[1];

  var _useState5 = useState(availableTermDuration[0]),
    _useState6 = _slicedToArray(_useState5, 2),
    termDuration = _useState6[0],
    setTermDuration = _useState6[1];

  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    payByTerm = _useState8[0],
    setPayByTerm = _useState8[1];

  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isLoading = _useState10[0],
    setIsLoading = _useState10[1];

  var _useState11 = useState({
      shopping_cart_items: [],
      total: 0
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    data = _useState12[0],
    setData = _useState12[1];

  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    remainingBal = _useState14[0],
    setRemainingBal = _useState14[1];

  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    grandTotal = _useState16[0],
    setGrandTotal = _useState16[1];

  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    paymentTotal = _useState18[0],
    setPaymentTotal = _useState18[1];

  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showTermDurationDropdown = _useState20[0],
    setShowTermDurationDropdown = _useState20[1];

  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    installmentAmount = _useState22[0],
    setInstallmentAmount = _useState22[1];

  var _useState23 = useState(0),
    _useState24 = _slicedToArray(_useState23, 2),
    shipping_fee = _useState24[0],
    setShipping_fee = _useState24[1];

  var _useState25 = useState(""),
    _useState26 = _slicedToArray(_useState25, 2),
    discount_code = _useState26[0],
    setDiscount_code = _useState26[1];

  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    invalidDiscountCode = _useState28[0],
    setInvalidDiscountCode = _useState28[1];

  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    hasDeposit = _useState30[0],
    setHasDeposit = _useState30[1];

  var _useState31 = useState("/"),
    _useState32 = _slicedToArray(_useState31, 2),
    shoppingPath = _useState32[0],
    setShoppingPath = _useState32[1];

  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    errorPop = _useState34[0],
    setErrorPop = _useState34[1];

  var _useState35 = useState(""),
    _useState36 = _slicedToArray(_useState35, 2),
    errorNote1 = _useState36[0],
    setErrorNote1 = _useState36[1];

  var _useState37 = useState(""),
    _useState38 = _slicedToArray(_useState37, 2),
    errorNote2 = _useState38[0],
    setErrorNote2 = _useState38[1];

  var _useState39 = useState(""),
    _useState40 = _slicedToArray(_useState39, 2),
    errorNote3 = _useState40[0],
    setErrorNote3 = _useState40[1];

  var _useState41 = useState(""),
    _useState42 = _slicedToArray(_useState41, 2),
    errorNote4 = _useState42[0],
    setErrorNote4 = _useState42[1];

  useEffect(
    function() {
      if (continuePath) {
        setShoppingPath(continuePath);
      } else {
        setShoppingPath("/");
      }
    },
    [continuePath]
  ); // this is directly from url by cms

  var _useState43 = useState(""),
    _useState44 = _slicedToArray(_useState43, 2),
    orderRef = _useState44[0],
    setOrderRef = _useState44[1];

  var calInstallmentAmount = function calInstallmentAmount(remBal, total) {
    var instAmt;

    if (remBal == 0) {
      instAmt = (total / localStorage.termduration).toFixed(0);
    } else {
      instAmt = (remBal / localStorage.termduration).toFixed(0);
    }

    setInstallmentAmount(instAmt);
  };

  var generateTotals = function generateTotals(res) {
    setHasDeposit(
      res.shopping_cart_items.some(function(item) {
        return item.product.deposit_amount > 0;
      })
    );
    var tmpTotal = res.total - res.discount_amount;
    var remBal = tmpTotal - res.payment_total;
    tmpTotal = tmpTotal.toFixed(0);
    setRemainingBal(remBal);
    setGrandTotal(tmpTotal);
    setPaymentTotal(res.payment_total);
    setShipping_fee(res.shipping_fee);
    calInstallmentAmount(remBal, tmpTotal);
    setDiscount_code(res.discount_code ? res.discount_code.discount_code : "");
    localStorage.setItem("paymentTotal", res.payment_total);
  };

  var changeProductAmount = function changeProductAmount(data) {
    post("api/v1/shopping_carts/change_product_amount", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var add = function add(item) {
    var data = {
      amount: ++item.amount,
      shopping_cart_item_id: item.id
    };
    changeProductAmount(data);
  };

  var reduce = function reduce(item) {
    if (item.amount > 1) {
      var _data = {
        amount: --item.amount,
        shopping_cart_item_id: item.id
      };
      changeProductAmount(_data);
    }
  };

  var build1 = function build1(item) {
    var data = {
      shopping_cart_item_id: item.id
    };
    post("api/v1/shopping_carts/stk_build_service", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var build2 = function build2(item) {
    var data = {
      shopping_cart_item_id: item.id
    };
    del("api/v1/shopping_carts/cancel_stk_build_service", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var build3 = function build3() {
    var data = {
      shopping_cart_key: localStorage.cartKey
    };
    post(
      "api/v1/shopping_carts/build_yourself_kit_with_installment_service",
      data,
      1
    )
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var hidepop = function hidepop() {
    setShowPop(false);
  };

  var showpop = function showpop(id) {
    setWillRemoveItemID(id);
    setShowPop(true);
  };

  var delcart = function delcart() {
    setShowPop(false);
    var data = {
      shopping_cart_item_id: willRemoveItemID
    };
    del("api/v1/shopping_carts/delete_shopping_cart_item", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var formatReceiveDate = function formatReceiveDate(
    leastDayToShip,
    mostDayToShip
  ) {
    if (leastDayToShip < 0 || mostDayToShip < 0) {
      return null;
    }

    var firstAvailableDate = moment().add(leastDayToShip, "day");
    var lastAvailableDate = moment().add(mostDayToShip, "day");
    var receive_date = formatMessage({
      id: "cart.receive_date"
    });
    var receive_date_1 = formatMessage({
      id: "cart.receive_date_1"
    });

    if (firstAvailableDate.isSame(lastAvailableDate)) {
      return "".concat(receive_date).concat(formatDateStr(firstAvailableDate));
    } else {
      return ""
        .concat(receive_date)
        .concat(formatDateStr(firstAvailableDate))
        .concat(receive_date_1)
        .concat(lastAvailableDate);
    }
  };

  var applyDiscountCode = function applyDiscountCode() {
    setInvalidDiscountCode(false);
    var data = {
      discount_code: discount_code,
      shopping_cart_key: localStorage.cartKey
    };
    post("api/v1/shopping_carts/add_discount_code_to_shopping_cart", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {
        setInvalidDiscountCode(true);
      });
  };

  var removeDiscountCode = function removeDiscountCode() {
    var data = {
      shopping_cart_key: localStorage.cartKey
    };
    del(
      "api/v1/shopping_carts/remove_discount_code_from_shopping_cart",
      data,
      1
    )
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var push = function push(name) {
    localStorage.setItem("cartdata", JSON.stringify(data));

    if (
      [
        requestParam$1.webBaseURL + "/cart2",
        requestParam$1.webBaseURL + "/cart1",
        requestParam$1.webBaseURL + "/login"
      ].includes(name)
    ) {
      localStorage.setItem("historyOrderRef", orderRef);
    }

    window.location.href = name;
  };

  var togglePayByTerm = function togglePayByTerm(e) {
    setPayByTerm(e.target.checked);

    if (localStorage.payByTerm === "false") {
      localStorage.setItem("payByTerm", "true");
    } else if (localStorage.payByTerm === "true") {
      localStorage.setItem("payByTerm", "false");
    }

    if (e.target.checked) {
      calInstallmentAmount(remainingBal, grandTotal);
    }
  };

  var chooseTermDuration = function chooseTermDuration() {
    setShowTermDurationDropdown(!showTermDurationDropdown);
  };

  var selectTermDuration = function selectTermDuration(month) {
    setShowTermDurationDropdown(false);
    setTermDuration(month);
    localStorage.setItem("termduration", month);

    if (payByTerm) {
      calInstallmentAmount(remainingBal, grandTotal);
    }
  };

  var closeTermDuration = function closeTermDuration() {
    setShowTermDurationDropdown(false);
  };

  var setQty = function setQty(item, qty) {
    var data = {
      amount: qty,
      shopping_cart_item_id: item.id
    };
    post("api/v1/shopping_carts/change_product_amount", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var clearShoppingCartAndAddProduct = function clearShoppingCartAndAddProduct(
    data,
    qty,
    email,
    isLoggedInPrevAcct
  ) {
    if (!email && localStorage.user) {
      initCartKey();
      data.shopping_cart_key = localStorage.cartKey;
    } else if (
      (email && isLoggedInPrevAcct) ||
      (!email && !localStorage.user) ||
      (email && !localStorage.user)
    ) {
      data.shopping_cart_key = localStorage.cartKey;
    }

    post(
      "api/v1/shopping_carts/clear_shopping_cart_and_add_product",
      data,
      1,
      22
    )
      .then(function(res) {
        console.log(res);

        if ((email && isLoggedInPrevAcct) || !email) {
          if (email && isLoggedInPrevAcct) {
            localStorage.setItem("cartItemCount", 1);
          }

          if (!email) {
            localStorage.removeItem("user");
            localStorage.removeItem("userheader");
            localStorage.setItem("cartItemCount", 1);
          }

          setIsLoading(false);
          res = res.data.response;
          setData(res);
          generateTotals(res);
          localStorage.setItem(
            "cartItem",
            JSON.stringify(res.shopping_cart_items)
          );

          if (qty && qty > 1) {
            setQty(res.shopping_cart_items[0], qty);
          }
        } else {
          localStorage.removeItem("user");
          localStorage.removeItem("userheader");
          localStorage.setItem("cartItemCount", 1);
          localStorage.setItem("redirectedfromcart", true);
          localStorage.setItem("redirectedfromcartemail", email);
          localStorage.setItem("redirectedfromcartproduct", data.product_key);

          if (qty > 1) {
            localStorage.setItem("redirectedfromcartqty", qty);
          } else {
            localStorage.setItem("redirectedfromcartqty", 1);
          }

          push(requestParam$1.webBaseURL + "/login");
        }
      })
      ["catch"](function(err) {});
  };

  var clearShoppingCartAndAddProduct2 = function clearShoppingCartAndAddProduct2(
    data
  ) {
    post(
      "api/v1/shopping_carts/clear_shopping_cart_and_add_product",
      data,
      1,
      22
    )
      .then(function(res) {
        setIsLoading(false);
        res = res.data.response;
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );

        if (
          localStorage.redirectedfromcartqty &&
          localStorage.redirectedfromcartqty > 1
        ) {
          setQty(
            res.shopping_cart_items[0],
            localStorage.redirectedfromcartqty
          );
        }
      })
      ["catch"](function(err) {});
  };

  useEffect(function() {
    initCartKey();

    if (localStorage.historyOrderRef) {
      setOrderRef(localStorage.historyOrderRef);
      localStorage.setItem("historyOrderRef", "");
    }

    if (!localStorage.payByTerm) {
      localStorage.setItem("payByTerm", "false");
    }

    if (localStorage.getItem("payByTerm") === "true") {
      setPayByTerm(true);
    }

    if (!localStorage.termduration) {
      localStorage.setItem("termduration", availableTermDuration[0]);
    } else {
      var duration = parseInt(localStorage.termduration);

      if (availableTermDuration.includes(duration)) {
        setTermDuration(duration);
      }
    }

    if (localStorage.redirectedfromcart) {
      if (localStorage.redirectedfromcartemail) {
        var _data2 = {
          shopping_cart_key: localStorage.cartKey,
          product_key: localStorage.redirectedfromcartproduct
        };
        clearShoppingCartAndAddProduct2(_data2);
        localStorage.removeItem("redirectedfromcartemail");
      }

      localStorage.removeItem("redirectedfromcart");
      localStorage.removeItem("redirectedfromcartproduct");
    }

    var query = queryString.parse(window.location.search);
    var shoppingCartKey = query.shopping_cart_key;
    var orderID = query.order_id;
    var productKey = query.product_key;
    var qty = query.qty;
    var order_ref = query.order_ref;
    setIsLoading(true);

    if (query.order_id && query.product_key && query.shopping_cart_key) {
      var _data3 = {
        shopping_cart_key: shoppingCartKey,
        product_key: productKey
      };
      var url = "";

      if (order_ref) {
        url = "api/v1/shopping_carts/is_shopping_cart_belong_to_user?order_id="
          .concat(orderID, "&shopping_cart_key=")
          .concat(shoppingCartKey, "&order_ref=")
          .concat(order_ref);
        setOrderRef(orderRef);
      } else {
        url = "api/v1/shopping_carts/is_shopping_cart_belong_to_user?order_id="
          .concat(orderID, "&shopping_cart_key=")
          .concat(shoppingCartKey);
      }

      get(url, 1, 23)
        .then(function(res) {
          console.log("RESPONSE: " + JSON.stringify(res));

          if (res.is_user_equal_order_user && res.is_local_user_present) {
            clearShoppingCartAndAddProduct(_data3, qty, res.email, true);
          } else if (
            (!res.is_user_equal_order_user &&
              !res.is_local_user_present &&
              res.email) ||
            (!res.is_user_equal_order_user &&
              res.is_local_user_present &&
              res.email) ||
            (!res.is_user_equal_order_user &&
              !res.is_local_user_present &&
              !res.email) ||
            (!res.is_user_equal_order_user &&
              res.is_local_user_present &&
              !res.email)
          ) {
            clearShoppingCartAndAddProduct(_data3, qty, res.email, false);
          }
        })
        ["catch"](function(err) {
          push(requestParam$1.webBaseURL + "/cart1");
        });
      return;
    }

    if (query.product_key) {
      if (outOfStockKey[query.product_key]) {
        window.location.href = outOfStockKey[query.product_key].redirectTo;
      }

      var _data4 = {
        shopping_cart_key: localStorage.cartKey,
        product_key: productKey
      };
      post(
        "api/v1/shopping_carts/clear_shopping_cart_and_add_product",
        _data4,
        1,
        22
      )
        .then(function(res) {
          setIsLoading(false);
          localStorage.setItem("cartItemCount", 1);
          res = res.data.response;
          setData(res);
          generateTotals(res);
          localStorage.setItem(
            "cartItem",
            JSON.stringify(res.shopping_cart_items)
          );

          if (qty && qty > 1) {
            setQty(res.shopping_cart_items[0], qty);
          }
        })
        ["catch"](function(err) {
          push(requestParam$1.webBaseURL + "/cart1");
        });
      return;
    }

    if (query.add_product_key) {
      if (outOfStockKey[query.add_product_key]) {
        window.location.href = outOfStockKey[query.add_product_key].redirectTo;
      }

      requestAddCart({
        getCart: function getCart() {
          get(
            "api/v1/shopping_carts/get_shopping_cart?shopping_cart_key=".concat(
              localStorage.cartKey
            ),
            1
          )
            .then(function(res) {
              setData(res);
              generateTotals(res);
              localStorage.setItem(
                "cartItem",
                JSON.stringify(res.shopping_cart_items)
              );
            })
            ["catch"](function(err) {})
            ["finally"](function() {
              setIsLoading(false);
            });
        },
        product_key: query.add_product_key,
        amount: query.qty || 1,
        showpop: function showpop(note1, note2, note3, note4) {
          setErrorPop(true);
          setErrorNote1(note1);
          setErrorNote2(note2);
          setErrorNote3(note3);
          setErrorNote4(note4);
        },
        setIsLoading: setIsLoading
      });
      return;
    }

    get(
      "api/v1/shopping_carts/get_shopping_cart?shopping_cart_key=".concat(
        localStorage.cartKey
      ),
      1
    )
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {})
      ["finally"](function() {
        setIsLoading(false);
      });
  }, []);
  var cart1 = formatMessage({
    id: "cart.cart1"
  });
  formatMessage({
    id: "cart.cart2"
  });
  formatMessage({
    id: "cart.cart3"
  });
  formatMessage({
    id: "cart.cart4"
  });
  var cart5 = formatMessage({
    id: "cart.cart5"
  });
  var cart6 = formatMessage({
    id: "cart.cart6"
  });
  var cart7 = formatMessage({
    id: "cart.cart7"
  });
  var cart8 = formatMessage({
    id: "cart.cart8"
  });
  var cart9 = formatMessage({
    id: "cart.cart9"
  });
  var cart10 = formatMessage({
    id: "cart.cart10"
  });
  var cart11 = formatMessage({
    id: "cart.cart11"
  });
  var cart12 = formatMessage({
    id: "cart.cart12"
  });
  var cart14 = formatMessage({
    id: "cart.cart14"
  });
  var cart46 = formatMessage({
    id: "cart.cart46"
  });
  var cart47 = formatMessage({
    id: "cart.cart47"
  });
  var cart48 = formatMessage({
    id: "cart.cart48"
  });
  var cart64 = formatMessage({
    id: "cart.cart64"
  });
  var cart64tc = formatMessage({
    id: "cart.cart64tc"
  });
  var cart64b = formatMessage({
    id: "cart.cart64b"
  });
  var cart64c = formatMessage({
    id: "cart.cart64c"
  });
  var cart64d = formatMessage({
    id: "cart.cart64d"
  });
  var cartdeposit = formatMessage({
    id: "cart.deposit"
  });
  var cartpaynow = formatMessage({
    id: "cart.paynow"
  });
  var cartbalancedue = formatMessage({
    id: "cart.balancedue"
  });
  var cartdiscountamt = formatMessage({
    id: "cart.discountamt"
  });
  var cartinputdiscount = formatMessage({
    id: "cart.inputdiscount"
  });
  var cartinvaliddiscountcode = formatMessage({
    id: "cart.invaliddiscountcode"
  });
  var cartstarter01 = formatMessage({
    id: "cart.starter01"
  });
  var cartstarter02 = formatMessage({
    id: "cart.starter02"
  });
  var cartstarter03 = formatMessage({
    id: "cart.starter03"
  });
  var cartstarter04 = formatMessage({
    id: "cart.starter04"
  });
  var cartpack1disclaimer1 = formatMessage({
    id: "cart.pack1disclaimer1"
  });
  var cartpack1disclaimer2 = formatMessage({
    id: "cart.pack1disclaimer2"
  });
  var cartpack1disclaimer3 = formatMessage({
    id: "cart.pack1disclaimer3"
  });
  var cartpack1disclaimer4 = formatMessage({
    id: "cart.pack1disclaimer4"
  });
  var cartpack1disclaimer5 = formatMessage({
    id: "cart.pack1disclaimer5"
  });
  var cartpack1disclaimer6 = formatMessage({
    id: "cart.pack1disclaimer6"
  });
  var cartpack1disclaimer7 = formatMessage({
    id: "cart.pack1disclaimer7"
  });
  var cartdepositdisclaimer0 = formatMessage({
    id: "cart.depositdisclaimer0"
  });
  var cartdepositdisclaimer1 = formatMessage({
    id: "cart.depositdisclaimer1"
  });
  var cartdepositdisclaimer2 = formatMessage({
    id: "cart.depositdisclaimer2"
  });
  var cartremoveitemheader = formatMessage({
    id: "cartremoveitemheader"
  });
  var cartremoveitem = formatMessage({
    id: "cartremoveitem"
  });
  var cartremoveconfirm = formatMessage({
    id: "cartremoveconfirm"
  });
  var cartremovecancel = formatMessage({
    id: "cartremovecancel"
  });
  var cartempty1 = formatMessage({
    id: "cart.empty1"
  });
  var cartempty2 = formatMessage({
    id: "cart.empty2"
  });
  var cartempty3 = formatMessage({
    id: "cart.empty3"
  });
  var cartcontinueshopping = formatMessage({
    id: "cart.continueshopping"
  });
  var subsub = formatMessage({
    id: "subscription.sub"
  });
  var cartpaybytermcheckbox = formatMessage({
    id: "cartpaybytermcheckbox"
  });
  var cartmonthlypayments = formatMessage({
    id: "cartmonthlypayments"
  });
  var accessoriessection23 = formatMessage({
    id: "accessoriessection23"
  });
  var accessoriessection24 = formatMessage({
    id: "accessoriessection24"
  });
  var cartBenefitDisclaimer1 = formatMessage({
    id: "cartBenefitDisclaimer1"
  });
  var cartBenefitDisclaimer2 = formatMessage({
    id: "cartBenefitDisclaimer2"
  });
  var cartBenefitDisclaimer3 = formatMessage({
    id: "cartBenefitDisclaimer3"
  });
  var acceleratedDisclaimer1 = formatMessage({
    id: "acceleratedDisclaimer1"
  });
  var acceleratedDisclaimer2 = formatMessage({
    id: "acceleratedDisclaimer2"
  });
  var acceleratedDisclaimer3 = formatMessage({
    id: "acceleratedDisclaimer3"
  });
  var acceleratedDisclaimer4a = formatMessage({
    id: "acceleratedDisclaimer4a"
  });
  var acceleratedDisclaimer4b = formatMessage({
    id: "acceleratedDisclaimer4b"
  });
  var acceleratedDisclaimer4c = formatMessage({
    id: "acceleratedDisclaimer4c"
  });
  var acceleratedDisclaimer5 = formatMessage({
    id: "acceleratedDisclaimer5"
  });
  var r2d2StarterDisclaimer1 = formatMessage({
    id: "r2d2StarterDisclaimer1"
  });
  var r2d2StarterDisclaimer2 = formatMessage({
    id: "r2d2StarterDisclaimer2"
  });
  var r2d2StarterDisclaimer3 = formatMessage({
    id: "r2d2StarterDisclaimer3"
  });
  var r2d2StarterDisclaimer4a = formatMessage({
    id: "r2d2StarterDisclaimer4a"
  });
  var r2d2StarterDisclaimer4b = formatMessage({
    id: "r2d2StarterDisclaimer4b"
  });
  var r2d2StarterDisclaimer4c = formatMessage({
    id: "r2d2StarterDisclaimer4c"
  });
  var r2d2StarterDisclaimer5 = formatMessage({
    id: "r2d2StarterDisclaimer5"
  });
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "page"
      },
      /*#__PURE__*/ React.createElement(Header, {
        type: 2
      }),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "containers mobilecart"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "mg  cart1 mpad_all",
            style: {
              position: "relative"
            }
          },
          /*#__PURE__*/ React.createElement(PreLoader, {
            isLoading: isLoading
          }),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "topheader"
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "title"
              },
              cart1
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "ul"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "li active"
                },
                /*#__PURE__*/ React.createElement("span", null, "1"),
                /*#__PURE__*/ React.createElement("i", null)
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "li"
                },
                /*#__PURE__*/ React.createElement("span", null, "2"),
                /*#__PURE__*/ React.createElement("i", null)
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "li"
                },
                /*#__PURE__*/ React.createElement("span", null, "3")
              )
            )
          ),
          data.shopping_cart_items.length > 0
            ? /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "main"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "tabel"
                  },
                  data.shopping_cart_items.map(function(item, index) {
                    return /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "cart-item",
                        key: index
                      },
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "tabelmain"
                        },
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "desc"
                          },
                          /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "img"
                            },
                            /*#__PURE__*/ React.createElement("img", {
                              src: item.product.image,
                              alt: "Product"
                            })
                          ),
                          /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "desctext"
                            },
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "name-series"
                              },
                              localStorage.lang === "tw"
                                ? item.product.zhtw_product_series
                                : localStorage.lang === "en"
                                ? item.product.product_series
                                : item.product.product_series
                            ),
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "name"
                              },
                              localStorage.lang === "tw"
                                ? item.product.zhtw_product_item_name
                                : localStorage.lang === "en"
                                ? item.product.name
                                : item.product.name
                            ),
                            item.product.is_installment
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "name"
                                  },
                                  subsub
                                )
                              : null,
                            item.product.product_variation ===
                              "Build Yourself Kit"
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "desc"
                                  },
                                  cart48
                                )
                              : null,
                            item.product.product_variation === "Build Service"
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "build2"
                                  },
                                  /*#__PURE__*/ React.createElement("img", {
                                    src: STK_LOGO_BUILD_SERVICE_BUTTON,
                                    alt: "Build Service Logo"
                                  }),
                                  /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "p"
                                    },
                                    /*#__PURE__*/ React.createElement(
                                      "p",
                                      null,
                                      cart46
                                    ),
                                    /*#__PURE__*/ React.createElement(
                                      "span",
                                      {
                                        style: {
                                          display:
                                            item.product.product_key ===
                                            "stk_build_service"
                                              ? "block"
                                              : "none"
                                        },
                                        onClick: function onClick() {
                                          return build2(item);
                                        }
                                      },
                                      cart47
                                    )
                                  )
                                )
                              : null,
                            item.custom_plaque_name
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "plaque-name"
                                  },
                                  accessoriessection23 + item.custom_plaque_name
                                )
                              : null,
                            item.custom_plaque_creditline
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "plaque-creditline"
                                  },
                                  accessoriessection24 +
                                    item.custom_plaque_creditline
                                )
                              : null
                          )
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "numandprice"
                          },
                          /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "qty"
                            },
                            cart5
                          ),
                          /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "price"
                            },
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "prices",
                                style: {
                                  justifyContent: "flex-end"
                                }
                              },
                              cart6
                            )
                          )
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "numandprice"
                          },
                          /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "qty",
                              style: {
                                display:
                                  item.product.is_installment ||
                                  item.product.is_balance_payment
                                    ? "flex"
                                    : "none"
                              }
                            },
                            item.amount
                          ),
                          /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "qty",
                              style: {
                                display:
                                  item.product.is_installment ||
                                  item.product.is_balance_payment
                                    ? "none"
                                    : "flex"
                              }
                            },
                            /*#__PURE__*/ React.createElement(
                              "span",
                              {
                                onClick: function onClick() {
                                  return reduce(item);
                                }
                              },
                              "-"
                            ),
                            /*#__PURE__*/ React.createElement("input", {
                              type: "number",
                              value: item.amount,
                              maxLength: "2",
                              readOnly: true
                            }),
                            /*#__PURE__*/ React.createElement(
                              "span",
                              {
                                onClick: function onClick() {
                                  return add(item);
                                }
                              },
                              "+"
                            )
                          ),
                          /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "price"
                            },
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "prices"
                              },
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "newprice",
                                  style: {
                                    color: [
                                      "stk_build_service",
                                      "stk_build_service_with_installment"
                                    ].includes(item.product.product_key)
                                      ? "#ff8800"
                                      : "#000"
                                  }
                                },
                                "NT$",
                                " ",
                                item.price_subtotal
                              ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "mon",
                                  style: {
                                    display:
                                      item.product.is_installment &&
                                      isShowNextMonthPaymentAmount({
                                        cartItem: item
                                      })
                                        ? "block"
                                        : "none",
                                    fontSize: 12
                                  }
                                },
                                "(",
                                localStorage.lang !== "en" ? cart64tc : null,
                                "NT$",
                                " ",
                                Math.floor(item.product.price),
                                localStorage.lang === "en" ? cart64 : null,
                                ")"
                              ),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "deposit",
                                  style: {
                                    display:
                                      item.product.deposit_amount > 0
                                        ? "block"
                                        : "none",
                                    fontSize: 12,
                                    marginLeft: 10,
                                    color: "#28a6d4"
                                  }
                                },
                                cartdeposit,
                                ": ",
                                "NT$",
                                " ",
                                item.payment_subtotal
                              )
                            ),
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "del",
                                onClick: function onClick() {
                                  return showpop(item.id);
                                },
                                style: {
                                  color: "#777"
                                }
                              },
                              cart7
                            )
                          )
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            style: {
                              marginTop: 20,
                              display: item.product.is_installment
                                ? "block"
                                : "none"
                            }
                          },
                          item.product &&
                            item.product.benefit &&
                            item.product.benefit.tw
                            ? item.product.benefit.tw.map(function(benefit) {
                                return /*#__PURE__*/ React.createElement(
                                  "p",
                                  {
                                    key: benefit
                                  },
                                  /*#__PURE__*/ React.createElement("img", {
                                    style: {
                                      width: 12,
                                      height: 12,
                                      marginTop: -4,
                                      marginBottom: 0
                                    },
                                    src: CART_CHECK_MARK,
                                    alt: "Checkmark"
                                  }),
                                  " ",
                                  benefit
                                );
                              })
                            : getSubBenefitTranslationKey(item).map(function(
                                benefitKey
                              ) {
                                return /*#__PURE__*/ React.createElement(
                                  "p",
                                  {
                                    key: benefitKey
                                  },
                                  /*#__PURE__*/ React.createElement("img", {
                                    style: {
                                      width: 12,
                                      height: 12,
                                      marginTop: -4,
                                      marginBottom: 0
                                    },
                                    src: CART_CHECK_MARK,
                                    alt: "Checkmark"
                                  }),
                                  " ",
                                  formatMessage({
                                    id: benefitKey
                                  })
                                );
                              })
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "pts-long",
                            style: {
                              marginTop: 20,
                              display: [
                                "btmf_pack_1a_starter_build_yourself",
                                "btmf_pack_1a_starter_build_yourself_shop_special",
                                "btmf_pack_1a_starter_build_yourself_shop_special_SFdelivery"
                              ].includes(item.product.product_key)
                                ? "block"
                                : "none"
                            }
                          },
                          /*#__PURE__*/ React.createElement(
                            "p",
                            null,
                            /*#__PURE__*/ React.createElement("img", {
                              style: {
                                width: 12,
                                height: 12,
                                marginTop: -4,
                                marginBottom: 0
                              },
                              src: CART_CHECK_MARK,
                              alt: "Checkmark"
                            }),
                            " ",
                            cartstarter01
                          ),
                          /*#__PURE__*/ React.createElement(
                            "p",
                            null,
                            /*#__PURE__*/ React.createElement("img", {
                              style: {
                                width: 12,
                                height: 12,
                                marginTop: -4,
                                marginBottom: 0
                              },
                              src: CART_CHECK_MARK,
                              alt: "Checkmark"
                            }),
                            " ",
                            cartstarter02,
                            /*#__PURE__*/ React.createElement("br", null),
                            cartstarter03
                          ),
                          /*#__PURE__*/ React.createElement(
                            "p",
                            null,
                            /*#__PURE__*/ React.createElement("img", {
                              style: {
                                width: 12,
                                height: 12,
                                marginTop: -4,
                                marginBottom: 0
                              },
                              src: CART_CHECK_MARK,
                              alt: "Checkmark"
                            }),
                            " ",
                            cartstarter04
                          )
                        )
                      ),
                      formatReceiveDate(
                        item.product.least_days_to_ship,
                        item.product.most_days_to_ship
                      ) != null && isShowShipDate(item)
                        ? /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "shipping-delivery-date-mobile"
                            },
                            formatReceiveDate(
                              item.product.least_days_to_ship,
                              item.product.most_days_to_ship
                            )
                          )
                        : null,
                      item.product.shipping_notice != ""
                        ? /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "shipping-notice-mobile"
                            },
                            /*#__PURE__*/ React.createElement(
                              "span",
                              null,
                              localStorage.lang === "tw"
                                ? item.product.zhhk_shipping_notice
                                : localStorage.lang === "en"
                                ? item.product.shipping_notice
                                : item.product.shipping_notice
                            )
                          )
                        : null,
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "tabelbot"
                        },
                        item.product.product_key === "build_yourself_kit" ||
                          item.product.product_key ===
                            "build_yourself_kit_with_installment"
                          ? /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "left",
                                onClick: function onClick() {
                                  return build1(item);
                                }
                              },
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "text"
                                },
                                /*#__PURE__*/ React.createElement(
                                  "span",
                                  null,
                                  cart8,
                                  " "
                                ),
                                /*#__PURE__*/ React.createElement(
                                  "span",
                                  null,
                                  cart9
                                )
                              ),
                              /*#__PURE__*/ React.createElement("img", {
                                src: STK_LOGO_BUILD_SERVICE_BUTTON,
                                alt: "Build Service Logo"
                              })
                            )
                          : null
                      ),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: showPop ? "pop" : "hidden"
                        },
                        /*#__PURE__*/ React.createElement(
                          "h3",
                          null,
                          cartremoveitemheader
                        ),
                        /*#__PURE__*/ React.createElement(
                          "p",
                          null,
                          cartremoveitem
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "btn btn-confirm",
                            onClick: function onClick() {
                              return hidepop();
                            }
                          },
                          cartremovecancel
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "btn btn-cancel",
                            onClick: function onClick() {
                              return delcart();
                            }
                          },
                          cartremoveconfirm
                        ),
                        /*#__PURE__*/ React.createElement("img", {
                          src: CLOSE,
                          alt: "Close Dialog",
                          className: "close",
                          onClick: function onClick() {
                            return hidepop();
                          }
                        })
                      )
                    );
                  }),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "bto_right"
                    },
                    isShowDiscountCode({
                      cartItems: data.shopping_cart_items
                    }) &&
                      /*#__PURE__*/ React.createElement(
                        React.Fragment,
                        null,
                        " ",
                        !data.discount_code
                          ? /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "discount-code-container"
                              },
                              /*#__PURE__*/ React.createElement("input", {
                                id: "discount-code",
                                type: "text",
                                placeholder: cartinputdiscount,
                                onInput: function onInput(e) {
                                  return setDiscount_code(e.target.value);
                                },
                                value: discount_code,
                                maxLength: "10"
                              }),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  id: "btn-apply-discount-code",
                                  className: "btn-discount-code",
                                  onClick: function onClick() {
                                    return applyDiscountCode();
                                  }
                                },
                                "Apply"
                              )
                            )
                          : /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "discount-code-container"
                              },
                              /*#__PURE__*/ React.createElement("input", {
                                id: "discount-code",
                                type: "text",
                                placeholder: cartinputdiscount,
                                onInput: function onInput(e) {
                                  return setDiscount_code(e.target.value);
                                },
                                value: discount_code,
                                maxLength: "10",
                                readOnly: true
                              }),
                              /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  id: "btn-remove-discount-code",
                                  className: "btn-discount-code",
                                  onClick: function onClick() {
                                    return removeDiscountCode();
                                  }
                                },
                                "Remove"
                              )
                            ),
                        invalidDiscountCode
                          ? /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "discount-code-error"
                              },
                              cartinvaliddiscountcode
                            )
                          : null
                      ),
                    hasDeposit ||
                      data.shopping_cart_items[0].product.is_installment ===
                        true ||
                      data.payment_total < priceToAllowInstallment
                      ? null
                      : /*#__PURE__*/ React.createElement(
                          React.Fragment,
                          null,
                          /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "checkbox checkbox-paybyterm"
                            },
                            /*#__PURE__*/ React.createElement("input", {
                              type: "checkbox",
                              id: "checkbox-paybyterm",
                              name: "checkbox-paybyterm",
                              checked: payByTerm,
                              onChange: function onChange(e) {
                                return togglePayByTerm(e);
                              }
                            }),
                            /*#__PURE__*/ React.createElement(
                              "label",
                              {
                                htmlFor: "checkbox-paybyterm"
                              },
                              cartpaybytermcheckbox
                            )
                          ),
                          payByTerm
                            ? /*#__PURE__*/ React.createElement(
                                React.Fragment,
                                null,
                                /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "term-duration"
                                  },
                                  /*#__PURE__*/ React.createElement("input", {
                                    id: "term-duration",
                                    type: "text",
                                    readOnly: true,
                                    placeholder: "3", // onInput={e => onInput(e, "country")}
                                    value: termDuration,
                                    style: {
                                      cursor: "pointer"
                                    },
                                    onClick: function onClick() {
                                      return chooseTermDuration();
                                    }
                                  }),
                                  /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      onClick: function onClick() {
                                        return chooseTermDuration();
                                      },
                                      style: {
                                        width: 12,
                                        height: 8,
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        cursor: "pointer"
                                      }
                                    },
                                    /*#__PURE__*/ React.createElement("img", {
                                      style: {
                                        width: "100%",
                                        height: "100%"
                                      },
                                      src: RECTANGLE,
                                      alt: "Dropdown Icon"
                                    })
                                  ),
                                  /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "choose-term-duration",
                                      style: {
                                        display: showTermDurationDropdown
                                          ? "block"
                                          : "none",
                                        bottom: -49,
                                        cursor: "pointer"
                                      }
                                    },
                                    /*#__PURE__*/ React.createElement(
                                      "span",
                                      {
                                        onClick: function onClick() {
                                          return closeTermDuration();
                                        },
                                        style: {
                                          cursor: "pointer",
                                          display: "block",
                                          height: "21px",
                                          width: "21px",
                                          position: "absolute",
                                          right: "-9px",
                                          top: "-9px",
                                          border: "1px solid #000",
                                          borderRadius: "50%",
                                          backgroundColor: "#000",
                                          color: "#FFF",
                                          zIndex: "100",
                                          textAlign: "center",
                                          fontSize: "16px",
                                          lineHeight: "16px",
                                          fontWeight: "bold"
                                        }
                                      },
                                      "x"
                                    ),
                                    availableTermDuration.map(function(
                                      allowMonth
                                    ) {
                                      return /*#__PURE__*/ React.createElement(
                                        "div",
                                        {
                                          key: allowMonth,
                                          onClick: function onClick() {
                                            return selectTermDuration(
                                              allowMonth
                                            );
                                          },
                                          style: {
                                            cursor: "pointer"
                                          }
                                        },
                                        allowMonth,
                                        " ",
                                        cartmonthlypayments
                                      );
                                    })
                                  )
                                ),
                                /*#__PURE__*/ React.createElement(
                                  "span",
                                  null,
                                  cartmonthlypayments
                                ),
                                /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "inst-amt"
                                  },
                                  cart64c,
                                  " ",
                                  "NT$",
                                  " ",
                                  installmentAmount,
                                  " ",
                                  cart64b
                                )
                              )
                            : null
                        ),
                    data.discount_amount > 0
                      ? /*#__PURE__*/ React.createElement(
                          "p",
                          {
                            className: "p1"
                          },
                          cartdiscountamt,
                          /*#__PURE__*/ React.createElement(
                            "span",
                            null,
                            "NT$",
                            " ",
                            data.discount_amount
                          )
                        )
                      : null,
                    /*#__PURE__*/ React.createElement(
                      "p",
                      {
                        className: "p1",
                        style: {
                          display: hasDeposit ? "flex" : "none",
                          color: "#28a6d4"
                        }
                      },
                      cartpaynow,
                      /*#__PURE__*/ React.createElement(
                        "span",
                        null,
                        "NT$",
                        " ",
                        paymentTotal
                      )
                    ),
                    /*#__PURE__*/ React.createElement(
                      "p",
                      {
                        className: "p1",
                        style: {
                          display: hasDeposit ? "flex" : "none"
                        }
                      },
                      cartbalancedue,
                      " ",
                      /*#__PURE__*/ React.createElement(
                        "span",
                        null,
                        "NT$",
                        " ",
                        remainingBal
                      )
                    ),
                    /*#__PURE__*/ React.createElement(
                      "p",
                      {
                        className: "p1"
                      },
                      cart10,
                      " ",
                      /*#__PURE__*/ React.createElement(
                        "span",
                        null,
                        shipping_fee === 0
                          ? cart11
                          : "NT$".concat(" ", shipping_fee)
                      )
                    ),
                    /*#__PURE__*/ React.createElement(
                      "p",
                      {
                        className: "p1",
                        style: {
                          fontWeight: "bold"
                        }
                      },
                      cart12,
                      /*#__PURE__*/ React.createElement(
                        "span",
                        {
                          style: {
                            fontWeight: "bold"
                          }
                        },
                        "NT$",
                        " ",
                        grandTotal,
                        " "
                      )
                    ),
                    data.shopping_cart_items[0].product.is_installment &&
                      isShowNextMonthPaymentAmount({
                        cartItems: data.shopping_cart_items
                      })
                      ? /*#__PURE__*/ React.createElement(
                          "p",
                          {
                            className: "p1"
                          },
                          cart64d,
                          /*#__PURE__*/ React.createElement(
                            "span",
                            null,
                            "NT$",
                            " ",
                            data.subscription_fee,
                            " "
                          )
                        )
                      : null,
                    isShowBenefitDisclaimer({
                      cartItems: data.shopping_cart_items
                    }) &&
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          style: {
                            color: "#555",
                            marginTop: 25,
                            marginBottom: 30,
                            lineHeight: "17px",
                            fontSize: 12
                          }
                        },
                        cartBenefitDisclaimer1,
                        /*#__PURE__*/ React.createElement(
                          "a",
                          {
                            href: "/faq"
                          },
                          cartBenefitDisclaimer2
                        ),
                        cartBenefitDisclaimer3
                      ),
                    data &&
                      Array.isArray(data.shopping_cart_items) &&
                      data.shopping_cart_items.some(function(item) {
                        return (
                          item.product.product_key ===
                          "btmf_accelerated_starter_plan_1_5"
                        );
                      }) &&
                      /*#__PURE__*/ React.createElement(
                        "p",
                        {
                          className: "cart-subscription-disclaimer",
                          style: {
                            color: "#555",
                            marginTop: 25,
                            marginBottom: 30,
                            lineHeight: "17px",
                            fontSize: 12
                          }
                        },
                        acceleratedDisclaimer1,
                        /*#__PURE__*/ React.createElement("br", null),
                        acceleratedDisclaimer2,
                        /*#__PURE__*/ React.createElement("br", null),
                        acceleratedDisclaimer3,
                        /*#__PURE__*/ React.createElement("br", null),
                        acceleratedDisclaimer4a,
                        acceleratedStarterPlanSinglePay,
                        acceleratedDisclaimer4b,
                        acceleratedStarterPlanEachMonth,
                        acceleratedDisclaimer4c,
                        /*#__PURE__*/ React.createElement("br", null),
                        acceleratedDisclaimer5
                      ),
                    data &&
                      Array.isArray(data.shopping_cart_items) &&
                      data.shopping_cart_items.some(function(item) {
                        return (
                          item.product.product_key ===
                          "r2d2_accelerated_starter_plan_1_5"
                        );
                      }) &&
                      /*#__PURE__*/ React.createElement(
                        "p",
                        {
                          className: "cart-subscription-disclaimer",
                          style: {
                            color: "#555",
                            marginTop: 25,
                            marginBottom: 30,
                            lineHeight: "17px",
                            fontSize: 12
                          }
                        },
                        r2d2StarterDisclaimer1,
                        /*#__PURE__*/ React.createElement("br", null),
                        r2d2StarterDisclaimer2,
                        /*#__PURE__*/ React.createElement("br", null),
                        r2d2StarterDisclaimer3,
                        /*#__PURE__*/ React.createElement("br", null),
                        r2d2StarterDisclaimer4a,
                        r2d2StarterPlanSinglePay,
                        r2d2StarterDisclaimer4b,
                        r2d2StarterPlanEachMonth,
                        r2d2StarterDisclaimer4c,
                        /*#__PURE__*/ React.createElement("br", null),
                        r2d2StarterDisclaimer5
                      ),
                    data.shopping_cart_items.length === 1 &&
                      data.shopping_cart_items[0].product.product_key ===
                        "build_yourself_kit" &&
                      data.shopping_cart_items[0].amount === 1
                      ? /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            style: {
                              color: "#555",
                              marginTop: 25,
                              marginBottom: 30,
                              lineHeight: "17px",
                              fontSize: 12
                            }
                          },
                          cartpack1disclaimer1,
                          cartpack1disclaimer2,
                          /*#__PURE__*/ React.createElement("br", null),
                          cartpack1disclaimer3,
                          /*#__PURE__*/ React.createElement(
                            "span",
                            {
                              style: {
                                fontStyle: "italic"
                              }
                            },
                            cartpack1disclaimer4
                          ),
                          cartpack1disclaimer5,
                          cartpack1disclaimer6,
                          /*#__PURE__*/ React.createElement(
                            "span",
                            {
                              style: {
                                color: "#000",
                                textDecoration: "underline",
                                cursor: "pointer"
                              },
                              onClick: function onClick() {
                                return build3();
                              }
                            },
                            cartpack1disclaimer7
                          )
                        )
                      : null,
                    hasDeposit
                      ? /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            style: {
                              color: "#555",
                              marginTop: 25,
                              marginBottom: 30,
                              lineHeight: "17px",
                              fontSize: 12
                            }
                          },
                          cartdepositdisclaimer0,
                          /*#__PURE__*/ React.createElement("br", null),
                          cartdepositdisclaimer1,
                          /*#__PURE__*/ React.createElement(
                            "a",
                            {
                              href: "".concat(
                                requestParam$1.r2d2Url,
                                "/r2d2/faq"
                              ),
                              target: "_blank",
                              rel: "noopener noreferrer"
                            },
                            /*#__PURE__*/ React.createElement(
                              "span",
                              {
                                style: {
                                  color: "#000",
                                  textDecoration: "underline",
                                  cursor: "pointer"
                                }
                              },
                              cartdepositdisclaimer2
                            )
                          )
                        )
                      : null,
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "btn",
                        onClick: function onClick() {
                          return push(requestParam$1.webBaseURL + "/cart2");
                        }
                      },
                      cart14
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "continue-shopping-link",
                        style: {
                          marginBottom: 30
                        }
                      },
                      /*#__PURE__*/ React.createElement(
                        "a",
                        {
                          href: shoppingPath,
                          style: {
                            color: "#000"
                          }
                        },
                        cartcontinueshopping
                      )
                    )
                  )
                )
              )
            : /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "empty-cart-wrapper-mobile"
                },
                /*#__PURE__*/ React.createElement("img", {
                  src: SHOPPING_CART_512,
                  alt: "Empty Shopping Cart",
                  className: "empty-cart-image-mobile"
                }),
                /*#__PURE__*/ React.createElement(
                  "p",
                  {
                    className: "empty-cart-heading-mobile"
                  },
                  cartempty1
                ),
                /*#__PURE__*/ React.createElement(
                  "p",
                  {
                    className: "empty-cart-p-mobile"
                  },
                  cartempty2
                ),
                /*#__PURE__*/ React.createElement(
                  "p",
                  {
                    className: "empty-cart-p2-mobile"
                  },
                  /*#__PURE__*/ React.createElement(
                    "a",
                    {
                      href: shoppingPath
                    },
                    cartempty3
                  )
                )
              )
        )
      ),
      /*#__PURE__*/ React.createElement("div", {
        id: "mask",
        className: "mask"
      })
    ),
    /*#__PURE__*/ React.createElement(ErrorModal, {
      note1: errorNote1,
      note2: errorNote2,
      note3: errorNote3,
      note4: errorNote4,
      isOpen: errorPop,
      onCloseButtonClick: function onCloseButtonClick() {
        setErrorPop(false);
      }
    })
  );
};

var Cart1Web = function Cart1Web(_ref) {
  var continuePath = _ref.continuePath;

  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    willRemoveItemID = _useState2[0],
    setWillRemoveItemID = _useState2[1];

  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPop = _useState4[0],
    setShowPop = _useState4[1];

  var _useState5 = useState(availableTermDuration[0]),
    _useState6 = _slicedToArray(_useState5, 2),
    termDuration = _useState6[0],
    setTermDuration = _useState6[1];

  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    payByTerm = _useState8[0],
    setPayByTerm = _useState8[1];

  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isLoading = _useState10[0],
    setIsLoading = _useState10[1];

  var _useState11 = useState({
      shopping_cart_items: [],
      total: 0
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    data = _useState12[0],
    setData = _useState12[1];

  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    remainingBal = _useState14[0],
    setRemainingBal = _useState14[1];

  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    grandTotal = _useState16[0],
    setGrandTotal = _useState16[1];

  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    paymentTotal = _useState18[0],
    setPaymentTotal = _useState18[1];

  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showTermDurationDropdown = _useState20[0],
    setShowTermDurationDropdown = _useState20[1];

  var _useState21 = useState(0),
    _useState22 = _slicedToArray(_useState21, 2),
    installmentAmount = _useState22[0],
    setInstallmentAmount = _useState22[1];

  var _useState23 = useState(0),
    _useState24 = _slicedToArray(_useState23, 2),
    shipping_fee = _useState24[0],
    setShipping_fee = _useState24[1];

  var _useState25 = useState(""),
    _useState26 = _slicedToArray(_useState25, 2),
    discount_code = _useState26[0],
    setDiscount_code = _useState26[1];

  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    invalidDiscountCode = _useState28[0],
    setInvalidDiscountCode = _useState28[1];

  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    hasDeposit = _useState30[0],
    setHasDeposit = _useState30[1];

  var _useState31 = useState("/"),
    _useState32 = _slicedToArray(_useState31, 2),
    shoppingPath = _useState32[0],
    setShoppingPath = _useState32[1];

  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    errorPop = _useState34[0],
    setErrorPop = _useState34[1];

  var _useState35 = useState(""),
    _useState36 = _slicedToArray(_useState35, 2),
    errorNote1 = _useState36[0],
    setErrorNote1 = _useState36[1];

  var _useState37 = useState(""),
    _useState38 = _slicedToArray(_useState37, 2),
    errorNote2 = _useState38[0],
    setErrorNote2 = _useState38[1];

  var _useState39 = useState(""),
    _useState40 = _slicedToArray(_useState39, 2),
    errorNote3 = _useState40[0],
    setErrorNote3 = _useState40[1];

  var _useState41 = useState(""),
    _useState42 = _slicedToArray(_useState41, 2),
    errorNote4 = _useState42[0],
    setErrorNote4 = _useState42[1];

  useEffect(
    function() {
      if (continuePath) {
        setShoppingPath(continuePath);
      } else {
        setShoppingPath("/");
      }
    },
    [continuePath]
  ); // this is directly from url by cms

  var _useState43 = useState(""),
    _useState44 = _slicedToArray(_useState43, 2),
    orderRef = _useState44[0],
    setOrderRef = _useState44[1];

  var calInstallmentAmount = function calInstallmentAmount(remBal, total) {
    var instAmt;

    if (remBal == 0) {
      instAmt = (total / localStorage.termduration).toFixed(0);
    } else {
      instAmt = (remBal / localStorage.termduration).toFixed(0);
    }

    setInstallmentAmount(instAmt);
  };

  var generateTotals = function generateTotals(res) {
    setHasDeposit(
      res.shopping_cart_items.some(function(item) {
        return item.product.deposit_amount > 0;
      })
    );
    var tmpTotal = res.total - res.discount_amount;
    var remBal = tmpTotal - res.payment_total;
    tmpTotal = tmpTotal.toFixed(0);
    setRemainingBal(remBal);
    setGrandTotal(tmpTotal);
    setPaymentTotal(res.payment_total);
    setShipping_fee(res.shipping_fee);
    calInstallmentAmount(remBal, tmpTotal);
    setDiscount_code(res.discount_code ? res.discount_code.discount_code : "");
    localStorage.setItem("paymentTotal", res.payment_total);
  };

  var changeProductAmount = function changeProductAmount(data) {
    post("api/v1/shopping_carts/change_product_amount", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var add = function add(item) {
    var data = {
      amount: ++item.amount,
      shopping_cart_item_id: item.id
    };
    changeProductAmount(data);
  };

  var reduce = function reduce(item) {
    if (item.amount > 1) {
      var _data = {
        amount: --item.amount,
        shopping_cart_item_id: item.id
      };
      changeProductAmount(_data);
    }
  };

  var build1 = function build1(item) {
    var data = {
      shopping_cart_item_id: item.id
    };
    post("api/v1/shopping_carts/stk_build_service", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var build2 = function build2(item) {
    var data = {
      shopping_cart_item_id: item.id
    };
    del("api/v1/shopping_carts/cancel_stk_build_service", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var build3 = function build3() {
    var data = {
      shopping_cart_key: localStorage.cartKey
    };
    post(
      "api/v1/shopping_carts/build_yourself_kit_with_installment_service",
      data,
      1
    )
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var hidepop = function hidepop() {
    setShowPop(false);
  };

  var showpop = function showpop(id) {
    setWillRemoveItemID(id);
    setShowPop(true);
  };

  var delcart = function delcart() {
    setShowPop(false);
    var data = {
      shopping_cart_item_id: willRemoveItemID
    };
    del("api/v1/shopping_carts/delete_shopping_cart_item", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var formatReceiveDate = function formatReceiveDate(
    leastDayToShip,
    mostDayToShip
  ) {
    if (leastDayToShip < 0 || mostDayToShip < 0) {
      return null;
    }

    var firstAvailableDate = moment().add(leastDayToShip, "day");
    var lastAvailableDate = moment().add(mostDayToShip, "day");
    var receive_date = formatMessage({
      id: "cart.receive_date"
    });
    var receive_date_1 = formatMessage({
      id: "cart.receive_date_1"
    });

    if (firstAvailableDate.isSame(lastAvailableDate)) {
      return "".concat(receive_date).concat(formatDateStr(firstAvailableDate));
    } else {
      return ""
        .concat(receive_date)
        .concat(formatDateStr(firstAvailableDate))
        .concat(receive_date_1)
        .concat(lastAvailableDate);
    }
  };

  var applyDiscountCode = function applyDiscountCode() {
    setInvalidDiscountCode(false);
    var data = {
      discount_code: discount_code,
      shopping_cart_key: localStorage.cartKey
    };
    post("api/v1/shopping_carts/add_discount_code_to_shopping_cart", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {
        setInvalidDiscountCode(true);
      });
  };

  var removeDiscountCode = function removeDiscountCode() {
    var data = {
      shopping_cart_key: localStorage.cartKey
    };
    del(
      "api/v1/shopping_carts/remove_discount_code_from_shopping_cart",
      data,
      1
    )
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var push = function push(name) {
    localStorage.setItem("cartdata", JSON.stringify(data));

    if (
      [
        requestParam$1.webBaseURL + "/cart2",
        requestParam$1.webBaseURL + "/cart1",
        requestParam$1.webBaseURL + "/login"
      ].includes(name)
    ) {
      localStorage.setItem("historyOrderRef", orderRef);
    }

    window.location.href = name;
  };

  var togglePayByTerm = function togglePayByTerm(e) {
    setPayByTerm(e.target.checked);

    if (localStorage.payByTerm === "false") {
      localStorage.setItem("payByTerm", "true");
    } else if (localStorage.payByTerm === "true") {
      localStorage.setItem("payByTerm", "false");
    }

    if (e.target.checked) {
      calInstallmentAmount(remainingBal, grandTotal);
    }
  };

  var chooseTermDuration = function chooseTermDuration() {
    setShowTermDurationDropdown(!showTermDurationDropdown);
  };

  var selectTermDuration = function selectTermDuration(month) {
    setShowTermDurationDropdown(false);
    setTermDuration(month);
    localStorage.setItem("termduration", month);

    if (payByTerm) {
      calInstallmentAmount(remainingBal, grandTotal);
    }
  };

  var closeTermDuration = function closeTermDuration() {
    setShowTermDurationDropdown(false);
  };

  var setQty = function setQty(item, qty) {
    var data = {
      amount: qty,
      shopping_cart_item_id: item.id
    };
    post("api/v1/shopping_carts/change_product_amount", data, 1)
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {});
  };

  var clearShoppingCartAndAddProduct = function clearShoppingCartAndAddProduct(
    data,
    qty,
    email,
    isLoggedInPrevAcct
  ) {
    if (!email && localStorage.user) {
      initCartKey();
      data.shopping_cart_key = localStorage.cartKey;
    } else if (
      (email && isLoggedInPrevAcct) ||
      (!email && !localStorage.user) ||
      (email && !localStorage.user)
    ) {
      data.shopping_cart_key = localStorage.cartKey;
    }

    post(
      "api/v1/shopping_carts/clear_shopping_cart_and_add_product",
      data,
      1,
      22
    )
      .then(function(res) {
        console.log(res);

        if ((email && isLoggedInPrevAcct) || !email) {
          if (email && isLoggedInPrevAcct) {
            localStorage.setItem("cartItemCount", 1);
          }

          if (!email) {
            localStorage.removeItem("user");
            localStorage.removeItem("userheader");
            localStorage.setItem("cartItemCount", 1);
          }

          setIsLoading(false);
          res = res.data.response;
          setData(res);
          generateTotals(res);
          localStorage.setItem(
            "cartItem",
            JSON.stringify(res.shopping_cart_items)
          );

          if (qty && qty > 1) {
            setQty(res.shopping_cart_items[0], qty);
          }
        } else {
          localStorage.removeItem("user");
          localStorage.removeItem("userheader");
          localStorage.setItem("cartItemCount", 1);
          localStorage.setItem("redirectedfromcart", true);
          localStorage.setItem("redirectedfromcartemail", email);
          localStorage.setItem("redirectedfromcartproduct", data.product_key);

          if (qty > 1) {
            localStorage.setItem("redirectedfromcartqty", qty);
          } else {
            localStorage.setItem("redirectedfromcartqty", 1);
          }

          push(requestParam$1.webBaseURL + "/login");
        }
      })
      ["catch"](function(err) {});
  };

  var clearShoppingCartAndAddProduct2 = function clearShoppingCartAndAddProduct2(
    data
  ) {
    post(
      "api/v1/shopping_carts/clear_shopping_cart_and_add_product",
      data,
      1,
      22
    )
      .then(function(res) {
        setIsLoading(false);
        res = res.data.response;
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );

        if (
          localStorage.redirectedfromcartqty &&
          localStorage.redirectedfromcartqty > 1
        ) {
          setQty(
            res.shopping_cart_items[0],
            localStorage.redirectedfromcartqty
          );
        }
      })
      ["catch"](function(err) {});
  };

  useEffect(function() {
    initCartKey();

    if (localStorage.historyOrderRef) {
      setOrderRef(localStorage.historyOrderRef);
      localStorage.setItem("historyOrderRef", "");
    }

    if (!localStorage.payByTerm) {
      localStorage.setItem("payByTerm", "false");
    }

    if (localStorage.getItem("payByTerm") === "true") {
      setPayByTerm(true);
    }

    if (!localStorage.termduration) {
      localStorage.setItem("termduration", availableTermDuration[0]);
    } else {
      var duration = parseInt(localStorage.termduration);

      if (availableTermDuration.includes(duration)) {
        setTermDuration(duration);
      }
    }

    if (localStorage.redirectedfromcart) {
      if (localStorage.redirectedfromcartemail) {
        var _data2 = {
          shopping_cart_key: localStorage.cartKey,
          product_key: localStorage.redirectedfromcartproduct
        };
        clearShoppingCartAndAddProduct2(_data2);
        localStorage.removeItem("redirectedfromcartemail");
      }

      localStorage.removeItem("redirectedfromcart");
      localStorage.removeItem("redirectedfromcartproduct");
    }

    var query = queryString.parse(window.location.search);
    var shoppingCartKey = query.shopping_cart_key;
    var orderID = query.order_id;
    var productKey = query.product_key;
    var qty = query.qty;
    var order_ref = query.order_ref;
    setIsLoading(true);

    if (query.order_id && query.product_key && query.shopping_cart_key) {
      var _data3 = {
        shopping_cart_key: shoppingCartKey,
        product_key: productKey
      };
      var url = "";

      if (order_ref) {
        url = "api/v1/shopping_carts/is_shopping_cart_belong_to_user?order_id="
          .concat(orderID, "&shopping_cart_key=")
          .concat(shoppingCartKey, "&order_ref=")
          .concat(order_ref);
        setOrderRef(orderRef);
      } else {
        url = "api/v1/shopping_carts/is_shopping_cart_belong_to_user?order_id="
          .concat(orderID, "&shopping_cart_key=")
          .concat(shoppingCartKey);
      }

      get(url, 1, 23)
        .then(function(res) {
          console.log("RESPONSE: " + JSON.stringify(res));

          if (res.is_user_equal_order_user && res.is_local_user_present) {
            clearShoppingCartAndAddProduct(_data3, qty, res.email, true);
          } else if (
            (!res.is_user_equal_order_user &&
              !res.is_local_user_present &&
              res.email) ||
            (!res.is_user_equal_order_user &&
              res.is_local_user_present &&
              res.email) ||
            (!res.is_user_equal_order_user &&
              !res.is_local_user_present &&
              !res.email) ||
            (!res.is_user_equal_order_user &&
              res.is_local_user_present &&
              !res.email)
          ) {
            clearShoppingCartAndAddProduct(_data3, qty, res.email, false);
          }
        })
        ["catch"](function(err) {
          push(requestParam$1.webBaseURL + "/cart1");
        });
      return;
    }

    if (query.product_key) {
      if (outOfStockKey[query.product_key]) {
        window.location.href = outOfStockKey[query.product_key].redirectTo;
      }

      var _data4 = {
        shopping_cart_key: localStorage.cartKey,
        product_key: productKey
      };
      post(
        "api/v1/shopping_carts/clear_shopping_cart_and_add_product",
        _data4,
        1,
        22
      )
        .then(function(res) {
          setIsLoading(false);
          localStorage.setItem("cartItemCount", 1);
          res = res.data.response;
          setData(res);
          generateTotals(res);
          localStorage.setItem(
            "cartItem",
            JSON.stringify(res.shopping_cart_items)
          );

          if (qty && qty > 1) {
            setQty(res.shopping_cart_items[0], qty);
          }
        })
        ["catch"](function(err) {
          push(requestParam$1.webBaseURL + "/cart1");
        });
      return;
    }

    if (query.add_product_key) {
      if (outOfStockKey[query.add_product_key]) {
        window.location.href = outOfStockKey[query.add_product_key].redirectTo;
      }

      requestAddCart({
        getCart: function getCart() {
          get(
            "api/v1/shopping_carts/get_shopping_cart?shopping_cart_key=".concat(
              localStorage.cartKey
            ),
            1
          )
            .then(function(res) {
              setData(res);
              generateTotals(res);
              localStorage.setItem(
                "cartItem",
                JSON.stringify(res.shopping_cart_items)
              );
            })
            ["catch"](function(err) {})
            ["finally"](function() {
              setIsLoading(false);
            });
        },
        product_key: query.add_product_key,
        amount: query.qty || 1,
        showpop: function showpop(note1, note2, note3, note4) {
          setErrorPop(true);
          setErrorNote1(note1);
          setErrorNote2(note2);
          setErrorNote3(note3);
          setErrorNote4(note4);
        },
        setIsLoading: setIsLoading
      });
      return;
    }

    get(
      "api/v1/shopping_carts/get_shopping_cart?shopping_cart_key=".concat(
        localStorage.cartKey
      ),
      1
    )
      .then(function(res) {
        setData(res);
        generateTotals(res);
        localStorage.setItem(
          "cartItem",
          JSON.stringify(res.shopping_cart_items)
        );
      })
      ["catch"](function(err) {})
      ["finally"](function() {
        setIsLoading(false);
      });
  }, []);
  var cart1 = formatMessage({
    id: "cart.cart1"
  });
  var cart2 = formatMessage({
    id: "cart.cart2"
  });
  var cart3 = formatMessage({
    id: "cart.cart3"
  });
  var cart4 = formatMessage({
    id: "cart.cart4"
  });
  var cart5 = formatMessage({
    id: "cart.cart5"
  });
  var cart6 = formatMessage({
    id: "cart.cart6"
  });
  var cart7 = formatMessage({
    id: "cart.cart7"
  });
  var cart8 = formatMessage({
    id: "cart.cart8"
  });
  var cart9 = formatMessage({
    id: "cart.cart9"
  });
  var cart10 = formatMessage({
    id: "cart.cart10"
  });
  var cart11 = formatMessage({
    id: "cart.cart11"
  });
  var cart12 = formatMessage({
    id: "cart.cart12"
  });
  var cart14 = formatMessage({
    id: "cart.cart14"
  });
  var cart46 = formatMessage({
    id: "cart.cart46"
  });
  var cart47 = formatMessage({
    id: "cart.cart47"
  });
  var cart48 = formatMessage({
    id: "cart.cart48"
  });
  var cart64 = formatMessage({
    id: "cart.cart64"
  });
  var cart64tc = formatMessage({
    id: "cart.cart64tc"
  });
  var cart64b = formatMessage({
    id: "cart.cart64b"
  });
  var cart64c = formatMessage({
    id: "cart.cart64c"
  });
  var cart64d = formatMessage({
    id: "cart.cart64d"
  });
  var cartdeposit = formatMessage({
    id: "cart.deposit"
  });
  var cartpaynow = formatMessage({
    id: "cart.paynow"
  });
  var cartbalancedue = formatMessage({
    id: "cart.balancedue"
  });
  var cartdiscountamt = formatMessage({
    id: "cart.discountamt"
  });
  var cartinputdiscount = formatMessage({
    id: "cart.inputdiscount"
  });
  var cartinvaliddiscountcode = formatMessage({
    id: "cart.invaliddiscountcode"
  });
  var cartstarter01 = formatMessage({
    id: "cart.starter01"
  });
  var cartstarter02 = formatMessage({
    id: "cart.starter02"
  });
  var cartstarter03 = formatMessage({
    id: "cart.starter03"
  });
  var cartstarter04 = formatMessage({
    id: "cart.starter04"
  });
  var cartpack1disclaimer1 = formatMessage({
    id: "cart.pack1disclaimer1"
  });
  var cartpack1disclaimer2 = formatMessage({
    id: "cart.pack1disclaimer2"
  });
  var cartpack1disclaimer3 = formatMessage({
    id: "cart.pack1disclaimer3"
  });
  var cartpack1disclaimer4 = formatMessage({
    id: "cart.pack1disclaimer4"
  });
  var cartpack1disclaimer5 = formatMessage({
    id: "cart.pack1disclaimer5"
  });
  var cartpack1disclaimer6 = formatMessage({
    id: "cart.pack1disclaimer6"
  });
  var cartpack1disclaimer7 = formatMessage({
    id: "cart.pack1disclaimer7"
  });
  var cartdepositdisclaimer0 = formatMessage({
    id: "cart.depositdisclaimer0"
  });
  var cartdepositdisclaimer1 = formatMessage({
    id: "cart.depositdisclaimer1"
  });
  var cartdepositdisclaimer2 = formatMessage({
    id: "cart.depositdisclaimer2"
  });
  var cartremoveitemheader = formatMessage({
    id: "cartremoveitemheader"
  });
  var cartremoveitem = formatMessage({
    id: "cartremoveitem"
  });
  var cartremoveconfirm = formatMessage({
    id: "cartremoveconfirm"
  });
  var cartremovecancel = formatMessage({
    id: "cartremovecancel"
  });
  var cartempty1 = formatMessage({
    id: "cart.empty1"
  });
  var cartempty2 = formatMessage({
    id: "cart.empty2"
  });
  var cartempty3 = formatMessage({
    id: "cart.empty3"
  });
  var cartcontinueshopping = formatMessage({
    id: "cart.continueshopping"
  });
  var subsub = formatMessage({
    id: "subscription.sub"
  });
  var cartpaybytermcheckbox = formatMessage({
    id: "cartpaybytermcheckbox"
  });
  var cartmonthlypayments = formatMessage({
    id: "cartmonthlypayments"
  });
  var accessoriessection23 = formatMessage({
    id: "accessoriessection23"
  });
  var accessoriessection24 = formatMessage({
    id: "accessoriessection24"
  });
  var cartBenefitDisclaimer1 = formatMessage({
    id: "cartBenefitDisclaimer1"
  });
  var cartBenefitDisclaimer2 = formatMessage({
    id: "cartBenefitDisclaimer2"
  });
  var cartBenefitDisclaimer3 = formatMessage({
    id: "cartBenefitDisclaimer3"
  });
  var acceleratedDisclaimer1 = formatMessage({
    id: "acceleratedDisclaimer1"
  });
  var acceleratedDisclaimer2 = formatMessage({
    id: "acceleratedDisclaimer2"
  });
  var acceleratedDisclaimer3 = formatMessage({
    id: "acceleratedDisclaimer3"
  });
  var acceleratedDisclaimer4a = formatMessage({
    id: "acceleratedDisclaimer4a"
  });
  var acceleratedDisclaimer4b = formatMessage({
    id: "acceleratedDisclaimer4b"
  });
  var acceleratedDisclaimer4c = formatMessage({
    id: "acceleratedDisclaimer4c"
  });
  var acceleratedDisclaimer5 = formatMessage({
    id: "acceleratedDisclaimer5"
  });
  var r2d2StarterDisclaimer1 = formatMessage({
    id: "r2d2StarterDisclaimer1"
  });
  var r2d2StarterDisclaimer2 = formatMessage({
    id: "r2d2StarterDisclaimer2"
  });
  var r2d2StarterDisclaimer3 = formatMessage({
    id: "r2d2StarterDisclaimer3"
  });
  var r2d2StarterDisclaimer4a = formatMessage({
    id: "r2d2StarterDisclaimer4a"
  });
  var r2d2StarterDisclaimer4b = formatMessage({
    id: "r2d2StarterDisclaimer4b"
  });
  var r2d2StarterDisclaimer4c = formatMessage({
    id: "r2d2StarterDisclaimer4c"
  });
  var r2d2StarterDisclaimer5 = formatMessage({
    id: "r2d2StarterDisclaimer5"
  });
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "page"
      },
      /*#__PURE__*/ React.createElement(Header, null),
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "containers cart"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "mg",
            style: {
              paddingLeft: 5,
              paddingRight: 5
            }
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "topheader"
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "li active"
              },
              /*#__PURE__*/ React.createElement("span", null, "1"),
              /*#__PURE__*/ React.createElement("i", null, cart1)
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "li"
              },
              /*#__PURE__*/ React.createElement("span", null, "2"),
              /*#__PURE__*/ React.createElement("i", null, cart2)
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "li"
              },
              /*#__PURE__*/ React.createElement("span", null, "3"),
              /*#__PURE__*/ React.createElement("i", null, cart3)
            )
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "main",
              style: {
                position: "relative"
              }
            },
            /*#__PURE__*/ React.createElement(PreLoader, {
              isLoading: isLoading
            }),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "title"
              },
              cart1
            ),
            data.shopping_cart_items.length > 0
              ? /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "tabel"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "tabelheader"
                    },
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "desc"
                      },
                      cart4
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "qty"
                      },
                      cart5
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "price"
                      },
                      cart6
                    )
                  ),
                  data.shopping_cart_items.map(function(item, index) {
                    return /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        key: index,
                        className: "tabelmain"
                      },
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "desc"
                        },
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "img"
                          },
                          /*#__PURE__*/ React.createElement("img", {
                            src: item.product.image,
                            alt: "Product"
                          })
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "desctext"
                          },
                          /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              className: "toptext"
                            },
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "name-series"
                              },
                              localStorage.lang === "tw"
                                ? item.product.zhtw_product_series
                                : localStorage.lang === "en"
                                ? item.product.product_series
                                : item.product.product_series
                            ),
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "name"
                              },
                              localStorage.lang === "tw"
                                ? item.product.zhtw_product_item_name
                                : localStorage.lang === "en"
                                ? item.product.name
                                : item.product.name
                            ),
                            item.product.is_installment
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "name"
                                  },
                                  subsub
                                )
                              : null,
                            item.product.product_variation ===
                              "Build Yourself Kit"
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "desc"
                                  },
                                  cart48
                                )
                              : null,
                            item.product.product_variation === "Build Service"
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "build2"
                                  },
                                  /*#__PURE__*/ React.createElement("img", {
                                    src: STK_LOGO_BUILD_SERVICE_BUTTON,
                                    alt: "Build Service Logo"
                                  }),
                                  /*#__PURE__*/ React.createElement(
                                    "p",
                                    null,
                                    cart46
                                  ),
                                  /*#__PURE__*/ React.createElement(
                                    "u",
                                    {
                                      style: {
                                        display:
                                          item.product.product_key ===
                                          "stk_build_service"
                                            ? "block"
                                            : "none"
                                      },
                                      onClick: function onClick() {
                                        return build2(item);
                                      }
                                    },
                                    cart47
                                  )
                                )
                              : null,
                            item.custom_plaque_name
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "plaque-name"
                                  },
                                  accessoriessection23 + item.custom_plaque_name
                                )
                              : null,
                            item.custom_plaque_creditline
                              ? /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "plaque-creditline"
                                  },
                                  accessoriessection24 +
                                    item.custom_plaque_creditline
                                )
                              : null,
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                style: {
                                  marginTop: 20,
                                  display: item.product.is_installment
                                    ? "block"
                                    : "none"
                                }
                              },
                              item.product &&
                                item.product.benefit &&
                                item.product.benefit.tw
                                ? item.product.benefit.tw.map(function(
                                    benefit
                                  ) {
                                    return /*#__PURE__*/ React.createElement(
                                      "p",
                                      {
                                        key: benefit
                                      },
                                      /*#__PURE__*/ React.createElement("img", {
                                        className: "cart-checkmark",
                                        src: CART_CHECK_MARK,
                                        alt: "Checkmark"
                                      }),
                                      " ",
                                      benefit
                                    );
                                  })
                                : getSubBenefitTranslationKey(item).map(
                                    function(benefitKey) {
                                      return /*#__PURE__*/ React.createElement(
                                        "p",
                                        {
                                          key: benefitKey
                                        },
                                        /*#__PURE__*/ React.createElement(
                                          "img",
                                          {
                                            className: "cart-checkmark",
                                            src: CART_CHECK_MARK,
                                            alt: "Checkmark"
                                          }
                                        ),
                                        " ",
                                        formatMessage({
                                          id: benefitKey
                                        })
                                      );
                                    }
                                  )
                            ),
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "pts-long",
                                style: {
                                  marginTop: 20,
                                  display: [
                                    "btmf_pack_1a_starter_build_yourself",
                                    "btmf_pack_1a_starter_build_yourself_shop_special",
                                    "btmf_pack_1a_starter_build_yourself_shop_special_SFdelivery"
                                  ].includes(item.product.product_key)
                                    ? "block"
                                    : "none"
                                }
                              },
                              /*#__PURE__*/ React.createElement(
                                "p",
                                null,
                                /*#__PURE__*/ React.createElement("img", {
                                  className: "cart-checkmark",
                                  src: CART_CHECK_MARK,
                                  alt: "Checkmark"
                                }),
                                " ",
                                cartstarter01
                              ),
                              /*#__PURE__*/ React.createElement(
                                "p",
                                null,
                                /*#__PURE__*/ React.createElement("img", {
                                  className: "cart-checkmark",
                                  src: CART_CHECK_MARK,
                                  alt: "Checkmark"
                                }),
                                " ",
                                cartstarter02,
                                /*#__PURE__*/ React.createElement("br", null),
                                cartstarter03
                              ),
                              /*#__PURE__*/ React.createElement(
                                "p",
                                null,
                                /*#__PURE__*/ React.createElement("img", {
                                  className: "cart-checkmark",
                                  src: CART_CHECK_MARK,
                                  alt: "Checkmark"
                                }),
                                " ",
                                cartstarter04
                              )
                            )
                          ),
                          formatReceiveDate(
                            item.product.least_days_to_ship,
                            item.product.most_days_to_ship
                          ) != null && isShowShipDate(item)
                            ? /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "shipping-delivery-date"
                                },
                                formatReceiveDate(
                                  item.product.least_days_to_ship,
                                  item.product.most_days_to_ship
                                )
                              )
                            : null,
                          item.product.shipping_notice != ""
                            ? /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "shipping-notice"
                                },
                                /*#__PURE__*/ React.createElement(
                                  "span",
                                  null,
                                  localStorage.lang === "tw"
                                    ? item.product.zhhk_shipping_notice
                                    : localStorage.lang === "en"
                                    ? item.product.shipping_notice
                                    : item.product.shipping_notice
                                )
                              )
                            : null,
                          [
                            "build_yourself_kit",
                            "build_yourself_kit_with_installment"
                          ].includes(item.product.product_key)
                            ? /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "build1",
                                  onClick: function onClick() {
                                    return build1(item);
                                  }
                                },
                                /*#__PURE__*/ React.createElement("img", {
                                  src: STK_LOGO_BUILD_SERVICE_BUTTON,
                                  alt: "Build Service Logo"
                                }),
                                /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    className: "text"
                                  },
                                  cart8,
                                  /*#__PURE__*/ React.createElement(
                                    "p",
                                    null,
                                    cart9
                                  )
                                )
                              )
                            : null
                        )
                      ),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "qty qty-fixed",
                          style: {
                            display:
                              item.product.is_installment ||
                              item.product.is_balance_payment
                                ? "flex"
                                : "none"
                          }
                        },
                        item.amount
                      ),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "qty",
                          style: {
                            display:
                              item.product.is_installment ||
                              item.product.is_balance_payment
                                ? "none"
                                : "flex"
                          }
                        },
                        /*#__PURE__*/ React.createElement(
                          "span",
                          {
                            onClick: function onClick() {
                              return reduce(item);
                            }
                          },
                          "-"
                        ),
                        /*#__PURE__*/ React.createElement("input", {
                          type: "number",
                          value: item.amount,
                          maxLength: "2",
                          readOnly: true
                        }),
                        /*#__PURE__*/ React.createElement(
                          "span",
                          {
                            onClick: function onClick() {
                              return add(item);
                            }
                          },
                          "+"
                        )
                      ),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "price"
                        },
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "newprice",
                            style: {
                              color: [
                                "stk_build_service",
                                "stk_build_service_with_installment"
                              ].includes(item.product.product_key)
                                ? "#ff8800"
                                : "#000"
                            }
                          },
                          "NT$",
                          " ",
                          item.price_subtotal
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "mon",
                            style: {
                              display:
                                item.product.is_installment &&
                                isShowNextMonthPaymentAmount({
                                  cartItem: item
                                })
                                  ? "block"
                                  : "none"
                            }
                          },
                          "(",
                          localStorage.lang !== "en" ? cart64tc : null,
                          "NT$",
                          " ",
                          Math.floor(item.product.price),
                          localStorage.lang === "en" ? cart64 : null,
                          ")"
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "deposit",
                            style: {
                              display:
                                item.product.deposit_amount > 0
                                  ? "block"
                                  : "none"
                            }
                          },
                          cartdeposit,
                          ": ",
                          "NT$",
                          " ",
                          item.payment_subtotal
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "del",
                            onClick: function onClick() {
                              return showpop(item.id);
                            },
                            style: {
                              color: "#777"
                            }
                          },
                          cart7
                        )
                      ),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: showPop ? "pop" : "hidden"
                        },
                        /*#__PURE__*/ React.createElement(
                          "h3",
                          null,
                          cartremoveitemheader
                        ),
                        /*#__PURE__*/ React.createElement(
                          "p",
                          null,
                          cartremoveitem
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "btn btn-confirm",
                            onClick: function onClick() {
                              return hidepop();
                            }
                          },
                          cartremovecancel
                        ),
                        /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "btn btn-cancel",
                            onClick: function onClick() {
                              return delcart();
                            }
                          },
                          cartremoveconfirm
                        ),
                        /*#__PURE__*/ React.createElement("img", {
                          src: CLOSE,
                          alt: "Close Dialog",
                          className: "close",
                          onClick: function onClick() {
                            return hidepop();
                          }
                        })
                      )
                    );
                  }),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "tabelbot"
                    },
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "left"
                      },
                      isShowBenefitDisclaimer({
                        cartItems: data.shopping_cart_items
                      }) &&
                        /*#__PURE__*/ React.createElement(
                          "p",
                          {
                            className: "cart-subscription-disclaimer",
                            style: {
                              color: "#555"
                            }
                          },
                          cartBenefitDisclaimer1,
                          /*#__PURE__*/ React.createElement(
                            "a",
                            {
                              href: "/faq"
                            },
                            cartBenefitDisclaimer2
                          ),
                          cartBenefitDisclaimer3
                        ),
                      data &&
                        Array.isArray(data.shopping_cart_items) &&
                        data.shopping_cart_items.some(function(item) {
                          return (
                            item.product.product_key ===
                            "btmf_accelerated_starter_plan_1_5"
                          );
                        }) &&
                        /*#__PURE__*/ React.createElement(
                          "p",
                          {
                            className: "cart-subscription-disclaimer",
                            style: {
                              color: "#555",
                              maxWidth: "100%",
                              width: 800
                            }
                          },
                          acceleratedDisclaimer1,
                          /*#__PURE__*/ React.createElement("br", null),
                          acceleratedDisclaimer2,
                          /*#__PURE__*/ React.createElement("br", null),
                          acceleratedDisclaimer3,
                          /*#__PURE__*/ React.createElement("br", null),
                          acceleratedDisclaimer4a,
                          acceleratedStarterPlanSinglePay,
                          acceleratedDisclaimer4b,
                          acceleratedStarterPlanEachMonth,
                          acceleratedDisclaimer4c,
                          /*#__PURE__*/ React.createElement("br", null),
                          acceleratedDisclaimer5
                        ),
                      data &&
                        Array.isArray(data.shopping_cart_items) &&
                        data.shopping_cart_items.some(function(item) {
                          return (
                            item.product.product_key ===
                            "r2d2_accelerated_starter_plan_1_5"
                          );
                        }) &&
                        /*#__PURE__*/ React.createElement(
                          "p",
                          {
                            className: "cart-subscription-disclaimer",
                            style: {
                              color: "#555",
                              maxWidth: "100%",
                              width: 800
                            }
                          },
                          r2d2StarterDisclaimer1,
                          /*#__PURE__*/ React.createElement("br", null),
                          r2d2StarterDisclaimer2,
                          /*#__PURE__*/ React.createElement("br", null),
                          r2d2StarterDisclaimer3,
                          /*#__PURE__*/ React.createElement("br", null),
                          r2d2StarterDisclaimer4a,
                          r2d2StarterPlanSinglePay,
                          r2d2StarterDisclaimer4b,
                          r2d2StarterPlanEachMonth,
                          r2d2StarterDisclaimer4c,
                          /*#__PURE__*/ React.createElement("br", null),
                          r2d2StarterDisclaimer5
                        ),
                      data.shopping_cart_items.length === 1 &&
                        data.shopping_cart_items[0].product.product_key ===
                          "build_yourself_kit" &&
                        data.shopping_cart_items[0].amount === 1
                        ? /*#__PURE__*/ React.createElement(
                            "p",
                            {
                              className: "cart-subscription-disclaimer",
                              style: {
                                color: "#555"
                              }
                            },
                            cartpack1disclaimer1,
                            cartpack1disclaimer2,
                            /*#__PURE__*/ React.createElement("br", null),
                            cartpack1disclaimer3,
                            /*#__PURE__*/ React.createElement(
                              "span",
                              {
                                style: {
                                  fontStyle: "italic"
                                }
                              },
                              cartpack1disclaimer4
                            ),
                            cartpack1disclaimer5,
                            cartpack1disclaimer6,
                            /*#__PURE__*/ React.createElement(
                              "span",
                              {
                                style: {
                                  color: "#000",
                                  textDecoration: "underline",
                                  cursor: "pointer"
                                },
                                onClick: function onClick() {
                                  return build3();
                                }
                              },
                              cartpack1disclaimer7
                            )
                          )
                        : null,
                      hasDeposit
                        ? /*#__PURE__*/ React.createElement(
                            "p",
                            {
                              className: "cart-subscription-disclaimer",
                              style: {
                                color: "#555"
                              }
                            },
                            cartdepositdisclaimer0,
                            /*#__PURE__*/ React.createElement("br", null),
                            cartdepositdisclaimer1,
                            /*#__PURE__*/ React.createElement(
                              "a",
                              {
                                href: "".concat(
                                  requestParam$1.r2d2Url,
                                  "/r2d2/faq"
                                ),
                                target: "_blank",
                                rel: "noopener noreferrer"
                              },
                              /*#__PURE__*/ React.createElement(
                                "span",
                                {
                                  style: {
                                    color: "#000",
                                    textDecoration: "underline",
                                    cursor: "pointer"
                                  }
                                },
                                cartdepositdisclaimer2
                              )
                            )
                          )
                        : null
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "right"
                      },
                      isShowDiscountCode({
                        cartItems: data.shopping_cart_items
                      }) &&
                        /*#__PURE__*/ React.createElement(
                          React.Fragment,
                          null,
                          !data.discount_code
                            ? /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "discount-code-container"
                                },
                                /*#__PURE__*/ React.createElement("input", {
                                  id: "discount-code",
                                  type: "text",
                                  placeholder: cartinputdiscount,
                                  onInput: function onInput(e) {
                                    return setDiscount_code(e.target.value);
                                  },
                                  value: discount_code,
                                  maxLength: "10"
                                }),
                                /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    id: "btn-apply-discount-code",
                                    className: "btn-discount-code",
                                    onClick: function onClick() {
                                      return applyDiscountCode();
                                    }
                                  },
                                  "Apply"
                                )
                              )
                            : /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "discount-code-container"
                                },
                                /*#__PURE__*/ React.createElement("input", {
                                  id: "discount-code",
                                  type: "text",
                                  placeholder: cartinputdiscount,
                                  onInput: function onInput(e) {
                                    return setDiscount_code(e.target.value);
                                  },
                                  value: discount_code,
                                  maxLength: "10",
                                  readOnly: true
                                }),
                                /*#__PURE__*/ React.createElement(
                                  "div",
                                  {
                                    id: "btn-remove-discount-code",
                                    className: "btn-discount-code",
                                    onClick: function onClick() {
                                      return removeDiscountCode();
                                    }
                                  },
                                  "Remove"
                                )
                              ),
                          invalidDiscountCode
                            ? /*#__PURE__*/ React.createElement(
                                "div",
                                {
                                  className: "discount-code-error"
                                },
                                cartinvaliddiscountcode
                              )
                            : null
                        ),
                      hasDeposit ||
                        data.shopping_cart_items[0].product.is_installment ===
                          true ||
                        data.payment_total < priceToAllowInstallment
                        ? null
                        : /*#__PURE__*/ React.createElement(
                            React.Fragment,
                            null,
                            /*#__PURE__*/ React.createElement(
                              "div",
                              {
                                className: "checkbox checkbox-paybyterm"
                              },
                              /*#__PURE__*/ React.createElement("input", {
                                type: "checkbox",
                                id: "checkbox-paybyterm",
                                name: "checkbox-paybyterm",
                                checked: payByTerm,
                                onChange: function onChange(e) {
                                  return togglePayByTerm(e);
                                }
                              }),
                              /*#__PURE__*/ React.createElement(
                                "label",
                                {
                                  htmlFor: "checkbox-paybyterm"
                                },
                                cartpaybytermcheckbox
                              )
                            ),
                            payByTerm
                              ? /*#__PURE__*/ React.createElement(
                                  React.Fragment,
                                  null,
                                  /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "term-duration"
                                    },
                                    /*#__PURE__*/ React.createElement("input", {
                                      id: "term-duration",
                                      type: "text",
                                      readOnly: true,
                                      placeholder: "3",
                                      value: termDuration,
                                      style: {
                                        cursor: "pointer"
                                      },
                                      onClick: function onClick() {
                                        return chooseTermDuration();
                                      }
                                    }),
                                    /*#__PURE__*/ React.createElement(
                                      "div",
                                      {
                                        onClick: function onClick() {
                                          return chooseTermDuration();
                                        },
                                        style: {
                                          width: 12,
                                          height: 8,
                                          position: "absolute",
                                          top: 0,
                                          right: 0,
                                          cursor: "pointer"
                                        }
                                      },
                                      /*#__PURE__*/ React.createElement("img", {
                                        style: {
                                          width: "100%",
                                          height: "100%"
                                        },
                                        src: RECTANGLE,
                                        alt: "Dropdown Icon"
                                      })
                                    ),
                                    /*#__PURE__*/ React.createElement(
                                      "div",
                                      {
                                        className: "choose-term-duration",
                                        style: {
                                          display: showTermDurationDropdown
                                            ? "block"
                                            : "none",
                                          bottom: -49,
                                          cursor: "pointer"
                                        }
                                      },
                                      /*#__PURE__*/ React.createElement(
                                        "span",
                                        {
                                          onClick: closeTermDuration,
                                          style: {
                                            cursor: "pointer",
                                            display: "block",
                                            height: "21px",
                                            width: "21px",
                                            position: "absolute",
                                            right: "-9px",
                                            top: "-9px",
                                            border: "1px solid #000",
                                            borderRadius: "50%",
                                            backgroundColor: "#000",
                                            color: "#FFF",
                                            zIndex: "100",
                                            textAlign: "center",
                                            fontSize: "16px",
                                            lineHeight: "16px",
                                            fontWeight: "bold"
                                          }
                                        },
                                        "x"
                                      ),
                                      availableTermDuration.map(function(
                                        allowMonth
                                      ) {
                                        return /*#__PURE__*/ React.createElement(
                                          "div",
                                          {
                                            key: allowMonth,
                                            onClick: function onClick() {
                                              return selectTermDuration(
                                                allowMonth
                                              );
                                            },
                                            style: {
                                              cursor: "pointer"
                                            }
                                          },
                                          allowMonth,
                                          " ",
                                          cartmonthlypayments
                                        );
                                      })
                                    )
                                  ),
                                  /*#__PURE__*/ React.createElement(
                                    "span",
                                    null,
                                    cartmonthlypayments
                                  ),
                                  /*#__PURE__*/ React.createElement(
                                    "div",
                                    {
                                      className: "inst-amt"
                                    },
                                    cart64c,
                                    " ",
                                    "NT$",
                                    " ",
                                    installmentAmount,
                                    " ",
                                    cart64b
                                  )
                                )
                              : null
                          ),
                      data.discount_amount > 0
                        ? /*#__PURE__*/ React.createElement(
                            "p",
                            {
                              className: "p1"
                            },
                            cartdiscountamt,
                            /*#__PURE__*/ React.createElement(
                              "span",
                              null,
                              "NT$",
                              " ",
                              data.discount_amount
                            )
                          )
                        : null,
                      /*#__PURE__*/ React.createElement(
                        "p",
                        {
                          className: "p1 payment-due-today",
                          style: {
                            display: hasDeposit ? "flex" : "none"
                          }
                        },
                        cartpaynow,
                        /*#__PURE__*/ React.createElement(
                          "span",
                          null,
                          "NT$",
                          " ",
                          paymentTotal
                        )
                      ),
                      /*#__PURE__*/ React.createElement(
                        "p",
                        {
                          className: "p1",
                          style: {
                            display: hasDeposit ? "flex" : "none"
                          }
                        },
                        cartbalancedue,
                        " ",
                        /*#__PURE__*/ React.createElement(
                          "span",
                          null,
                          "NT$",
                          " ",
                          remainingBal
                        )
                      ),
                      /*#__PURE__*/ React.createElement(
                        "p",
                        {
                          className: "p1"
                        },
                        cart10,
                        " ",
                        /*#__PURE__*/ React.createElement(
                          "span",
                          null,
                          shipping_fee === 0
                            ? cart11
                            : "NT$".concat(" ", shipping_fee)
                        )
                      ),
                      /*#__PURE__*/ React.createElement(
                        "p",
                        {
                          className: "p1",
                          style: {
                            fontWeight: "bold"
                          }
                        },
                        cart12,
                        /*#__PURE__*/ React.createElement(
                          "span",
                          {
                            style: {
                              fontWeight: "bold"
                            }
                          },
                          "NT$",
                          " ",
                          grandTotal,
                          " "
                        )
                      ),
                      data.shopping_cart_items[0].product.is_installment &&
                        isShowNextMonthPaymentAmount({
                          cartItems: data.shopping_cart_items
                        })
                        ? /*#__PURE__*/ React.createElement(
                            "p",
                            {
                              className: "p1"
                            },
                            cart64d,
                            /*#__PURE__*/ React.createElement(
                              "span",
                              null,
                              "NT$",
                              " ",
                              data.subscription_fee,
                              " "
                            )
                          )
                        : null,
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "btn",
                          onClick: function onClick() {
                            return push(requestParam$1.webBaseURL + "/cart2");
                          }
                        },
                        cart14
                      ),
                      /*#__PURE__*/ React.createElement("div", {
                        style: {
                          clear: "both"
                        }
                      }),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "continue-shopping-link",
                          style: {
                            marginBottom: 30
                          }
                        },
                        /*#__PURE__*/ React.createElement(
                          "a",
                          {
                            href: shoppingPath,
                            style: {
                              color: "#000"
                            }
                          },
                          cartcontinueshopping
                        )
                      ),
                      /*#__PURE__*/ React.createElement("div", {
                        style: {
                          clear: "both"
                        }
                      })
                    )
                  )
                )
              : /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "empty-cart-wrapper"
                  },
                  /*#__PURE__*/ React.createElement("img", {
                    src: SHOPPING_CART_512,
                    alt: "Empty Shopping Cart",
                    className: "empty-cart-image"
                  }),
                  /*#__PURE__*/ React.createElement(
                    "p",
                    {
                      className: "empty-cart-heading"
                    },
                    cartempty1
                  ),
                  /*#__PURE__*/ React.createElement(
                    "p",
                    {
                      className: "empty-cart-p"
                    },
                    cartempty2
                  ),
                  /*#__PURE__*/ React.createElement(
                    "p",
                    {
                      className: "empty-cart-p2"
                    },
                    /*#__PURE__*/ React.createElement(
                      "a",
                      {
                        href: shoppingPath
                      },
                      cartempty3
                    )
                  )
                )
          )
        )
      ),
      /*#__PURE__*/ React.createElement("div", {
        id: "mask",
        className: "mask",
        style: {
          display: showPop ? "block" : "none"
        }
      })
    ),
    /*#__PURE__*/ React.createElement(ErrorModal, {
      note1: errorNote1,
      note2: errorNote2,
      note3: errorNote3,
      note4: errorNote4,
      isOpen: errorPop,
      onCloseButtonClick: function onCloseButtonClick() {
        setErrorPop(false);
      }
    })
  );
};

var Cart1 = function Cart1(_ref) {
  var continuePath = _ref.continuePath;
  return /*#__PURE__*/ React.createElement(MobileDetector, {
    desktopChildren: /*#__PURE__*/ React.createElement(Cart1Web, {
      continuePath: continuePath
    }),
    mobileChildren: /*#__PURE__*/ React.createElement(Cart1Mobile, {
      continuePath: continuePath
    })
  });
};

var Cart2Mobile = function Cart2Mobile() {
  var cart2 = formatMessage({
    id: "cart.cart2"
  });
  var cart15 = formatMessage({
    id: "cart.cart15"
  });
  var cart16 = formatMessage({
    id: "cart.cart16"
  });
  var cart17 = formatMessage({
    id: "cart.cart17"
  });
  var cart18 = formatMessage({
    id: "cart.cart18"
  });
  var emaildisclaimer = formatMessage({
    id: "cart.emaildisclaimer"
  });
  var mobiledisclaimer = formatMessage({
    id: "cart.mobiledisclaimer"
  });
  var passworddisclaimer = formatMessage({
    id: "cart.passworddisclaimer"
  });
  var cart21 = formatMessage({
    id: "cart.cart21"
  });
  var cart22 = formatMessage({
    id: "cart.cart22"
  });
  var cart23 = formatMessage({
    id: "cart.cart23"
  });
  var cart26 = formatMessage({
    id: "cart.cart26"
  });
  var cart27 = formatMessage({
    id: "cart.cart27"
  });
  var cart28 = formatMessage({
    id: "cart.cart28"
  });
  var cart29 = formatMessage({
    id: "cart.cart29"
  });
  var cart45 = formatMessage({
    id: "cart.cart45"
  });
  var cart66 = formatMessage({
    id: "cart.cart66"
  });
  var cart69 = formatMessage({
    id: "cart.cart69"
  });
  var cart70 = formatMessage({
    id: "cart.cart70"
  });
  var ordervalidinfo = formatMessage({
    id: "ordervalidinfo"
  });
  var paymentdisclaimer = formatMessage({
    id: "paymentdisclaimer"
  });
  var paymentdisclaimer2 = formatMessage({
    id: "paymentdisclaimer2"
  });
  var paymentdisclaimer3 = formatMessage({
    id: "paymentdisclaimer3"
  });
  var paymentdisclaimer4 = formatMessage({
    id: "paymentdisclaimer4"
  });
  var paymentdepositdisclaimer = formatMessage({
    id: "paymentdepositdisclaimer"
  });
  var paymentdepositdisclaimer2 = formatMessage({
    id: "paymentdepositdisclaimer2"
  });
  var mustagreedisclaimer = formatMessage({
    id: "mustagreedisclaimer"
  });

  var _useState = useState({
      amount: 1,
      orderRef: Date.parse(new Date()),
      secureHash: "1",
      subscription_fee: 0,
      nSch: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];

  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    checkAgree = _useState4[0],
    setCheckAgree = _useState4[1];

  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];

  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasDeposit = _useState8[0],
    setHasDeposit = _useState8[1];

  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2);
  _useState10[0];
  var setRemainingBal = _useState10[1];

  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2);
  _useState12[0];
  var setGrandTotal = _useState12[1];

  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2);
  _useState14[0];
  var setPaymentTotal = _useState14[1];

  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    first_name = _useState16[0],
    setFirst_name = _useState16[1];

  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    last_name = _useState18[0],
    setLast_name = _useState18[1];

  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    email = _useState20[0],
    setEmail = _useState20[1];

  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2),
    contact_number = _useState22[0],
    setContact_number = _useState22[1];

  var _useState23 = useState(""),
    _useState24 = _slicedToArray(_useState23, 2),
    password = _useState24[0],
    setPassword = _useState24[1];

  var _useState25 = useState(""),
    _useState26 = _slicedToArray(_useState25, 2),
    receiver_name = _useState26[0],
    setReceiver_name = _useState26[1];

  var _useState27 = useState(""),
    _useState28 = _slicedToArray(_useState27, 2),
    address_line_1 = _useState28[0],
    setAddress_line_1 = _useState28[1];

  var _useState29 = useState(""),
    _useState30 = _slicedToArray(_useState29, 2),
    city = _useState30[0],
    setCity = _useState30[1];

  var _useState31 = useState(""),
    _useState32 = _slicedToArray(_useState31, 2),
    district = _useState32[0],
    setDistrict = _useState32[1];

  var _useState33 = useState(""),
    _useState34 = _slicedToArray(_useState33, 2),
    postal_code = _useState34[0],
    setPostal_code = _useState34[1];

  var _useState35 = useState(""),
    _useState36 = _slicedToArray(_useState35, 2),
    country = _useState36[0],
    setCountry = _useState36[1];

  var _useState37 = useState(""),
    _useState38 = _slicedToArray(_useState37, 2),
    gift_message = _useState38[0],
    setGift_message = _useState38[1];

  var _useState39 = useState(""),
    _useState40 = _slicedToArray(_useState39, 2),
    recipient_contact_number = _useState40[0],
    setRecipient_contact_number = _useState40[1];

  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    is_gift = _useState42[0],
    setIs_gift = _useState42[1];

  var _useState43 = useState(null),
    _useState44 = _slicedToArray(_useState43, 2),
    shopping_cart_id = _useState44[0],
    setShopping_cart_id = _useState44[1];

  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 1),
    isPickup = _useState46[0];

  var _useState47 = useState(1),
    _useState48 = _slicedToArray(_useState47, 1),
    physical_store_id = _useState48[0];

  var _useState49 = useState([]),
    _useState50 = _slicedToArray(_useState49, 2),
    districtList = _useState50[0],
    setDistrictList = _useState50[1];

  var _useState51 = useState(false),
    _useState52 = _slicedToArray(_useState51, 2),
    showCityList = _useState52[0],
    setShowCityList = _useState52[1];

  var _useState53 = useState(false),
    _useState54 = _slicedToArray(_useState53, 2),
    showDistrictList = _useState54[0],
    setShowDistrictList = _useState54[1];

  var _useState55 = useState(false),
    _useState56 = _slicedToArray(_useState55, 2),
    showCountryList = _useState56[0],
    setShowCountryList = _useState56[1];

  var _useState57 = useState({}),
    _useState58 = _slicedToArray(_useState57, 2),
    submitPaymentError = _useState58[0],
    setSubmitPaymentError = _useState58[1];

  var _useState59 = useState(""),
    _useState60 = _slicedToArray(_useState59, 2),
    orderRef = _useState60[0],
    setOrderRef = _useState60[1];

  var _useState61 = useState(false),
    _useState62 = _slicedToArray(_useState61, 2),
    isLoading = _useState62[0],
    setIsLoading = _useState62[1];

  var _useState63 = useState(false),
    _useState64 = _slicedToArray(_useState63, 2),
    triggerFormSubmit = _useState64[0],
    setTriggerFormSubmit = _useState64[1];

  var paymentFormRef = useRef();

  var submit = function submit() {
    //#region validation
    var newSubmitPaymentError = {}; // personal information

    if (first_name === "") {
      newSubmitPaymentError.first_namePlaceholder = true;
    }

    if (last_name === "") {
      newSubmitPaymentError.last_namePlaceholder = true;
    }

    if (contact_number === "") {
      newSubmitPaymentError.contact_numberPlaceholder = true;
    }

    if (contact_number.length > 0 && contact_number.length < 8) {
      newSubmitPaymentError.contact_numberText = true;
    }

    if (email === "") {
      newSubmitPaymentError.emailPlaceholder = true;
    }

    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      newSubmitPaymentError.emailText = true;
    }

    if (password.length > 0 && password.length < 8) {
      newSubmitPaymentError.passwordText = true;
    } // shipping address

    if (!isPickup) {
      if (receiver_name === "") {
        newSubmitPaymentError.receiver_namePlaceholder = true;
      }

      if (address_line_1 === "") {
        newSubmitPaymentError.address_line_1Placeholder = true;
      }

      if (city === "") {
        newSubmitPaymentError.cityPlaceholder = true;
      }

      if (!district) {
        newSubmitPaymentError.districtPlaceholder = true;
      }

      if (country === "") {
        newSubmitPaymentError.countryPlaceholder = true;
      }
    }

    if (hasDeposit && !checkAgree) {
      newSubmitPaymentError.agree = true;
    }

    setSubmitPaymentError(newSubmitPaymentError);
    if (Object.keys(newSubmitPaymentError).length > 0) return; //#endregion

    if (!localStorage.lang) {
      localStorage.lang = "en";
    }

    var language = localStorage.lang;
    localStorage.setItem("password", password);
    localStorage.setItem("email", email);
    var termDuration;

    if (localStorage.payByTerm === "true") {
      termDuration = localStorage.termduration;
    } else {
      termDuration = 0;
    }

    if (
      hasDeposit ||
      data.is_installment ||
      data.payment_total < priceToAllowInstallment
    ) {
      localStorage.setItem("payByTerm", "false");
      termDuration = 0;
    }

    var url = "";

    if (isPickup) {
      url = "api/v1/payments/get_secure_hash?first_name="
        .concat(encodeURIComponent(first_name), "&last_name=")
        .concat(encodeURIComponent(last_name), "&email=")
        .concat(encodeURIComponent(email), "&receiver_name=")
        .concat(
          encodeURIComponent(first_name + " " + last_name),
          "&address_line_1=",
          "&address_line_2=",
          "&city=",
          "&district="
        )
        .concat(encodeURIComponent(district), "&postal_code=")
        .concat(
          encodeURIComponent(postal_code),
          "&country=",
          "Taiwan",
          "&is_gift="
        )
        .concat(encodeURIComponent(is_gift), "&shopping_cart_id=")
        .concat(
          encodeURIComponent(shopping_cart_id),
          "&provision=&contact_number="
        )
        .concat(encodeURIComponent(contact_number), "&language=")
        .concat(encodeURIComponent(language), "&physical_store_id=")
        .concat(encodeURIComponent(physical_store_id), "&term=")
        .concat(encodeURIComponent(termDuration))
        .concat(
          orderRef ? "&order_ref=".concat(encodeURIComponent(orderRef)) : ""
        );
    } else if (is_gift) {
      url = "api/v1/payments/get_secure_hash?first_name="
        .concat(encodeURIComponent(first_name), "&last_name=")
        .concat(encodeURIComponent(last_name), "&email=")
        .concat(encodeURIComponent(email), "&receiver_name=")
        .concat(encodeURIComponent(receiver_name), "&address_line_1=")
        .concat(
          encodeURIComponent(address_line_1),
          "&address_line_2=",
          "&city="
        )
        .concat(encodeURIComponent(city), "&district=")
        .concat(encodeURIComponent(district), "&postal_code=")
        .concat(encodeURIComponent(postal_code), "&country=")
        .concat(encodeURIComponent(country), "&gift_message=")
        .concat(encodeURIComponent(gift_message), "&recipient_contact_number=")
        .concat(encodeURIComponent(recipient_contact_number), "&is_gift=")
        .concat(encodeURIComponent(is_gift), "&shopping_cart_id=")
        .concat(
          encodeURIComponent(shopping_cart_id),
          "&provision=&contact_number="
        )
        .concat(encodeURIComponent(contact_number), "&language=")
        .concat(encodeURIComponent(language), "&term=")
        .concat(encodeURIComponent(termDuration))
        .concat(
          orderRef ? "&order_ref=".concat(encodeURIComponent(orderRef)) : ""
        );
    } else {
      url = "api/v1/payments/get_secure_hash?first_name="
        .concat(encodeURIComponent(first_name), "&last_name=")
        .concat(encodeURIComponent(last_name), "&email=")
        .concat(encodeURIComponent(email), "&receiver_name=")
        .concat(encodeURIComponent(receiver_name), "&address_line_1=")
        .concat(
          encodeURIComponent(address_line_1),
          "&address_line_2=",
          "&city="
        )
        .concat(encodeURIComponent(city), "&district=")
        .concat(encodeURIComponent(district), "&postal_code=")
        .concat(encodeURIComponent(postal_code), "&country=")
        .concat(encodeURIComponent(country), "&is_gift=")
        .concat(encodeURIComponent(is_gift), "&shopping_cart_id=")
        .concat(
          encodeURIComponent(shopping_cart_id),
          "&provision=&contact_number="
        )
        .concat(encodeURIComponent(contact_number), "&language=")
        .concat(encodeURIComponent(language), "&term=")
        .concat(encodeURIComponent(termDuration))
        .concat(
          orderRef ? "&order_ref=".concat(encodeURIComponent(orderRef)) : ""
        );
    }

    setIsLoading(true);
    get(url, 1, 23)
      .then(function(res) {
        var response = res.response;
        var newForm = {};
        newForm.secureHash = response.secure_hash;
        newForm.orderRef = response.order_ref;
        newForm.amount = parseInt(localStorage.paymentTotal);
        newForm.subscription_fee = response.subscription_fee;
        newForm.nSch = response.nSch;
        newForm.userID = response.subscription_ref;
        newForm.note1 = response.order_ref;
        localStorage.setItem("orderId", response.id);
        setForm(newForm);

        if (data.shopping_cart_items[0].product.is_installment) {
          window.location.href = requestParam$1.webBaseURL + "/payment";
        } else {
          setTriggerFormSubmit(true);
        }
      })
      ["catch"](function(err) {
        alert("err");
        setIsLoading(false);
      });
  };

  var toggleIsGift = function toggleIsGift(e) {
    setIs_gift(e.target.checked);
    setReceiver_name("");
    setAddress_line_1("");
    setCity("");
    setDistrict("");
    setPostal_code("");
    setDistrictList([]);
    setCountry("");
  };

  var toggleAgree = function toggleAgree(e) {
    setCheckAgree(e.target.checked);
  };

  var toggleCityList = function toggleCityList() {
    if (!showCityList) {
      setShowCityList(true);
      setShowDistrictList(false);
      setShowCountryList(false);
    } else {
      setShowCityList(false);
    }
  };

  var toggleDistrictList = function toggleDistrictList() {
    if (!showDistrictList) {
      setShowCityList(false);
      setShowDistrictList(true);
      setShowCountryList(false);
    } else {
      setShowDistrictList(false);
    }
  };

  var toggleCountryList = function toggleCountryList() {
    if (!showCountryList) {
      setShowCityList(false);
      setShowDistrictList(false);
      setShowCountryList(true);
    } else {
      setShowCountryList(false);
    }
  };

  var selectCity = function selectCity(val, list) {
    setCity(val);
    setDistrictList(list);
    setDistrict("");
    setPostal_code("");
    setShowCityList(false);
  };

  var selectDistrict = function selectDistrict(val, code) {
    setDistrict(val);
    setPostal_code(code);
    setShowDistrictList(false);
  };

  var selectCountry = function selectCountry(val) {
    setCountry(val);
    setShowCountryList(false);
  };

  var paymentForm = function paymentForm() {
    return /*#__PURE__*/ React.createElement(
      "form",
      {
        name: "payForm",
        method: "post",
        action: requestParam$1.paymentUrl,
        ref: paymentFormRef
      },
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "web",
        value: requestParam$1.merchantID
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "MN",
        value: form.amount.toFixed(0)
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "Td",
        value: form.orderRef
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "sdt",
        value: contact_number
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "email",
        value: email
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "Card_Type",
        value: "2"
      }),
      localStorage.payByTerm === "true"
        ? /*#__PURE__*/ React.createElement("input", {
            type: "hidden",
            name: "Term",
            value: localStorage.termduration
          })
        : null,
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "ChkValue",
        value: form.secureHash
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "userID",
        value: form.userID
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "note1",
        value: form.note1
      })
    );
  };

  useEffect(function() {
    if (localStorage.historyOrderRef) {
      setOrderRef(localStorage.historyOrderRef);
      localStorage.setItem("historyOrderRef", "");
    }

    if (localStorage.cartdata) {
      var tmpCartData;
      tmpCartData = JSON.parse(localStorage.cartdata);
      setHasDeposit(
        tmpCartData.shopping_cart_items.some(function(item) {
          return item.product.deposit_amount > 0;
        })
      );
      var tmpTotal = (tmpCartData.total - tmpCartData.discount_amount).toFixed(
        0
      );
      var remBal = tmpTotal - tmpCartData.payment_total;
      setRemainingBal(remBal);
      setGrandTotal(tmpTotal);
      setPaymentTotal(tmpCartData.payment_total);
      setData(tmpCartData);
      setShopping_cart_id(tmpCartData.id);
    } else {
      window.location.href = requestParam$1.webBaseURL + "/cart1";
    }

    if (localStorage.user) {
      var _districtTW$find;

      var user = JSON.parse(localStorage.user);
      setEmail(user.email);
      setContact_number(user.contact_number);
      setFirst_name(user.first_name);
      setLast_name(user.last_name);
      setReceiver_name(user.receiver_name);
      setAddress_line_1(user.address_line_1 == "-" ? "" : user.address_line_1);
      setCity(user.city == "-" ? "" : user.city);
      setDistrict(user.district == "-" ? "" : user.district);
      setDistrictList(
        ((_districtTW$find = districtTW.find(function(c) {
          return (
            formatMessage({
              id: c.tKey
            }) === user.city
          );
        })) === null || _districtTW$find === void 0
          ? void 0
          : _districtTW$find.district) || []
      );
      setPostal_code(user.postal_code);
      setCountry(user.country);
    } else {
      setCountry(cart66);
    }
  }, []);
  useEffect(
    function() {
      if (triggerFormSubmit) {
        var _paymentFormRef$curre;

        (_paymentFormRef$curre = paymentFormRef.current) === null ||
        _paymentFormRef$curre === void 0
          ? void 0
          : _paymentFormRef$curre.submit();
        setTriggerFormSubmit(false);
      }
    },
    [triggerFormSubmit]
  );
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, {
      type: 2
    }),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers mobilecart"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "mg cart2 mpad_all"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "topheader"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "title"
            },
            cart2
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "ul"
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "li active"
              },
              /*#__PURE__*/ React.createElement("span", null, "1"),
              /*#__PURE__*/ React.createElement("i", null)
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "li active"
              },
              /*#__PURE__*/ React.createElement("span", null, "2"),
              /*#__PURE__*/ React.createElement("i", null)
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "li"
              },
              /*#__PURE__*/ React.createElement("span", null, "3")
            )
          )
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "main"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "left"
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "title"
              },
              cart15
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "form"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "group"
                },
                /*#__PURE__*/ React.createElement("input", {
                  className: "".concat(
                    submitPaymentError.first_namePlaceholder
                      ? "form-error-placeholder"
                      : ""
                  ),
                  id: "order-form-first-name",
                  type: "text",
                  placeholder: cart16,
                  onInput: function onInput(e) {
                    return setFirst_name(e.target.value);
                  },
                  value: first_name,
                  maxLength: "60"
                }),
                /*#__PURE__*/ React.createElement("input", {
                  className: "".concat(
                    submitPaymentError.last_namePlaceholder
                      ? "form-error-placeholder"
                      : ""
                  ),
                  id: "order-form-last-name",
                  type: "text",
                  placeholder: cart17,
                  onInput: function onInput(e) {
                    return setLast_name(e.target.value);
                  },
                  value: last_name,
                  maxLength: "60"
                })
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "group"
                },
                /*#__PURE__*/ React.createElement("input", {
                  className: ""
                    .concat(
                      submitPaymentError.contact_numberPlaceholder
                        ? "form-error-placeholder"
                        : "",
                      " "
                    )
                    .concat(
                      submitPaymentError.contact_numberText
                        ? "form-error-text"
                        : ""
                    ),
                  id: "order-form-contact-number",
                  type: "text",
                  placeholder: cart69,
                  onInput: function onInput(e) {
                    return setContact_number(e.target.value);
                  },
                  value: contact_number,
                  maxLength: "10"
                })
              ),
              /*#__PURE__*/ React.createElement(
                "p",
                {
                  className: "disclaimer"
                },
                mobiledisclaimer
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "group"
                },
                /*#__PURE__*/ React.createElement("input", {
                  className: ""
                    .concat(
                      submitPaymentError.emailPlaceholder
                        ? "form-error-placeholder"
                        : "",
                      " "
                    )
                    .concat(
                      submitPaymentError.emailText ? "form-error-text" : ""
                    ),
                  id: "order-form-email",
                  type: "text",
                  placeholder: cart18,
                  onInput: function onInput(e) {
                    return setEmail(e.target.value);
                  },
                  value: email,
                  maxLength: "120"
                })
              ),
              /*#__PURE__*/ React.createElement(
                "p",
                {
                  className: "disclaimer"
                },
                emaildisclaimer
              ),
              localStorage.user
                ? null
                : /*#__PURE__*/ React.createElement(
                    React.Fragment,
                    null,
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "group"
                      },
                      /*#__PURE__*/ React.createElement("input", {
                        className: "".concat(
                          submitPaymentError.passwordText
                            ? "form-error-text"
                            : ""
                        ),
                        id: "order-form-password",
                        type: "password",
                        placeholder: cart45,
                        value: password,
                        onInput: function onInput(e) {
                          return setPassword(e.target.value);
                        },
                        maxLength: "60"
                      })
                    ),
                    /*#__PURE__*/ React.createElement(
                      "p",
                      {
                        className: "disclaimer"
                      },
                      passworddisclaimer
                    )
                  )
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "title"
              },
              cart21
            ),
            !isPickup
              ? /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "checkbox"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      type: "checkbox",
                      id: "checkbox1",
                      name: "checkboox",
                      onChange: toggleIsGift
                    }),
                    /*#__PURE__*/ React.createElement(
                      "label",
                      {
                        htmlFor: "checkbox1"
                      },
                      cart27
                    )
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: is_gift ? "group" : "hidden"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      type: "text",
                      placeholder: cart70,
                      onInput: function onInput(e) {
                        return setRecipient_contact_number(e.target.value);
                      },
                      maxLength: "10"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: is_gift ? "group" : "hidden"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      type: "text",
                      placeholder: cart28,
                      onInput: function onInput(e) {
                        return setGift_message(e.target.value);
                      },
                      maxLength: "250"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      className: "".concat(
                        submitPaymentError.receiver_namePlaceholder
                          ? "form-error-placeholder"
                          : ""
                      ),
                      id: "order-form-receiver-name",
                      type: "text",
                      placeholder: cart22,
                      onInput: function onInput(e) {
                        return setReceiver_name(e.target.value);
                      },
                      value: receiver_name,
                      maxLength: "60"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      className: "".concat(
                        submitPaymentError.address_line_1Placeholder
                          ? "form-error-placeholder"
                          : ""
                      ),
                      id: "order-form-address-line-1",
                      type: "text",
                      placeholder: cart23,
                      onInput: function onInput(e) {
                        return setAddress_line_1(e.target.value);
                      },
                      value: address_line_1,
                      maxLength: "250"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group",
                      style: {
                        zIndex: 2
                      }
                    },
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        style: {
                          flex: 1,
                          position: "relative",
                          marginRight: 10
                        }
                      },
                      /*#__PURE__*/ React.createElement("input", {
                        id: "order-form-city",
                        type: "text",
                        readOnly: true,
                        placeholder: formatMessage({
                          id: "twCity"
                        }),
                        value: city,
                        style: {
                          cursor: "pointer"
                        },
                        onClick: toggleCityList,
                        className: "".concat(
                          submitPaymentError.cityPlaceholder
                            ? "form-error-placeholder"
                            : ""
                        )
                      }),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          onClick: toggleCityList,
                          style: {
                            width: 12,
                            height: 8,
                            position: "absolute",
                            top: 0,
                            right: 22,
                            cursor: "pointer"
                          }
                        },
                        /*#__PURE__*/ React.createElement("img", {
                          style: {
                            width: "100%",
                            height: "100%"
                          },
                          src: RECTANGLE,
                          alt: "Dropdown Icon"
                        })
                      ),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "chooseCountry",
                          style: {
                            display: showCityList ? "block" : "none",
                            bottom: -150,
                            cursor: "pointer",
                            height: 150,
                            overflow: "auto",
                            maxWidth: "100%"
                          }
                        },
                        districtTW.map(function(districtCity) {
                          return /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              key: districtCity.tKey,
                              onClick: function onClick() {
                                return selectCity(
                                  formatMessage({
                                    id: districtCity.tKey
                                  }),
                                  districtCity.district
                                );
                              },
                              style: {
                                cursor: "pointer"
                              }
                            },
                            formatMessage({
                              id: districtCity.tKey
                            })
                          );
                        })
                      )
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        style: {
                          flex: 1,
                          position: "relative"
                        }
                      },
                      /*#__PURE__*/ React.createElement("input", {
                        id: "order-form-district",
                        type: "text",
                        readOnly: true,
                        placeholder: formatMessage({
                          id: "twDistrict"
                        }),
                        value: district,
                        style: {
                          cursor: "pointer"
                        },
                        onClick: toggleDistrictList,
                        className: "".concat(
                          submitPaymentError.districtPlaceholder
                            ? "form-error-placeholder"
                            : ""
                        )
                      }),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          onClick: toggleDistrictList,
                          style: {
                            width: 12,
                            height: 8,
                            position: "absolute",
                            top: 0,
                            right: 22,
                            cursor: "pointer"
                          }
                        },
                        /*#__PURE__*/ React.createElement("img", {
                          style: {
                            width: "100%",
                            height: "100%"
                          },
                          src: RECTANGLE,
                          alt: "Dropdown Icon"
                        })
                      ),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "chooseCountry",
                          style: {
                            display: showDistrictList ? "block" : "none",
                            bottom: -150,
                            cursor: "pointer",
                            height: 150,
                            overflow: "auto",
                            background: "white",
                            maxWidth: "100%"
                          }
                        },
                        districtList.map(function(twDistrict) {
                          return /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              key: twDistrict.tKey,
                              onClick: function onClick() {
                                return selectDistrict(
                                  formatMessage({
                                    id: twDistrict.tKey
                                  }),
                                  twDistrict.code
                                );
                              },
                              style: {
                                cursor: "pointer"
                              }
                            },
                            ""
                              .concat(
                                formatMessage({
                                  id: twDistrict.tKey
                                }),
                                " ("
                              )
                              .concat(twDistrict.code, ")")
                          );
                        })
                      )
                    )
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group",
                      style: {
                        zIndex: 1
                      }
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      className: "".concat(
                        submitPaymentError.countryPlaceholder
                          ? "form-error-placeholder"
                          : ""
                      ),
                      id: "order-form-country",
                      type: "text",
                      readOnly: true,
                      placeholder: cart26,
                      value: country,
                      style: {
                        cursor: "pointer"
                      },
                      onClick: toggleCountryList
                    }),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        onClick: toggleCountryList,
                        style: {
                          width: 12,
                          height: 8,
                          position: "absolute",
                          top: 0,
                          right: 22,
                          cursor: "pointer"
                        }
                      },
                      /*#__PURE__*/ React.createElement("img", {
                        style: {
                          width: "100%",
                          height: "100%"
                        },
                        src: RECTANGLE,
                        alt: "Dropdown Icon"
                      })
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "chooseCountry",
                        style: {
                          display: showCountryList ? "block" : "none",
                          bottom: -49,
                          cursor: "pointer"
                        }
                      },
                      [cart66].map(function(place) {
                        return /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            key: place,
                            onClick: function onClick() {
                              return selectCountry(place);
                            },
                            style: {
                              cursor: "pointer"
                            }
                          },
                          place
                        );
                      })
                    )
                  )
                )
              : null,
            /*#__PURE__*/ React.createElement(
              "div",
              {
                id: "form-error",
                className: "form-error",
                style: {
                  display:
                    Object.keys(submitPaymentError).length > 0
                      ? "block"
                      : "none"
                }
              },
              ordervalidinfo
            ),
            hasDeposit
              ? /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "checkbox checkboxAgree"
                  },
                  /*#__PURE__*/ React.createElement("input", {
                    type: "checkbox",
                    id: "checkbox2",
                    name: "checkbox2",
                    onChange: toggleAgree
                  }),
                  /*#__PURE__*/ React.createElement(
                    "label",
                    {
                      htmlFor: "checkbox2"
                    },
                    paymentdepositdisclaimer,
                    /*#__PURE__*/ React.createElement(
                      "a",
                      {
                        href:
                          requestParam$1.webBaseURL + "/terms-and-conditions",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        style: {
                          color: "#000",
                          textDecoration: "underline"
                        }
                      },
                      paymentdepositdisclaimer2
                    )
                  )
                )
              : /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "payment-disclaimer"
                  },
                  paymentdisclaimer,
                  /*#__PURE__*/ React.createElement(
                    "a",
                    {
                      href: requestParam$1.webBaseURL + "/terms-and-conditions",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      style: {
                        color: "#000",
                        textDecoration: "underline"
                      }
                    },
                    paymentdisclaimer2
                  ),
                  paymentdisclaimer3,
                  /*#__PURE__*/ React.createElement(
                    "a",
                    {
                      href: requestParam$1.webBaseURL + "/privacy-policy",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      style: {
                        color: "#000",
                        textDecoration: "underline"
                      }
                    },
                    paymentdisclaimer4
                  )
                ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                id: "agree-error",
                className: "form-error",
                style: {
                  display: submitPaymentError.agree ? "block" : "none"
                }
              },
              mustagreedisclaimer
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                id: "btn-goto-payment",
                className: "btn",
                style: {
                  display: isLoading ? "none" : "block"
                },
                onClick: submit
              },
              cart29
            ),
            /*#__PURE__*/ React.createElement(PreLoader, {
              isLoading: isLoading,
              containerClassName: "payment-preloader-container",
              innerClassName: "payment-preloader"
            }),
            paymentForm()
          )
        )
      )
    )
  );
};

var Cart2Web = function Cart2Web() {
  var cart1 = formatMessage({
    id: "cart.cart1"
  });
  var cart2 = formatMessage({
    id: "cart.cart2"
  });
  var cart3 = formatMessage({
    id: "cart.cart3"
  });
  var cart15 = formatMessage({
    id: "cart.cart15"
  });
  var cart16 = formatMessage({
    id: "cart.cart16"
  });
  var cart17 = formatMessage({
    id: "cart.cart17"
  });
  var cart18 = formatMessage({
    id: "cart.cart18"
  });
  var emaildisclaimer = formatMessage({
    id: "cart.emaildisclaimer"
  });
  var mobiledisclaimer = formatMessage({
    id: "cart.mobiledisclaimer"
  });
  var passworddisclaimer = formatMessage({
    id: "cart.passworddisclaimer"
  });
  var cart21 = formatMessage({
    id: "cart.cart21"
  });
  var cart22 = formatMessage({
    id: "cart.cart22"
  });
  var cart23 = formatMessage({
    id: "cart.cart23"
  });
  var cart26 = formatMessage({
    id: "cart.cart26"
  });
  var cart27 = formatMessage({
    id: "cart.cart27"
  });
  var cart28 = formatMessage({
    id: "cart.cart28"
  });
  var cart29 = formatMessage({
    id: "cart.cart29"
  });
  var cart30 = formatMessage({
    id: "cart.cart30"
  });
  var cart32 = formatMessage({
    id: "cart.cart32"
  });
  var cart33 = formatMessage({
    id: "cart.cart33"
  });
  var cart45 = formatMessage({
    id: "cart.cart45"
  });
  var cart48 = formatMessage({
    id: "cart.cart48"
  });
  var cart64 = formatMessage({
    id: "cart.cart64"
  });
  var cart64tc = formatMessage({
    id: "cart.cart64tc"
  });
  var cart66 = formatMessage({
    id: "cart.cart66"
  });
  var cart69 = formatMessage({
    id: "cart.cart69"
  });
  var cart70 = formatMessage({
    id: "cart.cart70"
  });
  var cartdiscountamt = formatMessage({
    id: "cart.discountamt"
  });
  var cartpaynow = formatMessage({
    id: "cart.paynow"
  });
  var cartbalancedue = formatMessage({
    id: "cart.balancedue"
  });
  var cart12 = formatMessage({
    id: "cart.cart12"
  });
  var cart64d = formatMessage({
    id: "cart.cart64d"
  });
  var ordervalidinfo = formatMessage({
    id: "ordervalidinfo"
  });
  var paymentdisclaimer = formatMessage({
    id: "paymentdisclaimer"
  });
  var paymentdisclaimer2 = formatMessage({
    id: "paymentdisclaimer2"
  });
  var paymentdisclaimer3 = formatMessage({
    id: "paymentdisclaimer3"
  });
  var paymentdisclaimer4 = formatMessage({
    id: "paymentdisclaimer4"
  });
  var paymentdepositdisclaimer = formatMessage({
    id: "paymentdepositdisclaimer"
  });
  var paymentdepositdisclaimer2 = formatMessage({
    id: "paymentdepositdisclaimer2"
  });
  var mustagreedisclaimer = formatMessage({
    id: "mustagreedisclaimer"
  });
  var cartdeposit = formatMessage({
    id: "cart.deposit"
  });
  var subsub = formatMessage({
    id: "subscription.sub"
  });
  var cartpaybytermcheckbox = formatMessage({
    id: "cartpaybytermcheckbox"
  });
  var cartmonthlypayments = formatMessage({
    id: "cartmonthlypayments"
  });

  var _useState = useState({
      amount: 1,
      orderRef: Date.parse(new Date()),
      secureHash: "1",
      subscription_fee: 0,
      nSch: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    setForm = _useState2[1];

  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    checkAgree = _useState4[0],
    setCheckAgree = _useState4[1];

  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];

  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    hasDeposit = _useState8[0],
    setHasDeposit = _useState8[1];

  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    remainingBal = _useState10[0],
    setRemainingBal = _useState10[1];

  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    grandTotal = _useState12[0],
    setGrandTotal = _useState12[1];

  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    paymentTotal = _useState14[0],
    setPaymentTotal = _useState14[1];

  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    first_name = _useState16[0],
    setFirst_name = _useState16[1];

  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    last_name = _useState18[0],
    setLast_name = _useState18[1];

  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    email = _useState20[0],
    setEmail = _useState20[1];

  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2),
    contact_number = _useState22[0],
    setContact_number = _useState22[1];

  var _useState23 = useState(""),
    _useState24 = _slicedToArray(_useState23, 2),
    password = _useState24[0],
    setPassword = _useState24[1];

  var _useState25 = useState(""),
    _useState26 = _slicedToArray(_useState25, 2),
    receiver_name = _useState26[0],
    setReceiver_name = _useState26[1];

  var _useState27 = useState(""),
    _useState28 = _slicedToArray(_useState27, 2),
    address_line_1 = _useState28[0],
    setAddress_line_1 = _useState28[1];

  var _useState29 = useState(""),
    _useState30 = _slicedToArray(_useState29, 2),
    city = _useState30[0],
    setCity = _useState30[1];

  var _useState31 = useState(""),
    _useState32 = _slicedToArray(_useState31, 2),
    district = _useState32[0],
    setDistrict = _useState32[1];

  var _useState33 = useState(""),
    _useState34 = _slicedToArray(_useState33, 2),
    postal_code = _useState34[0],
    setPostal_code = _useState34[1];

  var _useState35 = useState(""),
    _useState36 = _slicedToArray(_useState35, 2),
    country = _useState36[0],
    setCountry = _useState36[1];

  var _useState37 = useState(""),
    _useState38 = _slicedToArray(_useState37, 2),
    gift_message = _useState38[0],
    setGift_message = _useState38[1];

  var _useState39 = useState(""),
    _useState40 = _slicedToArray(_useState39, 2),
    recipient_contact_number = _useState40[0],
    setRecipient_contact_number = _useState40[1];

  var _useState41 = useState(false),
    _useState42 = _slicedToArray(_useState41, 2),
    is_gift = _useState42[0],
    setIs_gift = _useState42[1];

  var _useState43 = useState(null),
    _useState44 = _slicedToArray(_useState43, 2),
    shopping_cart_id = _useState44[0],
    setShopping_cart_id = _useState44[1];

  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 1),
    isPickup = _useState46[0];

  var _useState47 = useState(1),
    _useState48 = _slicedToArray(_useState47, 1),
    physical_store_id = _useState48[0];

  var _useState49 = useState([]),
    _useState50 = _slicedToArray(_useState49, 2),
    districtList = _useState50[0],
    setDistrictList = _useState50[1];

  var _useState51 = useState(false),
    _useState52 = _slicedToArray(_useState51, 2),
    showCityList = _useState52[0],
    setShowCityList = _useState52[1];

  var _useState53 = useState(false),
    _useState54 = _slicedToArray(_useState53, 2),
    showDistrictList = _useState54[0],
    setShowDistrictList = _useState54[1];

  var _useState55 = useState(false),
    _useState56 = _slicedToArray(_useState55, 2),
    showCountryList = _useState56[0],
    setShowCountryList = _useState56[1];

  var _useState57 = useState({}),
    _useState58 = _slicedToArray(_useState57, 2),
    submitPaymentError = _useState58[0],
    setSubmitPaymentError = _useState58[1];

  var _useState59 = useState(""),
    _useState60 = _slicedToArray(_useState59, 2),
    orderRef = _useState60[0],
    setOrderRef = _useState60[1];

  var _useState61 = useState(false),
    _useState62 = _slicedToArray(_useState61, 2),
    isLoading = _useState62[0],
    setIsLoading = _useState62[1];

  var _useState63 = useState(false),
    _useState64 = _slicedToArray(_useState63, 2),
    triggerFormSubmit = _useState64[0],
    setTriggerFormSubmit = _useState64[1];

  var paymentFormRef = useRef();

  var submit = function submit() {
    //#region validation
    var newSubmitPaymentError = {}; // personal information

    if (first_name === "") {
      newSubmitPaymentError.first_namePlaceholder = true;
    }

    if (last_name === "") {
      newSubmitPaymentError.last_namePlaceholder = true;
    }

    if (contact_number === "") {
      newSubmitPaymentError.contact_numberPlaceholder = true;
    }

    if (contact_number.length > 0 && contact_number.length < 8) {
      newSubmitPaymentError.contact_numberText = true;
    }

    if (email === "") {
      newSubmitPaymentError.emailPlaceholder = true;
    }

    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      newSubmitPaymentError.emailText = true;
    }

    if (password.length > 0 && password.length < 8) {
      newSubmitPaymentError.passwordText = true;
    } // shipping address

    if (!isPickup) {
      if (receiver_name === "") {
        newSubmitPaymentError.receiver_namePlaceholder = true;
      }

      if (address_line_1 === "") {
        newSubmitPaymentError.address_line_1Placeholder = true;
      }

      if (city === "") {
        newSubmitPaymentError.cityPlaceholder = true;
      }

      if (!district) {
        newSubmitPaymentError.districtPlaceholder = true;
      }

      if (country === "") {
        newSubmitPaymentError.countryPlaceholder = true;
      }
    }

    if (hasDeposit && !checkAgree) {
      newSubmitPaymentError.agree = true;
    }

    setSubmitPaymentError(newSubmitPaymentError);
    if (Object.keys(newSubmitPaymentError).length > 0) return; //#endregion

    if (!localStorage.lang) {
      localStorage.lang = "en";
    }

    var language = localStorage.lang;
    localStorage.setItem("password", password);
    localStorage.setItem("email", email);
    var termDuration;

    if (localStorage.payByTerm === "true") {
      termDuration = localStorage.termduration;
    } else {
      termDuration = 0;
    }

    if (
      hasDeposit ||
      data.is_installment ||
      data.payment_total < priceToAllowInstallment
    ) {
      localStorage.setItem("payByTerm", "false");
      termDuration = 0;
    }

    var url = "";

    if (isPickup) {
      url = "api/v1/payments/get_secure_hash?first_name="
        .concat(encodeURIComponent(first_name), "&last_name=")
        .concat(encodeURIComponent(last_name), "&email=")
        .concat(encodeURIComponent(email), "&receiver_name=")
        .concat(
          encodeURIComponent(first_name + " " + last_name),
          "&address_line_1=",
          "&address_line_2=",
          "&city=",
          "&district="
        )
        .concat(encodeURIComponent(district), "&postal_code=")
        .concat(
          encodeURIComponent(postal_code),
          "&country=",
          "Taiwan",
          "&is_gift="
        )
        .concat(encodeURIComponent(is_gift), "&shopping_cart_id=")
        .concat(
          encodeURIComponent(shopping_cart_id),
          "&provision=&contact_number="
        )
        .concat(encodeURIComponent(contact_number), "&language=")
        .concat(encodeURIComponent(language), "&physical_store_id=")
        .concat(encodeURIComponent(physical_store_id), "&term=")
        .concat(encodeURIComponent(termDuration))
        .concat(
          orderRef ? "&order_ref=".concat(encodeURIComponent(orderRef)) : ""
        );
    } else if (is_gift) {
      url = "api/v1/payments/get_secure_hash?first_name="
        .concat(encodeURIComponent(first_name), "&last_name=")
        .concat(encodeURIComponent(last_name), "&email=")
        .concat(encodeURIComponent(email), "&receiver_name=")
        .concat(encodeURIComponent(receiver_name), "&address_line_1=")
        .concat(
          encodeURIComponent(address_line_1),
          "&address_line_2=",
          "&city="
        )
        .concat(encodeURIComponent(city), "&district=")
        .concat(encodeURIComponent(district), "&postal_code=")
        .concat(encodeURIComponent(postal_code), "&country=")
        .concat(encodeURIComponent(country), "&gift_message=")
        .concat(encodeURIComponent(gift_message), "&recipient_contact_number=")
        .concat(encodeURIComponent(recipient_contact_number), "&is_gift=")
        .concat(encodeURIComponent(is_gift), "&shopping_cart_id=")
        .concat(
          encodeURIComponent(shopping_cart_id),
          "&provision=&contact_number="
        )
        .concat(encodeURIComponent(contact_number), "&language=")
        .concat(encodeURIComponent(language), "&term=")
        .concat(encodeURIComponent(termDuration))
        .concat(
          orderRef ? "&order_ref=".concat(encodeURIComponent(orderRef)) : ""
        );
    } else {
      url = "api/v1/payments/get_secure_hash?first_name="
        .concat(encodeURIComponent(first_name), "&last_name=")
        .concat(encodeURIComponent(last_name), "&email=")
        .concat(encodeURIComponent(email), "&receiver_name=")
        .concat(encodeURIComponent(receiver_name), "&address_line_1=")
        .concat(
          encodeURIComponent(address_line_1),
          "&address_line_2=",
          "&city="
        )
        .concat(encodeURIComponent(city), "&district=")
        .concat(encodeURIComponent(district), "&postal_code=")
        .concat(encodeURIComponent(postal_code), "&country=")
        .concat(encodeURIComponent(country), "&is_gift=")
        .concat(encodeURIComponent(is_gift), "&shopping_cart_id=")
        .concat(
          encodeURIComponent(shopping_cart_id),
          "&provision=&contact_number="
        )
        .concat(encodeURIComponent(contact_number), "&language=")
        .concat(encodeURIComponent(language), "&term=")
        .concat(encodeURIComponent(termDuration))
        .concat(
          orderRef ? "&order_ref=".concat(encodeURIComponent(orderRef)) : ""
        );
    }

    setIsLoading(true);
    get(url, 1, 23)
      .then(function(res) {
        var response = res.response;
        var newForm = {};
        newForm.secureHash = response.secure_hash;
        newForm.orderRef = response.order_ref;
        newForm.amount = parseInt(localStorage.paymentTotal);
        newForm.subscription_fee = response.subscription_fee;
        newForm.nSch = response.nSch;
        newForm.userID = response.subscription_ref;
        newForm.note1 = response.order_ref;
        localStorage.setItem("orderId", response.id);
        setForm(newForm);

        if (data.shopping_cart_items[0].product.is_installment) {
          window.location.href = requestParam$1.webBaseURL + "/payment";
        } else {
          setTriggerFormSubmit(true);
        }
      })
      ["catch"](function(err) {
        alert("err");
        setIsLoading(false);
      });
  };

  var toggleIsGift = function toggleIsGift(e) {
    setIs_gift(e.target.checked);
    setReceiver_name("");
    setAddress_line_1("");
    setCity("");
    setDistrict("");
    setPostal_code("");
    setDistrictList([]);
    setCountry("");
  };

  var toggleAgree = function toggleAgree(e) {
    setCheckAgree(e.target.checked);
  };

  var toggleCityList = function toggleCityList() {
    if (!showCityList) {
      setShowCityList(true);
      setShowDistrictList(false);
      setShowCountryList(false);
    } else {
      setShowCityList(false);
    }
  };

  var toggleDistrictList = function toggleDistrictList() {
    if (!showDistrictList) {
      setShowCityList(false);
      setShowDistrictList(true);
      setShowCountryList(false);
    } else {
      setShowDistrictList(false);
    }
  };

  var toggleCountryList = function toggleCountryList() {
    if (!showCountryList) {
      setShowCityList(false);
      setShowDistrictList(false);
      setShowCountryList(true);
    } else {
      setShowCountryList(false);
    }
  };

  var selectCity = function selectCity(val, list) {
    setCity(val);
    setDistrictList(list);
    setDistrict("");
    setPostal_code("");
    setShowCityList(false);
  };

  var selectDistrict = function selectDistrict(val, code) {
    setDistrict(val);
    setPostal_code(code);
    setShowDistrictList(false);
  };

  var selectCountry = function selectCountry(val) {
    setCountry(val);
    setShowCountryList(false);
  };

  var paymentForm = function paymentForm() {
    return /*#__PURE__*/ React.createElement(
      "form",
      {
        name: "payForm",
        method: "post",
        action: requestParam$1.paymentUrl,
        ref: paymentFormRef
      },
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "web",
        value: requestParam$1.merchantID
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "MN",
        value: form.amount.toFixed(0)
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "Td",
        value: form.orderRef
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "sdt",
        value: contact_number
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "email",
        value: email
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "Card_Type",
        value: "2"
      }),
      localStorage.payByTerm === "true"
        ? /*#__PURE__*/ React.createElement("input", {
            type: "hidden",
            name: "Term",
            value: localStorage.termduration
          })
        : null,
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "ChkValue",
        value: form.secureHash
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "userID",
        value: form.userID
      }),
      /*#__PURE__*/ React.createElement("input", {
        type: "hidden",
        name: "note1",
        value: form.note1
      })
    );
  };

  useEffect(function() {
    if (localStorage.historyOrderRef) {
      setOrderRef(localStorage.historyOrderRef);
      localStorage.setItem("historyOrderRef", "");
    }

    if (localStorage.cartdata) {
      var tmpCartData;
      tmpCartData = JSON.parse(localStorage.cartdata);
      setHasDeposit(
        tmpCartData.shopping_cart_items.some(function(item) {
          return item.product.deposit_amount > 0;
        })
      );
      var tmpTotal = (tmpCartData.total - tmpCartData.discount_amount).toFixed(
        0
      );
      var remBal = tmpTotal - tmpCartData.payment_total;
      setRemainingBal(remBal);
      setGrandTotal(tmpTotal);
      setPaymentTotal(tmpCartData.payment_total);
      setData(tmpCartData);
      setShopping_cart_id(tmpCartData.id);
    } else {
      window.location.href = requestParam$1.webBaseURL + "/cart1";
    }

    if (localStorage.user) {
      var _districtTW$find;

      var user = JSON.parse(localStorage.user);
      setEmail(user.email);
      setContact_number(user.contact_number);
      setFirst_name(user.first_name);
      setLast_name(user.last_name);
      setReceiver_name(user.receiver_name);
      setAddress_line_1(user.address_line_1 == "-" ? "" : user.address_line_1);
      setCity(user.city == "-" ? "" : user.city);
      setDistrict(user.district == "-" ? "" : user.district);
      setDistrictList(
        ((_districtTW$find = districtTW.find(function(c) {
          return (
            formatMessage({
              id: c.tKey
            }) === user.city
          );
        })) === null || _districtTW$find === void 0
          ? void 0
          : _districtTW$find.district) || []
      );
      setPostal_code(user.postal_code);
      setCountry(user.country);
    } else {
      setCountry(cart66);
    }
  }, []);
  useEffect(
    function() {
      if (triggerFormSubmit) {
        var _paymentFormRef$curre;

        (_paymentFormRef$curre = paymentFormRef.current) === null ||
        _paymentFormRef$curre === void 0
          ? void 0
          : _paymentFormRef$curre.submit();
        setTriggerFormSubmit(false);
      }
    },
    [triggerFormSubmit]
  );
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers cart"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "mg cart2",
          style: {
            paddingLeft: 5,
            paddingRight: 5
          }
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "topheader"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "li active"
            },
            /*#__PURE__*/ React.createElement("span", null, "1"),
            /*#__PURE__*/ React.createElement("i", null, cart1)
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "li active"
            },
            /*#__PURE__*/ React.createElement("span", null, "2"),
            /*#__PURE__*/ React.createElement("i", null, cart2)
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "li"
            },
            /*#__PURE__*/ React.createElement("span", null, "3"),
            /*#__PURE__*/ React.createElement("i", null, cart3)
          )
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "main"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "left",
              style: {
                paddingRight: 5
              }
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "title"
              },
              cart15
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "form"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "group"
                },
                /*#__PURE__*/ React.createElement("input", {
                  className: "".concat(
                    submitPaymentError.first_namePlaceholder
                      ? "form-error-placeholder"
                      : ""
                  ),
                  id: "order-form-first-name",
                  type: "text",
                  placeholder: cart16,
                  onInput: function onInput(e) {
                    return setFirst_name(e.target.value);
                  },
                  value: first_name,
                  maxLength: "60"
                }),
                /*#__PURE__*/ React.createElement("input", {
                  className: "".concat(
                    submitPaymentError.last_namePlaceholder
                      ? "form-error-placeholder"
                      : ""
                  ),
                  id: "order-form-last-name",
                  type: "text",
                  placeholder: cart17,
                  onInput: function onInput(e) {
                    return setLast_name(e.target.value);
                  },
                  value: last_name,
                  maxLength: "60"
                })
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "group"
                },
                /*#__PURE__*/ React.createElement("input", {
                  className: ""
                    .concat(
                      submitPaymentError.contact_numberPlaceholder
                        ? "form-error-placeholder"
                        : "",
                      " "
                    )
                    .concat(
                      submitPaymentError.contact_numberText
                        ? "form-error-text"
                        : ""
                    ),
                  id: "order-form-contact-number",
                  type: "text",
                  placeholder: cart69,
                  onInput: function onInput(e) {
                    return setContact_number(e.target.value);
                  },
                  value: contact_number,
                  maxLength: "10"
                })
              ),
              /*#__PURE__*/ React.createElement(
                "p",
                {
                  className: "disclaimer"
                },
                mobiledisclaimer
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "group"
                },
                /*#__PURE__*/ React.createElement("input", {
                  className: ""
                    .concat(
                      submitPaymentError.emailPlaceholder
                        ? "form-error-placeholder"
                        : "",
                      " "
                    )
                    .concat(
                      submitPaymentError.emailText ? "form-error-text" : ""
                    ),
                  id: "order-form-email",
                  type: "text",
                  placeholder: cart18,
                  onInput: function onInput(e) {
                    return setEmail(e.target.value);
                  },
                  value: email,
                  maxLength: "120"
                })
              ),
              /*#__PURE__*/ React.createElement(
                "p",
                {
                  className: "disclaimer"
                },
                emaildisclaimer
              ),
              localStorage.user
                ? null
                : /*#__PURE__*/ React.createElement(
                    React.Fragment,
                    null,
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "group"
                      },
                      /*#__PURE__*/ React.createElement("input", {
                        className: "".concat(
                          submitPaymentError.passwordText
                            ? "form-error-text"
                            : ""
                        ),
                        id: "order-form-password",
                        type: "password",
                        placeholder: cart45,
                        value: password,
                        onInput: function onInput(e) {
                          return setPassword(e.target.value);
                        },
                        maxLength: "60"
                      })
                    ),
                    /*#__PURE__*/ React.createElement(
                      "p",
                      {
                        className: "disclaimer"
                      },
                      passworddisclaimer
                    )
                  )
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "title"
              },
              cart21
            ),
            !isPickup
              ? /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "checkbox"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      type: "checkbox",
                      id: "checkbox1",
                      name: "checkboox",
                      onChange: toggleIsGift
                    }),
                    /*#__PURE__*/ React.createElement(
                      "label",
                      {
                        htmlFor: "checkbox1"
                      },
                      cart27
                    )
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: is_gift ? "group" : "hidden"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      type: "text",
                      placeholder: cart70,
                      onInput: function onInput(e) {
                        return setRecipient_contact_number(e.target.value);
                      },
                      maxLength: "10"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: is_gift ? "group" : "hidden"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      type: "text",
                      placeholder: cart28,
                      onInput: function onInput(e) {
                        return setGift_message(e.target.value);
                      },
                      maxLength: "250"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      className: "".concat(
                        submitPaymentError.receiver_namePlaceholder
                          ? "form-error-placeholder"
                          : ""
                      ),
                      id: "order-form-receiver-name",
                      type: "text",
                      placeholder: cart22,
                      onInput: function onInput(e) {
                        return setReceiver_name(e.target.value);
                      },
                      value: receiver_name,
                      maxLength: "60"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      className: "".concat(
                        submitPaymentError.address_line_1Placeholder
                          ? "form-error-placeholder"
                          : ""
                      ),
                      id: "order-form-address-line-1",
                      type: "text",
                      placeholder: cart23,
                      onInput: function onInput(e) {
                        return setAddress_line_1(e.target.value);
                      },
                      value: address_line_1,
                      maxLength: "250"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group",
                      style: {
                        zIndex: 2
                      }
                    },
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        style: {
                          flex: 1,
                          position: "relative",
                          marginRight: 10
                        }
                      },
                      /*#__PURE__*/ React.createElement("input", {
                        id: "order-form-city",
                        type: "text",
                        readOnly: true,
                        placeholder: formatMessage({
                          id: "twCity"
                        }),
                        value: city,
                        style: {
                          cursor: "pointer"
                        },
                        onClick: toggleCityList,
                        className: "".concat(
                          submitPaymentError.cityPlaceholder
                            ? "form-error-placeholder"
                            : ""
                        )
                      }),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          onClick: toggleCityList,
                          style: {
                            width: 12,
                            height: 8,
                            position: "absolute",
                            top: 0,
                            right: 22,
                            cursor: "pointer"
                          }
                        },
                        /*#__PURE__*/ React.createElement("img", {
                          style: {
                            width: "100%",
                            height: "100%"
                          },
                          src: RECTANGLE,
                          alt: "Dropdown Icon"
                        })
                      ),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "chooseCountry",
                          style: {
                            display: showCityList ? "block" : "none",
                            bottom: -150,
                            cursor: "pointer",
                            height: 150,
                            overflow: "auto",
                            maxWidth: "100%"
                          }
                        },
                        districtTW.map(function(districtCity) {
                          return /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              key: districtCity.tKey,
                              onClick: function onClick() {
                                return selectCity(
                                  formatMessage({
                                    id: districtCity.tKey
                                  }),
                                  districtCity.district
                                );
                              },
                              style: {
                                cursor: "pointer"
                              }
                            },
                            formatMessage({
                              id: districtCity.tKey
                            })
                          );
                        })
                      )
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        style: {
                          flex: 1,
                          position: "relative"
                        }
                      },
                      /*#__PURE__*/ React.createElement("input", {
                        id: "order-form-district",
                        type: "text",
                        readOnly: true,
                        placeholder: formatMessage({
                          id: "twDistrict"
                        }),
                        value: district,
                        style: {
                          cursor: "pointer"
                        },
                        onClick: toggleDistrictList,
                        className: "".concat(
                          submitPaymentError.districtPlaceholder
                            ? "form-error-placeholder"
                            : ""
                        )
                      }),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          onClick: toggleDistrictList,
                          style: {
                            width: 12,
                            height: 8,
                            position: "absolute",
                            top: 0,
                            right: 22,
                            cursor: "pointer"
                          }
                        },
                        /*#__PURE__*/ React.createElement("img", {
                          style: {
                            width: "100%",
                            height: "100%"
                          },
                          src: RECTANGLE,
                          alt: "Dropdown Icon"
                        })
                      ),
                      /*#__PURE__*/ React.createElement(
                        "div",
                        {
                          className: "chooseCountry",
                          style: {
                            display: showDistrictList ? "block" : "none",
                            bottom: -150,
                            cursor: "pointer",
                            height: 150,
                            overflow: "auto",
                            background: "white",
                            maxWidth: "100%"
                          }
                        },
                        districtList.map(function(twDistrict) {
                          return /*#__PURE__*/ React.createElement(
                            "div",
                            {
                              key: twDistrict.tKey,
                              onClick: function onClick() {
                                return selectDistrict(
                                  formatMessage({
                                    id: twDistrict.tKey
                                  }),
                                  twDistrict.code
                                );
                              },
                              style: {
                                cursor: "pointer"
                              }
                            },
                            ""
                              .concat(
                                formatMessage({
                                  id: twDistrict.tKey
                                }),
                                " ("
                              )
                              .concat(twDistrict.code, ")")
                          );
                        })
                      )
                    )
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group",
                      style: {
                        zIndex: 1
                      }
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      className: "".concat(
                        submitPaymentError.countryPlaceholder
                          ? "form-error-placeholder"
                          : ""
                      ),
                      id: "order-form-country",
                      type: "text",
                      readOnly: true,
                      placeholder: cart26,
                      value: country,
                      style: {
                        cursor: "pointer"
                      },
                      onClick: toggleCountryList
                    }),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        onClick: toggleCountryList,
                        style: {
                          width: 12,
                          height: 8,
                          position: "absolute",
                          top: 0,
                          right: 22,
                          cursor: "pointer"
                        }
                      },
                      /*#__PURE__*/ React.createElement("img", {
                        style: {
                          width: "100%",
                          height: "100%"
                        },
                        src: RECTANGLE,
                        alt: "Dropdown Icon"
                      })
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "chooseCountry",
                        style: {
                          display: showCountryList ? "block" : "none",
                          bottom: -49,
                          cursor: "pointer"
                        }
                      },
                      [cart66].map(function(place) {
                        return /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            key: place,
                            onClick: function onClick() {
                              return selectCountry(place);
                            },
                            style: {
                              cursor: "pointer"
                            }
                          },
                          place
                        );
                      })
                    )
                  )
                )
              : null,
            /*#__PURE__*/ React.createElement(
              "div",
              {
                id: "form-error",
                className: "form-error",
                style: {
                  display:
                    Object.keys(submitPaymentError).length > 0
                      ? "block"
                      : "none"
                }
              },
              ordervalidinfo
            ),
            hasDeposit
              ? /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "checkbox checkboxAgree"
                  },
                  /*#__PURE__*/ React.createElement("input", {
                    type: "checkbox",
                    id: "checkbox2",
                    name: "checkbox2",
                    onChange: toggleAgree
                  }),
                  /*#__PURE__*/ React.createElement(
                    "label",
                    {
                      htmlFor: "checkbox2"
                    },
                    paymentdepositdisclaimer,
                    /*#__PURE__*/ React.createElement(
                      "a",
                      {
                        href:
                          requestParam$1.webBaseURL + "/terms-and-conditions",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        style: {
                          color: "#000",
                          textDecoration: "underline"
                        }
                      },
                      paymentdepositdisclaimer2
                    )
                  )
                )
              : /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "payment-disclaimer"
                  },
                  paymentdisclaimer,
                  /*#__PURE__*/ React.createElement(
                    "a",
                    {
                      href: requestParam$1.webBaseURL + "/terms-and-conditions",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      style: {
                        color: "#000",
                        textDecoration: "underline"
                      }
                    },
                    paymentdisclaimer2
                  ),
                  paymentdisclaimer3,
                  /*#__PURE__*/ React.createElement(
                    "a",
                    {
                      href: requestParam$1.webBaseURL + "/privacy-policy",
                      target: "_blank",
                      rel: "noopener noreferrer",
                      style: {
                        color: "#000",
                        textDecoration: "underline"
                      }
                    },
                    paymentdisclaimer4
                  )
                ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                id: "agree-error",
                className: "form-error",
                style: {
                  display: submitPaymentError.agree ? "block" : "none"
                }
              },
              mustagreedisclaimer
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                id: "btn-goto-payment",
                className: "btn",
                style: {
                  display: isLoading ? "none" : "block"
                },
                onClick: submit
              },
              cart29
            ),
            /*#__PURE__*/ React.createElement(PreLoader, {
              isLoading: isLoading,
              containerClassName: "payment-preloader-container",
              innerClassName: "payment-preloader"
            }),
            paymentForm()
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "right"
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "title"
              },
              cart30
            ),
            data.shopping_cart_items
              ? data.shopping_cart_items.map(function(item, index) {
                  return /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "li",
                      key: index
                    },
                    /*#__PURE__*/ React.createElement("img", {
                      className: "bigimg",
                      src: item.product.image,
                      alt: "Product"
                    }),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "name-series"
                      },
                      localStorage.lang === "tw"
                        ? item.product.zhtw_product_series
                        : localStorage.lang === "en"
                        ? item.product.product_series
                        : item.product.product_series
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "name"
                      },
                      localStorage.lang === "tw"
                        ? item.product.zhtw_product_item_name
                        : localStorage.lang === "en"
                        ? item.product.name
                        : item.product.name
                    ),
                    item.product.is_installment
                      ? /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "name"
                          },
                          subsub
                        )
                      : null,
                    item.product.product_variation === "Build Yourself Kit"
                      ? /*#__PURE__*/ React.createElement(
                          "div",
                          {
                            className: "desc"
                          },
                          cart48
                        )
                      : null,
                    /*#__PURE__*/ React.createElement("img", {
                      style: {
                        display:
                          item.product.product_variation === "Build Service"
                            ? "block"
                            : "none"
                      },
                      className: "smalimg",
                      src: STK_LOGO_BUILD_SERVICE_BUTTON,
                      alt: "Build Service Logo"
                    }),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "qty"
                      },
                      cart32,
                      ": ",
                      item.amount
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "price",
                        style: {
                          color:
                            item.product.product_variation === "Build Service"
                              ? "#ff8800"
                              : "#000"
                        }
                      },
                      /*#__PURE__*/ React.createElement(
                        "span",
                        null,
                        cart33,
                        ": NT$",
                        item.price_subtotal
                      )
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "mon",
                        style: {
                          display:
                            item.product.is_installment &&
                            isShowNextMonthPaymentAmount({
                              cartItems: data.shopping_cart_items
                            })
                              ? "block"
                              : "none"
                        }
                      },
                      "(",
                      localStorage.lang === "tw" ? cart64tc : null,
                      "NT$",
                      " ",
                      item.product.price,
                      localStorage.lang !== "tw" ? cart64 : null,
                      ")"
                    ),
                    /*#__PURE__*/ React.createElement(
                      "div",
                      {
                        className: "deposit",
                        style: {
                          display:
                            item.product.deposit_amount > 0 ? "block" : "none"
                        }
                      },
                      cartdeposit,
                      ": NT$ ",
                      item.payment_subtotal
                    )
                  );
                })
              : null,
            hasDeposit ||
              data.is_installment ||
              data.payment_total < priceToAllowInstallment
              ? null
              : /*#__PURE__*/ React.createElement(
                  React.Fragment,
                  null,
                  localStorage.payByTerm === "true" &&
                    localStorage.termduration > 0
                    ? /*#__PURE__*/ React.createElement(
                        "p",
                        null,
                        cartpaybytermcheckbox,
                        ": ",
                        localStorage.termduration,
                        " ",
                        cartmonthlypayments
                      )
                    : null
                ),
            data.discount_amount > 0
              ? /*#__PURE__*/ React.createElement(
                  "p",
                  null,
                  cartdiscountamt,
                  ": NT$ ",
                  data.discount_amount
                )
              : null,
            hasDeposit
              ? /*#__PURE__*/ React.createElement(
                  React.Fragment,
                  null,
                  /*#__PURE__*/ React.createElement(
                    "p",
                    null,
                    cartpaynow,
                    ": NT$ ",
                    paymentTotal
                  ),
                  /*#__PURE__*/ React.createElement(
                    "p",
                    null,
                    cartbalancedue,
                    ": NT$ ",
                    remainingBal
                  )
                )
              : null,
            /*#__PURE__*/ React.createElement(
              "p",
              null,
              cart12,
              ": NT$ ",
              grandTotal
            ),
            data.is_installment &&
              isShowNextMonthPaymentAmount({
                cartItems: data.shopping_cart_items
              })
              ? /*#__PURE__*/ React.createElement(
                  "p",
                  null,
                  cart64d,
                  ": NT$ ",
                  data.subscription_fee
                )
              : null
          )
        )
      )
    )
  );
};

var Cart2 = function Cart2() {
  return /*#__PURE__*/ React.createElement(MobileDetector, {
    desktopChildren: /*#__PURE__*/ React.createElement(Cart2Web, null),
    mobileChildren: /*#__PURE__*/ React.createElement(Cart2Mobile, null)
  });
};

var Cart3Mobile = function Cart3Mobile() {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];

  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    password = _useState4[0],
    setPassword = _useState4[1];

  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showRegForm = _useState6[0],
    setShowRegForm = _useState6[1];

  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    showLoader = _useState8[0],
    setShowLoader = _useState8[1];

  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    registerError = _useState10[0],
    setRegisterError = _useState10[1];

  useEffect(function() {
    // password from cart2 submit
    if (!localStorage.user && localStorage.password) {
      var data = {
        email: localStorage.email,
        password: localStorage.password,
        password_confirmation: localStorage.password,
        is_receive_marketing_materials: false,
        order_id: localStorage.orderId,
        language: localStorage.lang
      };
      post("auth", data)
        .then(function() {
          localStorage.removeItem("email");
          localStorage.removeItem("password");
          setShowRegForm(false);
          setShowLoader(false);
        })
        ["catch"](function(err) {
          setShowRegForm(true);
          setShowLoader(false);
        });
    } else {
      setShowRegForm(localStorage.user ? false : true);
      setShowLoader(false);
    }
  }, []);

  var submit = function submit() {
    var newRegisterError = {};

    if (email === "") {
      newRegisterError.emailPlaceholder = true;
    }

    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      newRegisterError.emailText = true;
    }

    if (password === "") {
      newRegisterError.passwordPlaceholder = true;
    }

    if (password.length < 8) {
      newRegisterError.passwordText = true;
    }

    setRegisterError(newRegisterError);
    if (Object.keys(newRegisterError).length > 0) return;
    var data = {
      email: email,
      password: password,
      password_confirmation: password,
      is_receive_marketing_materials: false,
      order_id: localStorage.orderId,
      language: localStorage.lang
    };
    post("auth", data)
      .then(function(res) {
        window.location.href = requestParam$1.webBaseURL + "/login";
      })
      ["catch"](function(err) {
        alert("Register Failed");
      });
  };

  var cart34 = formatMessage({
    id: "cart.cart34"
  });
  var cart35 = formatMessage({
    id: "cart.cart35"
  });
  var cart36 = formatMessage({
    id: "cart.cart36"
  });
  var cart37 = formatMessage({
    id: "cart.cart37"
  });
  var cart38 = formatMessage({
    id: "cart.cart38"
  });
  var cart39 = formatMessage({
    id: "cart.cart39"
  });
  var cart41 = formatMessage({
    id: "cart.cart41"
  });
  var cart45 = formatMessage({
    id: "cart.cart45"
  });
  var reginfovalid = formatMessage({
    id: "reginfovalid"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, {
      type: 2
    }),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers mobilecart"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "cart3 cart2"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "main",
            style: {
              position: "relative"
            }
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "left"
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "carttop"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "title"
                },
                cart34
              ),
              /*#__PURE__*/ React.createElement("p", null, cart35),
              /*#__PURE__*/ React.createElement(
                "a",
                {
                  href: "/"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "topbtn",
                    style: {
                      color: "#000"
                    }
                  },
                  cart36
                )
              )
            ),
            showRegForm
              ? /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "mainbot mpad_h"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "title"
                    },
                    cart37
                  ),
                  /*#__PURE__*/ React.createElement("p", null, cart38),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group"
                    },
                    /*#__PURE__*/ React.createElement("span", null, cart39),
                    /*#__PURE__*/ React.createElement("input", {
                      className: ""
                        .concat(
                          registerError.emailPlaceholder
                            ? "form-error-placeholder"
                            : "",
                          " "
                        )
                        .concat(
                          registerError.emailText ? "form-error-text" : ""
                        ),
                      id: "reg-form-email",
                      type: "text",
                      placeholder: "customer@gmail.com",
                      onInput: function onInput(e) {
                        return setEmail(e.target.value);
                      },
                      maxLength: "120"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group"
                    },
                    /*#__PURE__*/ React.createElement("span", null, cart45),
                    /*#__PURE__*/ React.createElement("input", {
                      className: ""
                        .concat(
                          registerError.passwordPlaceholder
                            ? "form-error-placeholder"
                            : "",
                          " "
                        )
                        .concat(
                          registerError.passwordText ? "form-error-text" : ""
                        ),
                      id: "reg-form-password",
                      type: "password",
                      placeholder: "********",
                      onInput: function onInput(e) {
                        return setPassword(e.target.value);
                      },
                      maxLength: "60"
                    })
                  ),
                  /*#__PURE__*/ React.createElement("br", null),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      id: "form-error",
                      className: "form-error",
                      style: {
                        display:
                          Object.keys(registerError).length > 0
                            ? "block"
                            : "none"
                      }
                    },
                    reginfovalid
                  ),
                  /*#__PURE__*/ React.createElement("br", null),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "btn",
                      onClick: submit
                    },
                    cart41
                  )
                )
              : null
          ),
          /*#__PURE__*/ React.createElement(PreLoader, {
            isLoading: showLoader
          })
        )
      )
    )
  );
};

var Cart3Web = function Cart3Web() {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];

  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    password = _useState4[0],
    setPassword = _useState4[1];

  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showRegForm = _useState6[0],
    setShowRegForm = _useState6[1];

  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    showLoader = _useState8[0],
    setShowLoader = _useState8[1];

  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    registerError = _useState10[0],
    setRegisterError = _useState10[1];

  useEffect(function() {
    // password from cart2 submit
    if (!localStorage.user && localStorage.password) {
      var data = {
        email: localStorage.email,
        password: localStorage.password,
        password_confirmation: localStorage.password,
        is_receive_marketing_materials: false,
        order_id: localStorage.orderId,
        language: localStorage.lang
      };
      post("auth", data)
        .then(function() {
          localStorage.removeItem("email");
          localStorage.removeItem("password");
          setShowRegForm(false);
          setShowLoader(false);
        })
        ["catch"](function(err) {
          setShowRegForm(true);
          setShowLoader(false);
        });
    } else {
      setShowRegForm(localStorage.user ? false : true);
      setShowLoader(false);
    }
  }, []);

  var submit = function submit() {
    var newRegisterError = {};

    if (email === "") {
      newRegisterError.emailPlaceholder = true;
    }

    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      newRegisterError.emailText = true;
    }

    if (password === "") {
      newRegisterError.passwordPlaceholder = true;
    }

    if (password.length < 8) {
      newRegisterError.passwordText = true;
    }

    setRegisterError(newRegisterError);
    if (Object.keys(newRegisterError).length > 0) return;
    var data = {
      email: email,
      password: password,
      password_confirmation: password,
      is_receive_marketing_materials: false,
      order_id: localStorage.orderId,
      language: localStorage.lang
    };
    post("auth", data)
      .then(function(res) {
        window.location.href = requestParam.webBaseURL + "/login";
      })
      ["catch"](function(err) {
        alert("Register Failed");
      });
  };

  var cart34 = formatMessage({
    id: "cart.cart34"
  });
  var cart35 = formatMessage({
    id: "cart.cart35"
  });
  var cart36 = formatMessage({
    id: "cart.cart36"
  });
  var cart37 = formatMessage({
    id: "cart.cart37"
  });
  var cart38 = formatMessage({
    id: "cart.cart38"
  });
  var cart39 = formatMessage({
    id: "cart.cart39"
  });
  var cart41 = formatMessage({
    id: "cart.cart41"
  });
  var cart45 = formatMessage({
    id: "cart.cart45"
  });
  var reginfovalid = formatMessage({
    id: "reginfovalid"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers cart"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "mg cart3 cart2",
          style: {
            paddingLeft: 5,
            paddingRight: 5
          }
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "main",
            style: {
              position: "relative"
            }
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "left"
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "title"
              },
              cart34
            ),
            /*#__PURE__*/ React.createElement("p", null, cart35),
            showRegForm
              ? /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "subsequent-section"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "title"
                    },
                    cart37
                  ),
                  /*#__PURE__*/ React.createElement("p", null, cart38),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "tit"
                    },
                    cart39
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      className: ""
                        .concat(
                          registerError.emailPlaceholder
                            ? "form-error-placeholder"
                            : "",
                          " "
                        )
                        .concat(
                          registerError.emailText ? "form-error-text" : ""
                        ),
                      id: "reg-form-email",
                      type: "text",
                      placeholder: "customer@gmail.com",
                      onInput: function onInput(e) {
                        return setEmail(e.target.value);
                      },
                      maxLength: "120"
                    })
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "tit"
                    },
                    cart45
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "group"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      className: ""
                        .concat(
                          registerError.passwordPlaceholder
                            ? "form-error-placeholder"
                            : "",
                          " "
                        )
                        .concat(
                          registerError.passwordText ? "form-error-text" : ""
                        ),
                      id: "reg-form-password",
                      type: "password",
                      placeholder: "********",
                      onInput: function onInput(e) {
                        return setPassword(e.target.value);
                      },
                      maxLength: "60"
                    })
                  ),
                  /*#__PURE__*/ React.createElement("br", null),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      id: "form-error",
                      className: "form-error",
                      style: {
                        display:
                          Object.keys(registerError).length > 0
                            ? "block"
                            : "none"
                      }
                    },
                    reginfovalid
                  ),
                  /*#__PURE__*/ React.createElement("br", null),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "btn",
                      onClick: submit
                    },
                    cart41
                  )
                )
              : null,
            /*#__PURE__*/ React.createElement(
              "a",
              {
                href: "/"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "topbtn",
                  style: {
                    color: "#000"
                  }
                },
                cart36
              )
            )
          ),
          /*#__PURE__*/ React.createElement(PreLoader, {
            isLoading: showLoader
          })
        )
      )
    )
  );
};

var Cart3 = function Cart3() {
  return /*#__PURE__*/ React.createElement(MobileDetector, {
    desktopChildren: /*#__PURE__*/ React.createElement(Cart3Web, null),
    mobileChildren: /*#__PURE__*/ React.createElement(Cart3Mobile, null)
  });
};

var Cart4Mobile = function Cart4Mobile() {
  var goBack = function goBack() {
    window.history.back();
  };

  useEffect(function() {
    if (localStorage.orderId) {
      var data = {
        order_id: localStorage.orderId
      };
      post("api/v1/payments/payment_failed", data, 1)
        .then(function(res) {})
        ["catch"](function(err) {});
    }
  }, []);
  var cart61 = formatMessage({
    id: "cart.cart61"
  });
  var cart62 = formatMessage({
    id: "cart.cart62"
  });
  var cart63 = formatMessage({
    id: "cart.cart63"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers cart"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "mg mobilecart4"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "main"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "title"
            },
            cart61
          ),
          /*#__PURE__*/ React.createElement("p", null, cart62),
          /*#__PURE__*/ React.createElement(
            "u",
            {
              onClick: goBack
            },
            cart63
          )
        )
      )
    )
  );
};

var Cart4Web = function Cart4Web() {
  var goBack = function goBack() {
    window.history.back();
  };

  useEffect(function() {
    if (localStorage.orderId) {
      var data = {
        order_id: localStorage.orderId
      };
      post("api/v1/payments/payment_failed", data, 1)
        .then(function(res) {})
        ["catch"](function(err) {});
    }
  }, []);
  var cart61 = formatMessage({
    id: "cart.cart61"
  });
  var cart62 = formatMessage({
    id: "cart.cart62"
  });
  var cart63 = formatMessage({
    id: "cart.cart63"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers cart"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "mg cart4"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "main"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "title"
            },
            cart61
          ),
          /*#__PURE__*/ React.createElement("p", null, cart62),
          /*#__PURE__*/ React.createElement(
            "u",
            {
              onClick: goBack
            },
            cart63
          )
        )
      )
    )
  );
};

var Cart4 = function Cart4() {
  return /*#__PURE__*/ React.createElement(MobileDetector, {
    desktopChildren: /*#__PURE__*/ React.createElement(Cart4Web, null),
    mobileChildren: /*#__PURE__*/ React.createElement(Cart4Mobile, null)
  });
};

var Cart5 = function Cart5() {
  var toHomePage = function toHomePage() {
    window.location.href = "/";
  };

  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers cart"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "mg cart4"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "main"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "title"
            },
            "Payment Pending"
          ),
          /*#__PURE__*/ React.createElement(
            "p",
            null,
            "Your payment is still being processed by our payment gateway. Please check your email in the next 10 minutes for order results. If you do not receive a successful payment email from us, it is likely the payment has failed. If so, please contact customer support or try another payment attempt."
          ),
          /*#__PURE__*/ React.createElement(
            "u",
            {
              onClick: toHomePage
            },
            "Return to home page."
          )
        )
      )
    )
  );
};

var HONYANG_CARD_TYPES =
  "data:image/png;base64,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";

var CCV_HELP =
  "data:image/gif;base64,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";

var NCCC =
  "data:image/gif;base64,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";

var SUNTECH =
  "data:image/gif;base64,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";

var SSL =
  "data:image/png;base64,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";

var CCV_EXAMPLE =
  "data:image/jpeg;base64,/9j/4RUCRXhpZgAATU0AKgAAAAgABwESAAMAAAABAAEAAAEaAAUAAAABAAAAYgEbAAUAAAABAAAAagEoAAMAAAABAAIAAAExAAIAAAAkAAAAcgEyAAIAAAAUAAAAlodpAAQAAAABAAAArAAAANgACvyAAAAnEAAK/IAAACcQQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoV2luZG93cykAMjAxNzowNDoyMSAxODoyODo1MwAAAAADoAEAAwAAAAEAAQAAoAIABAAAAAEAAAH0oAMABAAAAAEAAAEsAAAAAAAAAAYBAwADAAAAAQAGAAABGgAFAAAAAQAAASYBGwAFAAAAAQAAAS4BKAADAAAAAQACAAACAQAEAAAAAQAAATYCAgAEAAAAAQAAE8QAAAAAAAAASAAAAAEAAABIAAAAAf/Y/+0ADEFkb2JlX0NNAAH/7gAOQWRvYmUAZIAAAAAB/9sAhAAMCAgICQgMCQkMEQsKCxEVDwwMDxUYExMVExMYEQwMDAwMDBEMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMAQ0LCw0ODRAODhAUDg4OFBQODg4OFBEMDAwMDBERDAwMDAwMEQwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCABgAKADASIAAhEBAxEB/90ABAAK/8QBPwAAAQUBAQEBAQEAAAAAAAAAAwABAgQFBgcICQoLAQABBQEBAQEBAQAAAAAAAAABAAIDBAUGBwgJCgsQAAEEAQMCBAIFBwYIBQMMMwEAAhEDBCESMQVBUWETInGBMgYUkaGxQiMkFVLBYjM0coLRQwclklPw4fFjczUWorKDJkSTVGRFwqN0NhfSVeJl8rOEw9N14/NGJ5SkhbSVxNTk9KW1xdXl9VZmdoaWprbG1ub2N0dXZ3eHl6e3x9fn9xEAAgIBAgQEAwQFBgcHBgU1AQACEQMhMRIEQVFhcSITBTKBkRShsUIjwVLR8DMkYuFygpJDUxVjczTxJQYWorKDByY1wtJEk1SjF2RFVTZ0ZeLys4TD03Xj80aUpIW0lcTU5PSltcXV5fVWZnaGlqa2xtbm9ic3R1dnd4eXp7fH/9oADAMBAAIRAxEAPwD1VDvvqx6LMi9wrppabLHnhrWjc9zv6rURc5/jEtbV9TepPeSGhtYJHOttTf4oE0CV0IiU4xJ4QSAZfu31cq7/ABsdGbY5tOJkW1gw2w7Gbv5QY5+7b/WUP/Ha6Z/3AyP85n/kl5P+0cT94/5pTjqOJ++f80qvx5ux+x2By3w3rkj/AOGPrH/js9L/AO4N/wDnM/8AJJv/AB2el/8AcG//ADmf+SXlH7Rw/wB4/wCaVOjquBW8usb6rSCNpBHP53f/AF/4T3pcebsf8VJ5f4bWkon/AKr/AOhPqf8A47XTP+4GR/nM/wDJJ/8Ax2emf9wMj/OZ/wCSXmn7d6H7f1BkCAZfdqB8Ht9zkv290f0yw4bCS8uaZsG1pI/R+1+5+1v51iPFm/lFYMHw7uP/AA2P/fvpf/js9L/7g3/5zP8AySX/AI7PTP8AuBkf5zP/ACS8yPXOkeo2xmHWNoO5jja5pJcHB38436Df0f7iK/6xdGO+MCsbqTU0nfLXHd+nbt2MdZ7vz2JcWX+UVex8P8P/AA2P/fvo/wD47XTP+4GR/nM/8kn/APHa6X/3Bv8A85n/AJJedN+s/RRa97ul472O27Kz6gawD1C6Nrg92/1fz3f4GpDp+sHRa9m/Ars2OeS1xeA5rj7GWbdtn6L+RYxLiy/yij2eQvp/4bH/AL99I/8AHa6Z/wBwMj/OZ/5JP/47XS/+4N/+cz/yS8oPUcKSQ4gE8bToPBMeoYf7x/zShx5ux/xV/wB2+Hfvx/8ADf8A0J9XP+NvpY4wLz/ar/8AJLQ6H/jH6L1fOZgursw7rjtpNu3Y9x+jV6jHe22z/B7m/wDgi8W+34n7x/zSj9Pz8cdRxS17gRdWQQDIIe0ynCeWxYP2MeTl+R4TwziJVp+svV+jkkklO5KkkkklP//Q9VXLf4z/APxC9U+FP/n+hdSuX/xmtc76j9TDQXEinQan+foSSNw/PqSIcfIHNT/80pvs9/8Ao3/5pQ4h3C72sn7kvsLBJE+z5H+if/mlN9nv/wBG/wDzSlxDuFe1k/cl/ilgkifZsj/RP/zSl9myP9E//NKXEO4V7WT9yX+KUaSJ9nyP9E//ADSl9myf9E//ADSlxDuFe1k/cl/ilGkifZ8j/RP/AM0pvs9/+jf/AJpS4h3CvayfuS+wsElP7Pf/AKN/+aUvQv8A9G//ADSlxDuFe1k/cl9hYKx07/lDF/46v/qmof2fI/0T/wDNKsdPx8gdQxZqeP01f5p/ealY7hXtZP3JfYX6eSSSRWKSSSSU/wD/0fVVz3+MD/xIdR/q1/8An2pdCud/xgf+I/qP9Wv/AM+1Js/ll5Fl5f8An8X9+H/SeA+qPSOrdQw77MG3EYyu9vtyqjY71Wsmqxjmsfs9Nj3rc/5qdeO4m/pTw/QziyHPJnft9Ha6z3fSUf8AFiI6TnAzByWAxy79H9Bq6+eCXQRoXDho/dZ/LUUIAxDf5jmJxzZAK37PJ/8ANb6wbLGW5HTLBue6X0vd6Zsf6z/R3V7e769n+j/4RDy/qb1vKqsqfd0yv1AA8145Y5rQWOZtsFO6rZs2N2f4NdgNIA0I1aDw0fvP/lpaagSQdQ08k/6Sz+Sne3FiHN5Rrp3+UPn/AP42XUzxnY0u1aIt1H7382o/+Nn1M6jPxiDo3S3U/wDba9DkayZDuSOXH91v/BpT4uggQ4jsP9HX/KQ9qHZeef5j94fYHz7/AMbPqPJzsaBo4xbof3W/o/cm/wDGz6qD7s/GBH0gRboP+2l6FJ01DS3UeDB+9/XTaRA8Za09/wCXal7UOyj8Q5j94fYHjMD6lddwK31UZeBY2x7bdt1L7ILAQ239JSfT9rkQ/VP6wnHGP9r6eWmv0mWGh3qEBno7vU9LduY31P0v8u3/AEq686zruDj83n/0mnkaku7Q5w/891I+3HxWHm8pJJ4bP9UPJf8ANbr+7cbukvG6Ydil/u42N30uc/8AM3e5Vr/q/wBW6fiVfbMvpbmUmulj7May6z6RbVi01ejY7Jtv3/zDK/W/R/ov8Iu1BIIkhpaOezB/J/lrOzHinrvSrbiGUFmRTjl5hrcy30Pszrdf53IxGZ2Pjbv+I/w6IgFsuZyV0+x89zPqp9dszKdkjpRAe1jWQaqhtYxtdf6vU+xtDtjP0le/6azb+ndU6L1HEb1nGOJL2Whxc14DA/3WO9P3sY3avbHUZ76ajiXmvbo9jwBP6RjnP3Ortc1/pNuraz6H6T+QvPfr/wDaKPrF0Q5dzPWqqrNl59rBtvP6V7nbWt2s91rvoJk8cQOKurPy3OZpy9on08J6D9EPqNdldtbbanB9bwHMe0gtLSJa5rh9JrlJYX1aouf0Wt1Vr8bGffk24bGMa39VsvttwG+nfW/0q/srqvRq2VelT+i2exaWI64ZGRRZabhXsLXODQ4bh7m/om1t/N/dU7lttJJJJT//0vVVzv8AjB/8R/UY/dr/APPtS6Jc7/jB/wDEf1H+rX/59qTZ/LLyLLy/89i/vx/6T5V0Tr/WulNdRgZJxqLrA613pMsAJGz1P0ldjm+z9xa7vrZ9ZWVBw6w11jQS2kYgkuhr4l2IGfnfTWB0vLZS81OdktNz2BvoXClv5zf0u6u3972P/MWqX5Baa3nLf6gdtIz6oIAl0y1v5v0G/o/W+gq0Sa3Lt5YQMjeOH94iFy/xmzb9a/rExry3rjLWtDngNxQd7m/R1OJs2v8A396T/rd9YSHGvrrbHHbub9kAMEsb/wBxfoMc93/baqVuyK3W17snc7ZJZ1CgDaG/oNz9ux7Np+nt/ReytIeuWm2x+U+rbLgc+mZqc91cyPcym317P/PadZ7n/nMft4/3IfZj/wC9bn/Oz6xBzt3XWMg7GudiR7YbusG3E/R1+p6lX+k/R/zai363fWMPcHdaZWKnFrAcVp0mG2wzFds3fyv0qrB2VeHDflPY0fpWnPp1Y4CzX2/mu+n/AOCfpEQWZ7YYbcggOO0jqFG4OPuq/Se5/srdZZZt+nb/AMWhZ7n/AJyTjxgfzcP/ABr/AL1sH619e2T+3q+ZYfsnteSP3nYn73t9yi361/WJ1Re7rrG+o4gTiD3bTp7vsv57Nltdbf31WdkXY21jLcsMqgANzqJaGFlWM2vaLNmz9yv/AIxQqxsmsMFX2ljWNLSGZ1DW7rJ9RrXNbtZ62z6P7iNnuf8AnIOPGRfBD7MX/et0/Wz6xlr3Drlbnholv2UNlktbur3YrXbWt3WOaz8yqxP/AM7PrCLiG9cbsZXLbXYgDZ13Vta3Fe/+X6jmqmxt77Lq3uyZLRXdPUaS1zXDexpO39Iz9L9BRaMk0b7nZb6nMBfGfTqHxtb6ZDne71Pe1Cz3P/OSMePT9XD7MXX/AAW1/wA7vrDNYb1xuze8ScRp2gbvSsO3Gfv9fazb/wAYo2fWXrWTScbK61j20Xfz9VmGHsIH022Ndh+/Z9LagZLs9lRFF+U20hldbn51TmgO2tfVsbse/wBz9v8AwKp7frBQx+zJDWucXv25NQJcSK3u/nN73P8Abv8A+3EeKXco9nEd4wHb5P8AvGvZjfaT69nWH+o9gc/1W3PLQ0bWsfZZXb9FjWMq/SWINGM1vVMet9rstotq2ueCGEFzHT6NjWe33f4Riv10/WPaaa8l0U6OrGQ0hrWBr2v/AJzZ6W13s/tqq37U3rNTct/qZHr1eo/eLJMs/wAKwua/2oWdPNdGMPULBHCajdxH+A/QKq4/9Py/hV+RytKrj/0/L+FX5HK04LaSSSSU/wD/0/VVzv8AjBn/AJn9Rj92v/z7UuiQsrFozMa3FyWCyi9jq7WGRLXDa5vt9yBFgjuF2OXBOMv3ZCX+K/PuLmOxidtVVkkEG1geQR9HbuRv2s4HTEw9Xbj+gae5dt1+iz+qu/v/AMUOG61xx+pWV1fmssqbY4fGxr6d3/baH/4z1f8A5bO/9hx/6WVf259nZPO8qdTLU/1ZPnmXlHJc0uqqqLQf5pgYDJ3e7ahNjgj4L0j/AMZ6v/y2d/7Dj/0sn/8AGfr/APLZ3/bA/wDSyBxT7Jjz/LD9L/myfN5DeAokzyAvRcj/ABS42PTZkX9YLKaWusseccQGtG97v5781oQ6/wDFb0601ej1xtov3ei5lLXBxZ/ObXsvc32Je1Psk/EOXP6en92TwAYIEhMQ0nhd2/8AxddJrrquf14ivIq9el32Y+6uN+8fpf3XJ7f8WvTKXsZZ1xzXWR6Y+zH3S11u2v8ASe93pMfZtb+4l7U+yj8Q5XpL/myeFAaBEKO7X2gLvH/4uui1vFVv1jrrsc0u2PrY1wADXHe1942e2xntekf8W3RhkfZT9Y6hkbxX6JYzfvJ2+ns+0bt+781L2Z9kn4jy2lSI/wAGTwR+ATQJ4C7qr/F70W2+nHZ11zrcifSZ9ld7gC5hP85+9VZ/mK6f8U2LvfX+2CH1tD7B6A9rXbtjnfpv+DsR9qfZb9/5f98/4snzktbzCN08T1DFAHN1cAf12rvsb/FThZdXq4vXG5FUxvqqa9sjtuZe5q1/q/8A4sem9Jz68/JyX51tDg+hhYK2NcPo2OaHWOsex3ur96IxTvVZk5/l+E8JJNbUXsbbG1VPtfOytpc7aC4wBuO1jA57/wCqxcz0/wCvf1SyupmnG6i227MdVVRW2u6S8+wN1p9vud/Y/PXTixhcWBwLm6OaDqNA7X+y9i47pX1M6N0H645XWrLqKm5unS8ZzmtLLLdM3063tb+c5leN6D/5rJso9P8Am1YcZ7NJRssZUx1ljgytgLnvcYAA1c5zj9FrVJJT/9T1VJJJJSkkkklKSSSSU5vXsGrN6ddW+w12OrfVQTc+lhsuHoUst9F7PU9S17K9ljbP6ipZPQd7qG52S12LU+x29/ve62414uLXt6j9vq+g6xjvT9L1Miyv0Kav0iu9e6Y/qOG1lQ3W021WsrdbZVW8V21XWV2+hO7fXVtr9Sq30rP0izMn6ruv6N9lqqooyGG65jHhl4Nz3jIqPrW0MqqY6xjPU24fsr/RV/o6/elMsnofUcvHxXOsqNuNhip5aTtttIHqtLKPsrK6vZ6ddlWz+k2/oqvT99O/oOWyxht+xuGLTS+422lu5rPQdkbx6D/Sx32Y+V+md9P7Rb+i/nVqdS6Tnu6a3B6e/wB1dVjKck5D8R1bnDbSfQ6bjsotZT+YzYz6CJ1TpeTmVvNTWNvzqG4eYXPJZVSfUdc+j9G199/6V9dO/wBFn+Ef/o0lONd0y6vLxG39Tpx8uiltVeIcp7RY4sooAtZvZd+s2U2/0T0f8HZ6eZ+mrW4cXqJzvtHot27wf6dkbdv0N32P0Ps3837vS+h6v/bibJ6Tbk9VFpturw/TJtFeVewvtO1lbG01WMropprZvd6X87bZ/wAZ6kndOy39Zqyr73XYlTbXV06MrrtJqZQ702D1L3+i7K/SX22MZ/gqqklOJ0/oOTjZuK9uZTdkYtjWD9IXv9Jv9JFjbd/6V/6f+abUxl1/s9Fbv2G2/G6i25rA/OdY1rLW+ozYGfZahaxj2epTa2v1n0+rX/PbP0aqv6Vl29Sx8g4mFRXRkPudfW4m9zXV5FIMfZ2fpXuvY6z9P/pP5xW8TpJxrmW/bcu/YCPTusDmGRt97djUlOPT0vLuyKHV51e3cbmU15BtexgNFf2kZVlLr897fQfR+sN/mrvsv2j0f0dh6Oh9Xq9MC6tjQW+qW23OJLLMa5+TFhd+my/s93rV/wCD9b+dy/03q3OhdIt6dSDba91jmkPpLg+tp3vs/Q2OZ9oaz3/zHq/Zqv8AA01rVSU8tb9XuqYu2/Esa/LbW2ii6XudXuGJVc9/qv8A0lD/AE87Jv3fpPVsru2XZK1Lul5LMnfiCiym2inGsblbnlrKH2PbYPpfaXPZe/2W2Ve/07PVWqkkp5i76s9RspsqdcyxtjXVuY+y3a97g9v7Utgf0t2/Y/D/AKP/AMN/N+nqdH6bl4VuU/Jt9X1nAtO4ndDrHes6v06m1WPbYyt389/M1/pdnpsZppJKf//Z/+0jSlBob3Rvc2hvcCAzLjAAOEJJTQQEAAAAAAAPHAFaAAMbJUccAgAAAgAAADhCSU0EJQAAAAAAEM3P+n2ox74JBXB2rq8Fw044QklNBDoAAAAAANcAAAAQAAAAAQAAAAAAC3ByaW50T3V0cHV0AAAABQAAAABQc3RTYm9vbAEAAAAASW50ZWVudW0AAAAASW50ZQAAAABJbWcgAAAAD3ByaW50U2l4dGVlbkJpdGJvb2wAAAAAC3ByaW50ZXJOYW1lVEVYVAAAAAEAAAAAAA9wcmludFByb29mU2V0dXBPYmpjAAAABWghXA2KLVuaAAAAAAAKcHJvb2ZTZXR1cAAAAAEAAAAAQmx0bmVudW0AAAAMYnVpbHRpblByb29mAAAACXByb29mQ01ZSwA4QklNBDsAAAAAAi0AAAAQAAAAAQAAAAAAEnByaW50T3V0cHV0T3B0aW9ucwAAABcAAAAAQ3B0bmJvb2wAAAAAAENsYnJib29sAAAAAABSZ3NNYm9vbAAAAAAAQ3JuQ2Jvb2wAAAAAAENudENib29sAAAAAABMYmxzYm9vbAAAAAAATmd0dmJvb2wAAAAAAEVtbERib29sAAAAAABJbnRyYm9vbAAAAAAAQmNrZ09iamMAAAABAAAAAAAAUkdCQwAAAAMAAAAAUmQgIGRvdWJAb+AAAAAAAAAAAABHcm4gZG91YkBv4AAAAAAAAAAAAEJsICBkb3ViQG/gAAAAAAAAAAAAQnJkVFVudEYjUmx0AAAAAAAAAAAAAAAAQmxkIFVudEYjUmx0AAAAAAAAAAAAAAAAUnNsdFVudEYjUHhsQFIAAAAAAAAAAAAKdmVjdG9yRGF0YWJvb2wBAAAAAFBnUHNlbnVtAAAAAFBnUHMAAAAAUGdQQwAAAABMZWZ0VW50RiNSbHQAAAAAAAAAAAAAAABUb3AgVW50RiNSbHQAAAAAAAAAAAAAAABTY2wgVW50RiNQcmNAWQAAAAAAAAAAABBjcm9wV2hlblByaW50aW5nYm9vbAAAAAAOY3JvcFJlY3RCb3R0b21sb25nAAAAAAAAAAxjcm9wUmVjdExlZnRsb25nAAAAAAAAAA1jcm9wUmVjdFJpZ2h0bG9uZwAAAAAAAAALY3JvcFJlY3RUb3Bsb25nAAAAAAA4QklNA+0AAAAAABAASAAAAAEAAgBIAAAAAQACOEJJTQQmAAAAAAAOAAAAAAAAAAAAAD+AAAA4QklNA/IAAAAAAAoAAP///////wAAOEJJTQQNAAAAAAAEAAAAWjhCSU0EGQAAAAAABAAAAB44QklNA/MAAAAAAAkAAAAAAAAAAAEAOEJJTScQAAAAAAAKAAEAAAAAAAAAAjhCSU0D9QAAAAAASAAvZmYAAQBsZmYABgAAAAAAAQAvZmYAAQChmZoABgAAAAAAAQAyAAAAAQBaAAAABgAAAAAAAQA1AAAAAQAtAAAABgAAAAAAAThCSU0D+AAAAAAAcAAA/////////////////////////////wPoAAAAAP////////////////////////////8D6AAAAAD/////////////////////////////A+gAAAAA/////////////////////////////wPoAAA4QklNBAAAAAAAAAIABjhCSU0EAgAAAAAADgAAAAAAAAAAAAAAAAAAOEJJTQQwAAAAAAAHAQEBAQEBAQA4QklNBC0AAAAAAAIAADhCSU0ECAAAAAAAEAAAAAEAAAJAAAACQAAAAAA4QklNBB4AAAAAAAQAAAAAOEJJTQQaAAAAAAL0AAAACAAAABAAAAABAAAAAAAAbnVsbAAAAAMAAAAIYmFzZU5hbWVURVhUAAAABE9/dSiABQAAAAAABmJvdW5kc09iamMAAAABAAAAAAAAUmN0MQAAAAQAAAAAVG9wIGxvbmcAAAAAAAAAAExlZnRsb25nAAAAAAAAAABCdG9tbG9uZwAAASwAAAAAUmdodGxvbmcAAAH0AAAABnNsaWNlc1ZsTHMAAAABT2JqYwAAAAEAAAAAAAVzbGljZQAAABIAAAAHc2xpY2VJRGxvbmcAAAAAAAAAB2dyb3VwSURsb25nAAAAAAAAAAZvcmlnaW5lbnVtAAAADEVTbGljZU9yaWdpbgAAAA1hdXRvR2VuZXJhdGVkAAAAAFR5cGVlbnVtAAAACkVTbGljZVR5cGUAAAAASW1nIAAAAAZib3VuZHNPYmpjAAAAAQAAAAAAAFJjdDEAAAAEAAAAAFRvcCBsb25nAAAAAAAAAABMZWZ0bG9uZwAAAAAAAAAAQnRvbWxvbmcAAAEsAAAAAFJnaHRsb25nAAAB9AAAAAN1cmxURVhUAAAAAQAAAAAAAG51bGxURVhUAAAAAQAAAAAAAE1zZ2VURVhUAAAAAQAAAAAABmFsdFRhZ1RFWFQAAAABAAAAAAAOY2VsbFRleHRJc0hUTUxib29sAQAAAAhjZWxsVGV4dFRFWFQAAAABAAAAAAAJaG9yekFsaWduZW51bQAAAA9FU2xpY2VIb3J6QWxpZ24AAAAHZGVmYXVsdAAAAAl2ZXJ0QWxpZ25lbnVtAAAAD0VTbGljZVZlcnRBbGlnbgAAAAdkZWZhdWx0AAAAC2JnQ29sb3JUeXBlZW51bQAAABFFU2xpY2VCR0NvbG9yVHlwZQAAAABOb25lAAAACXRvcE91dHNldGxvbmcAAAAAAAAACmxlZnRPdXRzZXRsb25nAAAAAAAAAAxib3R0b21PdXRzZXRsb25nAAAAAAAAAAtyaWdodE91dHNldGxvbmcAAAAAOEJJTQQoAAAAAAAMAAAAAj/wAAAAAAAAOEJJTQQUAAAAAAAEAAAACzhCSU0EDAAAAAAT4AAAAAEAAACgAAAAYAAAAeAAALQAAAATxAAYAAH/2P/tAAxBZG9iZV9DTQAB/+4ADkFkb2JlAGSAAAAAAf/bAIQADAgICAkIDAkJDBELCgsRFQ8MDA8VGBMTFRMTGBEMDAwMDAwRDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAENCwsNDg0QDg4QFA4ODhQUDg4ODhQRDAwMDAwREQwMDAwMDBEMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwM/8AAEQgAYACgAwEiAAIRAQMRAf/dAAQACv/EAT8AAAEFAQEBAQEBAAAAAAAAAAMAAQIEBQYHCAkKCwEAAQUBAQEBAQEAAAAAAAAAAQACAwQFBgcICQoLEAABBAEDAgQCBQcGCAUDDDMBAAIRAwQhEjEFQVFhEyJxgTIGFJGhsUIjJBVSwWIzNHKC0UMHJZJT8OHxY3M1FqKygyZEk1RkRcKjdDYX0lXiZfKzhMPTdePzRieUpIW0lcTU5PSltcXV5fVWZnaGlqa2xtbm9jdHV2d3h5ent8fX5/cRAAICAQIEBAMEBQYHBwYFNQEAAhEDITESBEFRYXEiEwUygZEUobFCI8FS0fAzJGLhcoKSQ1MVY3M08SUGFqKygwcmNcLSRJNUoxdkRVU2dGXi8rOEw9N14/NGlKSFtJXE1OT0pbXF1eX1VmZ2hpamtsbW5vYnN0dXZ3eHl6e3x//aAAwDAQACEQMRAD8A9VQ776seizIvcK6aWmyx54a1o3Pc7+q1EXOf4xLW1fU3qT3khobWCRzrbU3+KBNAldCIlOMSeEEgGX7t9XKu/wAbHRm2ObTiZFtYMNsOxm7+UGOfu2/1lD/x2umf9wMj/OZ/5JeT/tHE/eP+aU46jifvn/NKr8ebsfsdgct8N65I/wDhj6x/47PS/wDuDf8A5zP/ACSb/wAdnpf/AHBv/wA5n/kl5R+0cP8AeP8AmlTo6rgVvLrG+q0gjaQRz+d3/wBf+E96XHm7H/FSeX+G1pKJ/wCq/wDoT6n/AOO10z/uBkf5zP8AySf/AMdnpn/cDI/zmf8Akl5p+3eh+39QZAgGX3agfB7fc5L9vdH9MsOGwkvLmmbBtaSP0ftfuftb+dYjxZv5RWDB8O7j/wANj/376X/47PS/+4N/+cz/AMkl/wCOz0z/ALgZH+cz/wAkvMj1zpHqNsZh1jaDuY42uaSXBwd/ON+g39H+4iv+sXRjvjArG6k1NJ3y1x3fp27djHWe789iXFl/lFXsfD/D/wANj/376P8A+O10z/uBkf5zP/JJ/wDx2ul/9wb/APOZ/wCSXnTfrP0UWve7peO9jtuys+oGsA9Quja4Pdv9X893+BqQ6frB0WvZvwK7NjnktcXgOa4+xlm3bZ+i/kWMS4sv8oo9nkL6f+Gx/wC/fSP/AB2umf8AcDI/zmf+ST/+O10v/uDf/nM/8kvKD1HCkkOIBPG06DwTHqGH+8f80ocebsf8Vf8Advh378f/AA3/ANCfVz/jb6WOMC8/2q//ACS0Oh/4x+i9XzmYLq7MO647aTbt2Pcfo1eox3tts/we5v8A4IvFvt+J+8f80o/T8/HHUcUte4EXVkEAyCHtMpwnlsWD9jHk5fkeE8M4iVafrL1fo5JJJTuSpJJJJT//0PVVy3+M/wD8QvVPhT/5/oXUrl/8ZrXO+o/Uw0FxIp0Gp/n6EkjcPz6kiHHyBzU//NKb7Pf/AKN/+aUOIdwu9rJ+5L7CwSRPs+R/on/5pTfZ7/8ARv8A80pcQ7hXtZP3Jf4pYJIn2bI/0T/80pfZsj/RP/zSlxDuFe1k/cl/ilGkifZ8j/RP/wA0pfZsn/RP/wA0pcQ7hXtZP3Jf4pRpIn2fI/0T/wDNKb7Pf/o3/wCaUuIdwr2sn7kvsLBJT+z3/wCjf/mlL0L/APRv/wA0pcQ7hXtZP3JfYWCsdO/5Qxf+Or/6pqH9nyP9E/8AzSrHT8fIHUMWanj9NX+af3mpWO4V7WT9yX2F+nkkkkVikkkklP8A/9H1Vc9/jA/8SHUf6tf/AJ9qXQrnf8YH/iP6j/Vr/wDPtSbP5ZeRZeX/AJ/F/fh/0ngPqj0jq3UMO+zBtxGMrvb7cqo2O9VrJqsY5rH7PTY963P+anXjuJv6U8P0M4shzyZ37fR2us930lH/ABYiOk5wMwclgMcu/R/Qauvngl0EaFw4aP3Wfy1FCAMQ3+Y5icc2QCt+zyf/ADW+sGyxluR0ywbnul9L3embH+s/0d1e3u+vZ/o/+EQ8v6m9byqrKn3dMr9QAPNeOWOa0FjmbbBTuq2bNjdn+DXYDSANCNWg8NH7z/5aWmoEkHUNPJP+ks/kp3txYhzeUa6d/lD5/wD+Nl1M8Z2NLtWiLdR+9/NqP/jZ9TOoz8Yg6N0t1P8A22vQ5GsmQ7kjlx/db/waU+LoIEOI7D/R1/ykPah2Xnn+Y/eH2B8+/wDGz6jyc7GgaOMW6H91v6P3Jv8Axs+qg+7PxgR9IEW6D/tpehSdNQ0t1Hgwfvf102kQPGWtPf8Al2pe1Dso/EOY/eH2B4zA+pXXcCt9VGXgWNse23bdS+yCwENt/SUn0/a5EP1T+sJxxj/a+nlpr9Jlhod6hAZ6O71PS3bmN9T9L/Lt/wBKuvOs67g4/N5/9Jp5GpLu0OcP/PdSPtx8Vh5vKSSeGz/VDyX/ADW6/u3G7pLxumHYpf7uNjd9LnP/ADN3uVa/6v8AVun4lX2zL6W5lJrpY+zGsus+kW1YtNXo2Oybb9/8wyv1v0f6L/CLtQSCJIaWjnswfyf5azsx4p670q24hlBZkU45eYa3Mt9D7M63X+dyMRmdj427/iP8OiIBbLmcldPsfPcz6qfXbMynZI6UQHtY1kGqobWMbXX+r1PsbQ7Yz9JXv+ms2/p3VOi9RxG9ZxjiS9locXNeAwP91jvT97GN2r2x1Ge+mo4l5r26PY8AT+kY5z9zq7XNf6Tbq2s+h+k/kLz36/8A2ij6xdEOXcz1qqqzZefawbbz+le521rdrPda76CZPHEDirqz8tzmacvaJ9PCeg/RD6jXZXbW22pwfW8BzHtILS0iWua4fSa5SWF9WqLn9FrdVa/Gxn35NuGxjGt/VbL7bcBvp31v9Kv7K6r0atlXpU/otnsWliOuGRkUWWm4V7C1zg0OG4e5v6Jtbfzf3VO5bbSSSSU//9L1Vc7/AIwf/Ef1GP3a/wDz7UuiXO/4wf8AxH9R/q1/+fak2fyy8iy8v/PYv78f+k+VdE6/1rpTXUYGScai6wOtd6TLACRs9T9JXY5vs/cWu762fWVlQcOsNdY0EtpGIJLoa+JdiBn5301gdLy2UvNTnZLTc9gb6Fwpb+c39Lurt/e9j/zFql+QWmt5y3+oHbSM+qCAJdMtb+b9Bv6P1voKtEmty7eWEDI3jh/eIhcv8Zs2/Wv6xMa8t64y1rQ54DcUHe5v0dTibNr/AN/ek/63fWEhxr662xx27m/ZADBLG/8AcX6DHPd/22qlbsit1te7J3O2SWdQoA2hv6Dc/bsezafp7f0XsrSHrlptsflPq2y4HPpmanPdXMj3Mpt9ez/z2nWe5/5zH7eP9yH2Y/8AvW5/zs+sQc7d11jIOxrnYke2G7rBtxP0dfqepV/pP0f82ot+t31jD3B3WmVipxawHFadJhtsMxXbN38r9KqwdlXhw35T2NH6Vpz6dWOAs19v5rvp/wDgn6REFme2GG3IIDjtI6hRuDj7qv0nuf7K3WWWbfp2/wDFoWe5/wCck48YH83D/wAa/wC9bB+tfXtk/t6vmWH7J7Xkj952J+97fcot+tf1idUXu66xvqOIE4g9206e77L+ezZbXW399VnZF2NtYy3LDKoADc6iWhhZVjNr2izZs/cr/wCMUKsbJrDBV9pY1jS0hmdQ1u6yfUa1zW7Wets+j+4jZ7n/AJyDjxkXwQ+zF/3rdP1s+sZa9w65W54aJb9lDZZLW7q92K121rd1jms/MqsT/wDOz6wi4hvXG7GVy212IA2dd1bWtxXv/l+o5qpsbe+y6t7smS0V3T1Gktc1w3saTt/SM/S/QUWjJNG+52W+pzAXxn06h8bW+mQ53u9T3tQs9z/zkjHj0/Vw+zF1/wAFtf8AO76wzWG9cbs3vEnEadoG70rDtxn7/X2s2/8AGKNn1l61k0nGyutY9tF38/VZhh7CB9NtjXYfv2fS2oGS7PZURRflNtIZXW5+dU5oDtrX1bG7Hv8Ac/b/AMCqe36wUMfsyQ1rnF79uTUCXEit7v5ze9z/AG7/APtxHil3KPZxHeMB2+T/ALxr2Y32k+vZ1h/qPYHP9Vtzy0NG1rH2WV2/RY1jKv0liDRjNb1THrfa7LaLatrnghhBcx0+jY1nt93+EYr9dP1j2mmvJdFOjqxkNIa1ga9r/wCc2eltd7P7aqt+1N6zU3Lf6mR69XqP3iyTLP8ACsLmv9qFnTzXRjD1CwRwmo3cR/gP0CquP/T8v4VfkcrSq4/9Py/hV+RytOC2kkkklP8A/9P1Vc7/AIwZ/wCZ/UY/dr/8+1LokLKxaMzGtxclgsovY6u1hkS1w2ub7fcgRYI7hdjlwTjL92Ql/ivz7i5jsYnbVVZJBBtYHkEfR27kb9rOB0xMPV24/oGnuXbdfos/qrv7/wDFDhutccfqVldX5rLKm2OHxsa+nd/22h/+M9X/AOWzv/Ycf+llX9ufZ2TzvKnUy1P9WT55l5RyXNLqqqi0H+aYGAyd3u2oTY4I+C9I/wDGer/8tnf+w4/9LJ//ABn6/wDy2d/2wP8A0sgcU+yY8/yw/S/5snzeQ3gKJM8gL0XI/wAUuNj02ZF/WCymlrrLHnHEBrRve7+e/NaEOv8AxW9OtNXo9cbaL93ouZS1wcWfzm17L3N9iXtT7JPxDlz+np/dk8AGCBITENJ4Xdv/AMXXSa66rn9eIryKvXpd9mPurjfvH6X91ye3/Fr0yl7GWdcc11kemPsx90tdbtr/AEnvd6TH2bW/uJe1Pso/EOV6S/5snhQGgRCju19oC7x/+LrotbxVb9Y667HNLtj62NcAA1x3tfeNntsZ7XpH/Ft0YZH2U/WOoZG8V+iWM37ydvp7PtG7fu/NS9mfZJ+I8tpUiP8ABk8EfgE0CeAu6q/xe9Ftvpx2ddc63In0mfZXe4AuYT/OfvVWf5iun/FNi731/tgh9bQ+wegPa127Y536b/g7Efan2W/f+X/fP+LJ85LW8wjdPE9QxQBzdXAH9dq77G/xU4WXV6uL1xuRVMb6qmvbI7bmXuatf6v/AOLHpvSc+vPycl+dbQ4PoYWCtjXD6Njmh1jrHsd7q/eiMU71WZOf5fhPCSTW1F7G2xtVT7XzsraXO2guMAbjtYwOe/8AqsXM9P8Ar39UsrqZpxuottuzHVVUVtrukvPsDdafb7nf2Pz104sYXFgcC5ujmg6jQO1/svYuO6V9TOjdB+uOV1qy6ipubp0vGc5rSyy3TN9Ot7W/nOZXjeg/+aybKPT/AJtWHGezSUbLGVMdZY4MrYC573GAANXOc4/Ra1SSU//U9VSSSSUpJJJJSkkkklOb17BqzenXVvsNdjq31UE3PpYbLh6FLLfRez1PUteyvZY2z+oqWT0He6hudktdi1Psdvf73utuNeLi17eo/b6voOsY70/S9TIsr9Cmr9IrvXumP6jhtZUN1tNtVrK3W2VVvFdtV1ldvoTu311ba/Uqt9Kz9IszJ+q7r+jfZaqqKMhhuuYx4ZeDc94yKj61tDKqmOsYz1NuH7K/0Vf6Ov3pTLJ6H1HLx8VzrKjbjYYqeWk7bbSB6rSyj7Kyur2enXZVs/pNv6Kr0/fTv6DlssYbfsbhi00vuNtpbuaz0HZG8eg/0sd9mPlfpnfT+0W/ov51anUuk57umtwenv8AdXVYynJOQ/EdW5w20n0Om47KLWU/mM2M+gidU6Xk5lbzU1jb86huHmFzyWVUn1HXPo/Rtfff+lfXTv8ARZ/hH/6NJTjXdMury8Rt/U6cfLopbVXiHKe0WOLKKALWb2XfrNlNv9E9H/B2enmfpq1uHF6ic77R6Ldu8H+nZG3b9Dd9j9D7N/N+70voer/24myek25PVRabbq8P0ybRXlXsL7TtZWxtNVjK6Kaa2b3el/O22f8AGepJ3Tst/Wasq+912JU211dOjK67SamUO9Ng9S9/ouyv0l9tjGf4KqpJTidP6Dk42bivbmU3ZGLY1g/SF7/Sb/SRY23f+lf+n/mm1MZdf7PRW79htvxuotuawPznWNay1vqM2Bn2WoWsY9nqU2tr9Z9Pq1/z2z9Gqr+lZdvUsfIOJhUV0ZD7nX1uJvc11eRSDH2dn6V7r2Os/T/6T+cVvE6Sca5lv23Lv2Aj07rA5hkbfe3Y1JTj09Ly7sih1edXt3G5lNeQbXsYDRX9pGVZS6/Pe30H0frDf5q77L9o9H9HYejofV6vTAurY0FvqlttziSyzGufkxYXfpsv7Pd61f8Ag/W/ncv9N6tzoXSLenUg22vdY5pD6S4Prad77P0NjmfaGs9/8x6v2ar/AANNa1UlPLW/V7qmLtvxLGvy21tooul7nV7hiVXPf6r/ANJQ/wBPOyb936T1bK7tl2StS7peSzJ34gosptopxrG5W55ayh9j22D6X2lz2Xv9ltlXv9Oz1VqpJKeYu+rPUbKbKnXMsbY11bmPst2ve4Pb+1LYH9Ldv2Pw/wCj/wDDfzfp6nR+m5eFblPybfV9ZwLTuJ3Q6x3rOr9OptVj22Mrd/PfzNf6XZ6bGaaSSn//2ThCSU0EIQAAAAAAYQAAAAEBAAAADwBBAGQAbwBiAGUAIABQAGgAbwB0AG8AcwBoAG8AcAAAABkAQQBkAG8AYgBlACAAUABoAG8AdABvAHMAaABvAHAAIABDAEMAIAAyADAAMQA1AC4ANQAAAAEAOEJJTQ+gAAAAAAYWbW9wdAAAAAMAAAABAAAAAAAAAAcAAAABAAAAAAABAAD//////////wAAADwAAAAB/////wAAAAAAAAAAAAAAAAAAAAEAAAAA/////wAAAAAE/////wAAAAD/////AAAAAP////8AAAAA/////wAAAAAAAAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAAAAAAAAAAAAAAAAAZQAAAAQAAAAAQAAAAAADlRhcmdldFNldHRpbmdzAAAACQAAAABNdHRDT2JqYwAAAAEAAAAAAApOYXRpdmVRdWFkAAAAAwAAAABCbCAgbG9uZwAAAP8AAAAAR3JuIGxvbmcAAAD/AAAAAFJkICBsb25nAAAA/wAAAABPcHRtYm9vbAEAAAAAUWx0eWxvbmcAAAA8AAAACmJsdXJBbW91bnRkb3ViAAAAAAAAAAAAAAAPZW1iZWRJQ0NQcm9maWxlYm9vbAAAAAAKZmlsZUZvcm1hdGVudW0AAAAKRmlsZUZvcm1hdAAAAABKUEVHAAAADG5vTWF0dGVDb2xvcmJvb2wAAAAAC3Byb2dyZXNzaXZlYm9vbAAAAAAMem9uZWRRdWFsaXR5T2JqYwAAAAEAAAAAAAlab25lZEluZm8AAAAEAAAACWNoYW5uZWxJRGxvbmf/////AAAADWVtcGhhc2l6ZVRleHRib29sAAAAABBlbXBoYXNpemVWZWN0b3JzYm9vbAAAAAAFZmxvb3Jsb25nAAAAADhCSU0PoQAAAAAALW1zZXQAAAAQAAAAAQAAAAAABG51bGwAAAABAAAAB1ZlcnNpb25sb25nAAAAAAA4QklND6IAAAAAAAhtczR3AAAAAjhCSU0EBgAAAAAABwAEAAAAAQEA/+ES3mh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8APD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzIgNzkuMTU5Mjg0LCAyMDE2LzA0LzE5LTEzOjEzOjQwICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUuNSAoV2luZG93cykiIHhtcDpDcmVhdGVEYXRlPSIyMDE3LTAzLTAyVDA5OjU3OjEwKzA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAxNy0wNC0yMVQxODoyODo1MyswODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAxNy0wNC0yMVQxODoyODo1MyswODowMCIgZGM6Zm9ybWF0PSJpbWFnZS9qcGVnIiBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIiBwaG90b3Nob3A6SUNDUHJvZmlsZT0ic1JHQiBJRUM2MTk2Ni0yLjEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MDMyM2FmNWMtNTQ5Zi04YzQwLTgwMzQtZjQ3MjEyY2QwODRlIiB4bXBNTTpEb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6NDU0MzRkNDYtMjY3ZC0xMWU3LTlkMjItZTBjNTZlOGRjZmI3IiB4bXBNTTpPcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6MDE2NzZkMGMtZWJiOC1hMzRkLTg4NDEtOTdkYTMzNTVlZmM3Ij4gPHBob3Rvc2hvcDpUZXh0TGF5ZXJzPiA8cmRmOkJhZz4gPHJkZjpsaSBwaG90b3Nob3A6TGF5ZXJOYW1lPSLljaHniYfog4zpnaLmnKvkuInnorwgLyBTZWN1cml0eSBDb2RlIOOCu+OCreODpeODquODhuOCo+OCs+ODvOODiSIgcGhvdG9zaG9wOkxheWVyVGV4dD0i5Y2h54mH6IOM6Z2i5pyr5LiJ56K8IC8gU2VjdXJpdHkgQ29kZSDjgrvjgq3jg6Xjg6rjg4bjgqPjgrPjg7zjg4kiLz4gPHJkZjpsaSBwaG90b3Nob3A6TGF5ZXJOYW1lPSLilrwiIHBob3Rvc2hvcDpMYXllclRleHQ9IuKWvCIvPiA8L3JkZjpCYWc+IDwvcGhvdG9zaG9wOlRleHRMYXllcnM+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImNyZWF0ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6MDE2NzZkMGMtZWJiOC1hMzRkLTg4NDEtOTdkYTMzNTVlZmM3IiBzdEV2dDp3aGVuPSIyMDE3LTAzLTAyVDA5OjU3OjEwKzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNS41IChXaW5kb3dzKSIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6YzE2ODE0NDUtZjliYS05NDQwLWE3ZDQtYjNjNGM2MzU4ZTgzIiBzdEV2dDp3aGVuPSIyMDE3LTA0LTIxVDE4OjI2OjEzKzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNS41IChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0ic2F2ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6MTQyZGViODYtMzRlOC1kZDRhLThiMDMtMGRjYzY2ZWQ3NWU4IiBzdEV2dDp3aGVuPSIyMDE3LTA0LTIxVDE4OjI4OjUzKzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNS41IChXaW5kb3dzKSIgc3RFdnQ6Y2hhbmdlZD0iLyIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY29udmVydGVkIiBzdEV2dDpwYXJhbWV0ZXJzPSJmcm9tIGFwcGxpY2F0aW9uL3ZuZC5hZG9iZS5waG90b3Nob3AgdG8gaW1hZ2UvanBlZyIvPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iZGVyaXZlZCIgc3RFdnQ6cGFyYW1ldGVycz0iY29udmVydGVkIGZyb20gYXBwbGljYXRpb24vdm5kLmFkb2JlLnBob3Rvc2hvcCB0byBpbWFnZS9qcGVnIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDowMzIzYWY1Yy01NDlmLThjNDAtODAzNC1mNDcyMTJjZDA4NGUiIHN0RXZ0OndoZW49IjIwMTctMDQtMjFUMTg6Mjg6NTMrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE1LjUgKFdpbmRvd3MpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxNDJkZWI4Ni0zNGU4LWRkNGEtOGIwMy0wZGNjNjZlZDc1ZTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDE2NzZkMGMtZWJiOC1hMzRkLTg4NDEtOTdkYTMzNTVlZmM3IiBzdFJlZjpvcmlnaW5hbERvY3VtZW50SUQ9InhtcC5kaWQ6MDE2NzZkMGMtZWJiOC1hMzRkLTg4NDEtOTdkYTMzNTVlZmM3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDw/eHBhY2tldCBlbmQ9InciPz7/4gxYSUNDX1BST0ZJTEUAAQEAAAxITGlubwIQAABtbnRyUkdCIFhZWiAHzgACAAkABgAxAABhY3NwTVNGVAAAAABJRUMgc1JHQgAAAAAAAAAAAAAAAAAA9tYAAQAAAADTLUhQICAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABFjcHJ0AAABUAAAADNkZXNjAAABhAAAAGx3dHB0AAAB8AAAABRia3B0AAACBAAAABRyWFlaAAACGAAAABRnWFlaAAACLAAAABRiWFlaAAACQAAAABRkbW5kAAACVAAAAHBkbWRkAAACxAAAAIh2dWVkAAADTAAAAIZ2aWV3AAAD1AAAACRsdW1pAAAD+AAAABRtZWFzAAAEDAAAACR0ZWNoAAAEMAAAAAxyVFJDAAAEPAAACAxnVFJDAAAEPAAACAxiVFJDAAAEPAAACAx0ZXh0AAAAAENvcHlyaWdodCAoYykgMTk5OCBIZXdsZXR0LVBhY2thcmQgQ29tcGFueQAAZGVzYwAAAAAAAAASc1JHQiBJRUM2MTk2Ni0yLjEAAAAAAAAAAAAAABJzUkdCIElFQzYxOTY2LTIuMQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWFlaIAAAAAAAAPNRAAEAAAABFsxYWVogAAAAAAAAAAAAAAAAAAAAAFhZWiAAAAAAAABvogAAOPUAAAOQWFlaIAAAAAAAAGKZAAC3hQAAGNpYWVogAAAAAAAAJKAAAA+EAAC2z2Rlc2MAAAAAAAAAFklFQyBodHRwOi8vd3d3LmllYy5jaAAAAAAAAAAAAAAAFklFQyBodHRwOi8vd3d3LmllYy5jaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABkZXNjAAAAAAAAAC5JRUMgNjE5NjYtMi4xIERlZmF1bHQgUkdCIGNvbG91ciBzcGFjZSAtIHNSR0IAAAAAAAAAAAAAAC5JRUMgNjE5NjYtMi4xIERlZmF1bHQgUkdCIGNvbG91ciBzcGFjZSAtIHNSR0IAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZGVzYwAAAAAAAAAsUmVmZXJlbmNlIFZpZXdpbmcgQ29uZGl0aW9uIGluIElFQzYxOTY2LTIuMQAAAAAAAAAAAAAALFJlZmVyZW5jZSBWaWV3aW5nIENvbmRpdGlvbiBpbiBJRUM2MTk2Ni0yLjEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHZpZXcAAAAAABOk/gAUXy4AEM8UAAPtzAAEEwsAA1yeAAAAAVhZWiAAAAAAAEwJVgBQAAAAVx/nbWVhcwAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAo8AAAACc2lnIAAAAABDUlQgY3VydgAAAAAAAAQAAAAABQAKAA8AFAAZAB4AIwAoAC0AMgA3ADsAQABFAEoATwBUAFkAXgBjAGgAbQByAHcAfACBAIYAiwCQAJUAmgCfAKQAqQCuALIAtwC8AMEAxgDLANAA1QDbAOAA5QDrAPAA9gD7AQEBBwENARMBGQEfASUBKwEyATgBPgFFAUwBUgFZAWABZwFuAXUBfAGDAYsBkgGaAaEBqQGxAbkBwQHJAdEB2QHhAekB8gH6AgMCDAIUAh0CJgIvAjgCQQJLAlQCXQJnAnECegKEAo4CmAKiAqwCtgLBAssC1QLgAusC9QMAAwsDFgMhAy0DOANDA08DWgNmA3IDfgOKA5YDogOuA7oDxwPTA+AD7AP5BAYEEwQgBC0EOwRIBFUEYwRxBH4EjASaBKgEtgTEBNME4QTwBP4FDQUcBSsFOgVJBVgFZwV3BYYFlgWmBbUFxQXVBeUF9gYGBhYGJwY3BkgGWQZqBnsGjAadBq8GwAbRBuMG9QcHBxkHKwc9B08HYQd0B4YHmQesB78H0gflB/gICwgfCDIIRghaCG4IggiWCKoIvgjSCOcI+wkQCSUJOglPCWQJeQmPCaQJugnPCeUJ+woRCicKPQpUCmoKgQqYCq4KxQrcCvMLCwsiCzkLUQtpC4ALmAuwC8gL4Qv5DBIMKgxDDFwMdQyODKcMwAzZDPMNDQ0mDUANWg10DY4NqQ3DDd4N+A4TDi4OSQ5kDn8Omw62DtIO7g8JDyUPQQ9eD3oPlg+zD88P7BAJECYQQxBhEH4QmxC5ENcQ9RETETERTxFtEYwRqhHJEegSBxImEkUSZBKEEqMSwxLjEwMTIxNDE2MTgxOkE8UT5RQGFCcUSRRqFIsUrRTOFPAVEhU0FVYVeBWbFb0V4BYDFiYWSRZsFo8WshbWFvoXHRdBF2UXiReuF9IX9xgbGEAYZRiKGK8Y1Rj6GSAZRRlrGZEZtxndGgQaKhpRGncanhrFGuwbFBs7G2MbihuyG9ocAhwqHFIcexyjHMwc9R0eHUcdcB2ZHcMd7B4WHkAeah6UHr4e6R8THz4faR+UH78f6iAVIEEgbCCYIMQg8CEcIUghdSGhIc4h+yInIlUigiKvIt0jCiM4I2YjlCPCI/AkHyRNJHwkqyTaJQklOCVoJZclxyX3JicmVyaHJrcm6CcYJ0kneierJ9woDSg/KHEooijUKQYpOClrKZ0p0CoCKjUqaCqbKs8rAis2K2krnSvRLAUsOSxuLKIs1y0MLUEtdi2rLeEuFi5MLoIuty7uLyQvWi+RL8cv/jA1MGwwpDDbMRIxSjGCMbox8jIqMmMymzLUMw0zRjN/M7gz8TQrNGU0njTYNRM1TTWHNcI1/TY3NnI2rjbpNyQ3YDecN9c4FDhQOIw4yDkFOUI5fzm8Ofk6Njp0OrI67zstO2s7qjvoPCc8ZTykPOM9Ij1hPaE94D4gPmA+oD7gPyE/YT+iP+JAI0BkQKZA50EpQWpBrEHuQjBCckK1QvdDOkN9Q8BEA0RHRIpEzkUSRVVFmkXeRiJGZ0arRvBHNUd7R8BIBUhLSJFI10kdSWNJqUnwSjdKfUrESwxLU0uaS+JMKkxyTLpNAk1KTZNN3E4lTm5Ot08AT0lPk0/dUCdQcVC7UQZRUFGbUeZSMVJ8UsdTE1NfU6pT9lRCVI9U21UoVXVVwlYPVlxWqVb3V0RXklfgWC9YfVjLWRpZaVm4WgdaVlqmWvVbRVuVW+VcNVyGXNZdJ114XcleGl5sXr1fD19hX7NgBWBXYKpg/GFPYaJh9WJJYpxi8GNDY5dj62RAZJRk6WU9ZZJl52Y9ZpJm6Gc9Z5Nn6Wg/aJZo7GlDaZpp8WpIap9q92tPa6dr/2xXbK9tCG1gbbluEm5rbsRvHm94b9FwK3CGcOBxOnGVcfByS3KmcwFzXXO4dBR0cHTMdSh1hXXhdj52m3b4d1Z3s3gReG54zHkqeYl553pGeqV7BHtje8J8IXyBfOF9QX2hfgF+Yn7CfyN/hH/lgEeAqIEKgWuBzYIwgpKC9INXg7qEHYSAhOOFR4Wrhg6GcobXhzuHn4gEiGmIzokziZmJ/opkisqLMIuWi/yMY4zKjTGNmI3/jmaOzo82j56QBpBukNaRP5GokhGSepLjk02TtpQglIqU9JVflcmWNJaflwqXdZfgmEyYuJkkmZCZ/JpomtWbQpuvnByciZz3nWSd0p5Anq6fHZ+Ln/qgaaDYoUehtqImopajBqN2o+akVqTHpTilqaYapoum/adup+CoUqjEqTepqaocqo+rAqt1q+msXKzQrUStuK4trqGvFq+LsACwdbDqsWCx1rJLssKzOLOutCW0nLUTtYq2AbZ5tvC3aLfguFm40blKucK6O7q1uy67p7whvJu9Fb2Pvgq+hL7/v3q/9cBwwOzBZ8Hjwl/C28NYw9TEUcTOxUvFyMZGxsPHQce/yD3IvMk6ybnKOMq3yzbLtsw1zLXNNc21zjbOts83z7jQOdC60TzRvtI/0sHTRNPG1EnUy9VO1dHWVdbY11zX4Nhk2OjZbNnx2nba+9uA3AXcit0Q3ZbeHN6i3ynfr+A24L3hROHM4lPi2+Nj4+vkc+T85YTmDeaW5x/nqegy6LzpRunQ6lvq5etw6/vshu0R7ZzuKO6070DvzPBY8OXxcvH/8ozzGfOn9DT0wvVQ9d72bfb794r4Gfio+Tj5x/pX+uf7d/wH/Jj9Kf26/kv+3P9t////7gAOQWRvYmUAZAAAAAAB/9sAhAAGBAQEBQQGBQUGCQYFBgkLCAYGCAsMCgoLCgoMEAwMDAwMDBAMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMAQcHBw0MDRgQEBgUDg4OFBQODg4OFBEMDAwMDBERDAwMDAwMEQwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCAEsAfQDAREAAhEBAxEB/90ABAA//8QBogAAAAcBAQEBAQAAAAAAAAAABAUDAgYBAAcICQoLAQACAgMBAQEBAQAAAAAAAAABAAIDBAUGBwgJCgsQAAIBAwMCBAIGBwMEAgYCcwECAxEEAAUhEjFBUQYTYSJxgRQykaEHFbFCI8FS0eEzFmLwJHKC8SVDNFOSorJjc8I1RCeTo7M2F1RkdMPS4ggmgwkKGBmElEVGpLRW01UoGvLj88TU5PRldYWVpbXF1eX1ZnaGlqa2xtbm9jdHV2d3h5ent8fX5/c4SFhoeIiYqLjI2Oj4KTlJWWl5iZmpucnZ6fkqOkpaanqKmqq6ytrq+hEAAgIBAgMFBQQFBgQIAwNtAQACEQMEIRIxQQVRE2EiBnGBkTKhsfAUwdHhI0IVUmJy8TMkNEOCFpJTJaJjssIHc9I14kSDF1STCAkKGBkmNkUaJ2R0VTfyo7PDKCnT4/OElKS0xNTk9GV1hZWltcXV5fVGVmZ2hpamtsbW5vZHV2d3h5ent8fX5/c4SFhoeIiYqLjI2Oj4OUlZaXmJmam5ydnp+So6SlpqeoqaqrrK2ur6/9oADAMBAAIRAxEAPwD1TirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdir//0PVOKuxV2KuxV2KuxVTuLm3toJLi5lSCCJS0s0jBEVR1LMaADElMYkmhzYhe/nN+V1nMYZvMdozjqYS06/8ABxK6/jlJ1EB1djj7I1UxYgf86of7pD/8rz/Kj/qYYf8AkXP/ANU8H5nH3s/5E1f8z/ZQ/wCKcfz0/Kcf9NDD/wAi5/8Aqnj+Zx96P5F1X8z/AGUP+Ka/5Xr+U/8A1MMP/Iqf/qnj+Zx96/yLqv5n+yh/xTv+V6/lP/1MUP8AyKn/AOqeP5nH3r/Iuq/mf7KH/FN/8rz/ACo/6mGH/kXP/wBU8fzOPvT/ACJq/wCZ/sof8U3/AMrx/Kn/AKmGH/kXP/1TwfmsfeyHYWr/AJn+yh/xTv8AleP5U/8AUwwf8i5/+qeP5rH3r/IWr/mf7LH/AMU7/leP5U/9TDD/AMi5/wDqnj+ax96/yFq/5n+yh/xTv+V5flR/1MMP/Iuf/qnh/M4+9H8h6v8Amf7KH/FNf8rz/Kj/AKmGH/kXP/1Tx/M4+9f5D1f8z/ZQ/wCKb/5Xl+VP/Uww/wDIuf8A6p4PzWPvX+QtX/M/2UP+KaP56flODT/EMP8AyLn/AOqeH8zj70HsTV/zP9lD/imv+V6/lP8A9TFD/wAi5/8Aqnj+Zh3o/kXVfzP9lD/inf8AK9fym/6mKH/kVP8A9U8fzMO9f5G1X8z7Y/8AFN/8rz/Kj/qYYf8AkXP/ANU8fzOPvT/Imr/mf7KH/FO/5Xn+VH/Uww/8i5/+qeP5nH3r/Imr/mf7KH/FN/8AK8vyo/6mGH/kXP8A9U8H5rH3pHYer/mf7KH/ABTv+V4/lT/1MMP/ACLn/wCqeP5rH3p/kLV/zP8AZQ/4p3/K8fyp/wCphh/5Fz/9U8fzWPvX+QtX/M/2UP8Ainf8ry/Kj/qYYf8AkXP/ANU8P5nH3o/kPV/zP9lD/imv+V5/lR/1MMP/ACLn/wCqeP5nH3o/kTV/zP8AZQ/4p3/K8/yo/wCphh/5Fz/9U8fzOPvX+RNX/M/2UP8Aimv+V6/lP/1MMP8AyKn/AOqeP5mHej+RtV/M+2P/ABTf/K9Pyn/6mGH/AJFz/wDVPH8zj71/kXVfzP8AZQ/4p3/K9Pyn/wCphh/5Fz/9U8fzOPvT/Imr/mf7KH/FLT+e/wCUoND5ihr/AMYrj/qnh/MQ72B7I1I/g+2P62x+ev5TkV/xDD/yKn/6p4PzOPvZDsXVH+D7Y/8AFN/8r0/Kf/qYYf8AkXP/ANU8fzOPvT/Imr/mf7KH/FO/5Xn+VH/Uww/8i5/+qeP5nH3r/Imr/mf7KH/FO/5Xp+U//Uww/wDIqf8A6p4/mcfev8i6v+Z/sof8U7/len5T/wDUww/8ip/+qeP5nH3o/kXVfzP9lD/imj+e35TD/poof+RVx/1Tw/mId6P5H1X8z7Y/rb/5Xp+U/wD1MMP/ACLn/wCqeD8zj72Q7F1f8z7Yf8U7/lef5Uf9TDD/AMi5/wDqnj+Zx96/yJq/5n+yh/xTf/K8vyo/6mGH/kXP/wBU8fzOPvT/ACHq/wCZ/sof8U1/yvP8qP8AqYYf+Rc//VPH8zj70fyHq/5n+yh/xTv+V5/lR/1MMP8AyLn/AOqeP5nH3r/Ier/mf7KH/FLT+fH5Sg0PmKKv/GK4/wCqeH8xDvaz2TqR/B/uf1tf8r4/KT/qYof+RVx/1Tx/MQ71/knU/wAz/c/rbX89/wApWIA8xQ1PjFOB95jx/MQ71/knU/zD/sWVaH5o8ua9EZdF1O21FFAMn1eVJGTl05qp5J/shlkZg8i4mXT5Mf1xMf6yZ5JpdirsVdirsVdirsVdirsVdirsVdirsVdir//R9U4q7FXYq7FXYqgNe1vTtC0a81jUpfRsbGJpp370X9lR3dj8KL+03w4JSAFlsw4pZJiMfqk+LfzI/NTzF571SSS8ma30iN62WlIx9KNRUKX6epNT7Ujf5XDgnw5qcuYzPk99oOz8enjQ3n/FP8fwsOqPHKKdtYcCvj+vGltvZu/TFBa4nFeEu4HFeErlXx6DFIFN8l8cFM+IO5L4/rxpHEHclp16fPGl4wt5L4/rw0jiDVV8caRxBcGFOvTpjS8aynviho/PCxLarXbwxUBfT3yLbTRXCii2Nhv0GKg07mvj+vBTLjDvUT+b9ePCjxA4MjdDUj54aQZg8nfTgVoj3wq6m1T2whgQ1UeOKbaqPHFbaYKaEnp88Ia5Vbua+P68jwln4gbDJ4/rxpPGFwZSNjWmNLxhbUeOFHEHVHjivEG6Kd69MWJol3JfHA28QdVfHGl4lwZabnpjSDMBbzT+b9eNL4ga9SP+b9ePCUeLFa/Btwdx88nFpykHcKe3jiwt23jito3SdX1DSb6LUNOu5LO8tzyiuIWZHHjuOx/aH7WEWNwxnGEhwzFxL6//ACP/ADcTz3pEtpflE8w6aq/W1T4VnjOyzou1N/hlVfhR+P2VkVF2WDLxDfm8T2t2eME7h/dz+n+h/Q/4l6bmQ6l2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV//S9U4q7FXYq7FXYq8T/wCcrdXmtfI2n6dEzKNRvl9ehoGjgjZ+DeP7wxv/ALDMXVy9NO+9n8YOYyP8Mf8AdPldRxHv3zWvaxDiMCWsDJd0+jFQvrUV8cDYC7FLifwwsStbb6cLFbihxP4YocfwOKFaxsrq/vIbK0jM11cOscMS0qzMaAb7ffhAthOYiCTyCK1PQNQsFikYxXEMnLjPayx3EfJGVWDNEW4lWdPtfzpx+2uSMSGqGeMvL+t6V1p5e128ZVtrCdzIJSn7tgD9XRnlAJ2LIqNVftf7LBwFtlqIAbkdP9l9KHTR9WdoVSyuGa4XnbqInJkWoHJKD4lqeq4OEpOWO+42Xro+reqsIsrgzMhmWP0n5GMdXApUp/lfZx4SkZYVdj5qlpo2qXdzZW8FrIZdRkWKyDDgsrsQoCs1F6su/LIiJtslmiIkk/R9Svd+XNUt5o4o0W99WNpo3snW5UohKuaxFuPAj4uX+t9llwmBYx1ESLPp/r+j/dIF9O1L04pfqs3pTMEgk9NuLu3RUNKMT2AwiJYyyxJIsbN3GkalCHc27vFGUV5kUvGrSKGVS4qvIhh8OPCWAzRPXdD3FhfWzOlzbywPEVWRZEZCrOCyhgwFCwBK4SERmDyKP0zyzr2o3mn2djYyzXGqVawULtKqOyO6k7cEaN+b/ZTg/LCIknZjPPCAJJ+j6kzTyB5ne1u7lLeNls5ZIZ4vXh9WsMqwyssRf1HjjlkRGkVeHxYPCkka/FYF/V/Rl/EOL6v6v8KC17yzq+h3kFpfxp6lzGJrdoJY7iORC7R1R4WdGpJG6Hf7S5GUDHm24NRDKCY/w/zhwf7pMrr8uPNdm+opeQQ2baSsBvvrNzbwBWuoTPFGvquvqStGrH0o+T/5OTOKQvyaI6/FLhomXicXDwxlL6JcEvp/h/pJdY+UNavdJfV4UhSwWQxLJPcQQF2Th6nprK6M4i9WMyso4pz+LEQJFpyamEZ8Bvi/qyl/uf53Cq33kbzFZ6jpenNHBcXWtFRpi2t1b3Ky85PRWkkMjoAZAUqzfst/LhOMggd7GGsxyjKW4GP6+KMocP8AF/EEU/5Y+cq3BS1hkS3jWVXS5t2WdXieYfVyJP8ASG9KKR+EPNuKZLwpNB7QxGt/9jL0/wAPr/mer+clmueT9f0O0tLzUrdYoL0fuiskchVvTSb05VRmaKT0popPTlCPwfBKBA3Z4dRDISIn6f8ApH/O+lME/LPzkdSj02WzS1vZLeK7EN1PDbkJPJ6USt6roFlkk+BYT+85fs4fCldMDr8XDxA3G+H0gy+n1S+n/dIXR/Juv6q95DZwIZ7AlZ4ZZoopC6q7GONJGVpZOMUjcI+X2MgIE8nJnqceMDiP1+R/EfqQ175c1iz0Wx1u5tzFpupvLHYzMRWQwcRIQv2uILceWAxIF96xzRMzAH1Qri/zksyLaqAUGLZEbLGFD7dsVawK4n8MLA7qbCn8Mk1nZrCxb6Yq0RT+GKuxVaTvt2wsDu9D/wCcf9Xm0v8ANjRCjMIr1pLOdFNOaTRsFDeIWURv/sMv05qYdV2tjEtPL+j6n2zmyeKdirsVdirsVdirsVdirsVdirsVdirsVf/T9U4q7FXYq7FXYq8F/wCctR/uB8vnwu5v+TYzC1nIPS+zQuc/cHzLmvexb67YUFoeP3YEOwMm1O9OxwqDRXdN/uwM5FrFi4eGKHdN/uxStxVoHenj0wsLTDQ9Vk0jVrXUkjWU27hjCxIDqdnQkbjkpK1GGJo2wzY+OJj3pzZeZfLFis1vb6PcfVLmL07h3vFNwzC4guEHMQCJY0+rcOIg5t6sj+p9hEmJAdHGnp8kqJkLH9H0/TKH87i/j/nfwptL+aFrOhWbTJGaSS4LuLhFZYrmO5jKIywhmKi8PBpzN6bJ+74LJxWfi+Tjjs8jlL+b/D/M4P6X+1/w8KHvfzHM9jfw29pNDNqQczytc81jkkESkW6iNPSh4wlfT5N8LRrz/c/HE5dve2w0FSBJBEP6P9b69/q9X44kdD+bUou72aaxdxd3c94GEsTyJ6twtwkatPBOnFCtP7v7XGReHDix8ZiezBQAP0xEOv8AN4P4JQY/febXv9b0/UbmBnjshEPqwlaMH025MY3jCGHmdxw+w2Vmdm3Mx6XggYg/Vfqr8cTIIfzUht5ua2M8xZIxJe3E1tNfSPFN6y85pLVo3VfsryhaXl+89X4fTywZvx+A4k+ziRVj+rESjj+nh+nxP99w/wBFLF/Mm8+tTTvbeorWccFrE0lFt7uEH0ruMBQqvGzyMqAf7sweKy/ICgL/AIvV/ThL6saLh/M6NLuxvRp8oudPeIwIl0UgdY2hc+tGI/3jkwfCeXH+65I3ofHIZWs9n7EXtL+j6v4vp3/p/wC6/npF5m8zR62YyIpYhbxxQ26l4AnBGmduccEFujPzn/dsFX005r+85/BXOduTp9P4fdv/AFv6P8+U/wCajbr8yvMV7HoMF84ltdCdXjRAI2l4StJ8bAdeLmL4Rx4faVmwnKTV/wALCOgxx4zHnk/V+JI0ef8AQW0nWLU6JMt9rV7Jd3l2l2qiSJpvVS1kX0DJ6Cn7XpTRepJ8bfYRVl4go7c2saOYnE8Q4cceGMeHy4fE+r6/60ZKeqfmEkmvaHqumaasX6BhWG0jv5frjvwkeSP1JFW35LB6gSDbkiRx/G2ROXcED6W3HoahOEpf3p9XB+7/AOL+v+NOH/OUSXl9d/oqSB7q1htvqtveSJayNFZGzJu4XWQXKUbnGtY3TgiNI/xPk/zHk4w7JoAcV8MjLilD1/X4v7uX8CTaR+Yr2Pka68rSWjzrL9ZEDibhB/paxhjNBwb1pITDztn9SP03fIxy1Hhb82g4swyg/wA3p6vRf0z/AIeLi9aGHnixHmu38wSaWZf0e1iNMsDMPSjjsRGvB/3Z5h0j7cOMj+p+8+yzx+q6Yy0p8I4xL6+PjlX+qX5sjH53cL27u002eSaS3jhtpLm5imczRwTQevcMbYc5OE9OVv8AVZPTjWF5Hj55b47hfyVsBY5/wx/pRlww9f8AR/j4/wCcknmf8wbDzBpsVnNpckL1a5uZVuQQ979UhtEkRTF8EKrb82h5O7PI375VyE8gkOTkafRyxSsS/o/T/k+KWT+d9Xr+r/Yq+h/mLpVrqVhqWoaPLeXWmaYmn2MyXSxvFOkjubtfUgmX1R6n7vmjem37z7fHgjKAbI6JnoJSiYxlwiU+OXp/h/1P6o+lQ8t+dNB0K/mv4dIuZ7mSJk5S3oIcyeosiTr6PGa3lR4/UjosnOL++4yccjDIIm6b9RpJ5YiJkAL/AJnu+j1emcf999Kn5p/MSfzH5a07RrjTLa1l0+dpY7m29RQY/q8VukYjZnVPhhHPj9r938CfH6jLLxACmODQDFklMSlLiH0y/rSn/vmIqO+VOdELsDY4iop92KkLO2FgWsWLTCo9+2EMZBYPH7sk1uxS3Sop92BJCwmgwtcitwsGZ/k1/wCTS8s/8x0f8ctwfWHB7TH+Dz9z7qzaPCuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kv//U9U4q7FXYq7FXYq+b/wDnNPU7my0HywIOP7y6ueXIV+zGlP15VkxidAufotbk04lKHM8P++fKH+JdS/yP+B/tyv8AKQcz/RBqe+P+ld/iXUv8j/gf7cfykF/0Qanvj/pW/wDEupf5H/A/24/lIL/og1P9H/Stf4l1L/I/4H+3H8pBf9EGp/o/6V3+JNS/yP8Agf7cfykF/wBEGp/o/wClbPmbUz3T/gf7cfykF/0Qanvj/pXf4l1P/I/4H+3H8pBf9EGp74/6V3+JdT/yP+B/tx/KQX/RBqe+P+lcfM2pnrw/4H+3H8pBf9EGp/o/6Vr/ABLqX+R/wP8Abj+Ugv8Aog1P9H/Su/xHqP8Akf8AA/24/lIL/L+p/o/6Vs+ZdSPXh/wP9uP5SC/6INT/AEf9K1/iTUf8j/gf7cfykF/0Qan+j/pXf4j1H/I/4H+3H8pBf5f1P9H/AErf+JdT/wAj/gf7cfykFHtBqe+P+ld/iXU/8j/gf7cfykE/6IdT3x/0rv8AE2p/5H/A/wBuD8pBf9EOp74/6Vx8y6mTU8P+B/tw/lII/wBEGp74/wCla/xJqX+R/wAD/bj+Ugv+iDU/0f8ASu/xJqX+R/wP9uP5SC/6INT/AEf9K3/iXUv8j/gf7cfykF/0Qan+j/pWv8S6l/kf8D/bj+Ugv+iDU/0f9K7/ABJqX+R/wP8Abj+Ugv8Aog1P9H/St/4m1PxT/gf7cH5SCf8ARDqe+P8ApXf4l1P/ACP+B/tx/KQX/RDqe+P+ld/iXU/8j/gf7cfykF/0Q6nvj/pWj5j1Emp4f8D/AG4fysGP8vaj+j/pWv8AEWof5H/A/wBuP5WC/wAvaj+j/pXf4j1H/I/4H+3H8rBf5e1H9H/Srv8AEupf5H/A/wBuP5SCR7QakdY/6V3+JdT/AMj/AIH+3H8pBf8ARBqe+P8ApWv8Sal/kf8AA/24/lIL/og1PfH/AErf+JtT8U/4H+3H8pBR7Qanvj/pXf4m1PxT/gf7cfykE/6IdT3x/wBK7/E2p+Kf8D/bg/KQX/RDqe+P+laPmXUia/B/wP8Abh/KQY/y/qe+P+ld/iTUv8j/AIH+3H8pBf5f1PfH/Su/xJqX+R/wP9uP5SC/y/qe+P8ApWj5i1E/yf8AA/24fysEfy7qP6P+ld/iLUP8j/gf7cH5WC/y7qP6P+ld/iPUf8j/AIH+3H8rBP8AL2o/o/6Vo+YdQJqeH/A/24fysGP8uaj+j8nf4gv/API/4H+3H8rBH8t5/wCj8mb/AJI65fSfm35UjbhxfUYVag7MaHvhGCMTYYz7VzZYmEq4ZA9H6FZe6p2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV/9X1TirsVdirsVdir5k/5zh/44flT/mKuv8Ak3Hg6sx9J94/3z5GwsHYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FWc/kd/wCTf8o/9tO3/wCJYCzhz+B/3L9G8LB2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV//W9U4q7FXYq7FXYq+ZP+c4f+OF5U/5irr/AJNx4OrMfSfeP98+RsLB2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxVnP5Hf8Ak3/KP/bTt/8AiWAs4c/gf9y/RvCwdirsVdirsVdirsVdirsVdirsVdirsVf/1/VOKuxV2KuxV2KvmT/nOH/jh+VP+Yq7/wCTceDqzH0n3j/fPkbCwdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVZz+R3/AJN7yj/207f/AIlgLKHP5/c/RvCxdirsVdirsVdirsVdirsVdirsVdirsVf/0PVOKuxV2KuxV2KvmT/nOH/jh+VP+Yq7/wCTceDqzH0n3j/fPkbCwdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVZz+R3/AJN/yj/207f/AIlgLKHP5/c/RvCxdirsVdirsVdirsVdirsVdirsVdirsVf/0fVOKuxV2KuxV2KvmT/nOH/jg+Vf+Yq6/wCTceDq2D6D74/758jYWt2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxVnP5HGn5v+Uf8Atp2//EsBZwO/wP3P0bwsHYq7FXYq7FXYq7FXYq7FXYq7FXYq7FX/0vVOKuxV2KuxV2KvmT/nOH/jh+VP+Yq6/wCTceDqzH0n3j/fPkbCwdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVZz+Rv/AJN/yj/204P+JYCzhz+B/wBy/RvCwdirsVdirsVdirsVdirsVdirsVdirsVf/9P1TirsVdirsVdir5+/5y+trebQPLpljWTjdT8eQBpWNa0r8sxNVIgCnf8AYOGGSUhICQofU+Y10/TyP95oqj/IX+mYJyz7y9RHQ6f/AFOH+kim/lPyVB5l8wWuj28dvbtcc2e5lQCOKOKNpJJHIH2URGY5OE5yNWWjU6fT4oGZxwNf0IuuPy91WK7ubUaR6j2s91ayskYK+rYJ6lyAaf7qjIkf/Ix4sneUDFpCAeHHuIy+mP8AlPo/0yda/wDkn5h0fT7i9l06OcWU81vfrBHyEIgihl9VmoP3bLcbbf7rdsskMgF2XFxS0eSQiIQHEBw+mP8AEZR/3iB/5VV5nFxHany3Ms8kDXSRtAATChVXc1G3AunOv2Oa8srvL/ScwR0NXWKr4fpj9StfflNr0LTPaaI97ZxTJbi7jtioaSVljRQjKJAzSOqAFftYT4nfJhH8kauOKMq4uGoL9J/KHX7/AFG5s5NGNoLJWa9uJYf3cVIGnSpA39RF+Hj/ADc/s4R4hPMscn5KMQeHHLi+n0x/ncC7R/yuttR8p3PmNpbS1t4XnihjkhkIeS2iWVleZEaGBpFdVgEzr60nwrkYmZjxcTZlhpoZRj8KEjt/Dj/jPD9P1T/p8P0qN7+Vmrwm8kttHa7sbI0nvVtmRBSNZXqJFVhwV15bfy/zrgJyd8mUI6I0DHFGUv4eGHfwrX/KXzWL5LE+Wplu5I2lWEwAHgjiNj0p9tlT/WZf51w/vbr1MSNBXFWLh/qxU778q9etItOlbRxIupxQS24jjBIN1I0UEbggUkkZdl/yskTkHUtcY6ORPpx+i/4Y/wAHqktt/wAq/NNwkMkPlyaRLmNprcrADzjQqCy7bisiKP5mbivxYLyf0kmOiF2MW39GLHjptjX/AHmiHY/Av9Mh4s+8uT+QwfzIf6WLv0fp/wDyzRf8Av8ATHxZd5T+QwfzIf6SLhp1h/yzRf8AAL/THxZd5T+QwfzIf6SLjpth2tovf4F/pj4su8oOgwfzIf6SLjp2n/8ALNF/wC/0x8WXeV/IYP5kP9LFo6fYf8s0X/AL/THxZd5QdBg/mQ/0sW/0dYGn+jRe/wAC/wBMfFl3lfyGD+ZD/Sxd+jtP/wCWaL/gF/pg8WfeU/kMH8yH+litbT7Dp9Wi/wCAX+mEZZ95Yy0OD+ZD/SxbXTrBqf6NFXv8C/0wnLLvKI6HB/Mh/pYqn6N07/lmi/4Bf6ZDxp95bx2fp/8AU4f6SLR07T/+WaL/AIBf6Y+LPvK/yfp/9Tx/6SK4abpxFfqsW3X4F/pj4s+8p/Iaf/U8f+kisOnafX/eaL/gF/ph8WfeWv8AIYP9Tx/6SKeeTPIH+LdbGjafFbx3bwzTReogCs0MZcJWmxenEHJ45TkaBLjavDpsMOOWOFWP4I/xIm5/KnWhQ2ekm9VLKG/uzDBX0EmVnCPUfbUI/wAP+Q2SvJ3lrEdJ1jjj6jCPpj6uFWf8qbqHXG0S6gtoL86adUto+HISoLb616Smg/ecFdP5fUTjgvJdWeVshHSGHGMcDHj8P6I/zvD4m7v8o9WhitriPTlntJIbWa7uUh+C3N2qSLHJt9pI5oXk4/Y9VOWH953lA/JkkcGMG5cPpj6+D/pGSJT8ldUufMNto9jaJdGWVorq7S3cRQKt9LY+oxZRyTlC0nwcv2l+0j4ayXVlpMtIIGZhjj/NjUPV6I5f98lOl/l1HqMUcsf1eMSavbaIA0fSS5DlZNh9hfT3/awCUz1PPhbMmLTxP93D6JZfpj/Ai7D8oNcutSs7dtMEFhe3i2MOqPD+45SSNGr7CvEsjYR4l8yxn+TESeHGZRjx8HDHiQVt+Wuvzx2Lx+X5Cmoo0lm/ogLIiKHL8iKBeBD1b9n4sheTvk5Ahohdxxej6vTFQvfIGsWdhNqN3ob29lBM1vNNJCFCSI5jZWBFRSQGOv2fU+D7WJlkAu5LHDo5S4RHEZH1fTFkC/k0jadol091aRza29t6Nr9WnZvTu2Ko0TLHwuHjp++hgZ5I8sAnQ9XP3uHOWn4pAYo/u+L1Vj/g/wBx/RlJI4Pyx8zXFrZ3UPl6Z7fUKCzkWColLI8i8Nt+UcTuv8yrywA5P6TaYaMEgjFcfq9MW7j8ttft0v3m0CRE0zib5jCKRB0EikkDf92yyVX9j4/s5EnJ/SbY49GaAGL1/T6YqnmL8tr7y7pOm3+r2C2kmpS3McdpLFxkUWywks1R0b16f5LI3LGRnEAklGHHpcspRhDHLg4fVwx/j4v+IY8dMsSRS2i36/Av9Mj4su8t/wDJ+C/oh/pYqv6M07/lmi/4Bf6ZDxp95codnacf5PH/AKSLv0bp3/LLF/wC/wBMfFn3lf5P0/8AqeP/AEkVCbTLIPUW8fE/5A2yyOaXeXDzdnYQdoQ3/oxZl+TFjZL+anlhlgjBW+jKkKtQRWh6ZPFkkZCy4Wv0mKGCRjGIPD/ND7vzZvFOxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kv8A/9T1TirsVdirsVdirwX/AJy1/wCUf0D/AJi5v+TYzC1vIPTezQ9c/dF8y1oPnmA9aQnnlPzdN5YfUp7e0iur28tTZwyXKpLFEkkiNKWgkV0l9SNWio37MjfayyE+Fw9Tp/FoEkCMuL0/7H1fw/zmU3n5xwXtvqBudDBv79Ls/WI7nhGtxqGmx6fdTekIjXmYlnWPmvBmkTk32ltOa+n4pwY9mmJFS9MeH+H+HHk8WEfq/pcKnqP5vrcyyyQaSYDOdRkkDXPqD1dTs4bV2H7pfhjeD1VT/L9Pl+2wlm8u/wD2TLH2dVXK64P4f9SnKf8AO/pcLeufmwmoWep21tpP1RNXS8kvGNy0p+t389tNNKnJBxh/0NUjt/2ebfvWyMs12K5t2Hs7hMZGXFwcPD6f4MUZxjH+t+9+v/Yo1PzpsImS4h8vNHfjUE1KaYXv7uZ4wI1SWP0KuqQ80i/ecUeRpuDNkvHHc0nsqR2M/TweH9P0/wBX1fzv+JUx+ckBkcy6K8kcNTpY+tBGh52RspPV9OBEmBRuaKkdusbf5GDx/JP8lnpL+v6fq9fi/wA70/7NJ/Kf5hxeXtEu7FNNaa9nS5iW6S6eGJ47qH0uN1bhWS6WLeSGrR8GyMMnCKpyNTojlmJcXpHD6eHi+g8X7uf+T4v4mXx/md5bvvL+pX1/xg1n0by20+wBuGkC3cUEf2lj+ryAtCXLySRNEvwelL8DLZ4oIJPNwj2fkjOMY7wuMpS9P8Bl58f8X9L/ADUusvzmgi1R9QuNCWeQ3t7fW5M684mvbuK6CqzwSABPR9FmVFkdH/dvDkfzG905B7IMocInXphD6fq8OEsf87+lxf8AFLLL837CC5t559BaZrc2zgC84BpLG8ku7dv7hvhHrNHIv+7Pt/B9nAM/kmfZJIIE6vi/g/1SAxz/AIv6PpUdK/OB7G/+sPpfqxfUrS0EazKriSxkMsUqu8MgUFmbkipz/wB9zI/xYBqKPJnl7JEo1xfxSl9P+qenh+r8fzXnk87STPK/25GLvTxY1OUuyoDYLMWVB2C00FrPTb78Ia5uJI75JitqfHFi3z4kd/H5YFBoqtBkN3KABdQeGG14B3LWoNhsfEYQWuUR0Uizg0qfvyTj2Wub/wAx+/FFlersCKknxGJZxKrkXIoJr5a8wS6Fe3N3FGXlns7m0Rlf0yjXMLRCQEA7x8udP+GyUJ8Lj6jTjIAD0lGX+kPEzm5/PGS6vhfXmipJdxG2ubZo5zEi31vA8JmdBHSSKT1TJ6HwfF/u77WX/mL3IdWOyBEcMZbeqMtv8nKXFw/1o/z/APYsak8+Mvm3RvMtvZmK40yGxiuIGl5pcGyhSBqfAvppPDGFZP3nH4vibKvE9QPc5o0Y8GWMnaZnw7fR4h4/9hJPE/OKEJq7NoafWdUnmcTRzKnCCT0vRgasLSOLZbdUj4yRx8WflFy4ss/H57c3FPZX0+raAHT+L1cUvq/j4/8Ajyrb/nVCl7HPdaGZ4obmO+iiS7MbC4g1G6v4WL+k1UX688Tx8fj4LJyX7GSGfy/F8TXPsrahLpwfT/DLHDFL+L/auJIPKfn+z0Uzpf6T+kojqNvq9kguDbmK7tfU9MsQknqxES/HH8HL+dcjDJXMf0m7UaM5K4ZcHpOOXp4vRNM9N/OCe0ubO4k0wTPax2aOBOUDtZ3st4WA9NuPqGf06fFw48vi+zhGaujVPs0EEcXPi6fz4Rx/71EQfnXLEulK2mupsoUhu2huEj9YxWgtI2VWt3Qfu15Olyt3G/8AKicVUjPy2YS7LB4t/qPp2/peJ/O/3Hhpb5g/M+21Tyzf6KNFjthdXUlzassivFaiS49elvGYucTEH0m9OZIHRm/0f1G54JZbFU24tCccxPiuo8P9f08Hr9X+d9PF/TROgfnFFoul6bZ22jMXtJ7Ka6BvH+rSmxlEoeK3KMtvcT8Qs8ys/P4v3fxZKOahyaM3Z5ySJMvq4v4fV+8/p/xRj/DFN5PzN8tab5W06e0Zb3zBJHYxX1vGbiLitpplzYAv6kfooYxcR8fQkl9fi7t6P2cn4gA8/wBjj/k5yyEH0w9XD9P8eSGX/e/xfT/SSeP86LqLQZdKXTQJBaw21tdCZSUZNPh0+V3DRMzrLHbq6xpJFx5MrtMuR8baq/H0t57PufFxdeL/AGcsv87+kk3n3z/b+aYbaO30xtNMd5fahcsbk3Akn1ExNLxBSP00V4fgT4/hb/J5PGc+Lo3aXTHETcuL0xhy4fTj4v8AimJxsw6k75SXYQvmv5P/ADH78i3W7m3ifvxW3cj0JrhYndmX5N1/5Wl5a/5jU/Uctw/WHB7TA/Lz/qvuTNs+euxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kv/9X1TirsVdirsVdirwX/AJy1/wCUf0D/AJi5v+TYzC1nIPTezX1z9wfMdTmA9c9E/JjyLonm3WL+HWo5Ws7SAMGhfgRJI3Fa03P7TZfggJHd1Ha2qnhiDD6iXrDf84//AJcJCYliuZZWIPrCd6rQ9FFFXfvyRsyfy8XSfyvnu9vkq2v/ADj3+XfEFre6lPqAPzuGARVIO4UL8LbgnEaeKJds5+8fJRf8gfy9eixRXYVamvrksR132I+HB+Xi2DtnOP5vyRI/5x9/LhYQWt7opw3n+sNyLNToKBeSb/DT/mrD+Wgw/lrUXzj/AKVCn/nH7yFIWZIrsACpCzEgAbV3U4Py0Wf8tZx/N+SIb8gfy2SR5fSuHjJHpRC5PTrvQch4GuH8tBiO2dR5f6VSg/5x9/L8Mryx3ZiJK1aY8a02rxUHB+WiyPbWfpw/Je35B/l5HCYzHcvM3+7BcV479uI4muD8tBkO29R/Rr+qutv+cffy+Ppu0N3KC/FlM9FAFPtFV5b4RpYIl27qO+P+lWTfkN+XTKqRQXK8Osonbk/+sDyUf7HB+Wgkdt6jqY/JUT/nHv8ALpVYvFeMpjDeqZzQElfshVHujVP837WS/LQaz23qO+PyUZvyE/L6Vy8VvcwoB9iOdiB71cMfxwHTQZx7azjrH5IqX8g/y1Qlzaz+moCxhbl6vQk8zUnc9Gpx/wBjj+WgxHbep7x/pUJB/wA4/fl6Z1eSK6MRY/C05CEgVCkgA0/2WEaeKy7Zz1/D8lSb8gvy5VGBtrhZXqVC3DEIK9N+Vf8AZHH8vFiO2M/eP9Kttv8AnHr8vOULul44eQL6frUBAIqC1BStcRporLtnP/R+S25/IT8t3NIoLlCKVdbhiDQUqAwNOXVv+FxOnise18/Uj5Ii3/5x+/LqI/vI7uUKgc85iFHIqR9gBiN+OD8tBkO3NRVDh+ShL+Q35eu1Y4buNR2+sFu5O5K/Rg/LQbR23qO+P+lRP/Qv/wCW8LM8ttdvGCoQtcN8fXccQnwsOtPs/Dkvy0Gr+W9QeRj/AKVCJ/zj7+Xks4ql2qkmiieg8QtSv+xxGniifbGf+j8lZ/yA/LeKJle0uhM4PENcPVak0J6b+Hw/83H8vFgO185PMfJSh/5x5/LxjGZBeUkagRZhUioB34jB+WizPbWf+j8lS4/Ib8tyqpFBcoy0DOtwxBpXccgetcTpoModtagdY/6VfD/zj7+XSSfvVu5OKh2Qz8V3IoCwFd60wDSwWXbmo6cPyQ9x+Qn5dSS1ihuol329cnqSe4bpXj/scfy8FHbOo6mPyRUX/OP35bQu/rwXciRsF+OdhU0bpwC7H7XX+X9nD+WgwPbeoPIx+SGj/wCcfvy+lmChLtQQaKJ6k0FaCq9Wpg/LQbD23nA/h+St/wAqC/LWO3+O2umlcVQtcNUUc7mgUbj4T8P+r8WH8vBr/ljUE84/JRi/5x5/L5zGXN2oc0AE1WIrSoomP5aKT21n/o/JfdfkF+W1FWKG7R1+2RcEj6DRq4nTwRHtjUdTH5Oh/wCcd/y7ElZRdvxUO0YnI7jYtxFNjj+Wip7Zz9OH5KVz+QH5cSSD0Y7uNOlPX9+u4b9eP5eK/wAr5634fkrwf848/lnEZhPFdyKtE5NOylWPIfCFHX9peX8uH8vFrPa+c8uH5Ib/AKF6/Lue4bjHdxIeTcVnJoACaCoJ7fzY+BFP8rZgOnyYl5+8t/kD5EsVj1QXd5rEg5WumQXDNcuCSFLqKJFGfFyrfD8HqfZyQ08WqXbGYHmPk8a8zaB5sCWl/F5fm8vaTqHqGwW6dpZ5Fj48i3IK9PjXi3oRK37PLIThjhz3cjT6rV6kkRMYAJH/AIav5N7iedz4BWp+Ncr/ADAHKLmfyRKX95llL8e9cPKMZHS45eNB/wA04/mpdwZDsHB/On84/wDEu/wzfx729xPGR2KtT8KY/mAecUnseUP7vLOP496k0uvWJPrxi6jX7RXZh+AP/C48OKfL0lHi67T7yAzw/o/V+P8AMk9A/IzVLW8/NDy2IzxlF4nKNtm6H78EcMoTFs83aOLPppiJqXD9Evqfd+bF4x2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV/9b1TirsVdirsVdirwT/AJy3I/QHl+pp/pc3/JsZh6wbB6T2bNTn7g+Y6r4/rzX09bxh7D/zjVO6+YtXjjAJks13oeW0q7D51zK0vMui7cIOOP8AWfRVtaGpkkAAT9httx/MKfZzNp5iUlKZjcSVjQlgPiNKsd+ppikbK8UYt4fXYjkacSDuAfmOv/N2FiTZpD09aekaceZ2UdBU4GV0N0U0iW0ISqmShpQGpJJrWopQf82/ZwsOZQsMLzsxWigbsxFFH3DBTMypE3VwigxJStSGFOgG29R9r/NcSxgOqna2zMfVYfAm9K0qQe/gPfEBlKfRZPKsklY61I/eGnHkfHiK4CmOytDD6ERnfYkUHQ0B9js3hx/zU0xMrNIY/vJeEQIVm+BK+OLK6G6MqltBxanMqdq9anoR9H/Gv2vslhzKEjhedyEAA6nwG/vgpmZUibuWNEMSgE1Iod6U2B7Ub/iP+rhLCIPNRtLZnYSGvBCDt1O/QYAEyLU8wDH0WKhx+8CVVSfYfLFQO9VggMUZmlA3FArCooe5ofo/ycKCb2CizM7elEzGLl+7Qnx6bdMDMd5RQEdvb0cDmV+IVB5cj02P+f7P+UsLsoNI2lfjGN+tK9N/fBTYZUirqSFIvSUA1Jota0oKctj/AJ/tYS1x3NqFrbs7ByD6ampNK1odwOxNMQEyNNyzBGIgeituyipUMdvhJ36YqB3rreAIhllA4kUCsDSh7mgqP8kj9rGlMu5Skkdj6UbM8daICNyK7DFPmiVjjhtiZFNWHxAjqT0ofH/P7OFjdlCqJZWCJyYD7K7mgwM+SKuvRji9OhrUlOgIptWu/wAP/Ev+JEsIkkoeCN5ZObmqKQXZqnYEV+eAMiaXSy+k3GJhxPxBdn4E9QG/pigC+bdvbjiZJQOBFFBPEknvU7D2rjSmXcpyyuaxKwdR8IbiAWA6b9cUgIhIIo7ctKNyPiqNxUmnE067f81f5BYk2UKzTTMEqzgfZBqaDAmqYB+dv5kT+UNOstE8vRG58463J6WkxKKvECeBmKkfF8XwxK3wtJ8f2EkjyQDTKZQX5V/kpYaFMNf8xuNa833DCe+1G5YyiF3I5CIv+1U0M5+P+X00xu2Qhw+97XoShDPGGqg4FQaclry2JGGLXl6Jrkmp2KuxV8L/AJwEf8rP8zb/APH/AC/rzU5h6y+g9my/weH9Vi/l7yxqGt+aNOt9BufqGvyTA6fdqxjpOoLRksu6/EB8f7OW6fLIGujr+19DjljOQDhnH/Z/1n13+RH5s33nHT73QfMsP1Pzv5db0NXtmAQyhTw9cINlPIcJlX4Vf4l+CRFzYvHPVcVdirsVdirsVdirsVdirsVdirsVdir/AP/X9U4q7FXYq7FXYq8E/wCcuFr5f0Dx+tzU/wCRYzD1nIPSezo9U/cHy/mE9Q9m/wCcZEP+I9YmUhjHZqDH0JVpByIP+TTMnTcy6Ptw+iI/pPoP1C4WCEEKx3BO7Gu1aZlvOctyqtF6KHn8ccgHIjYqe3X/AD/2WK3an+8uZAiA8VHwR12AA/WcU7BV9ZESoI+wE9GhBrty5bbjavXlhQQoxrJITO4MqxkeoCSSRgXlsvkuOKEJJzYtyDAFeO1BTpRvGmNoAbhhmjpMwJoTyUV5gEfa+iuKkjktaUsBDCWYN9okDkxr/sv14prqV4jaBDzJCSAfvI9yp60PTrii7U2aS4YRxiqqDwTatAN/mcWWwVVljjXkhXjwChRs3LatT17cgf8ArnCxq1JecretLV40ZfUPgCcCfJUacxxlVdSzMSDHsAKAeA+14HFQLajjdCJ5N1qQx6sCR9qnz/4bFJPRzzvx9KNi/KvN996mvfG1A6uVGhUh24GQArIu9PFT/HFB3WyyvN8CVMaCoHeg7nFIFKqNHEPUXiF4ChDfGWqD4/DxNf2cKKtS5NNIsk28YYB2ApQE1PT6cDKq5KjTGGMheAZiaBCGFKAb15VDeDYsKtTjVg4nmHwMSCxFfiIqCR/w2KT3Bc9wyx+jGwYv9plBA6k0UbfqxtRHqtRPTUrJxRpFDI7DkOO9RsGpipNunneUemlTHHU13qfc4rEUqoqQgyBfgCArL1qxIOwO1R3X+XCg7qJYzzK0vwxlgrMOgBNTua4GXIbKxkNvGfgCOxIC9arQdTWtD+yRhY1ajGpaQSzD4XLfER8PMiorT3pgSfJVa4eOIQoQXbrxoQCWJoKYbRw9VOOPirBgFkYAx89gVNa0J2rgCSW7m5Zx6SmqLX4vHf8AVhKxjSpHGkJMnE0VQyytupJIpxFB8uuBBNqRka4mTmeCMQNug+/FlVBVDi2jLCMo7EgK+7ECnU/DSh+yRhYkW8J/L6JPNv8AzkL5w8w34EqeW/8Acdp8bbJHJV4RT+Wvo3H/ACNbCeTWPqPk91e5MMHpAAO1SQDULUnbvvT3+y3xYGdWUx8tKy/WAwIrwIrtseWSi1ZuiTyeZ/OC+bNX0Q6dawiTTZbvyp6spJuZrRhHMbhk2jjaS4tOKL+8SPm7fa4JJpQNt5g8/wA2raj5YhutLudXsIbG6uNVS2nSC3junkE0L2wnkZ7lY4vVgH1mPnHKvqKvH98qnf5febJfMmjTT3IRb2yup7O5CJJBy9JyI5TbTEz23rxcJlhn+NVf7TpxkZV8dfnD/wCTQ8zf8x8v681Wb6y992d/i8P6q78mv/JpeWf+Y5P1HDh+sMe0z/g8/wCq9k/MmBfJ/wDzkx5G8zWI9JPNgOlanGuwlfkluGb/AJH23/Ilc2jwb3XW9TvdOtUns9Ju9ZlaQIbWya1SRVIJ9Qm8ntYuApx+GTn8S/Bx5cVUl/xl5i/6kTXP+R2h/wDeTxV3+MvMX/Uia5/yO0P/ALyeKph5Y8zrry6iradd6Vd6VdiyvLO9NuZFkNvDdKQ1rNcwsjQ3MR2l/m+HFU6xV2KuxV2KuxV2KuxV2Kv/0PVOKuxV2KuxV2KvBP8AnLf/AI4Hl/8A5i5v+TYzC1nIPS+zf1z9wfMTDeo7/rzCBeokKev/APONJmbzLq0SMeDWQZlrRSVlWhNdtqnMnTcy6PtquCJ/pPo6BIYU9WRquQeFK07gio75mh5kknZRdnuCXYhUQAfET16fSzUwMxsrn0YLYU3eShIYdfY+3+f+qoFkqPBpWEkjbyNSgBLHfegGLK62CrcyrDwjgIJApUUNCa7gjvvhawL5qcNpUkz/ALtRtQkKa0rTfYbfzYKSZdzdxO87mKIEip6b1A6U2HwjtiVArcr7eGOJfVlaj0JRQQD3Hcdfl9lsIQTeyjK8lwxYCioO5A/E03OBmBSvxjt7YPXk0niCKjwrXoDvXCx5lDlHlf1XIUSNudu53ovU4GXLZEXDrbBYowCwBBqDsTUE9e/vhLGItSgs2c/vKxr7jckUNANuxrgATKSpc3LOxiiqTUgle46UFOop3/awkojHqW7aARj1pG4so5Ku1emx3/DEBZSvZSlkknJCA+moFRsBsOp7fLAyApVVEtoBLyq79CpoaeCn+P8AmxYHcoco0rmSgjR269AK+AwM7pEzMlqgiX4iQeQr1J2qw7+w/ZwsRvuh7a1aY+C7mvWtKVoO/XAAylKla7ut2jTrUhz7eHU/ThJYxi60tmUfWHPEICQKV6rsSK/9dYAEyl0U55ZJzxjUlFFSAD2FCcVApWjiFtF6rEF22qD0B8Kjr4/zLhQTZpDem0rlkThGzUB34rXtXAzukRL6dtH6VA5cHkK7E9N9ug/ZwtY33Q8Fu8xNPhRRVmNaUFO9D44KZE0r3lwoBiQLWpD0Gwpt3/a/4j+zhJRGK20t2H796BAGoGrvRa9PDELI9Fl1P6pCRiqL3p7b7nen+f2sVApVihNtEZZNi1V7MANuxPxd1YYoJtD8TI5EakIWPEE7CvvgbLpEyLHbQ+k4JLglhtu1KD3Xieh/awsBubQ0MMkzUHRRViewHzwMpGniXki4Xyn/AM5B+dvLl2Fjj8zkajp7N0dgXmovTcetcD/nk2SPJohtJ7jaQMT6zAemteu1SBXIhtkeid6JKjtOE3VAgB+/b5DJxaMg5LtQ0K1vdX0rVXd47rSXmaHgRR0uIjFJHJUE8K8JPh4/vIo8k1Ma0f8ALA6ZHf20fmPVJLHU5bm4vYP9Eikea6qWl+tQ28d36kZK+k3r/Csccf8AdLwxVOPLflL9DahqWpXGpXOq6jqggS4ublYEpHaqyxKqW8cMdf3jl348n5fyqq4q+Nfzh/8AJoeZv+Y+X9eanN9Ze/7NP+Dw/qu/Jo1/NPyz/wAxqfqOHD9YYdpf4vP+q9k/MmZfOH/OTHkXyzYn1V8pg6rqci7iJ+SXHFv+RFt/yOXNq8G+hcVdirsVYr5N/wCUi89/9tyH/uh6ZirKsVdirsVdirsVdirsVdir/9H1TirsVdirsVdirwX/AJy2/wCOBoH/ADFzf8mxmFreQem9mvrn7g+Y2ZRQEdcwQ9VMh7J/zjREV1/WrgBSiWaRuhr8QeUHb5cPHMnSncuk7dA4I1/O/Q+gR+/lVNlUCgFdgBvU1zMeZqgrTKkAHCnxKA8bfEG71/z/ANjhYjdTgQ3EpZyNqVHSp6BR/TEJJoNyyei5SIgqDyUEVKH2P+f/AAWKBu1bwPxEw2dWDRAg0bjUn9WIWR6KbzKU4RKUUklgTWvTboNtsKgKohMMXNhUMtJozsQC2xB+YxpF2pgmeRI1+BBsoJrTbcnFPLdVlRbdQBR1YAPG9ftDuKUxQDayGNrmZmagGxIFenSgxSTQXSSfV3CJxcKS0ZNeSV+VAf8AhlxQN1tvC9BMoBZGBRD+1x3NPlgCZHo1JMnApHyoxq5ale1B9HjhUBekRhj5tUq60kA2ZKnY/h/xrit2sLNPIkMY+EbIDSvufpxXkqSRiBKN8cbgclJCsGFdx+ONIBtbGr3UpJ2RdyB2Wvvim6XOwgYIVDlCTE1aEV7Mv8P+NcCjdZDG5InI58GBZSd2A3NK9ad8Uk9HTTgpwV2kLHkzv17AdzhQA3ErQqJSSFdac0+0hJqNven/AAOKCbWuxmdIo9wBxUnqfHx7/s4pGy9oxBHxerxycSSpoVYA/Oo3xRdtD1LmWn2UU7L14gmmwwc08lzsISquvNo6+mwNAQT+0N++KjdZGsjn6xIDIisPUruafTik9zclwVQKknN+RbmAVpsAKdKHb4sLEB0SNEBI/wAIkWiSUrxavcfIYpJt0kjyERRkkcQpIr8VB39h2xUDq36ZgjZZOQSTifUTehofhINPHxxY3a0+pcycVFIwaKKdATQdMU8l5YQhUkDVSpSn2Hr0b+3FeamnKR/XlHKMMBIR2+gYpJrYL3uGjjCq6lySax7AAgDsB9qmLEC3mf5xflhfeaLGz1zRJvqfm7Rz9Y0e6qFEvFuRhZzsp5DlGz/Cr/b+CV3wgsZi+XMKf5afnfZ+ZuPl7X1/QvnG1pb3dhP+6WeRBxJi5U+LxhPxr/xYnx4kIhIdeb09PM/lvy1tr2qW2m/WwDbG4lWPn6f2+PKlSnNeX8vLBxCPNs8GeT6AZUv/AOVtflj/ANTRpv8A0kx/1x8WPej8jn/mS+TX/K2/yx/6mjTf+kmP+uPix71/I5/5kvk7/lbf5Y/9TRpv/STH/XHxY96/kc/8yXyfHX5oahZaj+YfmG9sZ0ubO5vZHt7iIhkdSdmVh1BzXZSDIvZaCMo4Yg7ERY95c8z6novmnTbjQrb69r0cwGn2iqZKzsCsYKru3xkfB+1luDESb6Ov7W10I4zjB4py/wBj/WfX35EflNfeTrC917zLN9d87+Ym9fV7liHMQY8/QDjYnkeczL8LP8K/BGjZsHknquKuxV2KsV8m/wDKRee/+25D/wB0PTMVZVirsVdirsVdirsVdirsVf/S9U4q7FXYq7FXYq8F/wCctj/zr+gf8xc3/JsZhazkHpfZs1Kf9UPl5jU1zCenJtmf5ZfmAvk3Uru9axN99Yg9H0xL6XH4w3KvGSvSmTx5OA24ur0n5iIjfDwniepQf85O6fFGwHl2T1CoIb6yv2u4/utlGXjVjudZL2ekT9f+x/48hT/zkvG7gyeX2ptUi7Gw9h6Iwfm/Jn/ofP8AP/2P/HkTL/zlDZpb8bfy7IrhiN7pfs1qDX0j8WS/N+TTL2fIO8/9j/x5DR/85MWQXk/l2RpOVeP1sceO3U+jXxx/M+SnsM/z/wDY/wDHlW6/5yggkoIvLrooBU/6WBUV2G0PT/jbE6ryRHsEj+P/AGP/AB5Yv/OTdjCVf/Dckh4nlyu1pypUUHo9K/D/AMNhGqHcifYcv5/+x/48pz/85QRTTNx8uuELVAN4PvP7n7WJ1PkiPYh/nf7H/jyIg/5ydsIov+UccykGrG6UjcHpWHxp/wANg/NDuZHsGR/j/wBj/wAeQ0n/ADk2jtyby8x6Da7GwGwp+5x/NeSf5Dr+P/Y/8eRJ/wCco7JIgsHlxwwIPJ7lOxO9fRPbj/w2H815MP5CPWf+x/48ho/+cmrMktN5ekJ5A8RdAgjvU+kMH5nySexD0l/sf2q9x/zlHauqrb+XpFUAqwN2BtU0G0R7f8S44TqvJEewz1n/ALH9rUH/ADkzpyFWfy9K7cSSv1oABgdqER1O3+bYPzQ7mR7Dkf4/9i1df85PxSyNw8vyejyqoa7A+kgQkA/LE6ryZR7BI/j/ANj/AMeXQ/8AOTmnRQ8j5ckec1BrdDiAQR19Pf3+HCNUO5hPsKX8/b+r+1Qf/nJ1JXq3l1uwAF3sABT/AHzj+a8lHYn9L/Y/8eRZ/wCcn9PiQC38uSFwQ3N7oD4gdjtGcH5sdzL+QJHnP/Y/tQ6f85LQFg0nl5+NfipditP+ROD815Nn8gn+f/sf+PIif/nKC3oqweXpFRVp8V0oP0fuT9/7WP5vyYj2fPMz/wBj/wAeQ9v/AM5M2QkrP5dcqOgW7U9/eHCNV5MZdhnpP/Y/8ebuv+coo5Hbj5ef0ya0N2Knv/vk/wDA1+HD+a8mA7Dr+P8A2P8Ax5u1/wCcnrGMMz+XJPUo3Ei7FNxQf7qHvj+Z8ll2If5/+x/aoz/85QJM/JvLreAH1wf9UfvwfmfJI7Er+L/Y/wDHkTD/AM5RWMcNI/LkhlBBat2KGg9ovEsKU+zh/NV0QOwzI/X/ALH9qgv/ADkxC8oMnl96E/GRdgmntWHI/mvJu/kI9J/7H/jyKl/5yetQirB5ecUBHxXS7AgCoIi6ncN/nxfzfkgezx6z/wBj/wAeQ8X/ADktZLIGn8vScNvsXSk9feEdsI1XkifYRHKf+x/48um/5yhimYqnl1gjULD60oNR22h3Va/DhOq8mEewj/P/ANj/AMeX2/8AzkzZxVdvL0vqivHjdqAOgrX0a1+1kfzfk3S7AJ/j/wBj/wAeUrr/AJycjd+f+HW49APrY2/5I4Rqr6MD2CY/x/7H/jy+L/nKKyhj+Dy5Kzmhet4oBAHT+5Pw1J2/1cl+Z8mo9iE/x/7H/jyFP/OT0LycpPLz0Y/GwuwTTv1hGD8x5J/kX+l/sf8AjyJk/wCcpbRUCW/lxioDKS90Ad9q7RH7S9a/ZbD+Z8mH8inrP/Y/tUIP+cm7PnWby9IEAJHG6DVI6A/ul2x/MeTI9jHpL/Y/tVLn/nKWB+SR+W2EZINTdAHYbCghK/D02wHU+SB2If5/+x/48wrzz5+/L7zxAZdY8sz2urRgLb6pZ3KCdQOnMmICRV/kdf8AUePlywjVV0RPsIy/i+x5zrfmLzte29pZ3mpy6zp+m+oLAXZBlRJOIILEl+kcY4mR+HH4MZZIT5+lGLR6rSknHw5IlJzrMqH/AEi0kQ+I6fiBkfy4PIhu/lacf7zHOLZ8wWh/3XJXuKL/AFx/LS7wj+XMX82f+x/4pr9MSybW9pI58T/YDh8ADmV/lWcv7vHOS4w63d7SOtrEeqr9qn0Gv/DYOLHHl6iy8HW59pEYIf0fq/H+dFn35HabbWn5o+WTGOUhvUDSNue/3YwymUxadR2fjwaefCLlw/XL6n3pme8k7FXYq7FWK+Tf+Ui89/8Abch/7oemYqyrFXYq7FXYq7FXYq7FXYq//9P1TirsVdirsVdirwL/AJy6r/h/y+B3u5q/8ixmHrOQei9nvrn7g+YaHwzBeqptaqQaYEiwr1UDr1yNOQJAsmvvK9mmu6japcm30/TbWK7uJnHqyBJFhWiqvHmxmuFUfZ+H7TfDlhx7uJHVHgBO8py4f91/vYJg35YvHK8Vxq9tG8UEl5NUcVFsl19TVw8zRJyklKcUZkbj/l/A0/B83GPaII2iefD/AJ3D4n8PE0n5ZIsiQXGtW6XEjhAIkeWMq19Lp8bLIuzB54ef/GBuf2/3eHwvP8fS1nX9RE/iAy/7mX+mSjy/5WTVbXUHluFtvqEoE0x5OAiWt3dSUjUfGxWzovxr8X+tySMYW3ZtTwEVvxf8VCH/AE8TaD8r7m59NIdRhke4mtUiRVJYQXpg9KaRK+pGON2jf3fp/A8frerxRpDEWuWvjRsdJf6bHxen/Yf8dQWhfl69/Y213NqUVoL1YvqyvHI5LTSXiIG4/ZX/AHHSMzfF9uP4WxGO/wAfj+aierEJEVxcP+98P/qqgz5WT9NmwF6ptVshqTXnBq/VzbC6/uq19TgeHDlx5/t8PjyPBvTf+Z9F1vxcHD/S4uBPrv8ALiyXVIYLfUA0VzEs9tEytylhit4p7ly9AsRpI5hRl5fBxfj8HOZxbuNHXExJI/HFKMP+PIeX8tOd9PaxalHE0FJ7hHSRvStZA7RPzUUkfgi+oij9v4eXGTgPD35r+d9IPDz/AN2kuh+Uf0xFqclreKPqP+88TJ+9uAVkcFI68+kXxiP1XT1E+DhzdRGNt2XOYVY+r/YorzL5QttNutMtrOWSS7vppoZYSpdUKT+lHwKLzk5e0fL+VcMoU1YM5kCSNo/qTcflU/1i2jOrwLHeyW8FtKULVnup5rdEcRtJwAktyX+LkiN/d+p+6x8LzUdobE8J9N/6WEYz/wB+h4vy1eax+vxatbC0mQNYvMRA0rek0jKVkYFaceHw+p8TJ+zyZR4W122HXVLh4Tf8X8SReZdHtdO1+fTLKV7iGMxqkkoCMS6KTXt9psrkKNBysMzPHchSdL+XcS3M0J1eMLBex6TLJ6E1BfSu6Kg2+KH907GUfGq8eUPNlXLTj83CjrKF8P8AD4nOP93/AMV+OJcn5c1dI5NWt45U+rfXVccFiN5ZSXsKiSRkidmSB0+J409Ro/j+L4R4Xmy/Pju/ncP+ZMY5f7pEp+VWosY4f0hax3lzMI7S1mYRPJGboWgfgx9UVkJcD0mX00ZvU+yrPglf5SiOhoD/AHviKWn+QdO1Ow9Wy1XmzSFhNLEYIhbxQTzSsfVKgvW3ITjJ6X+/JEb1PSY4weqcutlE0Y/771cUY/79Q1jyFDYaJPex6glzc2rTPKIuLwvAq2Jj4OhYep/uRX1fiZfh4fsfGnHQ/H9H/ikQ1hlKqoGv9N+8/wCqKW+ZPJ76Fc29nJeLcX9xNcRfV4432WC7ms+XKhqXlt3Koq8uPHGUKXDqPEBNenb/AGUY5P8Afp6v5Wx299Zm+1RP0ZPPFbyyxIWl9WScw+nwUvw+yz8n+NP24fU/d5PwvNxzrrBoeqv97xfj/dIO8/L5BGrxXiwyTI5tLd1eQyNDai7flIAqx1Q8V+18f+RykUeGyGr8vxxcCrc/lfMt1cG3vovTgu7qK4iFZTbwWssyM0hUc+XG3LJyhjSXnH6b+pyjQnEwhrqokdI/53Fw/wDFLrXyFYz6dHfLqax2jMf9KaKXk6u1skY9EqpUq118beo6Nxb02f4PUh4bljWkGq394/p/xf8AJNB6x5Kk0rTrmee9je7s/QNzaIj0C3LMIysp+Ftkqw/Z5ftfHwjLHQbsWsE5AAbSv1f1Ufb/AJdIlpHc3l/BJ6llJdvZwyJ6yGTTJtQtjxqz8aRJ63KNPtfBz+3khi/H+bxNE9dZIA/i4eL/AJKxxT/3XpSvzr5ZsPL19b29vM0kkouTOj0IQwX1xagI1FLLxt+pX7XxftcFjljTZocxyAk/0f8AZQjP/fphp/5dT31laXkeowCCaIzXb1XjABC8wRmLhVlKxkBJ/Q5faTnDylUjFaz14iSK939Lfh/0v9Xj/wBN6V9x5BtLK1v2vdRjnljtJrqwS1+NJEiMYDtKOSD+8/u/8lvj+xzfDpB1nHQAr1CMuL+HmhNA8gR6ppwLXqpqV7bRXOnW/FuASTVItO9SWQBujGb92q8vsN/xXk4wsfjvcXPquCVV6Ynhl/yrOX/iUsj8nPc6xpFhZXsctvrURntbuVTCFjSWWKQyK1ePBreXozcl44ODcebM6ioyJH0fs/4pHal+X7Wel3F5HewXSQIZxNFIrhouMfwFYzIiyK0nxfvXX4cJx0GuGquQFUiv+VVXfMw/pKEypcvb3PFWYQrHK8PqShSZEBaOq8o/TbmqpK0vKJT4aPzo50eSi35cxmCS5h1aOS1t4obm8cwyK8cFzayXcRCb85GjhdWQNxR+H7zhydB4fmy/NG6Mdz6R/my4P98vf8vYLG1up76+EjtYSX+mxQo49WERxSRu7MP3ZKzL+6b4vhb4l+D1HgpRqjIgAfxcEvt/4lbpX5fW+qaTY3sepJaerC8t81zwREY3Rt4VjLMnLlQu9W+Hj8PNuKYxx2Fy6sxkRV/zf9LxLo/yyr6UUmsQLeSy29usKRySJ614ZVgUSD4SrG3fm/7KcGXn9lT4fmxOt68Jrf8A2FcX+6UP+Vecbaa6Opxm3sYYZtVIik5RC5txcRLGpp67EHg32FR/+K/3mPho/N71W8vp/wA2XD/moLzH5Q/QFrA818k9xdOxhhjRxWACqylmpx5VX93Tl/N9nITjTk6bN4hNDkkFDkHLpmf5NA/8rS8tf8xsf8ctw/WHA7TH+Dz/AKr7ozaPBuxV2KuxVivk3/lIvPf/AG3If+6HpmKsqxV2KuxV2KuxV2KuxV2Kv//U9U4q7FXYq7FXYq8E/wCctx/uA8v/APMVN/ybGYes5B6T2c+ufuD5izAesRWnWEt9cNBH9pYppjQV+GCF5m8P2UOEC2GSfCL93+yPCm0vkPzVFOYJbREdfU9R2uLcRxmJkSRJZPU9OJ1eaFfTkZH/AHsfw/vEyRxlxxq8ZF39kvx/DJO0svzJmflJqt1DFp9nNcLJPcFCogsTcvDEjPzkIhCo4jVuCunqcUywCXe4sp4ByiPVLu/nT4OL/TLIfLX5gre313HfTreWTPbwO1wFuLgy6gLV1VDJ6oSS6lkZnf8AdNKsvx+pjwy/HvXxsJABAqXl6Y/u+P8A3H+cltvpXn2+tl1GCSd04rLFM1yqs/72W4URh3DySetHcTqicpOayScciBIt2WWGJrb/AEv9WH+54IrYF82eVtWvYrO4V7iK1+s3T28weNVubYxCXkjCssaXjqjfss/8uHeJYfu8sQSOvD/pZf8AVtH/AKP8+pf6Tpt5rE0Emv3xQx/Wmdo7hLpYGeZUYsrCZEev7Xpqy/FH8JqWwvmwEsJEpCP93H+b/Dw8XpW22l/mDrDx3M2oy/FE1xFPLeIePoW01zEsn7ytvyhedoTN6S8JJW+xzwASKcksMNgP9j/OlGH+f6uHi4Uvi8u+fILpb6JJo7y1AghlWdBMY0RI/wByA/OWBYpEX1IucPpN9rhjwySc2IijyPl+PV/skTqMH5lWtvfS3t7cmFX9S+AvUlLFDHGXKpKzSKjiGKSRQyxyRrFJ+8i4qTxMcZwSIoD+j6f2K2kad+YOrQ2Vut9LHZ3LloDPdhEQS+qPUeMvzjjkrOqSOio7O6o37zABIthyYYE2Nx/R93/HUJ5X0zzXPbX7aXdvZWPpXLXTrOIlmNpbSTuioHVp2EXJT6av6aS/HxjfIwB6NupyYwRxDiltW38+XD/m/wDHUW3lnz7c8/rMk7XFiTcWkPretJ9ae6traSJeDt6N0slzA8qPwlT9tfs5Lhk1HUYRyr1enl/Bwzn/AJ0PRJtrD8zrt0kkubi49GW3e2mF7G6GRnkMBt3EpSQrIs7D0S3pcJ2bjwkxImUQyYI7UN7/AIf9Nxbf1fq/ooW0g88Q3Z0S2upkee2L+lHdIIHtY4nkZhKJPQMKxGarepw4+qv8+Q9XJyScJHGQOf8AN9XH/V+ri4uH/Yq2r6D55lSC01SjpE0rxyT3VuVRljgjYPM0nFP3YtfTEjryRovS+2uJhLqxhnwizH/cy/pfw1/wxXSw/NuWcyJcX31xW+qlDeBZ/wDer6sB6ZkEvH63+7EnHh63L4+S5YBNxJy09co19X0+n6ePu/mf7FA22lfmBbTyG3nkSVI4ZQ8V7ERKkVvJHD6LLLxuOFsJolSH1GWP1IuP7OCpMjPCRuP9j/S93p9XD9SzTpPPWqWM8sOoXMlk0rTXAa7ozyRlJZJBE0gll9M+nLI0aNw4o7fZwDiIZmOKMgCBf9VOb3TPzJjv5/Q1G6uJImJa4Nz6XNoDOn7sSSK0pWNJ24p8SxvJy+1iRO+awyacxFiI/wA3+dw/8dS6E/mKtxKyXt1A4nl9eaS8WFBMI4xIXkkkVFJjMK8mb4v3afy4jiZz8A9By/m/s/rJfHZ+YNT822mjahcypqz3y2Hq3Ds7QzzXJ5kmpO08skj8T9tnbAATKimU4QxGUR6eHi/2P/EpxpUnn3UNIl8wweYZ0a1F5y9S6eOQJa/V5ZOBZhyZ3uI3VF+LmnP7fHLBxEXbiS8KMuAxG/D/AA/zuL/iUNZN+YuoaFDZWTzyWV/KAipOBNMJ2SxUMhkDm29UC2WQp6PqO8XqfFxwDiIZT8GM7POPl/yU/wBN/ErJp35lOlBf3JaOYXaEXqGGrCa4a4FwJfR+Fo53d/U+F/V5fHzw1JjxYe4fzfp/qx4eGuL+ag9ah8/Wcsdvq1xcNLdzNFGn1lZ+U0RiJQ+m7hXSlswRv2PRb7Hp5CQl1cjBLCfpA28v63/H/wDZMgjsfP8ArdnZeVJlhjsrqe3L35uhLG7SzzIh5G4kt2k9X6wWjtkW4kaKTkrsr5KpHZpM8OMnILsA+nh/ox/o8f8AN+v0pBpFv571fTVWxup5dPtPUhjje7SJFHoP6iIssiVC2zS8+P2IPV/3XzyMRIhvyywwluBxS/o+f/F/7JGy6F+YN9ayWc8j3PqSOZ0uLiL0wWlSQMk0snpt681wrqY2/evJ+16mExkWuOXDE3y+Hl/N/oxivttH/Mj6taCzurkQW0fOBHultxF+5ZnVFkkT+7gaTnT7EPq8uMfqYKmzOTBZsCz/AEeLr7v53+yS+eXz5z1PTZLq7lIIk1O3E5kWT13jjV24syyrK7wfEvNX/df5GD1bhtrDUZAR/obfzb/0vD6laHRvzJgs00+1luIrYycvqkd2iqrIWnWR0En7peVu00UrhUf0/UjZskBLk4+SeAniNX/V/wA3u/pcKjd6J55lvrfUbm6kOqRuwiu5buNRGsKW80ciXbSiLiwvYGiKSf7sThy54eGTWMmIAgD0/wBX+t/BX+1yRltov5rS3C3aT3KXLOY153scc3Lm1nx4PKrjlJC1qnw8XdPRT4uK4akx8TBy2r+r/n93+elNhrXnPVLg2MGpXc0rtLcOr3DItRyllkkeRlRQPjlkd24/bdshci5Xh4oCyB8kbFpnn2xvo4VkubecgENHOD8FtAFBBR6MsVtc8V3/ALqXgv7WNSCTPDIXsfh/Pl/xcFutt550u0uRfX9yLO+lcXCNc8mlZyRylhDtIBL6PWRf3np/tcMTxDmiBwyI4QOKP9H/AHMv6PErW2kfmTpYigtriaySETEFL2KOKEBoTMJHEojgb1JLVuMrI3N4P2vTyVSDTLJgnuRxf5v9by9X8f8Aslln5a8/y31rDJO9jK837prm6SJklsjMFdlZ/UT0njuI4pGXj6nNFf4sIjJjPNio7cXuj/P4f+Oquot+Zj3WnzSzTROsMUdhDb3SkRo1qAo4LI3pGW1i5sr8ecf+Qy4niYwGGiP9Nt/S/wCLS/XtH8yw6Zb6nrdw0sk9xLGkUswmlVyqTyGSjOY3b1QzxycZf51yE4mrLlabLAyMYjp/x1IMrc1mf5N/+TR8tf8AMan6jluH6w4HaZ/wef8AVfc2bV4B2KuxV2KsV8m/8pF57/7bkP8A3Q9MxVlWKuxV2KuxV2KuxV2KuxV//9X1TirsVdirsVdirwP/AJy4NNA8v+P1ub/k2Mw9ZyD0fs79c/6ofMXvmC9XaJ07UrjT7oz24UyNDPAQwJHG5heB+hG/CRuP+VhBpqyREhR8v9ieJPP8fatI14l1a2t1b391dXl3ayrKEaW8kglcfBIjqqSWkJj4v/Or81fJnIWgaSO1GQ4RGP8ApOL/AKqSXS+f9XeF4ZbOzk/czQ2zek6fV1ubRbKYxLG6RjnAiD40dE4K0aJj4hR+TiDzlz/03DLxI/7JMoPPnmmaWfUY7G0kvVkM0t1xf1UjS9GpmPh6vH0VuP2mj5cP3fq/Zx8Q8/x/OY/k8YAiTKv+OeD3fVwIWDzX5gvPq0VhYWsFvpzQSRRIHWKMBnhjLvNKx4M92eTPJ/L8WATJZy08I3xEkyv/AIr+Ef7WlX+KbsalJfSWdvMLq0SyubdxMIpo40RAW4SLIH/dI37uRPi/Z4/DjxpOnFcNnY8SIvPO+q3Or2OqywW6X2n3j30TIrhS7z/WPTZedPTSXlxpxf4m+Nvh4pyEm1hpIiBjZqUeH/Y8Kc3fnTzbY6TZW17plsdPeNYoY5PWZJEGnrHTgs9IudpfRyv6Cw/vJPU+3zyfHID8dzQNNilIkE8Xw/1T+r/PxcPq4krb8xdc5pMtpa+tCphspwknK3t+CIbeP95w9P04+H71ZJeDP+8+LB4hU6OI2s/8VL+coy+fPMEuhS6K/E205lowaYFVmm9eRFQSCBh6nL4nieReTfvMByGqbI6SAlxdfh/V/rI2y8+ea4NEsFWKOaw06WKBHdpir+nykSF4hKI6UP244o5eKr+9w+IaYS0uMzP86Xu/03JB2PmDVtI0lE+owPa3YvH0+aUSFofrcRs7kxcZF+0iBP36ycfTV0yIkQG+WKM5czceHi/pcH7yH4ijofzH8yPfkWdvZwXF5MZbiisqy3M9zb3EkshlkKJ6klpCrD93bpH6nFI+fLJDIWiWjhW5kREf7GMZR/38v6SEi8/61BJYGzgt7KDTpIpbK3iWXggiMx4hnkeVlka6nZ+UnP4/gdOK4PELP8nE3ZMuL6v9j/xEVt55p1u71F9YdY/Ue2l04Rl5JSsc8Dwv/fSSTseErtzd2+P/AIDImRu26GCAjw+fH/pZcX8I4ERF+YPmCxf1fStm+tLJIpDSK6+p6MTFXglSWJv9CQfbRmRpOXKKbJCZDRPSwltv6f8Aj384f7YnFx+ZN1FZrqsunj/EOosZort0IhMa6o18fTpJ8UX1hDH6Zj5/a/0hlVIkn4nXr+1xvyYvhB9Ef4f+Sfh/7n/pBLNI86+atJ0SF7e2t/qKxtbxTOzo7LGzB0KpNH61Dd/YkSRV/vFVfjbAJkBnk02Octyb/H9H0/QgdE88axoujzaRbRQ+jN64lZ/VDH6xGI3DKkiRvwC/uzLG7Rty45AZCBTlT0cZyEjd7d38PwTRfzD1OPUW/S9lbXUcLylRHyJilmEvJ4nSTgSfW/b9ROKJ+0vLD4hvdrOjjw+kkfiPl/RUY/zL1mHi0dlaRs4dpZU+sRySSSLEjy+okyyRyEW6D9w0Kf3i8OEjrj4pZfkYHrL/AGPn/R/pfxcSR6h5o1C78wjzAscVvqi3bX7Twq1DO0vrBirM6/C/2ceI3fVIwxEeDnGuD/NRc3na8MDWlvp1nZ2MkdyrWcKz+mz3gjEktZJXk5/uIeCh/RX0/wC64s/I8bWNMLsmRO2+38Hw/pSVtO/MXzHpumWOnQBGg02SN7cuZiAIrr64sbRiRYD+/Fefpevx/d+rw+HCMhAphPRwlIk/xe7+bwf1vp/zUNF5y1mHR10tUi+qrAbbkUblwcT9+VK0upf+FyPGaps/LRMuLrfF/uf+IU7vzZq1zdW1xNFCXtr+TUY0MZKNNKIQysrEho6W0fwf62AzLKOniAQOseD/AHX/ABbIoPzI80395FKNPtbz9HBLuGKY3Mojaxea4SYvJOZXaL17j4JJHTg3H0/gTjPxCWk6PHEczHi9P8P+U4YcP0/xcMWL2HmLUdPtfqcCoYz9Z+0pLH65ataSdCP91P8AB/lZAGnJyYhI2fL/AGEuNHy+fdde3igaOERwGAKeDVrbiEJX4v8Al2j5f7PJcZahpY3fv/2XF/xarc+e9cuVQPHCAkVxGKI32bu2Nq9fi/32/wAH+VkTMtsNLAd/T/YS40PZecNasteTWrYRi8WFYFUoWjKxxLCjcSd2T00kU/7+RXwCZBtlPTQlDgP03+ni/H9FFH8yPMP6Lg08mNo4IfqwdmmblF6EluqmMyegvGOX7UcSO3FPU55LxDVNMtHCye/3fzuPu4lSy8/eZ7SzE0VrC1raCO09ak0bI0lvbQxj1IpY5Fd4tJT7LfH+/wCfwPwyQyH8fj+i0T0kCavc+r/ZS/6rf7lDzfmJr0upDUGS39cTJcUCNx5peyX425/Z9eZx1/u/+CwHIbbo6KAjW/4h4f8AuUtttf8AqepLe2lnEoNu1vdW8hd45hLEY5i9GV19Tkx/dunD9jIiW7bLDcaJ63/V/mp/e/mTdNKxstPtY4/SWOAusheENbQW8yR0k48G+rLw9RZJF/n+1kjkaYaMVuT/AMV6pSj0/ppXrnnjVdY0pdLuYoVt1uPrXJPVr6nx/ZV5HiiB9Vufoxx+rxRpvUZcBmSKTDTRjLiHdw/j/jy8efNUf62lzbWt1bX0s813ayLIEc3DQOwrHIkihXs4HTg6t9rlyRuOHjKPysdqJBjX+x4v+Lkin/NHzCVCSQW0oa5e7kDCbi7SO7MvprKsUdfVZC8EcU3p8U9XD4pavyMB38uH8bf7r0oW18/6pbyzSfVLSZ5DC0RkWU+i8FsbVWj4yLuYTRvU9ReXx/Dg8QszpYkcz+JcaE1vzZe6xbRwz21vCwma6nnhWQSTzyIqPJJyd1qwjHwxrGnLl8OCUrbMWAQNgn/iUq67jvlbnA2GY/k2a/mn5ZHYXqfqOW4frDre0z+4n/VfdGbV4N2KuxV2KsV8m/8AKRee/wDtuQ/90PTMVZVirsVdirsVdirsVdirsVf/1vVOKuxV2KuxV2KvAv8AnLmn6A8v/wDMXN/ybGYer5B6L2d+uf8AVD5jqAPn0+eYL1R2TXylr0Gh6/banNA00cKzIVU0ZTNC8QkQjj8cRf1U+JPjT7afaycJUbcbUQOSBiPxuzE/mnpoN0Gsp7kXEtvKWmZAf9FWAFKfG3C99DjeVkd2Rbf45vSf1p+KHFGhltuBV/7Pi/6Z8X7v/P8A81W6/NqJriOS3iuZVW5s5p/Vk4meG3mnmkt5DylZo39dV+N5Eb4v3aL+7xOZY9nmt65S/wA2Uoxjx/w/zUHH+YtlHby2rTandrNFNDPe3EqevIsqEBTQn4AeK8Wkk+H4/wCWJR4nvZnSEm6hHl6f4U1f839K+vwTJDfejFIHYGQlmVL63vI42MksrMqrDLH8Un+7OaovNo8n4waP5PlRHp/EJY/5v9JKofzLggsUS3W7S4W3WGBfUVY7OSPTZrDlakbr68k63Ev93xaNf71/3mR8X8fBuOiJO/DV/wDKz95HL6/6vDwRUtO8/wCkrrT6hqFvcupvNK1KsbI0klxpkTI4kLnpcPI7tJ8T/wCT8WAZBdny/wBimellwcMSPpyQ/wA3L/xCI0v8zdLtEtuVtdJNbQokcsUhU8ktdOgOyPESGOnSfaZlX1EZopePHJDIB+P6v/EteTRyle43/wCKyy/6eq6/m6I76JrZbuHT4rm3mFosoVDHFeT3EqcVPD97FOsTfzcfi+DD4rH+T7G9cVH1f5kYf71BQ/mDZC2EPq6lbNJZw2aGCRONi0McSNJZrVTyufRPrfHB+7mkT9637zI+I2nRm79J9XF/wz6v7z+pxf0vpasPzB0uLUtSupLWeIXt3LdQvC55xmSJo6t6b27SMef7zjJErcv5f3bIyC0z0cjECx6Rw/j6k0uPzY0t7r60tpdTReu0zaVO6G0lL3iXZeTrWQenw/u/iZlf9ni58UNI7PkBVjl9f8f0cCDh/NFLVrFIZb+4+r3lhcXl7cSgXF1BaT3M7wykM1V/0mNUVndf3XL4fhRB4rM9n3d8IuMvT/DCUxCPF/sFF/zAsTJ5an9K5efQ3jZmZwAFjhjiCRqG9LrFX1FigbjxWX1W/eZE5Rt5N0dBKpix+8/Wfx/EiNM/MyOKO2a6+tPdpGsdxe8hJJIVjaOrEtHK3wlUqk8Mv/Fv7LEZmOTs4m64a/m/j/iZJXeecdFvby5Eltc29hdWM9iwV1mmjEmpPqCEFyvqUqkTF25fafE5Afx5rHSyiBuOISEv+lfhIy//ADG02+8yWeqyRXiQ2rap6cIkJMYv555onUxvCxZPrHCVFkh5rEv7zJHKLv3tUdFIQMfTvwf9KxGP9L+ajJfzW0pr9rlbGch2Vql1Dh6WnKQN8X70NavIjn/djI382HxQwGgkBVj8cf8AxbWoeffL5W1Dy3uoSW9ovpXDlPUeZ7SS2ZZ+RPHhzR/gaX/ffL/dmRMw2Q009/pjcv8AfCfpUvNH5g6VqGhtDA9y8l9BPG+nMw+rwtJfm4WVx+1MEQceI/bX4/gZHMpghGDSyjOzXpI9X8X0cH+lRH/K2dOE1lcLYSSi1RgNOlKm2PKFIPQ+IyVt/h9WipF8ccH7v4PWx8UMfyEqIv6v4v4ufFxf1v4f9N/VSvTfPlhZaTq9g0dzO19cXswuJGBkuFvIRCq3R5cC0RHq8jHN8Uknp+i373AMgALdPRSlKJsekR/zeA/wfiKL1j8xtJvNT0q6gt7pU0+W+YPJIWmjS8iSOL0nd5m9S0ZWljbkier8SJD9lU5QSGGPQSEZAkerh/2H87+v+OJbF+Y9hDCqFtQufTV42jnkQpds8cSC4uaf7uhMXKEfvfswfvv3TPIRlRLQm/4R/vOfpj/R/wCPelUt/wA3ZvrsU94bu5jhKyJG8vICZNUF8sgDGnJbcfV1P7P2f7vHxvx8WJ7PFUOEf9Y/D/3XqUbb80na3SHUGvLh1igjS5MvOSGSO0u7V7iIuf72t1FIpqrN6P20+B1fFZnQb7cPX/dQnw/7D/ZIgfmdYGOYeleH908LQs6mO+Z7SG29a9Fd5OVv6rf3n979v4GeZ8UI/IS/o/8AVP1Snw4/9N+P4QN5+YFlNrNpef6bMIRqH+mzupu4f0hGURYSDTjZsfVh+JOUjScfQ5fCDk3Zx0ZESPT/AAen+D93/O/4Z/F/vkbZfmfp1rLbSMuoXK2zRiSCaSNkuWS6juTeTUp/pVI/TX4X+zD+/wD3beoRlDXLQSN/SL/2Pp4PDj/Q/wCPelbpv5mxmyki1EXlzLJafVrh/VPKZhNeSKGlDJMtI7xIx8ckf7vhJbyr6fpjxe9s/k8k3HhAvi/q7Q/zf8n/AMfV7/8ANDT7pPTjiu7L1IXjS4t2AlsuRgPG1JevClt6TcWt19GTj6fw/GnMCsezpR6xl/W/yn1fX/p+L+P1L9U/MLyyfMN9e+jdXVJ5YIXiZY0ktv06dWWYP8MiyMp9PjxTj9rl/KTkF/j+dxNUNFk4ALA2H+m8HwOFLfMnn3TNa0uTTn+upG4syz1r6j2huwSyvJI3xJdQ8eUkrL6HHk3wtglkBFM8Wjljlxen+L/Z8H/ES/0zz/kvgfv/ALMrc/idyHgfvxRxLlbalPlvitrajw/HFDdR4fjils7ChBB6r9OKCsqvgfvxQ3UeH44ra5XABFOvTGmQlTMvyZYf8rT8s7f8fsf8csw/WHB7Sl/g8/c+6s2jwzsVdirsVYr5N/5SLz3/ANtyH/uh6ZirKsVdirsVdirsVdirsVdir//X9U4q7FXYq7FXYq8D/wCcuB/uA8v/APMXN/ybGYes5B6P2d+uf9UPl9tz7ZhPTlxHf7/nihwwMrerTeZNCublota1tNR0O6/RsVrprG4kFqYmg9eYqU4wqkKTwsIm9R/V+FWy/iHU7bOrjhkB6I8Mxx3P0+v6uGP9L1cEvV/NQOnN5Etba2srm4truQLG1z+8nWA3Hpzgv8SNGzpyiHxp6bf78X7eAcLLJ4pJIBj/AKX6fShfLUX5fDWNYGpT2smnG9EdkXjuI62jGUGSKrSugH7n4H9Sf7H75FWZmYiNm055ZuGPDfFw+r6fr9P4/m/0Vexm8k2UUssNxaNLe2jRRoyzM0RfTSsgfkvFXa8qo+1/yL4tiOEfjyWXiy2Il6Zf9PP+qa3WrryBB5q0G40f07fT4dQL3U8Es5YWayxGFnqiOkoUSluLNN/P9lORPDYpEBmOOQl9XD5fXvxfj6VKF/IF4yK31OzjsvqpYkXAa4Q2Tev/AD8pPrhFfscfh4/u1bH0lBOUfzpcXF/N9Pr9P/StEi8/LSW11EG1tUkiVorejzxloxbVSSP4ZeUzXRbn9j/dK/3Hq4+lFZgRufs/nf7ng/338SzynfeSodA9LUXtlS7hgg1dWFx9ceQavBM4QoOP1f6hEG+H4vUWTj+844ImIG/49TPNHLKdxv0k8H08H91KP+m8VFQ3nkpdLksZpLEX0xhnljiFx9QN3FFqKxMduXBVlsw9P3fqt8fwethuNV+P4mJhl4r9XDv/ADfE4P3X/Vz8cKTa7e+UI5dNi0mK3Ui7SXUbuH1wV4Rwc1hLmq2/rm5aLb1OHD/JyJMejZjjlNmV/T6fp/pfV/S4eBvzNeeULmwu0sIoRdo1vJDdL6xmld3m+sc2ckH4fR7fs/8AGTkMhjWzZpY5RIcXLfu/o8H++TWa6/Leaz1YJa2scqPcx2lHnjJhWAfVJI/hl5StcGQyfY/3Vz/c88Nw3YiOoBjvL+Hi+n6uL95/sPxxIrzInkPS77WLZraya8tpbu3tYIBcFUiF5bRxcuZAN0kP1/vw+z/xVjPhBP4/H8S6fx5xiblwnhlK+H+ZP/pXxeE3qOsfl7YG8TTbezeC7McbQ8riWN4FvI2QspWIrIsAlP22f+f96uS4o9Gjws5riMv9j9XB/wAV+OFCl/yritbf0obeYR8jWWS49VpBHPUSIqD900no8T6q/D6XD4vXw+hFagk3f+x/o/8AHvxwqdjqXkiG3nu7f6nbXU1hdx3iEXHqCS40dYo0tB8SAtevdLLy+BeS/wC6+GIMfx/VROGUkA8RHFHh+n+HL/H/AMk+Bdrd7+Wts9zNpVtayMI5VsavcP8AA11bCF2UrFxnS2+tt8Tu3+/PiWPkJcPROIZyAJE/0vp/mz4v83j4ELreteXLnXbe4guIxaLpus25kjMyymaX68Lf1W+2/rerb7ktz9T99+2uMiL+f6WWLHMQII34sf8A074v9L6kHr2oeRzrVvPZ2cP6Og1a9hmt7f1V9XS1aH6s/wC8Yn1HVrijfa+FeS/ZyMjG/j/sWzFHLwkE+rgj/wArfVx/71GuPy8jtbm3he1mW1FzBNdyLcCa4KWaC2ntQPhHq3/rsQ/H916Pq/u+eE8KInMSCb34f5vDH1+uM/8Aklw/7JOY4fIOt+b2uTPbXX6RvGT6u/1gPJLLrjOZCFUUjbTXQVDf6v7xclUTL8fzv+JaTLNjxVuOGP8AR/1H/qsgbW88jPaCxuJdOjk5wXF6UjnaB5o4L0KsBJQhatZq/JvSWZ5H4yQ8lxHCiYy3Y4uvDy+m4fV/0s/zf6SKkvfy0kX6tH9Ua3gkmmtoz6qr9ZuLOxqWkZN4vVjvlXknD1Vh+BI8JMfx8ERjn5+q9v8ASxlk/wCrbGrWTyP+l9c9aJFsYJWvNGUGaRZfR5qlnyYI/oztJG5klVHWOH+ZvirBjZcyUc3DGvqPpny/0/8Am/75lNpqf5cWE9u1g8dtG6wo00ck/qmEXFpI3qgIvCUenM/JJOfL1OP7v0MlxRDjHFnkDe/+l+rhn9P+x/HEkr33lG88y2U999Xksl0lYo1HONPrkaFR9YPFjyLAnkVaNv3fqfBzwXEn4NphkjAgXfH/ALD+ijK/liyuUjskVL1GWMyXb+rH9YQOgf00khi9H1GWT07hPT+H0vX+PD6Gv9//AEvp/o/zff6vV/V/0q67H5ZpYakIhbzXbLKVoZouBNnH6AhosqyOt563qlfTiduPwx2/2Ing3bsY1Fx5gf5v888fF9P+T4f+k0v0W48qW+mWUsktrDL9VuBduTci9+uN66qFaMiMQtCYR/J+z9vnghw0zzjKZEequIcP0+Hwen/ZcXEnGp6j5F1zV7WS7vbf0re+ilnkmEwDWR1G/luY14KSWkjmtX4/8MvF8mTEn8d8nFhDNjiaB3j5f3nh4+D/AHM0oW/8hGwW3NnaeoLaGM3FJ/V9RtL5TNXlx5jUgoB4/wDJJmwXGvx3f8U2mGbiu5c/6P8Aqnp/6VLvK975Jt9BWLUXtkjvIYYdXVhcfW3kGrwzOF4Dj9X+oRI3wfHzV+H7zDAxr8fzmrUQy8e17fR9PB/dS/2XiK0N75JXTnspZLEX0whmljjFx9QN5FHqCxMduXBUlsw9P3frN8fwerh2/HxYEZeK/VX+b4nB+7/4+2t3+WS3cNutvaOGSd5Zv9IWP60sEQRFZ+XG2M7XLQ8o/wDfPrfu8fSms9XZ6d302f8AZ8PBxf7FCaK35df4h1l7uGA2Rmi/R0Uss4txByP1nhIIzLX7Ppco/U9Pnw/e8cA4bLPIM3BGrv8Ai5cX9FLNch8opozXWmTQvdSyab9XtP3plRIrWZb71OSqnx3Ihbr8X7HFcEqrZtxHJxVLl6/91Hw/9gyrULzyH5h8zz6lfXEU0Ms72wto/XE8i/XYVhMK04qPqXqKvxIqt8PH7GTJiTbhwjlxw4R+j+YeLi/5KKmoad5V0yOzsdYFnYXtysV1c20aXiW7tEdTRC8MpiZWr9TRWlHFefqcXiab1CQBz/H1MYznIkxuQHp/h4v8l/x9jXnq88qyaXb2mgNbCKG9eZ1iEnP9/Y2fMqzqnKP6zHdL9lePFPgVchOq2cnTRnxEzv6f9zOf+84GEE/2ZU5rNPya/wDJp+WT430f8ctw/WHC7S/uJ+592Zs3iHYq7FXYqxXyb/ykXnv/ALbkP/dD0zFWVYq7FXYq7FXYq7FXYq7FX//Q9U4q7FXYq7FXYq8C/wCcujTy/wCXx43U3/JsZh6vkHovZ765+4PmDMF6lNPLWm2mpasLa8eSO2WC6uJWipzpbW0k9F5bfF6XHJxFlx88zGNjncf9lLhZVJ+W8DIt5ZtcyWP1a4u53Kh/QRdIt9St1ldQFrJJcNb8qJ6np/AuTOP8f5vE40dYeRrisR/rfvZYpf7jiT++/LDR7/U7lLWOW0hjaeKL0OTIJBeXqoXASZto7eKMc/Qj/wCL+fwtI4gT+PNohrpRiL35f7jH/V/n/wBL+qx7Q/y7ttT0fTLql2kmoRpL9ZAj+rMz6kbH6tEW41uPTH1kVl+yjfu+PxrGOOwPx1cjNrDGUh6fT/pv7vxOP+r/AAJlN+W+h6fPbPLJcO161ulrA4PFDMs5f1fUit5HC/Vjx/dQ/b/yfjl4YDSNZOQPL03/AL3zl/P/AKTZ/LPS7PThc3Ed1PNJaXP7kkrSeO3jnWZSIwjIqtJ8MclxHxTl6/2kx8MAJGtlKVCvqj/uuHv/AOI/qoHU/wAtYNMstRlvFvWmhluIdPtlQK8xW5jt7d91JKSGTn8C/H9lPtcsicdNsdZx0Bw9OL+j6eOTz143jdkdSsikqynYgjYg5W5YaxSuU0Pt3wMxsqNsKdzgZkrcLBpWo1e3fAVjKjauooK+OQLlR3dgZErDvWvfJhpkLUztt3yTQVuKGgfHocKG6U+eBLsVXDw7YGa1zTbvhDCRWYWK9DQ+3fFkDSsBQZAt8XYslvXr3wtZ3bRabnrgJTjj1X5FtdSophCyFhTO23fJNBawoWkVFMQxkLWUp88k1hrAlcPDtilx2274oK3FDqknc9e+Fi47bd8VaxVmn5MH/kKfln/mOj/jluH6g4XaP9xP3Pu3Nk8S7FXYq7FWK+Tf+Ui89/8Abch/7oemYqyrFXYq7FXYq7FXYq7FXYq//9H1TirsVdirsVdirwH/AJy6JGgeXqGn+lTf8m1zE1fIPQez/wBcv6r5gLt4nMF6guDN4nChesjEUqR7VwFnAt83/mP34GStPf3c8NvFNKWis4zDbr/JGZHlKin/ABZLI2/82G7Y8IFnvQxdm3qa998LBwd+vI+HXAkBvm56sfvxZLWZiK1O3vhay0GfxP34qAuBYnqffFICtG7EUr0/VkC3w7nMzdKnAyLXI9anCwNBaJGI6moyRYxKx5H6cj9+IYzK0M38xp88LBsOxHU1GKhou3ifvxVtObNSp98SUxjZVyTTbtkAXIMQHAnxxSA4sQK1xU7LORO9d8LVTgT44sgGxUnqffFICqGNOvTIFtAaLN4nFJC0uQK1OEMJEAKDM53qa98sDiSWhn/mP34sWwzE/aNO++KWyzEVqduuKlrm/wDMfvwocGbxP34q4sxFan3wJaDP/MfvxVtSxPU0774pAVeRI69MDbTRY+OKKa5ECtcUGgpl2IrU175Jpa5N4n78VZp+TBY/mn5Z3P8AvdH/ABy3D9QcLtH+4n7n3ZmyeJdirsVdirFfJv8AykXnv/tuQ/8AdD0zFWVYq7FXYq7FXYq7FXYq7FX/0vVOKuxV2KuxV2KvBf8AnLmCU+WdBuAtYo72SN27BpIiVH0hGzE1fIO/9nyPEkP6P6Xy2RQ/qzBepd0FPvxQ4Ghriq+v3YGwFa7dvvwhhIrQaHCxXH8O2BkC0T2+/CglrlTFBLdPu7YqFwFB74C2RDYNDXAlfgbButc9vvwhrkVtab4WB2WHrhYtHw+/CxJcDQ1xW11BgZhWjSi+5yBLkY4ULXdMDMho4WKx27YQGuUloNDhY2uJwMrXrUD3yJbIrgd8DNoihxVSlapp4dcmA4+SVlZhYOIphY0u40FPvwMgGthhUhaRQ4tdN02p9+LIBwxVadjTFCoooPfvgZxbBocWVuPXFVNzvTw64Q1yK0GmFg4ihxVnX5I28s35q+Wo4l5OLsSMB/LGjOx/2KqTlmH6w4faRrTz9z7nzZvEOxVAa/cavbaLe3GjW8d5qkMLyWdpKxRJZFFRGXH2edOIb9lsVfK8n/ObnmKKR4pfKVskiEq6NcyhlYGhBBj2IxVKtI/5zF1rTdQ1u8Xy1bSNrV6l86G5kAjZLK2s+APD4hxtA9f8vFWdflt/zlL5x89+cdP8t6f5WtY2un5XNybmRlgt03llI4D7K/ZWvxvwT9rFX0lirsVdirsVdirsVdir/9P1TirsVdirsVdirDvzb8i/418j32jxUF+tLnTXbYC5irxBNRQSKXiLfs+pyyvLDijTmaDVeBlEun8X9V8NXdldWd3NZXkTW93bO0U8EilXSRDRkYHcEEZqyKe6hMSAI5FR9M+I/HI22cJaKe4/HDbExLaig3I9sV3C2nv+vCxdx9xirajbqNumKrae+KtEDxwsSvjAOxPTAUx5rqe+Rb3UHjihcpAHX5YrdLdvHCxWNQnrhDAlwFR16dMKFtPf9eKKdx9x+OKr4wK/Eagb4Cyhz3VfVTIcLk+KGjKpw8LE5g71FKmnUdMaYnKFLkPHC18TdR440niXKy9+2NJEwu9VMjwtnihsSp448LIZQ4yKVNOo6YRFEsorZRqPHDTRxNVHjjS8S5Sp6np0wotuo8cDK1pIPfDTEltQD33HTFebfA+IwWz4S1w9x+ONo4S3xFKk1phQRTXNfHGl4g7kvjgpPEG+QK7HcdMNIMlOg8cLW6nviq5QD36dMVD6H/5xZ/Lm6a/l88ahEUtoke30fkCDJI/wTTL0+FE5Qj9lmeT/AH3mXpsf8ToO29WK8Ic/4/8AiX0vmY827FXYq+Kf+ct/ysHlzzYnm7TYQmkeYXb60EFFi1AAtJ0/5aFBmH/Fnr4q8BxV9v8A/OJ/5WHyv5NPmbUYeOteYkWSMMKNDYj4ok37zf3z/wCT6X8mKvdcVdirsVdirsVdirsVf//U9U4q7FXYq7FXYq7FXn/5kfkn5P8APTG7ukew1oKFXVLagduIoomQ/DMq7fyyfDxWRVyrJhEve5+j7RyYNh6o/wA0vIL7/nEjzKkxFjr1lPD+y88csLH5qnrD/h8xTpD0LvIe0MK3jK0L/wBCk+dv+rxpv3z/APVLH8pLvT/ogxfzZf7Fpv8AnEnzuTtrGm7e9x/1SwjSHvYnt/Gf4ZfY1/0KR52/6u+mffP/ANUsfyp70fy9j/my+x3/AEKR53/6vGmffcf9Usfyp71/l7H/ADZfY3/0KR532prGm7e9x/1Sx/KnvX+Xsf8ANl9jR/5xH879tX0z77j/AKpY/lT3o/l7H/Nl9i3/AKFG88f9XjTPvuP+qWH8qe9H8u4/5slw/wCcSPO4pTWNM297j/qlg/KnvSO3sf8ANl9i/wD6FK87f9XfTfvn/wCqWD8pLvbR7Q4v5svsa/6FJ86/9XjTfvn/AOqWP5SXev8AogxfzZf7Fo/84k+d9qaxpu3vcf8AVLH8oe9ie38f82X2OP8AziT527axpn33H/VLD+UPeg9v4/5svsW/9Cj+d/8Aq8aZ99x/1Sx/KnvY/wAvY/5svsXD/nEnzsAP9zGm/fcf9Usfyp70jt7H/Nl9jR/5xH87V21fTPvuP+qWP5U96P5ex/zZfY1/0KP53/6vGmffcf8AVLD+VPev8vY/5svsb/6FI87ilNY0zb3uP+qWD8qe9P8AL2P+bL7HH/nEjzv21fTPvuP+qWP5Q96/y/j/AJsvsa/6FH88f9XjTPvuP+qWP5U96P5ex/zZLh/ziT52FP8Acxpv33H/AFSx/KnvSO3sf82X2LT/AM4jed67axplPncf9Usfyp70fy9j/my+x3/Qo/nf/q8aZ99x/wBUsfyp71/l7H/Nl9jv+hR/PG1NY0zb3uP+qWP5U96/y9j/AJsm/wDoUfztX/jr6Z99x/1Sx/KnvSO3sf8ANl9jv+hSPO//AFeNM++4/wCqWD8oe9P8v4/5svsb/wChSfO23+5jTfvn/wCqWP5SXen+X8X82X2LT/ziN53rtrGmU+dx/wBUsP5U97D+Xsf82X2Nf9CjeeP+rxpn33H/AFSx/KnvX+Xsf82Tf/Qo/njamsaZt73H/VLD+VPej+Xcf82TZ/5xI87/APV30z77j/qlg/KnvZfy9j/my+xr/oUfzv8A9XjTPvuP+qWH8qe9H8vY/wCbL7G/+hSPPG1NY0zb3uP+qWP5U96/y9j/AJsvsX/9Cledf+rvpv3z/wDVLI/lJd7b/ohxfzZfY1/0KT52/wCrxpv3z/8AVLH8pLvR/ogxfzZfY4/84ledv+rxpu3vP/1Sw/lD3oPb+P8Amy+xYf8AnEbzvXbWNMp87j/qlh/Knva/5dx/zZNf9CjeeP8Aq8aZ99x/1SwflT3p/l7H/Nk3/wBCj+d9v9zGmbe9x/1Sx/KnvX+Xsf8ANl9jR/5xG87121fTKf61x/1Sw/lT3o/l2H82Ta/84jed6jlrGmAdyDcE/wDJoY/lT3o/l2H82TN/Jv8Azil5b026jvPMmoPrLR0ZbGNPq9vy7iQ8mklWvShh/wAvllkNMBz3cTP23OQqA4P9lJ7lb28FvBHb28awwQqI4YY1CoiKKKqqKBVUbADMl0pJJsr8UOxV2Ksd/MLyTpvnbyfqXlvUPhjvoiIZqVMM6/FFKP8AjG4U/wCUvwftYq+Kvyb/ACS1XzD+bM3l3XrVorHy3MZPMCkfCRE9EhBI+Jblh8J/ag5yJir72VVRQqgKqiiqNgAOgAxVvFXYq7FXYq7FXYq7FX//1fVOKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KpB5k85WGgaromn3cZP6ankgjn5KqRGNA5Zy1NjXFU1h1bS5pFihvIJJG+yiSIzHvsAcVSzzn5stvK2jDVLmB7iMzw2/pxkBqzOEB+LsCcVT3FUg8kebYvNWiHVYrZrVRPNb+kzBzWByhaoA+1TFUq8zfm95F0D9I29zqUb6rp8bk6cA4keVE5LEG4lQz7KDiqjqn5s6TpegeWdcv7doLHzE0YZ2fa2WSP1OT0U8+I/lGKp15c8/eT/MtzLbaHqcd9PAnqypGHBVKha/Eq9ziqR/8AK7vy/wD+Wi8/6QLv/qliqnH+e35cSlxFeXLmM8ZAtldniw7GkexxVOvLP5i+V/Mt/JY6VLO9xHEZ3EttPAvBWVT8UqItauvw4qybFUh8jeb7Xzd5bttetYJLaC5aRVhlILj0pDGa8dtyuKpzdXVtaWs11dSrDbW6NLPM5CoiICzMxPRVUVOKsd/5Wf8Al1/1Mum/9JMX/NWKu/5Wf+XX/Uy6b/0kxf8ANWKt+ZfzE8t+XrCy1G9eaawv42mt7q0he4i9JQjc2eMFVVlkUox+1iqTzfnT5Vj0m61NLTU5YLVYmZRZvGziaVYk9P1jEjnk69H+ziqET88LB72SxTyj5na9hRZJrUacplRHqFZkE3JVanwsRir0S0uPrNpDcelJD60ayejMvCROYB4uu/F1rRlxVD63rFjouj3mrXzFbSxieeYqKtxQVoo2qx6LiqIs7lbq0gulRkWeNZVRxR1DqGowBPxCu+Kuuru1tIGuLuaO3gTd5pWCIo92YgDFULpXmDQdXDHSdStdQCfbNrPHNx+fps1MVR+KuxV2KuxV2KrJ54YIXmnkWKGMFpJXIVVUdSzHYDFXRTQzRRzRSLJFKoaKRCGVlYVBUjYgjfFV+KuxVBxafpNhcX2pJDFbT3pSTULqgUyeigRGkY/yIOIriqjpvmby5qk7waZqtnfTx19SK2uIpnWnXkqMxGKplirsVdiqjaXlneQLcWc8dzA1Qs0Lq6GhoaMpI2OKq2KuxV2Kv//W9U4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FWK+bvzAg8s3kFrJomr6oZ4/VEumWouI1+Irxdi6cW26Yq8l/Mnz5ovmbWvK0d/wCVtc+oW11M1zY3Vn6clyrRgcIFWWsjAjkw5LiqZaPrf5Z6NqUGp6Z+W/mK1vrckwTrYMSpZSppW4I+yxGKsn/PaR7j8t1kiLW7zXli0ZkUckLSqRyU7VXuMVWf4b/Nv/y5Vv8A9wyyxVkv5beVX8r+WV0mS/TUpRPNPJdRoIwWmfmRxDPTr44qxD8zPN/mO0t7vQdW/RejadriXllZXMpvr25mtwvpvIkNpAyo/pyo3GST4W/n44qxK713SY/LXle0s/MUN3qvla7jntTcaXqkFu8MUYjWNjHDLJyA350+L/JxVnfkbzB51846la6wmq6Ynl/TZZ7e/t9OS89S4mMakRyC9hhKCLkj84/9TFWOan5//Mw6d5y1yxvrCLTvLOp3NjHaSWzPK6QyhFPMOB9l17Yqk2i6h5j8t3drZ+XvN2hareeatW9S8WFVuJY5rlSzSOElJ9NSvHjT7TYqz7yfqXmPzDqnnTyh5ruYbqPTEtLf17JGtiy3kUjSUPJmBoF44qwL6x/zjV/1MGof8Hqf/VLFWN/l7L+Sa+VbUeadXvLTWuUv1iCFr4IB6jcKegjR7px+ycCXun5caT5Dl8tXL+WZZNS0PUndLj64ZZVkoPTkQpcqG4EfCyleLYUJDca//wA4521xLbz2+hJNC7RyodPjqrKaMP7nsRiq+x1n/nHe/vbextLXQ5ru6lSC3iGnx1eSRgqKKwgfExpiqp+e1/a6V+XA0W0j9H9KTW2mWdrbIoKxBgzJFGKKB6Ufpqv2fiXFWO/mB53tPMP5f6/pEWlX+k3ehz6Sk9rdBI5gLidWiCcHajcI67/zLirH7Gxvz581SMWfnEyLZWxaOPUEF8AWahml9ajQ/wC+l5/D8WKvoyGvpJXlXiPtbt07++KsI/NamoWmieVl3bzDqcENwlaE2lsfrNyff4IlX/Z4qznFXlH5ufUrfzZ5c1PzRZy3vke0ScXaojTQxXj7Ry3ES15px+Far/N/qsqqW2hflt5i1PStV8gajp2l6xptwlxILBEiaa139WCW3QwtxkH7bJ8OKsg1/wA+6nHr83l3yvora7q1nHHLqRadLa3tVlFY1kkcNykdfiWNV+z8WKqnl78xILyLVodfsX0DVtCi+sapZTOsqrblS4nilQcZoqKd1Hwt8OKsef8AN3zMulf4mHk6f/B+z/XjcxfW/q5/4+PqtPsf89Ps/Hy4Yqyex89Q3vnkeWILXlC+kJrMWoeoRyV5VjWP0im2z8+fqf5PDFW0878vNOv6D9Sp+g7KK9+s+r/e+qhbhw4fBSn2uT4qxKH8z9U8w+T7zXJvKIk8ptp9zJdST3ifvHhjb1IRGIy7RM6tD6vFf2vg/mVY7rPmnzKfOH5cz6H5bLWZ017nSNKS+iijnE2njnHV1CxfUo3Kq8ifvf2OOKvU/JfnL/EUWqpcWf6Nv9HvZbG9tWk9QAx0KyK5WOqSKar8OKteQfOR83aPPq8dl9Usvrc1vYuZPUM8MLcRP9hOHNuQ4fHx4/bxVjHmq1Hm/wDM+18o3xZvLmk2A1TUbQMVW5uHl4QxygUZo4/7yn2f5sVTHzR+UXlq/son8vWtt5d12zkSbT9VsoViaN0YV5rHw9VWXkKPiqO83eeJ9Al03SLOwfXPM2pqfqthARAhEYHqTSSPyEMQ9+X/ABtiqh5c/MDULjzB/hvzPo7aFrUkTXFkBMtzb3MSfb9OVQo5oN2jP7OKpZb/AJra3qAuNW0byvNqHlG0kdJNWSeNZpUiYrLLb2pHOVEpX7XJ/wDX+HFUh/KrzdZ+WfyX0W5mgkvLq7u57TTrCAAy3FxLcycI1rsOlWY/ZxVk9r+YnmSx1KxtvOHlo6HZ6nKlvaahFdx3kSXEleEM/BVMZalOf2OX+yxVn2KuxV//1/VOKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KvNPzXguLjzZ5Egtrg2lxLe3aRXSqHaNmt6BwrfCSvUcsVRenXn5u6JqdrYataWvmfSp5UhOsWpFpcwqxoZJ4GqjKvU+l/wX7OKpd+cn1fXtV8q+RV/ey6pqKXmoQr1FjbK3qliPiTmC3Aj/feKph/yoH8pP8Aqw/9Pd7/ANVsVQH5F6faabH5y0+yj9Kzs/MV5b20VWbjFEFRF5MSxooG7HliqF/M+eyvvzK8s2Twz3kWj2Gp32rW9lzNwLa4hWFQnpMknN2XivB1f4sVS/SJPO1tqVvd+UdG8yjTQ1Z9L166t4rdkoRRTdGe4h6hvgLfy/5WKp7+Qz3L6R5pe6jWG5bzJfmeJG5qkhSHkqtQcgrbcqYqwm6u7WPyB+bNu80azyeYL0xxMwDsPXj6KTU9MVRWpJqNtrfkqbUbfy3aWy6vbn1tHdvX/u3/AL7nHGojp9r4vt8cVZL5L1jS7P8AMP8AM7VLm6ij06BtLkluiwMYUW8oJ5CvfFVFrm4/NO5+paVavp3kGJx+kNUeMwz6iUavoW/RkgNP3sn2v2fh+xirDfyu0DzDovkjTvOvli2GptMZo9f0J/iNzDDO6pLb1rxniTbiv2/5Wb4XCXrmhfml5E1DQJdXivUsLS1dYr2K5UwvbyyVASRaUqSOq8lwoQrfmF+TbMWbVNKLE1JIjJJP+xxVtPzE/J2N1kj1XSkdCGR1CAgjcEELirFvzjXy3regaH52sr17yDS76GO3NsxeJxJcxiU8KfE6+kVHH/mnFWPy6lYeYvOnmK0fTbiXT/N+o6HbW8dyJrGX0rO2la4mSq8/3DxL/wAEv82BUBLpOk3Ggz+Y9N0zU4wdKj1Ga5/Sdw7iIi4jdRK3pI7WtxDGxjb+8hfki8uOFXuX5frcL5F8vfWXd7htOtWmaQkuXaFWbkTvWpxVJY/9zH5wSvUNbeVdMWOn8t5qbczv/wAw0S/8HirOcVYH5q89XvlXznarroCeS9RtvTjv1iZvQvg/2Z2WvGN4/s/D9r/JR8VYV+Y9z5A1ebTR5Fa1n89yXkDadc6UByQB/wB5JcvCOHpKn2vUPL/Yc8VU9V0vQtP/ADS8xR+bdZ1DQbfVzDeaPfW13JaW06rHwlR3UcfUiNFHJv8AiSclVSz8u+VtatfOKeULnVtZ1AaTJYfpa8nNxazNIRKLaGR6O8nJKdPTXn/l4qn2jfnH5O0z8vLF1nSTWrKzitB5fBZLpruJBF6Aj4s6gyLx9T0+PHFUJc+YrTRfzmsda8ygaLb6v5aWCM3DD047kXCzSQtLQLyjAox/1f51xVZ5e1uz1r8xPPt/Zcmsn0m3W2nZWUSosTD1EDAExsa+m/2XX41+FsVX6GAP+cZ5Kf8AVmvP1y4qlZ1LT9J1f8mtS1K4Sz0+LRpllupjwjUvpsaKCx2FWZRiq782bzUvJ3mXU7/SoWkTzxpv6PCxDcajEwijkrtT/R5W4fzSYq9a8paBD5f8s6ZosNONjbpEzAU5OBWR/wDZuWfFWFeb7g+T/wAyLPzpdI58vajYnStWnjRn+rSJJ6sM0gUFuDf3df2f+BxVX81/nF5dh0v6v5UvItc8y349LSbC0/fkyv0aULQIqfaYOy/8SxVLPMF5ceWfzK8ueaPM7oljdaOdJvr2JWFtBe+oZixqXKRyFuCcv9k2KqOs6lp/nn8z/L0Xlq5W7ttBtdQl1LU4KtChvIRDFGJB8LPyHQN9nl/I2Ktflr5+8teXPIkfl3WpVs/MGiNNZ3GjMD680xldkEKAVm9bmtOH7Tf7LFWCadpzv+UHknWJmuk0jSdTum1aWxZkuIYJpnQzqyVYelTen8+BLJbux/Kq7u9KsLPzFrfma6vrmL6vp9rftdcCp5CaZJKJGkVOT8zyXCh7pirsVf/Q9U4q7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYqlGp+X9G1jUtM1C4rJdaLK81oUegWR14NzA67Dviqb4qly+XtFXXn18WiDV3gFq15T4/RDcuP398VRkd1ayTSQRzI88VDLErAutenJQaiuKoHRPLWj6I+oPp0JibVLuS/vSXZ+dxNu7DkTxr/Kvw4q3ZeW9EsdYv9ZtbRItT1IIL25FeTiMUXr09+P2v2sVd5h8uaV5h01tO1SNpLVmV6RyPE4ZDUFXjKuv0HFVnlryvoXlrTf0dott9VtTI0zrzeRnkenJ3eQs7MaDq2KpDH+T35fG91C+u9Kjv7rUrqW8nkuqSFZJm5MqbDinI7Liqr/yqP8ALT/qXLL/AJF/24qifLf5eeVfLdzq0uk2ghi1kRLd2ho0AWFXUKkZGysJH5g8uWKsjiiiijWKJFjiQBURQFVVGwAA2AGKpd5a8taP5b0eHSNIhMFhAXaKJnaQgyMXb4nLN9psVRE2kaTPFLFNZQSxTyerPG8SMryAAc3BFGeij4jiqF/wl5V/6s1j/wBI0P8AzTirv8JeVf8AqzWP/SND/wA04qqz+XdCnsI9PksIPqMUizR2yoqRrIjc1cKtByD/ABYqiJtN0+a8t76a2ikvLTmLW5ZFMkYkHFwjkcl5DZqYqk3mbyHoHmO3gtdQ+sR2cCsn1W1nktoZEcglZEiKq6/D8Nfs4qn0MMUEKQxKEiiUJGg2AVRQAfIYqkHlHy1daPNrd5fTJPfazqEt47x1okPFY4IqkAn040/4LFWRYqtlhimjaKVFkjbZkcBlI9wcVQ1jpGk6fy+oWUFpz+36ESR1+fADFV95YWF9F6F7bxXUQIb0pkWRa9jxYEYqqW1tbWsKwW0SQQoKJFGoRQPZVoBiqidJ0s3v142cBvf+Wr009X/g6cvxxVde6fYX0YjvbaK6jU8lSZFkUHxAYHfFV62lqrs6wxh3UI7BQCygUCk03GKuFrarb/VlhQW9CvohRwoeo40piqndaXpl3bpbXVnBcW8dPThljR0WgoKKwIFBirC9Q8q+afMPnbTrrXI7ODyz5fuJLvToYHd5rmbpA8qsAsfoj4qD9v8A1vgVZ7irTorqUcBkYEMpFQQeoIxVC2ej6RZSNLZ2NvbSP9t4YkjZvmVAriqInt4LiF4biNZoXFHjkUMrDwKnY4qss7GysofRs7eK2hBr6cKLGtT/AJKgDFVkmm6dJeJeyWsL3kYpHctGplUezkch9+KqsVtbQw+jFEkcO/7pFCrv1+Ebb4qoWekaTYyPJZWUFrJJ/ePDEkZb5lQK4qi8Vdir/9H1TirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVSXzB508qeXSi63qlvYPIpeOOV6OyjaqoKsR9GKvGfy4/M/R9L1XzjJaadqWtNqutXN3Yrplq0xaGR2KM3IoU5A14n4v8nArLIfzf8ANU/nPSPLp8oS2X6TbmfrVwonW3FecxiRT6apTl8Z+PiyLhVlfnHzpqPl+5tbWx8uahrst2juGskrHHwIFJXoQla7VxV5Np+ufmTD+bGqSab5ct9K1bzJYxTrY6lcepFwtR6frFoeHxng1Y/hb/iWBXrXk23/ADGSS6l84XWnSrKsf1S305ZAsRBbnyaRQzcqr+03HjhVOdb1/RtDsvr2r3kdlacxH68x4rzatBX3piqQH83Py0/6mOy/5Gf2YqyiyvbO+tIbyzmS4tbhRJDPGwZHVtwVYbHFXnvni8u4vzb8gW8U8iW8/wCkPXhVmCPxhBXmoNGp2rirI/zNd0/LzzG6MVddOuSrA0IIjJBBGKrfy3uAPy48vXFxJsNNt3llc12EQLMScVYf5j/5VBr+rSandedWt5pVVWitNUWGIcFCghAeu2+KpX/h/wDJb/qfLr/uMjFXrHl7WtB1SwB0XUIdRtbXjA00MiygMqjZmXblxocVTPFWHXX5maUfOVp5U0m3k1i+dm/SktqQYrKMA/FK5+Anlsycvh/4ycI3VZLrEGo3GlXcGmXIs9RkidbS7ZRIIpSPgcowKtxO/E4q88/wh+ev/U+23/cOtv8AqniqSeYrr84vKWoeXpdT82xajZ6nqttYTW8djbREpK1W+L067qpX4fixV7VirsVdiqhfgGxuARUGJwQelOJxV5d/zj5qej3P5aWmjx38S6kjXIntopVFzGJJnKvxrzX4TyRuOKsk8oeTNe03UoNX1bUhNqItn0/UPTDMt7FFJWzuJS3HhcxxVWSgfny+3irNMVdirsVdirsVdirsVdirsVdirsVdirsVdirsVdirsVf/0vVOKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxVLtR8ueX9TuobrUtNtb25tgVt5biFJWjBNTwLg8foxV5/wDksiR6v+YEcahETzDdqiKKAAOwAAHbFWReTvIk2j6zq3mDWL4arr+qSFTecPTWK1U/u4Ikq3Bdhy+L+X/WZVW846r+YFpdWsHlXRbbUo5kY3F1dXAhSFgRxBSqu/IfyYq8l88Wf5swebfKmt6zqGmaRf3VydJsrrTY5JhB9aHE+slwGV68m4/F8P2sCXpOg/l35ks9ZtNW1nznqOrS2rM31QKtvaOXUp8cCl1NAxphQzO9sLG+h9C9torqGob0pkWReQ6HiwIrirzr86dJ8taT+Wet3UGlWcVwY44YZI7eJXDTTJHVWC1FAxOKs18oad+jPKejad3tLG3hb/WSJVJ7dxiqW+YPJcmredPLfmNbsQpoP1nlbFCxl+sIE2fkOHGn8rYqk353+ZrTTPJN3pKN6usa8v1DTrFN5ZDMQjkIKtxVT1/n4J9p8VZZ5X0X9FeVNK0acLIbOygtZwQCrGOII+24IYg4qlOreT/yx0nTLrU77y7pENnZxtNPI1jbCioK/wAnU9FH7WKsN/JLyH5bvvJC6trOgWE9xqt3cXkIubWGVo4GYJGiF0PGP4OSKPh+Ll+1ir0y20fT9F065j8vaXaWrsGljtIES1ikm40XmY025UVS/BvhxV5nr+mfnLr+iahd61qFt5W0yC2mn/Rum1mu5PTjLBJbitE6btDJ8X8mKp9+ROl6dZ/lppFxa20cNxextLdzIoDyuJHALt1agFBirO7u8tLK2kuryeO2tYV5zTzMscaKOpZmIVR88VST/lYn5f8A/Uz6T/0nW3/NeKvPfzb80+WNXm8mwaTq9lqE8fmGyd4rW4indUqw5FY2YhakCuKs189flf5Z87SWcmtfWOViJFg9CQR7SlS1aq1fsDFWK/8AQs/5bf8AL9/0kL/zRiqL0j/nHr8v9K1Wy1S1+u/WrCeK5g5zgr6kLh15DgKjkuKvRr3/AHjn/wCMb/8AETirwr8rPyj8mebPyy0y/vreS21f1LjjqdrI0cwKTuEJ6xtx4rTkmBXp/kHyr5n8uJe2mr+YJddsiyfowzrSWJBXkHc8nc/ZA+Pj8P2VwqyzFXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FX//0/VOKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KsC1n8mfLeoa1d6zaahqmiX1+3O9bS7r0Flf8AmcMknf4tv2sVVdA/KPQ9H1e21Y6pq2pXtozNC2oXZmWrqUNVCop+E4qzjFWOeefJVr5t0+zs57mS0axvIr6CeIAuJIQwWnLb9vuMVZHirFfNf5a+W/NGox6hqhuhcRQrAv1e4khXgrM4qqEDlV2+LFUim/IH8vp09OZb6WM7lHvJmG3sTirI/KPkDQPKj3L6Ubit2EWUXE7zCkdePHmTx+12xVkUiCSNkJKhwVLKSrCopUEdDirCvKv5S6DoesPrt3c3Wua+xPDU9Rk9WSMHYCMbKvw7cvtfy8V+HFWb4qxPzn+Xdl5uvLE6rqF3+ibRuc+jxMqW9wymqmQgB9v9b/U4YqymCCG3hjggjWKGJQkUSAKqqooFUDYADFV+KoPWbFtQ0e+sEYI93bywK53CmRCgJ+VcVS3yJ5bm8teUtN0KaZbiSxjMbTICqtV2aoB/1sVTbUNPstRsprG+hW4s7hSk8Diqup6gjFWM/wDKo/y0/wCpcsv+Rf8AbiqHuPya/LyS5sbq20pLC4sLmO7hltKRszxHkqvs3JK/s4qzbFXYq7FVk8fqwSRV481K8qVpUUrTFUh8g+T4vKHli20GK5a7jtmkZZ3QIx9WQyEEAt0LYqyHFXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq7FXYq/wD/1PVOKuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2KuxV2Kv//Z";

var Payment = function Payment() {
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    payer = _useState2[0],
    setPayer = _useState2[1];

  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    card_no_1 = _useState4[0],
    setCard_no_1 = _useState4[1];

  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    card_no_2 = _useState6[0],
    setCard_no_2 = _useState6[1];

  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    card_no_3 = _useState8[0],
    setCard_no_3 = _useState8[1];

  var _useState9 = useState(""),
    _useState10 = _slicedToArray(_useState9, 2),
    card_no_4 = _useState10[0],
    setCard_no_4 = _useState10[1];

  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    exp_date_month = _useState12[0],
    setExp_date_month = _useState12[1];

  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    exp_date_year = _useState14[0],
    setExp_date_year = _useState14[1];

  var _useState15 = useState(""),
    _useState16 = _slicedToArray(_useState15, 2),
    ccv = _useState16[0],
    setCcv = _useState16[1];

  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    contact_number = _useState18[0],
    setContact_number = _useState18[1];

  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    email = _useState20[0],
    setEmail = _useState20[1];

  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2),
    payment_total = _useState22[0],
    setPayment_total = _useState22[1];

  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    ccv_help_on = _useState24[0],
    setCcv_help_on = _useState24[1];

  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    pi_notes_on = _useState26[0],
    setPi_notes_on = _useState26[1];

  var _useState27 = useState(false),
    _useState28 = _slicedToArray(_useState27, 2),
    sa_notes_on = _useState28[0],
    setSa_notes_on = _useState28[1];

  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    is_update_auto_pay_date = _useState30[0],
    setIs_update_auto_pay_date = _useState30[1];

  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    isLoading = _useState32[0],
    setIsLoading = _useState32[1];

  var _useState33 = useState(false),
    _useState34 = _slicedToArray(_useState33, 2),
    formError = _useState34[0],
    setFormError = _useState34[1];

  var submit = function submit() {
    setFormError(false);

    if (!localStorage.orderId) {
      return;
    }

    if (
      card_no_1.length < 4 ||
      card_no_2.length < 4 ||
      card_no_3.length < 4 ||
      card_no_4.length < 4 ||
      ccv.length < 3
    ) {
      setFormError(true);
      return;
    }

    var card_no_1_temp = parseInt(card_no_1);
    var card_no_2_temp = parseInt(card_no_2);
    var card_no_3_temp = parseInt(card_no_3);
    var card_no_4_temp = parseInt(card_no_4);
    var ccv_temp = parseInt(ccv);

    if (
      payer === "" ||
      isNaN(card_no_1_temp) ||
      isNaN(card_no_2_temp) ||
      isNaN(card_no_3_temp) ||
      isNaN(card_no_4_temp) ||
      isNaN(exp_date_month) ||
      isNaN(exp_date_year) ||
      !exp_date_month ||
      exp_date_month < 1 ||
      exp_date_month > 12 ||
      !exp_date_year ||
      exp_date_year === 0 ||
      isNaN(ccv_temp)
    ) {
      setFormError(true);
      return;
    }

    var card_no = "" + card_no_1 + card_no_2 + card_no_3 + card_no_4;
    var expDateMonth = exp_date_month;
    var expDateYear = exp_date_year;

    if (expDateMonth < 10) {
      expDateMonth = "0" + expDateMonth;
    }

    expDateYear = "" + exp_date_year;
    expDateYear = exp_date_year.substr(2, 2);
    var exp_date = "" + expDateMonth + expDateYear;
    var orderid = localStorage.orderId;
    var data = {
      cardHolder: payer,
      cardNo: card_no,
      expiryDate: exp_date,
      CVV2: "".concat(ccv),
      order_id: orderid,
      is_update_auto_pay_date: is_update_auto_pay_date
    };
    setIsLoading(true);
    post("api/v1/payments/add_credit_card_and_pay", data, 1, 22)
      .then(function(res) {
        if (
          res.data.response === null ||
          (res.data.response && res.data.response.errorMessage !== "")
        ) {
          window.location.href = requestParam$1.webBaseURL + "/cart4";
        } else {
          window.setTimeout(function() {
            get("api/v1/payments/get_order?order_id=".concat(orderid), 1, 23)
              .then(function(res) {
                if (res.response.status == "payment_failed") {
                  window.location.href = requestParam$1.webBaseURL + "/cart4";
                } else if (res.response.status == "created") {
                  window.location.href = requestParam$1.webBaseURL + "/cart5";
                } else if (res.response.status == "confirmed_order") {
                  window.location.href = "/cart3?order_id=".concat(orderid);
                }
              })
              ["catch"](function(err) {});
          }, 10000);
        }
      })
      ["catch"](function(err) {
        window.location.href = requestParam$1.webBaseURL + "/cart4";
      });
  };

  var generateExpYears = function generateExpYears() {
    var date = new Date();
    var y = date.getFullYear();
    return /*#__PURE__*/ React.createElement(
      React.Fragment,
      null,
      /*#__PURE__*/ React.createElement(
        "option",
        {
          value: "",
          disabled: true,
          selected: true
        },
        "\u5E74/Year"
      ),
      new Array(11).fill(0).map(function(_, addedYear) {
        return /*#__PURE__*/ React.createElement(
          "option",
          {
            key: addedYear,
            value: y + addedYear
          },
          y + addedYear
        );
      })
    );
  };

  var openCCVHelp = function openCCVHelp() {
    setCcv_help_on(true);
  };

  var closeCCVHelp = function closeCCVHelp() {
    setCcv_help_on(false);
  };

  var togglePI = function togglePI() {
    setPi_notes_on(!pi_notes_on);
  };

  var toggleSA = function toggleSA() {
    setSa_notes_on(!sa_notes_on);
  };

  useEffect(function() {
    var query = queryString.parse(window.location.search);
    var orderRef = query.order_ref;
    var url = "";

    if (orderRef) {
      url = "api/v1/payments/get_order_by_order_ref?order_ref=".concat(
        orderRef
      );
    } else {
      var orderid = localStorage.orderId;
      url = "api/v1/payments/get_order?order_id=".concat(orderid);
    }

    get(url, 1, 23)
      .then(function(res) {
        var total_trunc = Math.trunc(res.response.payment_total);
        setContact_number(res.response.contact_number);
        setEmail(res.response.email);
        setPayment_total(total_trunc);

        if (orderRef) {
          localStorage.setItem("orderId", res.response.id);
          setIs_update_auto_pay_date(true);
        }
      })
      ["catch"](function(err) {});
  }, []);
  var cart1 = formatMessage({
    id: "cart.cart1"
  });
  var cart2 = formatMessage({
    id: "cart.cart2"
  });
  var cart3 = formatMessage({
    id: "cart.cart3"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "page payment-page"
    },
    /*#__PURE__*/ React.createElement(Header, null),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "containers cart"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "mg cart2",
          style: {
            paddingLeft: 5,
            paddingRight: 5
          }
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "topheader"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "li active"
            },
            /*#__PURE__*/ React.createElement("span", null, "1"),
            /*#__PURE__*/ React.createElement("i", null, cart1)
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "li active"
            },
            /*#__PURE__*/ React.createElement("span", null, "2"),
            /*#__PURE__*/ React.createElement("i", null, cart2)
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "li active"
            },
            /*#__PURE__*/ React.createElement("span", null, "3"),
            /*#__PURE__*/ React.createElement("i", null, cart3)
          )
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "main-wrap"
          },
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "title"
            },
            cart3
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "form"
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "form-top"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "left-side"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "span",
                    {
                      className: "label-heading"
                    },
                    "\u4FE1\u7528\u5361\u985E\u5225/Card Type:"
                  ),
                  /*#__PURE__*/ React.createElement(
                    "span",
                    {
                      className: "field-content"
                    },
                    /*#__PURE__*/ React.createElement("img", {
                      className: "card-logos",
                      src: HONYANG_CARD_TYPES,
                      alt: "Visa Mastercard JCB logos"
                    })
                  )
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "label",
                    null,
                    /*#__PURE__*/ React.createElement("input", {
                      type: "radio",
                      id: "payment-type",
                      name: "payment-type",
                      value: "credit-card-type",
                      checked: true,
                      disabled: true
                    }),
                    "\u4FE1\u7528\u5361/Credit Card"
                  )
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "label-heading"
                    },
                    /*#__PURE__*/ React.createElement(
                      "span",
                      {
                        className: "compulsory"
                      },
                      "* "
                    ),
                    "\u4ED8\u6B3E\u4EBA/Payer:"
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    null,
                    /*#__PURE__*/ React.createElement("input", {
                      id: "payer",
                      type: "text",
                      className: "single-text",
                      onInput: function onInput(e) {
                        return setPayer(e.target.value);
                      },
                      value: payer,
                      maxLength: "25"
                    })
                  )
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "label-heading"
                    },
                    /*#__PURE__*/ React.createElement(
                      "span",
                      {
                        className: "compulsory"
                      },
                      "* "
                    ),
                    "\u4FE1\u7528\u5361\u5361\u865F/Card No.:"
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "flex-holder"
                    },
                    /*#__PURE__*/ React.createElement("input", {
                      id: "card-no-1",
                      type: "text",
                      onInput: function onInput(e) {
                        return setCard_no_1(e.target.value);
                      },
                      value: card_no_1,
                      maxLength: "4"
                    }),
                    /*#__PURE__*/ React.createElement("input", {
                      id: "card-no-2",
                      type: "text",
                      onInput: function onInput(e) {
                        return setCard_no_2(e.target.value);
                      },
                      value: card_no_2,
                      maxLength: "4"
                    }),
                    /*#__PURE__*/ React.createElement("input", {
                      id: "card-no-3",
                      type: "text",
                      onInput: function onInput(e) {
                        return setCard_no_3(e.target.value);
                      },
                      value: card_no_3,
                      maxLength: "4"
                    }),
                    /*#__PURE__*/ React.createElement("input", {
                      id: "card-no-4",
                      type: "text",
                      onInput: function onInput(e) {
                        return setCard_no_4(e.target.value);
                      },
                      value: card_no_4,
                      maxLength: "4"
                    })
                  )
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "label-heading"
                    },
                    /*#__PURE__*/ React.createElement(
                      "span",
                      {
                        className: "compulsory"
                      },
                      "* "
                    ),
                    "\u6709\u6548\u671F\u9650/Expiration Date:"
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "flex-holder"
                    },
                    /*#__PURE__*/ React.createElement(
                      "select",
                      {
                        onChange: function onChange(e) {
                          return setExp_date_month(e.target.value);
                        }
                      },
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "",
                          disabled: true,
                          selected: true
                        },
                        "\u6708/Month"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "1"
                        },
                        "1"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "2"
                        },
                        "2"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "3"
                        },
                        "3"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "4"
                        },
                        "4"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "5"
                        },
                        "5"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "6"
                        },
                        "6"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "7"
                        },
                        "7"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "8"
                        },
                        "8"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "9"
                        },
                        "9"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "10"
                        },
                        "10"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "11"
                        },
                        "11"
                      ),
                      /*#__PURE__*/ React.createElement(
                        "option",
                        {
                          value: "12"
                        },
                        "12"
                      )
                    ),
                    /*#__PURE__*/ React.createElement(
                      "select",
                      {
                        onChange: function onChange(e) {
                          return setExp_date_year(e.target.value);
                        }
                      },
                      generateExpYears()
                    )
                  )
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "label-heading"
                    },
                    /*#__PURE__*/ React.createElement(
                      "span",
                      {
                        className: "compulsory"
                      },
                      "* "
                    ),
                    "\u5B89\u5168\u78BC/Security Code:"
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    null,
                    /*#__PURE__*/ React.createElement("input", {
                      id: "ccv",
                      type: "text",
                      className: "single-text ccv",
                      onInput: function onInput(e) {
                        return setCcv(e.target.value);
                      },
                      value: ccv,
                      maxLength: "3"
                    }),
                    /*#__PURE__*/ React.createElement(
                      "span",
                      {
                        className: "field-content"
                      },
                      /*#__PURE__*/ React.createElement("img", {
                        className: "ccv-help",
                        onClick: openCCVHelp,
                        src: CCV_HELP,
                        alt: "What is Security Code?"
                      })
                    )
                  )
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "right-side"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "label-heading"
                    },
                    "\u5546\u5E97\u540D\u7A31/Business Name:"
                  ),
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "filled-in-field"
                    },
                    "\u6642\u7279\u79D1\u5DE5\u4F5C\u5BA4\u6709\u9650\u516C\u53F8"
                  )
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "span",
                    {
                      className: "label-heading"
                    },
                    "\u96FB\u8A71/Mobile:"
                  ),
                  /*#__PURE__*/ React.createElement(
                    "span",
                    {
                      className: "field-content filled-in-field"
                    },
                    contact_number
                  )
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "span",
                    {
                      className: "label-heading"
                    },
                    "\u96FB\u5B50\u4FE1\u7BB1/E-mail:"
                  ),
                  /*#__PURE__*/ React.createElement(
                    "span",
                    {
                      className: "field-content filled-in-field"
                    },
                    email
                  )
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "form-row"
                  },
                  /*#__PURE__*/ React.createElement(
                    "span",
                    {
                      className: "label-heading"
                    },
                    "\u4EA4\u6613\u91D1\u984D/Amount(NT$):"
                  ),
                  /*#__PURE__*/ React.createElement(
                    "span",
                    {
                      className: "field-content filled-in-field"
                    },
                    payment_total
                  )
                )
              )
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "form-bottom"
              },
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "pi-notes-msg",
                  onClick: togglePI
                },
                "\u500B\u4EBA\u8CC7\u6599\u63D0\u4F9B\u540C\u610F\u66F8 (Notification Letter of Collection, Processing and Use of Personal Information)"
              ),
              pi_notes_on
                ? /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "pi-notes-container"
                    },
                    "(English version is available after Chinese text below.)",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7D05\u967D\u79D1\u6280\u80A1\u4EFD\u6709\u9650\u516C\u53F8(\u4E0B\u7A31\u300C\u672C\u516C\u53F8\u300D)\u70BA\u63D0\u4F9B\u60A8\u8207\u672C\u516C\u53F8\u9593\u5404\u9805\u5F80\u4F86\u4E4B\u4EA4\u6613\u6216\u670D\u52D9\u3001\u4F9D\u4E2D\u83EF\u6C11\u570B\u6CD5\u4EE4\u53CA\u672C\u516C\u53F8\u4E3B\u7BA1\u6A5F\u95DC\u6CD5\u4EE4\u898F\u5B9A\u53CA\u91D1\u878D\u76E3\u7406\u9700\u8981\uFF0C\u4F9D\u6CD5\u5B9A\u7FA9\u52D9\u3001\u4F9D\u5951\u7D04\u3001\u985E\u4F3C\u5951\u7D04\u95DC\u4FC2\u6216\u5176\u4ED6\u6CD5\u5F8B\u95DC\u4FC2\u7B49\uFF0C\u6240\u70BA\u500B\u4EBA\u8CC7\u6599\u4E4B\u8490\u96C6\u3001\u8655\u7406\u53CA\u5229\u7528\u53CA\u570B\u969B\u50B3\u8F38\uFF0C\u8332\u4F9D\u64DA\u500B\u4EBA\u8CC7\u6599\u4FDD\u8B77\u6CD5\uFF08\u4E0B\u7A31\u300C\u500B\u8CC7\u6CD5\u300D\uFF09\u53CA\u5176\u65BD\u884C\u7D30\u5247\u4E4B\u898F\u5B9A\uFF0C\u7531\u672C\u516C\u53F8\u544A\u77E5\u4E0B\u5217\u4E8B\u9805\uFF1A(\u4E00)\u8490\u96C6\u4E4B\u76EE\u7684 (\u4E8C)\u500B\u4EBA\u8CC7\u6599\u4E4B\u985E\u5225 (\u4E09)\u500B\u4EBA\u8CC7\u6599\u5229\u7528\u4E4B\u671F\u9593\u3001\u5730\u5340\u3001\u5C0D\u8C61\u53CA\u65B9\u5F0F (\u56DB)\u7576\u4E8B\u4EBA\u4F9D\u500B\u8CC7\u6CD5\u7B2C\u4E09\u689D\u898F\u5B9A\u5F97\u884C\u4F7F\u4E4B\u6B0A\u5229\u53CA\u65B9\u5F0F (\u4E94)\u7576\u4E8B\u4EBA\u5F97\u81EA\u7531\u9078\u64C7\u63D0\u4F9B\u500B\u4EBA\u8CC7\u6599\u6642\uFF0C\u4E0D\u63D0\u4F9B\u5C07\u5C0D\u5176\u6B0A\u76CA\u4E4B\u5F71\u97FF\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u6709\u95DC\u672C\u516C\u53F8\u8490\u96C6\u60A8\u500B\u4EBA\u8CC7\u6599\u4E4B\u76EE\u7684\u3001\u985E\u5225\u53CA\u500B\u4EBA\u8CC7\u6599\u5229\u7528\u4E4B\u671F\u9593\u3001\u5730\u5340\u3001\u5C0D\u8C61\u53CA\u65B9\u5F0F\u7B49\u5167\u5BB9\u5206\u8FF0\u5982\u4E0B\u3002\u4F46\u672C\u516C\u53F8\u5BE6\u969B\u8490\u96C6\u3001\u8655\u7406\u53CA\u5229\u7528\u8CC7\u6599\u4E4B\u985E\u5225\u3001\u4F7F\u7528\u76EE\u7684\u3001\u5730\u5340\u3001\u5C0D\u8C61\u53CA\u65B9\u5F0F\uFF0C\u4ECD\u4EE5\u60A8\u8207\u672C\u516C\u53F8\u5BE6\u969B\u5F80\u4F86\u4E4B\u76F8\u95DC\u696D\u52D9\u6216\u670D\u52D9\u6240\u6D89\u8005\u70BA\u6E96\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "(\u4E00)\u8490\u96C6\u76EE\u7684",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u672C\u516C\u53F8\u65BC\u8490\u96C6\u60A8\u500B\u4EBA\u8CC7\u6599\u4E4B\u7279\u5B9A\u76EE\u7684\u70BA\u300C\u5951\u7D04\u3001\u985E\u4F3C\u5951\u7D04\u6216\u5176\u4ED6\u6CD5\u5F8B\u95DC\u4FC2\u4E8B\u52D9\u300D\u3001\u300C\u6D88\u8CBB\u8005\u3001\u5BA2\u6236\u7BA1\u7406\u8207\u670D\u52D9\u300D\u3001\u300C\u5546\u696D\u8207\u6280\u8853\u8CC7\u8A0A\u300D\u3001\u300C\u8CC7\uFF08\u901A\uFF09\u8A0A\u670D\u52D9\u300D\u3001\u300C\u7DB2\u8DEF\u8CFC\u7269\u53CA\u5176\u4ED6\u96FB\u5B50\u5546\u52D9\u670D\u52D9\u300D\u3001\u300C\u8ABF\u67E5\u3001\u7D71\u8A08\u8207\u7814\u7A76\u5206\u6790\u300D\u3001\u300C\u71DF\u696D\u767B\u8A18\u9805\u76EE\u6216\u7AE0\u7A0B\u6240\u5B9A\u696D\u52D9\u6216\u5176\u4ED6\u6CD5\u4EE4\u6240\u51C6\u8A31\u4E4B\u5404\u9805\u76EE\u7684\u300D\u3001\u300C\u696D\u52D9\u6216\u71DF\u904B\u7BA1\u7406\u4E4B\u76EE\u7684(\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u5BA2\u6236\u7BA1\u7406\u3001\u7A05\u52D9\u3001\u8AEE\u8A62\u9867\u554F\u3001\u884C\u653F\u7814\u7A76\u3001\u7D71\u8A08\u8ABF\u67E5\u5206\u6790\u3001\u8CC7\u8A0A\u8207\u8CC7\u6599\u5EAB\u7BA1\u7406\u3001\u8F14\u52A9\u6027\u8207\u5F8C\u52E4\u652F\u63F4\u3001\u98A8\u96AA\u63A7\u7BA1\u3001\u57F7\u884C\u6D17\u9322\u9632\u5236\u4F5C\u696D\u53CA\u914D\u5408\u5168\u7403\u6253\u64CA\u6050\u6016\u4EFD\u5B50\u8ABF\u67E5\u7B49\u76EE\u7684\u300D\u3001\u300C\u9032\u884C\u8A8D\u8B58\u5BA2\u6236\uFF08Know Your Customers\uFF09\u4E4B\u7A0B\u5E8F\u300D\u3001\u53CA\u300C\u59D4\u8A17\u4ED6\u4EBA\u8655\u7406\u958B\u7ACB\u96FB\u5B50\u767C\u7968\u4E8B\u5B9C\u300D\uFF0C\u800C\u8490\u96C6\u3001\u8655\u7406\u3001\u5229\u7528\u53CA\u570B\u969B\u50B3\u8F38\u6D89\u53CA\u60A8\u7684\u500B\u4EBA\u8CC7\u6599\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "(\u4E8C)\u8490\u96C6\u985E\u5225",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u59D3\u540D\u3001\u51FA\u751F\u5E74\u6708\u65E5\u3001\u6027\u5225\u3001\u5730\u5740\u3001\u96FB\u8A71\u3001\u96FB\u5B50\u90F5\u4EF6\u3001\u7DB2\u8DEF\u4F4D\u5740\u3001\u4EA4\u6613\u5730\u9EDE\u3001\u4EA4\u6613\u6642\u9593\u3001\u4EA4\u6613\u5167\u5BB9\u3001\u4FE1\u7528\u5361\u865F\u78BC(\u500B\u4EBA\u8CC7\u6599\u985E\u5225\uFF1A C001\u3001C002\u3001C003\u3001C091\u3001C092\u3001C093\u3001C101\u3001C102)\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "(\u4E09)\u500B\u4EBA\u8CC7\u6599\u5229\u7528\u671F\u9593\u3001\u5730\u5340\u3001\u5C0D\u8C61\u53CA\u65B9\u5F0F",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u672C\u516C\u53F8\u4F9D\u76F8\u95DC\u6CD5\u4EE4\u6240\u5B9A(\u4F8B\u5982\u5546\u696D\u6703\u8A08\u6CD5\u7B49)\u6216\u56E0\u57F7\u884C\u696D\u52D9\u6240\u5FC5\u9808\u4E4B\u4FDD\u5B58\u671F\u9593\uFF0C\u5C07\u65BC\u672C\u516C\u53F8\u53CA\u5408\u4F5C\u5925\u4F34\u7684\u71DF\u904B\u6240\u53CA\u5730\u5340(\u542B\u4E2D\u83EF\u6C11\u570B\u5883\u5167\u53CA\u672A\u7D93\u4E3B\u7BA1\u6A5F\u95DC\u7981\u6B62\u570B\u969B\u50B3\u8F38\u7684\u5883\u5916\u5730\u5340)\u5229\u7528\u60A8\u7684\u500B\u4EBA\u8CC7\u6599\u5411\u4F60\u5BC4\u9001\u4E0A\u8FF0\u8A02\u8CFC\u7522\u54C1\u8A0A\u606F\u3001\u4ED8\u6B3E\u8CC7\u8A0A\u53CA\u6D3B\u52D5\u8CC7\u8A0A\uFF1B\u6216\u5728\u5FC5\u8981\u7684\u7BC4\u570D\u5167\u5C07\u60A8\u7684\u8CC7\u6599\u63D0\u4F9B\u4E88\u672C\u516C\u53F8\u6216\u8207\u672C\u516C\u53F8\u56E0\u696D\u52D9\u9700\u8981\u8A02\u6709\u5951\u7D04\u95DC\u4FC2\u6216\u696D\u52D9\u5F80\u4F86\u6A5F\u69CB\u6216\u4F9D\u6CD5\u6709\u6B0A\u6A5F\u95DC\u6216\u91D1\u878D\u76E3\u7406\u6A5F\u95DC\uFF1B\u5305\u542B\u672C\u516C\u53F8\u6B21\u7279\u7D04\u5546\u5E97\u3001Austreme International Limited\u3001\u767C\u5361\u9280\u884C\u3001\u6536\u55AE\u6A5F\u69CB\u3001\u5F80\u4F86\u5408\u4F5C\u5EE0\u5546\u7B49\u3002\u4EE5\u9054\u4E0A\u8FF0\u8490\u96C6\u4E4B\u76EE\u7684\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "(\u56DB)\u7576\u4E8B\u4EBA\u6B0A\u5229\u53CA\u884C\u4F7F\u65B9\u5F0F",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4F9D\u64DA\u500B\u8CC7\u6CD5\u76F8\u95DC\u898F\u5B9A\uFF0C\u60A8\u5C31\u672C\u516C\u53F8\u4FDD\u6709\u4E4B\u500B\u4EBA\u8CC7\u6599\u5F97\u884C\u4F7F\u4E0B\u5217\u6B0A\u5229\uFF1A",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1\u3001\u9664\u6709\u500B\u8CC7\u6CD5\u7B2C\u5341\u689D\u6240\u898F\u5B9A\u4E4B\u4F8B\u5916\u60C5\u5F62\u5916\uFF0C\u5F97\u5411\u672C\u516C\u53F8\u67E5\u8A62\u3001\u8ACB\u6C42\u95B1\u89BD\u6216\u8ACB\u6C42\u88FD\u7D66\u8907\u88FD\u672C\uFF0C\u60DF\u672C\u516C\u53F8\u4F9D\u500B\u8CC7\u6CD5\u7B2C\u5341\u56DB\u689D\u898F\u5B9A\u5F97\u914C\u6536\u5FC5\u8981\u6210\u672C\u8CBB\u7528\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2\u3001\u5F97\u5411\u672C\u516C\u53F8\u8ACB\u6C42\u88DC\u5145\u6216\u66F4\u6B63\uFF0C\u60DF\u4F9D\u500B\u8CC7\u6CD5\u65BD\u884C\u7D30\u5247\u7B2C\u5341\u4E5D\u689D\u898F\u5B9A\uFF0C\u60A8\u61C9\u9069\u7576\u91CB\u660E\u5176\u539F\u56E0\u53CA\u4E8B\u5BE6\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3\u3001\u672C\u516C\u53F8\u5982\u6709\u9055\u53CD\u500B\u8CC7\u6CD5\u898F\u5B9A\u8490\u96C6\u3001\u8655\u7406\u6216\u5229\u7528\u500B\u4EBA\u8CC7\u6599\uFF0C\u4F9D\u500B\u8CC7\u6CD5\u7B2C\u5341\u4E00\u689D\u7B2C\u56DB\u9805\u898F\u5B9A\uFF0C\u60A8\u5F97\u5411\u672C\u516C\u53F8\u8ACB\u6C42\u505C\u6B62\u8490\u96C6\u3001\u8655\u7406\u6216\u5229\u7528\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "4\u3001\u4F9D\u500B\u8CC7\u6CD5\u7B2C\u5341\u4E00\u689D\u7B2C\u4E8C\u9805\u898F\u5B9A\uFF0C\u500B\u4EBA\u8CC7\u6599\u6B63\u78BA\u6027\u6709\u722D\u8B70\u8005\uFF0C\u5F97\u5411\u672C\u516C\u53F8\u8ACB\u6C42\u505C\u6B62\u8655\u7406\u6216\u5229\u7528\u500B\u4EBA\u8CC7\u6599\u3002\u60DF\u4F9D\u8A72\u9805\u4F46\u66F8\u898F\u5B9A\uFF0C\u672C\u516C\u53F8\u56E0\u57F7\u884C\u696D\u52D9\u6240\u5FC5\u9808\u4E26\u8A3B\u660E\u5176\u722D\u8B70\u6216\u7D93\u60A8\u66F8\u9762\u540C\u610F\u8005\uFF0C\u4E0D\u5728\u6B64\u9650\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "5\u3001\u4F9D\u500B\u8CC7\u6CD5\u7B2C\u5341\u4E00\u689D\u7B2C\u4E09\u9805\u898F\u5B9A\uFF0C\u500B\u4EBA\u8CC7\u6599\u8490\u96C6\u4E4B\u7279\u5B9A\u76EE\u7684\u6D88\u5931\u6216\u671F\u9650\u5C46\u6EFF\u6642\uFF0C\u5F97\u5411\u672C\u516C\u53F8\u8ACB\u6C42\u522A\u9664\u3001\u505C\u6B62\u8655\u7406\u6216\u5229\u7528\u500B\u4EBA\u8CC7\u6599\u3002\u60DF\u4F9D\u8A72\u9805\u4F46\u66F8\u898F\u5B9A\uFF0C\u672C\u516C\u53F8\u56E0\u57F7\u884C\u696D\u52D9\u6240\u5FC5\u9808\u6216\u7D93\u60A8\u66F8\u9762\u540C\u610F\u8005\uFF0C\u4E0D\u5728\u6B64\u9650\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u82E5\u60A8\u64EC\u884C\u4F7F\u4E0A\u8FF0\u4EFB\u4E00\u6B0A\u5229\uFF0C\u8ACB\u6AA2\u9644\u76F8\u95DC\u8B49\u660E\u6587\u4EF6\u5411\u672C\u516C\u53F8\u5BA2\u670D\u4FE1\u7BB1(service@esafe.com.tw)\u63D0\u51FA\u8ACB\u6C42\uFF0C\u672C\u516C\u53F8\u5C31\u8A72\u66F8\u9762\u8ACB\u6C42\u4E4B\u6C7A\u5B9A\uFF0C\u5C07\u65BC\u6536\u5230\u66F8\u9762\u8ACB\u6C42\u4E4B\u6B21\u65E5\u8D7715\u65E5\u5167\u4EE5\u66F8\u9762\u901A\u77E5\u7533\u8ACB\u4EBA\u3002\u524D\u8FF015\u65E5\u671F\u9593\u65BC\u5FC5\u8981\u6642\uFF0C\u5F97\u4E88\u518D\u5EF6\u957715\u65E5\uFF0C\u672C\u516C\u53F8\u4E26\u5C07\u4EE5\u66F8\u9762\u901A\u77E5\u7533\u8ACB\u4EBA\u3002\u5982\u4FC2\u8ACB\u6C42\u67E5\u8A62\u6216\u95B1\u89BD\u6587\u4EF6\uFF0C\u7533\u8ACB\u4EBA\u61C9\u65BC\u6536\u53D7\u672C\u516C\u53F8\u901A\u77E5\u5F8C\uFF0C\u65BC\u901A\u77E5\u6307\u5B9A\u4E4B\u671F\u9593\u5167\uFF0C\u81F3\u672C\u516C\u53F8\u901A\u77E5\u51FD\u6307\u5B9A\u4E4B\u5730\u9EDE\u67E5\u8A62\u6216\u95B1\u89BD\u3002\u5982\u7533\u8ACB\u4EBA\u903E\u671F\u672A\u67E5\u8A62\u6216\u95B1\u89BD\u6587\u4EF6\u8005\uFF0C\u9700\u5411\u672C\u516C\u53F8\u91CD\u65B0\u63D0\u51FA\u66F8\u9762\u8ACB\u6C42\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u60A8\u5F97\u81EA\u7531\u9078\u64C7\u662F\u5426\u63D0\u4F9B\u6709\u95DC\u500B\u4EBA\u8CC7\u6599\uFF0C\u60DF\u82E5\u62D2\u7D55\u63D0\u4F9B\u76F8\u95DC\u500B\u4EBA\u8CC7\u6599\u4FC2\u672C\u516C\u53F8\u8FA6\u7406\u696D\u52D9\u5BE9\u6838\u6216\u4F5C\u696D\u6240\u9700\u4E4B\u8CC7\u6599\uFF0C\u672C\u516C\u53F8\u53EF\u80FD\u7121\u6CD5\u9032\u884C\u5FC5\u8981\u4E4B\u696D\u52D9\u5BE9\u6838\u6216\u4F5C\u696D\u800C\u7121\u6CD5\u63D0\u4F9B\u60A8\u76F8\u95DC\u670D\u52D9\uFF0C\u672C\u516C\u53F8\u6709\u6B0A\u4F9D\u5176\u5224\u65B7\u6C7A\u5B9A\u662F\u5426\u540C\u610F\u8655\u7406\u60A8\u7684\u7533\u8ACB\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u56DB\u3001\u672C\u516C\u53F8\u6709\u6B0A\u4FEE\u8A02\u672C\u540C\u610F\u66F8\uFF0C\u4E26\u65BC\u4FEE\u8A02\u5F8C\uFF0C\u5F97\u4EE5\u8A00\u8A5E\u3001\u66F8\u9762\u3001\u96FB\u8A71\u3001\u7C21\u8A0A\u3001\u96FB\u5B50\u90F5\u4EF6\u3001\u50B3\u771F\u3001\u96FB\u5B50\u6587\u4EF6\u6216\u5176\u4ED6\u8DB3\u4EE5\u4F7F\u60A8\u77E5\u6089\u6216\u53EF\u5F97\u77E5\u6089\u4E4B\u65B9\u5F0F\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u4EE5\u524D\u8FF0\u65B9\u5F0F\u544A\u77E5\u63D0\u4F9B\u8A73\u8F09\u672C\u540C\u610F\u66F8\u5167\u5BB9\u4E4B\u7DB2\u7AD9\u9023\u7D50\uFF09\uFF0C\u544A\u77E5\u4FEE\u8A02\u8981\u9EDE\u53CA\u6307\u5B9A\u7DB2\u9801\uFF0C\u5C46\u6642\uFF0C\u8ACB\u8A73\u95B1\u6307\u5B9A\u7DB2\u9801\u5167\u5BB9\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E94\u3001\u5982\u60A8\u8207\u6642\u7279\u79D1\u5DE5\u4F5C\u5BA4\u6709\u9650\u516C\u53F8 (\u6642\u7279\u79D1\u5DE5\u4F5C\u5BA4\u6709\u9650\u516C\u53F8 )\u5148\u524D\u7C3D\u8A02\u4E4B\u5951\u7D04\u6216\u6587\u4EF6\u6240\u5B9A\u8207\u500B\u4EBA\u8CC7\u6599\u4E4B\u8490\u96C6\u3001\u8655\u7406\u3001\u5229\u7528\u3001\u570B\u969B\u50B3\u8F38\u6709\u95DC\u689D\u6B3E\u8207\u672C\u540C\u610F\u66F8\u6709\u6240\u6B67\u7570\u8005\uFF0C\u4EE5\u672C\u540C\u610F\u66F8\u70BA\u6E96\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    'Red Sunrise Co., Ltd. (hereinafter referred to as "the Company") may, for the purpose of (1) processing any and all of the transactions with your (the "Client"), or providing services to the Client; (2) (i) fulfilling Company\'s legal obligations in compliance with the laws and regulations of the Republic of China, or (ii) complying with the financial supervisory requirements of the governmental authorities in the Republic of China, or (iii) based on the contractual, quasi-contractual or other legal relationship between Company and the Client, pursuant to the Personal Data Protection Act ("PDPA") and Enforcement Rules of the PDPA ("PDPA Enforcement Rules"), notify the Client of the following matters:',
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. Regarding the type of Personal Data to be collected, time period, areas and manners of use of Personal Data and entities to use Personal Data, please see the contents are as follows for details, provided however that, the actual contents regarding collection, processing and use of the Personal Data will depend on the actual businesses and services provided by Company to the Client.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(1) The specific purposes",
                    /*#__PURE__*/ React.createElement("br", null),
                    'The specific purpose of the Company to collect your personal information is for "Contract, similar contract or other legal relationship", "Consumer, customer management and service", "Business and technical information", "Internet shopping and other e-commerce services", "the business or operational management (including but not limited to customer management, tax administration, consulting and advisory services, administrative research, statistical investigation and analysis, information and database management, logistics support, risk control and management, money laundering prevention operations, compliance with the global goal to fight crime and conduct investigation, etc.), conducting "know your customers", "outsourced issuing electronic invoice matters to third parties" and collection, processing, use and international transmission of your personal information.',
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "(2) The collection categories",
                    /*#__PURE__*/ React.createElement("br", null),
                    "Name, date of birth, gender, address, telephone, e-mail, internet address, place of transaction occurred, transaction time, transaction content, and credit card number (personal data category: C001, C002, C003, C091, C092, C093, C101, C102).",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "(3) Time period, areas, objects, and manners of use of Personal Data",
                    /*#__PURE__*/ React.createElement("br", null),
                    "The Company shall, in accordance with the relevant laws and regulations (such as commercial accounting laws, etc.) or the period of preservation required for the execution of the business, will be held in the territory of the Company and its partners (including the territory of the Republic of China foreign territories that are not prohibit to international transmission by the competent authority) to use your personal information to send you the order information, payment information and event information, or to provide your information to partners for the purpose of the above collection.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "(4) Each of the Client Personnel may exercise the following rights with respect to his/her information according to relevant Articles set forth in the PDPA:",
                    /*#__PURE__*/ React.createElement("br", null),
                    "A. to make any enquiries or request for review or making a duplicate copy, except for the Exceptions set forth in Article 10 of the PDPA, provided however that, Company may charge a reasonable fee in accordance with Article 14 of the PDPA;",
                    /*#__PURE__*/ React.createElement("br", null),
                    "B. to request to supplement or rectify any error, provided that the Client Personnel shall provide Company with the adequate explanations in accordance with Article19 of the PDPA Enforcement Rules;",
                    /*#__PURE__*/ React.createElement("br", null),
                    "C. to request Company to cease the collection, processing or use of Personal Data if Company violates the PDPA to collect, process and use the Personal Data in accordance with Paragraph 4 of Article 1 of the PDPA;",
                    /*#__PURE__*/ React.createElement("br", null),
                    "D. to request to cease processing or using the Personal Data if the accuracy of the Personal Data is in dispute in accordance with Paragraph 2 of Article 11 of the PDPA, provided however that, according to the proviso of the same Paragraph, Company may not proceed with the cessation request if the Personal Data is required for the performance of the Company's business operation and such dispute is recorded or the written consent is obtained / from the Client Personnel; and",
                    /*#__PURE__*/ React.createElement("br", null),
                    "E. to request to delete or cease processing or using the Personal Data if the specific purpose no longer exists or time period expires in accordance with Paragraph 3 of Article 11 of the PDPA, provided however that, according to the proviso of the same Paragraph, Company may not proceed with the deletion or cessation request if such Personal Data is required for the performance of the Company's business operation or the written consent is obtained from the Client Personnel.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    '2. To exercise any of the aforementioned rights, the applicant for any above request ("Applicant") should provide Company with a email request (email address: service@esafe.com.tw) together with the relevant supporting documents. Company will, within 15 days from the next day of receiving the written request, send to such Applicant a written notice informing Company determination. Such 15-day period may be extended for another 15 days when necessary, and Company will notify the Applicant of the extension in writing. In the case of request for making an inquiry or review documents, the Applicant should, after receiving a notice from Company in response to such request, visit the location designated by Company in the notice within the time limit specified by Company. The Applicant should submit a new request if he/she fails to make an inquiry or review of the Personal Data within the specified time limit.',
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. Client are free to choose whether to provide the relevant personal information, but if the refusal to provide relevant personal information is the company for business audit or operation of the necessary information, the company may not be able to carry out the necessary business audit or operation and cannot provide you with services, Have the right to decide whether or not to agree to your application.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "4. The Company has the right to amend this Notification Letter at any time, and notify the Client and Client Personnel of the amendments orally, in writing, or by telephone, text messaging, e-mail, facsimile, electronic documents, or other methods that may give the data subject direct or constructive notice (including but not limited to notification made via the aforementioned method to provide a website for reference to the contents of this Notification Letter). Please refer to such website so provided then.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "5. In the event of any inconsistency between this Notification Letter and any consent to collect, process, use, and internationally transmit Personal Data given by the Client or the Client personnel under any agreements or documents previously executed between the Client and \u6642\u7279\u79D1\u5DE5\u4F5C\u5BA4\u6709\u9650\u516C\u53F8 (\u6642\u7279\u79D1\u5DE5\u4F5C\u5BA4\u6709\u9650\u516C\u53F8 ), this Notification Letter shall prevail.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null)
                  )
                : null,
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "sa-notes-msg",
                  onClick: toggleSA
                },
                "\u7D05\u967D\u79D1\u6280\u7DB2\u8DEF\u4EE3\u7406\u6536\u4ED8\u670D\u52D9\u5951\u7D04 (SunTech Online Payment Processing Service Agreement)"
              ),
              sa_notes_on
                ? /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "sa-notes-container"
                    },
                    "(English version is available after Chinese text below.)",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E00\u689D \u95DC\u65BC\u300C\u7D05\u967D\u79D1\u6280\u300D",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u672C\u7DB2\u8DEF\u4EE3\u7406\u6536\u4ED8\u670D\u52D9\u4FC2\u7531\u7D05\u967D\u79D1\u6280\u80A1\u4EFD\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7C21\u7A31\u672C\u516C\u53F8\uFF09\u5411\u8CB7\uFF08\u5E97\uFF09\u5BB6\u63D0\u4F9B\u7684\u7CFB\u7D71\u670D\u52D9\u5E73\u53F0\u66A8\u4EE3\u6536\u8F49\u4ED8\u7684\u670D\u52D9\uFF08\u4EE5\u4E0B\u7C21\u7A31\u672C\u670D\u52D9\uFF09\u3002\u70BA\u4E86\u4FDD\u969C\u8CB7\uFF08\u5E97\uFF09\u5BB6\u7684\u6B0A\u76CA\uFF0C\u8ACB\u65BC\u8A3B\u518A\uFF08\u5982\u6709\uFF09\u53CA\u4F7F\u7528\u672C\u670D\u52D9\u524D\uFF0C\u8A73\u7D30\u95B1\u8B80\u4E86\u672C\u670D\u52D9\u689D\u6B3E\u6240\u6709\u5167\u5BB9\u3002\u7576\u4F7F\u7528\u672C\u670D\u52D9\u6642\uFF0C\u5373\u8868\u793A\u8CB7\uFF08\u5E97\uFF09\u5BB6\u5DF2\u95B1\u8B80\u3001\u7406\u89E3\u4E26\u540C\u610F\u63A5\u53D7\u672C\u670D\u52D9\u6240\u5B9A\u4E4B\u6240\u6709\u5167\u5BB9\u3002\u82E5\u8CB7\uFF08\u5E97\uFF09\u5BB6\u672A\u6EFF\u4E8C\u5341\u6B72\uFF0C\u4E26\u61C9\u65BC\u8CB7\uFF08\u5E97\uFF09\u5BB6\u7684\u6CD5\u5B9A\u4EE3\u7406\u4EBA\u95B1\u8B80\u3001\u77AD\u89E3\u4E14\u540C\u610F\u672C\u670D\u52D9\u689D\u6B3E\u4E4B\u6240\u6709\u5167\u5BB9\u5F8C\uFF0C\u65B9\u5F97\u4F7F\u7528\u672C\u670D\u52D9\u3002\u4F46\u82E5\u8CB7\uFF08\u5E97\uFF09\u5BB6\u5DF2\u63A5\u53D7\u672C\u670D\u52D9\uFF0C\u5373\u8996\u70BA\u5DF2\u53D6\u5F97\u6CD5\u5B9A\u4EE3\u7406\u4EBA\u4E4B\u540C\u610F\uFF0C\u4E26\u61C9\u9075\u5B88\u4EE5\u4E0B\u6240\u6709\u898F\u7BC4\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u5982\u8CB7\uFF08\u5E97\uFF09\u5BB6\u6240\u5C6C\u7684\u570B\u5BB6\u6216\u5730\u5340\u6392\u9664\u672C\u670D\u52D9\u689D\u6B3E\u5167\u5BB9\u4E4B\u5168\u90E8\u6216\u90E8\u5206\uFF0C\u5247\u61C9\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u672C\u670D\u52D9\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u516C\u53F8\u4EE3\u8868\u4EBA\uFF1A\u5289\u5B87\u7530\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u56DB\u3001\u5BA2\u670D\u4FE1\u7BB1\uFF1Aservice@esafe.com.tw\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E94\u3001\u5BA2\u670D\u96FB\u8A71\uFF1A02-2502-6969",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u516D\u3001\u516C\u53F8\u7DB2\u5740\uFF1Ahttps://www.esafe.com.tw",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E03\u3001\u670D\u52D9\u6642\u9593\uFF1A\u9031\u4E00\u81F3\u9031\u4E94\uFF0C9:30~18:30",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u516B\u3001\u71DF\u696D\u5730\u5740\uFF1A\u53F0\u5317\u5E02\u4E2D\u5C71\u5340\u677E\u6C5F\u8DEF207\u865F9\u6A13\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E8C\u689D \u4EE5\u96FB\u5B50\u6587\u4EF6\u70BA\u8868\u793A\u65B9\u6CD5",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u672C\u516C\u53F8\u8207\u8CB7\uFF08\u5E97\uFF09\u5BB6\u9593\u4EE5\u96FB\u5B50\u6587\u4EF6\u70BA\u8868\u793A\u65B9\u6CD5\u6642\uFF0C\u4F9D\u672C\u670D\u52D9\u689D\u6B3E\u4EA4\u63DB\u4E4B\u96FB\u5B50\u6587\u4EF6\uFF0C\u5982\u5176\u5167\u5BB9\u53EF\u5B8C\u6574\u5448\u73FE\u4E14\u53EF\u65BC\u65E5\u5F8C\u53D6\u51FA\u4F9B\u67E5\u9A57\u8005\uFF0C\u5176\u6548\u529B\u8207\u66F8\u9762\u6587\u4EF6\u76F8\u540C\u3002\u4F46\u4F9D\u6CD5\u4EE4\u6216\u884C\u653F\u6A5F\u95DC\u4E4B\u516C\u544A\u6392\u9664\u9069\u7528\u8005\uFF0C\u4E0D\u5728\u6B64\u9650\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E09\u689D \u8CB7\u5BB6\u53CA\u5E97\u5BB6\u5E33\u865F\u3001\u5BC6\u78BC\u53CA\u5B89\u5168\uFF08\u5982\u6709\uFF09",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u8CB7\uFF08\u5E97\uFF09\u5BB6\u77AD\u89E3\u4E26\u540C\u610F\uFF0C\u78BA\u4FDD\u5BC6\u78BC\u53CA\u5E33\u865F\u7684\u6A5F\u5BC6\u5B89\u5168\u662F\u81EA\u8EAB\u7684\u8CAC\u4EFB\u3002\u8CB7\uFF08\u5E97\uFF09\u5BB6\u5C07\u5C0D\u5229\u7528\u8A72\u5BC6\u78BC\u3001\u5E33\u865F\u6240\u9032\u884C\u7684\u4E00\u5207\u884C\u70BA\u53CA\u8A00\u8AD6\uFF0C\u8CA0\u9069\u7576\u7684\u7FA9\u52D9\uFF0C\u4E26\u540C\u610F\u4EE5\u4E0B\u4E8B\u9805\uFF1A",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u540C\u610F\u59A5\u5584\u4FDD\u7BA1\u5E33\u865F\u3001\u5BC6\u78BC\u53CA\u6216\u4EFB\u4F55\u500B\u4EBA\u8CC7\u6599\u3002\u5728\u8CB7\uFF08\u5E97\uFF09\u5BB6\u5B8C\u6210\u8CFC\u7269\u6216\u8CFC\u7269\u7B49\u7A0B\u5E8F\u5F8C\uFF0C\u61C9\u63A1\u53D6\u767B\u51FA\u5E33\u6236\u7684\u52D5\u4F5C\uFF0C\u5C24\u5176\u662F\u8CB7\uFF08\u5E97\uFF09\u5BB6\u662F\u8207\u4ED6\u4EBA\u5171\u7528\u96FB\u8166\u6216\u4F7F\u7528\u516C\u5171\u96FB\u8166\uFF0C\u52D9\u5FC5\u8981\u95DC\u9589\u700F\u89BD\u5668\u8996\u7A97\uFF0C\u4EE5\u9632\u6B62\u4ED6\u4EBA\u8B80\u53D6\u8CB7\uFF08\u5E97\uFF09\u5BB6\u4FE1\u4EF6\u6216\u5176\u4ED6\u500B\u4EBA\u8CC7\u6599\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u540C\u610F\u65BC\u767C\u73FE\u6709\u7B2C\u4E09\u4EBA\u5192\u7528\u6216\u76DC\u7528\u5E33\u865F\u53CA\u5BC6\u78BC\uFF0C\u6216\u5176\u4ED6\u4EFB\u4F55\u672A\u7D93\u5408\u6CD5\u6388\u6B0A\u4E4B\u60C5\u5F62\uFF0C\u61C9\u5373\u523B\u901A\u77E5\u672C\u516C\u53F8\uFF0C\u540C\u610F\u66AB\u505C\u5176\u4F7F\u7528\u672C\u670D\u52D9\u4E26\u63A1\u53D6\u9632\u7BC4\u4E4B\u63AA\u65BD\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u56DB\u689D \u8CB7\u5BB6\u53CA\u5E97\u5BB6\u7684\u5B88\u6CD5\u7FA9\u52D9\u53CA\u627F\u8AFE",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u627F\u8AFE\u7D55\u4E0D\u70BA\u4EFB\u4F55\u975E\u6CD5\u76EE\u7684\u6216\u4EE5\u4EFB\u4F55\u975E\u6CD5\u65B9\u5F0F\u4F7F\u7528\u672C\u670D\u52D9\uFF0C\u4E5F\u4E0D\u5C07\u672C\u670D\u52D9\u7528\u65BC\u7981\u6B62\u6216\u9650\u5236\u7269\u54C1\u7684\u4EA4\u6613\uFF0C\u4E26\u627F\u8AFE\u9075\u5B88\u4E2D\u83EF\u6C11\u570B\u76F8\u95DC\u6CD5\u5F8B\u3001\u6CD5\u898F\u53CA\u4E00\u5207\u4F7F\u7528\u7DB2\u969B\u7DB2\u8DEF\u4E4B\u570B\u969B\u6163\u4F8B\u3002\u8CB7\uFF08\u5E97\uFF09\u5BB6\u82E5\u4FC2\u4E2D\u83EF\u6C11\u570B\u4EE5\u5916\u4E4B\u4F7F\u7528\u8005\uFF0C\u8CB7\uFF08\u5E97\uFF09\u5BB6\u540C\u610F\u540C\u6642\u9075\u5B88\u6240\u5C6C\u570B\u5BB6\u6216\u5730\u57DF\u4E4B\u6CD5\u4EE4\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u540C\u610F\u4E26\u4FDD\u8B49\u4E0D\u5F97\u5229\u7528\u672C\u670D\u52D9\u5F9E\u4E8B\u4FB5\u5BB3\u4ED6\u4EBA\u6B0A\u76CA\u6216\u9055\u6CD5\u4E4B\u884C\u70BA\uFF0C\u82E5\u6709\u9055\u53CD\u8005\u61C9\u8CA0\u6240\u6709\u6CD5\u5F8B\u8CAC\u4EFB\uFF0C\u5305\u542B\u4F46\u4E0D\u9650\u65BC\uFF1A",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E00\uFF09\u4FB5\u5BB3\u4ED6\u4EBA\u540D\u8B7D\u3001\u96B1\u79C1\u6B0A\u3001\u5546\u696D\u79D8\u5BC6\u3001\u5546\u6A19\u6B0A\u3001\u8457\u4F5C\u6B0A\u3001\u5C08\u5229\u6B0A\u3001\u5176\u4ED6\u667A\u6167\u8CA1\u7522\u6B0A\u53CA\u5176\u4ED6\u6B0A\u5229\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E8C\uFF09\u9055\u53CD\u4F9D\u6CD5\u5F8B\u6216\u689D\u6B3E\u6240\u61C9\u8CA0\u4E4B\u4FDD\u5BC6\u7FA9\u52D9\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E09\uFF09\u5192\u7528\u4ED6\u4EBA\u540D\u7FA9\u4F7F\u7528\u672C\u670D\u52D9\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u56DB\uFF09\u5F9E\u4E8B\u4EFB\u4F55\u4E0D\u6CD5\u4EA4\u6613\u884C\u70BA\uFF0C\u5982\u6D17\u9322\u7B49\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E94\uFF09\u63D0\u4F9B\u8CED\u535A\u8CC7\u8A0A\u6216\u4EE5\u4EFB\u4F55\u65B9\u5F0F\u5F15\u8A98\u4ED6\u4EBA\u53C3\u8207\u8CED\u535A\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u516D\uFF09\u4F7F\u7528\u7121\u6548\u4FE1\u7528\u5361\u865F\u78BC\uFF0C\u6216\u975E\u4F7F\u7528\u8005\u672C\u4EBA\u7684\u4FE1\u7528\u5361\u865F\u78BC\u9032\u884C\u4EA4\u6613\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E03\uFF09\u4F7F\u7528\u4ED6\u4EBA\u9280\u884C\u5E33\u865F\u6216\u7121\u6548\u9280\u884C\u5E33\u865F\u4EA4\u6613\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u516B\uFF09\u5229\u7528\u672C\u670D\u52D9\u9032\u884C\u7121\u771F\u5BE6\u4EA4\u6613\u80CC\u666F\u7684\u865B\u5047\u4EA4\u6613\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E5D\uFF09\u5F9E\u4E8B\u4EFB\u4F55\u53EF\u80FD\u542B\u6709\u96FB\u8166\u75C5\u6BD2\u6216\u662F\u53EF\u80FD\u4FB5\u5BB3\u672C\u670D\u52D9\u7CFB\u7D71\u3001\u8CC7\u6599\u4E4B\u884C\u70BA\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u5341\uFF09\u5176\u4ED6\u672C\u516C\u53F8\u6709\u6B63\u7576\u7406\u7531\u8A8D\u70BA\u4E0D\u9069\u7576\u4E4B\u884C\u70BA\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u5E97\u5BB6\u4F7F\u7528\u672C\u670D\u52D9\u6642\uFF0C\u61C9\u4F9D\u672C\u516C\u53F8\u53CA\u767C\u5361\u9280\u884C\u898F\u5B9A\u8CA0\u8CAC\u6AA2\u67E5\u4FE1\u7528\u5361\u771F\u507D\u53CA\u6838\u5C0D\u8CB7\u5BB6\u6301\u5361\u4EBA\u8EAB\u5206\uFF1B\u5E97\u5BB6\u81EA\u767C\u5361\u9280\u884C\u6240\u53D6\u5F97\u4E4B\u6388\u6B0A\u78BC\uFF0C\u50C5\u70BA\u767C\u5361\u9280\u884C\u6240\u63D0\u4F9B\u4FE1\u7528\u5361\u865F\u78BC\u4E4B\u6709\u6548\u6027\u4E4B\u5224\u5225\uFF0C\u4E26\u975E\u5C0D\u65BC\u4FE1\u7528\u5361\u771F\u507D\u6216\u6301\u5361\u4EBA\u8EAB\u5206\u4E4B\u5224\u5225\uFF0C\u4EA6\u4E0D\u4EE3\u8868\u5E97\u5BB6\u5DF2\u5B8C\u6210\u5C0D\u8CB7\u5BB6\u61C9\u5C65\u884C\u4E4B\u50B5\u52D9\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u56DB\u3001\u5E97\u5BB6\u7D93\u7531\u672C\u670D\u52D9\u63A5\u53D7\u5176\u4EA4\u6613\u76F8\u5C0D\u4EBA\u4EE5\u4FE1\u7528\u5361\u7DDA\u4E0A\u5237\u5361\u65B9\u5F0F\u652F\u4ED8\u4EA4\u6613\u6B3E\u9805\u6642\uFF0C\u5E97\u5BB6\u8207\u5176\u4EA4\u6613\u76F8\u5C0D\u4EBA\u9593\u4E4B\u6574\u7B46\u4EA4\u6613\u91D1\u984D\uFF0C\u9808\u4E00\u6B21\u53D6\u5F97\u6388\u6B0A\u53CA\u8ACB\u6B3E\uFF0C\u5E97\u5BB6\u4E0D\u5F97\u5C07\u5176\u4EA4\u6613\u6524\u5206\u4F5C\u5169\u7B46\u6216\u591A\u7B46\u91D1\u984D\u9032\u884C\u5206\u5237\u4EA4\u6613\u6216\u500B\u5225\u53D6\u5F97\u4EA4\u6613\u6388\u6B0A\u865F\u78BC\uFF0C\u4E14\u5E97\u5BB6\u64D4\u4FDD\u4E0D\u5F97\u5229\u7528\u672C\u670D\u52D9\u5F9E\u4E8B\u4EFB\u4F55\u975E\u6CD5\u4EA4\u6613\u3001\u975E\u5BE6\u969B\u6D88\u8CBB\u4E4B\u7C3D\u5E33\u3001\u878D\u8CC7\u6027\u588A\u4ED8\u73FE\u6B3E\uFF08\u4FD7\u7A31\u8ABF\u73FE\uFF09\u6216\u5176\u4ED6\u8B8A\u76F8\u4E4B\u878D\u8CC7\u7B49\u4EA4\u6613\u3001\u6216\u6D89\u53CA\u7121\u5BE6\u8CEA\u4EA4\u6613\u57FA\u790E\u4E4B\u8CC7\u91D1\u50B3\u8F38\uFF0C\u4EA6\u4E0D\u5F97\u5F9E\u4E8B\u4EE3\u5176\u4EA4\u6613\u76F8\u5C0D\u4EBA\u5148\u884C\u588A\u6B3E\u7E73\u4EA4\u76F8\u95DC\u8CBB\u7528\u518D\u900F\u904E\u672C\u516C\u53F8\u5411\u767C\u5361\u6A5F\u69CB\u8ACB\u6B3E\u4E4B\u884C\u70BA\u3002\u5E97\u5BB6\u9055\u53CD\u672C\u9805\u7D04\u5B9A\u8005\uFF0C\u672C\u516C\u53F8\u5F97\u4FDD\u7559\u8A72\u7B49\u4EA4\u6613\u6B3E\u9805\uFF0C\u5982\u8A72\u7B49\u4EA4\u6613\u6B3E\u9805\u5DF2\u64A5\u4ED8\u4E88\u5E97\u5BB6\uFF0C\u5E97\u5BB6\u61C9\u8FD4\u9084\u4E88\u672C\u516C\u53F8\uFF0C\u672C\u516C\u53F8\u4E26\u5F97\u81EA\u5E97\u5BB6\u65BC\u672C\u670D\u52D9\u4E4B\u5E33\u6236\u5167\u6263\u9084\u76F8\u7576\u65BC\u8A72\u7B49\u4EA4\u6613\u91D1\u984D\u4E4B\u6B3E\u9805\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E94\u689D \u5C0D\u300C\u6703\u54E1\u300D\u670D\u52D9\u7684\u4F7F\u7528",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u300C\u8CB7\uFF08\u5E97\uFF09\u5BB6\u6703\u54E1\u300D\u670D\u52D9\u8AAA\u660E",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E00\uFF09\u4E00\u65E6\u8CB7\uFF08\u5E97\uFF09\u5BB6\u8A3B\u518A\u6210\u70BA\u672C\u516C\u53F8\u5BA2\u6236\uFF0C\u672C\u516C\u53F8\u5C07\u4EE3\u7406\u8CB7\u5BB6\u5728\u8CB7\u5BB6\u6216\u5E97\u5BB6\u7B26\u5408\u6307\u5B9A\u689D\u4EF6\u6216\u72C0\u614B\u6642\uFF0C\u652F\u4ED8\u6B3E\u9805\u7D66\u5E97\u5BB6\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E8C\uFF09\u8CB7\uFF08\u5E97\uFF09\u5BB6\u5728\u4F7F\u7528\u672C\u670D\u52D9\u904E\u7A0B\u4E2D\uFF0C\u756B\u9762\u4E0A\u51FA\u73FE\u7684\u95DC\u65BC\u4EA4\u6613\u64CD\u4F5C\u7684\u63D0\u793A\u662F\u8CB7\uFF08\u5E97\uFF09\u5BB6\u6703\u54E1\u4EA4\u6613\u7684\u898F\u5247\uFF0C\u8CB7\uFF08\u5E97\uFF09\u5BB6\u5C0D\u65BC\u4EA4\u6613\u904E\u7A0B\u4E2D\u4EFB\u4F55\u4E00\u500B\u9801\u9762\u7684\u78BA\u8A8D\u8868\u793A\u5C0D\u8CB7\uFF08\u5E97\uFF09\u5BB6\u6703\u54E1\u4EA4\u6613\u898F\u5247\u7684\u8A8D\u540C\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E09\uFF09\u8CB7\u5BB6\u4F7F\u7528\u672C\u670D\u52D9\u9032\u884C\u4EA4\u6613\uFF0C\u5373\u8868\u793A\u540C\u610F\u4E26\u6388\u6B0A\u672C\u516C\u53F8\u5C07\u60A8\u7D93\u906E\u7F69\u4E4B\u500B\u4EBA\u8CC7\u8A0A\u4EE5\u53CA\u4EA4\u6613\u8CC7\u8A0A\u56DE\u50B3\u901A\u77E5\u6240\u6307\u5B9A\u7684\u4EA4\u6613\u5E97\u5BB6\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u92B7\u8CA8\u9000\u6B3E\u4E4B\u8655\u7406\u6D41\u7A0B",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4EA4\u6613\u5B8C\u6210\u5F8C\uFF0C\u8CB7\u5BB6\u5982\u6B32\u9000\u8CA8\u6216\u53D6\u6D88\u8A72\u7B46\u4EA4\u6613\uFF0C\u672C\u516C\u53F8\u61C9\u5354\u52A9\u8CB7\u5BB6\u8207\u5E97\u5BB6\u6E9D\u901A\u8655\u7406\u76F8\u95DC\u9000\u8CA8\u4E8B\u9805\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u8CFC\u7269\u7CFE\u7D1B\u4E4B\u8655\u7406",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u8CB7\uFF08\u5E97\uFF09\u5BB6\u90FD\u61C9\u4FDD\u7559\u4EA4\u6613\u6191\u8B49\u7B49\u76F8\u95DC\u6587\u4EF6\uFF0C\u4EE5\u5099\u7CFE\u7D1B\u722D\u8B70\u6642\u4F9B\u67E5\u8B49\u4E4B\u7528\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u516D\u689D \u5546\u6A19\u3001\u77E5\u8B58\u7522\u6B0A\u7684\u4FDD\u8B77",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u6703\u54E1\u5E73\u53F0\u4E0A\u6240\u6709\u5167\u5BB9\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u8457\u4F5C\u3001\u5716\u7247\u3001\u6A94\u6848\u3001\u8CC7\u8A0A\u3001\u8CC7\u6599\u3001\u7DB2\u7AD9\u67B6\u69CB\u3001\u7DB2\u7AD9\u756B\u9762\u7684\u5B89\u6392\u3001\u7DB2\u9801\u8A2D\u8A08\uFF0C\u5747\u7531\u672C\u516C\u53F8\u6216\u5176\u4ED6\u6B0A\u5229\u4EBA\u4F9D\u6CD5\u64C1\u6709\u5176\u667A\u6167\u8CA1\u7522\u6B0A\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u5546\u6A19\u6B0A\u3001\u5C08\u5229\u6B0A\u3001\u8457\u4F5C\u6B0A\u3001\u5546\u696D\u79D8\u5BC6\u7B49\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u975E\u7D93\u672C\u516C\u53F8\u6216\u5176\u4ED6\u6B0A\u5229\u4EBA\u66F8\u9762\u540C\u610F\u4EFB\u4F55\u4EBA\u4E0D\u5F97\u64C5\u81EA\u4F7F\u7528\u3001\u4FEE\u6539\u3001\u8907\u88FD\u3001\u516C\u958B\u50B3\u64AD\u3001\u6539\u8B8A\u3001\u6563\u4F48\u3001\u767C\u884C\u6216\u516C\u958B\u767C\u8868\u672C\u7DB2\u7AD9\u7A0B\u5F0F\u6216\u5167\u5BB9\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u5982\u6709\u9055\u53CD\uFF0C\u8CB7\uFF08\u5E97\uFF09\u5BB6\u61C9\u5C0D\u672C\u516C\u53F8\u8CA0\u640D\u5BB3\u8CE0\u511F\u8CAC\u4EFB\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E03\u689D \u672C\u670D\u52D9\u5951\u7D04\u89E3\u91CB\u539F\u5247",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u672C\u670D\u52D9\u5951\u7D04\u689D\u6B3E\u5982\u6709\u7591\u7FA9\u6642\uFF0C\u61C9\u70BA\u6709\u5229\u8CB7\uFF08\u5E97\uFF09\u5BB6\u4E4B\u89E3\u91CB\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u516B\u689D \u672C\u670D\u52D9\u5167\u5BB9\u53CA\u8CBB\u7528",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u652F\u4ED8\u5DE5\u5177\uFF1A\u4FE1\u7528\u5361\u3001\u91D1\u878D\u5361\u3001\u8D85\u5546\u4EE3\u6536\u7B49\u670D\u52D9\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u6536\u8CBB\u9805\u76EE\uFF1A\u4EA4\u6613\u624B\u7E8C\u8CBB\u3001\u5E33\u52D9\u8655\u7406\u8CBB\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u6536\u8CBB\u65B9\u5F0F\uFF1A\u64A5\u6B3E\u4E88\u5E97\u5BB6\u6642\u5167\u6263\u624B\u7E8C\u8CBB\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u56DB\u3001\u6536\u8CBB\u6A19\u6E96\uFF1A\u4F9D\u5BE6\u969B\u4EA4\u6613\u91D1\u984D\u8A08\u6536\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E94\u3001\u6536\u8CBB\u91D1\u984D\uFF1A\u5404\u9805\u670D\u52D9\u8CBB\u4E4B\u9805\u76EE\u3001\u8A08\u7B97\u65B9\u5F0F\u53CA\u91D1\u984D\u8ACB\u53C3\u95B1\u300A\u7533\u8ACB\u8CBB\u7528\u300B\u8AAA\u660E\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u516D\u3001\u61C9\u6536\u8CBB\u4E4B\u5C0D\u8C61\uFF1A\u8207\u672C\u516C\u53F8\u7C3D\u7D04\u4E4B\u5E97\u5BB6\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E03\u3001\u652F\u4ED8\u6D41\u7A0B\uFF1A",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E00\uFF09\u4FE1\u7528\u5361\uFF1A\u8CB7\u5BB6\u81F3\u5E97\u5BB6\u7DB2\u7AD9\u9078\u8CFC\u5546\u54C1\u2192\u8CB7\u5BB6\u8F38\u5165\u4FE1\u7528\u5361\u4ED8\u6B3E\u8CC7\u8A0A\u2192\u53D6\u5F97\u8CB7\u5BB6\u767C\u5361\u9280\u884C\u4E4B\u6388\u6B0A\u78BC\u2192\u6210\u529F\u6388\u6B0A\u5F8C\u5E97\u5BB6\u51FA\u8CA8\u2192\u6536\u55AE\u9280\u884C\u64A5\u6B3E\u81F3\u672C\u516C\u53F8\u8207\u4FE1\u8A17\u9280\u884C\u7C3D\u8A02\u4FE1\u8A17\u5951\u7D04\u6240\u7D04\u5B9A\u4E4B\u4FE1\u8A17\u5C08\u6236\u2192\u4EA4\u6613\u5B8C\u6210\u5F8C8~10\u5929\u7531\u672C\u516C\u53F8\u6307\u793A\u4FE1\u8A17\u9280\u884C\u6574\u6279\u532F\u6B3E\u81F3\u5E97\u5BB6\u6307\u5B9A\u6236\u982D\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E8C\uFF09\u91D1\u878D\u5361\uFF1A\u8CB7\u5BB6\u81F3\u5E97\u5BB6\u7DB2\u7AD9\u9078\u8CFC\u5546\u54C1\u2192\u8CB7\u5BB6\u4F7F\u7528\u91D1\u878D\u5361\u8F49\u5E33\u2192\u6536\u55AE\u9280\u884C\u9032\u884C\u6263\u6B3E\u2192\u6263\u6B3E\u6210\u529F\u5F8C\u5E97\u5BB6\u51FA\u8CA8\u2192\u6536\u55AE\u9280\u884C\u64A5\u6B3E\u81F3\u672C\u516C\u53F8\u6307\u5B9A\u5C08\u6236\u2192\u4EA4\u6613\u5B8C\u6210\u5F8C\u4E8C\u5DE5\u4F5C\u65E5\u7531\u672C\u516C\u53F8\u6574\u6279\u532F\u6B3E\u81F3\u5E97\u5BB6\u6307\u5B9A\u6236\u982D\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E09\uFF09\u8D85\u5546\u4EE3\u6536\uFF1A\u8CB7\u5BB6\u81F3\u5E97\u5BB6\u7DB2\u7AD9\u9078\u8CFC\u5546\u54C1\u2192\u8CB7\u5BB6\u9078\u64C7\u8D85\u5546\u4EE3\u6536\u65B9\u5F0F\u4ED8\u6B3E\u2192\u8CB7\u5BB6\u81F3\u8D85\u5546\u4ED8\u6B3E\u2192\u4EE3\u6536\u6B3E\u6A5F\u69CB\u901A\u77E5\u672C\u516C\u53F8\u8CB7\u5BB6\u5DF2\u4ED8\u6B3E\u2192\u672C\u516C\u53F8\u5C07\u4ED8\u6B3E\u6210\u529F\u8A0A\u606F\u901A\u77E5\u5E97\u5BB6\uFF0C\u5E97\u5BB6\u51FA\u8CA8\u2192\u4EE3\u6536\u6B3E\u6A5F\u69CB\u64A5\u6B3E\u81F3\u672C\u516C\u53F8\u6307\u5B9A\u5C08\u6236\u2192\u4EA4\u6613\u5B8C\u6210\u5F8C5~25\u5929\u7531\u672C\u516C\u53F8\u6574\u6279\u532F\u6B3E\u81F3\u5E97\u5BB6\u6307\u5B9A\u6236\u982D\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u516B\u3001\u652F\u4ED8\u5E33\u6236\u6B3E\u9805\u63D0\u9818\u65B9\u5F0F\uFF1A\u4F9D\u5E97\u5BB6\u8207\u672C\u516C\u53F8\u4E4B\u7D04\u5B9A\u671F\u9593\uFF08\u5982\u4E0A\u8FF0\u652F\u4ED8\u6D41\u7A0B\u5167\u8AAA\u660E\uFF09\uFF0C\u7531\u672C\u516C\u53F8\u4E3B\u52D5\u6307\u793A\u4FE1\u8A17\u9280\u884C\u8FA6\u7406\u532F\u64A5\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E5D\u3001\u652F\u4ED8\u6B3E\u9805\u5C08\u7528\u5B58\u6B3E\u5E33\u6236\u7684\u5B58\u6B3E\u9280\u884C\uFF1A\u83EF\u6CF0\u9280\u884C\u3001\u7B2C\u4E00\u9280\u884C\u3001\u5408\u4F5C\u91D1\u5EAB\u3001\u5F70\u5316\u9280\u884C\u3001\u51F1\u57FA\u9280\u884C\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E5D\u689D \u532F\u7387\u4E4B\u8A08\u7B97",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u672C\u670D\u52D9\u8CB7\uFF08\u5E97\uFF09\u5BB6\u6240\u6709\u4EA4\u6613\u5E33\u6B3E\u5747\u61C9\u4EE5\u65B0\u81FA\u5E63\u7D50\u4ED8\uFF0C\u4E0D\u6D89\u53CA\u532F\u7387\u63DB\u7B97\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u689D \u652F\u4ED8\u6B3E\u9805\u4E4B\u4FDD\u969C",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u672C\u670D\u52D9\u652F\u4ED8\u6B3E\u9805\u5DF2\u7D93\u5206\u5225\u5168\u90E8\u5B58\u5165\u8207\u83EF\u6CF0\u9280\u884C\u3001\u7B2C\u4E00\u9280\u884C\u3001\u5408\u4F5C\u91D1\u5EAB\u3001\u5F70\u5316\u9280\u884C\u3001\u51F1\u57FA\u9280\u884C\u7C3D\u8A02\u4FE1\u8A17\u5951\u7D04\u6240\u7D04\u5B9A\u4E4B\u4FE1\u8A17\u5C08\u6236\uFF0C\u5C08\u6B3E\u5C08\u7528\u3002\u6240\u7A31\u5C08\u7528\uFF0C\u6307\u672C\u516C\u53F8\u70BA\u5C65\u884C\u7DB2\u8DEF\u4EE3\u7406\u6536\u4ED8\u670D\u52D9\u5951\u7D04\u4E4B\u7FA9\u52D9\u6240\u4F7F\u7528\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u4E00\u689D \u652F\u4ED8\u6307\u793A\u4E4B\u518D\u78BA\u8A8D\u53CA\u4E8B\u5F8C\u6838\u5C0D",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u672C\u516C\u53F8\u65BC\u652F\u4ED8\u5B8C\u6210\u524D\uFF0C\u5C31\u8CB7\u5BB6\u4E4B\u652F\u4ED8\u6307\u793A\uFF0C\u61C9\u986F\u793A\u300C\u78BA\u5B9A\u4ED8\u6B3E\u55CE?\u300D\u4E4B\u9078\u64C7\u6A5F\u5236\uFF08\u542B\u78BA\u5B9A\u6216\u53D6\u6D88\uFF09\uFF0C\u4FFE\u4F9B\u8CB7\u5BB6\u5F97\u4EE5\u518D\u78BA\u8A8D\u652F\u4ED8\u6307\u793A\u5167\u5BB9\u662F\u5426\u6B63\u78BA\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u672C\u516C\u53F8\u61C9\u65BC\u6BCF\u7B46\u6B3E\u9805\u652F\u4ED8\u5B8C\u6210\u5F8C\uFF0C\u4EE5\u96FB\u5B50\u90F5\u4EF6\u6216\u767C\u9001\u7C21\u8A0A\u4E4B\u65B9\u5F0F\u901A\u77E5\u8CB7\u5BB6\u652F\u4ED8\u660E\u7D30\uFF0C\u4FFE\u4F9B\u8CB7\u5BB6\u4E8B\u5F8C\u6838\u5C0D\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u4E8C\u689D \u652F\u4ED8\u932F\u8AA4\u4E4B\u8655\u7406",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u56E0\u4E0D\u53EF\u6B78\u8CAC\u65BC\u8CB7\u5BB6\u4E4B\u4E8B\u7531\u800C\u767C\u751F\u652F\u4ED8\u932F\u8AA4\u6642\uFF0C\u672C\u516C\u53F8\u61C9\u5354\u52A9\u8CB7\u5BB6\u66F4\u6B63\uFF0C\u4E26\u63D0\u4F9B\u5176\u4ED6\u5FC5\u8981\u4E4B\u5354\u52A9\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u56E0\u53EF\u6B78\u8CAC\u65BC\u672C\u516C\u53F8\u4E4B\u4E8B\u7531\u800C\u767C\u751F\u652F\u4ED8\u932F\u8AA4\u6642\uFF0C\u672C\u516C\u53F8\u61C9\u65BC\u77E5\u6089\u6642\uFF0C\u7ACB\u5373\u66F4\u6B63\uFF0C\u4E26\u540C\u6642\u4EE5\u96FB\u5B50\u90F5\u4EF6\u6216\u96D9\u65B9\u7D04\u5B9A\u4E4B\u65B9\u5F0F\u901A\u77E5\u8CB7\u5BB6\u53CA\u5E97\u5BB6\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u56E0\u53EF\u6B78\u8CAC\u65BC\u8CB7\u5BB6\u4E4B\u4E8B\u7531\u800C\u767C\u751F\u652F\u4ED8\u932F\u8AA4\u6642\uFF0C\u4F8B\u5982\u8CB7\u5BB6\u8F38\u5165\u932F\u8AA4\u4E4B\u91D1\u984D\u6216\u8F38\u5165\u932F\u8AA4\u4E4B\u6536\u6B3E\u65B9\uFF0C\u7D93\u8CB7\u5BB6\u901A\u77E5\u5F8C\uFF0C\u672C\u516C\u53F8\u61C9\u7ACB\u5373\u5354\u52A9\u8655\u7406\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u4E09\u689D \u8CC7\u8A0A\u5B89\u5168",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u672C\u670D\u52D9\u662F\u7D93\u7531\u4FE1\u7528\u5361\u570B\u969B\u7D44\u7E54\u898F\u5B9A\u7684PCIDSS\u8A8D\u8B49\u518D\u52A0\u4E0A\u570B\u969B\u8A8D\u8B49\u6A19\u6E96SSL\u5B89\u5168\u52A0\u5BC6\u6A5F\u5236\uFF0C\u78BA\u4FDD\u8CB7\uFF08\u5E97\uFF09\u5BB6\u7684\u4EFB\u4F55\u8CC7\u6599\u7D55\u4E0D\u5916\u6D29\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u672C\u516C\u53F8\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u61C9\u5404\u81EA\u78BA\u4FDD\u6240\u4F7F\u7528\u8CC7\u8A0A\u7CFB\u7D71\u4E4B\u5B89\u5168\uFF0C\u9632\u6B62\u975E\u6CD5\u5165\u4FB5\u3001\u53D6\u5F97\u3001\u7AC4\u6539\u3001\u6BC0\u640D\u696D\u52D9\u7D00\u9304\u6216\u8CB7\u5BB6\u4E4B\u500B\u4EBA\u8CC7\u6599\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u7B2C\u4E09\u4EBA\u7834\u89E3\u672C\u516C\u53F8\u8CC7\u8A0A\u7CFB\u7D71\u4E4B\u4FDD\u8B77\u63AA\u65BD\u6216\u5229\u7528\u8CC7\u8A0A\u7CFB\u7D71\u4E4B\u6F0F\u6D1E\u722D\u8B70\uFF0C\u7531\u672C\u516C\u53F8\u5C31\u8A72\u4E8B\u5BE6\u4E0D\u5B58\u5728\u8CA0\u8209\u8B49\u8CAC\u4EFB\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u56DB\u3001\u7B2C\u4E09\u4EBA\u5165\u4FB5\u7DB2\u8DEF\u4EE3\u7406\u6536\u4ED8\u670D\u52D9\u8CC7\u8A0A\u7CFB\u7D71\u5C0D\u8CB7\uFF08\u5E97\uFF09\u5BB6\u6240\u9020\u6210\u4E4B\u640D\u5BB3\uFF0C\u7531\u672C\u516C\u53F8\u8CA0\u64D4\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u56DB\u689D \u672C\u516C\u53F8\u4E4B\u7D42\u6B62\u5951\u7D04\u6216\u66AB\u505C\u670D\u52D9",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u672C\u516C\u53F8\u65BC\u4E0B\u5217\u60C5\u5F62\uFF0C\u5F97\u7247\u9762\u7D42\u6B62\u5951\u7D04\u6216\u66AB\u6642\u505C\u6B62\u672C\u670D\u52D9\uFF1A",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u6709\u76F8\u7576\u4E8B\u8B49\u8DB3\u8A8D\u8CB7\uFF08\u5E97\uFF09\u5BB6\u6709\u5229\u7528\u652F\u4ED8\u670D\u52D9\u70BA\u6D17\u9322\u3001\u8A50\u6B3A\u7B49\u72AF\u7F6A\u884C\u70BA\u6216\u4E0D\u6CD5\u884C\u70BA\u8005\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u652F\u4ED8\u6B3E\u9805\u7D93\u6CD5\u9662\u88C1\u5B9A\u6216\u6AA2\u5BDF\u5B98\u547D\u4EE4\u6263\u62BC\u8005\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u63D0\u4EA4\u865B\u507D\u4E4B\u8EAB\u5206\u8A8D\u8B49\u8CC7\u6599\uFF0C\u7D93\u67E5\u8B49\u5C6C\u5BE6\u8005\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u56DB\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u7531\u65BC\u4E0D\u5C65\u884C\u672C\u5408\u7D04\u898F\u5B9A\u4E4B\u7FA9\u52D9\u8005\uFF0C\u8996\u4F5C\u55AE\u65B9\u9762\u7D42\u6B62\u672C\u5408\u7D04\uFF0C\u672C\u516C\u53F8\u6709\u6B0A\u5411\u8CB7\uFF08\u5E97\uFF09\u5BB6\u8ACB\u6C42\u640D\u5BB3\u8CE0\u511F\uFF0C\u4E26\u6709\u6B0A\u7D42\u6B62\u672C\u5408\u7D04\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E94\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u672A\u914D\u5408\u7B2C\u5341\u4E5D\u689D\u7B2C\u4E09\u9805\u518D\u6B21\u9032\u884C\u8B58\u5225\u53CA\u78BA\u8A8D\u8EAB\u5206\u8005\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u4E94\u689D \u5E33\u865F\u5BC6\u78BC\u88AB\u5192\u7528\u4E4B\u8655\u7406",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u672C\u516C\u53F8\u6216\u8CB7\uFF08\u5E97\uFF09\u5BB6\u65BC\u77E5\u6089\u5E33\u865F\u5BC6\u78BC\u88AB\u5192\u7528\u6642\uFF0C\u61C9\u7ACB\u5373\u901A\u77E5\u4ED6\u65B9\u4E26\u66AB\u505C\u8A72\u5E33\u865F\u6240\u6307\u793A\u4E4B\u652F\u4ED8\u884C\u70BA\u66A8\u66AB\u505C\u8A72\u5E33\u865F\u5F8C\u7E8C\u4E4B\u652F\u4ED8\u6307\u793A\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u672C\u516C\u53F8\u61C9\u65BC\u670D\u52D9\u7DB2\u9801\u660E\u986F\u8655\u8F09\u660E\u5E33\u865F\u5BC6\u78BC\u88AB\u5192\u7528\u6642\u7684\u9023\u7D61\u96FB0509-11-2277\uFF0C\u9664\u6709\u4E0D\u53EF\u6297\u529B\u6216\u5176\u4ED6\u91CD\u5927\u4E8B\u7531\uFF0C\u901A\u77E5\u96FB\u8A71\u4E4B\u670D\u52D9\u6642\u9593\u61C9\u70BA\u5168\u65E5\uFF0824\u5C0F\u6642\uFF09\u5168\u5E74\uFF08365\u65E5\uFF09\u7121\u4F11\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u8FA6\u7406\u5E33\u865F\u5BC6\u78BC\u88AB\u5192\u7528\u624B\u7E8C\u5B8C\u6210\u5F8C\u6240\u767C\u751F\u4E4B\u640D\u5931\uFF0C\u6982\u7531\u672C\u516C\u53F8\u8CA0\u64D4\uFF1B\u5176\u8FA6\u7406\u5E33\u865F\u5BC6\u78BC\u88AB\u5192\u7528\u624B\u7E8C\u524D\u6240\u767C\u751F\u4E4B\u640D\u5931\uFF0C\u65BC\u6709\u4E0B\u5217\u60C5\u4E8B\u6642\uFF0C\u6089\u7531\u8CB7\uFF08\u5E97\uFF09\u5BB6\u8CA0\u64D4\uFF1A",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E00\uFF09\u8CB7\uFF08\u5E97\uFF09\u5BB6\u672A\u59A5\u5584\u4FDD\u7BA1\u5E33\u865F\u5BC6\u78BC\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E8C\uFF09\u8CB7\uFF08\u5E97\uFF09\u5BB6\u81EA\u884C\u5C07\u5E33\u865F\u5BC6\u78BC\u63D0\u4F9B\u8207\u4ED6\u4EBA\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E09\uFF09\u8CB7\uFF08\u5E97\uFF09\u5BB6\u672A\u4F7F\u7528\u672C\u516C\u53F8\u6240\u63D0\u4F9B\u7684\u5E33\u865F\u5B89\u5168\u6A5F\u5236\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u56DB\uFF09\u56E0\u8CB7\uFF08\u5E97\uFF09\u5BB6\u4E4B\u6545\u610F\u6216\u91CD\u5927\u904E\u5931\u6240\u81F4\u4E4B\u4E8B\u7531\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u56DB\u3001\u8ABF\u67E5\u8CB7\uFF08\u5E97\uFF09\u5BB6\u5E33\u865F\u5BC6\u78BC\u88AB\u5192\u7528\u6240\u751F\u4E4B\u8CBB\u7528\uFF0C\u7531\u672C\u516C\u53F8\u8CA0\u64D4\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E94\u3001\u672C\u516C\u53F8\u57FA\u65BC\u4FDD\u8B77\u8CB7\uFF08\u5E97\uFF09\u5BB6\u5B89\u5168\u4E4B\u7406\u7531\uFF0C\u65BC\u767C\u73FE\u6216\u63A5\u7372\u8CB7\uFF08\u5E97\uFF09\u5BB6\u901A\u77E5\u6709\u672C\u689D\u7B2C\u4E00\u9805\u60C5\u5F62\u6642\uFF0C\u7ACB\u5373\u505C\u6B62\u8A72\u5E33\u865F\u4F7F\u7528\u672C\u670D\u52D9\uFF0C\u76F4\u81F3\u8A72\u7570\u5E38\u72C0\u6CC1\u89E3\u9664\u70BA\u6B62\uFF0C\u672C\u516C\u53F8\u4E26\u5F97\u8981\u6C42\u8CB7\uFF08\u5E97\uFF09\u5BB6\u51FA\u5177\u76F8\u95DC\u6587\u4EF6\uFF08\u5305\u542B\u4F46\u4E0D\u9650\u65BC\uFF1A\u8B66\u653F\u6A5F\u95DC\u5831\u6848\u8B49\u660E\u3001\u5207\u7D50\u66F8\u3001\u8EAB\u5206\u8B49\u660E\u6587\u4EF6\u7B49\uFF09\uFF0C\u4EE5\u6062\u5FA9\u8A72\u5E33\u865F\u65BC\u672C\u670D\u52D9\u4E4B\u4F7F\u7528\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u516D\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u540C\u610F\u65BC\u4F7F\u7528\u672C\u670D\u52D9\u6642\uFF0C\u672C\u516C\u53F8\u5F97\u5C31\u4F7F\u7528\u8005\u767B\u5165\u8CC7\u8A0A\uFF08\u5305\u62EC\u7DB2\u8DEFIP\u4F4D\u7F6E\u8207\u6642\u9593\uFF09\u3001\u6240\u70BA\u4E4B\u884C\u70BA\u53CA\u5176\u4ED6\u4F9D\u6CD5\u4EE4\u61C9\u7559\u5B58\u4E4B\u7D00\u9304\u4E88\u4EE5\u8A73\u5BE6\u8A18\u9304\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u516D\u689D \u8CB7\u5BB6\u6216\u5E97\u5BB6\u4E4B\u7D42\u6B62\u5951\u7D04",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u8CB7\uFF08\u5E97\uFF09\u5BB6\u5F97\u4F9D\u96D9\u65B9\u7D04\u5B9A\u4E4B\u65B9\u5F0F\u96A8\u6642\u7D42\u6B62\u5951\u7D04\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u4E03\u689D \u5951\u7D04\u689D\u6B3E\u8B8A\u66F4",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u672C\u516C\u53F8\u5982\u6B32\u8B8A\u66F4\u5951\u7D04\u5167\u5BB9\uFF0C\u61C9\u65BC\u7DB2\u7AD9\u660E\u986F\u8655\u516C\u544A\uFF0C\u4E26\u4EE5\u96FB\u5B50\u90F5\u4EF6\u6216\u96D9\u65B9\u7D04\u5B9A\u4E4B\u65B9\u5F0F\u901A\u77E5\u8CB7\uFF08\u5E97\uFF09\u5BB6\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u672C\u516C\u53F8\u672A\u4F9D\u524D\u9805\u9032\u884C\u516C\u544A\u53CA\u901A\u77E5\u8005\uFF0C\u5176\u5951\u7D04\u4E4B\u8B8A\u66F4\u7121\u6548\u3002\u4F46\u6709\u5229\u65BC\u8CB7\uFF08\u5E97\uFF09\u5BB6\u7684\u8B8A\u66F4\u4E0D\u5728\u6B64\u9650\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u516B\u689D \u722D\u8B70\u8655\u7406",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u6D88\u8CBB\u722D\u8B70\u4E4B\u5BA2\u670D\u96FB\u8A71\uFF1A02-25026969\u53CA\u96FB\u5B50\u90F5\u4EF6\u4FE1\uFF1Aservice@esafe.com.tw\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u7533\u8A34\u3001\u722D\u8B70\u8655\u7406\u6A5F\u5236\u53CA\u7A0B\u5E8F\uFF1A\u7531\u5BA2\u670D\u53D7\u7406\u8CB7\uFF08\u5E97\uFF09\u5BB6\u722D\u8B70\u66A8\u7533\u8A34\u2192\u8CB7\uFF08\u5E97\uFF09\u5BB6\u586B\u5BEB\u300C\u7DDA\u4E0A\u5BA2\u670D\u8655\u7406\u8868\u300D\u2192\u4F9D\u8CB7\uFF08\u5E97\uFF09\u5BB6\u722D\u8B70\u66A8\u7533\u8A34\u5167\u5BB9\u6703\u8FA6\u76F8\u95DC\u55AE\u4F4D\u2192\u7D93\u8FA6\u55AE\u4F4D\u5148\u5224\u65B7\u662F\u5426\u53EF\u6B78\u8CAC\u672C\u516C\u53F8\u4E4B\u758F\u5931\u2192\u82E5\u662F\uFF0C\u5247\u4F9D\u672C\u670D\u52D9\u689D\u6B3E\u6AA2\u8A0E\u6539\u5584\u4E26\u63A1\u53D6\u88DC\u6551\u63AA\u65BD\u2192\u56DE\u8986\u5BA2\u6236\uFF1B\u82E5\u5426\uFF0C\u5247\u9015\u56DE\u8986\u5BA2\u6236\u2192\u586B\u8986\u5BA2\u670D\u4EBA\u54E1\u300C\u7DDA\u4E0A\u5BA2\u670D\u8655\u7406\u8868\u300D\u2192\u5BA2\u670D\u4EBA\u54E1\u8207\u5BA2\u6236\u78BA\u8A8D\u662F\u5426\u63A5\u53D7\uFF1F\u82E5\u63A5\u53D7\uFF0C\u4EA4\u884C\u653F\u90E8\u4E3B\u7BA1\u6838\u6C7A\u2192\u5BA2\u670D\u4EBA\u54E1\u7D50\u6848\u6B78\u6A94\uFF1B\u82E5\u4E0D\u63A5\u53D7\uFF0C\u5247\u4EA4\u56DE\u7D93\u8FA6\u55AE\u4F4D\u91CD\u65B0\u8655\u7406\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u5341\u4E5D\u689D \u8CB7\uFF08\u5E97\uFF09\u5BB6\u4E4B\u8EAB\u5206\u8A8D\u8B49",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u61C9\u78BA\u8A8D\u63D0\u4EA4\u4E4B\u8EAB\u5206\u8A8D\u8B49\u8CC7\u6599\u6B63\u78BA\u4E14\u771F\u5BE6\uFF0C\u4E0D\u5F97\u6709\u865B\u507D\u60C5\u4E8B\uFF0C\u5982\u8A72\u7B49\u8CC7\u6599\u4E8B\u5F8C\u6709\u8B8A\u66F4\uFF0C\u61C9\u7ACB\u5373\u901A\u77E5\u672C\u516C\u53F8\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u672C\u670D\u52D9\u6703\u54E1\u8EAB\u5206\u8A8D\u8B49\u6A5F\u5236\u5982\u4E0B\uFF1A",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E00\uFF09\u8CB7\u5BB6\uFF1A\u8EAB\u5206\u8A8D\u8B49\u8CC7\u6599\u586B\u59A5\u5F8C\uFF0C\u672C\u670D\u52D9\u81EA\u52D5\u5E36\u51FA\u624B\u6A5F\u865F\u78BC\u5F8C\u767C\u9001\u7C21\u8A0A\uFF0C\u8CB7\u5BB6\u5C07\u624B\u6A5F\u7C21\u8A0A\u6536\u5230\u7684\u56DB\u78BC\u9A57\u8B49\u78BC\u8F38\u5165\u81F3\u9A57\u8B49\u78BC\u6B04\u4F4D\uFF08\u903E\u5341\u5206\u9418\u5F8C\u9A57\u8B49\u78BC\u5373\u5931\u6548\uFF09\uFF0C\u7D93\u672C\u670D\u52D9\u4F3A\u670D\u5668\u5224\u65B7\u6B63\u78BA\u5F8C\u5373\u5B8C\u6210\u6703\u54E1\u8EAB\u5206\u8A8D\u8B49\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E8C\uFF09\u5E97\u5BB6\uFF1A\u8EAB\u5206\u8A8D\u8B49\u8CC7\u6599\u586B\u59A5\u5F8C\uFF0C\u5E97\u5BB6\u4EE5\u624B\u6A5F\u64A5\u8A9E\u97F3\u5C08\u7DDA\uFF0C\u7D93\u672C\u670D\u52D9\u4F3A\u670D\u5668\u5224\u65B7\u70BA\u771F\u5F8C\u5373\u5B8C\u6210\u6703\u54E1\u8EAB\u5206\u8A8D\u8B49\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u5982\u6709\u4E0B\u5217\u60C5\u5F62\u4E4B\u4E00\uFF0C\u672C\u516C\u53F8\u5F97\u8981\u6C42\u8CB7\uFF08\u5E97\uFF09\u5BB6\u518D\u6B21\u9032\u884C\u8EAB\u5206\u8A8D\u8B49\u7A0B\u5E8F\uFF1A",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E00\uFF09\u8CB7\uFF08\u5E97\uFF09\u5BB6\u7533\u8ACB\u8B8A\u66F4\u57FA\u672C\u8EAB\u5206\u8CC7\u6599\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E8C\uFF09\u8CB7\uFF08\u5E97\uFF09\u5BB6\u63D0\u4F9B\u4E4B\u8EAB\u5206\u8B49\u660E\u6587\u4EF6\u6216\u767B\u8A18\u8B49\u7167\u7B49\u76F8\u95DC\u6587\u4EF6\u7591\u4F3C\u507D\u9020\u6216\u8B8A\u9020\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E09\uFF09\u8CB7\uFF08\u5E97\uFF09\u5BB6\u4EA4\u6613\u6642\u8DDD\u524D\u6B21\u4EA4\u6613\u5DF2\u903E\u534A\u5E74\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u56DB\uFF09\u540C\u4E00\u884C\u52D5\u96FB\u8A71\u865F\u78BC\u3001\u96FB\u5B50\u90F5\u4EF6\u4FE1\u7BB1\u7B49\u906D\u4E0D\u540C\u8CB7\uFF08\u5E97\uFF09\u5BB6\u7528\u65BC\u8EAB\u5206\u78BA\u8A8D\u7A0B\u5E8F\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E94\uFF09\u767C\u73FE\u7591\u4F3C\u6D17\u9322\u6216\u8CC7\u52A9\u6050\u6016\u4E3B\u7FA9\u4EA4\u6613\uFF0C\u6216\u81EA\u6D17\u9322\u6216\u8CC7\u52A9\u6050\u6016\u4E3B\u7FA9\u9AD8\u98A8\u96AA\u570B\u5BB6\u6216\u5730\u5340\u532F\u5165\u6B3E\u9805\u4E4B\u4EA4\u6613\u6642\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u516D\uFF09\u5C0D\u65BC\u6240\u53D6\u5F97\u8CB7\uFF08\u5E97\uFF09\u5BB6\u8EAB\u5206\u8CC7\u6599\u4E4B\u771F\u5BE6\u6027\u6216\u59A5\u9069\u6027\u6709\u6240\u61F7\u7591\u6642\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E8C\u5341\u689D \u6D17\u9322\u9632\u5236\u53CA\u6253\u64CA\u8CC7\u52A9\u6050\u6016\u4E3B\u7FA9",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u672C\u516C\u53F8\u70BA\u9632\u5236\u6D17\u9322\u53CA\u6253\u64CA\u8CC7\u52A9\u6050\u6016\u4E3B\u7FA9\u4E4B\u76EE\u7684\uFF0C\u8CB7\uFF08\u5E97\uFF09\u5BB6\u540C\u610F\u672C\u516C\u53F8\u5F97\u4F9D\u300C\u6D17\u9322\u9632\u5236\u6CD5\u300D\u3001\u300C\u4E2D\u83EF\u6C11\u570B\u9280\u884C\u516C\u6703\u9280\u884C\u9632\u5236\u6D17\u9322\u53CA\u6253\u64CA\u8CC7\u52A9\u6050\u6016\u4E3B\u7FA9\u6CE8\u610F\u4E8B\u9805\u7BC4\u672C\u300D\u4E4B\u898F\u5B9A\uFF0C\u9032\u884C\u4EE5\u4E0B\u63AA\u65BD\uFF0C\u672C\u516C\u53F8\u4F9D\u672C\u689D\u8FA6\u7406\u82E5\u81F4\u8CB7\uFF08\u5E97\uFF09\u5BB6\u767C\u751F\u640D\u5BB3\u6216\u627F\u53D7\u4E0D\u5229\u76CA\u8005\uFF0C\u5747\u7531\u8CB7\uFF08\u5E97\uFF09\u5BB6\u81EA\u884C\u627F\u64D4\uFF0C\u672C\u516C\u53F8\u4E0D\u8CA0\u640D\u5BB3\u8CE0\u511F\u8CAC\u4EFB\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E00\uFF09\u672C\u516C\u53F8\u65BC\u767C\u73FE\u8CB7\uFF08\u5E97\uFF09\u5BB6\u53CA\u95DC\u806F\u4EBA\u70BA\u53D7\u7D93\u6FDF\u5236\u88C1\u3001\u5916\u570B\u653F\u5E9C\u6216\u570B\u969B\u6D17\u9322\u9632\u5236\u7D44\u7E54\u8A8D\u5B9A\u6216\u8FFD\u67E5\u4E4B\u6050\u6016\u5206\u5B50\u6216\u5718\u9AD4\u8005\u4E4B\u6642\uFF0C\u5F97\u9015\u884C\u66AB\u6642\u505C\u6B62\u672C\u670D\u52D9\u4E4B\u5168\u90E8\u6216\u4E00\u90E8\u800C\u7121\u9808\u53E6\u901A\u77E5\u8CB7\uFF08\u5E97\uFF09\u5BB6\u53CA\u95DC\u806F\u4EBA\uFF1B\u672C\u516C\u53F8\u4E26\u5F97\u4EE5\u96FB\u5B50\u90F5\u4EF6\u6216\u96D9\u65B9\u7D04\u5B9A\u4E4B\u65B9\u5F0F\u901A\u77E5\u8CB7\uFF08\u5E97\uFF09\u5BB6\u7D42\u6B62\u672C\u670D\u52D9\u689D\u6B3E\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E8C\uFF09\u672C\u516C\u53F8\u65BC\u5B9A\u671F\u6216\u4E0D\u5B9A\u671F\u5BE9\u67E5\u8CB7\uFF08\u5E97\uFF09\u5BB6\u53CA\u95DC\u806F\u4EBA\u8EAB\u5206\u4F5C\u696D\u6216\u8A8D\u70BA\u5FC5\u8981\u6642\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\uFF1A\u61F7\u7591\u8CB7\uFF08\u5E97\uFF09\u5BB6\u6D89\u53CA\u975E\u6CD5\u6D3B\u52D5\u3001\u7591\u4F3C\u6D17\u9322\u3001\u8CC7\u52A9\u6050\u6016\u4E3B\u7FA9\u6D3B\u52D5\u3001\u6216\u5A92\u9AD4\u5831\u5C0E\u6D89\u53CA\u9055\u6CD5\u4E4B\u7279\u6B8A\u6848\u4EF6\u7B49\uFF09\uFF0C\u5F97\u8981\u6C42\u8CB7\uFF08\u5E97\uFF09\u5BB6\u65BC\u63A5\u7372\u672C\u516C\u53F8\u901A\u77E5\u5F8C60\u5929\uFF08\u542B\uFF09\u5167\u63D0\u4F9B\u5BE9\u67E5\u6240\u9700\u4E4B\u5FC5\u8981\u500B\u4EBA\uFF08\u542B\u4F7F\u7528\u8005\u53CA\u95DC\u806F\u4EBA\uFF09\u6216\u516C\u53F8\u8CC7\u6599\u3001\u6CD5\u4EBA\u6236\u4E4B\u5BE6\u969B\u53D7\u76CA\u4EBA\u6216\u5C0D\u5176\u884C\u4F7F\u63A7\u5236\u6B0A\u4E4B\u4EBA\u7684\u8CC7\u8A0A\u6216\u5C0D\u4EA4\u6613\u6027\u8CEA\u8207\u76EE\u7684\u6216\u8CC7\u91D1\u4F86\u6E90\u9032\u884C\u8AAA\u660E\uFF0C\u8CB7\uFF08\u5E97\uFF09\u5BB6\u903E\u671F\u4ECD\u4E0D\u5C65\u884C\u8005\uFF0C\u672C\u516C\u53F8\u5F97\u4EE5\u96FB\u5B50\u90F5\u4EF6\u6216\u96D9\u65B9\u7D04\u5B9A\u4E4B\u65B9\u5F0F\u901A\u77E5\u66AB\u6642\u505C\u6B62\u672C\u670D\u52D9\u4E4B\u5168\u90E8\u6216\u4E00\u90E8\u3001\u6216\u7D42\u6B62\u672C\u670D\u52D9\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E8C\u5341\u4E00\u689D \u8CE0\u511F\u8CAC\u4EFB",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\uFF08\u5E97\uFF09\u5BB6\u4F7F\u7528\u672C\u516C\u53F8\u91D1\u6D41\u670D\u52D9\u6642\uFF0C\u61C9\u4F9D\u64DA\u8207\u6D88\u8CBB\u8005\u4E4B\u7D04\u5B9A\u78BA\u5BE6\u5C65\u884C\u7FA9\u52D9\u3002\u5982\uFF08\u5E97\uFF09\u5BB6\u51FA\u65BC\u4EFB\u4F55\u539F\u56E0\u8207\u6D88\u8CBB\u8005\u767C\u751F\u7CFE\u7D1B\u81F4\u6D88\u8CBB\u8005\u5411\u767C\u5361\u9280\u884C\u6216\u6536\u55AE\u6A5F\u69CB\u8ACB\u6C42\u62D2\u4ED8\u6216\u7D22\u56DE\u5176\u5411\u672C\u516C\u53F8\u652F\u4ED8\u7684\u5168\u90E8\u6216\u90E8\u5206\u6B3E\u9805\u6642\uFF0C\u65BC\u767C\u5361\u9280\u884C\u62D2\u4ED8\u6216\u5C0D\u672C\u516C\u53F8\u5F37\u5236\u6263\u6B3E\u6642\uFF0C\uFF08\u5E97\uFF09\u5BB6\u540C\u610F\u7121\u689D\u4EF6\u6388\u6B0A\u672C\u516C\u53F8\u4F9D\u5BE6\u969B\u60C5\u5F62\u5148\u884C\u8CE0\u511F\u6216\u88DC\u511F\u6D88\u8CBB\u8005\u3001\u767C\u5361\u9280\u884C\u6216\u6536\u55AE\u6A5F\u69CB\u4E4B\u640D\u5931\u6216\u640D\u5BB3\uFF0C\uFF08\u5E97\uFF09\u5BB6\u4E26\u540C\u610F\u65BC\u672C\u516C\u53F8\u70BA\u524D\u63ED\u8CE0\u511F\u6216\u88DC\u511F\u5F8C\uFF0C\u61C9\u7121\u689D\u4EF6\u8CE0\u511F\u6216\u88DC\u511F\u672C\u516C\u53F8\u56E0\u6B64\u6240\u751F\u4E4B\u4E00\u5207\u640D\u5931\u6216\u640D\u5BB3\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u8CE0\u511F\u3001\u88DC\u511F\u4E4B\u91D1\u984D\u3001\u9000\u9084\u4E4B\u6B3E\u9805\u3001\u5229\u606F\u3001\u5F8B\u5E2B\u8CBB\u53CA\u5176\u4ED6\u56E0\u8A34\u8A1F\u6216\u975E\u8A34\u8A1F\u6240\u652F\u51FA\u4E4B\u8CBB\u7528\u7B49\uFF09\uFF0C\u9019\u4E9B\u60C5\u6CC1\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u4E0B\u8FF0\u60C5\u7BC0\uFF1A",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E00\uFF09\uFF08\u5E97\uFF09\u5BB6\u6C92\u80FD\u63D0\u4F9B\u670D\u52D9\u6216\u6240\u63D0\u4F9B\u7684\u670D\u52D9\u8207\u6D88\u8CBB\u8005\u8A02\u8CFC\u660E\u7D30\u4E0D\u7B26\u6216\u62D2\u7D55\u9000\u8CA8\uFF1B",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E8C\uFF09\uFF08\u5E97\uFF09\u5BB6\u672A\u80FD\u63D0\u4F9B\u4EA4\u6613\u5C0D\u61C9\u7684\u6D88\u8CBB\u8005\u6D88\u8CBB\u7D00\u9304\u6216\u76F8\u95DC\u8B49\u64DA\uFF1B",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\uFF08\u4E09\uFF09\u7531\u65BC\uFF08\u5E97\uFF09\u5BB6\u539F\u56E0\u5C0E\u81F4\u4EA4\u6613\u4E0D\u5408\u6CD5\u6216\u4E0D\u53EF\u57F7\u884C\uFF1B",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\uFF08\u5E97\uFF09\u5BB6\u672A\u4F9D\u672C\u5408\u7D04\u7D04\u5B9A\u8655\u7406\u5E33\u6B3E\uFF0C\u81F4\u672C\u516C\u53F8\u6216\u6536\u55AE\u6A5F\u69CB\u6216\u767C\u5361\u9280\u884C\u6240\u53D7\u640D\u5BB3\uFF0C\uFF08\u5E97\uFF09\u5BB6\u61C9\u8CA0\u8CE0\u511F\u4E4B\u8CAC\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u5F8B\u5E2B\u8CBB\u53CA\u5176\u4ED6\u8A34\u8A1F\u6216\u975E\u8A34\u8A1F\u6240\u751F\u4E4B\u8CBB\u7528\uFF09\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\uFF08\u5E97\uFF09\u5BB6\u4F9D\u672C\u689D\u524D\u4E09\u9805\u898F\u5B9A\u800C\u61C9\u8CA0\u8CE0\u511F\u4E4B\u8CAC\u6642\uFF0C\uFF08\u5E97\uFF09\u5BB6\u7121\u689D\u4EF6\u540C\u610F\u4E26\u6388\u6B0A\u672C\u516C\u53F8\u65BC\u7576\u671F\u6216\u672A\u4F86\u61C9\u7D66\u4ED8\uFF08\u5E97\uFF09\u5BB6\u4E4B\u8CA8\u6B3E\u4E2D\u9015\u884C\u6263\u62B5\uFF0C\u4E0D\u8DB3\u90E8\u5206\u4E26\u540C\u610F\u4EE5\uFF08\u5E97\uFF09\u5BB6\u4EA4\u4ED8\u4E4B\u4FDD\u8B49\u91D1\u4F5C\u70BA\u6263\u62B5\u4F7F\u7528\uFF08\u5982\u6709\uFF09\uFF0C\u6263\u62B5\u5F8C\u4ECD\u6709\u5DEE\u984D\u8005\uFF0C\uFF08\u5E97\uFF09\u5BB6\u61C9\u65BC\u672C\u516C\u53F8\u901A\u77E5\u4E4B\u65E5\u8D77\u4E09\u500B\u65E5\u66C6\u5929\u5167\uFF0C\u4EE5\u532F\u6B3E\u6216\u73FE\u91D1\u65B9\u5F0F\u652F\u4ED8\u672C\u516C\u53F8\u8A72\u5DEE\u984D\u3002\u82E5\u9055\u53CD\u524D\u63ED\u898F\u5B9A\u8005\uFF0C\uFF08\u5E97\uFF09\u5BB6\u6240\u7A4D\u6B20\u4E4B\u6B3E\u9805\uFF0C\u672C\u516C\u53F8\u5F97\u52A0\u8A08\u81EA\u901A\u77E5\u65E5\u8D77\u81F3\u6E05\u511F\u65E5\u6B62\uFF0C\u6309\u5E74\u5229\u7387\u767E\u5206\u4E4B\u5341\u8A08\u7B97\u4E4B\u5229\u606F\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E8C\u5341\u4E8C\u689D \u6E96\u64DA\u6CD5\u53CA\u7BA1\u8F44\u6CD5\u9662",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u672C\u670D\u52D9\u4E4B\u722D\u8B70\u61C9\u4EE5\u4E2D\u83EF\u6C11\u570B\u6CD5\u5F8B\u70BA\u6E96\u64DA\u6CD5\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u56E0\u672C\u670D\u52D9\u6240\u751F\u4E4B\u4E00\u5207\u722D\u8B70\uFF0C\u7ACB\u7D04\u4EBA\u540C\u610F\u672C\u8AA0\u4FE1\u539F\u5247\u5354\u8B70\u89E3\u6C7A\u4E4B\uFF1B\u5982\u6709\u8A34\u8A1F\u4E4B\u5FC5\u8981\u6642\uFF0C\u9664\u6CD5\u5F8B\u53E6\u6709\u898F\u5B9A\u5916\uFF0C\u8CB7\uFF08\u5E97\uFF09\u5BB6\u540C\u610F\u4EE5\u81FA\u7063\u81FA\u5317\u5730\u65B9\u6CD5\u9662\u70BA\u7B2C\u4E00\u5BE9\u7BA1\u8F44\u6CD5\u9662\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u7B2C\u4E8C\u5341\u4E09\u689D \u5176\u4ED6\u7D04\u5B9A\u4E8B\u9805",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E00\u3001\u672C\u670D\u52D9\u4EE3\u6536\u6B3E\u9805\uFF0C\u4E00\u5F8B\u50C5\u5F97\u64A5\u4ED8\u81F3\u8CB7\uFF08\u5E97\uFF09\u5BB6\u672C\u4EBA\u6301\u6709\u4E14\u5DF2\u7D93\u8A8D\u8B49\u4E4B\u91D1\u878D\u6A5F\u69CB\u5BE6\u9AD4\u5B58\u6B3E\u5E33\u6236\u3002\u8CB7\uFF08\u5E97\uFF09\u5BB6\u4E0D\u5F97\u56E0\u8A72\u5E33\u6236\u56E0\u6545\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u65BC\u906D\u51CD\u7D50\u3001\u8A2D\u70BA\u8B66\u793A\u5E33\u6236\u7B49\u4E8B\u7531\uFF09\uFF0C\u800C\u4E3B\u5F35\u672C\u516C\u53F8\u61C9\u5C07\u6B3E\u9805\u64A5\u4ED8\u81F3\u5176\u4ED6\u672A\u7D93\u8A8D\u8B49\u4E4B\u5E33\u6236\u4E2D\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E8C\u3001\u8CB7\uFF08\u5E97\uFF09\u5BB6\u540C\u610F\u672C\u516C\u53F8\u63D0\u4F9B\u5404\u9805\u696D\u52D9\u3001\u5546\u54C1\u6216\u670D\u52D9\u76F8\u95DC\u8A0A\u606F\uFF0C\u53CA\u5BC4\u9001\u5404\u9805\u696D\u52D9\u4E4B\u6D88\u8CBB\u3001\u884C\u92B7\u6216\u512A\u60E0\u6D3B\u52D5\u8A0A\u606F\uFF1B\u5982\u8CB7\uFF08\u5E97\uFF09\u5BB6\u4EE5\u66F8\u9762\u660E\u793A\u62D2\u7D55\u540C\u610F\uFF0C\u672C\u516C\u53F8\u5373\u61C9\u505C\u6B62\u63D0\u4F9B\u524D\u8FF0\u5404\u9805\u8A0A\u606F\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E09\u3001\u672C\u670D\u52D9\u4E4B\u5E97\u5BB6\u5747\u6709\u4EA4\u6613\u9650\u984D\u53CA\u984D\u5EA6\u9650\u5236\uFF0C\u672C\u516C\u53F8\u4FDD\u6709\u4F9D\u64DA\u5E97\u5BB6\u4E4B\u76F8\u95DC\u8CA1\u529B\u60C5\u5F62\u53CA\u6AA2\u9644\u6587\u4EF6\u8ABF\u6574\u5404\u9805\u9650\u5236\u4E4B\u6B0A\u5229\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u56DB\u3001\u5E97\u5BB6\u61C9\u96A8\u6642\u6CE8\u610F\u5176\u65BC\u672C\u670D\u52D9\u4E4B\u6536\u6B3E\u984D\u5EA6\u72C0\u6CC1\uFF0C\u82E5\u6709\u8F03\u9AD8\u6536\u6B3E\u984D\u5EA6\u9700\u6C42\u6642\uFF0C\u9808\u53E6\u5411\u672C\u516C\u53F8\u63D0\u51FA\u7533\u8ACB\uFF0C\u60DF\u5E97\u5BB6\u5C0D\u672C\u516C\u53F8\u6240\u8A02\u4E4B\u6536\u6B3E\u984D\u5EA6\u4E0A\u9650\u4E0D\u5F97\u7570\u8B70\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u4E94\u3001\u5E97\u5BB6\u50C5\u80FD\u65BC\u6536\u6B3E\u984D\u5EA6\u5167\u9032\u884C\u6536\u6B3E\uFF0C\u82E5\u56E0\u5DF2\u9054\u6536\u6B3E\u984D\u5EA6\u4E0A\u9650\u4E14\u672A\u4E8B\u5148\u5411\u672C\u516C\u53F8\u63D0\u51FA\u7533\u8ACB\u8ABF\u9AD8\u6536\u6B3E\u984D\u5EA6\uFF0C\u5C07\u7121\u6CD5\u518D\u9032\u884C\u6536\u6B3E\uFF0C\u6545\u5E97\u5BB6\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u7406\u7531\u5411\u672C\u516C\u53F8\u63D0\u51FA\u56E0\u6B64\u9020\u6210\u5176\u6536\u5165\u6E1B\u640D\u3001\u71DF\u696D\u640D\u5931\u53CA\u8ACB\u6C42\u640D\u5BB3\u8CE0\u511F\u4E4B\u4E3B\u5F35\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    "\u516D\u3001\u8CB7\u5BB6\u82E5\u56E0\u5DF2\u9054\u4ED8\u6B3E\u984D\u5EA6\u4E0A\u9650\u800C\u7121\u6CD5\u9032\u884C\u4ED8\u6B3E\uFF0C\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u7406\u7531\u5411\u672C\u516C\u53F8\u63D0\u51FA\u56E0\u6B64\u9020\u6210\u5176\u8CB7\u8CE3\u3001\u6D88\u8CBB\u4E4B\u4E0D\u4FBF\u5229\u3001\u6216\u8CB7\u8CE3\u96D9\u65B9\u4E4B\u7CFE\u7D1B\u7B49\u4E3B\u5F35\u3002",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 1 About SunTech",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. These online payment-processing services are the system service platform and payment forwarding services (hereinafter referred to as the \"Services\") provided by SunTech Co., Ltd. (hereinafter referred to as the \"Company\") to the buyer (vendor). To protect the buyer's (vendor's) interest, please read all the service terms and conditions hereunder carefully. The buyer's (vendor's) use of the Services shall constitute the buyer's (vendor's) reading, understanding and acceptance of all terms and conditions of the Services. For any buyer (vendor) below the age of 20, these Services shall only be used after the buyer's (vendor's) legal representative have read, understood and agreed to all terms and conditions of the Services. However, the buyer's (vendor's) acceptance of the Services shall constitute the consent of its legal representative and the buyer (vendor) shall comply with all terms and conditions below.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. If the buyer's (vendor's) country or territory excludes the terms and condition the Services in whole or in part, such buyer (vendor) shall immediately stop the use of the Services.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. The Company's legal representative: Liu, Yu-Tian.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "4. Customer service email address: service@esafe.com.tw.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "5. Customer Service Hotline: 02-2502-6969.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "6. Official website: https://www.esafe.com.tw",
                    /*#__PURE__*/ React.createElement("br", null),
                    "7. Service Hours: Monday through Friday, 9:30 - 18:30.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "8. Business location: 9F, No. 207, Songjian Road, Zhongshan District, Taipei City",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 2 Electronic Documents",
                    /*#__PURE__*/ React.createElement("br", null),
                    "When the Company exchanges an electronic document with a buyer (vendor) in accordance with the terms and conditions of the Services and if the provisions of the document can be displayed in a complete manner and are available for future verifications, such document shall have the same effect as a written document, unless it is excluded by law or any public announcement by an administrative authority.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 3 Buyer and Vendor Account, Password and Security (if any)",
                    /*#__PURE__*/ React.createElement("br", null),
                    "The buyer (vendor) understands and agrees to be solely liable for the confidentiality and security of its password and account. The buyer (vendor) shall be duly obliged for all conducts and statements through use of such password and account. The buyer (vendor) also agrees to the following:",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. The buyer (vendor) agrees to maintain the account, password or any personal information in a proper manner. After the buyer (vendor) completes shopping or shopping procedures, it shall log out of the account, particularly when the buyer (vendor) shares a computer with any other person or uses a public computer. Make sure that the browser window is closed to prevent others from reading the buyer's (vendor's) correspondence or other personal information.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. The buyer (vendor) agrees to give immediate notice to the Company upon discovery of any third party fraudulent use or theft of its account, password or any other event without legal authorization. The buyer (vendor) agrees to suspend its use of the Services and shall undertake precautionary measures.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 4 Buyer and Vendor's Obligation and Undertaking about Compliance with Law",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. The buyer (vendor) undertakes to never use the Services for any illegal purposes or in any illegal manner, nor shall the Services be used to trade any contraband or restricted object. The buyer (vendor) also undertakes to comply with applicable laws and regulations of the Republic of China, as well as international practice for Internet use. If the buyer (vendor) is a user outside the Republic of China, the buyer (vendor) also agrees to comply with the laws of its country or territory.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. The buyer (vendor) agrees and warrants not using the Services to engage in any act that jeopardizes any other person's interest or in any illegal act. In case of any breach, the buyer (vendor) shall bear all legal liabilities, including but not limited to:",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(1) Infringement against any other person's goodwill, privacy, trade secret, trademark, copyright, patent, other intellectual property rights or other rights.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(2) Breach of any confidentiality obligation by law or provision.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(3) Fraudulent use of any other person's name to use the Services.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(4) Engagement of any unlawful transaction, such as money laundering.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(5) Provision of any gambling information or enticing any other person to participate in gambling in any manner.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(6) Transaction through use of any invalid credit card number or the credit card number of any other person.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(7) Transaction through use of any other person's bank account or any invalid bank account.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(8) Engagement of false transactions without genuine transaction backgrounds through the use of these Services.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(9) Engagement of any conduct that may include a computer virus or that may jeopardize the system or data of the Services.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(10) Any other conduct deemed improper by the Company with justification.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. In using these Services, the vendor is responsible for verifying the genuineness of the credit card and the identity of the buyer/cardholder in accordance with the regulations of the Company and the card-issuing bank. The authorization code acquired by the vendor from the card issuing bank only represents a verification by the card issuing bank about the validity of the credit card number and does not serve as a verification about the genuineness of the credit card or the identity of the cardholder and thus shall not release the vendor of its obligation to the buyer.",
                    /*#__PURE__*/ React.createElement("br", null),
                    '4. When a vendor accepts an online credit card payment by the transaction counterparty through the Services, an authorization and payment claim shall be acquired for the entire transaction amount between the vendor and the transaction counterparty. The vendor shall not divide any single transaction into two or more amounts to achieve multiple transactions or individual transaction authorization codes. The vendor also warrants that the Services shall not be used to engage in any unlawful transaction, credit card transaction without actual consumption, financing cash advance ("cash-out"), any other financing transaction or any fund transmission without underlying transaction, nor shall the vendor advance any funds to the transaction counterparty for payment, followed by payment claim against the card issuer through the Company. In case of any breaches by the vendor, the Company may withhold the transaction amount. If the transaction amount has been released to the vendor, the vendor shall return the amount to the Company. The Company may also debit an amount equivalent to the transaction amount from the vendor\'s account under the Services.',
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    'Article 5 Use of "Member" Services',
                    /*#__PURE__*/ React.createElement("br", null),
                    '1. "Buyer (Vendor) Member" Services',
                    /*#__PURE__*/ React.createElement("br", null),
                    "(1) Once the buyer (vendor) registers as a client to the Company, the Company shall make payments to the vendor on behalf of the buyer when the buyer or the vendor meets the designated conditions or status.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(2) When the buyer (vendor) uses the Services, the instructions related to transaction operations displayed on the screen represent the buyer (vendor) member transaction rules. The buyer's (vendor's) confirmation on any single page in the course of a transaction shall be deemed the buyer's (vendor's) agreement to the member transaction rules.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(3) The buyer's engagement of a transaction through use of the Services shall be deemed its agreement and authorization to the Company to transmit your personal information that has been blinded and the transaction data to the designated transaction vendor.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. Cancellation and Refund Procedure",
                    /*#__PURE__*/ React.createElement("br", null),
                    "If the buyer wishes to return the product or cancel the transaction after the transaction has been completed, the Company shall assist the buyer and the vendor to communicate and process relevant return matters.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. Shopping Disputes",
                    /*#__PURE__*/ React.createElement("br", null),
                    "Both the buyer and the vendor shall maintain relevant documents such as proof of transactions for verification in case of a dispute.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 6 Protection of Trademark and Intellectual Property Rights",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. The intellectual property rights to all contents on the buyer (vendor) member platform, including but not limited to written work, pictures, files, data, information, website structure, webpage arrangements, webpage design belongs to the Company or other rights holders in accordance with the law, including but not limited to trademark, patent, copyright and trade secrets.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. No one shall use, adapt, reproduce, publicly broadcast, disseminate, alter, issue or publish any program or content of the website without the written consent of the company or any other right holder.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. In case of any breach, the buyer (vendor) shall be liable for compensating the Company.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 7 Rules of Interpretation of This Service Agreement",
                    /*#__PURE__*/ React.createElement("br", null),
                    "In case of any ambiguities, the contract terms and conditions of the Services shall be interpreted to the buyer's (vendor's) favor.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 8 Scope of Services and Fees",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. Payment Tools: Credit card, debit card and convenience store payment services.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. Fee Items: Transaction processing fee, account management fee.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. Fee Payment: Processing fee is debited from payment to the vendor.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "4. Fee Schedule: Based on the actual transaction amount.",
                    /*#__PURE__*/ React.createElement("br", null),
                    '5. Fee Amount: For the items, calculation method and amount of different service fees please refer to "Application Fees".',
                    /*#__PURE__*/ React.createElement("br", null),
                    "6. Payers: Vendors that have signed contracts with the Company.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "7. Payment Procedure:",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(1) Credit Card: Buyer selects product from the vendor's website \u2192 Buyer keys in credit card payment information \u2192 Acquire authorization code from the buyer's card issuing bank \u2192 Successful authorization, followed by the vendor's shipping \u2192 Bank remits funds to the trust account designated under the trust agreement signed by the Company and the trust bank \u2192 The Company instructs the trust bank to make batch remittance to the vendor's designated account 8 to 10 days after transactions are completed.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(2) Debit Card: Buyer selects product from the vendor's website \u2192 Buyer uses debit card to transfer funds \u2192 Bank debits the amount \u2192 Successful debit, followed by vendor's shipping \u2192 Bank remits funds to the Company's designated account \u2192 The Company makes batch remittance to the vendor's designated account 2 working days after transactions are completed.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(3) Convenience Store Payment: Buyer selects product from the vendor's website \u2192 Buyer chooses to make payment through a convenience store \u2192 Buyer goes to the convenience store to make payment \u2192 Payment processing organization gives notice to the Company about the buyer's payment \u2192 The Company gives notice about successful payment to the vendor, followed by the vendor's shipping \u2192 Payment processing organization remits funds to the Company's designated account \u2192 The Company makes batch remittances to the vendor's designated account 5 to 25 days after transactions are completed.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "8. Withdrawal from Payment Account: In accordance with the period agreed between the vendor and the Company (as provided in the above payment procedure), the company will give instruction to the trust bank for transfer.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "9. Deposit bank providing payment deposit accounts: Hwatai Bank, First Bank, Taiwan Cooperative Bank, Changhwa Bank, KGI Bank.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 9 Foreign Exchange",
                    /*#__PURE__*/ React.createElement("br", null),
                    "All transaction amounts by the buyer (vendor) through the Services shall be in NT Dollars, without any foreign exchange conversion.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 10 Secured Payment",
                    /*#__PURE__*/ React.createElement("br", null),
                    "The payments through the Services have been fully deposited into trust accounts agreed under trust contracts signed with Hwatai Bank, First Bank, Taiwan Cooperative Bank, Changhwa Bank and KGI Bank for exclusive purpose. Exclusive purpose means the use by the Company for the performance of its obligations under the Online Payment Services Agreement.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 11 Re-Confirmation of Payment Instruction and Post-Transaction Verification",
                    /*#__PURE__*/ React.createElement("br", null),
                    '1. Before payment is completed, the Company shall display an option mechanism showing "Do you confirm payment?" (offering options between "Confirm" or "Cancel") in relation to the buyer\'s payment instruction, so that the buyer can re-confirm whether the payment instruction is correct.',
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. After completion of each payment, the company shall send a notice to the buyer showing payment details by email or short message to allow the buyer's post-transaction verification.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 12 Payment Error",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. In case of payment errors due to any reason that is not imputable to the buyer, the Company shall assist the buyer with the correction and shall provide other necessary assistance.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. In case of payment errors due to any reason that is imputable to the Company, the Company shall make immediate correction upon learning of the event and shall give notice to the buyer and the vendor by email or another manner agreed by both parties.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. In case of payment errors due to any reason that is imputable to the buyer, such as the buyer's input error in amount or payee, the Company shall provide immediate assistance upon the buyer's notice.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 13 Information Security",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. The Services are PCIDSS certified by the international credit card organizations, with security encryption mechanism under SSL international certification standard, in order to ensure no disclosure of any of the buyer's (vendor's) information.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. The Company and the buyer (vendor) shall each ensure the security of the information system that they use to prevent unlawful intrusion, acquisition, alteration or jeopardy to any business record of the buyer's personal information.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. In case of any dispute about any third party's breaking into the protection measure of the Company's information system or use of any loophole in the information system, the Company shall bear the burden of proof about the non-existence of such event.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "4. The Company shall be liable for any damage suffered by the buyer (vendor) caused by any third party hacking into the online payment processing services information system.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 14 The Company's Termination of Contract or Suspension of Services",
                    /*#__PURE__*/ React.createElement("br", null),
                    "The Company may unilaterally terminate the agreement or suspend the Services in the following events:",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. Sufficient evidence showing that the buyer (vendor) uses the payment services to engage in any criminal offense or unlawful conduct such as money laundering or fraud.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. The payment amount has been seized by court ruling or prosecutor's order.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. The buyer (vendor) submits false identification information, as confirmed following verification.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "4. The buyer (vendor) is deemed to have unilaterally terminated this agreement due to failure to perform its obligations under this agreement. The Company shall be entitled to seek compensation from the buyer (vendor) and shall have the right to terminate this agreement.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "5. The buyer (vendor) fails to perform second identification and confirmation of identity in accordance with Paragraph 3, Article 19.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 15 Fraudulent Use of Account and Password",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. If the Company or the buyer (vendor) learns that its account and passcode have been subject to fraudulent use, it shall give immediate notice to the other party and suspend the payment instructed with such account and suspend any subsequent payment instruction with such account.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. The Company shall indicate in a clear location of the service webpage the contact number 0509-11-2277 in case of fraudulent use of account and password. Unless there is any even of force majeure or any other material event, the service hours of such number shall be full day (24 hours) and full year (365 days).",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. The Company shall bear all losses incurred after the buyer (vendor) has completed the procedure for fraudulent use of account and password. In case of the below events, the losses incurred before the completion of such procedure shall be borne by the buyer (vendor):",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(1) The buyer (vendor) fails to keep in due custody the account and password.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(2) The buyer (vendor) provides its account and password to another person.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(3) The buyer (vendor) fails to use the account security mechanism provided by the Company.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(4) Any event caused by the buyer's (vendor's) willful conduct or gross negligence.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "4. The Company shall bear the cost incurred for the investigation of fraudulent use of the buyer's (vendor's) account and password.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "5. To protect the buyer's (vendor's) security, upon receipt of any buyer's (vendor's) notice about any event under Paragraph 1 of this article, the Company shall immediately stop the use of the Services with such account until the anomaly has ceased to exist. The Company may also ask the buyer (vendor) to provide relevant documents (including but not limited to proof of report to the police authority, affidavit and proof of documentation) to reinstate the use of the Services with such account.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "6. The buyer (vendor) agrees that, during its use of the Services, the Company may keep detailed records of the user log-in information (including IP location and time), the activities and other records that should be maintained in accordance with the law.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 16 Termination of Contract by Buyer or Vendor",
                    /*#__PURE__*/ React.createElement("br", null),
                    "The buyer (vendor) may terminate the contract at any time in the manner agreed by both parties.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 17 Amendment",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. If the Company wishes to change the contract terms, it shall make a public announcement in a clear location on the website and shall give notice to the buyer (vendor) by email or any other manner agreed by both parties.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. If the Company fails to make public announcement and give notice in accordance with the previous paragraph, the amendment shall be invalid, except if the amendment is to the buyer's (vendor's) favor.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 18 Dispute Resolution",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. Consumer dispute customer service hotline: 02-25026969 and email: service@esafe.com.tw.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. Complaint, Dispute Resolution Mechanism and Procedure: The customer service receives buyer's (vendor's) dispute and complaint \u2192 The buyer (vendor) completes the \"Online Customer Service Processing Form\" \u2192 Inform relevant department according to the buyer's (vendor's) dispute and nature of complaint \u2192 Processing department makes a first determination about whether there is a negligence imputable to the Company \u2192 If yes, review and undertake remedy measures in accordance with these service terms and conditions \u2192 Reply to the client; If No, reply to the client directly \u2192 Complete the customer service staff \"Online Customer Service Processing Form\" \u2192 Customer service staff confirms whether the client accepts? If yes, submit to supervisor of administration department for approval \u2192 Customer service staff closes and files the case; If not accepted, return the case to processing department for further handling.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 19 Buyer's (Vendor's) Identity Certification",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. The buyer (vendor) shall confirm that the identity certification information that its submits is correct and truthful, without any falsity. If any such information is changed subsequently, an immediate notice shall be given to the Company.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. The Service member identity certification mechanism is as follows:",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(1) Buyer: After the identity certification information is completed, the Service will automatically bring out a mobile number and send a short message. The buyer should key in the 4-digit verification code received through mobile short message into the verification code box (verification code is valid for 10 minutes). Member identity certification will be completed after the server of the Services makes a positive determination.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(2) Vendor: After the identity certification information is completed, the vendor should dial a voice hotline by mobile phone. The member identity certification will be completed after the server of the Services makes a positive detemrination.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. In case of any of the following events, the Company may ask the buyer (vendor) to complete second identity certification procedure:",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(1) The buyer (vendor) asks to change basic identity information.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(2) Relevant document such as identification document or registration license provided by the buyer (vendor) may be forged or altered.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(3) The buyer's (vendor's) last transaction was more than six months ago.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(4) The same mobile phone number or email address was used by different buyers (vendors) in the identity confirmation procedure.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(5) Suspected trade involving money laundering or funding for terrorism, or remittance of transaction funds from a high-risk country or territory in terms of money laundering or terrorism funding.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(6) There is a concern about the genuineness or appropriateness of the buyer's (vendor's) identity information that was acquired.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 20 Money Laundering Prevention and Crackdown on Terrorism Funding",
                    /*#__PURE__*/ React.createElement("br", null),
                    "To achieve the Company's purpose of money laundering prevention and crackdown on terrorism funding, the buyer (vendor) agrees that the Company may undertake the following measures in accordance with the Money Laundering Prevention Act and the Template Guidelines for Money Laundering Prevention and Crackdown on Terrorism Funding by the Banker's Association of the Republic of China. Any damage or jeopardy suffered by the buyer (vendor) due to the Company's performance in accordance with this article shall be solely borne by the buyer (vendor) and the Company shall not be liable for compensation.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(1) If the Company discovers that the buyer (vendor) or its related party is a terrorist or terrorist group subject to economic sanction, determination or investigation by a foreign government or international money laundering prevention organization, it may suspend the Services in whole or in part without notice to the buyer (vendor) or its related party. The Company may also terminate these service terms and conditions by notice to the buyer (vendor) through email or in any other manner agreed by both parties.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(2) When the Company performs regular or aperiodic review of the identity of the buyer (vendor) or its related party or as it deems it necessary (including but not limited to: suspicion about the buyer's (vendor's) involvement in unlawful activities, suspicion of money laundering, funding for terrorist activities or special cases of breach of law reported by the media), it may ask the buyer (vendor) to provide individual (including the user and related parties) or company information, actual beneficiary of a corporate account, information about the person exercising control or explanations about the nature and purpose of the transaction and the source of funds that is required for review within 60 days (inclusive) from receipt of the Company's notice. If the buyer (vendor) fails to perform before the deadline, the Company may suspend the Services in whole or in party or terminate the Services by email notice or in any other manner agreed by the parties.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 21 Compensation",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. When the (vendor) uses any of the Company's cash flows services, it shall duly perform its obligations in accordance with its agreements with the consumers. If the (vendor) has any disagreement with any consumer due to any reason and if the consumer asks the card issuing bank or card accepting organization to refuse payment or claims the refund of any amount paid to the Company in whole or in part, upon the card issuing bank's refusal for payment or mandatory debit against the Company, the (vendor) agrees to unconditionally authorize the Company to first compensate or indemnify the loss or damage suffered by the consumer, card issuing bank or card accepting organization first based on the actual situation. The (vendor) also agrees that, after the Company has provided such compensation or indemnification, it shall unconditionally compensate or indemnify all losses or damages suffered by the Company (including but not limited to the amount of compensation or indemnification, the amount of refund, interest, attorney's fee or any other litigation or non-litigation cost incurred). These events include but are not limited to the following:",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(1) The (vendor) fails to provide services or the services provided are inconsistent with the consumer's order details or the product is rejected and returned;",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(2) The (vendor) fails to provide consumer purchase records or relevant proof corresponding to the transaction;",
                    /*#__PURE__*/ React.createElement("br", null),
                    "(3) The transaction is unlawful or unenforceable due to the (vendor's) reason.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. If the (vendor) fails to process accounts in accordance with the requirements of this agreement, the (vendor) shall be liable for compensating the damages suffered by the Company, the card accepting organization or card-issuing bank (including but not limited to attorney's fee and other litigation or non-litigation cost).",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. If the (vendor) is liable for compensation in accordance with the previous three paragraphs of this article, the (vendor) unconditionally agrees and authorizes the Company to debit the amount from product payment that is due to the (vendor) in the current period or in the future. It is also agreed that any shortfall may be set off against the security deposit provided by the vendor (if any). If any shortfall remains after the setoff, the (vendor) shall pay the difference to the Company by remittance or in cash within 3 calendar days from the Company's notice. In case of any breach of the above, the Company may accrue interest at 10% per annum from the date of notice to the date of repayment on the overdue amount owed by the (vendor).",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 22 Governing Law and Court of Jurisdiction",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. Any dispute about the Services shall be governed by the laws of the Republic of China.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. The undersigned agree that all disputes arising out of the Services shall be resolved through negotiation based on the principle of good faith. If litigation is necessary, unless otherwise provided by law, the buyer (vendor) agrees that the Taiwan Taipei District Court shall be the first-instance court of jurisdiction.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    "Article 23 Other Agreements",
                    /*#__PURE__*/ React.createElement("br", null),
                    "1. All payments processed by the Services shall only be forwarded to the physical deposit account with a certified financial institution in the name of the buyer (vendor). The buyer (vendor) shall not ask the Company to pay the amount to any other non-certified account for any reason (including but not limited to seized or red-flagged account).",
                    /*#__PURE__*/ React.createElement("br", null),
                    "2. The buyer (vendor) agrees for the Company to provide information about business activities, products or services and to send information about business consumption, marketing or promotional event. If the buyer (vendor) expressly refuses to give this consent in writing, the Company shall immediately stop the provision of such information.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "3. Each vendor of the Services is subject to transaction limit and amount limit. The Company reserves the right to change any limit based on the vendor's relevant financial status and documents submitted.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "4. The vendor shall exercise due care at all times about the status of payment acceptance limit with the Services. If the vendor needs a higher payment acceptance limit, it shall file another application with the Company. However, the vendor shall not object to any payment acceptance limit that is established by the Company.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "5. The vendor shall only accept payments within the payment acceptance limit. If the limit has been reached and if there is no prior application filed with the Company to raise the limit, no further payment shall be accepted. Thus the vendor shall not file any claim against the Company for loss of income, loss of business or compensation based on any reason.",
                    /*#__PURE__*/ React.createElement("br", null),
                    "6. If the buyer has reached its payment limit and cannot make further payment, it shall not file any claim against the Company for inconvenience of trade or consumption or dispute between the buyer and the vendor based on any reason.",
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null),
                    /*#__PURE__*/ React.createElement("br", null)
                  )
                : null,
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "hy-terms-consent-wrapper"
                },
                /*#__PURE__*/ React.createElement(
                  "label",
                  {
                    htmlFor: "hy-terms-consent"
                  },
                  "\u672C\u4EBA\u5DF2\u7406\u89E3\u4E0A\u63ED\u500B\u8CC7\u6CD5\u53CA\u670D\u52D9\u689D\u6B3E\uFF0C\u4E26\u540C\u610F\u5176\u5167\u5BB9\u3002",
                  /*#__PURE__*/ React.createElement("br", null),
                  "\u672C\u4EBA\u540C\u610F\u8A18\u4F4F\u9019\u5F35\u4FE1\u7528\u5361\u865F\uFF0C\u4EE5\u7BC0\u7701\u4E0B\u6B21\u4ED8\u6B3E\u6642\u9593\u3002",
                  /*#__PURE__*/ React.createElement("br", null),
                  "1.\u60A8\u540C\u610F\u7D05\u967D\u79D1\u6280\u5F97\u65BC\u5408\u7406\u4E4B\u7BC4\u570D\u5167\u8490\u96C6\u3001\u8655\u7406\u3001\u4FDD\u5B58\u3001\u50B3\u8F38\u53CA\u5229\u7528\u60A8\u7684\u4FE1\u7528\u5361\u865F\u3002",
                  /*#__PURE__*/ React.createElement("br", null),
                  "2.\u70BA\u4FDD\u969C\u60A8\u7684\u96B1\u79C1\u53CA\u5B89\u5168, \u7D05\u967D\u79D1\u6280\u4E0D\u6703\u5132\u5B58\u4FE1\u7528\u5361\u7684\u9A57\u8B49\u7DE8\u78BC\u3002",
                  /*#__PURE__*/ React.createElement("br", null),
                  "I agree to the terms of Privacy Statement and Service Terms and Conditions.",
                  /*#__PURE__*/ React.createElement("br", null),
                  "I agree to keep the card info in the system to save time for the next payment.",
                  /*#__PURE__*/ React.createElement("br", null),
                  "1. I agree to Red Sunrise Co., Ltd. to collect, process, store, transmit, and use this card info.",
                  /*#__PURE__*/ React.createElement("br", null),
                  "2. For the purpose of personal privacy and security, the card authorization code will not be stored in the system of Red Sunrise Co., Ltd.",
                  /*#__PURE__*/ React.createElement("br", null)
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  id: "form-error",
                  className: "form-error",
                  style: {
                    display: formError ? "block" : "none"
                  }
                },
                "\u8F38\u5165\u932F\u8AA4. \u6709\u53EF\u80FD\u662F\u4EE5\u4E0B\u554F\u984C\u4E4B\u4E00 (Error due to one of the below issues):",
                /*#__PURE__*/ React.createElement("br", null),
                "\u59D3\u540D\u5FC5\u9808\u586B\u5BEB (Your name is required.)",
                /*#__PURE__*/ React.createElement("br", null),
                "\u8ACB\u9078\u64C7\u5361\u7247\u6709\u6548\u6708\u4EFD (Please select the month of expiry date on your card.)",
                /*#__PURE__*/ React.createElement("br", null),
                "\u8ACB\u8F38\u5165\u5B8C\u6574\u5361\u865F\uFF01 (Please key in the all card number.)",
                /*#__PURE__*/ React.createElement("br", null),
                "\u8ACB\u8F38\u5165\u5361\u7247\u80CC\u9762\u672B3\u78BC\uFF01 (Please key in the security code in back of the card.)",
                /*#__PURE__*/ React.createElement("br", null)
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  id: "btn-submit-hy-payment",
                  className: "btn-submit-hy-payment",
                  onClick: submit,
                  style: {
                    display: isLoading ? "none" : "block"
                  }
                },
                "\u78BA\u5B9A\u4ED8\u6B3E Confirm"
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  id: "hy-loader-container",
                  className: "hy-loader-container",
                  style: {
                    display: isLoading ? "block" : "none"
                  }
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "hy-loader-msg"
                  },
                  "\u6388\u6B0A\u4E2D - \u8ACB\u7B49\u5F8510-20\u79D2. \u8ACB\u52FF\u91CD\u6574\u756B\u9762.",
                  /*#__PURE__*/ React.createElement("br", null),
                  "(Please wait 10-20 seconds. Do not refresh the web page.)"
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "hy-loader"
                  },
                  /*#__PURE__*/ React.createElement("img", {
                    src: LOADING,
                    alt: "Loading"
                  })
                )
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "hy-notice"
                },
                "\u60A8\u6240\u4F7F\u7528\u7684\u652F\u4ED8\u670D\u52D9\u70BA\u7D05\u967D\u652F\u4ED8\uFF0C\u656C\u8ACB\u5B89\u5FC3\u9032\u884C\u4ED8\u6B3E"
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "hy-notice"
                },
                "This service is provided by Suntech Co., Ltd, a PCI compliant payment service provider on security payment."
              ),
              /*#__PURE__*/ React.createElement(
                "div",
                {
                  className: "hy-payment-footer"
                },
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "footer-section-wrapper"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "footer-label"
                    },
                    "\u6536\u55AE\u9280\u884C/Acquiring Bank"
                  ),
                  /*#__PURE__*/ React.createElement("img", {
                    className: "nccc-logo",
                    src: NCCC,
                    alt: "National Credit Card Center of R.O.C."
                  })
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "footer-section-wrapper"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "footer-label"
                    },
                    "\u652F\u4ED8\u670D\u52D9/Payment Service"
                  ),
                  /*#__PURE__*/ React.createElement("img", {
                    className: "hy-logo",
                    src: SUNTECH,
                    alt: "Suntech"
                  })
                ),
                /*#__PURE__*/ React.createElement(
                  "div",
                  {
                    className: "footer-section-wrapper"
                  },
                  /*#__PURE__*/ React.createElement(
                    "div",
                    {
                      className: "footer-label"
                    },
                    "SSL\u8A8D\u8B49/Secure Socket Layer"
                  ),
                  /*#__PURE__*/ React.createElement("img", {
                    className: "ssl-logo",
                    src: SSL,
                    alt: "Secure Socket Layer"
                  })
                )
              )
            )
          )
        )
      )
    ),
    ccv_help_on
      ? /*#__PURE__*/ React.createElement(
          React.Fragment,
          null,
          /*#__PURE__*/ React.createElement("div", {
            className: "ccv-mask"
          }),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "ccv-example-container"
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                className: "ccv-example-container-close",
                onClick: closeCCVHelp
              },
              "\u8FD4\u56DE/Back"
            ),
            /*#__PURE__*/ React.createElement("img", {
              className: "ccv-example",
              src: CCV_EXAMPLE,
              alt: "CCV Example"
            })
          )
        )
      : null
  );
};

var Footer = function Footer(_ref) {
  var backgroundColor = _ref.backgroundColor,
    darkTheme = _ref.darkTheme;
  var edmtitle = formatMessage({
    id: "footer.edm.title"
  });
  var edmp = formatMessage({
    id: "footer.edm.p"
  });
  var edmsubmit = formatMessage({
    id: "footer.edm.submit"
  });
  var edmdisclaimer = formatMessage({
    id: "footer.edm.disclaimer"
  });
  var contacttitle = formatMessage({
    id: "footer.contact.title"
  });
  var contactphone = formatMessage({
    id: "footer.contact.phone"
  });
  var contactphonehours1 = formatMessage({
    id: "footer.contact.phonehours1"
  });
  var contactphonehours2 = formatMessage({
    id: "footer.contact.phonehours2"
  });
  var contactemail1 = formatMessage({
    id: "footer.contact.email1"
  });
  var contactemail2 = formatMessage({
    id: "footer.contact.email2"
  });
  var contactwhatsapp = formatMessage({
    id: "footer.contact.whatsapp"
  });
  var contactonline = formatMessage({
    id: "footer.contact.online"
  });
  var emfcompanyname = formatMessage({
    id: "footer.emf.companyname"
  });
  var footerEmfAddress1 = formatMessage({
    id: "footer.emf.address1"
  });
  var footerEmfAddress2 = formatMessage({
    id: "footer.emf.address2"
  });
  var footerEmfAddress3 = formatMessage({
    id: "footer.emf.address3"
  });
  var footerEmfAddress4 = formatMessage({
    id: "footer.emf.address4"
  });
  var footercopyright = formatMessage({
    id: "footer.copyright"
  });
  var footerabout = formatMessage({
    id: "footer.about"
  });
  var footerterms = formatMessage({
    id: "footer.terms"
  });
  var footerprivacy = formatMessage({
    id: "footer.privacy"
  });
  var footeruseofwebsite = formatMessage({
    id: "footer.useofwebsite"
  });
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "stklibfooter footer-root".concat(
        darkTheme ? " darkTheme" : ""
      ),
      style: {
        backgroundColor: backgroundColor
      }
    },
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "footer-wrapper"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "footer-edm"
        },
        /*#__PURE__*/ React.createElement(
          "h3",
          {
            className: "footer-title"
          },
          edmtitle
        ),
        /*#__PURE__*/ React.createElement("p", null, edmp),
        /*#__PURE__*/ React.createElement(
          "form",
          {
            action: "https://stk-workshop.us19.list-manage.com/subscribe/post",
            method: "post",
            id: "mc-embedded-subscribe-form",
            name: "mc-embedded-subscribe-form",
            target: "_blank",
            noValidate: true
          },
          /*#__PURE__*/ React.createElement("input", {
            type: "hidden",
            name: "u",
            value: "dbb97ed597bf7f400423d3a6e"
          }),
          /*#__PURE__*/ React.createElement("input", {
            type: "hidden",
            name: "id",
            value: "809bc77220"
          }),
          /*#__PURE__*/ React.createElement("input", {
            type: "email",
            id: "mce-EMAIL",
            name: "EMAIL"
          }),
          /*#__PURE__*/ React.createElement(
            "button",
            {
              id: "mc-embedded-subscribe",
              name: "subscribe",
              className: "footer-subscribe",
              type: "submit"
            },
            edmsubmit
          ),
          /*#__PURE__*/ React.createElement("input", {
            type: "text",
            style: {
              display: "none"
            },
            "aria-hidden": "true",
            name: "b_dbb97ed597bf7f400423d3a6e_809bc77220",
            tabIndex: "-1"
          })
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "footer-disclaimer"
          },
          edmdisclaimer
        )
      ),
      /*#__PURE__*/ React.createElement(
        "div",
        null,
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "footer-contact"
          },
          /*#__PURE__*/ React.createElement(
            "h3",
            {
              className: "footer-title"
            },
            contacttitle
          ),
          /*#__PURE__*/ React.createElement("br", null),
          /*#__PURE__*/ React.createElement("p", null, contactphone),
          /*#__PURE__*/ React.createElement("p", null, contactphonehours1),
          /*#__PURE__*/ React.createElement("p", null, contactphonehours2),
          /*#__PURE__*/ React.createElement("br", null),
          /*#__PURE__*/ React.createElement("p", null, contactemail1),
          /*#__PURE__*/ React.createElement("p", null, contactemail2),
          /*#__PURE__*/ React.createElement("br", null),
          /*#__PURE__*/ React.createElement("p", null, contactwhatsapp)
        ),
        /*#__PURE__*/ React.createElement(
          "div",
          {
            className: "footer-social"
          },
          /*#__PURE__*/ React.createElement(
            "h3",
            {
              className: "footer-title"
            },
            contactonline
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              className: "footer-channels"
            },
            /*#__PURE__*/ React.createElement(
              "a",
              {
                href: "https://www.facebook.com/stkworkshoptw",
                target: "_blank",
                rel: "noreferrer"
              },
              /*#__PURE__*/ React.createElement(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  "aria-hidden": "true",
                  focusable: "false",
                  "data-prefix": "fab",
                  "data-icon": "facebook-square",
                  className: "svg-inline--fa fa-facebook-square fa-w-14",
                  role: "img",
                  viewBox: "0 0 448 512"
                },
                /*#__PURE__*/ React.createElement("path", {
                  fill: "currentColor",
                  d:
                    "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                })
              )
            ),
            /*#__PURE__*/ React.createElement(
              "a",
              {
                href: "https://www.instagram.com/stkworkshop_taiwan/",
                target: "_blank",
                rel: "noreferrer"
              },
              /*#__PURE__*/ React.createElement(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  "aria-hidden": "true",
                  focusable: "false",
                  "data-prefix": "fab",
                  "data-icon": "instagram-square",
                  className: "svg-inline--fa fa-instagram-square fa-w-14",
                  role: "img",
                  viewBox: "0 0 448 512"
                },
                /*#__PURE__*/ React.createElement("path", {
                  fill: "currentColor",
                  d:
                    "M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
                })
              )
            ),
            /*#__PURE__*/ React.createElement(
              "a",
              {
                href:
                  "https://www.youtube.com/channel/UC0JldLEEkZLjpCT4vc1jsuA",
                target: "_blank",
                rel: "noreferrer"
              },
              /*#__PURE__*/ React.createElement(
                "svg",
                {
                  xmlns: "http://www.w3.org/2000/svg",
                  "aria-hidden": "true",
                  focusable: "false",
                  "data-prefix": "fab",
                  "data-icon": "youtube-square",
                  className: "svg-inline--fa fa-youtube-square fa-w-14",
                  role: "img",
                  viewBox: "0 0 448 512"
                },
                /*#__PURE__*/ React.createElement("path", {
                  fill: "currentColor",
                  d:
                    "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
                })
              )
            )
          )
        )
      )
    ),
    /*#__PURE__*/ React.createElement(
      "div",
      {
        className: "footer-wrapper"
      },
      /*#__PURE__*/ React.createElement(
        "div",
        {
          className: "footer-legal"
        },
        /*#__PURE__*/ React.createElement(
          "div",
          {
            style: {
              textAlign: "left"
            }
          },
          emfcompanyname,
          /*#__PURE__*/ React.createElement("br", null),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start"
              }
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                style: {
                  flexShrink: 0
                }
              },
              footerEmfAddress1
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                style: {
                  textAlign: "left"
                }
              },
              footerEmfAddress2
            )
          ),
          /*#__PURE__*/ React.createElement(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "flex-start"
              }
            },
            /*#__PURE__*/ React.createElement(
              "div",
              {
                style: {
                  flexShrink: 0
                }
              },
              footerEmfAddress3
            ),
            /*#__PURE__*/ React.createElement(
              "div",
              {
                style: {
                  textAlign: "left"
                }
              },
              footerEmfAddress4
            )
          )
        ),
        /*#__PURE__*/ React.createElement("br", null),
        /*#__PURE__*/ React.createElement(
          "div",
          null,
          new Date().getFullYear(),
          footercopyright
        ),
        /*#__PURE__*/ React.createElement(
          "ul",
          {
            className: "footer-links"
          },
          /*#__PURE__*/ React.createElement(
            "li",
            null,
            /*#__PURE__*/ React.createElement(
              "a",
              {
                href: requestParam$1.webBaseURL + "/about"
              },
              footerabout
            )
          ),
          /*#__PURE__*/ React.createElement(
            "li",
            null,
            /*#__PURE__*/ React.createElement(
              "a",
              {
                href: requestParam$1.webBaseURL + "/terms-and-conditions"
              },
              footerterms
            )
          ),
          /*#__PURE__*/ React.createElement(
            "li",
            null,
            /*#__PURE__*/ React.createElement(
              "a",
              {
                href: requestParam$1.webBaseURL + "/privacy-policy"
              },
              footerprivacy
            )
          ),
          /*#__PURE__*/ React.createElement(
            "li",
            null,
            /*#__PURE__*/ React.createElement(
              "a",
              {
                href: requestParam$1.webBaseURL + "/use-of-website"
              },
              footeruseofwebsite
            )
          )
        )
      )
    )
  );
};

var Description = function Description(_ref) {
  var title = _ref.title,
    html = _ref.html,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor =
      _ref$backgroundColor === void 0 ? "white" : _ref$backgroundColor,
    _ref$darkTheme = _ref.darkTheme,
    darkTheme = _ref$darkTheme === void 0 ? false : _ref$darkTheme;
  return /*#__PURE__*/ React.createElement(
    "div",
    {
      className: "stk_description_inner stk_description ".concat(
        darkTheme ? " stk_darkTheme" : ""
      ),
      style: {
        backgroundColor: backgroundColor
      }
    },
    /*#__PURE__*/ React.createElement(
      "h2",
      {
        className: "stk_descriptionTitle"
      },
      title
    ),
    /*#__PURE__*/ React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: html || ""
      }
    })
  );
};

var AboutContent = function AboutContent(_ref) {
  var serverLanguageCode = _ref.serverLanguageCode,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor =
      _ref$backgroundColor === void 0 ? "white" : _ref$backgroundColor,
    _ref$darkTheme = _ref.darkTheme,
    darkTheme = _ref$darkTheme === void 0 ? false : _ref$darkTheme;

  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];

  useEffect(function() {
    localStorage.setItem("about", "true");
    get("page/content?page=about_us&language=".concat(serverLanguageCode))
      .then(function(res) {
        setData(res);
      })
      ["catch"](function(err) {});
  }, []);
  var footerabout = formatMessage({
    id: "footer.about"
  });
  return /*#__PURE__*/ React.createElement(Description, {
    title: footerabout,
    html: data,
    backgroundColor: backgroundColor,
    darkTheme: darkTheme
  });
};

var PrivacyPolicyContent = function PrivacyPolicyContent(_ref) {
  var serverLanguageCode = _ref.serverLanguageCode,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor =
      _ref$backgroundColor === void 0 ? "white" : _ref$backgroundColor,
    _ref$darkTheme = _ref.darkTheme,
    darkTheme = _ref$darkTheme === void 0 ? false : _ref$darkTheme;

  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];

  useEffect(function() {
    localStorage.setItem("privacypolicy", true);
    get("page/content?page=privacy_policy&language=".concat(serverLanguageCode))
      .then(function(res) {
        setData(res);
      })
      ["catch"](function(err) {});
  }, []);
  var footerprivacy = formatMessage({
    id: "footer.privacy"
  });
  return /*#__PURE__*/ React.createElement(Description, {
    title: footerprivacy,
    html: data,
    backgroundColor: backgroundColor,
    darkTheme: darkTheme
  });
};

var TcContent = function TcContent(_ref) {
  var serverLanguageCode = _ref.serverLanguageCode,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor =
      _ref$backgroundColor === void 0 ? "white" : _ref$backgroundColor,
    _ref$darkTheme = _ref.darkTheme,
    darkTheme = _ref$darkTheme === void 0 ? false : _ref$darkTheme;

  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];

  useEffect(function() {
    localStorage.setItem("tc", true);
    get(
      "page/content?page=terms_and_conditions&language=".concat(
        serverLanguageCode
      )
    )
      .then(function(res) {
        setData(res);
      })
      ["catch"](function(err) {});
  }, []);
  var footerterms = formatMessage({
    id: "footer.terms"
  });
  return /*#__PURE__*/ React.createElement(Description, {
    title: footerterms,
    html: data,
    backgroundColor: backgroundColor,
    darkTheme: darkTheme
  });
};

var UseOfWebsiteContent = function UseOfWebsiteContent(_ref) {
  var serverLanguageCode = _ref.serverLanguageCode,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor =
      _ref$backgroundColor === void 0 ? "white" : _ref$backgroundColor,
    _ref$darkTheme = _ref.darkTheme,
    darkTheme = _ref$darkTheme === void 0 ? false : _ref$darkTheme;

  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];

  useEffect(function() {
    localStorage.setItem("useofwebsite", true);
    get(
      "page/content?page=notice_on_use_of_website&language=".concat(
        serverLanguageCode
      )
    )
      .then(function(res) {
        setData(res);
      })
      ["catch"](function(err) {});
  }, []);
  var footeruseofwebsite = formatMessage({
    id: "footer.useofwebsite"
  });
  return /*#__PURE__*/ React.createElement(Description, {
    title: footeruseofwebsite,
    html: data,
    backgroundColor: backgroundColor,
    darkTheme: darkTheme
  });
};

var FaqContent = function FaqContent(_ref) {
  var requestFaqPage = _ref.requestFaqPage,
    serverLanguageCode = _ref.serverLanguageCode,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor =
      _ref$backgroundColor === void 0 ? "white" : _ref$backgroundColor,
    _ref$darkTheme = _ref.darkTheme,
    darkTheme = _ref$darkTheme === void 0 ? false : _ref$darkTheme;

  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];

  useEffect(function() {
    get(
      "page/content?page="
        .concat(requestFaqPage, "&language=")
        .concat(serverLanguageCode)
    )
      .then(function(res) {
        setData(res);
      })
      ["catch"](function(err) {});
  }, []);
  var faq = formatMessage({
    id: "faq"
  });
  return /*#__PURE__*/ React.createElement(Description, {
    title: faq,
    html: data,
    backgroundColor: backgroundColor,
    darkTheme: darkTheme
  });
};

export {
  AboutContent,
  Cart1 as Cart1Page,
  Cart2 as Cart2Page,
  Cart3 as Cart3Page,
  Cart4 as Cart4Page,
  Cart5 as Cart5Page,
  Description,
  FaqContent,
  Footer,
  Forgot as ForgotPage,
  Header,
  Login as LoginPage,
  MobileDetector,
  Payment as PaymentPage,
  PrivacyPolicyContent,
  TcContent,
  UseOfWebsiteContent,
  User as UserPage,
  index as apiRequest,
  useAppHeight
};
